import { City } from "../functions/types";

export const cities: City[] = [
	{
		zip: '35031',
		name: 'Abano Terme',
		province: 'PD',
		altitude: 14
	},
	{
		zip: '26834',
		name: 'Abbadia Cerreto',
		province: 'LO',
		altitude: 64
	},
	{
		zip: '23821',
		name: 'Abbadia Lariana',
		province: 'LC',
		altitude: 204
	},
	{
		zip: '53021',
		name: 'Abbadia San Salvatore',
		province: 'SI',
		altitude: 822
	},
	{
		zip: '09071',
		name: 'Abbasanta',
		province: 'OR',
		altitude: 315
	},
	{
		zip: '65020',
		name: 'Abbateggio',
		province: 'PE',
		altitude: 450
	},
	{
		zip: '20081',
		name: 'Abbiategrasso',
		province: 'MI',
		altitude: 120
	},
	{
		zip: '85010',
		name: 'Abriola',
		province: 'PZ',
		altitude: 957
	},
	{
		zip: '97011',
		name: 'Acate',
		province: 'RG',
		altitude: 199
	},
	{
		zip: '71021',
		name: 'Accadia',
		province: 'FG',
		altitude: 650
	},
	{
		zip: '12021',
		name: 'Acceglio',
		province: 'CN',
		altitude: 1220
	},
	{
		zip: '75011',
		name: 'Accettura',
		province: 'MT',
		altitude: 770
	},
	{
		zip: '67020',
		name: 'Acciano',
		province: 'AQ',
		altitude: 600
	},
	{
		zip: '02011',
		name: 'Accumoli',
		province: 'RI',
		altitude: 855
	},
	{
		zip: '85011',
		name: 'Acerenza',
		province: 'PZ',
		altitude: 833
	},
	{
		zip: '84042',
		name: 'Acerno',
		province: 'SA',
		altitude: 727
	},
	{
		zip: '80011',
		name: 'Acerra',
		province: 'NA',
		altitude: 28
	},
	{
		zip: '95020',
		name: 'Aci Bonaccorsi',
		province: 'CT',
		altitude: 365
	},
	{
		zip: '95021',
		name: 'Aci Castello',
		province: 'CT',
		altitude: 15
	},
	{
		zip: '95022',
		name: 'Aci Catena',
		province: 'CT',
		altitude: 170
	},
	{
		zip: '95025',
		name: 'Aci Sant\'\'Antonio',
		province: 'CT',
		altitude: 302
	},
	{
		zip: '95024',
		name: 'Acireale',
		province: 'CT',
		altitude: 102
	},
	{
		zip: '03040',
		name: 'Acquafondata',
		province: 'FR',
		altitude: 914
	},
	{
		zip: '87010',
		name: 'Acquaformosa',
		province: 'CS',
		altitude: 756
	},
	{
		zip: '25010',
		name: 'Acquafredda',
		province: 'BS',
		altitude: 55
	},
	{
		zip: '61041',
		name: 'Acqualagna',
		province: 'PU',
		altitude: 204
	},
	{
		zip: '26020',
		name: 'Acquanegra Cremonese',
		province: 'CR',
		altitude: 45
	},
	{
		zip: '46011',
		name: 'Acquanegra sul Chiese',
		province: 'MN',
		altitude: 31
	},
	{
		zip: '01021',
		name: 'Acquapendente',
		province: 'VT',
		altitude: 420
	},
	{
		zip: '87020',
		name: 'Acquappesa',
		province: 'CS',
		altitude: 80
	},
	{
		zip: '89832',
		name: 'Acquaro',
		province: 'VV',
		altitude: 262
	},
	{
		zip: '63095',
		name: 'Acquasanta Terme',
		province: 'AP',
		altitude: 392
	},
	{
		zip: '05021',
		name: 'Acquasparta',
		province: 'TR',
		altitude: 320
	},
	{
		zip: '86030',
		name: 'Acquaviva Collecroce',
		province: 'CB',
		altitude: 425
	},
	{
		zip: '63075',
		name: 'Acquaviva Picena',
		province: 'AP',
		altitude: 359
	},
	{
		zip: '93010',
		name: 'Acquaviva Platani',
		province: 'CL',
		altitude: 558
	},
	{
		zip: '86080',
		name: 'Acquaviva d\'\'Isernia',
		province: 'IS',
		altitude: 730
	},
	{
		zip: '70021',
		name: 'Acquaviva delle Fonti',
		province: 'BA',
		altitude: 300
	},
	{
		zip: '98070',
		name: 'Acquedolci',
		province: 'ME',
		altitude: 16
	},
	{
		zip: '15011',
		name: 'Acqui Terme',
		province: 'AL',
		altitude: 156
	},
	{
		zip: '87041',
		name: 'Acri',
		province: 'CS',
		altitude: 720
	},
	{
		zip: '03010',
		name: 'Acuto',
		province: 'FR',
		altitude: 724
	},
	{
		zip: '70010',
		name: 'Adelfia',
		province: 'BA',
		altitude: 154
	},
	{
		zip: '95031',
		name: 'Adrano',
		province: 'CT',
		altitude: 560
	},
	{
		zip: '24060',
		name: 'Adrara San Martino',
		province: 'BG',
		altitude: 355
	},
	{
		zip: '24060',
		name: 'Adrara San Rocco',
		province: 'BG',
		altitude: 431
	},
	{
		zip: '45011',
		name: 'Adria',
		province: 'RO',
		altitude: 4
	},
	{
		zip: '25030',
		name: 'Adro',
		province: 'BS',
		altitude: 271
	},
	{
		zip: '37010',
		name: 'Affi',
		province: 'VR',
		altitude: 191
	},
	{
		zip: '00021',
		name: 'Affile',
		province: 'RM',
		altitude: 684
	},
	{
		zip: '80021',
		name: 'Afragola',
		province: 'NA',
		altitude: 43
	},
	{
		zip: '89030',
		name: 'Africo',
		province: 'RC',
		altitude: 15
	},
	{
		zip: '29010',
		name: 'Agazzano',
		province: 'PC',
		altitude: 187
	},
	{
		zip: '80051',
		name: 'Agerola',
		province: 'NA',
		altitude: 630
	},
	{
		zip: '07020',
		name: 'Aggius',
		province: 'SS',
		altitude: 514
	},
	{
		zip: '94011',
		name: 'Agira',
		province: 'EN',
		altitude: 650
	},
	{
		zip: '51031',
		name: 'Agliana',
		province: 'PT',
		altitude: 46
	},
	{
		zip: '14041',
		name: 'Agliano Terme',
		province: 'AT',
		altitude: 263
	},
	{
		zip: '07020',
		name: 'Aglientu',
		province: 'SS',
		altitude: 420
	},
	{
		zip: '10011',
		name: 'Aglie',
		province: 'TO',
		altitude: 315
	},
	{
		zip: '35021',
		name: 'Agna',
		province: 'PD',
		altitude: 3
	},
	{
		zip: '26020',
		name: 'Agnadello',
		province: 'CR',
		altitude: 94
	},
	{
		zip: '89040',
		name: 'Agnana Calabra',
		province: 'RC',
		altitude: 210
	},
	{
		zip: '86081',
		name: 'Agnone',
		province: 'IS',
		altitude: 830
	},
	{
		zip: '25071',
		name: 'Agnosine',
		province: 'BS',
		altitude: 465
	},
	{
		zip: '32021',
		name: 'Agordo',
		province: 'BL',
		altitude: 611
	},
	{
		zip: '00020',
		name: 'Agosta',
		province: 'RM',
		altitude: 382
	},
	{
		zip: '21010',
		name: 'Agra',
		province: 'VA',
		altitude: 650
	},
	{
		zip: '20864',
		name: 'Agrate Brianza',
		province: 'MB',
		altitude: 165
	},
	{
		zip: '28010',
		name: 'Agrate Conturbia',
		province: 'NO',
		altitude: 337
	},
	{
		zip: '92100',
		name: 'Agrigento',
		province: 'AG',
		altitude: 230
	},
	{
		zip: '84043',
		name: 'Agropoli',
		province: 'SA',
		altitude: 24
	},
	{
		zip: '60020',
		name: 'Agugliano',
		province: 'AN',
		altitude: 203
	},
	{
		zip: '36020',
		name: 'Agugliaro',
		province: 'VI',
		altitude: 13
	},
	{
		zip: '20886',
		name: 'Aicurzio',
		province: 'MB',
		altitude: 230
	},
	{
		zip: '09070',
		name: 'Aidomaggiore',
		province: 'OR',
		altitude: 250
	},
	{
		zip: '94010',
		name: 'Aidone',
		province: 'EN',
		altitude: 800
	},
	{
		zip: '67041',
		name: 'Aielli',
		province: 'AQ',
		altitude: 1021
	},
	{
		zip: '87031',
		name: 'Aiello Calabro',
		province: 'CS',
		altitude: 502
	},
	{
		zip: '33041',
		name: 'Aiello del Friuli',
		province: 'UD',
		altitude: 18
	},
	{
		zip: '83020',
		name: 'Aiello del Sabato',
		province: 'AV',
		altitude: 425
	},
	{
		zip: '87020',
		name: 'Aieta',
		province: 'CS',
		altitude: 524
	},
	{
		zip: '81010',
		name: 'Ailano',
		province: 'CE',
		altitude: 260
	},
	{
		zip: '13861',
		name: 'Ailoche',
		province: 'BI',
		altitude: 569
	},
	{
		zip: '10060',
		name: 'Airasca',
		province: 'TO',
		altitude: 257
	},
	{
		zip: '82011',
		name: 'Airola',
		province: 'BN',
		altitude: 270
	},
	{
		zip: '18030',
		name: 'Airole',
		province: 'IM',
		altitude: 149
	},
	{
		zip: '23881',
		name: 'Airuno',
		province: 'LC',
		altitude: 222
	},
	{
		zip: '12010',
		name: 'Aisone',
		province: 'CN',
		altitude: 834
	},
	{
		zip: '38061',
		name: 'Ala',
		province: 'TN',
		altitude: 210
	},
	{
		zip: '10070',
		name: 'Ala di Stura',
		province: 'TO',
		altitude: 1080
	},
	{
		zip: '27020',
		name: 'Alagna',
		province: 'PV',
		altitude: 92
	},
	{
		zip: '13021',
		name: 'Alagna Valsesia',
		province: 'VC',
		altitude: 1191
	},
	{
		zip: '65020',
		name: 'Alanno',
		province: 'PE',
		altitude: 307
	},
	{
		zip: '32031',
		name: 'Alano di Piave',
		province: 'BL',
		altitude: 308
	},
	{
		zip: '17021',
		name: 'Alassio',
		province: 'SV',
		altitude: 6
	},
	{
		zip: '03011',
		name: 'Alatri',
		province: 'FR',
		altitude: 502
	},
	{
		zip: '12051',
		name: 'Alba',
		province: 'CN',
		altitude: 172
	},
	{
		zip: '64011',
		name: 'Alba Adriatica',
		province: 'TE',
		altitude: 5
	},
	{
		zip: '09090',
		name: 'Albagiara',
		province: 'OR',
		altitude: 215
	},
	{
		zip: '20080',
		name: 'Albairate',
		province: 'MI',
		altitude: 124
	},
	{
		zip: '84044',
		name: 'Albanella',
		province: 'SA',
		altitude: 205
	},
	{
		zip: '00041',
		name: 'Albano Laziale',
		province: 'RM',
		altitude: 400
	},
	{
		zip: '24061',
		name: 'Albano Sant\'\'Alessandro',
		province: 'BG',
		altitude: 243
	},
	{
		zip: '13030',
		name: 'Albano Vercellese',
		province: 'VC',
		altitude: 151
	},
	{
		zip: '85010',
		name: 'Albano di Lucania',
		province: 'PZ',
		altitude: 899
	},
	{
		zip: '27040',
		name: 'Albaredo Arnaboldi',
		province: 'PV',
		altitude: 62
	},
	{
		zip: '37041',
		name: 'Albaredo d\'\'Adige',
		province: 'VR',
		altitude: 24
	},
	{
		zip: '23010',
		name: 'Albaredo per San Marco',
		province: 'SO',
		altitude: 950
	},
	{
		zip: '43051',
		name: 'Albareto',
		province: 'PR',
		altitude: 512
	},
	{
		zip: '12050',
		name: 'Albaretto della Torre',
		province: 'CN',
		altitude: 672
	},
	{
		zip: '22031',
		name: 'Albavilla',
		province: 'CO',
		altitude: 427
	},
	{
		zip: '17031',
		name: 'Albenga',
		province: 'SV',
		altitude: 5
	},
	{
		zip: '15060',
		name: 'Albera Ligure',
		province: 'AL',
		altitude: 423
	},
	{
		zip: '70011',
		name: 'Alberobello',
		province: 'BA',
		altitude: 428
	},
	{
		zip: '71031',
		name: 'Alberona',
		province: 'FG',
		altitude: 732
	},
	{
		zip: '22032',
		name: 'Albese con Cassano',
		province: 'CO',
		altitude: 402
	},
	{
		zip: '36020',
		name: 'Albettone',
		province: 'VI',
		altitude: 19
	},
	{
		zip: '88055',
		name: 'Albi',
		province: 'CZ',
		altitude: 710
	},
	{
		zip: '38041',
		name: 'Albiano',
		province: 'TN',
		altitude: 644
	},
	{
		zip: '10010',
		name: 'Albiano d\'\'Ivrea',
		province: 'TO',
		altitude: 230
	},
	{
		zip: '20847',
		name: 'Albiate',
		province: 'MB',
		altitude: 233
	},
	{
		zip: '87070',
		name: 'Albidona',
		province: 'CS',
		altitude: 810
	},
	{
		zip: '35020',
		name: 'Albignasego',
		province: 'PD',
		altitude: 13
	},
	{
		zip: '42020',
		name: 'Albinea',
		province: 'RE',
		altitude: 166
	},
	{
		zip: '24021',
		name: 'Albino',
		province: 'BG',
		altitude: 342
	},
	{
		zip: '22070',
		name: 'Albiolo',
		province: 'CO',
		altitude: 423
	},
	{
		zip: '17011',
		name: 'Albisola Superiore',
		province: 'SV',
		altitude: 10
	},
	{
		zip: '17012',
		name: 'Albissola Marina',
		province: 'SV',
		altitude: 3
	},
	{
		zip: '21041',
		name: 'Albizzate',
		province: 'VA',
		altitude: 334
	},
	{
		zip: '27020',
		name: 'Albonese',
		province: 'PV',
		altitude: 113
	},
	{
		zip: '23010',
		name: 'Albosaggia',
		province: 'SO',
		altitude: 490
	},
	{
		zip: '14020',
		name: 'Albugnano',
		province: 'AT',
		altitude: 549
	},
	{
		zip: '27010',
		name: 'Albuzzano',
		province: 'PV',
		altitude: 76
	},
	{
		zip: '91011',
		name: 'Alcamo',
		province: 'TP',
		altitude: 256
	},
	{
		zip: '98070',
		name: 'Alcara li Fusi',
		province: 'ME',
		altitude: 400
	},
	{
		zip: '38060',
		name: 'Aldeno',
		province: 'TN',
		altitude: 212
	},
	{
		zip: '39040',
		name: 'Aldino',
		province: 'BZ',
		altitude: 1225
	},
	{
		zip: '09091',
		name: 'Ales',
		province: 'OR',
		altitude: 194
	},
	{
		zip: '15121',
		name: 'Alessandria',
		province: 'AL',
		altitude: 95
	},
	{
		zip: '87070',
		name: 'Alessandria del Carretto',
		province: 'CS',
		altitude: 1000
	},
	{
		zip: '92010',
		name: 'Alessandria della Rocca',
		province: 'AG',
		altitude: 533
	},
	{
		zip: '73031',
		name: 'Alessano',
		province: 'LE',
		altitude: 140
	},
	{
		zip: '73011',
		name: 'Alezio',
		province: 'LE',
		altitude: 75
	},
	{
		zip: '84040',
		name: 'Alfano',
		province: 'SA',
		altitude: 250
	},
	{
		zip: '67030',
		name: 'Alfedena',
		province: 'AQ',
		altitude: 914
	},
	{
		zip: '25020',
		name: 'Alfianello',
		province: 'BS',
		altitude: 48
	},
	{
		zip: '15021',
		name: 'Alfiano Natta',
		province: 'AL',
		altitude: 280
	},
	{
		zip: '48011',
		name: 'Alfonsine',
		province: 'RA',
		altitude: 6
	},
	{
		zip: '07041',
		name: 'Alghero',
		province: 'SS',
		altitude: 7
	},
	{
		zip: '24010',
		name: 'Algua',
		province: 'BG',
		altitude: 432
	},
	{
		zip: '90021',
		name: 'Alia',
		province: 'PA',
		altitude: 700
	},
	{
		zip: '75010',
		name: 'Aliano',
		province: 'MT',
		altitude: 555
	},
	{
		zip: '15010',
		name: 'Alice Bel Colle',
		province: 'AL',
		altitude: 418
	},
	{
		zip: '13040',
		name: 'Alice Castello',
		province: 'VC',
		altitude: 258
	},
	{
		zip: '81011',
		name: 'Alife',
		province: 'CE',
		altitude: 110
	},
	{
		zip: '90020',
		name: 'Alimena',
		province: 'PA',
		altitude: 750
	},
	{
		zip: '90020',
		name: 'Aliminusa',
		province: 'PA',
		altitude: 450
	},
	{
		zip: '09080',
		name: 'Allai',
		province: 'OR',
		altitude: 60
	},
	{
		zip: '32022',
		name: 'Alleghe',
		province: 'BL',
		altitude: 979
	},
	{
		zip: '11010',
		name: 'Allein',
		province: 'AO',
		altitude: 1190
	},
	{
		zip: '05011',
		name: 'Allerona',
		province: 'TR',
		altitude: 472
	},
	{
		zip: '73040',
		name: 'Alliste',
		province: 'LE',
		altitude: 54
	},
	{
		zip: '00051',
		name: 'Allumiere',
		province: 'RM',
		altitude: 522
	},
	{
		zip: '24030',
		name: 'Almenno San Bartolomeo',
		province: 'BG',
		altitude: 352
	},
	{
		zip: '24031',
		name: 'Almenno San Salvatore',
		province: 'BG',
		altitude: 328
	},
	{
		zip: '10040',
		name: 'Almese',
		province: 'TO',
		altitude: 364
	},
	{
		zip: '24011',
		name: 'Alme',
		province: 'BG',
		altitude: 294
	},
	{
		zip: '36045',
		name: 'Alonte',
		province: 'VI',
		altitude: 34
	},
	{
		zip: '32016',
		name: 'Alpago',
		province: 'BL',
		altitude: 690
	},
	{
		zip: '10080',
		name: 'Alpette',
		province: 'TO',
		altitude: 957
	},
	{
		zip: '10091',
		name: 'Alpignano',
		province: 'TO',
		altitude: 314
	},
	{
		zip: '29010',
		name: 'Alseno',
		province: 'PC',
		altitude: 79
	},
	{
		zip: '22040',
		name: 'Alserio',
		province: 'CO',
		altitude: 265
	},
	{
		zip: '29031',
		name: 'Alta Val Tidone',
		province: 'PC',
		altitude: 284
	},
	{
		zip: '22024',
		name: 'Alta Valle Intelvi',
		province: 'CO',
		altitude: 907
	},
	{
		zip: '70022',
		name: 'Altamura',
		province: 'BA',
		altitude: 467
	},
	{
		zip: '17041',
		name: 'Altare',
		province: 'SV',
		altitude: 398
	},
	{
		zip: '38092',
		name: 'Altavalle',
		province: 'TN',
		altitude: 672
	},
	{
		zip: '83011',
		name: 'Altavilla Irpina',
		province: 'AV',
		altitude: 334
	},
	{
		zip: '90010',
		name: 'Altavilla Milicia',
		province: 'PA',
		altitude: 73
	},
	{
		zip: '15041',
		name: 'Altavilla Monferrato',
		province: 'AL',
		altitude: 256
	},
	{
		zip: '84045',
		name: 'Altavilla Silentina',
		province: 'SA',
		altitude: 319
	},
	{
		zip: '36077',
		name: 'Altavilla Vicentina',
		province: 'VI',
		altitude: 45
	},
	{
		zip: '63824',
		name: 'Altidona',
		province: 'FM',
		altitude: 224
	},
	{
		zip: '87040',
		name: 'Altilia',
		province: 'CS',
		altitude: 594
	},
	{
		zip: '66040',
		name: 'Altino',
		province: 'CH',
		altitude: 345
	},
	{
		zip: '36070',
		name: 'Altissimo',
		province: 'VI',
		altitude: 672
	},
	{
		zip: '31030',
		name: 'Altivole',
		province: 'TV',
		altitude: 88
	},
	{
		zip: '12070',
		name: 'Alto',
		province: 'CN',
		altitude: 652
	},
	{
		zip: '40046',
		name: 'Alto Reno Terme',
		province: 'BO',
		altitude: 349
	},
	{
		zip: '13029',
		name: 'Alto Sermenza',
		province: 'VC',
		altitude: 906
	},
	{
		zip: '90030',
		name: 'Altofonte',
		province: 'PA',
		altitude: 350
	},
	{
		zip: '87042',
		name: 'Altomonte',
		province: 'CS',
		altitude: 455
	},
	{
		zip: '55011',
		name: 'Altopascio',
		province: 'LU',
		altitude: 19
	},
	{
		zip: '38049',
		name: 'Altopiano della Vigolana',
		province: 'TN',
		altitude: 725
	},
	{
		zip: '05020',
		name: 'Alviano',
		province: 'TR',
		altitude: 251
	},
	{
		zip: '81012',
		name: 'Alvignano',
		province: 'CE',
		altitude: 132
	},
	{
		zip: '03041',
		name: 'Alvito',
		province: 'FR',
		altitude: 475
	},
	{
		zip: '24022',
		name: 'Alzano Lombardo',
		province: 'BG',
		altitude: 304
	},
	{
		zip: '15050',
		name: 'Alzano Scrivia',
		province: 'AL',
		altitude: 77
	},
	{
		zip: '22040',
		name: 'Alzate Brianza',
		province: 'CO',
		altitude: 371
	},
	{
		zip: '07020',
		name: 'Ala dei Sardi',
		province: 'SS',
		altitude: 663
	},
	{
		zip: '98020',
		name: 'Ali',
		province: 'ME',
		altitude: 450
	},
	{
		zip: '98021',
		name: 'Ali Terme',
		province: 'ME',
		altitude: 9
	},
	{
		zip: '84011',
		name: 'Amalfi',
		province: 'SA',
		altitude: 6
	},
	{
		zip: '63857',
		name: 'Amandola',
		province: 'FM',
		altitude: 500
	},
	{
		zip: '87032',
		name: 'Amantea',
		province: 'CS',
		altitude: 50
	},
	{
		zip: '33020',
		name: 'Amaro',
		province: 'UD',
		altitude: 296
	},
	{
		zip: '88050',
		name: 'Amaroni',
		province: 'CZ',
		altitude: 378
	},
	{
		zip: '03021',
		name: 'Amaseno',
		province: 'FR',
		altitude: 112
	},
	{
		zip: '88040',
		name: 'Amato',
		province: 'CZ',
		altitude: 480
	},
	{
		zip: '02012',
		name: 'Amatrice',
		province: 'RI',
		altitude: 955
	},
	{
		zip: '24030',
		name: 'Ambivere',
		province: 'BG',
		altitude: 261
	},
	{
		zip: '38011',
		name: 'Amblar-Don',
		province: 'TN',
		altitude: 980
	},
	{
		zip: '19031',
		name: 'Ameglia',
		province: 'SP',
		altitude: 89
	},
	{
		zip: '05022',
		name: 'Amelia',
		province: 'TR',
		altitude: 406
	},
	{
		zip: '87071',
		name: 'Amendolara',
		province: 'CS',
		altitude: 227
	},
	{
		zip: '28010',
		name: 'Ameno',
		province: 'NO',
		altitude: 517
	},
	{
		zip: '82031',
		name: 'Amorosi',
		province: 'BN',
		altitude: 60
	},
	{
		zip: '33021',
		name: 'Ampezzo',
		province: 'UD',
		altitude: 560
	},
	{
		zip: '80071',
		name: 'Anacapri',
		province: 'NA',
		altitude: 275
	},
	{
		zip: '03012',
		name: 'Anagni',
		province: 'FR',
		altitude: 424
	},
	{
		zip: '64010',
		name: 'Ancarano',
		province: 'TE',
		altitude: 293
	},
	{
		zip: '60121',
		name: 'Ancona',
		province: 'AN',
		altitude: 16
	},
	{
		zip: '88050',
		name: 'Andali',
		province: 'CZ',
		altitude: 650
	},
	{
		zip: '38010',
		name: 'Andalo',
		province: 'TN',
		altitude: 1042
	},
	{
		zip: '23009',
		name: 'Andalo Valtellino',
		province: 'SO',
		altitude: 229
	},
	{
		zip: '10020',
		name: 'Andezeno',
		province: 'TO',
		altitude: 306
	},
	{
		zip: '17051',
		name: 'Andora',
		province: 'SV',
		altitude: 10
	},
	{
		zip: '13811',
		name: 'Andorno Micca',
		province: 'BI',
		altitude: 544
	},
	{
		zip: '73032',
		name: 'Andrano',
		province: 'LE',
		altitude: 110
	},
	{
		zip: '10010',
		name: 'Andrate',
		province: 'TO',
		altitude: 836
	},
	{
		zip: '33080',
		name: 'Andreis',
		province: 'PN',
		altitude: 455
	},
	{
		zip: '83040',
		name: 'Andretta',
		province: 'AV',
		altitude: 850
	},
	{
		zip: '76123',
		name: 'Andria',
		province: 'BT',
		altitude: 151
	},
	{
		zip: '39010',
		name: 'Andriano',
		province: 'BZ',
		altitude: 274
	},
	{
		zip: '07010',
		name: 'Anela',
		province: 'SS',
		altitude: 446
	},
	{
		zip: '25070',
		name: 'Anfo',
		province: 'BS',
		altitude: 400
	},
	{
		zip: '21021',
		name: 'Angera',
		province: 'VA',
		altitude: 205
	},
	{
		zip: '52031',
		name: 'Anghiari',
		province: 'AR',
		altitude: 429
	},
	{
		zip: '37050',
		name: 'Angiari',
		province: 'VR',
		altitude: 17
	},
	{
		zip: '25040',
		name: 'Angolo Terme',
		province: 'BS',
		altitude: 426
	},
	{
		zip: '84012',
		name: 'Angri',
		province: 'SA',
		altitude: 32
	},
	{
		zip: '10060',
		name: 'Angrogna',
		province: 'TO',
		altitude: 782
	},
	{
		zip: '00061',
		name: 'Anguillara Sabazia',
		province: 'RM',
		altitude: 195
	},
	{
		zip: '35022',
		name: 'Anguillara Veneta',
		province: 'PD',
		altitude: 6
	},
	{
		zip: '26021',
		name: 'Annicco',
		province: 'CR',
		altitude: 60
	},
	{
		zip: '30020',
		name: 'Annone Veneto',
		province: 'VE',
		altitude: 9
	},
	{
		zip: '23841',
		name: 'Annone di Brianza',
		province: 'LC',
		altitude: 265
	},
	{
		zip: '89020',
		name: 'Anoia',
		province: 'RC',
		altitude: 210
	},
	{
		zip: '24051',
		name: 'Antegnate',
		province: 'BG',
		altitude: 112
	},
	{
		zip: '39040',
		name: 'Anterivo',
		province: 'BZ',
		altitude: 1209
	},
	{
		zip: '11020',
		name: 'Antey-Saint-André',
		province: 'AO',
		altitude: 1074
	},
	{
		zip: '00022',
		name: 'Anticoli Corrado',
		province: 'RM',
		altitude: 508
	},
	{
		zip: '14010',
		name: 'Antignano',
		province: 'AT',
		altitude: 260
	},
	{
		zip: '98030',
		name: 'Antillo',
		province: 'ME',
		altitude: 480
	},
	{
		zip: '89040',
		name: 'Antonimina',
		province: 'RC',
		altitude: 327
	},
	{
		zip: '02013',
		name: 'Antrodoco',
		province: 'RI',
		altitude: 525
	},
	{
		zip: '28841',
		name: 'Antrona Schieranco',
		province: 'VB',
		altitude: 902
	},
	{
		zip: '67030',
		name: 'Anversa degli Abruzzi',
		province: 'AQ',
		altitude: 560
	},
	{
		zip: '22040',
		name: 'Anzano del Parco',
		province: 'CO',
		altitude: 320
	},
	{
		zip: '71020',
		name: 'Anzano di Puglia',
		province: 'FG',
		altitude: 760
	},
	{
		zip: '85010',
		name: 'Anzi',
		province: 'PZ',
		altitude: 1008
	},
	{
		zip: '00042',
		name: 'Anzio',
		province: 'RM',
		altitude: 3
	},
	{
		zip: '28877',
		name: 'Anzola d\'\'Ossola',
		province: 'VB',
		altitude: 210
	},
	{
		zip: '40011',
		name: 'Anzola dell\'\'Emilia',
		province: 'BO',
		altitude: 38
	},
	{
		zip: '11100',
		name: 'Aosta',
		province: 'AO',
		altitude: 583
	},
	{
		zip: '61042',
		name: 'Apecchio',
		province: 'PU',
		altitude: 493
	},
	{
		zip: '82021',
		name: 'Apice',
		province: 'BN',
		altitude: 220
	},
	{
		zip: '62021',
		name: 'Apiro',
		province: 'MC',
		altitude: 516
	},
	{
		zip: '82030',
		name: 'Apollosa',
		province: 'BN',
		altitude: 430
	},
	{
		zip: '22070',
		name: 'Appiano Gentile',
		province: 'CO',
		altitude: 366
	},
	{
		zip: '39057',
		name: 'Appiano sulla Strada del Vino',
		province: 'BZ',
		altitude: 416
	},
	{
		zip: '62010',
		name: 'Appignano',
		province: 'MC',
		altitude: 199
	},
	{
		zip: '63083',
		name: 'Appignano del Tronto',
		province: 'AP',
		altitude: 194
	},
	{
		zip: '23031',
		name: 'Aprica',
		province: 'SO',
		altitude: 1181
	},
	{
		zip: '18035',
		name: 'Apricale',
		province: 'IM',
		altitude: 273
	},
	{
		zip: '71011',
		name: 'Apricena',
		province: 'FG',
		altitude: 73
	},
	{
		zip: '87051',
		name: 'Aprigliano',
		province: 'CS',
		altitude: 718
	},
	{
		zip: '04011',
		name: 'Aprilia',
		province: 'LT',
		altitude: 80
	},
	{
		zip: '84020',
		name: 'Aquara',
		province: 'SA',
		altitude: 500
	},
	{
		zip: '18020',
		name: 'Aquila d\'\'Arroscia',
		province: 'IM',
		altitude: 495
	},
	{
		zip: '33051',
		name: 'Aquileia',
		province: 'UD',
		altitude: 5
	},
	{
		zip: '83041',
		name: 'Aquilonia',
		province: 'AV',
		altitude: 750
	},
	{
		zip: '03031',
		name: 'Aquino',
		province: 'FR',
		altitude: 109
	},
	{
		zip: '73040',
		name: 'Aradeo',
		province: 'LE',
		altitude: 76
	},
	{
		zip: '92021',
		name: 'Aragona',
		province: 'AG',
		altitude: 400
	},
	{
		zip: '14020',
		name: 'Aramengo',
		province: 'AT',
		altitude: 357
	},
	{
		zip: '33090',
		name: 'Arba',
		province: 'PN',
		altitude: 210
	},
	{
		zip: '09092',
		name: 'Arborea',
		province: 'OR',
		altitude: 7
	},
	{
		zip: '13031',
		name: 'Arborio',
		province: 'VC',
		altitude: 185
	},
	{
		zip: '09031',
		name: 'Arbus',
		province: 'SU',
		altitude: 311
	},
	{
		zip: '31030',
		name: 'Arcade',
		province: 'TV',
		altitude: 65
	},
	{
		zip: '03032',
		name: 'Arce',
		province: 'FR',
		altitude: 247
	},
	{
		zip: '24040',
		name: 'Arcene',
		province: 'BG',
		altitude: 152
	},
	{
		zip: '60011',
		name: 'Arcevia',
		province: 'AN',
		altitude: 535
	},
	{
		zip: '66044',
		name: 'Archi',
		province: 'CH',
		altitude: 492
	},
	{
		zip: '58031',
		name: 'Arcidosso',
		province: 'GR',
		altitude: 679
	},
	{
		zip: '00020',
		name: 'Arcinazzo Romano',
		province: 'RM',
		altitude: 831
	},
	{
		zip: '21051',
		name: 'Arcisate',
		province: 'VA',
		altitude: 372
	},
	{
		zip: '38062',
		name: 'Arco',
		province: 'TN',
		altitude: 91
	},
	{
		zip: '19021',
		name: 'Arcola',
		province: 'SP',
		altitude: 70
	},
	{
		zip: '37040',
		name: 'Arcole',
		province: 'VR',
		altitude: 27
	},
	{
		zip: '20020',
		name: 'Arconate',
		province: 'MI',
		altitude: 180
	},
	{
		zip: '20862',
		name: 'Arcore',
		province: 'MB',
		altitude: 193
	},
	{
		zip: '36057',
		name: 'Arcugnano',
		province: 'VI',
		altitude: 60
	},
	{
		zip: '07010',
		name: 'Ardara',
		province: 'SS',
		altitude: 296
	},
	{
		zip: '09081',
		name: 'Ardauli',
		province: 'OR',
		altitude: 421
	},
	{
		zip: '00040',
		name: 'Ardea',
		province: 'RM',
		altitude: 37
	},
	{
		zip: '23011',
		name: 'Ardenno',
		province: 'SO',
		altitude: 266
	},
	{
		zip: '24020',
		name: 'Ardesio',
		province: 'BG',
		altitude: 608
	},
	{
		zip: '89031',
		name: 'Ardore',
		province: 'RC',
		altitude: 250
	},
	{
		zip: '89832',
		name: 'Arena',
		province: 'VV',
		altitude: 496
	},
	{
		zip: '27040',
		name: 'Arena Po',
		province: 'PV',
		altitude: 61
	},
	{
		zip: '16011',
		name: 'Arenzano',
		province: 'GE',
		altitude: 10
	},
	{
		zip: '20044',
		name: 'Arese',
		province: 'MI',
		altitude: 160
	},
	{
		zip: '52100',
		name: 'Arezzo',
		province: 'AR',
		altitude: 296
	},
	{
		zip: '22010',
		name: 'Argegno',
		province: 'CO',
		altitude: 210
	},
	{
		zip: '40050',
		name: 'Argelato',
		province: 'BO',
		altitude: 25
	},
	{
		zip: '44010',
		name: 'Argenta',
		province: 'FE',
		altitude: 4
	},
	{
		zip: '12010',
		name: 'Argentera',
		province: 'CN',
		altitude: 1684
	},
	{
		zip: '12050',
		name: 'Arguello',
		province: 'CN',
		altitude: 661
	},
	{
		zip: '88060',
		name: 'Argusto',
		province: 'CZ',
		altitude: 530
	},
	{
		zip: '66010',
		name: 'Ari',
		province: 'CH',
		altitude: 289
	},
	{
		zip: '45012',
		name: 'Ariano nel Polesine',
		province: 'RO',
		altitude: 2
	},
	{
		zip: '00072',
		name: 'Ariccia',
		province: 'RM',
		altitude: 412
	},
	{
		zip: '66030',
		name: 'Arielli',
		province: 'CH',
		altitude: 298
	},
	{
		zip: '81021',
		name: 'Arienzo',
		province: 'CE',
		altitude: 70
	},
	{
		zip: '10020',
		name: 'Arignano',
		province: 'TO',
		altitude: 321
	},
	{
		zip: '08031',
		name: 'Aritzo',
		province: 'NU',
		altitude: 796
	},
	{
		zip: '28811',
		name: 'Arizzano',
		province: 'VB',
		altitude: 458
	},
	{
		zip: '01010',
		name: 'Arlena di Castro',
		province: 'VT',
		altitude: 260
	},
	{
		zip: '20010',
		name: 'Arluno',
		province: 'MI',
		altitude: 156
	},
	{
		zip: '28011',
		name: 'Armeno',
		province: 'NO',
		altitude: 523
	},
	{
		zip: '85010',
		name: 'Armento',
		province: 'PZ',
		altitude: 710
	},
	{
		zip: '18026',
		name: 'Armo',
		province: 'IM',
		altitude: 578
	},
	{
		zip: '09040',
		name: 'Armungia',
		province: 'SU',
		altitude: 366
	},
	{
		zip: '11020',
		name: 'Arnad',
		province: 'AO',
		altitude: 361
	},
	{
		zip: '03020',
		name: 'Arnara',
		province: 'FR',
		altitude: 250
	},
	{
		zip: '17032',
		name: 'Arnasco',
		province: 'SV',
		altitude: 250
	},
	{
		zip: '73010',
		name: 'Arnesano',
		province: 'LE',
		altitude: 33
	},
	{
		zip: '28899',
		name: 'Arola',
		province: 'VB',
		altitude: 615
	},
	{
		zip: '28041',
		name: 'Arona',
		province: 'NO',
		altitude: 212
	},
	{
		zip: '22060',
		name: 'Arosio',
		province: 'CO',
		altitude: 300
	},
	{
		zip: '82011',
		name: 'Arpaia',
		province: 'BN',
		altitude: 283
	},
	{
		zip: '82010',
		name: 'Arpaise',
		province: 'BN',
		altitude: 410
	},
	{
		zip: '03033',
		name: 'Arpino',
		province: 'FR',
		altitude: 447
	},
	{
		zip: '15061',
		name: 'Arquata Scrivia',
		province: 'AL',
		altitude: 248
	},
	{
		zip: '63096',
		name: 'Arquata del Tronto',
		province: 'AP',
		altitude: 777
	},
	{
		zip: '35032',
		name: 'Arqua Petrarca',
		province: 'PD',
		altitude: 80
	},
	{
		zip: '45031',
		name: 'Arqua Polesine',
		province: 'RO',
		altitude: 8
	},
	{
		zip: '35020',
		name: 'Arre',
		province: 'PD',
		altitude: 5
	},
	{
		zip: '05031',
		name: 'Arrone',
		province: 'TR',
		altitude: 243
	},
	{
		zip: '21010',
		name: 'Arsago Seprio',
		province: 'VA',
		altitude: 290
	},
	{
		zip: '36011',
		name: 'Arsiero',
		province: 'VI',
		altitude: 356
	},
	{
		zip: '64031',
		name: 'Arsita',
		province: 'TE',
		altitude: 470
	},
	{
		zip: '32030',
		name: 'Arsie',
		province: 'BL',
		altitude: 314
	},
	{
		zip: '00023',
		name: 'Arsoli',
		province: 'RM',
		altitude: 470
	},
	{
		zip: '33022',
		name: 'Arta Terme',
		province: 'UD',
		altitude: 442
	},
	{
		zip: '33011',
		name: 'Artegna',
		province: 'UD',
		altitude: 210
	},
	{
		zip: '00031',
		name: 'Artena',
		province: 'RM',
		altitude: 420
	},
	{
		zip: '25040',
		name: 'Artogne',
		province: 'BS',
		altitude: 266
	},
	{
		zip: '11011',
		name: 'Arvier',
		province: 'AO',
		altitude: 776
	},
	{
		zip: '07020',
		name: 'Arzachena',
		province: 'SS',
		altitude: 83
	},
	{
		zip: '24040',
		name: 'Arzago d\'\'Adda',
		province: 'BG',
		altitude: 106
	},
	{
		zip: '08040',
		name: 'Arzana',
		province: 'NU',
		altitude: 672
	},
	{
		zip: '80022',
		name: 'Arzano',
		province: 'NA',
		altitude: 74
	},
	{
		zip: '35020',
		name: 'Arzergrande',
		province: 'PD',
		altitude: 6
	},
	{
		zip: '36071',
		name: 'Arzignano',
		province: 'VI',
		altitude: 118
	},
	{
		zip: '84046',
		name: 'Ascea',
		province: 'SA',
		altitude: 293
	},
	{
		zip: '53041',
		name: 'Asciano',
		province: 'SI',
		altitude: 200
	},
	{
		zip: '63100',
		name: 'Ascoli Piceno',
		province: 'AP',
		altitude: 154
	},
	{
		zip: '71022',
		name: 'Ascoli Satriano',
		province: 'FG',
		altitude: 393
	},
	{
		zip: '02020',
		name: 'Ascrea',
		province: 'RI',
		altitude: 757
	},
	{
		zip: '36012',
		name: 'Asiago',
		province: 'VI',
		altitude: 1001
	},
	{
		zip: '36020',
		name: 'Asigliano Veneto',
		province: 'VI',
		altitude: 22
	},
	{
		zip: '13032',
		name: 'Asigliano Vercellese',
		province: 'VC',
		altitude: 127
	},
	{
		zip: '46041',
		name: 'Asola',
		province: 'MN',
		altitude: 42
	},
	{
		zip: '31011',
		name: 'Asolo',
		province: 'TV',
		altitude: 190
	},
	{
		zip: '20057',
		name: 'Assago',
		province: 'MI',
		altitude: 109
	},
	{
		zip: '09032',
		name: 'Assemini',
		province: 'CA',
		altitude: 6
	},
	{
		zip: '06081',
		name: 'Assisi',
		province: 'PG',
		altitude: 424
	},
	{
		zip: '22033',
		name: 'Asso',
		province: 'CO',
		altitude: 427
	},
	{
		zip: '09080',
		name: 'Assolo',
		province: 'OR',
		altitude: 255
	},
	{
		zip: '94010',
		name: 'Assoro',
		province: 'EN',
		altitude: 850
	},
	{
		zip: '14100',
		name: 'Asti',
		province: 'AT',
		altitude: 123
	},
	{
		zip: '09080',
		name: 'Asuni',
		province: 'OR',
		altitude: 233
	},
	{
		zip: '67030',
		name: 'Ateleta',
		province: 'AQ',
		altitude: 760
	},
	{
		zip: '84030',
		name: 'Atena Lucana',
		province: 'SA',
		altitude: 625
	},
	{
		zip: '66041',
		name: 'Atessa',
		province: 'CH',
		altitude: 435
	},
	{
		zip: '03042',
		name: 'Atina',
		province: 'FR',
		altitude: 481
	},
	{
		zip: '84010',
		name: 'Atrani',
		province: 'SA',
		altitude: 21
	},
	{
		zip: '64032',
		name: 'Atri',
		province: 'TE',
		altitude: 442
	},
	{
		zip: '83042',
		name: 'Atripalda',
		province: 'AV',
		altitude: 294
	},
	{
		zip: '05012',
		name: 'Attigliano',
		province: 'TR',
		altitude: 95
	},
	{
		zip: '33040',
		name: 'Attimis',
		province: 'UD',
		altitude: 195
	},
	{
		zip: '08030',
		name: 'Atzara',
		province: 'NU',
		altitude: 553
	},
	{
		zip: '96011',
		name: 'Augusta',
		province: 'SR',
		altitude: 15
	},
	{
		zip: '84031',
		name: 'Auletta',
		province: 'SA',
		altitude: 280
	},
	{
		zip: '54011',
		name: 'Aulla',
		province: 'MS',
		altitude: 64
	},
	{
		zip: '28812',
		name: 'Aurano',
		province: 'VB',
		altitude: 683
	},
	{
		zip: '18020',
		name: 'Aurigo',
		province: 'IM',
		altitude: 431
	},
	{
		zip: '32041',
		name: 'Auronzo di Cadore',
		province: 'BL',
		altitude: 866
	},
	{
		zip: '03040',
		name: 'Ausonia',
		province: 'FR',
		altitude: 178
	},
	{
		zip: '08030',
		name: 'Austis',
		province: 'NU',
		altitude: 737
	},
	{
		zip: '16036',
		name: 'Avegno',
		province: 'GE',
		altitude: 40
	},
	{
		zip: '39010',
		name: 'Avelengo',
		province: 'BZ',
		altitude: 1290
	},
	{
		zip: '83021',
		name: 'Avella',
		province: 'AV',
		altitude: 207
	},
	{
		zip: '83100',
		name: 'Avellino',
		province: 'AV',
		altitude: 348
	},
	{
		zip: '24010',
		name: 'Averara',
		province: 'BG',
		altitude: 650
	},
	{
		zip: '81031',
		name: 'Aversa',
		province: 'CE',
		altitude: 39
	},
	{
		zip: '74020',
		name: 'Avetrana',
		province: 'TA',
		altitude: 62
	},
	{
		zip: '67051',
		name: 'Avezzano',
		province: 'AQ',
		altitude: 695
	},
	{
		zip: '33081',
		name: 'Aviano',
		province: 'PN',
		altitude: 159
	},
	{
		zip: '24020',
		name: 'Aviatico',
		province: 'BG',
		altitude: 1022
	},
	{
		zip: '10051',
		name: 'Avigliana',
		province: 'TO',
		altitude: 383
	},
	{
		zip: '85021',
		name: 'Avigliano',
		province: 'PZ',
		altitude: 800
	},
	{
		zip: '05020',
		name: 'Avigliano Umbro',
		province: 'TR',
		altitude: 441
	},
	{
		zip: '38063',
		name: 'Avio',
		province: 'TN',
		altitude: 131
	},
	{
		zip: '11010',
		name: 'Avise',
		province: 'AO',
		altitude: 775
	},
	{
		zip: '96012',
		name: 'Avola',
		province: 'SR',
		altitude: 40
	},
	{
		zip: '15050',
		name: 'Avolasca',
		province: 'AL',
		altitude: 425
	},
	{
		zip: '11020',
		name: 'Ayas',
		province: 'AO',
		altitude: 1699
	},
	{
		zip: '11010',
		name: 'Aymavilles',
		province: 'AO',
		altitude: 640
	},
	{
		zip: '10010',
		name: 'Azeglio',
		province: 'TO',
		altitude: 260
	},
	{
		zip: '26010',
		name: 'Azzanello',
		province: 'CR',
		altitude: 68
	},
	{
		zip: '33082',
		name: 'Azzano Decimo',
		province: 'PN',
		altitude: 14
	},
	{
		zip: '25020',
		name: 'Azzano Mella',
		province: 'BS',
		altitude: 95
	},
	{
		zip: '24052',
		name: 'Azzano San Paolo',
		province: 'BG',
		altitude: 230
	},
	{
		zip: '14030',
		name: 'Azzano d\'\'Asti',
		province: 'AT',
		altitude: 216
	},
	{
		zip: '21022',
		name: 'Azzate',
		province: 'VA',
		altitude: 332
	},
	{
		zip: '21030',
		name: 'Azzio',
		province: 'VA',
		altitude: 399
	},
	{
		zip: '24020',
		name: 'Azzone',
		province: 'BG',
		altitude: 973
	},
	{
		zip: '28861',
		name: 'Baceno',
		province: 'VB',
		altitude: 655
	},
	{
		zip: '80070',
		name: 'Bacoli',
		province: 'NA',
		altitude: 30
	},
	{
		zip: '18010',
		name: 'Badalucco',
		province: 'IM',
		altitude: 179
	},
	{
		zip: '07030',
		name: 'Badesi',
		province: 'SS',
		altitude: 102
	},
	{
		zip: '39036',
		name: 'Badia',
		province: 'BZ',
		altitude: 1315
	},
	{
		zip: '37030',
		name: 'Badia Calavena',
		province: 'VR',
		altitude: 470
	},
	{
		zip: '27010',
		name: 'Badia Pavese',
		province: 'PV',
		altitude: 55
	},
	{
		zip: '45021',
		name: 'Badia Polesine',
		province: 'RO',
		altitude: 11
	},
	{
		zip: '52032',
		name: 'Badia Tedalda',
		province: 'AR',
		altitude: 700
	},
	{
		zip: '88060',
		name: 'Badolato',
		province: 'CZ',
		altitude: 240
	},
	{
		zip: '89060',
		name: 'Bagaladi',
		province: 'RC',
		altitude: 473
	},
	{
		zip: '90011',
		name: 'Bagheria',
		province: 'PA',
		altitude: 76
	},
	{
		zip: '48012',
		name: 'Bagnacavallo',
		province: 'RA',
		altitude: 11
	},
	{
		zip: '89011',
		name: 'Bagnara Calabra',
		province: 'RC',
		altitude: 50
	},
	{
		zip: '48031',
		name: 'Bagnara di Romagna',
		province: 'RA',
		altitude: 22
	},
	{
		zip: '27050',
		name: 'Bagnaria',
		province: 'PV',
		altitude: 333
	},
	{
		zip: '33050',
		name: 'Bagnaria Arsa',
		province: 'UD',
		altitude: 20
	},
	{
		zip: '12071',
		name: 'Bagnasco',
		province: 'CN',
		altitude: 483
	},
	{
		zip: '24060',
		name: 'Bagnatica',
		province: 'BG',
		altitude: 220
	},
	{
		zip: '55022',
		name: 'Bagni di Lucca',
		province: 'LU',
		altitude: 150
	},
	{
		zip: '50012',
		name: 'Bagno a Ripoli',
		province: 'FI',
		altitude: 75
	},
	{
		zip: '47021',
		name: 'Bagno di Romagna',
		province: 'FC',
		altitude: 462
	},
	{
		zip: '83043',
		name: 'Bagnoli Irpino',
		province: 'AV',
		altitude: 654
	},
	{
		zip: '86091',
		name: 'Bagnoli del Trigno',
		province: 'IS',
		altitude: 660
	},
	{
		zip: '35023',
		name: 'Bagnoli di Sopra',
		province: 'PD',
		altitude: 5
	},
	{
		zip: '26010',
		name: 'Bagnolo Cremasco',
		province: 'CR',
		altitude: 82
	},
	{
		zip: '25021',
		name: 'Bagnolo Mella',
		province: 'BS',
		altitude: 85
	},
	{
		zip: '12031',
		name: 'Bagnolo Piemonte',
		province: 'CN',
		altitude: 365
	},
	{
		zip: '46031',
		name: 'Bagnolo San Vito',
		province: 'MN',
		altitude: 19
	},
	{
		zip: '73020',
		name: 'Bagnolo del Salento',
		province: 'LE',
		altitude: 96
	},
	{
		zip: '45022',
		name: 'Bagnolo di Po',
		province: 'RO',
		altitude: 7
	},
	{
		zip: '42011',
		name: 'Bagnolo in Piano',
		province: 'RE',
		altitude: 32
	},
	{
		zip: '54021',
		name: 'Bagnone',
		province: 'MS',
		altitude: 236
	},
	{
		zip: '01022',
		name: 'Bagnoregio',
		province: 'VT',
		altitude: 484
	},
	{
		zip: '25072',
		name: 'Bagolino',
		province: 'BS',
		altitude: 778
	},
	{
		zip: '81010',
		name: 'Baia e Latina',
		province: 'CE',
		altitude: 123
	},
	{
		zip: '83022',
		name: 'Baiano',
		province: 'AV',
		altitude: 196
	},
	{
		zip: '10010',
		name: 'Bairo',
		province: 'TO',
		altitude: 365
	},
	{
		zip: '42031',
		name: 'Baiso',
		province: 'RE',
		altitude: 542
	},
	{
		zip: '18031',
		name: 'Bajardo',
		province: 'IM',
		altitude: 910
	},
	{
		zip: '10070',
		name: 'Balangero',
		province: 'TO',
		altitude: 440
	},
	{
		zip: '14011',
		name: 'Baldichieri d\'\'Asti',
		province: 'AT',
		altitude: 173
	},
	{
		zip: '10080',
		name: 'Baldissero Canavese',
		province: 'TO',
		altitude: 392
	},
	{
		zip: '10020',
		name: 'Baldissero Torinese',
		province: 'TO',
		altitude: 421
	},
	{
		zip: '12040',
		name: 'Baldissero d\'\'Alba',
		province: 'CN',
		altitude: 380
	},
	{
		zip: '90041',
		name: 'Balestrate',
		province: 'PA',
		altitude: 35
	},
	{
		zip: '17020',
		name: 'Balestrino',
		province: 'SV',
		altitude: 371
	},
	{
		zip: '23811',
		name: 'Ballabio',
		province: 'LC',
		altitude: 661
	},
	{
		zip: '09040',
		name: 'Ballao',
		province: 'SU',
		altitude: 98
	},
	{
		zip: '10070',
		name: 'Balme',
		province: 'TO',
		altitude: 1432
	},
	{
		zip: '13020',
		name: 'Balmuccia',
		province: 'VC',
		altitude: 560
	},
	{
		zip: '13040',
		name: 'Balocco',
		province: 'VC',
		altitude: 166
	},
	{
		zip: '67052',
		name: 'Balsorano',
		province: 'AQ',
		altitude: 340
	},
	{
		zip: '85050',
		name: 'Balvano',
		province: 'PZ',
		altitude: 425
	},
	{
		zip: '15031',
		name: 'Balzola',
		province: 'AL',
		altitude: 119
	},
	{
		zip: '07040',
		name: 'Banari',
		province: 'SS',
		altitude: 419
	},
	{
		zip: '10010',
		name: 'Banchette',
		province: 'TO',
		altitude: 266
	},
	{
		zip: '28871',
		name: 'Bannio Anzino',
		province: 'VB',
		altitude: 669
	},
	{
		zip: '85010',
		name: 'Banzi',
		province: 'PZ',
		altitude: 571
	},
	{
		zip: '35030',
		name: 'Baone',
		province: 'PD',
		altitude: 17
	},
	{
		zip: '09090',
		name: 'Baradili',
		province: 'OR',
		altitude: 165
	},
	{
		zip: '85050',
		name: 'Baragiano',
		province: 'PZ',
		altitude: 625
	},
	{
		zip: '86011',
		name: 'Baranello',
		province: 'CB',
		altitude: 610
	},
	{
		zip: '80072',
		name: 'Barano d\'\'Ischia',
		province: 'NA',
		altitude: 210
	},
	{
		zip: '20021',
		name: 'Baranzate',
		province: 'MI',
		altitude: 144
	},
	{
		zip: '21020',
		name: 'Barasso',
		province: 'VA',
		altitude: 401
	},
	{
		zip: '09070',
		name: 'Baratili San Pietro',
		province: 'OR',
		altitude: 11
	},
	{
		zip: '10070',
		name: 'Barbania',
		province: 'TO',
		altitude: 362
	},
	{
		zip: '60010',
		name: 'Barbara',
		province: 'AN',
		altitude: 219
	},
	{
		zip: '01010',
		name: 'Barbarano Romano',
		province: 'VT',
		altitude: 340
	},
	{
		zip: '12050',
		name: 'Barbaresco',
		province: 'CN',
		altitude: 274
	},
	{
		zip: '25030',
		name: 'Barbariga',
		province: 'BS',
		altitude: 81
	},
	{
		zip: '24040',
		name: 'Barbata',
		province: 'BG',
		altitude: 105
	},
	{
		zip: '50028',
		name: 'Barberino Tavarnelle',
		province: 'FI',
		altitude: 389
	},
	{
		zip: '50031',
		name: 'Barberino di Mugello',
		province: 'FI',
		altitude: 270
	},
	{
		zip: '27041',
		name: 'Barbianello',
		province: 'PV',
		altitude: 63
	},
	{
		zip: '39040',
		name: 'Barbiano',
		province: 'BZ',
		altitude: 836
	},
	{
		zip: '35040',
		name: 'Barbona',
		province: 'PD',
		altitude: 7
	},
	{
		zip: '98051',
		name: 'Barcellona Pozzo di Gotto',
		province: 'ME',
		altitude: 60
	},
	{
		zip: '33080',
		name: 'Barcis',
		province: 'PN',
		altitude: 409
	},
	{
		zip: '11020',
		name: 'Bard',
		province: 'AO',
		altitude: 400
	},
	{
		zip: '21020',
		name: 'Bardello',
		province: 'VA',
		altitude: 263
	},
	{
		zip: '43032',
		name: 'Bardi',
		province: 'PR',
		altitude: 625
	},
	{
		zip: '17057',
		name: 'Bardineto',
		province: 'SV',
		altitude: 711
	},
	{
		zip: '37011',
		name: 'Bardolino',
		province: 'VR',
		altitude: 65
	},
	{
		zip: '10052',
		name: 'Bardonecchia',
		province: 'TO',
		altitude: 1312
	},
	{
		zip: '20010',
		name: 'Bareggio',
		province: 'MI',
		altitude: 138
	},
	{
		zip: '28010',
		name: 'Barengo',
		province: 'NO',
		altitude: 225
	},
	{
		zip: '09090',
		name: 'Baressa',
		province: 'OR',
		altitude: 165
	},
	{
		zip: '67010',
		name: 'Barete',
		province: 'AQ',
		altitude: 800
	},
	{
		zip: '55051',
		name: 'Barga',
		province: 'LU',
		altitude: 410
	},
	{
		zip: '16021',
		name: 'Bargagli',
		province: 'GE',
		altitude: 341
	},
	{
		zip: '12032',
		name: 'Barge',
		province: 'CN',
		altitude: 372
	},
	{
		zip: '25070',
		name: 'Barghe',
		province: 'BS',
		altitude: 295
	},
	{
		zip: '70121',
		name: 'Bari',
		province: 'BA',
		altitude: 5
	},
	{
		zip: '08042',
		name: 'Bari Sardo',
		province: 'NU',
		altitude: 51
	},
	{
		zip: '24050',
		name: 'Bariano',
		province: 'BG',
		altitude: 114
	},
	{
		zip: '40052',
		name: 'Baricella',
		province: 'BO',
		altitude: 11
	},
	{
		zip: '85022',
		name: 'Barile',
		province: 'PZ',
		altitude: 664
	},
	{
		zip: '67021',
		name: 'Barisciano',
		province: 'AQ',
		altitude: 940
	},
	{
		zip: '20825',
		name: 'Barlassina',
		province: 'MB',
		altitude: 227
	},
	{
		zip: '76121',
		name: 'Barletta',
		province: 'BT',
		altitude: 15
	},
	{
		zip: '22030',
		name: 'Barni',
		province: 'CO',
		altitude: 635
	},
	{
		zip: '12060',
		name: 'Barolo',
		province: 'CN',
		altitude: 301
	},
	{
		zip: '01010',
		name: 'Barone Canavese',
		province: 'TO',
		altitude: 325
	},
	{
		zip: '84081',
		name: 'Baronissi',
		province: 'SA',
		altitude: 226
	},
	{
		zip: '94012',
		name: 'Barrafranca',
		province: 'EN',
		altitude: 450
	},
	{
		zip: '09040',
		name: 'Barrali',
		province: 'SU',
		altitude: 140
	},
	{
		zip: '67030',
		name: 'Barrea',
		province: 'AQ',
		altitude: 1060
	},
	{
		zip: '09021',
		name: 'Barumini',
		province: 'SU',
		altitude: 202
	},
	{
		zip: '23890',
		name: 'Barzago',
		province: 'LC',
		altitude: 358
	},
	{
		zip: '24030',
		name: 'Barzana',
		province: 'BG',
		altitude: 300
	},
	{
		zip: '23891',
		name: 'Barzano',
		province: 'LC',
		altitude: 365
	},
	{
		zip: '23816',
		name: 'Barzio',
		province: 'LC',
		altitude: 769
	},
	{
		zip: '15060',
		name: 'Basaluzzo',
		province: 'AL',
		altitude: 149
	},
	{
		zip: '27010',
		name: 'Bascape',
		province: 'PV',
		altitude: 89
	},
	{
		zip: '05023',
		name: 'Baschi',
		province: 'TR',
		altitude: 165
	},
	{
		zip: '64030',
		name: 'Basciano',
		province: 'TE',
		altitude: 388
	},
	{
		zip: '38042',
		name: 'Baselga di Pine',
		province: 'TN',
		altitude: 964
	},
	{
		zip: '82020',
		name: 'Baselice',
		province: 'BN',
		altitude: 620
	},
	{
		zip: '20060',
		name: 'Basiano',
		province: 'MI',
		altitude: 161
	},
	{
		zip: '98060',
		name: 'Basico',
		province: 'ME',
		altitude: 520
	},
	{
		zip: '20079',
		name: 'Basiglio',
		province: 'MI',
		altitude: 97
	},
	{
		zip: '33031',
		name: 'Basiliano',
		province: 'UD',
		altitude: 77
	},
	{
		zip: '25020',
		name: 'Bassano Bresciano',
		province: 'BS',
		altitude: 65
	},
	{
		zip: '01030',
		name: 'Bassano Romano',
		province: 'VT',
		altitude: 360
	},
	{
		zip: '36061',
		name: 'Bassano del Grappa',
		province: 'VI',
		altitude: 129
	},
	{
		zip: '01030',
		name: 'Bassano in Teverina',
		province: 'VT',
		altitude: 304
	},
	{
		zip: '04010',
		name: 'Bassiano',
		province: 'LT',
		altitude: 562
	},
	{
		zip: '15042',
		name: 'Bassignana',
		province: 'AL',
		altitude: 96
	},
	{
		zip: '12060',
		name: 'Bastia Mondovi',
		province: 'CN',
		altitude: 294
	},
	{
		zip: '06083',
		name: 'Bastia Umbra',
		province: 'PG',
		altitude: 202
	},
	{
		zip: '27050',
		name: 'Bastida Pancarana',
		province: 'PV',
		altitude: 67
	},
	{
		zip: '41030',
		name: 'Bastiglia',
		province: 'MO',
		altitude: 27
	},
	{
		zip: '35041',
		name: 'Battaglia Terme',
		province: 'PD',
		altitude: 11
	},
	{
		zip: '12070',
		name: 'Battifollo',
		province: 'CN',
		altitude: 846
	},
	{
		zip: '84091',
		name: 'Battipaglia',
		province: 'SA',
		altitude: 72
	},
	{
		zip: '27020',
		name: 'Battuda',
		province: 'PV',
		altitude: 98
	},
	{
		zip: '90020',
		name: 'Baucina',
		province: 'PA',
		altitude: 550
	},
	{
		zip: '09070',
		name: 'Bauladu',
		province: 'OR',
		altitude: 38
	},
	{
		zip: '08040',
		name: 'Baunei',
		province: 'NU',
		altitude: 480
	},
	{
		zip: '28831',
		name: 'Baveno',
		province: 'VB',
		altitude: 205
	},
	{
		zip: '21039',
		name: 'Bedero Valcuvia',
		province: 'VA',
		altitude: 520
	},
	{
		zip: '25081',
		name: 'Bedizzole',
		province: 'BS',
		altitude: 184
	},
	{
		zip: '38043',
		name: 'Bedollo',
		province: 'TN',
		altitude: 1133
	},
	{
		zip: '43041',
		name: 'Bedonia',
		province: 'PR',
		altitude: 500
	},
	{
		zip: '24030',
		name: 'Bedulita',
		province: 'BG',
		altitude: 600
	},
	{
		zip: '28813',
		name: 'Bee',
		province: 'VB',
		altitude: 591
	},
	{
		zip: '10092',
		name: 'Beinasco',
		province: 'TO',
		altitude: 265
	},
	{
		zip: '12081',
		name: 'Beinette',
		province: 'CN',
		altitude: 491
	},
	{
		zip: '88050',
		name: 'Belcastro',
		province: 'CZ',
		altitude: 495
	},
	{
		zip: '37050',
		name: 'Belfiore',
		province: 'VR',
		altitude: 26
	},
	{
		zip: '15070',
		name: 'Belforte Monferrato',
		province: 'AL',
		altitude: 297
	},
	{
		zip: '61020',
		name: 'Belforte all\'\'Isauro',
		province: 'PU',
		altitude: 344
	},
	{
		zip: '62020',
		name: 'Belforte del Chienti',
		province: 'MC',
		altitude: 347
	},
	{
		zip: '27011',
		name: 'Belgioioso',
		province: 'PV',
		altitude: 75
	},
	{
		zip: '28832',
		name: 'Belgirate',
		province: 'VB',
		altitude: 199
	},
	{
		zip: '85051',
		name: 'Bella',
		province: 'PZ',
		altitude: 662
	},
	{
		zip: '22021',
		name: 'Bellagio',
		province: 'CO',
		altitude: 229
	},
	{
		zip: '23822',
		name: 'Bellano',
		province: 'LC',
		altitude: 202
	},
	{
		zip: '64020',
		name: 'Bellante',
		province: 'TE',
		altitude: 354
	},
	{
		zip: '47814',
		name: 'Bellaria-Igea Marina',
		province: 'RN',
		altitude: 3
	},
	{
		zip: '00030',
		name: 'Bellegra',
		province: 'RM',
		altitude: 815
	},
	{
		zip: '12020',
		name: 'Bellino',
		province: 'CN',
		altitude: 1572
	},
	{
		zip: '20060',
		name: 'Bellinzago Lombardo',
		province: 'MI',
		altitude: 129
	},
	{
		zip: '28043',
		name: 'Bellinzago Novarese',
		province: 'NO',
		altitude: 192
	},
	{
		zip: '84092',
		name: 'Bellizzi',
		province: 'SA',
		altitude: 60
	},
	{
		zip: '81041',
		name: 'Bellona',
		province: 'CE',
		altitude: 63
	},
	{
		zip: '84020',
		name: 'Bellosguardo',
		province: 'SA',
		altitude: 559
	},
	{
		zip: '32100',
		name: 'Belluno',
		province: 'BL',
		altitude: 389
	},
	{
		zip: '20882',
		name: 'Bellusco',
		province: 'MB',
		altitude: 214
	},
	{
		zip: '87033',
		name: 'Belmonte Calabro',
		province: 'CS',
		altitude: 262
	},
	{
		zip: '03040',
		name: 'Belmonte Castello',
		province: 'FR',
		altitude: 369
	},
	{
		zip: '90031',
		name: 'Belmonte Mezzagno',
		province: 'PA',
		altitude: 356
	},
	{
		zip: '63838',
		name: 'Belmonte Piceno',
		province: 'FM',
		altitude: 312
	},
	{
		zip: '86080',
		name: 'Belmonte del Sannio',
		province: 'IS',
		altitude: 864
	},
	{
		zip: '02020',
		name: 'Belmonte in Sabina',
		province: 'RI',
		altitude: 756
	},
	{
		zip: '95032',
		name: 'Belpasso',
		province: 'CT',
		altitude: 551
	},
	{
		zip: '87030',
		name: 'Belsito',
		province: 'CS',
		altitude: 600
	},
	{
		zip: '12060',
		name: 'Belvedere Langhe',
		province: 'CN',
		altitude: 639
	},
	{
		zip: '87021',
		name: 'Belvedere Marittimo',
		province: 'CS',
		altitude: 150
	},
	{
		zip: '60030',
		name: 'Belvedere Ostrense',
		province: 'AN',
		altitude: 251
	},
	{
		zip: '88824',
		name: 'Belvedere di Spinello',
		province: 'KR',
		altitude: 330
	},
	{
		zip: '14040',
		name: 'Belveglio',
		province: 'AT',
		altitude: 141
	},
	{
		zip: '08030',
		name: 'Belvi',
		province: 'NU',
		altitude: 660
	},
	{
		zip: '23010',
		name: 'Bema',
		province: 'SO',
		altitude: 800
	},
	{
		zip: '22010',
		name: 'Bene Lario',
		province: 'CO',
		altitude: 377
	},
	{
		zip: '12041',
		name: 'Bene Vagienna',
		province: 'CN',
		altitude: 349
	},
	{
		zip: '89030',
		name: 'Benestare',
		province: 'RC',
		altitude: 250
	},
	{
		zip: '07010',
		name: 'Benetutti',
		province: 'SS',
		altitude: 406
	},
	{
		zip: '12050',
		name: 'Benevello',
		province: 'CN',
		altitude: 671
	},
	{
		zip: '82100',
		name: 'Benevento',
		province: 'BN',
		altitude: 135
	},
	{
		zip: '40010',
		name: 'Bentivoglio',
		province: 'BO',
		altitude: 19
	},
	{
		zip: '24030',
		name: 'Berbenno',
		province: 'BG',
		altitude: 675
	},
	{
		zip: '23010',
		name: 'Berbenno di Valtellina',
		province: 'SO',
		altitude: 370
	},
	{
		zip: '43042',
		name: 'Berceto',
		province: 'PR',
		altitude: 852
	},
	{
		zip: '07022',
		name: 'Berchidda',
		province: 'SS',
		altitude: 290
	},
	{
		zip: '22070',
		name: 'Beregazzo con Figliaro',
		province: 'CO',
		altitude: 423
	},
	{
		zip: '27021',
		name: 'Bereguardo',
		province: 'PV',
		altitude: 98
	},
	{
		zip: '15022',
		name: 'Bergamasco',
		province: 'AL',
		altitude: 125
	},
	{
		zip: '24121',
		name: 'Bergamo',
		province: 'BG',
		altitude: 249
	},
	{
		zip: '45032',
		name: 'Bergantino',
		province: 'RO',
		altitude: 15
	},
	{
		zip: '17042',
		name: 'Bergeggi',
		province: 'SV',
		altitude: 110
	},
	{
		zip: '12074',
		name: 'Bergolo',
		province: 'CN',
		altitude: 616
	},
	{
		zip: '25030',
		name: 'Berlingo',
		province: 'BS',
		altitude: 121
	},
	{
		zip: '75012',
		name: 'Bernalda',
		province: 'MT',
		altitude: 126
	},
	{
		zip: '20881',
		name: 'Bernareggio',
		province: 'MB',
		altitude: 234
	},
	{
		zip: '20010',
		name: 'Bernate Ticino',
		province: 'MI',
		altitude: 130
	},
	{
		zip: '12010',
		name: 'Bernezzo',
		province: 'CN',
		altitude: 600
	},
	{
		zip: '47032',
		name: 'Bertinoro',
		province: 'FC',
		altitude: 254
	},
	{
		zip: '33032',
		name: 'Bertiolo',
		province: 'UD',
		altitude: 33
	},
	{
		zip: '26821',
		name: 'Bertonico',
		province: 'LO',
		altitude: 63
	},
	{
		zip: '14020',
		name: 'Berzano di San Pietro',
		province: 'AT',
		altitude: 424
	},
	{
		zip: '15050',
		name: 'Berzano di Tortona',
		province: 'AL',
		altitude: 270
	},
	{
		zip: '25040',
		name: 'Berzo Demo',
		province: 'BS',
		altitude: 785
	},
	{
		zip: '25040',
		name: 'Berzo Inferiore',
		province: 'BS',
		altitude: 356
	},
	{
		zip: '24060',
		name: 'Berzo San Fermo',
		province: 'BG',
		altitude: 350
	},
	{
		zip: '20842',
		name: 'Besana in Brianza',
		province: 'MB',
		altitude: 335
	},
	{
		zip: '21050',
		name: 'Besano',
		province: 'VA',
		altitude: 350
	},
	{
		zip: '20080',
		name: 'Besate',
		province: 'MI',
		altitude: 104
	},
	{
		zip: '38060',
		name: 'Besenello',
		province: 'TN',
		altitude: 218
	},
	{
		zip: '29010',
		name: 'Besenzone',
		province: 'PC',
		altitude: 48
	},
	{
		zip: '21010',
		name: 'Besnate',
		province: 'VA',
		altitude: 300
	},
	{
		zip: '21023',
		name: 'Besozzo',
		province: 'VA',
		altitude: 240
	},
	{
		zip: '07040',
		name: 'Bessude',
		province: 'SS',
		altitude: 447
	},
	{
		zip: '29021',
		name: 'Bettola',
		province: 'PC',
		altitude: 329
	},
	{
		zip: '06084',
		name: 'Bettona',
		province: 'PG',
		altitude: 353
	},
	{
		zip: '28851',
		name: 'Beura-Cardezza',
		province: 'VB',
		altitude: 257
	},
	{
		zip: '06031',
		name: 'Bevagna',
		province: 'PG',
		altitude: 210
	},
	{
		zip: '19020',
		name: 'Beverino',
		province: 'SP',
		altitude: 73
	},
	{
		zip: '37040',
		name: 'Bevilacqua',
		province: 'VR',
		altitude: 14
	},
	{
		zip: '95033',
		name: 'Biancavilla',
		province: 'CT',
		altitude: 513
	},
	{
		zip: '87050',
		name: 'Bianchi',
		province: 'CS',
		altitude: 825
	},
	{
		zip: '89032',
		name: 'Bianco',
		province: 'RC',
		altitude: 12
	},
	{
		zip: '28061',
		name: 'Biandrate',
		province: 'NO',
		altitude: 160
	},
	{
		zip: '21024',
		name: 'Biandronno',
		province: 'VA',
		altitude: 262
	},
	{
		zip: '24060',
		name: 'Bianzano',
		province: 'BG',
		altitude: 610
	},
	{
		zip: '23030',
		name: 'Bianzone',
		province: 'SO',
		altitude: 444
	},
	{
		zip: '13041',
		name: 'Bianze',
		province: 'VC',
		altitude: 182
	},
	{
		zip: '20853',
		name: 'Biassono',
		province: 'MB',
		altitude: 202
	},
	{
		zip: '42021',
		name: 'Bibbiano',
		province: 'RE',
		altitude: 121
	},
	{
		zip: '52011',
		name: 'Bibbiena',
		province: 'AR',
		altitude: 425
	},
	{
		zip: '57020',
		name: 'Bibbona',
		province: 'LI',
		altitude: 80
	},
	{
		zip: '10060',
		name: 'Bibiana',
		province: 'TO',
		altitude: 420
	},
	{
		zip: '71032',
		name: 'Biccari',
		province: 'FG',
		altitude: 450
	},
	{
		zip: '33050',
		name: 'Bicinicco',
		province: 'UD',
		altitude: 36
	},
	{
		zip: '09080',
		name: 'Bidoni',
		province: 'OR',
		altitude: 250
	},
	{
		zip: '13900',
		name: 'Biella',
		province: 'BI',
		altitude: 420
	},
	{
		zip: '25040',
		name: 'Bienno',
		province: 'BS',
		altitude: 445
	},
	{
		zip: '38050',
		name: 'Bieno',
		province: 'TN',
		altitude: 815
	},
	{
		zip: '56031',
		name: 'Bientina',
		province: 'PI',
		altitude: 10
	},
	{
		zip: '22070',
		name: 'Binago',
		province: 'CO',
		altitude: 431
	},
	{
		zip: '20082',
		name: 'Binasco',
		province: 'MI',
		altitude: 101
	},
	{
		zip: '70020',
		name: 'Binetto',
		province: 'BA',
		altitude: 170
	},
	{
		zip: '13841',
		name: 'Bioglio',
		province: 'BI',
		altitude: 513
	},
	{
		zip: '11010',
		name: 'Bionaz',
		province: 'AO',
		altitude: 1606
	},
	{
		zip: '25070',
		name: 'Bione',
		province: 'BS',
		altitude: 600
	},
	{
		zip: '08010',
		name: 'Birori',
		province: 'NU',
		altitude: 450
	},
	{
		zip: '83044',
		name: 'Bisaccia',
		province: 'AV',
		altitude: 860
	},
	{
		zip: '90032',
		name: 'Bisacquino',
		province: 'PA',
		altitude: 744
	},
	{
		zip: '76011',
		name: 'Bisceglie',
		province: 'BT',
		altitude: 16
	},
	{
		zip: '67050',
		name: 'Bisegna',
		province: 'AQ',
		altitude: 1210
	},
	{
		zip: '64033',
		name: 'Bisenti',
		province: 'TE',
		altitude: 274
	},
	{
		zip: '87043',
		name: 'Bisignano',
		province: 'CS',
		altitude: 350
	},
	{
		zip: '15012',
		name: 'Bistagno',
		province: 'AL',
		altitude: 175
	},
	{
		zip: '21050',
		name: 'Bisuschio',
		province: 'VA',
		altitude: 370
	},
	{
		zip: '70020',
		name: 'Bitetto',
		province: 'BA',
		altitude: 139
	},
	{
		zip: '70032',
		name: 'Bitonto',
		province: 'BA',
		altitude: 118
	},
	{
		zip: '70020',
		name: 'Bitritto',
		province: 'BA',
		altitude: 102
	},
	{
		zip: '08021',
		name: 'Bitti',
		province: 'NU',
		altitude: 549
	},
	{
		zip: '92010',
		name: 'Bivona',
		province: 'AG',
		altitude: 503
	},
	{
		zip: '89040',
		name: 'Bivongi',
		province: 'RC',
		altitude: 270
	},
	{
		zip: '22020',
		name: 'Bizzarone',
		province: 'CO',
		altitude: 436
	},
	{
		zip: '38071',
		name: 'Bleggio Superiore',
		province: 'TN',
		altitude: 628
	},
	{
		zip: '24012',
		name: 'Blello',
		province: 'BG',
		altitude: 815
	},
	{
		zip: '01010',
		name: 'Blera',
		province: 'VT',
		altitude: 207
	},
	{
		zip: '22028',
		name: 'Blessagno',
		province: 'CO',
		altitude: 762
	},
	{
		zip: '22020',
		name: 'Blevio',
		province: 'CO',
		altitude: 231
	},
	{
		zip: '90020',
		name: 'Blufi',
		province: 'PA',
		altitude: 725
	},
	{
		zip: '35040',
		name: 'Boara Pisani',
		province: 'PD',
		altitude: 7
	},
	{
		zip: '29022',
		name: 'Bobbio',
		province: 'PC',
		altitude: 272
	},
	{
		zip: '10060',
		name: 'Bobbio Pellice',
		province: 'TO',
		altitude: 732
	},
	{
		zip: '28010',
		name: 'Boca',
		province: 'NO',
		altitude: 389
	},
	{
		zip: '87060',
		name: 'Bocchigliero',
		province: 'CS',
		altitude: 870
	},
	{
		zip: '13022',
		name: 'Boccioleto',
		province: 'VC',
		altitude: 667
	},
	{
		zip: '38080',
		name: 'Bocenago',
		province: 'TN',
		altitude: 750
	},
	{
		zip: '21020',
		name: 'Bodio Lomnago',
		province: 'VA',
		altitude: 273
	},
	{
		zip: '26811',
		name: 'Boffalora d\'\'Adda',
		province: 'LO',
		altitude: 78
	},
	{
		zip: '20010',
		name: 'Boffalora sopra Ticino',
		province: 'MI',
		altitude: 142
	},
	{
		zip: '16031',
		name: 'Bogliasco',
		province: 'GE',
		altitude: 25
	},
	{
		zip: '28842',
		name: 'Bognanco',
		province: 'VB',
		altitude: 980
	},
	{
		zip: '28010',
		name: 'Bogogno',
		province: 'NO',
		altitude: 278
	},
	{
		zip: '17054',
		name: 'Boissano',
		province: 'SV',
		altitude: 121
	},
	{
		zip: '86021',
		name: 'Bojano',
		province: 'CB',
		altitude: 482
	},
	{
		zip: '19020',
		name: 'Bolano',
		province: 'SP',
		altitude: 317
	},
	{
		zip: '24060',
		name: 'Bolgare',
		province: 'BG',
		altitude: 199
	},
	{
		zip: '20021',
		name: 'Bollate',
		province: 'MI',
		altitude: 156
	},
	{
		zip: '10012',
		name: 'Bollengo',
		province: 'TO',
		altitude: 255
	},
	{
		zip: '40121',
		name: 'Bologna',
		province: 'BO',
		altitude: 54
	},
	{
		zip: '65020',
		name: 'Bolognano',
		province: 'PE',
		altitude: 276
	},
	{
		zip: '90030',
		name: 'Bolognetta',
		province: 'PA',
		altitude: 348
	},
	{
		zip: '62035',
		name: 'Bolognola',
		province: 'MC',
		altitude: 1070
	},
	{
		zip: '08011',
		name: 'Bolotana',
		province: 'NU',
		altitude: 472
	},
	{
		zip: '01023',
		name: 'Bolsena',
		province: 'VT',
		altitude: 350
	},
	{
		zip: '24040',
		name: 'Boltiere',
		province: 'BG',
		altitude: 171
	},
	{
		zip: '39100',
		name: 'Bolzano',
		province: 'BZ',
		altitude: 262
	},
	{
		zip: '28010',
		name: 'Bolzano Novarese',
		province: 'NO',
		altitude: 400
	},
	{
		zip: '36050',
		name: 'Bolzano Vicentino',
		province: 'VI',
		altitude: 44
	},
	{
		zip: '01020',
		name: 'Bomarzo',
		province: 'VT',
		altitude: 263
	},
	{
		zip: '66042',
		name: 'Bomba',
		province: 'CH',
		altitude: 424
	},
	{
		zip: '93010',
		name: 'Bompensiere',
		province: 'CL',
		altitude: 283
	},
	{
		zip: '90020',
		name: 'Bompietro',
		province: 'PA',
		altitude: 685
	},
	{
		zip: '41030',
		name: 'Bomporto',
		province: 'MO',
		altitude: 20
	},
	{
		zip: '09070',
		name: 'Bonarcado',
		province: 'OR',
		altitude: 284
	},
	{
		zip: '19011',
		name: 'Bonassola',
		province: 'SP',
		altitude: 6
	},
	{
		zip: '24040',
		name: 'Bonate Sopra',
		province: 'BG',
		altitude: 230
	},
	{
		zip: '24040',
		name: 'Bonate Sotto',
		province: 'BG',
		altitude: 215
	},
	{
		zip: '37040',
		name: 'Bonavigo',
		province: 'VR',
		altitude: 19
	},
	{
		zip: '44012',
		name: 'Bondeno',
		province: 'FE',
		altitude: 13
	},
	{
		zip: '38080',
		name: 'Bondone',
		province: 'TN',
		altitude: 720
	},
	{
		zip: '82013',
		name: 'Bonea',
		province: 'BN',
		altitude: 350
	},
	{
		zip: '86041',
		name: 'Bonefro',
		province: 'CB',
		altitude: 631
	},
	{
		zip: '26040',
		name: 'Bonemerse',
		province: 'CR',
		altitude: 40
	},
	{
		zip: '87020',
		name: 'Bonifati',
		province: 'CS',
		altitude: 425
	},
	{
		zip: '83032',
		name: 'Bonito',
		province: 'AV',
		altitude: 490
	},
	{
		zip: '07043',
		name: 'Bonnanaro',
		province: 'SS',
		altitude: 405
	},
	{
		zip: '07011',
		name: 'Bono',
		province: 'SS',
		altitude: 540
	},
	{
		zip: '07012',
		name: 'Bonorva',
		province: 'SS',
		altitude: 508
	},
	{
		zip: '12060',
		name: 'Bonvicino',
		province: 'CN',
		altitude: 502
	},
	{
		zip: '02010',
		name: 'Borbona',
		province: 'RI',
		altitude: 760
	},
	{
		zip: '32040',
		name: 'Borca di Cadore',
		province: 'BL',
		altitude: 942
	},
	{
		zip: '33010',
		name: 'Bordano',
		province: 'UD',
		altitude: 224
	},
	{
		zip: '18012',
		name: 'Bordighera',
		province: 'IM',
		altitude: 5
	},
	{
		zip: '26020',
		name: 'Bordolano',
		province: 'CR',
		altitude: 64
	},
	{
		zip: '43030',
		name: 'Bore',
		province: 'PR',
		altitude: 832
	},
	{
		zip: '42022',
		name: 'Boretto',
		province: 'RE',
		altitude: 23
	},
	{
		zip: '27010',
		name: 'Borgarello',
		province: 'PV',
		altitude: 88
	},
	{
		zip: '10071',
		name: 'Borgaro Torinese',
		province: 'TO',
		altitude: 254
	},
	{
		zip: '90042',
		name: 'Borgetto',
		province: 'PA',
		altitude: 290
	},
	{
		zip: '26812',
		name: 'Borghetto Lodigiano',
		province: 'LO',
		altitude: 68
	},
	{
		zip: '17052',
		name: 'Borghetto Santo Spirito',
		province: 'SV',
		altitude: 2
	},
	{
		zip: '18020',
		name: 'Borghetto d\'\'Arroscia',
		province: 'IM',
		altitude: 155
	},
	{
		zip: '15060',
		name: 'Borghetto di Borbera',
		province: 'AL',
		altitude: 295
	},
	{
		zip: '19020',
		name: 'Borghetto di Vara',
		province: 'SP',
		altitude: 104
	},
	{
		zip: '47030',
		name: 'Borghi',
		province: 'FC',
		altitude: 267
	},
	{
		zip: '88021',
		name: 'Borgia',
		province: 'CZ',
		altitude: 341
	},
	{
		zip: '10080',
		name: 'Borgiallo',
		province: 'TO',
		altitude: 540
	},
	{
		zip: '17022',
		name: 'Borgio Verezzi',
		province: 'SV',
		altitude: 10
	},
	{
		zip: '38083',
		name: 'Borgo Chiese',
		province: 'TN',
		altitude: 444
	},
	{
		zip: '38079',
		name: 'Borgo Lares',
		province: 'TN',
		altitude: 595
	},
	{
		zip: '61040',
		name: 'Borgo Pace',
		province: 'PU',
		altitude: 469
	},
	{
		zip: '27040',
		name: 'Borgo Priolo',
		province: 'PV',
		altitude: 144
	},
	{
		zip: '12011',
		name: 'Borgo San Dalmazzo',
		province: 'CN',
		altitude: 636
	},
	{
		zip: '25022',
		name: 'Borgo San Giacomo',
		province: 'BS',
		altitude: 74
	},
	{
		zip: '26851',
		name: 'Borgo San Giovanni',
		province: 'LO',
		altitude: 77
	},
	{
		zip: '50032',
		name: 'Borgo San Lorenzo',
		province: 'FI',
		altitude: 193
	},
	{
		zip: '15032',
		name: 'Borgo San Martino',
		province: 'AL',
		altitude: 107
	},
	{
		zip: '27020',
		name: 'Borgo San Siro',
		province: 'PV',
		altitude: 98
	},
	{
		zip: '28040',
		name: 'Borgo Ticino',
		province: 'NO',
		altitude: 299
	},
	{
		zip: '40021',
		name: 'Borgo Tossignano',
		province: 'BO',
		altitude: 102
	},
	{
		zip: '43043',
		name: 'Borgo Val di Taro',
		province: 'PR',
		altitude: 411
	},
	{
		zip: '32026',
		name: 'Borgo Valbelluna',
		province: 'BL',
		altitude: 362
	},
	{
		zip: '38051',
		name: 'Borgo Valsugana',
		province: 'TN',
		altitude: 386
	},
	{
		zip: '02010',
		name: 'Borgo Velino',
		province: 'RI',
		altitude: 460
	},
	{
		zip: '35046',
		name: 'Borgo Veneto',
		province: 'PD',
		altitude: 12
	},
	{
		zip: '13012',
		name: 'Borgo Vercelli',
		province: 'VC',
		altitude: 126
	},
	{
		zip: '46034',
		name: 'Borgo Virgilio',
		province: 'MN',
		altitude: 21
	},
	{
		zip: '55023',
		name: 'Borgo a Mozzano',
		province: 'LU',
		altitude: 97
	},
	{
		zip: '13040',
		name: 'Borgo d\'\'Ale',
		province: 'VC',
		altitude: 242
	},
	{
		zip: '38013',
		name: 'Borgo d\'\'Anaunia',
		province: 'TN',
		altitude: 982
	},
	{
		zip: '24060',
		name: 'Borgo di Terzo',
		province: 'BG',
		altitude: 300
	},
	{
		zip: '10013',
		name: 'Borgofranco d\'\'Ivrea',
		province: 'TO',
		altitude: 253
	},
	{
		zip: '28071',
		name: 'Borgolavezzaro',
		province: 'NO',
		altitude: 118
	},
	{
		zip: '12050',
		name: 'Borgomale',
		province: 'CN',
		altitude: 471
	},
	{
		zip: '28021',
		name: 'Borgomanero',
		province: 'NO',
		altitude: 308
	},
	{
		zip: '18021',
		name: 'Borgomaro',
		province: 'IM',
		altitude: 249
	},
	{
		zip: '10031',
		name: 'Borgomasino',
		province: 'TO',
		altitude: 260
	},
	{
		zip: '28846',
		name: 'Borgomezzavalle',
		province: 'VB',
		altitude: 582
	},
	{
		zip: '10050',
		name: 'Borgone Susa',
		province: 'TO',
		altitude: 394
	},
	{
		zip: '29011',
		name: 'Borgonovo Val Tidone',
		province: 'PC',
		altitude: 114
	},
	{
		zip: '15013',
		name: 'Borgoratto Alessandrino',
		province: 'AL',
		altitude: 105
	},
	{
		zip: '27040',
		name: 'Borgoratto Mormorolo',
		province: 'PV',
		altitude: 326
	},
	{
		zip: '35010',
		name: 'Borgoricco',
		province: 'PD',
		altitude: 18
	},
	{
		zip: '02021',
		name: 'Borgorose',
		province: 'RI',
		altitude: 732
	},
	{
		zip: '25010',
		name: 'Borgosatollo',
		province: 'BS',
		altitude: 112
	},
	{
		zip: '13011',
		name: 'Borgosesia',
		province: 'VC',
		altitude: 354
	},
	{
		zip: '17040',
		name: 'Bormida',
		province: 'SV',
		altitude: 585
	},
	{
		zip: '23032',
		name: 'Bormio',
		province: 'SO',
		altitude: 1225
	},
	{
		zip: '27010',
		name: 'Bornasco',
		province: 'PV',
		altitude: 85
	},
	{
		zip: '25042',
		name: 'Borno',
		province: 'BS',
		altitude: 912
	},
	{
		zip: '09080',
		name: 'Boroneddu',
		province: 'OR',
		altitude: 216
	},
	{
		zip: '08016',
		name: 'Borore',
		province: 'NU',
		altitude: 394
	},
	{
		zip: '66040',
		name: 'Borrello',
		province: 'CH',
		altitude: 804
	},
	{
		zip: '13872',
		name: 'Borriana',
		province: 'BI',
		altitude: 350
	},
	{
		zip: '31030',
		name: 'Borso del Grappa',
		province: 'TV',
		altitude: 279
	},
	{
		zip: '08012',
		name: 'Bortigali',
		province: 'NU',
		altitude: 510
	},
	{
		zip: '07030',
		name: 'Bortigiadas',
		province: 'SS',
		altitude: 476
	},
	{
		zip: '07040',
		name: 'Borutta',
		province: 'SS',
		altitude: 491
	},
	{
		zip: '16041',
		name: 'Borzonasca',
		province: 'GE',
		altitude: 167
	},
	{
		zip: '09089',
		name: 'Bosa',
		province: 'OR',
		altitude: 2
	},
	{
		zip: '45033',
		name: 'Bosaro',
		province: 'RO',
		altitude: 3
	},
	{
		zip: '37040',
		name: 'Boschi Sant\'\'Anna',
		province: 'VR',
		altitude: 12
	},
	{
		zip: '37021',
		name: 'Bosco Chiesanuova',
		province: 'VR',
		altitude: 1106
	},
	{
		zip: '15062',
		name: 'Bosco Marengo',
		province: 'AL',
		altitude: 121
	},
	{
		zip: '10080',
		name: 'Bosconero',
		province: 'TO',
		altitude: 310
	},
	{
		zip: '80041',
		name: 'Boscoreale',
		province: 'NA',
		altitude: 65
	},
	{
		zip: '80042',
		name: 'Boscotrecase',
		province: 'NA',
		altitude: 86
	},
	{
		zip: '12050',
		name: 'Bosia',
		province: 'CN',
		altitude: 484
	},
	{
		zip: '15060',
		name: 'Bosio',
		province: 'AL',
		altitude: 358
	},
	{
		zip: '23842',
		name: 'Bosisio Parini',
		province: 'LC',
		altitude: 270
	},
	{
		zip: '27049',
		name: 'Bosnasco',
		province: 'PV',
		altitude: 124
	},
	{
		zip: '24060',
		name: 'Bossico',
		province: 'BG',
		altitude: 860
	},
	{
		zip: '12060',
		name: 'Bossolasco',
		province: 'CN',
		altitude: 800
	},
	{
		zip: '88070',
		name: 'Botricello',
		province: 'CZ',
		altitude: 19
	},
	{
		zip: '73020',
		name: 'Botrugno',
		province: 'LE',
		altitude: 92
	},
	{
		zip: '24040',
		name: 'Bottanuco',
		province: 'BG',
		altitude: 222
	},
	{
		zip: '25080',
		name: 'Botticino',
		province: 'BS',
		altitude: 153
	},
	{
		zip: '07010',
		name: 'Bottidda',
		province: 'SS',
		altitude: 396
	},
	{
		zip: '89033',
		name: 'Bova',
		province: 'RC',
		altitude: 820
	},
	{
		zip: '89035',
		name: 'Bova Marina',
		province: 'RC',
		altitude: 20
	},
	{
		zip: '89034',
		name: 'Bovalino',
		province: 'RC',
		altitude: 11
	},
	{
		zip: '25061',
		name: 'Bovegno',
		province: 'BS',
		altitude: 680
	},
	{
		zip: '12012',
		name: 'Boves',
		province: 'CN',
		altitude: 590
	},
	{
		zip: '25073',
		name: 'Bovezzo',
		province: 'BS',
		altitude: 207
	},
	{
		zip: '03022',
		name: 'Boville Ernica',
		province: 'FR',
		altitude: 450
	},
	{
		zip: '71023',
		name: 'Bovino',
		province: 'FG',
		altitude: 620
	},
	{
		zip: '20813',
		name: 'Bovisio-Masciago',
		province: 'MB',
		altitude: 188
	},
	{
		zip: '35024',
		name: 'Bovolenta',
		province: 'PD',
		altitude: 6
	},
	{
		zip: '37051',
		name: 'Bovolone',
		province: 'VR',
		altitude: 24
	},
	{
		zip: '15040',
		name: 'Bozzole',
		province: 'AL',
		altitude: 91
	},
	{
		zip: '46012',
		name: 'Bozzolo',
		province: 'MN',
		altitude: 30
	},
	{
		zip: '12042',
		name: 'Bra',
		province: 'CN',
		altitude: 290
	},
	{
		zip: '24010',
		name: 'Bracca',
		province: 'BG',
		altitude: 720
	},
	{
		zip: '00062',
		name: 'Bracciano',
		province: 'RM',
		altitude: 280
	},
	{
		zip: '84082',
		name: 'Bracigliano',
		province: 'SA',
		altitude: 327
	},
	{
		zip: '39030',
		name: 'Braies',
		province: 'BZ',
		altitude: 1213
	},
	{
		zip: '27050',
		name: 'Brallo di Pregola',
		province: 'PV',
		altitude: 952
	},
	{
		zip: '89036',
		name: 'Brancaleone',
		province: 'RC',
		altitude: 12
	},
	{
		zip: '25030',
		name: 'Brandico',
		province: 'BS',
		altitude: 99
	},
	{
		zip: '10032',
		name: 'Brandizzo',
		province: 'TO',
		altitude: 187
	},
	{
		zip: '24010',
		name: 'Branzi',
		province: 'BG',
		altitude: 874
	},
	{
		zip: '25040',
		name: 'Braone',
		province: 'BS',
		altitude: 394
	},
	{
		zip: '21020',
		name: 'Brebbia',
		province: 'VA',
		altitude: 225
	},
	{
		zip: '31030',
		name: 'Breda di Piave',
		province: 'TV',
		altitude: 23
	},
	{
		zip: '21020',
		name: 'Bregano',
		province: 'VA',
		altitude: 303
	},
	{
		zip: '36042',
		name: 'Breganze',
		province: 'VI',
		altitude: 110
	},
	{
		zip: '22070',
		name: 'Bregnano',
		province: 'CO',
		altitude: 290
	},
	{
		zip: '24041',
		name: 'Brembate',
		province: 'BG',
		altitude: 173
	},
	{
		zip: '24030',
		name: 'Brembate di Sopra',
		province: 'BG',
		altitude: 267
	},
	{
		zip: '26822',
		name: 'Brembio',
		province: 'LO',
		altitude: 67
	},
	{
		zip: '27020',
		name: 'Breme',
		province: 'PV',
		altitude: 101
	},
	{
		zip: '36040',
		name: 'Brendola',
		province: 'VI',
		altitude: 156
	},
	{
		zip: '22040',
		name: 'Brenna',
		province: 'CO',
		altitude: 356
	},
	{
		zip: '39041',
		name: 'Brennero',
		province: 'BZ',
		altitude: 1374
	},
	{
		zip: '25043',
		name: 'Breno',
		province: 'BS',
		altitude: 343
	},
	{
		zip: '37020',
		name: 'Brentino Belluno',
		province: 'VR',
		altitude: 137
	},
	{
		zip: '38060',
		name: 'Brentonico',
		province: 'TN',
		altitude: 698
	},
	{
		zip: '37010',
		name: 'Brenzone sul Garda',
		province: 'VR',
		altitude: 69
	},
	{
		zip: '42041',
		name: 'Brescello',
		province: 'RE',
		altitude: 24
	},
	{
		zip: '25121',
		name: 'Brescia',
		province: 'BS',
		altitude: 149
	},
	{
		zip: '38020',
		name: 'Bresimo',
		province: 'TN',
		altitude: 1036
	},
	{
		zip: '27042',
		name: 'Bressana Bottarone',
		province: 'PV',
		altitude: 69
	},
	{
		zip: '39042',
		name: 'Bressanone',
		province: 'BZ',
		altitude: 559
	},
	{
		zip: '36050',
		name: 'Bressanvido',
		province: 'VI',
		altitude: 57
	},
	{
		zip: '20091',
		name: 'Bresso',
		province: 'MI',
		altitude: 142
	},
	{
		zip: '21010',
		name: 'Brezzo di Bedero',
		province: 'VA',
		altitude: 352
	},
	{
		zip: '12080',
		name: 'Briaglia',
		province: 'CN',
		altitude: 546
	},
	{
		zip: '89817',
		name: 'Briatico',
		province: 'VV',
		altitude: 51
	},
	{
		zip: '10060',
		name: 'Bricherasio',
		province: 'TO',
		altitude: 400
	},
	{
		zip: '22010',
		name: 'Brienno',
		province: 'CO',
		altitude: 203
	},
	{
		zip: '85050',
		name: 'Brienza',
		province: 'PZ',
		altitude: 713
	},
	{
		zip: '18025',
		name: 'Briga Alta',
		province: 'CN',
		altitude: 1310
	},
	{
		zip: '28010',
		name: 'Briga Novarese',
		province: 'NO',
		altitude: 345
	},
	{
		zip: '24053',
		name: 'Brignano Gera d\'\'Adda',
		province: 'BG',
		altitude: 128
	},
	{
		zip: '15050',
		name: 'Brignano-Frascata',
		province: 'AL',
		altitude: 288
	},
	{
		zip: '72100',
		name: 'Brindisi',
		province: 'BR',
		altitude: 13
	},
	{
		zip: '85010',
		name: 'Brindisi Montagna',
		province: 'PZ',
		altitude: 800
	},
	{
		zip: '21030',
		name: 'Brinzio',
		province: 'VA',
		altitude: 510
	},
	{
		zip: '28072',
		name: 'Briona',
		province: 'NO',
		altitude: 205
	},
	{
		zip: '25060',
		name: 'Brione',
		province: 'BS',
		altitude: 614
	},
	{
		zip: '20836',
		name: 'Briosco',
		province: 'MB',
		altitude: 271
	},
	{
		zip: '48013',
		name: 'Brisighella',
		province: 'RA',
		altitude: 115
	},
	{
		zip: '21030',
		name: 'Brissago-Valtravaglia',
		province: 'VA',
		altitude: 429
	},
	{
		zip: '11020',
		name: 'Brissogne',
		province: 'AO',
		altitude: 839
	},
	{
		zip: '65010',
		name: 'Brittoli',
		province: 'PE',
		altitude: 779
	},
	{
		zip: '23883',
		name: 'Brivio',
		province: 'LC',
		altitude: 208
	},
	{
		zip: '03030',
		name: 'Broccostella',
		province: 'FR',
		altitude: 307
	},
	{
		zip: '36070',
		name: 'Brogliano',
		province: 'VI',
		altitude: 172
	},
	{
		zip: '89822',
		name: 'Brognaturo',
		province: 'VV',
		altitude: 755
	},
	{
		zip: '98061',
		name: 'Brolo',
		province: 'ME',
		altitude: 8
	},
	{
		zip: '12030',
		name: 'Brondello',
		province: 'CN',
		altitude: 467
	},
	{
		zip: '27043',
		name: 'Broni',
		province: 'PV',
		altitude: 88
	},
	{
		zip: '95034',
		name: 'Bronte',
		province: 'CT',
		altitude: 760
	},
	{
		zip: '39051',
		name: 'Bronzolo',
		province: 'BZ',
		altitude: 238
	},
	{
		zip: '12020',
		name: 'Brossasco',
		province: 'CN',
		altitude: 606
	},
	{
		zip: '10080',
		name: 'Brosso',
		province: 'TO',
		altitude: 797
	},
	{
		zip: '28833',
		name: 'Brovello-Carpugnino',
		province: 'VB',
		altitude: 445
	},
	{
		zip: '10020',
		name: 'Brozolo',
		province: 'TO',
		altitude: 360
	},
	{
		zip: '20861',
		name: 'Brugherio',
		province: 'MB',
		altitude: 145
	},
	{
		zip: '35020',
		name: 'Brugine',
		province: 'PD',
		altitude: 7
	},
	{
		zip: '19020',
		name: 'Brugnato',
		province: 'SP',
		altitude: 115
	},
	{
		zip: '33070',
		name: 'Brugnera',
		province: 'PN',
		altitude: 16
	},
	{
		zip: '10090',
		name: 'Bruino',
		province: 'TO',
		altitude: 320
	},
	{
		zip: '24037',
		name: 'Brumano',
		province: 'BG',
		altitude: 911
	},
	{
		zip: '22034',
		name: 'Brunate',
		province: 'CO',
		altitude: 715
	},
	{
		zip: '21020',
		name: 'Brunello',
		province: 'VA',
		altitude: 411
	},
	{
		zip: '39031',
		name: 'Brunico',
		province: 'BZ',
		altitude: 838
	},
	{
		zip: '14046',
		name: 'Bruno',
		province: 'AT',
		altitude: 198
	},
	{
		zip: '24060',
		name: 'Brusaporto',
		province: 'BG',
		altitude: 255
	},
	{
		zip: '10020',
		name: 'Brusasco',
		province: 'TO',
		altitude: 170
	},
	{
		zip: '80031',
		name: 'Brusciano',
		province: 'NA',
		altitude: 27
	},
	{
		zip: '21050',
		name: 'Brusimpiano',
		province: 'VA',
		altitude: 289
	},
	{
		zip: '13862',
		name: 'Brusnengo',
		province: 'BI',
		altitude: 200
	},
	{
		zip: '11022',
		name: 'Brusson',
		province: 'AO',
		altitude: 1338
	},
	{
		zip: '10050',
		name: 'Bruzolo',
		province: 'TO',
		altitude: 455
	},
	{
		zip: '89030',
		name: 'Bruzzano Zeffirio',
		province: 'RC',
		altitude: 82
	},
	{
		zip: '20080',
		name: 'Bubbiano',
		province: 'MI',
		altitude: 106
	},
	{
		zip: '14051',
		name: 'Bubbio',
		province: 'AT',
		altitude: 224
	},
	{
		zip: '96010',
		name: 'Buccheri',
		province: 'SR',
		altitude: 820
	},
	{
		zip: '66011',
		name: 'Bucchianico',
		province: 'CH',
		altitude: 330
	},
	{
		zip: '82010',
		name: 'Bucciano',
		province: 'BN',
		altitude: 276
	},
	{
		zip: '20090',
		name: 'Buccinasco',
		province: 'MI',
		altitude: 113
	},
	{
		zip: '84021',
		name: 'Buccino',
		province: 'SA',
		altitude: 663
	},
	{
		zip: '52021',
		name: 'Bucine',
		province: 'AR',
		altitude: 250
	},
	{
		zip: '07020',
		name: 'Budduso',
		province: 'SS',
		altitude: 700
	},
	{
		zip: '33070',
		name: 'Budoia',
		province: 'PN',
		altitude: 135
	},
	{
		zip: '07051',
		name: 'Budoni',
		province: 'SS',
		altitude: 16
	},
	{
		zip: '40054',
		name: 'Budrio',
		province: 'BO',
		altitude: 25
	},
	{
		zip: '09010',
		name: 'Buggerru',
		province: 'SU',
		altitude: 51
	},
	{
		zip: '51011',
		name: 'Buggiano',
		province: 'PT',
		altitude: 41
	},
	{
		zip: '23010',
		name: 'Buglio in Monte',
		province: 'SO',
		altitude: 577
	},
	{
		zip: '67030',
		name: 'Bugnara',
		province: 'AQ',
		altitude: 580
	},
	{
		zip: '21020',
		name: 'Buguggiate',
		province: 'VA',
		altitude: 306
	},
	{
		zip: '33030',
		name: 'Buja',
		province: 'UD',
		altitude: 215
	},
	{
		zip: '23892',
		name: 'Bulciago',
		province: 'LC',
		altitude: 305
	},
	{
		zip: '22070',
		name: 'Bulgarograsso',
		province: 'CO',
		altitude: 317
	},
	{
		zip: '07010',
		name: 'Bultei',
		province: 'SS',
		altitude: 509
	},
	{
		zip: '07030',
		name: 'Bulzi',
		province: 'SS',
		altitude: 250
	},
	{
		zip: '84032',
		name: 'Buonabitacolo',
		province: 'SA',
		altitude: 501
	},
	{
		zip: '82020',
		name: 'Buonalbergo',
		province: 'BN',
		altitude: 555
	},
	{
		zip: '53022',
		name: 'Buonconvento',
		province: 'SI',
		altitude: 147
	},
	{
		zip: '87020',
		name: 'Buonvicino',
		province: 'CS',
		altitude: 400
	},
	{
		zip: '20875',
		name: 'Burago di Molgora',
		province: 'MB',
		altitude: 182
	},
	{
		zip: '09040',
		name: 'Burcei',
		province: 'CA',
		altitude: 648
	},
	{
		zip: '92010',
		name: 'Burgio',
		province: 'AG',
		altitude: 317
	},
	{
		zip: '07010',
		name: 'Burgos',
		province: 'SS',
		altitude: 575
	},
	{
		zip: '10060',
		name: 'Buriasco',
		province: 'TO',
		altitude: 301
	},
	{
		zip: '10010',
		name: 'Burolo',
		province: 'TO',
		altitude: 276
	},
	{
		zip: '13040',
		name: 'Buronzo',
		province: 'VC',
		altitude: 189
	},
	{
		zip: '09082',
		name: 'Busachi',
		province: 'OR',
		altitude: 379
	},
	{
		zip: '16012',
		name: 'Busalla',
		province: 'GE',
		altitude: 358
	},
	{
		zip: '10080',
		name: 'Busano',
		province: 'TO',
		altitude: 317
	},
	{
		zip: '12022',
		name: 'Busca',
		province: 'CN',
		altitude: 500
	},
	{
		zip: '20010',
		name: 'Buscate',
		province: 'MI',
		altitude: 176
	},
	{
		zip: '96010',
		name: 'Buscemi',
		province: 'SR',
		altitude: 761
	},
	{
		zip: '91012',
		name: 'Buseto Palizzolo',
		province: 'TP',
		altitude: 249
	},
	{
		zip: '20874',
		name: 'Busnago',
		province: 'MB',
		altitude: 210
	},
	{
		zip: '20041',
		name: 'Bussero',
		province: 'MI',
		altitude: 141
	},
	{
		zip: '43011',
		name: 'Busseto',
		province: 'PR',
		altitude: 40
	},
	{
		zip: '65022',
		name: 'Bussi sul Tirino',
		province: 'PE',
		altitude: 344
	},
	{
		zip: '86010',
		name: 'Busso',
		province: 'CB',
		altitude: 756
	},
	{
		zip: '37012',
		name: 'Bussolengo',
		province: 'VR',
		altitude: 127
	},
	{
		zip: '10053',
		name: 'Bussoleno',
		province: 'TO',
		altitude: 440
	},
	{
		zip: '21052',
		name: 'Busto Arsizio',
		province: 'VA',
		altitude: 226
	},
	{
		zip: '20020',
		name: 'Busto Garolfo',
		province: 'MI',
		altitude: 180
	},
	{
		zip: '93011',
		name: 'Butera',
		province: 'CL',
		altitude: 402
	},
	{
		zip: '56032',
		name: 'Buti',
		province: 'PI',
		altitude: 85
	},
	{
		zip: '37060',
		name: 'Buttapietra',
		province: 'VR',
		altitude: 38
	},
	{
		zip: '10090',
		name: 'Buttigliera Alta',
		province: 'TO',
		altitude: 414
	},
	{
		zip: '14021',
		name: 'Buttigliera d\'\'Asti',
		province: 'AT',
		altitude: 299
	},
	{
		zip: '33042',
		name: 'Buttrio',
		province: 'UD',
		altitude: 79
	},
	{
		zip: '15060',
		name: 'Cabella Ligure',
		province: 'AL',
		altitude: 474
	},
	{
		zip: '22060',
		name: 'Cabiate',
		province: 'CO',
		altitude: 237
	},
	{
		zip: '09072',
		name: 'Cabras',
		province: 'OR',
		altitude: 6
	},
	{
		zip: '90012',
		name: 'Caccamo',
		province: 'PA',
		altitude: 521
	},
	{
		zip: '88833',
		name: 'Caccuri',
		province: 'KR',
		altitude: 646
	},
	{
		zip: '21031',
		name: 'Cadegliano-Viconago',
		province: 'VA',
		altitude: 414
	},
	{
		zip: '42023',
		name: 'Cadelbosco di Sopra',
		province: 'RE',
		altitude: 33
	},
	{
		zip: '29010',
		name: 'Cadeo',
		province: 'PC',
		altitude: 65
	},
	{
		zip: '38080',
		name: 'Caderzone Terme',
		province: 'TN',
		altitude: 723
	},
	{
		zip: '35010',
		name: 'Cadoneghe',
		province: 'PD',
		altitude: 15
	},
	{
		zip: '22071',
		name: 'Cadorago',
		province: 'CO',
		altitude: 313
	},
	{
		zip: '21062',
		name: 'Cadrezzate con Osmate',
		province: 'VA',
		altitude: 281
	},
	{
		zip: '31031',
		name: 'Caerano di San Marco',
		province: 'TV',
		altitude: 124
	},
	{
		zip: '10070',
		name: 'Cafasse',
		province: 'TO',
		altitude: 409
	},
	{
		zip: '84030',
		name: 'Caggiano',
		province: 'SA',
		altitude: 828
	},
	{
		zip: '61043',
		name: 'Cagli',
		province: 'PU',
		altitude: 276
	},
	{
		zip: '09121',
		name: 'Cagliari',
		province: 'CA',
		altitude: 6
	},
	{
		zip: '22030',
		name: 'Caglio',
		province: 'CO',
		altitude: 800
	},
	{
		zip: '67012',
		name: 'Cagnano Amiterno',
		province: 'AQ',
		altitude: 841
	},
	{
		zip: '71010',
		name: 'Cagnano Varano',
		province: 'FG',
		altitude: 165
	},
	{
		zip: '81059',
		name: 'Caianello',
		province: 'CE',
		altitude: 236
	},
	{
		zip: '81013',
		name: 'Caiazzo',
		province: 'CE',
		altitude: 200
	},
	{
		zip: '39010',
		name: 'Caines',
		province: 'BZ',
		altitude: 592
	},
	{
		zip: '25070',
		name: 'Caino',
		province: 'BS',
		altitude: 385
	},
	{
		zip: '23010',
		name: 'Caiolo',
		province: 'SO',
		altitude: 335
	},
	{
		zip: '83040',
		name: 'Cairano',
		province: 'AV',
		altitude: 770
	},
	{
		zip: '21050',
		name: 'Cairate',
		province: 'VA',
		altitude: 276
	},
	{
		zip: '17014',
		name: 'Cairo Montenotte',
		province: 'SV',
		altitude: 330
	},
	{
		zip: '80023',
		name: 'Caivano',
		province: 'NA',
		altitude: 27
	},
	{
		zip: '83040',
		name: 'Calabritto',
		province: 'AV',
		altitude: 480
	},
	{
		zip: '32042',
		name: 'Calalzo di Cadore',
		province: 'BL',
		altitude: 806
	},
	{
		zip: '14042',
		name: 'Calamandrana',
		province: 'AT',
		altitude: 151
	},
	{
		zip: '92010',
		name: 'Calamonaci',
		province: 'AG',
		altitude: 307
	},
	{
		zip: '07023',
		name: 'Calangianus',
		province: 'SS',
		altitude: 518
	},
	{
		zip: '89050',
		name: 'Calanna',
		province: 'RC',
		altitude: 511
	},
	{
		zip: '28873',
		name: 'Calasca-Castiglione',
		province: 'VB',
		altitude: 665
	},
	{
		zip: '94010',
		name: 'Calascibetta',
		province: 'EN',
		altitude: 691
	},
	{
		zip: '67020',
		name: 'Calascio',
		province: 'AQ',
		altitude: 1210
	},
	{
		zip: '09011',
		name: 'Calasetta',
		province: 'SU',
		altitude: 9
	},
	{
		zip: '95011',
		name: 'Calatabiano',
		province: 'CT',
		altitude: 60
	},
	{
		zip: '91013',
		name: 'Calatafimi-Segesta',
		province: 'TP',
		altitude: 338
	},
	{
		zip: '01030',
		name: 'Calcata',
		province: 'VT',
		altitude: 220
	},
	{
		zip: '38050',
		name: 'Calceranica al Lago',
		province: 'TN',
		altitude: 465
	},
	{
		zip: '56011',
		name: 'Calci',
		province: 'PI',
		altitude: 50
	},
	{
		zip: '75010',
		name: 'Calciano',
		province: 'MT',
		altitude: 425
	},
	{
		zip: '56012',
		name: 'Calcinaia',
		province: 'PI',
		altitude: 16
	},
	{
		zip: '24050',
		name: 'Calcinate',
		province: 'BG',
		altitude: 186
	},
	{
		zip: '25011',
		name: 'Calcinato',
		province: 'BS',
		altitude: 171
	},
	{
		zip: '24054',
		name: 'Calcio',
		province: 'BG',
		altitude: 123
	},
	{
		zip: '23885',
		name: 'Calco',
		province: 'LC',
		altitude: 320
	},
	{
		zip: '39052',
		name: 'Caldaro sulla Strada del Vino',
		province: 'BZ',
		altitude: 425
	},
	{
		zip: '62020',
		name: 'Caldarola',
		province: 'MC',
		altitude: 314
	},
	{
		zip: '40012',
		name: 'Calderara di Reno',
		province: 'BO',
		altitude: 30
	},
	{
		zip: '38022',
		name: 'Caldes',
		province: 'TN',
		altitude: 697
	},
	{
		zip: '37042',
		name: 'Caldiero',
		province: 'VR',
		altitude: 44
	},
	{
		zip: '36030',
		name: 'Caldogno',
		province: 'VI',
		altitude: 52
	},
	{
		zip: '38052',
		name: 'Caldonazzo',
		province: 'TN',
		altitude: 480
	},
	{
		zip: '29010',
		name: 'Calendasco',
		province: 'PC',
		altitude: 55
	},
	{
		zip: '50041',
		name: 'Calenzano',
		province: 'FI',
		altitude: 68
	},
	{
		zip: '43030',
		name: 'Calestano',
		province: 'PR',
		altitude: 417
	},
	{
		zip: '17020',
		name: 'Calice Ligure',
		province: 'SV',
		altitude: 70
	},
	{
		zip: '19020',
		name: 'Calice al Cornoviglio',
		province: 'SP',
		altitude: 405
	},
	{
		zip: '73021',
		name: 'Calimera',
		province: 'LE',
		altitude: 56
	},
	{
		zip: '83045',
		name: 'Calitri',
		province: 'AV',
		altitude: 530
	},
	{
		zip: '17057',
		name: 'Calizzano',
		province: 'SV',
		altitude: 647
	},
	{
		zip: '13821',
		name: 'Callabiana',
		province: 'BI',
		altitude: 731
	},
	{
		zip: '23801',
		name: 'Calolziocorte',
		province: 'LC',
		altitude: 241
	},
	{
		zip: '87060',
		name: 'Calopezzati',
		province: 'CS',
		altitude: 217
	},
	{
		zip: '14052',
		name: 'Calosso',
		province: 'AT',
		altitude: 399
	},
	{
		zip: '87060',
		name: 'Caloveto',
		province: 'CS',
		altitude: 385
	},
	{
		zip: '92010',
		name: 'Caltabellotta',
		province: 'AG',
		altitude: 949
	},
	{
		zip: '95041',
		name: 'Caltagirone',
		province: 'CT',
		altitude: 608
	},
	{
		zip: '93100',
		name: 'Caltanissetta',
		province: 'CL',
		altitude: 568
	},
	{
		zip: '90022',
		name: 'Caltavuturo',
		province: 'PA',
		altitude: 635
	},
	{
		zip: '28010',
		name: 'Caltignaga',
		province: 'NO',
		altitude: 179
	},
	{
		zip: '45030',
		name: 'Calto',
		province: 'RO',
		altitude: 11
	},
	{
		zip: '36030',
		name: 'Caltrano',
		province: 'VI',
		altitude: 260
	},
	{
		zip: '24033',
		name: 'Calusco d\'\'Adda',
		province: 'BG',
		altitude: 273
	},
	{
		zip: '10014',
		name: 'Caluso',
		province: 'TO',
		altitude: 325
	},
	{
		zip: '25080',
		name: 'Calvagese della Riviera',
		province: 'BS',
		altitude: 225
	},
	{
		zip: '84080',
		name: 'Calvanico',
		province: 'SA',
		altitude: 600
	},
	{
		zip: '26030',
		name: 'Calvatone',
		province: 'CR',
		altitude: 29
	},
	{
		zip: '85010',
		name: 'Calvello',
		province: 'PZ',
		altitude: 730
	},
	{
		zip: '36030',
		name: 'Calvene',
		province: 'VI',
		altitude: 210
	},
	{
		zip: '24040',
		name: 'Calvenzano',
		province: 'BG',
		altitude: 113
	},
	{
		zip: '85030',
		name: 'Calvera',
		province: 'PZ',
		altitude: 630
	},
	{
		zip: '82018',
		name: 'Calvi',
		province: 'BN',
		altitude: 376
	},
	{
		zip: '81042',
		name: 'Calvi Risorta',
		province: 'CE',
		altitude: 80
	},
	{
		zip: '05032',
		name: 'Calvi dell\'\'Umbria',
		province: 'TR',
		altitude: 401
	},
	{
		zip: '27045',
		name: 'Calvignano',
		province: 'PV',
		altitude: 275
	},
	{
		zip: '20080',
		name: 'Calvignasco',
		province: 'MI',
		altitude: 105
	},
	{
		zip: '25012',
		name: 'Calvisano',
		province: 'BS',
		altitude: 67
	},
	{
		zip: '80012',
		name: 'Calvizzano',
		province: 'NA',
		altitude: 135
	},
	{
		zip: '15030',
		name: 'Camagna Monferrato',
		province: 'AL',
		altitude: 261
	},
	{
		zip: '55041',
		name: 'Camaiore',
		province: 'LU',
		altitude: 34
	},
	{
		zip: '13821',
		name: 'Camandona',
		province: 'BI',
		altitude: 792
	},
	{
		zip: '92020',
		name: 'Camastra',
		province: 'AG',
		altitude: 450
	},
	{
		zip: '20040',
		name: 'Cambiago',
		province: 'MI',
		altitude: 158
	},
	{
		zip: '10020',
		name: 'Cambiano',
		province: 'TO',
		altitude: 253
	},
	{
		zip: '28814',
		name: 'Cambiasca',
		province: 'VB',
		altitude: 290
	},
	{
		zip: '13891',
		name: 'Camburzano',
		province: 'BI',
		altitude: 420
	},
	{
		zip: '12072',
		name: 'Camerana',
		province: 'CN',
		altitude: 525
	},
	{
		zip: '60021',
		name: 'Camerano',
		province: 'AN',
		altitude: 231
	},
	{
		zip: '14020',
		name: 'Camerano Casasco',
		province: 'AT',
		altitude: 300
	},
	{
		zip: '24010',
		name: 'Camerata Cornello',
		province: 'BG',
		altitude: 570
	},
	{
		zip: '00020',
		name: 'Camerata Nuova',
		province: 'RM',
		altitude: 810
	},
	{
		zip: '60020',
		name: 'Camerata Picena',
		province: 'AN',
		altitude: 125
	},
	{
		zip: '28062',
		name: 'Cameri',
		province: 'NO',
		altitude: 161
	},
	{
		zip: '62032',
		name: 'Camerino',
		province: 'MC',
		altitude: 661
	},
	{
		zip: '84059',
		name: 'Camerota',
		province: 'SA',
		altitude: 322
	},
	{
		zip: '81050',
		name: 'Camigliano',
		province: 'CE',
		altitude: 80
	},
	{
		zip: '89040',
		name: 'Camini',
		province: 'RC',
		altitude: 300
	},
	{
		zip: '15020',
		name: 'Camino',
		province: 'AL',
		altitude: 252
	},
	{
		zip: '33030',
		name: 'Camino al Tagliamento',
		province: 'UD',
		altitude: 34
	},
	{
		zip: '26010',
		name: 'Camisano',
		province: 'CR',
		altitude: 92
	},
	{
		zip: '36043',
		name: 'Camisano Vicentino',
		province: 'VI',
		altitude: 27
	},
	{
		zip: '92022',
		name: 'Cammarata',
		province: 'AG',
		altitude: 682
	},
	{
		zip: '16032',
		name: 'Camogli',
		province: 'GE',
		altitude: 32
	},
	{
		zip: '84022',
		name: 'Campagna',
		province: 'SA',
		altitude: 281
	},
	{
		zip: '30010',
		name: 'Campagna Lupia',
		province: 'VE',
		altitude: 3
	},
	{
		zip: '00063',
		name: 'Campagnano di Roma',
		province: 'RM',
		altitude: 270
	},
	{
		zip: '58042',
		name: 'Campagnatico',
		province: 'GR',
		altitude: 275
	},
	{
		zip: '26013',
		name: 'Campagnola Cremasca',
		province: 'CR',
		altitude: 81
	},
	{
		zip: '42012',
		name: 'Campagnola Emilia',
		province: 'RE',
		altitude: 22
	},
	{
		zip: '87061',
		name: 'Campana',
		province: 'CS',
		altitude: 612
	},
	{
		zip: '20857',
		name: 'Camparada',
		province: 'MB',
		altitude: 243
	},
	{
		zip: '42040',
		name: 'Campegine',
		province: 'RE',
		altitude: 35
	},
	{
		zip: '06042',
		name: 'Campello sul Clitunno',
		province: 'PG',
		altitude: 290
	},
	{
		zip: '13023',
		name: 'Campertogno',
		province: 'VC',
		altitude: 815
	},
	{
		zip: '50013',
		name: 'Campi Bisenzio',
		province: 'FI',
		altitude: 38
	},
	{
		zip: '73012',
		name: 'Campi Salentina',
		province: 'LE',
		altitude: 33
	},
	{
		zip: '13812',
		name: 'Campiglia Cervo',
		province: 'BI',
		altitude: 77568
	},
	{
		zip: '57021',
		name: 'Campiglia Marittima',
		province: 'LI',
		altitude: 231
	},
	{
		zip: '36020',
		name: 'Campiglia dei Berici',
		province: 'VI',
		altitude: 16
	},
	{
		zip: '10060',
		name: 'Campiglione Fenile',
		province: 'TO',
		altitude: 365
	},
	{
		zip: '22061',
		name: 'Campione d\'\'Italia',
		province: 'CO',
		altitude: 273
	},
	{
		zip: '38031',
		name: 'Campitello di Fassa',
		province: 'TN',
		altitude: 1448
	},
	{
		zip: '64012',
		name: 'Campli',
		province: 'TE',
		altitude: 393
	},
	{
		zip: '89052',
		name: 'Campo Calabro',
		province: 'RC',
		altitude: 138
	},
	{
		zip: '16013',
		name: 'Campo Ligure',
		province: 'GE',
		altitude: 342
	},
	{
		zip: '35010',
		name: 'Campo San Martino',
		province: 'PD',
		altitude: 28
	},
	{
		zip: '39032',
		name: 'Campo Tures',
		province: 'BZ',
		altitude: 864
	},
	{
		zip: '67030',
		name: 'Campo di Giove',
		province: 'AQ',
		altitude: 1064
	},
	{
		zip: '39040',
		name: 'Campo di Trens',
		province: 'BZ',
		altitude: 937
	},
	{
		zip: '57034',
		name: 'Campo nell\'\'Elba',
		province: 'LI',
		altitude: 2
	},
	{
		zip: '86100',
		name: 'Campobasso',
		province: 'CB',
		altitude: 701
	},
	{
		zip: '92023',
		name: 'Campobello di Licata',
		province: 'AG',
		altitude: 316
	},
	{
		zip: '91021',
		name: 'Campobello di Mazara',
		province: 'TP',
		altitude: 110
	},
	{
		zip: '86020',
		name: 'Campochiaro',
		province: 'CB',
		altitude: 750
	},
	{
		zip: '35011',
		name: 'Campodarsego',
		province: 'PD',
		altitude: 17
	},
	{
		zip: '38010',
		name: 'Campodenno',
		province: 'TN',
		altitude: 534
	},
	{
		zip: '04020',
		name: 'Campodimele',
		province: 'LT',
		altitude: 647
	},
	{
		zip: '86010',
		name: 'Campodipietra',
		province: 'CB',
		altitude: 520
	},
	{
		zip: '23021',
		name: 'Campodolcino',
		province: 'SO',
		altitude: 1071
	},
	{
		zip: '35010',
		name: 'Campodoro',
		province: 'PD',
		altitude: 23
	},
	{
		zip: '90030',
		name: 'Campofelice di Fitalia',
		province: 'PA',
		altitude: 734
	},
	{
		zip: '90010',
		name: 'Campofelice di Roccella',
		province: 'PA',
		altitude: 54
	},
	{
		zip: '63828',
		name: 'Campofilone',
		province: 'FM',
		altitude: 202
	},
	{
		zip: '90030',
		name: 'Campofiorito',
		province: 'PA',
		altitude: 660
	},
	{
		zip: '33030',
		name: 'Campoformido',
		province: 'UD',
		altitude: 79
	},
	{
		zip: '93010',
		name: 'Campofranco',
		province: 'CL',
		altitude: 350
	},
	{
		zip: '41011',
		name: 'Campogalliano',
		province: 'MO',
		altitude: 43
	},
	{
		zip: '82020',
		name: 'Campolattaro',
		province: 'BN',
		altitude: 430
	},
	{
		zip: '03030',
		name: 'Campoli Appennino',
		province: 'FR',
		altitude: 650
	},
	{
		zip: '82030',
		name: 'Campoli del Monte Taburno',
		province: 'BN',
		altitude: 439
	},
	{
		zip: '86040',
		name: 'Campolieto',
		province: 'CB',
		altitude: 735
	},
	{
		zip: '30010',
		name: 'Campolongo Maggiore',
		province: 'VE',
		altitude: 3
	},
	{
		zip: '33040',
		name: 'Campolongo Tapogliano',
		province: 'UD',
		altitude: 16
	},
	{
		zip: '85010',
		name: 'Campomaggiore',
		province: 'PZ',
		altitude: 795
	},
	{
		zip: '86042',
		name: 'Campomarino',
		province: 'CB',
		altitude: 52
	},
	{
		zip: '16014',
		name: 'Campomorone',
		province: 'GE',
		altitude: 118
	},
	{
		zip: '30010',
		name: 'Camponogara',
		province: 'VE',
		altitude: 4
	},
	{
		zip: '84040',
		name: 'Campora',
		province: 'SA',
		altitude: 520
	},
	{
		zip: '90043',
		name: 'Camporeale',
		province: 'PA',
		altitude: 439
	},
	{
		zip: '55031',
		name: 'Camporgiano',
		province: 'LU',
		altitude: 475
	},
	{
		zip: '18033',
		name: 'Camporosso',
		province: 'IM',
		altitude: 25
	},
	{
		zip: '95040',
		name: 'Camporotondo Etneo',
		province: 'CT',
		altitude: 445
	},
	{
		zip: '62020',
		name: 'Camporotondo di Fiastrone',
		province: 'MC',
		altitude: 335
	},
	{
		zip: '35012',
		name: 'Camposampiero',
		province: 'PD',
		altitude: 24
	},
	{
		zip: '80030',
		name: 'Camposano',
		province: 'NA',
		altitude: 30
	},
	{
		zip: '41031',
		name: 'Camposanto',
		province: 'MO',
		altitude: 21
	},
	{
		zip: '27040',
		name: 'Campospinoso',
		province: 'PV',
		altitude: 64
	},
	{
		zip: '67013',
		name: 'Campotosto',
		province: 'AQ',
		altitude: 1420
	},
	{
		zip: '40032',
		name: 'Camugnano',
		province: 'BO',
		altitude: 692
	},
	{
		zip: '38050',
		name: 'Canal San Bovo',
		province: 'TN',
		altitude: 758
	},
	{
		zip: '12043',
		name: 'Canale',
		province: 'CN',
		altitude: 194
	},
	{
		zip: '00060',
		name: 'Canale Monterano',
		province: 'RM',
		altitude: 378
	},
	{
		zip: '32020',
		name: 'Canale d\'\'Agordo',
		province: 'BL',
		altitude: 976
	},
	{
		zip: '45034',
		name: 'Canaro',
		province: 'RO',
		altitude: 7
	},
	{
		zip: '38032',
		name: 'Canazei',
		province: 'TN',
		altitude: 1460
	},
	{
		zip: '85010',
		name: 'Cancellara',
		province: 'PZ',
		altitude: 680
	},
	{
		zip: '81030',
		name: 'Cancello ed Arnone',
		province: 'CE',
		altitude: 8
	},
	{
		zip: '45020',
		name: 'Canda',
		province: 'RO',
		altitude: 10
	},
	{
		zip: '71024',
		name: 'Candela',
		province: 'FG',
		altitude: 474
	},
	{
		zip: '13878',
		name: 'Candelo',
		province: 'BI',
		altitude: 340
	},
	{
		zip: '10010',
		name: 'Candia Canavese',
		province: 'TO',
		altitude: 330
	},
	{
		zip: '27031',
		name: 'Candia Lomellina',
		province: 'PV',
		altitude: 102
	},
	{
		zip: '35020',
		name: 'Candiana',
		province: 'PD',
		altitude: 4
	},
	{
		zip: '83040',
		name: 'Candida',
		province: 'AV',
		altitude: 579
	},
	{
		zip: '89020',
		name: 'Candidoni',
		province: 'RC',
		altitude: 239
	},
	{
		zip: '10060',
		name: 'Candiolo',
		province: 'TO',
		altitude: 237
	},
	{
		zip: '20039',
		name: 'Canegrate',
		province: 'MI',
		altitude: 196
	},
	{
		zip: '14053',
		name: 'Canelli',
		province: 'AT',
		altitude: 157
	},
	{
		zip: '01030',
		name: 'Canepina',
		province: 'VT',
		altitude: 501
	},
	{
		zip: '33070',
		name: 'Caneva',
		province: 'PN',
		altitude: 57
	},
	{
		zip: '96010',
		name: 'Canicattini Bagni',
		province: 'SR',
		altitude: 362
	},
	{
		zip: '92024',
		name: 'Canicatti',
		province: 'AG',
		altitude: 465
	},
	{
		zip: '01011',
		name: 'Canino',
		province: 'VT',
		altitude: 229
	},
	{
		zip: '10080',
		name: 'Canischio',
		province: 'TO',
		altitude: 659
	},
	{
		zip: '67050',
		name: 'Canistro',
		province: 'AQ',
		altitude: 554
	},
	{
		zip: '87070',
		name: 'Canna',
		province: 'CS',
		altitude: 417
	},
	{
		zip: '84040',
		name: 'Cannalonga',
		province: 'SA',
		altitude: 570
	},
	{
		zip: '06033',
		name: 'Cannara',
		province: 'PG',
		altitude: 191
	},
	{
		zip: '28821',
		name: 'Cannero Riviera',
		province: 'VB',
		altitude: 225
	},
	{
		zip: '27044',
		name: 'Canneto Pavese',
		province: 'PV',
		altitude: 233
	},
	{
		zip: '46013',
		name: 'Canneto sull\'\'Oglio',
		province: 'MN',
		altitude: 34
	},
	{
		zip: '28822',
		name: 'Cannobio',
		province: 'VB',
		altitude: 214
	},
	{
		zip: '73020',
		name: 'Cannole',
		province: 'LE',
		altitude: 100
	},
	{
		zip: '89040',
		name: 'Canolo',
		province: 'RC',
		altitude: 432
	},
	{
		zip: '24040',
		name: 'Canonica d\'\'Adda',
		province: 'BG',
		altitude: 99
	},
	{
		zip: '66010',
		name: 'Canosa Sannita',
		province: 'CH',
		altitude: 231
	},
	{
		zip: '76012',
		name: 'Canosa di Puglia',
		province: 'BT',
		altitude: 117
	},
	{
		zip: '12020',
		name: 'Canosio',
		province: 'CN',
		altitude: 1225
	},
	{
		zip: '42026',
		name: 'Canossa',
		province: 'RE',
		altitude: 219
	},
	{
		zip: '67030',
		name: 'Cansano',
		province: 'AQ',
		altitude: 835
	},
	{
		zip: '59025',
		name: 'Cantagallo',
		province: 'PO',
		altitude: 423
	},
	{
		zip: '02014',
		name: 'Cantalice',
		province: 'RI',
		altitude: 660
	},
	{
		zip: '10060',
		name: 'Cantalupa',
		province: 'TO',
		altitude: 459
	},
	{
		zip: '15060',
		name: 'Cantalupo Ligure',
		province: 'AL',
		altitude: 383
	},
	{
		zip: '02040',
		name: 'Cantalupo in Sabina',
		province: 'RI',
		altitude: 297
	},
	{
		zip: '86092',
		name: 'Cantalupo nel Sannio',
		province: 'IS',
		altitude: 587
	},
	{
		zip: '14010',
		name: 'Cantarana',
		province: 'AT',
		altitude: 176
	},
	{
		zip: '21050',
		name: 'Cantello',
		province: 'VA',
		altitude: 404
	},
	{
		zip: '00020',
		name: 'Canterano',
		province: 'RM',
		altitude: 602
	},
	{
		zip: '61044',
		name: 'Cantiano',
		province: 'PU',
		altitude: 360
	},
	{
		zip: '10070',
		name: 'Cantoira',
		province: 'TO',
		altitude: 770
	},
	{
		zip: '22063',
		name: 'Cantu',
		province: 'CO',
		altitude: 369
	},
	{
		zip: '64020',
		name: 'Canzano',
		province: 'TE',
		altitude: 448
	},
	{
		zip: '22035',
		name: 'Canzo',
		province: 'CO',
		altitude: 402
	},
	{
		zip: '30021',
		name: 'Caorle',
		province: 'VE',
		altitude: 1
	},
	{
		zip: '29012',
		name: 'Caorso',
		province: 'PC',
		altitude: 46
	},
	{
		zip: '84047',
		name: 'Capaccio Paestum',
		province: 'SA',
		altitude: 419
	},
	{
		zip: '90040',
		name: 'Capaci',
		province: 'PA',
		altitude: 51
	},
	{
		zip: '58011',
		name: 'Capalbio',
		province: 'GR',
		altitude: 217
	},
	{
		zip: '56033',
		name: 'Capannoli',
		province: 'PI',
		altitude: 51
	},
	{
		zip: '55012',
		name: 'Capannori',
		province: 'LU',
		altitude: 15
	},
	{
		zip: '00060',
		name: 'Capena',
		province: 'RM',
		altitude: 160
	},
	{
		zip: '26010',
		name: 'Capergnanica',
		province: 'CR',
		altitude: 77
	},
	{
		zip: '67022',
		name: 'Capestrano',
		province: 'AQ',
		altitude: 465
	},
	{
		zip: '22070',
		name: 'Capiago Intimiano',
		province: 'CO',
		altitude: 472
	},
	{
		zip: '89818',
		name: 'Capistrano',
		province: 'VV',
		altitude: 352
	},
	{
		zip: '67053',
		name: 'Capistrello',
		province: 'AQ',
		altitude: 734
	},
	{
		zip: '67014',
		name: 'Capitignano',
		province: 'AQ',
		altitude: 916
	},
	{
		zip: '98031',
		name: 'Capizzi',
		province: 'ME',
		altitude: 1100
	},
	{
		zip: '24030',
		name: 'Capizzone',
		province: 'BG',
		altitude: 654
	},
	{
		zip: '98071',
		name: 'Capo d\'\'Orlando',
		province: 'ME',
		altitude: 8
	},
	{
		zip: '25044',
		name: 'Capo di Ponte',
		province: 'BS',
		altitude: 362
	},
	{
		zip: '01010',
		name: 'Capodimonte',
		province: 'VT',
		altitude: 334
	},
	{
		zip: '81020',
		name: 'Capodrise',
		province: 'CE',
		altitude: 34
	},
	{
		zip: '57031',
		name: 'Capoliveri',
		province: 'LI',
		altitude: 167
	},
	{
		zip: '52010',
		name: 'Capolona',
		province: 'AR',
		altitude: 263
	},
	{
		zip: '20867',
		name: 'Caponago',
		province: 'MB',
		altitude: 158
	},
	{
		zip: '67020',
		name: 'Caporciano',
		province: 'AQ',
		altitude: 836
	},
	{
		zip: '83040',
		name: 'Caposele',
		province: 'AV',
		altitude: 405
	},
	{
		zip: '09012',
		name: 'Capoterra',
		province: 'CA',
		altitude: 54
	},
	{
		zip: '25070',
		name: 'Capovalle',
		province: 'BS',
		altitude: 1000
	},
	{
		zip: '67060',
		name: 'Cappadocia',
		province: 'AQ',
		altitude: 1108
	},
	{
		zip: '26020',
		name: 'Cappella Cantone',
		province: 'CR',
		altitude: 60
	},
	{
		zip: '31012',
		name: 'Cappella Maggiore',
		province: 'TV',
		altitude: 115
	},
	{
		zip: '26030',
		name: 'Cappella de Picenardi',
		province: 'CR',
		altitude: 42
	},
	{
		zip: '65010',
		name: 'Cappelle sul Tavo',
		province: 'PE',
		altitude: 122
	},
	{
		zip: '86082',
		name: 'Capracotta',
		province: 'IS',
		altitude: 1421
	},
	{
		zip: '57032',
		name: 'Capraia Isola',
		province: 'LI',
		altitude: 52
	},
	{
		zip: '50050',
		name: 'Capraia e Limite',
		province: 'FI',
		altitude: 28
	},
	{
		zip: '26010',
		name: 'Capralba',
		province: 'CR',
		altitude: 93
	},
	{
		zip: '01012',
		name: 'Capranica',
		province: 'VT',
		altitude: 370
	},
	{
		zip: '00030',
		name: 'Capranica Prenestina',
		province: 'RM',
		altitude: 915
	},
	{
		zip: '73010',
		name: 'Caprarica di Lecce',
		province: 'LE',
		altitude: 60
	},
	{
		zip: '01032',
		name: 'Caprarola',
		province: 'VT',
		altitude: 520
	},
	{
		zip: '12070',
		name: 'Caprauna',
		province: 'CN',
		altitude: 959
	},
	{
		zip: '52033',
		name: 'Caprese Michelangelo',
		province: 'AR',
		altitude: 653
	},
	{
		zip: '28815',
		name: 'Caprezzo',
		province: 'VB',
		altitude: 530
	},
	{
		zip: '80073',
		name: 'Capri',
		province: 'NA',
		altitude: 142
	},
	{
		zip: '98070',
		name: 'Capri Leone',
		province: 'ME',
		altitude: 420
	},
	{
		zip: '38030',
		name: 'Capriana',
		province: 'TN',
		altitude: 1007
	},
	{
		zip: '25020',
		name: 'Capriano del Colle',
		province: 'BS',
		altitude: 92
	},
	{
		zip: '15060',
		name: 'Capriata d\'\'Orba',
		province: 'AL',
		altitude: 176
	},
	{
		zip: '24042',
		name: 'Capriate San Gervasio',
		province: 'BG',
		altitude: 190
	},
	{
		zip: '81014',
		name: 'Capriati a Volturno',
		province: 'CE',
		altitude: 290
	},
	{
		zip: '10040',
		name: 'Caprie',
		province: 'TO',
		altitude: 374
	},
	{
		zip: '83010',
		name: 'Capriglia Irpina',
		province: 'AV',
		altitude: 575
	},
	{
		zip: '14014',
		name: 'Capriglio',
		province: 'AT',
		altitude: 231
	},
	{
		zip: '13864',
		name: 'Caprile',
		province: 'BI',
		altitude: 559
	},
	{
		zip: '24030',
		name: 'Caprino Bergamasco',
		province: 'BG',
		altitude: 315
	},
	{
		zip: '37013',
		name: 'Caprino Veronese',
		province: 'VR',
		altitude: 254
	},
	{
		zip: '25031',
		name: 'Capriolo',
		province: 'BS',
		altitude: 218
	},
	{
		zip: '34070',
		name: 'Capriva del Friuli',
		province: 'GO',
		altitude: 49
	},
	{
		zip: '81043',
		name: 'Capua',
		province: 'CE',
		altitude: 25
	},
	{
		zip: '70010',
		name: 'Capurso',
		province: 'BA',
		altitude: 74
	},
	{
		zip: '89030',
		name: 'Caraffa del Bianco',
		province: 'RC',
		altitude: 355
	},
	{
		zip: '88050',
		name: 'Caraffa di Catanzaro',
		province: 'CZ',
		altitude: 358
	},
	{
		zip: '12023',
		name: 'Caraglio',
		province: 'CN',
		altitude: 575
	},
	{
		zip: '12030',
		name: 'Caramagna Piemonte',
		province: 'CN',
		altitude: 257
	},
	{
		zip: '65023',
		name: 'Caramanico Terme',
		province: 'PE',
		altitude: 600
	},
	{
		zip: '71041',
		name: 'Carapelle',
		province: 'FG',
		altitude: 62
	},
	{
		zip: '67020',
		name: 'Carapelle Calvisio',
		province: 'AQ',
		altitude: 910
	},
	{
		zip: '16042',
		name: 'Carasco',
		province: 'GE',
		altitude: 26
	},
	{
		zip: '63063',
		name: 'Carassai',
		province: 'AP',
		altitude: 365
	},
	{
		zip: '20841',
		name: 'Carate Brianza',
		province: 'MB',
		altitude: 250
	},
	{
		zip: '22010',
		name: 'Carate Urio',
		province: 'CO',
		altitude: 199
	},
	{
		zip: '24043',
		name: 'Caravaggio',
		province: 'BG',
		altitude: 111
	},
	{
		zip: '21032',
		name: 'Caravate',
		province: 'VA',
		altitude: 296
	},
	{
		zip: '10010',
		name: 'Caravino',
		province: 'TO',
		altitude: 257
	},
	{
		zip: '18020',
		name: 'Caravonica',
		province: 'IM',
		altitude: 360
	},
	{
		zip: '01030',
		name: 'Carbognano',
		province: 'VT',
		altitude: 394
	},
	{
		zip: '15050',
		name: 'Carbonara Scrivia',
		province: 'AL',
		altitude: 177
	},
	{
		zip: '27020',
		name: 'Carbonara al Ticino',
		province: 'PV',
		altitude: 83
	},
	{
		zip: '80030',
		name: 'Carbonara di Nola',
		province: 'NA',
		altitude: 174
	},
	{
		zip: '22070',
		name: 'Carbonate',
		province: 'CO',
		altitude: 267
	},
	{
		zip: '85030',
		name: 'Carbone',
		province: 'PZ',
		altitude: 690
	},
	{
		zip: '31030',
		name: 'Carbonera',
		province: 'TV',
		altitude: 18
	},
	{
		zip: '09013',
		name: 'Carbonia',
		province: 'SU',
		altitude: 111
	},
	{
		zip: '17043',
		name: 'Carcare',
		province: 'SV',
		altitude: 365
	},
	{
		zip: '35040',
		name: 'Carceri',
		province: 'PD',
		altitude: 10
	},
	{
		zip: '13026',
		name: 'Carcoforo',
		province: 'VC',
		altitude: 1304
	},
	{
		zip: '21010',
		name: 'Cardano al Campo',
		province: 'VA',
		altitude: 240
	},
	{
		zip: '08040',
		name: 'Cardedu',
		province: 'NU',
		altitude: 19
	},
	{
		zip: '89060',
		name: 'Cardeto',
		province: 'RC',
		altitude: 700
	},
	{
		zip: '88062',
		name: 'Cardinale',
		province: 'CZ',
		altitude: 562
	},
	{
		zip: '80024',
		name: 'Cardito',
		province: 'NA',
		altitude: 33
	},
	{
		zip: '12030',
		name: 'Carde',
		province: 'CN',
		altitude: 258
	},
	{
		zip: '55030',
		name: 'Careggine',
		province: 'LU',
		altitude: 882
	},
	{
		zip: '10010',
		name: 'Carema',
		province: 'TO',
		altitude: 349
	},
	{
		zip: '23802',
		name: 'Carenno',
		province: 'LC',
		altitude: 635
	},
	{
		zip: '15026',
		name: 'Carentino',
		province: 'AL',
		altitude: 160
	},
	{
		zip: '89030',
		name: 'Careri',
		province: 'RC',
		altitude: 320
	},
	{
		zip: '13010',
		name: 'Caresana',
		province: 'VC',
		altitude: 119
	},
	{
		zip: '13030',
		name: 'Caresanablot',
		province: 'VC',
		altitude: 135
	},
	{
		zip: '15051',
		name: 'Carezzano',
		province: 'AL',
		altitude: 300
	},
	{
		zip: '88817',
		name: 'Carfizzi',
		province: 'KR',
		altitude: 512
	},
	{
		zip: '07030',
		name: 'Cargeghe',
		province: 'SS',
		altitude: 333
	},
	{
		zip: '87062',
		name: 'Cariati',
		province: 'CS',
		altitude: 50
	},
	{
		zip: '83040',
		name: 'Carife',
		province: 'AV',
		altitude: 740
	},
	{
		zip: '10041',
		name: 'Carignano',
		province: 'TO',
		altitude: 235
	},
	{
		zip: '22060',
		name: 'Carimate',
		province: 'CO',
		altitude: 265
	},
	{
		zip: '81032',
		name: 'Carinaro',
		province: 'CE',
		altitude: 29
	},
	{
		zip: '90044',
		name: 'Carini',
		province: 'PA',
		altitude: 181
	},
	{
		zip: '81030',
		name: 'Carinola',
		province: 'CE',
		altitude: 74
	},
	{
		zip: '13040',
		name: 'Carisio',
		province: 'VC',
		altitude: 183
	},
	{
		zip: '38080',
		name: 'Carisolo',
		province: 'TN',
		altitude: 801
	},
	{
		zip: '71030',
		name: 'Carlantino',
		province: 'FG',
		altitude: 558
	},
	{
		zip: '22010',
		name: 'Carlazzo',
		province: 'CO',
		altitude: 481
	},
	{
		zip: '96013',
		name: 'Carlentini',
		province: 'SR',
		altitude: 190
	},
	{
		zip: '33050',
		name: 'Carlino',
		province: 'UD',
		altitude: 5
	},
	{
		zip: '09014',
		name: 'Carloforte',
		province: 'SU',
		altitude: 10
	},
	{
		zip: '88040',
		name: 'Carlopoli',
		province: 'CZ',
		altitude: 924
	},
	{
		zip: '10022',
		name: 'Carmagnola',
		province: 'TO',
		altitude: 240
	},
	{
		zip: '73041',
		name: 'Carmiano',
		province: 'LE',
		altitude: 31
	},
	{
		zip: '59015',
		name: 'Carmignano',
		province: 'PO',
		altitude: 189
	},
	{
		zip: '35010',
		name: 'Carmignano di Brenta',
		province: 'PD',
		altitude: 46
	},
	{
		zip: '21040',
		name: 'Carnago',
		province: 'VA',
		altitude: 354
	},
	{
		zip: '20866',
		name: 'Carnate',
		province: 'MB',
		altitude: 237
	},
	{
		zip: '24060',
		name: 'Carobbio degli Angeli',
		province: 'BG',
		altitude: 232
	},
	{
		zip: '87030',
		name: 'Carolei',
		province: 'CS',
		altitude: 624
	},
	{
		zip: '24010',
		name: 'Carona',
		province: 'BG',
		altitude: 1110
	},
	{
		zip: '98072',
		name: 'Caronia',
		province: 'ME',
		altitude: 304
	},
	{
		zip: '21042',
		name: 'Caronno Pertusella',
		province: 'VA',
		altitude: 194
	},
	{
		zip: '21040',
		name: 'Caronno Varesino',
		province: 'VA',
		altitude: 403
	},
	{
		zip: '74021',
		name: 'Carosino',
		province: 'TA',
		altitude: 74
	},
	{
		zip: '72012',
		name: 'Carovigno',
		province: 'BR',
		altitude: 161
	},
	{
		zip: '86083',
		name: 'Carovilli',
		province: 'IS',
		altitude: 860
	},
	{
		zip: '29013',
		name: 'Carpaneto Piacentino',
		province: 'PC',
		altitude: 114
	},
	{
		zip: '87050',
		name: 'Carpanzano',
		province: 'CS',
		altitude: 600
	},
	{
		zip: '61021',
		name: 'Carpegna',
		province: 'PU',
		altitude: 748
	},
	{
		zip: '25013',
		name: 'Carpenedolo',
		province: 'BS',
		altitude: 78
	},
	{
		zip: '15071',
		name: 'Carpeneto',
		province: 'AL',
		altitude: 329
	},
	{
		zip: '41012',
		name: 'Carpi',
		province: 'MO',
		altitude: 26
	},
	{
		zip: '20074',
		name: 'Carpiano',
		province: 'MI',
		altitude: 91
	},
	{
		zip: '73020',
		name: 'Carpignano Salentino',
		province: 'LE',
		altitude: 75
	},
	{
		zip: '28064',
		name: 'Carpignano Sesia',
		province: 'NO',
		altitude: 190
	},
	{
		zip: '42033',
		name: 'Carpineti',
		province: 'RE',
		altitude: 562
	},
	{
		zip: '00032',
		name: 'Carpineto Romano',
		province: 'RM',
		altitude: 550
	},
	{
		zip: '66030',
		name: 'Carpineto Sinello',
		province: 'CH',
		altitude: 381
	},
	{
		zip: '65010',
		name: 'Carpineto della Nora',
		province: 'PE',
		altitude: 535
	},
	{
		zip: '71010',
		name: 'Carpino',
		province: 'FG',
		altitude: 147
	},
	{
		zip: '86093',
		name: 'Carpinone',
		province: 'IS',
		altitude: 636
	},
	{
		zip: '54033',
		name: 'Carrara',
		province: 'MS',
		altitude: 100
	},
	{
		zip: '15060',
		name: 'Carrega Ligure',
		province: 'AL',
		altitude: 958
	},
	{
		zip: '19012',
		name: 'Carro',
		province: 'SP',
		altitude: 178
	},
	{
		zip: '19020',
		name: 'Carrodano',
		province: 'SP',
		altitude: 215
	},
	{
		zip: '15060',
		name: 'Carrosio',
		province: 'AL',
		altitude: 254
	},
	{
		zip: '36010',
		name: 'Carre',
		province: 'VI',
		altitude: 224
	},
	{
		zip: '12061',
		name: 'Carru',
		province: 'CN',
		altitude: 364
	},
	{
		zip: '67061',
		name: 'Carsoli',
		province: 'AQ',
		altitude: 616
	},
	{
		zip: '36050',
		name: 'Cartigliano',
		province: 'VI',
		altitude: 86
	},
	{
		zip: '12020',
		name: 'Cartignano',
		province: 'CN',
		altitude: 694
	},
	{
		zip: '61030',
		name: 'Cartoceto',
		province: 'PU',
		altitude: 235
	},
	{
		zip: '15015',
		name: 'Cartosio',
		province: 'AL',
		altitude: 230
	},
	{
		zip: '35025',
		name: 'Cartura',
		province: 'PD',
		altitude: 6
	},
	{
		zip: '20061',
		name: 'Carugate',
		province: 'MI',
		altitude: 149
	},
	{
		zip: '22060',
		name: 'Carugo',
		province: 'CO',
		altitude: 270
	},
	{
		zip: '66050',
		name: 'Carunchio',
		province: 'CH',
		altitude: 714
	},
	{
		zip: '24030',
		name: 'Carvico',
		province: 'BG',
		altitude: 287
	},
	{
		zip: '38050',
		name: 'Carzano',
		province: 'TN',
		altitude: 433
	},
	{
		zip: '88822',
		name: 'Casabona',
		province: 'KR',
		altitude: 287
	},
	{
		zip: '86043',
		name: 'Casacalenda',
		province: 'CB',
		altitude: 643
	},
	{
		zip: '66010',
		name: 'Casacanditella',
		province: 'CH',
		altitude: 432
	},
	{
		zip: '81022',
		name: 'Casagiove',
		province: 'CE',
		altitude: 55
	},
	{
		zip: '15072',
		name: 'Casal Cermelli',
		province: 'AL',
		altitude: 102
	},
	{
		zip: '84040',
		name: 'Casal Velino',
		province: 'SA',
		altitude: 170
	},
	{
		zip: '81033',
		name: 'Casal di Principe',
		province: 'CE',
		altitude: 16
	},
	{
		zip: '66031',
		name: 'Casalanguida',
		province: 'CH',
		altitude: 470
	},
	{
		zip: '03030',
		name: 'Casalattico',
		province: 'FR',
		altitude: 420
	},
	{
		zip: '28060',
		name: 'Casalbeltrame',
		province: 'NO',
		altitude: 151
	},
	{
		zip: '66021',
		name: 'Casalbordino',
		province: 'CH',
		altitude: 203
	},
	{
		zip: '83034',
		name: 'Casalbore',
		province: 'AV',
		altitude: 601
	},
	{
		zip: '10020',
		name: 'Casalborgone',
		province: 'TO',
		altitude: 318
	},
	{
		zip: '84030',
		name: 'Casalbuono',
		province: 'SA',
		altitude: 661
	},
	{
		zip: '26011',
		name: 'Casalbuttano ed Uniti',
		province: 'CR',
		altitude: 60
	},
	{
		zip: '86010',
		name: 'Casalciprano',
		province: 'CB',
		altitude: 662
	},
	{
		zip: '82030',
		name: 'Casalduni',
		province: 'BN',
		altitude: 300
	},
	{
		zip: '28881',
		name: 'Casale Corte Cerro',
		province: 'VB',
		altitude: 372
	},
	{
		zip: '26010',
		name: 'Casale Cremasco-Vidolasco',
		province: 'CR',
		altitude: 92
	},
	{
		zip: '21020',
		name: 'Casale Litta',
		province: 'VA',
		altitude: 382
	},
	{
		zip: '56040',
		name: 'Casale Marittimo',
		province: 'PI',
		altitude: 214
	},
	{
		zip: '15033',
		name: 'Casale Monferrato',
		province: 'AL',
		altitude: 116
	},
	{
		zip: '35040',
		name: 'Casale di Scodosia',
		province: 'PD',
		altitude: 13
	},
	{
		zip: '31032',
		name: 'Casale sul Sile',
		province: 'TV',
		altitude: 6
	},
	{
		zip: '40033',
		name: 'Casalecchio di Reno',
		province: 'BO',
		altitude: 61
	},
	{
		zip: '15070',
		name: 'Casaleggio Boiro',
		province: 'AL',
		altitude: 321
	},
	{
		zip: '28060',
		name: 'Casaleggio Novara',
		province: 'NO',
		altitude: 170
	},
	{
		zip: '37052',
		name: 'Casaleone',
		province: 'VR',
		altitude: 16
	},
	{
		zip: '26010',
		name: 'Casaletto Ceredano',
		province: 'CR',
		altitude: 65
	},
	{
		zip: '26852',
		name: 'Casaletto Lodigiano',
		province: 'LO',
		altitude: 80
	},
	{
		zip: '84030',
		name: 'Casaletto Spartano',
		province: 'SA',
		altitude: 400
	},
	{
		zip: '26010',
		name: 'Casaletto Vaprio',
		province: 'CR',
		altitude: 87
	},
	{
		zip: '26014',
		name: 'Casaletto di Sopra',
		province: 'CR',
		altitude: 87
	},
	{
		zip: '40020',
		name: 'Casalfiumanese',
		province: 'BO',
		altitude: 125
	},
	{
		zip: '42013',
		name: 'Casalgrande',
		province: 'RE',
		altitude: 97
	},
	{
		zip: '12030',
		name: 'Casalgrasso',
		province: 'CN',
		altitude: 240
	},
	{
		zip: '87059',
		name: 'Casali del Manco',
		province: 'CS',
		altitude: 647
	},
	{
		zip: '66012',
		name: 'Casalincontrada',
		province: 'CH',
		altitude: 333
	},
	{
		zip: '28060',
		name: 'Casalino',
		province: 'NO',
		altitude: 131
	},
	{
		zip: '26041',
		name: 'Casalmaggiore',
		province: 'CR',
		altitude: 26
	},
	{
		zip: '26831',
		name: 'Casalmaiocco',
		province: 'LO',
		altitude: 88
	},
	{
		zip: '26020',
		name: 'Casalmorano',
		province: 'CR',
		altitude: 67
	},
	{
		zip: '46040',
		name: 'Casalmoro',
		province: 'MN',
		altitude: 47
	},
	{
		zip: '15052',
		name: 'Casalnoceto',
		province: 'AL',
		altitude: 159
	},
	{
		zip: '71033',
		name: 'Casalnuovo Monterotaro',
		province: 'FG',
		altitude: 432
	},
	{
		zip: '80013',
		name: 'Casalnuovo di Napoli',
		province: 'NA',
		altitude: 26
	},
	{
		zip: '46040',
		name: 'Casaloldo',
		province: 'MN',
		altitude: 45
	},
	{
		zip: '26841',
		name: 'Casalpusterlengo',
		province: 'LO',
		altitude: 60
	},
	{
		zip: '46040',
		name: 'Casalromano',
		province: 'MN',
		altitude: 42
	},
	{
		zip: '35020',
		name: 'Casalserugo',
		province: 'PD',
		altitude: 8
	},
	{
		zip: '81030',
		name: 'Casaluce',
		province: 'CE',
		altitude: 25
	},
	{
		zip: '98032',
		name: 'Casalvecchio Siculo',
		province: 'ME',
		altitude: 370
	},
	{
		zip: '71030',
		name: 'Casalvecchio di Puglia',
		province: 'FG',
		altitude: 465
	},
	{
		zip: '03034',
		name: 'Casalvieri',
		province: 'FR',
		altitude: 380
	},
	{
		zip: '28060',
		name: 'Casalvolone',
		province: 'NO',
		altitude: 141
	},
	{
		zip: '21030',
		name: 'Casalzuigno',
		province: 'VA',
		altitude: 350
	},
	{
		zip: '80032',
		name: 'Casamarciano',
		province: 'NA',
		altitude: 70
	},
	{
		zip: '70010',
		name: 'Casamassima',
		province: 'BA',
		altitude: 223
	},
	{
		zip: '80074',
		name: 'Casamicciola Terme',
		province: 'NA',
		altitude: 43
	},
	{
		zip: '80025',
		name: 'Casandrino',
		province: 'NA',
		altitude: 59
	},
	{
		zip: '13030',
		name: 'Casanova Elvo',
		province: 'VC',
		altitude: 152
	},
	{
		zip: '17033',
		name: 'Casanova Lerrone',
		province: 'SV',
		altitude: 256
	},
	{
		zip: '27041',
		name: 'Casanova Lonati',
		province: 'PV',
		altitude: 64
	},
	{
		zip: '00010',
		name: 'Casape',
		province: 'RM',
		altitude: 475
	},
	{
		zip: '81030',
		name: 'Casapesenna',
		province: 'CE',
		altitude: 25
	},
	{
		zip: '13866',
		name: 'Casapinta',
		province: 'BI',
		altitude: 432
	},
	{
		zip: '02030',
		name: 'Casaprota',
		province: 'RI',
		altitude: 523
	},
	{
		zip: '81020',
		name: 'Casapulla',
		province: 'CE',
		altitude: 46
	},
	{
		zip: '73042',
		name: 'Casarano',
		province: 'LE',
		altitude: 107
	},
	{
		zip: '23831',
		name: 'Casargo',
		province: 'LC',
		altitude: 804
	},
	{
		zip: '20059',
		name: 'Casarile',
		province: 'MI',
		altitude: 97
	},
	{
		zip: '33072',
		name: 'Casarsa della Delizia',
		province: 'PN',
		altitude: 44
	},
	{
		zip: '16030',
		name: 'Casarza Ligure',
		province: 'GE',
		altitude: 34
	},
	{
		zip: '15050',
		name: 'Casasco',
		province: 'AL',
		altitude: 398
	},
	{
		zip: '23880',
		name: 'Casatenovo',
		province: 'LC',
		altitude: 356
	},
	{
		zip: '27040',
		name: 'Casatisma',
		province: 'PV',
		altitude: 77
	},
	{
		zip: '80020',
		name: 'Casavatore',
		province: 'NA',
		altitude: 80
	},
	{
		zip: '24060',
		name: 'Casazza',
		province: 'BG',
		altitude: 349
	},
	{
		zip: '06043',
		name: 'Cascia',
		province: 'PG',
		altitude: 653
	},
	{
		zip: '21020',
		name: 'Casciago',
		province: 'VA',
		altitude: 400
	},
	{
		zip: '56035',
		name: 'Casciana Terme Lari',
		province: 'PI',
		altitude: 127
	},
	{
		zip: '56021',
		name: 'Cascina',
		province: 'PI',
		altitude: 8
	},
	{
		zip: '10010',
		name: 'Cascinette d\'\'Ivrea',
		province: 'TO',
		altitude: 239
	},
	{
		zip: '27050',
		name: 'Casei Gerola',
		province: 'PV',
		altitude: 81
	},
	{
		zip: '10040',
		name: 'Caselette',
		province: 'TO',
		altitude: 350
	},
	{
		zip: '16015',
		name: 'Casella',
		province: 'GE',
		altitude: 410
	},
	{
		zip: '26842',
		name: 'Caselle Landi',
		province: 'LO',
		altitude: 44
	},
	{
		zip: '26853',
		name: 'Caselle Lurani',
		province: 'LO',
		altitude: 80
	},
	{
		zip: '10072',
		name: 'Caselle Torinese',
		province: 'TO',
		altitude: 277
	},
	{
		zip: '84030',
		name: 'Caselle in Pittari',
		province: 'SA',
		altitude: 444
	},
	{
		zip: '81100',
		name: 'Caserta',
		province: 'CE',
		altitude: 68
	},
	{
		zip: '31030',
		name: 'Casier',
		province: 'TV',
		altitude: 12
	},
	{
		zip: '89030',
		name: 'Casignana',
		province: 'RC',
		altitude: 342
	},
	{
		zip: '42034',
		name: 'Casina',
		province: 'RE',
		altitude: 574
	},
	{
		zip: '24040',
		name: 'Casirate d\'\'Adda',
		province: 'BG',
		altitude: 114
	},
	{
		zip: '22030',
		name: 'Caslino d\'\'Erba',
		province: 'CO',
		altitude: 461
	},
	{
		zip: '22070',
		name: 'Casnate con Bernate',
		province: 'CO',
		altitude: 342
	},
	{
		zip: '24020',
		name: 'Casnigo',
		province: 'BG',
		altitude: 514
	},
	{
		zip: '48032',
		name: 'Casola Valsenio',
		province: 'RA',
		altitude: 195
	},
	{
		zip: '80050',
		name: 'Casola di Napoli',
		province: 'NA',
		altitude: 170
	},
	{
		zip: '54014',
		name: 'Casola in Lunigiana',
		province: 'MS',
		altitude: 328
	},
	{
		zip: '53031',
		name: 'Casole d\'\'Elsa',
		province: 'SI',
		altitude: 417
	},
	{
		zip: '66043',
		name: 'Casoli',
		province: 'CH',
		altitude: 378
	},
	{
		zip: '27022',
		name: 'Casorate Primo',
		province: 'PV',
		altitude: 103
	},
	{
		zip: '21011',
		name: 'Casorate Sempione',
		province: 'VA',
		altitude: 282
	},
	{
		zip: '20010',
		name: 'Casorezzo',
		province: 'MI',
		altitude: 166
	},
	{
		zip: '80026',
		name: 'Casoria',
		province: 'NA',
		altitude: 70
	},
	{
		zip: '14032',
		name: 'Casorzo',
		province: 'AT',
		altitude: 275
	},
	{
		zip: '02041',
		name: 'Casperia',
		province: 'RI',
		altitude: 397
	},
	{
		zip: '23020',
		name: 'Caspoggio',
		province: 'SO',
		altitude: 1098
	},
	{
		zip: '33010',
		name: 'Cassacco',
		province: 'UD',
		altitude: 179
	},
	{
		zip: '23893',
		name: 'Cassago Brianza',
		province: 'LC',
		altitude: 334
	},
	{
		zip: '83040',
		name: 'Cassano Irpino',
		province: 'AV',
		altitude: 510
	},
	{
		zip: '21012',
		name: 'Cassano Magnago',
		province: 'VA',
		altitude: 261
	},
	{
		zip: '15063',
		name: 'Cassano Spinola',
		province: 'AL',
		altitude: 191
	},
	{
		zip: '21030',
		name: 'Cassano Valcuvia',
		province: 'VA',
		altitude: 296
	},
	{
		zip: '87011',
		name: 'Cassano all\'\'Ionio',
		province: 'CS',
		altitude: 250
	},
	{
		zip: '20062',
		name: 'Cassano d\'\'Adda',
		province: 'MI',
		altitude: 133
	},
	{
		zip: '70020',
		name: 'Cassano delle Murge',
		province: 'BA',
		altitude: 341
	},
	{
		zip: '96010',
		name: 'Cassaro',
		province: 'SR',
		altitude: 560
	},
	{
		zip: '24010',
		name: 'Cassiglio',
		province: 'BG',
		altitude: 602
	},
	{
		zip: '22070',
		name: 'Cassina Rizzardi',
		province: 'CO',
		altitude: 317
	},
	{
		zip: '23817',
		name: 'Cassina Valsassina',
		province: 'LC',
		altitude: 849
	},
	{
		zip: '20051',
		name: 'Cassina de Pecchi',
		province: 'MI',
		altitude: 130
	},
	{
		zip: '14050',
		name: 'Cassinasco',
		province: 'AT',
		altitude: 447
	},
	{
		zip: '15016',
		name: 'Cassine',
		province: 'AL',
		altitude: 190
	},
	{
		zip: '15070',
		name: 'Cassinelle',
		province: 'AL',
		altitude: 360
	},
	{
		zip: '20081',
		name: 'Cassinetta di Lugagnano',
		province: 'MI',
		altitude: 125
	},
	{
		zip: '03043',
		name: 'Cassino',
		province: 'FR',
		altitude: 40
	},
	{
		zip: '36022',
		name: 'Cassola',
		province: 'VI',
		altitude: 92
	},
	{
		zip: '27023',
		name: 'Cassolnovo',
		province: 'PV',
		altitude: 120
	},
	{
		zip: '37043',
		name: 'Castagnaro',
		province: 'VR',
		altitude: 14
	},
	{
		zip: '57022',
		name: 'Castagneto Carducci',
		province: 'LI',
		altitude: 194
	},
	{
		zip: '10090',
		name: 'Castagneto Po',
		province: 'TO',
		altitude: 473
	},
	{
		zip: '12050',
		name: 'Castagnito',
		province: 'CN',
		altitude: 350
	},
	{
		zip: '14030',
		name: 'Castagnole Monferrato',
		province: 'AT',
		altitude: 232
	},
	{
		zip: '10060',
		name: 'Castagnole Piemonte',
		province: 'TO',
		altitude: 244
	},
	{
		zip: '14054',
		name: 'Castagnole delle Lanze',
		province: 'AT',
		altitude: 271
	},
	{
		zip: '27040',
		name: 'Castana',
		province: 'PV',
		altitude: 290
	},
	{
		zip: '20022',
		name: 'Castano Primo',
		province: 'MI',
		altitude: 182
	},
	{
		zip: '27045',
		name: 'Casteggio',
		province: 'PV',
		altitude: 90
	},
	{
		zip: '25045',
		name: 'Castegnato',
		province: 'BS',
		altitude: 143
	},
	{
		zip: '36020',
		name: 'Castegnero',
		province: 'VI',
		altitude: 22
	},
	{
		zip: '83040',
		name: 'Castel Baronia',
		province: 'AV',
		altitude: 639
	},
	{
		zip: '14040',
		name: 'Castel Boglione',
		province: 'AT',
		altitude: 260
	},
	{
		zip: '48014',
		name: 'Castel Bolognese',
		province: 'RA',
		altitude: 42
	},
	{
		zip: '81010',
		name: 'Castel Campagnano',
		province: 'CE',
		altitude: 58
	},
	{
		zip: '64030',
		name: 'Castel Castagna',
		province: 'TE',
		altitude: 452
	},
	{
		zip: '38082',
		name: 'Castel Condino',
		province: 'TN',
		altitude: 811
	},
	{
		zip: '52016',
		name: 'Castel Focognano',
		province: 'AR',
		altitude: 310
	},
	{
		zip: '66032',
		name: 'Castel Frentano',
		province: 'CH',
		altitude: 399
	},
	{
		zip: '26010',
		name: 'Castel Gabbiano',
		province: 'CR',
		altitude: 100
	},
	{
		zip: '00073',
		name: 'Castel Gandolfo',
		province: 'RM',
		altitude: 426
	},
	{
		zip: '05013',
		name: 'Castel Giorgio',
		province: 'TR',
		altitude: 559
	},
	{
		zip: '46042',
		name: 'Castel Goffredo',
		province: 'MN',
		altitude: 53
	},
	{
		zip: '40023',
		name: 'Castel Guelfo di Bologna',
		province: 'BO',
		altitude: 32
	},
	{
		zip: '38059',
		name: 'Castel Ivano',
		province: 'TN',
		altitude: 506
	},
	{
		zip: '00024',
		name: 'Castel Madama',
		province: 'RM',
		altitude: 428
	},
	{
		zip: '40013',
		name: 'Castel Maggiore',
		province: 'BO',
		altitude: 29
	},
	{
		zip: '25030',
		name: 'Castel Mella',
		province: 'BS',
		altitude: 106
	},
	{
		zip: '81020',
		name: 'Castel Morrone',
		province: 'CE',
		altitude: 251
	},
	{
		zip: '06044',
		name: 'Castel Ritaldi',
		province: 'PG',
		altitude: 297
	},
	{
		zip: '14040',
		name: 'Castel Rocchero',
		province: 'AT',
		altitude: 414
	},
	{
		zip: '24040',
		name: 'Castel Rozzone',
		province: 'BG',
		altitude: 140
	},
	{
		zip: '84083',
		name: 'Castel San Giorgio',
		province: 'SA',
		altitude: 90
	},
	{
		zip: '29015',
		name: 'Castel San Giovanni',
		province: 'PC',
		altitude: 74
	},
	{
		zip: '84049',
		name: 'Castel San Lorenzo',
		province: 'SA',
		altitude: 358
	},
	{
		zip: '52018',
		name: 'Castel San Niccolo',
		province: 'AR',
		altitude: 380
	},
	{
		zip: '00030',
		name: 'Castel San Pietro Romano',
		province: 'RM',
		altitude: 763
	},
	{
		zip: '40024',
		name: 'Castel San Pietro Terme',
		province: 'BO',
		altitude: 75
	},
	{
		zip: '86071',
		name: 'Castel San Vincenzo',
		province: 'IS',
		altitude: 749
	},
	{
		zip: '02010',
		name: 'Castel Sant\'\'Angelo',
		province: 'RI',
		altitude: 581
	},
	{
		zip: '01030',
		name: 'Castel Sant\'\'Elia',
		province: 'VT',
		altitude: 210
	},
	{
		zip: '05014',
		name: 'Castel Viscardo',
		province: 'TR',
		altitude: 507
	},
	{
		zip: '18030',
		name: 'Castel Vittorio',
		province: 'IM',
		altitude: 420
	},
	{
		zip: '81030',
		name: 'Castel Volturno',
		province: 'CE',
		altitude: 3
	},
	{
		zip: '40034',
		name: 'Castel d\'\'Aiano',
		province: 'BO',
		altitude: 805
	},
	{
		zip: '46033',
		name: 'Castel d\'\'Ario',
		province: 'MN',
		altitude: 24
	},
	{
		zip: '37060',
		name: 'Castel d\'\'Azzano',
		province: 'VR',
		altitude: 44
	},
	{
		zip: '86080',
		name: 'Castel del Giudice',
		province: 'IS',
		altitude: 800
	},
	{
		zip: '67023',
		name: 'Castel del Monte',
		province: 'AQ',
		altitude: 1346
	},
	{
		zip: '58033',
		name: 'Castel del Piano',
		province: 'GR',
		altitude: 637
	},
	{
		zip: '40022',
		name: 'Castel del Rio',
		province: 'BO',
		altitude: 215
	},
	{
		zip: '40030',
		name: 'Castel di Casio',
		province: 'BO',
		altitude: 533
	},
	{
		zip: '67020',
		name: 'Castel di Ieri',
		province: 'AQ',
		altitude: 519
	},
	{
		zip: '95040',
		name: 'Castel di Iudica',
		province: 'CT',
		altitude: 475
	},
	{
		zip: '63082',
		name: 'Castel di Lama',
		province: 'AP',
		altitude: 201
	},
	{
		zip: '98070',
		name: 'Castel di Lucio',
		province: 'ME',
		altitude: 753
	},
	{
		zip: '67031',
		name: 'Castel di Sangro',
		province: 'AQ',
		altitude: 793
	},
	{
		zip: '81040',
		name: 'Castel di Sasso',
		province: 'CE',
		altitude: 200
	},
	{
		zip: '02020',
		name: 'Castel di Tora',
		province: 'RI',
		altitude: 607
	},
	{
		zip: '35040',
		name: 'Castelbaldo',
		province: 'PD',
		altitude: 12
	},
	{
		zip: '46032',
		name: 'Castelbelforte',
		province: 'MN',
		altitude: 27
	},
	{
		zip: '60030',
		name: 'Castelbellino',
		province: 'AN',
		altitude: 261
	},
	{
		zip: '39020',
		name: 'Castelbello-Ciardes',
		province: 'BZ',
		altitude: 587
	},
	{
		zip: '17030',
		name: 'Castelbianco',
		province: 'SV',
		altitude: 341
	},
	{
		zip: '86030',
		name: 'Castelbottaccio',
		province: 'CB',
		altitude: 617
	},
	{
		zip: '90013',
		name: 'Castelbuono',
		province: 'PA',
		altitude: 423
	},
	{
		zip: '84020',
		name: 'Castelcivita',
		province: 'SA',
		altitude: 487
	},
	{
		zip: '25030',
		name: 'Castelcovati',
		province: 'BS',
		altitude: 121
	},
	{
		zip: '31030',
		name: 'Castelcucco',
		province: 'TV',
		altitude: 189
	},
	{
		zip: '90014',
		name: 'Casteldaccia',
		province: 'PA',
		altitude: 79
	},
	{
		zip: '47861',
		name: 'Casteldelci',
		province: 'RN',
		altitude: 618
	},
	{
		zip: '12020',
		name: 'Casteldelfino',
		province: 'CN',
		altitude: 1296
	},
	{
		zip: '26030',
		name: 'Casteldidone',
		province: 'CR',
		altitude: 27
	},
	{
		zip: '60022',
		name: 'Castelfidardo',
		province: 'AN',
		altitude: 199
	},
	{
		zip: '50051',
		name: 'Castelfiorentino',
		province: 'FI',
		altitude: 50
	},
	{
		zip: '04021',
		name: 'Castelforte',
		province: 'LT',
		altitude: 162
	},
	{
		zip: '83040',
		name: 'Castelfranci',
		province: 'AV',
		altitude: 450
	},
	{
		zip: '41013',
		name: 'Castelfranco Emilia',
		province: 'MO',
		altitude: 42
	},
	{
		zip: '52026',
		name: 'Castelfranco Piandisco',
		province: 'AR',
		altitude: 281
	},
	{
		zip: '31033',
		name: 'Castelfranco Veneto',
		province: 'TV',
		altitude: 43
	},
	{
		zip: '56022',
		name: 'Castelfranco di Sotto',
		province: 'PI',
		altitude: 16
	},
	{
		zip: '82022',
		name: 'Castelfranco in Miscano',
		province: 'BN',
		altitude: 760
	},
	{
		zip: '36070',
		name: 'Castelgomberto',
		province: 'VI',
		altitude: 145
	},
	{
		zip: '85050',
		name: 'Castelgrande',
		province: 'PZ',
		altitude: 950
	},
	{
		zip: '45020',
		name: 'Castelguglielmo',
		province: 'RO',
		altitude: 9
	},
	{
		zip: '66040',
		name: 'Castelguidone',
		province: 'CH',
		altitude: 775
	},
	{
		zip: '14033',
		name: 'Castell\'\'Alfero',
		province: 'AT',
		altitude: 235
	},
	{
		zip: '29014',
		name: 'Castell\'\'Arquato',
		province: 'PC',
		altitude: 224
	},
	{
		zip: '58034',
		name: 'Castell\'\'Azzara',
		province: 'GR',
		altitude: 815
	},
	{
		zip: '98070',
		name: 'Castell\'\'Umberto',
		province: 'ME',
		altitude: 660
	},
	{
		zip: '84048',
		name: 'Castellabate',
		province: 'SA',
		altitude: 278
	},
	{
		zip: '67050',
		name: 'Castellafiume',
		province: 'AQ',
		altitude: 840
	},
	{
		zip: '64020',
		name: 'Castellalto',
		province: 'TE',
		altitude: 492
	},
	{
		zip: '91014',
		name: 'Castellammare del Golfo',
		province: 'TP',
		altitude: 26
	},
	{
		zip: '80053',
		name: 'Castellammare di Stabia',
		province: 'NA',
		altitude: 6
	},
	{
		zip: '10081',
		name: 'Castellamonte',
		province: 'TO',
		altitude: 34317
	},
	{
		zip: '70013',
		name: 'Castellana Grotte',
		province: 'BA',
		altitude: 290
	},
	{
		zip: '90020',
		name: 'Castellana Sicula',
		province: 'PA',
		altitude: 765
	},
	{
		zip: '74011',
		name: 'Castellaneta',
		province: 'TA',
		altitude: 245
	},
	{
		zip: '15051',
		name: 'Castellania Coppi',
		province: 'AL',
		altitude: 400
	},
	{
		zip: '21053',
		name: 'Castellanza',
		province: 'VA',
		altitude: 216
	},
	{
		zip: '15050',
		name: 'Castellar Guidobono',
		province: 'AL',
		altitude: 144
	},
	{
		zip: '42014',
		name: 'Castellarano',
		province: 'RE',
		altitude: 149
	},
	{
		zip: '18011',
		name: 'Castellaro',
		province: 'IM',
		altitude: 275
	},
	{
		zip: '15073',
		name: 'Castellazzo Bormida',
		province: 'AL',
		altitude: 104
	},
	{
		zip: '28060',
		name: 'Castellazzo Novarese',
		province: 'NO',
		altitude: 182
	},
	{
		zip: '26012',
		name: 'Castelleone',
		province: 'CR',
		altitude: 66
	},
	{
		zip: '60010',
		name: 'Castelleone di Suasa',
		province: 'AN',
		altitude: 206
	},
	{
		zip: '14011',
		name: 'Castellero',
		province: 'AT',
		altitude: 247
	},
	{
		zip: '13851',
		name: 'Castelletto Cervo',
		province: 'BI',
		altitude: 216
	},
	{
		zip: '15020',
		name: 'Castelletto Merli',
		province: 'AL',
		altitude: 268
	},
	{
		zip: '14040',
		name: 'Castelletto Molina',
		province: 'AT',
		altitude: 227
	},
	{
		zip: '15040',
		name: 'Castelletto Monferrato',
		province: 'AL',
		altitude: 197
	},
	{
		zip: '12040',
		name: 'Castelletto Stura',
		province: 'CN',
		altitude: 447
	},
	{
		zip: '12070',
		name: 'Castelletto Uzzone',
		province: 'CN',
		altitude: 425
	},
	{
		zip: '15010',
		name: 'Castelletto d\'\'Erro',
		province: 'AL',
		altitude: 544
	},
	{
		zip: '15060',
		name: 'Castelletto d\'\'Orba',
		province: 'AL',
		altitude: 200
	},
	{
		zip: '27040',
		name: 'Castelletto di Branduzzo',
		province: 'PV',
		altitude: 70
	},
	{
		zip: '28053',
		name: 'Castelletto sopra Ticino',
		province: 'NO',
		altitude: 226
	},
	{
		zip: '64041',
		name: 'Castelli',
		province: 'TE',
		altitude: 497
	},
	{
		zip: '24060',
		name: 'Castelli Calepio',
		province: 'BG',
		altitude: 233
	},
	{
		zip: '56040',
		name: 'Castellina Marittima',
		province: 'PI',
		altitude: 375
	},
	{
		zip: '53011',
		name: 'Castellina in Chianti',
		province: 'SI',
		altitude: 578
	},
	{
		zip: '12050',
		name: 'Castellinaldo d\'\'Alba',
		province: 'CN',
		altitude: 285
	},
	{
		zip: '12060',
		name: 'Castellino Tanaro',
		province: 'CN',
		altitude: 613
	},
	{
		zip: '86020',
		name: 'Castellino del Biferno',
		province: 'CB',
		altitude: 450
	},
	{
		zip: '03030',
		name: 'Castelliri',
		province: 'FR',
		altitude: 261
	},
	{
		zip: '21030',
		name: 'Castello Cabiaglio',
		province: 'VA',
		altitude: 514
	},
	{
		zip: '38053',
		name: 'Castello Tesino',
		province: 'TN',
		altitude: 871
	},
	{
		zip: '27030',
		name: 'Castello d\'\'Agogna',
		province: 'PV',
		altitude: 106
	},
	{
		zip: '40050',
		name: 'Castello d\'\'Argile',
		province: 'BO',
		altitude: 23
	},
	{
		zip: '81016',
		name: 'Castello del Matese',
		province: 'CE',
		altitude: 476
	},
	{
		zip: '23030',
		name: 'Castello dell\'\'Acqua',
		province: 'SO',
		altitude: 664
	},
	{
		zip: '14034',
		name: 'Castello di Annone',
		province: 'AT',
		altitude: 109
	},
	{
		zip: '23884',
		name: 'Castello di Brianza',
		province: 'LC',
		altitude: 394
	},
	{
		zip: '80030',
		name: 'Castello di Cisterna',
		province: 'NA',
		altitude: 34
	},
	{
		zip: '31030',
		name: 'Castello di Godego',
		province: 'TV',
		altitude: 51
	},
	{
		zip: '38030',
		name: 'Castello-Molina di Fiemme',
		province: 'TN',
		altitude: 963
	},
	{
		zip: '46014',
		name: 'Castellucchio',
		province: 'MN',
		altitude: 26
	},
	{
		zip: '85040',
		name: 'Castelluccio Inferiore',
		province: 'PZ',
		altitude: 495
	},
	{
		zip: '85040',
		name: 'Castelluccio Superiore',
		province: 'PZ',
		altitude: 680
	},
	{
		zip: '71020',
		name: 'Castelluccio Valmaggiore',
		province: 'FG',
		altitude: 630
	},
	{
		zip: '71025',
		name: 'Castelluccio dei Sauri',
		province: 'FG',
		altitude: 284
	},
	{
		zip: '12020',
		name: 'Castelmagno',
		province: 'CN',
		altitude: 1141
	},
	{
		zip: '22030',
		name: 'Castelmarte',
		province: 'CO',
		altitude: 459
	},
	{
		zip: '45035',
		name: 'Castelmassa',
		province: 'RO',
		altitude: 12
	},
	{
		zip: '86031',
		name: 'Castelmauro',
		province: 'CB',
		altitude: 692
	},
	{
		zip: '85010',
		name: 'Castelmezzano',
		province: 'PZ',
		altitude: 750
	},
	{
		zip: '98030',
		name: 'Castelmola',
		province: 'ME',
		altitude: 529
	},
	{
		zip: '27030',
		name: 'Castelnovetto',
		province: 'PV',
		altitude: 111
	},
	{
		zip: '45030',
		name: 'Castelnovo Bariano',
		province: 'RO',
		altitude: 12
	},
	{
		zip: '33090',
		name: 'Castelnovo del Friuli',
		province: 'PN',
		altitude: 234
	},
	{
		zip: '42024',
		name: 'Castelnovo di Sotto',
		province: 'RE',
		altitude: 23
	},
	{
		zip: '42035',
		name: 'Castelnovo ne Monti',
		province: 'RE',
		altitude: 750
	},
	{
		zip: '38050',
		name: 'Castelnuovo',
		province: 'TN',
		altitude: 348
	},
	{
		zip: '14043',
		name: 'Castelnuovo Belbo',
		province: 'AT',
		altitude: 122
	},
	{
		zip: '53019',
		name: 'Castelnuovo Berardenga',
		province: 'SI',
		altitude: 351
	},
	{
		zip: '26843',
		name: 'Castelnuovo Bocca d\'\'Adda',
		province: 'LO',
		altitude: 49
	},
	{
		zip: '15017',
		name: 'Castelnuovo Bormida',
		province: 'AL',
		altitude: 123
	},
	{
		zip: '22070',
		name: 'Castelnuovo Bozzente',
		province: 'CO',
		altitude: 398
	},
	{
		zip: '14040',
		name: 'Castelnuovo Calcea',
		province: 'AT',
		altitude: 246
	},
	{
		zip: '84040',
		name: 'Castelnuovo Cilento',
		province: 'SA',
		altitude: 280
	},
	{
		zip: '14022',
		name: 'Castelnuovo Don Bosco',
		province: 'AT',
		altitude: 245
	},
	{
		zip: '19033',
		name: 'Castelnuovo Magra',
		province: 'SP',
		altitude: 181
	},
	{
		zip: '10080',
		name: 'Castelnuovo Nigra',
		province: 'TO',
		altitude: 828
	},
	{
		zip: '03040',
		name: 'Castelnuovo Parano',
		province: 'FR',
		altitude: 310
	},
	{
		zip: '41051',
		name: 'Castelnuovo Rangone',
		province: 'MO',
		altitude: 76
	},
	{
		zip: '15053',
		name: 'Castelnuovo Scrivia',
		province: 'AL',
		altitude: 85
	},
	{
		zip: '37014',
		name: 'Castelnuovo del Garda',
		province: 'VR',
		altitude: 130
	},
	{
		zip: '71034',
		name: 'Castelnuovo della Daunia',
		province: 'FG',
		altitude: 543
	},
	{
		zip: '12070',
		name: 'Castelnuovo di Ceva',
		province: 'CN',
		altitude: 743
	},
	{
		zip: '84020',
		name: 'Castelnuovo di Conza',
		province: 'SA',
		altitude: 650
	},
	{
		zip: '02031',
		name: 'Castelnuovo di Farfa',
		province: 'RI',
		altitude: 358
	},
	{
		zip: '55032',
		name: 'Castelnuovo di Garfagnana',
		province: 'LU',
		altitude: 270
	},
	{
		zip: '00060',
		name: 'Castelnuovo di Porto',
		province: 'RM',
		altitude: 250
	},
	{
		zip: '56041',
		name: 'Castelnuovo di Val di Cecina',
		province: 'PI',
		altitude: 576
	},
	{
		zip: '82024',
		name: 'Castelpagano',
		province: 'BN',
		altitude: 630
	},
	{
		zip: '86090',
		name: 'Castelpetroso',
		province: 'IS',
		altitude: 872
	},
	{
		zip: '86090',
		name: 'Castelpizzuto',
		province: 'IS',
		altitude: 836
	},
	{
		zip: '60031',
		name: 'Castelplanio',
		province: 'AN',
		altitude: 305
	},
	{
		zip: '82030',
		name: 'Castelpoto',
		province: 'BN',
		altitude: 293
	},
	{
		zip: '62022',
		name: 'Castelraimondo',
		province: 'MC',
		altitude: 307
	},
	{
		zip: '39040',
		name: 'Castelrotto',
		province: 'BZ',
		altitude: 1060
	},
	{
		zip: '62039',
		name: 'Castelsantangelo sul Nera',
		province: 'MC',
		altitude: 780
	},
	{
		zip: '85031',
		name: 'Castelsaraceno',
		province: 'PZ',
		altitude: 916
	},
	{
		zip: '07031',
		name: 'Castelsardo',
		province: 'SS',
		altitude: 114
	},
	{
		zip: '21050',
		name: 'Castelseprio',
		province: 'VA',
		altitude: 310
	},
	{
		zip: '88834',
		name: 'Castelsilano',
		province: 'KR',
		altitude: 900
	},
	{
		zip: '15070',
		name: 'Castelspina',
		province: 'AL',
		altitude: 116
	},
	{
		zip: '92025',
		name: 'Casteltermini',
		province: 'AG',
		altitude: 555
	},
	{
		zip: '21010',
		name: 'Castelveccana',
		province: 'VA',
		altitude: 257
	},
	{
		zip: '67020',
		name: 'Castelvecchio Calvisio',
		province: 'AQ',
		altitude: 1045
	},
	{
		zip: '67024',
		name: 'Castelvecchio Subequo',
		province: 'AQ',
		altitude: 490
	},
	{
		zip: '17034',
		name: 'Castelvecchio di Rocca Barbena',
		province: 'SV',
		altitude: 420
	},
	{
		zip: '82030',
		name: 'Castelvenere',
		province: 'BN',
		altitude: 119
	},
	{
		zip: '26022',
		name: 'Castelverde',
		province: 'CR',
		altitude: 52
	},
	{
		zip: '86080',
		name: 'Castelverrino',
		province: 'IS',
		altitude: 600
	},
	{
		zip: '82023',
		name: 'Castelvetere in Val Fortore',
		province: 'BN',
		altitude: 706
	},
	{
		zip: '83040',
		name: 'Castelvetere sul Calore',
		province: 'AV',
		altitude: 750
	},
	{
		zip: '91022',
		name: 'Castelvetrano',
		province: 'TP',
		altitude: 187
	},
	{
		zip: '29010',
		name: 'Castelvetro Piacentino',
		province: 'PC',
		altitude: 39
	},
	{
		zip: '41014',
		name: 'Castelvetro di Modena',
		province: 'MO',
		altitude: 157
	},
	{
		zip: '26010',
		name: 'Castelvisconti',
		province: 'CR',
		altitude: 66
	},
	{
		zip: '40055',
		name: 'Castenaso',
		province: 'BO',
		altitude: 42
	},
	{
		zip: '25014',
		name: 'Castenedolo',
		province: 'BS',
		altitude: 152
	},
	{
		zip: '09040',
		name: 'Castiadas',
		province: 'SU',
		altitude: 60
	},
	{
		zip: '52029',
		name: 'Castiglion Fibocchi',
		province: 'AR',
		altitude: 300
	},
	{
		zip: '52043',
		name: 'Castiglion Fiorentino',
		province: 'AR',
		altitude: 342
	},
	{
		zip: '16030',
		name: 'Castiglione Chiavarese',
		province: 'GE',
		altitude: 271
	},
	{
		zip: '87040',
		name: 'Castiglione Cosentino',
		province: 'CS',
		altitude: 384
	},
	{
		zip: '12060',
		name: 'Castiglione Falletto',
		province: 'CN',
		altitude: 350
	},
	{
		zip: '66033',
		name: 'Castiglione Messer Marino',
		province: 'CH',
		altitude: 1081
	},
	{
		zip: '64034',
		name: 'Castiglione Messer Raimondo',
		province: 'TE',
		altitude: 306
	},
	{
		zip: '21043',
		name: 'Castiglione Olona',
		province: 'VA',
		altitude: 307
	},
	{
		zip: '12053',
		name: 'Castiglione Tinella',
		province: 'CN',
		altitude: 408
	},
	{
		zip: '10090',
		name: 'Castiglione Torinese',
		province: 'TO',
		altitude: 304
	},
	{
		zip: '65020',
		name: 'Castiglione a Casauria',
		province: 'PE',
		altitude: 350
	},
	{
		zip: '26823',
		name: 'Castiglione d\'\'Adda',
		province: 'LO',
		altitude: 60
	},
	{
		zip: '53023',
		name: 'Castiglione d\'\'Orcia',
		province: 'SI',
		altitude: 540
	},
	{
		zip: '40035',
		name: 'Castiglione dei Pepoli',
		province: 'BO',
		altitude: 691
	},
	{
		zip: '84090',
		name: 'Castiglione del Genovesi',
		province: 'SA',
		altitude: 598
	},
	{
		zip: '06061',
		name: 'Castiglione del Lago',
		province: 'PG',
		altitude: 304
	},
	{
		zip: '58043',
		name: 'Castiglione della Pescaia',
		province: 'GR',
		altitude: 4
	},
	{
		zip: '46043',
		name: 'Castiglione delle Stiviere',
		province: 'MN',
		altitude: 116
	},
	{
		zip: '55033',
		name: 'Castiglione di Garfagnana',
		province: 'LU',
		altitude: 545
	},
	{
		zip: '95012',
		name: 'Castiglione di Sicilia',
		province: 'CT',
		altitude: 621
	},
	{
		zip: '01024',
		name: 'Castiglione in Teverina',
		province: 'VT',
		altitude: 228
	},
	{
		zip: '63072',
		name: 'Castignano',
		province: 'AP',
		altitude: 473
	},
	{
		zip: '64035',
		name: 'Castilenti',
		province: 'TE',
		altitude: 272
	},
	{
		zip: '12050',
		name: 'Castino',
		province: 'CN',
		altitude: 540
	},
	{
		zip: '23012',
		name: 'Castione Andevenno',
		province: 'SO',
		altitude: 468
	},
	{
		zip: '24020',
		name: 'Castione della Presolana',
		province: 'BG',
		altitude: 870
	},
	{
		zip: '33050',
		name: 'Castions di Strada',
		province: 'UD',
		altitude: 23
	},
	{
		zip: '26866',
		name: 'Castiraga Vidardo',
		province: 'LO',
		altitude: 74
	},
	{
		zip: '25070',
		name: 'Casto',
		province: 'BS',
		altitude: 417
	},
	{
		zip: '63081',
		name: 'Castorano',
		province: 'AP',
		altitude: 279
	},
	{
		zip: '25030',
		name: 'Castrezzato',
		province: 'BS',
		altitude: 125
	},
	{
		zip: '73020',
		name: 'Castri di Lecce',
		province: 'LE',
		altitude: 47
	},
	{
		zip: '73020',
		name: 'Castrignano de Greci',
		province: 'LE',
		altitude: 90
	},
	{
		zip: '73040',
		name: 'Castrignano del Capo',
		province: 'LE',
		altitude: 121
	},
	{
		zip: '03020',
		name: 'Castro dei Volsci',
		province: 'FR',
		altitude: 385
	},
	{
		zip: '47011',
		name: 'Castrocaro Terme e Terra del Sole',
		province: 'FC',
		altitude: 68
	},
	{
		zip: '03030',
		name: 'Castrocielo',
		province: 'FR',
		altitude: 250
	},
	{
		zip: '92020',
		name: 'Castrofilippo',
		province: 'AG',
		altitude: 470
	},
	{
		zip: '87040',
		name: 'Castrolibero',
		province: 'CS',
		altitude: 559
	},
	{
		zip: '21040',
		name: 'Castronno',
		province: 'VA',
		altitude: 325
	},
	{
		zip: '90030',
		name: 'Castronovo di Sicilia',
		province: 'PA',
		altitude: 660
	},
	{
		zip: '85030',
		name: 'Castronuovo di Sant\'\'Andrea',
		province: 'PZ',
		altitude: 650
	},
	{
		zip: '86010',
		name: 'Castropignano',
		province: 'CB',
		altitude: 590
	},
	{
		zip: '98053',
		name: 'Castroreale',
		province: 'ME',
		altitude: 394
	},
	{
		zip: '87070',
		name: 'Castroregio',
		province: 'CS',
		altitude: 819
	},
	{
		zip: '87012',
		name: 'Castrovillari',
		province: 'CS',
		altitude: 362
	},
	{
		zip: '95121',
		name: 'Catania',
		province: 'CT',
		altitude: 7
	},
	{
		zip: '88100',
		name: 'Catanzaro',
		province: 'CZ',
		altitude: 320
	},
	{
		zip: '94010',
		name: 'Catenanuova',
		province: 'EN',
		altitude: 170
	},
	{
		zip: '65011',
		name: 'Catignano',
		province: 'PE',
		altitude: 365
	},
	{
		zip: '47841',
		name: 'Cattolica',
		province: 'RN',
		altitude: 12
	},
	{
		zip: '92011',
		name: 'Cattolica Eraclea',
		province: 'AG',
		altitude: 220
	},
	{
		zip: '89041',
		name: 'Caulonia',
		province: 'RC',
		altitude: 300
	},
	{
		zip: '82030',
		name: 'Cautano',
		province: 'BN',
		altitude: 385
	},
	{
		zip: '27051',
		name: 'Cava Manara',
		province: 'PV',
		altitude: 79
	},
	{
		zip: '84013',
		name: 'Cava de Tirreni',
		province: 'SA',
		altitude: 180
	},
	{
		zip: '28010',
		name: 'Cavaglietto',
		province: 'NO',
		altitude: 233
	},
	{
		zip: '28010',
		name: 'Cavaglio d\'\'Agogna',
		province: 'NO',
		altitude: 243
	},
	{
		zip: '13881',
		name: 'Cavaglia',
		province: 'BI',
		altitude: 271
	},
	{
		zip: '10020',
		name: 'Cavagnolo',
		province: 'TO',
		altitude: 177
	},
	{
		zip: '37010',
		name: 'Cavaion Veronese',
		province: 'VR',
		altitude: 190
	},
	{
		zip: '38033',
		name: 'Cavalese',
		province: 'TN',
		altitude: 1000
	},
	{
		zip: '12030',
		name: 'Cavallerleone',
		province: 'CN',
		altitude: 270
	},
	{
		zip: '12030',
		name: 'Cavallermaggiore',
		province: 'CN',
		altitude: 285
	},
	{
		zip: '73020',
		name: 'Cavallino',
		province: 'LE',
		altitude: 38
	},
	{
		zip: '30013',
		name: 'Cavallino-Treporti',
		province: 'VE',
		altitude: 2
	},
	{
		zip: '28010',
		name: 'Cavallirio',
		province: 'NO',
		altitude: 367
	},
	{
		zip: '38011',
		name: 'Cavareno',
		province: 'TN',
		altitude: 983
	},
	{
		zip: '22010',
		name: 'Cavargna',
		province: 'CO',
		altitude: 1071
	},
	{
		zip: '21044',
		name: 'Cavaria con Premezzo',
		province: 'VA',
		altitude: 268
	},
	{
		zip: '30014',
		name: 'Cavarzere',
		province: 'VE',
		altitude: 4
	},
	{
		zip: '31034',
		name: 'Cavaso del Tomba',
		province: 'TV',
		altitude: 248
	},
	{
		zip: '33092',
		name: 'Cavasso Nuovo',
		province: 'PN',
		altitude: 285
	},
	{
		zip: '15010',
		name: 'Cavatore',
		province: 'AL',
		altitude: 516
	},
	{
		zip: '33020',
		name: 'Cavazzo Carnico',
		province: 'UD',
		altitude: 290
	},
	{
		zip: '00033',
		name: 'Cave',
		province: 'RM',
		altitude: 399
	},
	{
		zip: '38010',
		name: 'Cavedago',
		province: 'TN',
		altitude: 864
	},
	{
		zip: '38073',
		name: 'Cavedine',
		province: 'TN',
		altitude: 504
	},
	{
		zip: '26824',
		name: 'Cavenago d\'\'Adda',
		province: 'LO',
		altitude: 73
	},
	{
		zip: '20873',
		name: 'Cavenago di Brianza',
		province: 'MB',
		altitude: 176
	},
	{
		zip: '24050',
		name: 'Cavernago',
		province: 'BG',
		altitude: 199
	},
	{
		zip: '41032',
		name: 'Cavezzo',
		province: 'MO',
		altitude: 22
	},
	{
		zip: '38022',
		name: 'Cavizzana',
		province: 'TN',
		altitude: 710
	},
	{
		zip: '10061',
		name: 'Cavour',
		province: 'TO',
		altitude: 300
	},
	{
		zip: '42025',
		name: 'Cavriago',
		province: 'RE',
		altitude: 78
	},
	{
		zip: '46040',
		name: 'Cavriana',
		province: 'MN',
		altitude: 170
	},
	{
		zip: '52022',
		name: 'Cavriglia',
		province: 'AR',
		altitude: 308
	},
	{
		zip: '21020',
		name: 'Cazzago Brabbia',
		province: 'VA',
		altitude: 265
	},
	{
		zip: '25046',
		name: 'Cazzago San Martino',
		province: 'BS',
		altitude: 200
	},
	{
		zip: '24026',
		name: 'Cazzano Sant\'\'Andrea',
		province: 'BG',
		altitude: 504
	},
	{
		zip: '37030',
		name: 'Cazzano di Tramigna',
		province: 'VR',
		altitude: 100
	},
	{
		zip: '03023',
		name: 'Ceccano',
		province: 'FR',
		altitude: 200
	},
	{
		zip: '27050',
		name: 'Cecima',
		province: 'PV',
		altitude: 331
	},
	{
		zip: '57023',
		name: 'Cecina',
		province: 'LI',
		altitude: 15
	},
	{
		zip: '25051',
		name: 'Cedegolo',
		province: 'BS',
		altitude: 413
	},
	{
		zip: '23010',
		name: 'Cedrasco',
		province: 'SO',
		altitude: 287
	},
	{
		zip: '90030',
		name: 'Cefala Diana',
		province: 'PA',
		altitude: 563
	},
	{
		zip: '90015',
		name: 'Cefalu',
		province: 'PA',
		altitude: 16
	},
	{
		zip: '30022',
		name: 'Ceggia',
		province: 'VE',
		altitude: 2
	},
	{
		zip: '72013',
		name: 'Ceglie Messapica',
		province: 'BR',
		altitude: 298
	},
	{
		zip: '67043',
		name: 'Celano',
		province: 'AQ',
		altitude: 800
	},
	{
		zip: '71035',
		name: 'Celenza Valfortore',
		province: 'FG',
		altitude: 480
	},
	{
		zip: '66050',
		name: 'Celenza sul Trigno',
		province: 'CH',
		altitude: 646
	},
	{
		zip: '87053',
		name: 'Celico',
		province: 'CS',
		altitude: 750
	},
	{
		zip: '26040',
		name: 'Cella Dati',
		province: 'CR',
		altitude: 34
	},
	{
		zip: '15034',
		name: 'Cella Monte',
		province: 'AL',
		altitude: 268
	},
	{
		zip: '70010',
		name: 'Cellamare',
		province: 'BA',
		altitude: 110
	},
	{
		zip: '87050',
		name: 'Cellara',
		province: 'CS',
		altitude: 750
	},
	{
		zip: '14010',
		name: 'Cellarengo',
		province: 'AT',
		altitude: 321
	},
	{
		zip: '25060',
		name: 'Cellatica',
		province: 'BS',
		altitude: 170
	},
	{
		zip: '14010',
		name: 'Celle Enomondo',
		province: 'AT',
		altitude: 234
	},
	{
		zip: '17015',
		name: 'Celle Ligure',
		province: 'SV',
		altitude: 4
	},
	{
		zip: '84040',
		name: 'Celle di Bulgheria',
		province: 'SA',
		altitude: 234
	},
	{
		zip: '12020',
		name: 'Celle di Macra',
		province: 'CN',
		altitude: 1270
	},
	{
		zip: '71020',
		name: 'Celle di San Vito',
		province: 'FG',
		altitude: 726
	},
	{
		zip: '01020',
		name: 'Celleno',
		province: 'VT',
		altitude: 407
	},
	{
		zip: '01010',
		name: 'Cellere',
		province: 'VT',
		altitude: 344
	},
	{
		zip: '64036',
		name: 'Cellino Attanasio',
		province: 'TE',
		altitude: 443
	},
	{
		zip: '72020',
		name: 'Cellino San Marco',
		province: 'BR',
		altitude: 58
	},
	{
		zip: '13024',
		name: 'Cellio con Breia',
		province: 'VC',
		altitude: 685
	},
	{
		zip: '81030',
		name: 'Cellole',
		province: 'CE',
		altitude: 17
	},
	{
		zip: '38034',
		name: 'Cembra Lisignago',
		province: 'TN',
		altitude: 666
	},
	{
		zip: '88067',
		name: 'Cenadi',
		province: 'CZ',
		altitude: 539
	},
	{
		zip: '24060',
		name: 'Cenate Sopra',
		province: 'BG',
		altitude: 330
	},
	{
		zip: '24069',
		name: 'Cenate Sotto',
		province: 'BG',
		altitude: 267
	},
	{
		zip: '32020',
		name: 'Cencenighe Agordino',
		province: 'BL',
		altitude: 773
	},
	{
		zip: '24020',
		name: 'Cene',
		province: 'BG',
		altitude: 368
	},
	{
		zip: '45030',
		name: 'Ceneselli',
		province: 'RO',
		altitude: 13
	},
	{
		zip: '17056',
		name: 'Cengio',
		province: 'SV',
		altitude: 409
	},
	{
		zip: '12044',
		name: 'Centallo',
		province: 'CN',
		altitude: 426
	},
	{
		zip: '44042',
		name: 'Cento',
		province: 'FE',
		altitude: 15
	},
	{
		zip: '84051',
		name: 'Centola',
		province: 'SA',
		altitude: 336
	},
	{
		zip: '88060',
		name: 'Centrache',
		province: 'CZ',
		altitude: 458
	},
	{
		zip: '22023',
		name: 'Centro Valle Intelvi',
		province: 'CO',
		altitude: 799
	},
	{
		zip: '94010',
		name: 'Centuripe',
		province: 'EN',
		altitude: 730
	},
	{
		zip: '65012',
		name: 'Cepagatti',
		province: 'PE',
		altitude: 145
	},
	{
		zip: '82014',
		name: 'Ceppaloni',
		province: 'BN',
		altitude: 368
	},
	{
		zip: '28875',
		name: 'Ceppo Morelli',
		province: 'VB',
		altitude: 753
	},
	{
		zip: '03024',
		name: 'Ceprano',
		province: 'FR',
		altitude: 105
	},
	{
		zip: '94010',
		name: 'Cerami',
		province: 'EN',
		altitude: 970
	},
	{
		zip: '16014',
		name: 'Ceranesi',
		province: 'GE',
		altitude: 80
	},
	{
		zip: '28065',
		name: 'Cerano',
		province: 'NO',
		altitude: 127
	},
	{
		zip: '22020',
		name: 'Cerano d\'\'Intelvi',
		province: 'CO',
		altitude: 562
	},
	{
		zip: '27010',
		name: 'Ceranova',
		province: 'PV',
		altitude: 86
	},
	{
		zip: '84052',
		name: 'Ceraso',
		province: 'SA',
		altitude: 325
	},
	{
		zip: '86012',
		name: 'Cercemaggiore',
		province: 'CB',
		altitude: 930
	},
	{
		zip: '10060',
		name: 'Cercenasco',
		province: 'TO',
		altitude: 256
	},
	{
		zip: '86010',
		name: 'Cercepiccola',
		province: 'CB',
		altitude: 680
	},
	{
		zip: '87070',
		name: 'Cerchiara di Calabria',
		province: 'CS',
		altitude: 650
	},
	{
		zip: '67044',
		name: 'Cerchio',
		province: 'AQ',
		altitude: 834
	},
	{
		zip: '23016',
		name: 'Cercino',
		province: 'SO',
		altitude: 487
	},
	{
		zip: '33020',
		name: 'Cercivento',
		province: 'UD',
		altitude: 607
	},
	{
		zip: '80040',
		name: 'Cercola',
		province: 'NA',
		altitude: 75
	},
	{
		zip: '90010',
		name: 'Cerda',
		province: 'PA',
		altitude: 272
	},
	{
		zip: '37053',
		name: 'Cerea',
		province: 'VR',
		altitude: 18
	},
	{
		zip: '45010',
		name: 'Ceregnano',
		province: 'RO',
		altitude: 5
	},
	{
		zip: '88833',
		name: 'Cerenzia',
		province: 'KR',
		altitude: 664
	},
	{
		zip: '10070',
		name: 'Ceres',
		province: 'TO',
		altitude: 704
	},
	{
		zip: '46040',
		name: 'Ceresara',
		province: 'MN',
		altitude: 44
	},
	{
		zip: '15020',
		name: 'Cereseto',
		province: 'AL',
		altitude: 280
	},
	{
		zip: '12040',
		name: 'Ceresole Alba',
		province: 'CN',
		altitude: 301
	},
	{
		zip: '10080',
		name: 'Ceresole Reale',
		province: 'TO',
		altitude: 1620
	},
	{
		zip: '24020',
		name: 'Cerete',
		province: 'BG',
		altitude: 612
	},
	{
		zip: '27030',
		name: 'Ceretto Lomellina',
		province: 'PV',
		altitude: 109
	},
	{
		zip: '27020',
		name: 'Cergnago',
		province: 'PV',
		altitude: 100
	},
	{
		zip: '17023',
		name: 'Ceriale',
		province: 'SV',
		altitude: 10
	},
	{
		zip: '18034',
		name: 'Ceriana',
		province: 'IM',
		altitude: 369
	},
	{
		zip: '20816',
		name: 'Ceriano Laghetto',
		province: 'MB',
		altitude: 216
	},
	{
		zip: '29020',
		name: 'Cerignale',
		province: 'PC',
		altitude: 725
	},
	{
		zip: '71040',
		name: 'Cerignola',
		province: 'FG',
		altitude: 120
	},
	{
		zip: '87044',
		name: 'Cerisano',
		province: 'CS',
		altitude: 610
	},
	{
		zip: '22072',
		name: 'Cermenate',
		province: 'CO',
		altitude: 297
	},
	{
		zip: '39010',
		name: 'Cermes',
		province: 'BZ',
		altitude: 292
	},
	{
		zip: '64037',
		name: 'Cermignano',
		province: 'TE',
		altitude: 563
	},
	{
		zip: '22012',
		name: 'Cernobbio',
		province: 'CO',
		altitude: 202
	},
	{
		zip: '23870',
		name: 'Cernusco Lombardone',
		province: 'LC',
		altitude: 267
	},
	{
		zip: '20063',
		name: 'Cernusco sul Naviglio',
		province: 'MI',
		altitude: 134
	},
	{
		zip: '15050',
		name: 'Cerreto Grue',
		province: 'AL',
		altitude: 251
	},
	{
		zip: '50050',
		name: 'Cerreto Guidi',
		province: 'FI',
		altitude: 123
	},
	{
		zip: '00020',
		name: 'Cerreto Laziale',
		province: 'RM',
		altitude: 520
	},
	{
		zip: '82032',
		name: 'Cerreto Sannita',
		province: 'BN',
		altitude: 2774
	},
	{
		zip: '14020',
		name: 'Cerreto d\'\'Asti',
		province: 'AT',
		altitude: 280
	},
	{
		zip: '60043',
		name: 'Cerreto d\'\'Esi',
		province: 'AN',
		altitude: 276
	},
	{
		zip: '06040',
		name: 'Cerreto di Spoleto',
		province: 'PG',
		altitude: 557
	},
	{
		zip: '12050',
		name: 'Cerretto Langhe',
		province: 'CN',
		altitude: 687
	},
	{
		zip: '15020',
		name: 'Cerrina Monferrato',
		province: 'AL',
		altitude: 225
	},
	{
		zip: '13882',
		name: 'Cerrione',
		province: 'BI',
		altitude: 250
	},
	{
		zip: '20023',
		name: 'Cerro Maggiore',
		province: 'MI',
		altitude: 205
	},
	{
		zip: '14030',
		name: 'Cerro Tanaro',
		province: 'AT',
		altitude: 109
	},
	{
		zip: '37020',
		name: 'Cerro Veronese',
		province: 'VR',
		altitude: 730
	},
	{
		zip: '20070',
		name: 'Cerro al Lambro',
		province: 'MI',
		altitude: 84
	},
	{
		zip: '86072',
		name: 'Cerro al Volturno',
		province: 'IS',
		altitude: 572
	},
	{
		zip: '85030',
		name: 'Cersosimo',
		province: 'PZ',
		altitude: 548
	},
	{
		zip: '50052',
		name: 'Certaldo',
		province: 'FI',
		altitude: 67
	},
	{
		zip: '27012',
		name: 'Certosa di Pavia',
		province: 'PV',
		altitude: 90
	},
	{
		zip: '88050',
		name: 'Cerva',
		province: 'CZ',
		altitude: 800
	},
	{
		zip: '00020',
		name: 'Cervara di Roma',
		province: 'RM',
		altitude: 1053
	},
	{
		zip: '35030',
		name: 'Cervarese Santa Croce',
		province: 'PD',
		altitude: 21
	},
	{
		zip: '03044',
		name: 'Cervaro',
		province: 'FR',
		altitude: 250
	},
	{
		zip: '12010',
		name: 'Cervasca',
		province: 'CN',
		altitude: 578
	},
	{
		zip: '13025',
		name: 'Cervatto',
		province: 'VC',
		altitude: 1004
	},
	{
		zip: '25040',
		name: 'Cerveno',
		province: 'BS',
		altitude: 500
	},
	{
		zip: '12040',
		name: 'Cervere',
		province: 'CN',
		altitude: 304
	},
	{
		zip: '27050',
		name: 'Cervesina',
		province: 'PV',
		altitude: 72
	},
	{
		zip: '00052',
		name: 'Cerveteri',
		province: 'RM',
		altitude: 81
	},
	{
		zip: '48015',
		name: 'Cervia',
		province: 'RA',
		altitude: 5
	},
	{
		zip: '87010',
		name: 'Cervicati',
		province: 'CS',
		altitude: 485
	},
	{
		zip: '26832',
		name: 'Cervignano d\'\'Adda',
		province: 'LO',
		altitude: 87
	},
	{
		zip: '33052',
		name: 'Cervignano del Friuli',
		province: 'UD',
		altitude: 2
	},
	{
		zip: '83012',
		name: 'Cervinara',
		province: 'AV',
		altitude: 28490
	},
	{
		zip: '81023',
		name: 'Cervino',
		province: 'CE',
		altitude: 140
	},
	{
		zip: '18010',
		name: 'Cervo',
		province: 'IM',
		altitude: 66
	},
	{
		zip: '87040',
		name: 'Cerzeto',
		province: 'CS',
		altitude: 450
	},
	{
		zip: '81030',
		name: 'Cesa',
		province: 'CE',
		altitude: 40
	},
	{
		zip: '23861',
		name: 'Cesana Brianza',
		province: 'LC',
		altitude: 300
	},
	{
		zip: '10054',
		name: 'Cesana Torinese',
		province: 'TO',
		altitude: 1354
	},
	{
		zip: '20090',
		name: 'Cesano Boscone',
		province: 'MI',
		altitude: 119
	},
	{
		zip: '20811',
		name: 'Cesano Maderno',
		province: 'MB',
		altitude: 198
	},
	{
		zip: '28891',
		name: 'Cesara',
		province: 'VB',
		altitude: 499
	},
	{
		zip: '98033',
		name: 'Cesaro',
		province: 'ME',
		altitude: 1150
	},
	{
		zip: '20031',
		name: 'Cesate',
		province: 'MI',
		altitude: 192
	},
	{
		zip: '47521',
		name: 'Cesena',
		province: 'FC',
		altitude: 44
	},
	{
		zip: '47042',
		name: 'Cesenatico',
		province: 'FC',
		altitude: 2
	},
	{
		zip: '83020',
		name: 'Cesinali',
		province: 'AV',
		altitude: 380
	},
	{
		zip: '18022',
		name: 'Cesio',
		province: 'IM',
		altitude: 530
	},
	{
		zip: '32030',
		name: 'Cesiomaggiore',
		province: 'BL',
		altitude: 479
	},
	{
		zip: '31040',
		name: 'Cessalto',
		province: 'TV',
		altitude: 5
	},
	{
		zip: '89816',
		name: 'Cessaniti',
		province: 'VV',
		altitude: 428
	},
	{
		zip: '62020',
		name: 'Cessapalombo',
		province: 'MC',
		altitude: 447
	},
	{
		zip: '14050',
		name: 'Cessole',
		province: 'AT',
		altitude: 280
	},
	{
		zip: '84010',
		name: 'Cetara',
		province: 'SA',
		altitude: 10
	},
	{
		zip: '25040',
		name: 'Ceto',
		province: 'BS',
		altitude: 453
	},
	{
		zip: '53040',
		name: 'Cetona',
		province: 'SI',
		altitude: 385
	},
	{
		zip: '87022',
		name: 'Cetraro',
		province: 'CS',
		altitude: 120
	},
	{
		zip: '12073',
		name: 'Ceva',
		province: 'CN',
		altitude: 38665
	},
	{
		zip: '25040',
		name: 'Cevo',
		province: 'BS',
		altitude: 1100
	},
	{
		zip: '11020',
		name: 'Challand-Saint-Anselme',
		province: 'AO',
		altitude: 1030
	},
	{
		zip: '11020',
		name: 'Challand-Saint-Victor',
		province: 'AO',
		altitude: 744
	},
	{
		zip: '11023',
		name: 'Chambave',
		province: 'AO',
		altitude: 480
	},
	{
		zip: '11020',
		name: 'Chamois',
		province: 'AO',
		altitude: 1818
	},
	{
		zip: '11020',
		name: 'Champdepraz',
		province: 'AO',
		altitude: 512
	},
	{
		zip: '11020',
		name: 'Champorcher',
		province: 'AO',
		altitude: 1427
	},
	{
		zip: '11020',
		name: 'Charvensod',
		province: 'AO',
		altitude: 746
	},
	{
		zip: '12062',
		name: 'Cherasco',
		province: 'CN',
		altitude: 288
	},
	{
		zip: '07040',
		name: 'Cheremule',
		province: 'SS',
		altitude: 540
	},
	{
		zip: '10070',
		name: 'Chialamberto',
		province: 'TO',
		altitude: 875
	},
	{
		zip: '36072',
		name: 'Chiampo',
		province: 'VI',
		altitude: 175
	},
	{
		zip: '83010',
		name: 'Chianche',
		province: 'AV',
		altitude: 356
	},
	{
		zip: '53042',
		name: 'Chianciano Terme',
		province: 'SI',
		altitude: 475
	},
	{
		zip: '56034',
		name: 'Chianni',
		province: 'PI',
		altitude: 284
	},
	{
		zip: '10050',
		name: 'Chianocco',
		province: 'TO',
		altitude: 550
	},
	{
		zip: '97012',
		name: 'Chiaramonte Gulfi',
		province: 'RG',
		altitude: 668
	},
	{
		zip: '07030',
		name: 'Chiaramonti',
		province: 'SS',
		altitude: 430
	},
	{
		zip: '31040',
		name: 'Chiarano',
		province: 'TV',
		altitude: 6
	},
	{
		zip: '60033',
		name: 'Chiaravalle',
		province: 'AN',
		altitude: 22
	},
	{
		zip: '88064',
		name: 'Chiaravalle Centrale',
		province: 'CZ',
		altitude: 545
	},
	{
		zip: '25032',
		name: 'Chiari',
		province: 'BS',
		altitude: 138
	},
	{
		zip: '85032',
		name: 'Chiaromonte',
		province: 'PZ',
		altitude: 794
	},
	{
		zip: '86090',
		name: 'Chiauci',
		province: 'IS',
		altitude: 868
	},
	{
		zip: '16043',
		name: 'Chiavari',
		province: 'GE',
		altitude: 5
	},
	{
		zip: '23022',
		name: 'Chiavenna',
		province: 'SO',
		altitude: 333
	},
	{
		zip: '10010',
		name: 'Chiaverano',
		province: 'TO',
		altitude: 329
	},
	{
		zip: '39030',
		name: 'Chienes',
		province: 'BZ',
		altitude: 784
	},
	{
		zip: '10023',
		name: 'Chieri',
		province: 'TO',
		altitude: 283
	},
	{
		zip: '32010',
		name: 'Chies d\'\'Alpago',
		province: 'BL',
		altitude: 647
	},
	{
		zip: '23023',
		name: 'Chiesa in Valmalenco',
		province: 'SO',
		altitude: 960
	},
	{
		zip: '10080',
		name: 'Chiesanuova',
		province: 'TO',
		altitude: 664
	},
	{
		zip: '51013',
		name: 'Chiesina Uzzanese',
		province: 'PT',
		altitude: 20
	},
	{
		zip: '66100',
		name: 'Chieti',
		province: 'CH',
		altitude: 330
	},
	{
		zip: '71010',
		name: 'Chieuti',
		province: 'FG',
		altitude: 221
	},
	{
		zip: '26010',
		name: 'Chieve',
		province: 'CR',
		altitude: 77
	},
	{
		zip: '27013',
		name: 'Chignolo Po',
		province: 'PV',
		altitude: 68
	},
	{
		zip: '24040',
		name: 'Chignolo d\'\'Isola',
		province: 'BG',
		altitude: 229
	},
	{
		zip: '30015',
		name: 'Chioggia',
		province: 'VE',
		altitude: 2
	},
	{
		zip: '10050',
		name: 'Chiomonte',
		province: 'TO',
		altitude: 750
	},
	{
		zip: '33083',
		name: 'Chions',
		province: 'PN',
		altitude: 16
	},
	{
		zip: '33048',
		name: 'Chiopris-Viscone',
		province: 'UD',
		altitude: 33
	},
	{
		zip: '52010',
		name: 'Chitignano',
		province: 'AR',
		altitude: 582
	},
	{
		zip: '24060',
		name: 'Chiuduno',
		province: 'BG',
		altitude: 218
	},
	{
		zip: '36010',
		name: 'Chiuppano',
		province: 'VI',
		altitude: 230
	},
	{
		zip: '23030',
		name: 'Chiuro',
		province: 'SO',
		altitude: 389
	},
	{
		zip: '39043',
		name: 'Chiusa',
		province: 'BZ',
		altitude: 523
	},
	{
		zip: '90033',
		name: 'Chiusa Sclafani',
		province: 'PA',
		altitude: 658
	},
	{
		zip: '12013',
		name: 'Chiusa di Pesio',
		province: 'CN',
		altitude: 575
	},
	{
		zip: '10050',
		name: 'Chiusa di San Michele',
		province: 'TO',
		altitude: 378
	},
	{
		zip: '33010',
		name: 'Chiusaforte',
		province: 'UD',
		altitude: 391
	},
	{
		zip: '18027',
		name: 'Chiusanico',
		province: 'IM',
		altitude: 360
	},
	{
		zip: '14025',
		name: 'Chiusano d\'\'Asti',
		province: 'AT',
		altitude: 261
	},
	{
		zip: '83040',
		name: 'Chiusano di San Domenico',
		province: 'AV',
		altitude: 700
	},
	{
		zip: '18027',
		name: 'Chiusavecchia',
		province: 'IM',
		altitude: 140
	},
	{
		zip: '53012',
		name: 'Chiusdino',
		province: 'SI',
		altitude: 564
	},
	{
		zip: '53043',
		name: 'Chiusi',
		province: 'SI',
		altitude: 398
	},
	{
		zip: '52010',
		name: 'Chiusi della Verna',
		province: 'AR',
		altitude: 954
	},
	{
		zip: '10034',
		name: 'Chivasso',
		province: 'TO',
		altitude: 183
	},
	{
		zip: '11024',
		name: 'Châtillon',
		province: 'AO',
		altitude: 549
	},
	{
		zip: '00043',
		name: 'Ciampino',
		province: 'RM',
		altitude: 124
	},
	{
		zip: '92012',
		name: 'Cianciana',
		province: 'AG',
		altitude: 390
	},
	{
		zip: '32040',
		name: 'Cibiana di Cadore',
		province: 'BL',
		altitude: 985
	},
	{
		zip: '16044',
		name: 'Cicagna',
		province: 'GE',
		altitude: 88
	},
	{
		zip: '88040',
		name: 'Cicala',
		province: 'CZ',
		altitude: 829
	},
	{
		zip: '80033',
		name: 'Cicciano',
		province: 'NA',
		altitude: 50
	},
	{
		zip: '84053',
		name: 'Cicerale',
		province: 'SA',
		altitude: 475
	},
	{
		zip: '00020',
		name: 'Ciciliano',
		province: 'RM',
		altitude: 619
	},
	{
		zip: '26030',
		name: 'Cicognolo',
		province: 'CR',
		altitude: 44
	},
	{
		zip: '10080',
		name: 'Ciconio',
		province: 'TO',
		altitude: 273
	},
	{
		zip: '13043',
		name: 'Cigliano',
		province: 'VC',
		altitude: 237
	},
	{
		zip: '12060',
		name: 'Ciglie',
		province: 'CN',
		altitude: 549
	},
	{
		zip: '27040',
		name: 'Cigognola',
		province: 'PV',
		altitude: 309
	},
	{
		zip: '25020',
		name: 'Cigole',
		province: 'BS',
		altitude: 57
	},
	{
		zip: '27024',
		name: 'Cilavegna',
		province: 'PV',
		altitude: 115
	},
	{
		zip: '31010',
		name: 'Cimadolmo',
		province: 'TV',
		altitude: 32
	},
	{
		zip: '25050',
		name: 'Cimbergo',
		province: 'BS',
		altitude: 850
	},
	{
		zip: '90023',
		name: 'Ciminna',
		province: 'PA',
		altitude: 530
	},
	{
		zip: '89040',
		name: 'Cimina',
		province: 'RC',
		altitude: 312
	},
	{
		zip: '80030',
		name: 'Cimitile',
		province: 'NA',
		altitude: 40
	},
	{
		zip: '33080',
		name: 'Cimolais',
		province: 'PN',
		altitude: 652
	},
	{
		zip: '14020',
		name: 'Cinaglio',
		province: 'AT',
		altitude: 245
	},
	{
		zip: '00020',
		name: 'Cineto Romano',
		province: 'RM',
		altitude: 519
	},
	{
		zip: '26042',
		name: 'Cingia de Botti',
		province: 'CR',
		altitude: 31
	},
	{
		zip: '62011',
		name: 'Cingoli',
		province: 'MC',
		altitude: 631
	},
	{
		zip: '58044',
		name: 'Cinigiano',
		province: 'GR',
		altitude: 324
	},
	{
		zip: '20092',
		name: 'Cinisello Balsamo',
		province: 'MI',
		altitude: 154
	},
	{
		zip: '90045',
		name: 'Cinisi',
		province: 'PA',
		altitude: 75
	},
	{
		zip: '23010',
		name: 'Cino',
		province: 'SO',
		altitude: 504
	},
	{
		zip: '89021',
		name: 'Cinquefrondi',
		province: 'RC',
		altitude: 257
	},
	{
		zip: '10080',
		name: 'Cintano',
		province: 'TO',
		altitude: 646
	},
	{
		zip: '38050',
		name: 'Cinte Tesino',
		province: 'TN',
		altitude: 851
	},
	{
		zip: '30020',
		name: 'Cinto Caomaggiore',
		province: 'VE',
		altitude: 11
	},
	{
		zip: '35030',
		name: 'Cinto Euganeo',
		province: 'PD',
		altitude: 35
	},
	{
		zip: '10090',
		name: 'Cinzano',
		province: 'TO',
		altitude: 495
	},
	{
		zip: '81010',
		name: 'Ciorlano',
		province: 'CE',
		altitude: 330
	},
	{
		zip: '18017',
		name: 'Cipressa',
		province: 'IM',
		altitude: 240
	},
	{
		zip: '82020',
		name: 'Circello',
		province: 'BN',
		altitude: 700
	},
	{
		zip: '75010',
		name: 'Cirigliano',
		province: 'MT',
		altitude: 656
	},
	{
		zip: '22070',
		name: 'Cirimido',
		province: 'CO',
		altitude: 290
	},
	{
		zip: '10073',
		name: 'Cirie',
		province: 'TO',
		altitude: 344
	},
	{
		zip: '88813',
		name: 'Ciro',
		province: 'KR',
		altitude: 351
	},
	{
		zip: '88811',
		name: 'Ciro Marina',
		province: 'KR',
		altitude: 5
	},
	{
		zip: '38020',
		name: 'Cis',
		province: 'TN',
		altitude: 732
	},
	{
		zip: '24034',
		name: 'Cisano Bergamasco',
		province: 'BG',
		altitude: 267
	},
	{
		zip: '17035',
		name: 'Cisano sul Neva',
		province: 'SV',
		altitude: 52
	},
	{
		zip: '24040',
		name: 'Ciserano',
		province: 'BG',
		altitude: 159
	},
	{
		zip: '21040',
		name: 'Cislago',
		province: 'VA',
		altitude: 237
	},
	{
		zip: '20080',
		name: 'Cisliano',
		province: 'MI',
		altitude: 128
	},
	{
		zip: '31030',
		name: 'Cison di Valmarino',
		province: 'TV',
		altitude: 261
	},
	{
		zip: '12050',
		name: 'Cissone',
		province: 'CN',
		altitude: 661
	},
	{
		zip: '14010',
		name: 'Cisterna d\'\'Asti',
		province: 'AT',
		altitude: 350
	},
	{
		zip: '04012',
		name: 'Cisterna di Latina',
		province: 'LT',
		altitude: 77
	},
	{
		zip: '72014',
		name: 'Cisternino',
		province: 'BR',
		altitude: 394
	},
	{
		zip: '06010',
		name: 'Citerna',
		province: 'PG',
		altitude: 480
	},
	{
		zip: '35013',
		name: 'Cittadella',
		province: 'PD',
		altitude: 48
	},
	{
		zip: '02015',
		name: 'Cittaducale',
		province: 'RI',
		altitude: 481
	},
	{
		zip: '89022',
		name: 'Cittanova',
		province: 'RC',
		altitude: 400
	},
	{
		zip: '02010',
		name: 'Cittareale',
		province: 'RI',
		altitude: 962
	},
	{
		zip: '21033',
		name: 'Cittiglio',
		province: 'VA',
		altitude: 254
	},
	{
		zip: '65013',
		name: 'Citta Sant\'\'Angelo',
		province: 'PE',
		altitude: 320
	},
	{
		zip: '06062',
		name: 'Citta della Pieve',
		province: 'PG',
		altitude: 509
	},
	{
		zip: '06012',
		name: 'Citta di Castello',
		province: 'PG',
		altitude: 288
	},
	{
		zip: '23862',
		name: 'Civate',
		province: 'LC',
		altitude: 269
	},
	{
		zip: '18017',
		name: 'Civezza',
		province: 'IM',
		altitude: 225
	},
	{
		zip: '38045',
		name: 'Civezzano',
		province: 'TN',
		altitude: 469
	},
	{
		zip: '13010',
		name: 'Civiasco',
		province: 'VC',
		altitude: 716
	},
	{
		zip: '33043',
		name: 'Cividale del Friuli',
		province: 'UD',
		altitude: 135
	},
	{
		zip: '25040',
		name: 'Cividate Camuno',
		province: 'BS',
		altitude: 275
	},
	{
		zip: '24050',
		name: 'Cividate al Piano',
		province: 'BG',
		altitude: 147
	},
	{
		zip: '87010',
		name: 'Civita',
		province: 'CS',
		altitude: 450
	},
	{
		zip: '01033',
		name: 'Civita Castellana',
		province: 'VT',
		altitude: 145
	},
	{
		zip: '67050',
		name: 'Civita d\'\'Antino',
		province: 'AQ',
		altitude: 904
	},
	{
		zip: '86030',
		name: 'Civitacampomarano',
		province: 'CB',
		altitude: 520
	},
	{
		zip: '66040',
		name: 'Civitaluparella',
		province: 'CH',
		altitude: 903
	},
	{
		zip: '62012',
		name: 'Civitanova Marche',
		province: 'MC',
		altitude: 3
	},
	{
		zip: '86094',
		name: 'Civitanova del Sannio',
		province: 'IS',
		altitude: 656
	},
	{
		zip: '65010',
		name: 'Civitaquana',
		province: 'PE',
		altitude: 550
	},
	{
		zip: '00053',
		name: 'Civitavecchia',
		province: 'RM',
		altitude: 10
	},
	{
		zip: '67030',
		name: 'Civitella Alfedena',
		province: 'AQ',
		altitude: 1123
	},
	{
		zip: '65010',
		name: 'Civitella Casanova',
		province: 'PE',
		altitude: 400
	},
	{
		zip: '66010',
		name: 'Civitella Messer Raimondo',
		province: 'CH',
		altitude: 613
	},
	{
		zip: '58045',
		name: 'Civitella Paganico',
		province: 'GR',
		altitude: 329
	},
	{
		zip: '67054',
		name: 'Civitella Roveto',
		province: 'AQ',
		altitude: 528
	},
	{
		zip: '00060',
		name: 'Civitella San Paolo',
		province: 'RM',
		altitude: 195
	},
	{
		zip: '01020',
		name: 'Civitella d\'\'Agliano',
		province: 'VT',
		altitude: 262
	},
	{
		zip: '64010',
		name: 'Civitella del Tronto',
		province: 'TE',
		altitude: 589
	},
	{
		zip: '47012',
		name: 'Civitella di Romagna',
		province: 'FC',
		altitude: 219
	},
	{
		zip: '52041',
		name: 'Civitella in Val di Chiana',
		province: 'AR',
		altitude: 525
	},
	{
		zip: '23010',
		name: 'Civo',
		province: 'SO',
		altitude: 730
	},
	{
		zip: '22010',
		name: 'Claino con Osteno',
		province: 'CO',
		altitude: 280
	},
	{
		zip: '33080',
		name: 'Claut',
		province: 'PN',
		altitude: 613
	},
	{
		zip: '33090',
		name: 'Clauzetto',
		province: 'PN',
		altitude: 558
	},
	{
		zip: '12060',
		name: 'Clavesana',
		province: 'CN',
		altitude: 300
	},
	{
		zip: '10050',
		name: 'Claviere',
		province: 'TO',
		altitude: 1760
	},
	{
		zip: '38023',
		name: 'Cles',
		province: 'TN',
		altitude: 658
	},
	{
		zip: '87030',
		name: 'Cleto',
		province: 'CS',
		altitude: 250
	},
	{
		zip: '21050',
		name: 'Clivio',
		province: 'VA',
		altitude: 468
	},
	{
		zip: '24023',
		name: 'Clusone',
		province: 'BG',
		altitude: 647
	},
	{
		zip: '10070',
		name: 'Coassolo Torinese',
		province: 'TO',
		altitude: 742
	},
	{
		zip: '10050',
		name: 'Coazze',
		province: 'TO',
		altitude: 750
	},
	{
		zip: '14054',
		name: 'Coazzolo',
		province: 'AT',
		altitude: 291
	},
	{
		zip: '25030',
		name: 'Coccaglio',
		province: 'BS',
		altitude: 162
	},
	{
		zip: '14023',
		name: 'Cocconato',
		province: 'AT',
		altitude: 491
	},
	{
		zip: '21034',
		name: 'Cocquio-Trevisago',
		province: 'VA',
		altitude: 291
	},
	{
		zip: '67030',
		name: 'Cocullo',
		province: 'AQ',
		altitude: 897
	},
	{
		zip: '35020',
		name: 'Codevigo',
		province: 'PD',
		altitude: 3
	},
	{
		zip: '27050',
		name: 'Codevilla',
		province: 'PV',
		altitude: 146
	},
	{
		zip: '44021',
		name: 'Codigoro',
		province: 'FE',
		altitude: 3
	},
	{
		zip: '26845',
		name: 'Codogno',
		province: 'LO',
		altitude: 58
	},
	{
		zip: '31013',
		name: 'Codogne',
		province: 'TV',
		altitude: 26
	},
	{
		zip: '33033',
		name: 'Codroipo',
		province: 'UD',
		altitude: 43
	},
	{
		zip: '07040',
		name: 'Codrongianos',
		province: 'SS',
		altitude: 317
	},
	{
		zip: '13863',
		name: 'Coggiola',
		province: 'BI',
		altitude: 450
	},
	{
		zip: '20815',
		name: 'Cogliate',
		province: 'MB',
		altitude: 236
	},
	{
		zip: '11012',
		name: 'Cogne',
		province: 'AO',
		altitude: 1544
	},
	{
		zip: '16016',
		name: 'Cogoleto',
		province: 'GE',
		altitude: 4
	},
	{
		zip: '36010',
		name: 'Cogollo del Cengio',
		province: 'VI',
		altitude: 305
	},
	{
		zip: '16030',
		name: 'Cogorno',
		province: 'GE',
		altitude: 38
	},
	{
		zip: '28010',
		name: 'Colazza',
		province: 'NO',
		altitude: 517
	},
	{
		zip: '24020',
		name: 'Colere',
		province: 'BG',
		altitude: 1013
	},
	{
		zip: '03030',
		name: 'Colfelice',
		province: 'FR',
		altitude: 158
	},
	{
		zip: '29020',
		name: 'Coli',
		province: 'PC',
		altitude: 638
	},
	{
		zip: '23823',
		name: 'Colico',
		province: 'LC',
		altitude: 218
	},
	{
		zip: '02022',
		name: 'Collalto Sabino',
		province: 'RI',
		altitude: 980
	},
	{
		zip: '67040',
		name: 'Collarmele',
		province: 'AQ',
		altitude: 835
	},
	{
		zip: '06050',
		name: 'Collazzone',
		province: 'PG',
		altitude: 469
	},
	{
		zip: '23886',
		name: 'Colle Brianza',
		province: 'LC',
		altitude: 559
	},
	{
		zip: '03030',
		name: 'Colle San Magno',
		province: 'FR',
		altitude: 540
	},
	{
		zip: '82024',
		name: 'Colle Sannita',
		province: 'BN',
		altitude: 769
	},
	{
		zip: '32020',
		name: 'Colle Santa Lucia',
		province: 'BL',
		altitude: 1453
	},
	{
		zip: '31014',
		name: 'Colle Umberto',
		province: 'TV',
		altitude: 145
	},
	{
		zip: '86020',
		name: 'Colle d\'\'Anchise',
		province: 'CB',
		altitude: 649
	},
	{
		zip: '02020',
		name: 'Colle di Tora',
		province: 'RI',
		altitude: 542
	},
	{
		zip: '53034',
		name: 'Colle di Val d\'\'Elsa',
		province: 'SI',
		altitude: 141
	},
	{
		zip: '25060',
		name: 'Collebeato',
		province: 'BS',
		altitude: 200
	},
	{
		zip: '43044',
		name: 'Collecchio',
		province: 'PR',
		altitude: 112
	},
	{
		zip: '65010',
		name: 'Collecorvino',
		province: 'PE',
		altitude: 253
	},
	{
		zip: '64042',
		name: 'Colledara',
		province: 'TE',
		altitude: 430
	},
	{
		zip: '66010',
		name: 'Colledimacine',
		province: 'CH',
		altitude: 770
	},
	{
		zip: '66040',
		name: 'Colledimezzo',
		province: 'CH',
		altitude: 425
	},
	{
		zip: '00034',
		name: 'Colleferro',
		province: 'RM',
		altitude: 218
	},
	{
		zip: '02020',
		name: 'Collegiove',
		province: 'RI',
		altitude: 1001
	},
	{
		zip: '10093',
		name: 'Collegno',
		province: 'TO',
		altitude: 302
	},
	{
		zip: '67050',
		name: 'Collelongo',
		province: 'AQ',
		altitude: 915
	},
	{
		zip: '03010',
		name: 'Collepardo',
		province: 'FR',
		altitude: 586
	},
	{
		zip: '73040',
		name: 'Collepasso',
		province: 'LE',
		altitude: 119
	},
	{
		zip: '67020',
		name: 'Collepietro',
		province: 'AQ',
		altitude: 849
	},
	{
		zip: '10080',
		name: 'Colleretto Castelnuovo',
		province: 'TO',
		altitude: 585
	},
	{
		zip: '10010',
		name: 'Colleretto Giacosa',
		province: 'TO',
		altitude: 280
	},
	{
		zip: '57014',
		name: 'Collesalvetti',
		province: 'LI',
		altitude: 40
	},
	{
		zip: '90016',
		name: 'Collesano',
		province: 'PA',
		altitude: 468
	},
	{
		zip: '86044',
		name: 'Colletorto',
		province: 'CB',
		altitude: 515
	},
	{
		zip: '02042',
		name: 'Collevecchio',
		province: 'RI',
		altitude: 245
	},
	{
		zip: '27061',
		name: 'Colli Verdi',
		province: 'PV',
		altitude: 526
	},
	{
		zip: '86073',
		name: 'Colli a Volturno',
		province: 'IS',
		altitude: 408
	},
	{
		zip: '61036',
		name: 'Colli al Metauro',
		province: 'PU',
		altitude: 66
	},
	{
		zip: '63079',
		name: 'Colli del Tronto',
		province: 'AP',
		altitude: 168
	},
	{
		zip: '02010',
		name: 'Colli sul Velino',
		province: 'RI',
		altitude: 465
	},
	{
		zip: '84020',
		name: 'Colliano',
		province: 'SA',
		altitude: 630
	},
	{
		zip: '09020',
		name: 'Collinas',
		province: 'SU',
		altitude: 249
	},
	{
		zip: '25060',
		name: 'Collio',
		province: 'BS',
		altitude: 850
	},
	{
		zip: '13030',
		name: 'Collobiano',
		province: 'VC',
		altitude: 143
	},
	{
		zip: '33010',
		name: 'Colloredo di Monte Albano',
		province: 'UD',
		altitude: 218
	},
	{
		zip: '62020',
		name: 'Colmurano',
		province: 'MC',
		altitude: 414
	},
	{
		zip: '75021',
		name: 'Colobraro',
		province: 'MT',
		altitude: 630
	},
	{
		zip: '37044',
		name: 'Cologna Veneta',
		province: 'VR',
		altitude: 24
	},
	{
		zip: '25033',
		name: 'Cologne',
		province: 'BS',
		altitude: 187
	},
	{
		zip: '20093',
		name: 'Cologno Monzese',
		province: 'MI',
		altitude: 131
	},
	{
		zip: '24055',
		name: 'Cologno al Serio',
		province: 'BG',
		altitude: 156
	},
	{
		zip: '37030',
		name: 'Colognola ai Colli',
		province: 'VR',
		altitude: 177
	},
	{
		zip: '00030',
		name: 'Colonna',
		province: 'RM',
		altitude: 393
	},
	{
		zip: '64010',
		name: 'Colonnella',
		province: 'TE',
		altitude: 303
	},
	{
		zip: '22010',
		name: 'Colonno',
		province: 'CO',
		altitude: 215
	},
	{
		zip: '23010',
		name: 'Colorina',
		province: 'SO',
		altitude: 302
	},
	{
		zip: '43052',
		name: 'Colorno',
		province: 'PR',
		altitude: 29
	},
	{
		zip: '87050',
		name: 'Colosimi',
		province: 'CS',
		altitude: 870
	},
	{
		zip: '20075',
		name: 'Colturano',
		province: 'MI',
		altitude: 90
	},
	{
		zip: '22041',
		name: 'Colverde',
		province: 'CO',
		altitude: 412
	},
	{
		zip: '24020',
		name: 'Colzate',
		province: 'BG',
		altitude: 424
	},
	{
		zip: '21020',
		name: 'Comabbio',
		province: 'VA',
		altitude: 307
	},
	{
		zip: '44022',
		name: 'Comacchio',
		province: 'FE',
		altitude: 1
	},
	{
		zip: '54015',
		name: 'Comano',
		province: 'MS',
		altitude: 530
	},
	{
		zip: '38077',
		name: 'Comano Terme',
		province: 'TN',
		altitude: 400
	},
	{
		zip: '26833',
		name: 'Comazzo',
		province: 'LO',
		altitude: 98
	},
	{
		zip: '33023',
		name: 'Comeglians',
		province: 'UD',
		altitude: 553
	},
	{
		zip: '32040',
		name: 'Comelico Superiore',
		province: 'BL',
		altitude: 1210
	},
	{
		zip: '21025',
		name: 'Comerio',
		province: 'VA',
		altitude: 380
	},
	{
		zip: '25030',
		name: 'Comezzano-Cizzago',
		province: 'BS',
		altitude: 107
	},
	{
		zip: '28060',
		name: 'Comignago',
		province: 'NO',
		altitude: 268
	},
	{
		zip: '97013',
		name: 'Comiso',
		province: 'RG',
		altitude: 209
	},
	{
		zip: '92020',
		name: 'Comitini',
		province: 'AG',
		altitude: 350
	},
	{
		zip: '80030',
		name: 'Comiziano',
		province: 'NA',
		altitude: 73
	},
	{
		zip: '46010',
		name: 'Commessaggio',
		province: 'MN',
		altitude: 22
	},
	{
		zip: '38020',
		name: 'Commezzadura',
		province: 'TN',
		altitude: 850
	},
	{
		zip: '22100',
		name: 'Como',
		province: 'CO',
		altitude: 201
	},
	{
		zip: '43053',
		name: 'Compiano',
		province: 'PR',
		altitude: 519
	},
	{
		zip: '24040',
		name: 'Comun Nuovo',
		province: 'BG',
		altitude: 188
	},
	{
		zip: '63087',
		name: 'Comunanza',
		province: 'AP',
		altitude: 448
	},
	{
		zip: '30010',
		name: 'Cona',
		province: 'VE',
		altitude: 3
	},
	{
		zip: '86070',
		name: 'Conca Casale',
		province: 'IS',
		altitude: 657
	},
	{
		zip: '84010',
		name: 'Conca dei Marini',
		province: 'SA',
		altitude: 120
	},
	{
		zip: '81044',
		name: 'Conca della Campania',
		province: 'CE',
		altitude: 420
	},
	{
		zip: '37050',
		name: 'Concamarise',
		province: 'VR',
		altitude: 21
	},
	{
		zip: '02020',
		name: 'Concerviano',
		province: 'RI',
		altitude: 560
	},
	{
		zip: '25062',
		name: 'Concesio',
		province: 'BS',
		altitude: 216
	},
	{
		zip: '30023',
		name: 'Concordia Sagittaria',
		province: 'VE',
		altitude: 2
	},
	{
		zip: '41033',
		name: 'Concordia sulla Secchia',
		province: 'MO',
		altitude: 22
	},
	{
		zip: '20863',
		name: 'Concorezzo',
		province: 'MB',
		altitude: 171
	},
	{
		zip: '89030',
		name: 'Condofuri',
		province: 'RC',
		altitude: 339
	},
	{
		zip: '10055',
		name: 'Condove',
		province: 'TO',
		altitude: 376
	},
	{
		zip: '98040',
		name: 'Condro',
		province: 'ME',
		altitude: 58
	},
	{
		zip: '31015',
		name: 'Conegliano',
		province: 'TV',
		altitude: 72
	},
	{
		zip: '27030',
		name: 'Confienza',
		province: 'PV',
		altitude: 126
	},
	{
		zip: '02040',
		name: 'Configni',
		province: 'RI',
		altitude: 549
	},
	{
		zip: '88040',
		name: 'Conflenti',
		province: 'CZ',
		altitude: 540
	},
	{
		zip: '15030',
		name: 'Coniolo',
		province: 'AL',
		altitude: 252
	},
	{
		zip: '48017',
		name: 'Conselice',
		province: 'RA',
		altitude: 6
	},
	{
		zip: '35026',
		name: 'Conselve',
		province: 'PD',
		altitude: 7
	},
	{
		zip: '90030',
		name: 'Contessa Entellina',
		province: 'PA',
		altitude: 571
	},
	{
		zip: '02043',
		name: 'Contigliano',
		province: 'RI',
		altitude: 488
	},
	{
		zip: '83020',
		name: 'Contrada',
		province: 'AV',
		altitude: 420
	},
	{
		zip: '64010',
		name: 'Controguerra',
		province: 'TE',
		altitude: 267
	},
	{
		zip: '84020',
		name: 'Controne',
		province: 'SA',
		altitude: 200
	},
	{
		zip: '84024',
		name: 'Contursi Terme',
		province: 'SA',
		altitude: 250
	},
	{
		zip: '38093',
		name: 'Conta',
		province: 'TN',
		altitude: 593
	},
	{
		zip: '70014',
		name: 'Conversano',
		province: 'BA',
		altitude: 219
	},
	{
		zip: '83040',
		name: 'Conza della Campania',
		province: 'AV',
		altitude: 440
	},
	{
		zip: '15030',
		name: 'Conzano',
		province: 'AL',
		altitude: 262
	},
	{
		zip: '73043',
		name: 'Copertino',
		province: 'LE',
		altitude: 34
	},
	{
		zip: '27010',
		name: 'Copiano',
		province: 'PV',
		altitude: 74
	},
	{
		zip: '44034',
		name: 'Copparo',
		province: 'FE',
		altitude: 5
	},
	{
		zip: '27050',
		name: 'Corana',
		province: 'PV',
		altitude: 71
	},
	{
		zip: '70033',
		name: 'Corato',
		province: 'BA',
		altitude: 232
	},
	{
		zip: '84010',
		name: 'Corbara',
		province: 'SA',
		altitude: 167
	},
	{
		zip: '20011',
		name: 'Corbetta',
		province: 'MI',
		altitude: 140
	},
	{
		zip: '45015',
		name: 'Corbola',
		province: 'RO',
		altitude: 2
	},
	{
		zip: '01030',
		name: 'Corchiano',
		province: 'VT',
		altitude: 196
	},
	{
		zip: '06073',
		name: 'Corciano',
		province: 'PG',
		altitude: 408
	},
	{
		zip: '33084',
		name: 'Cordenons',
		province: 'PN',
		altitude: 44
	},
	{
		zip: '31016',
		name: 'Cordignano',
		province: 'TV',
		altitude: 56
	},
	{
		zip: '33075',
		name: 'Cordovado',
		province: 'PN',
		altitude: 15
	},
	{
		zip: '55025',
		name: 'Coreglia Antelminelli',
		province: 'LU',
		altitude: 595
	},
	{
		zip: '16040',
		name: 'Coreglia Ligure',
		province: 'GE',
		altitude: 65
	},
	{
		zip: '03040',
		name: 'Coreno Ausonio',
		province: 'FR',
		altitude: 318
	},
	{
		zip: '67030',
		name: 'Corfinio',
		province: 'AQ',
		altitude: 365
	},
	{
		zip: '04010',
		name: 'Cori',
		province: 'LT',
		altitude: 384
	},
	{
		zip: '47853',
		name: 'Coriano',
		province: 'RN',
		altitude: 102
	},
	{
		zip: '73022',
		name: 'Corigliano d\'\'Otranto',
		province: 'LE',
		altitude: 97
	},
	{
		zip: '87064',
		name: 'Corigliano-Rossano',
		province: 'CS',
		altitude: 210
	},
	{
		zip: '60013',
		name: 'Corinaldo',
		province: 'AN',
		altitude: 203
	},
	{
		zip: '10070',
		name: 'Corio',
		province: 'TO',
		altitude: 625
	},
	{
		zip: '90034',
		name: 'Corleone',
		province: 'PA',
		altitude: 558
	},
	{
		zip: '84020',
		name: 'Corleto Monforte',
		province: 'SA',
		altitude: 672
	},
	{
		zip: '85012',
		name: 'Corleto Perticara',
		province: 'PZ',
		altitude: 757
	},
	{
		zip: '20032',
		name: 'Cormano',
		province: 'MI',
		altitude: 149
	},
	{
		zip: '34071',
		name: 'Cormons',
		province: 'GO',
		altitude: 56
	},
	{
		zip: '24030',
		name: 'Corna Imagna',
		province: 'BG',
		altitude: 736
	},
	{
		zip: '24017',
		name: 'Cornalba',
		province: 'BG',
		altitude: 893
	},
	{
		zip: '27056',
		name: 'Cornale e Bastida',
		province: 'PV',
		altitude: 74
	},
	{
		zip: '20007',
		name: 'Cornaredo',
		province: 'MI',
		altitude: 145
	},
	{
		zip: '20872',
		name: 'Cornate d\'\'Adda',
		province: 'MB',
		altitude: 236
	},
	{
		zip: '36073',
		name: 'Cornedo Vicentino',
		province: 'VI',
		altitude: 200
	},
	{
		zip: '39053',
		name: 'Cornedo all\'\'Isarco',
		province: 'BZ',
		altitude: 290
	},
	{
		zip: '26854',
		name: 'Cornegliano Laudense',
		province: 'LO',
		altitude: 78
	},
	{
		zip: '12040',
		name: 'Corneliano d\'\'Alba',
		province: 'CN',
		altitude: 204
	},
	{
		zip: '43021',
		name: 'Corniglio',
		province: 'PR',
		altitude: 690
	},
	{
		zip: '26846',
		name: 'Corno Giovine',
		province: 'LO',
		altitude: 50
	},
	{
		zip: '33040',
		name: 'Corno di Rosazzo',
		province: 'UD',
		altitude: 88
	},
	{
		zip: '26842',
		name: 'Cornovecchio',
		province: 'LO',
		altitude: 52
	},
	{
		zip: '31041',
		name: 'Cornuda',
		province: 'TV',
		altitude: 163
	},
	{
		zip: '42015',
		name: 'Correggio',
		province: 'RE',
		altitude: 31
	},
	{
		zip: '20856',
		name: 'Correzzana',
		province: 'MB',
		altitude: 258
	},
	{
		zip: '35020',
		name: 'Correzzola',
		province: 'PD',
		altitude: 2
	},
	{
		zip: '22010',
		name: 'Corrido',
		province: 'CO',
		altitude: 468
	},
	{
		zip: '62014',
		name: 'Corridonia',
		province: 'MC',
		altitude: 261
	},
	{
		zip: '64013',
		name: 'Corropoli',
		province: 'TE',
		altitude: 120
	},
	{
		zip: '73033',
		name: 'Corsano',
		province: 'LE',
		altitude: 120
	},
	{
		zip: '20094',
		name: 'Corsico',
		province: 'MI',
		altitude: 115
	},
	{
		zip: '14020',
		name: 'Corsione',
		province: 'AT',
		altitude: 287
	},
	{
		zip: '39040',
		name: 'Cortaccia sulla Strada del Vino',
		province: 'BZ',
		altitude: 333
	},
	{
		zip: '88020',
		name: 'Cortale',
		province: 'CZ',
		altitude: 410
	},
	{
		zip: '14013',
		name: 'Cortandone',
		province: 'AT',
		altitude: 219
	},
	{
		zip: '14020',
		name: 'Cortanze',
		province: 'AT',
		altitude: 299
	},
	{
		zip: '14010',
		name: 'Cortazzone',
		province: 'AT',
		altitude: 225
	},
	{
		zip: '29020',
		name: 'Corte Brugnatella',
		province: 'PC',
		altitude: 476
	},
	{
		zip: '25040',
		name: 'Corte Franca',
		province: 'BS',
		altitude: 220
	},
	{
		zip: '26834',
		name: 'Corte Palasio',
		province: 'LO',
		altitude: 69
	},
	{
		zip: '26020',
		name: 'Corte de Cortesi con Cignone',
		province: 'CR',
		altitude: 60
	},
	{
		zip: '26010',
		name: 'Corte de Frati',
		province: 'CR',
		altitude: 51
	},
	{
		zip: '29016',
		name: 'Cortemaggiore',
		province: 'PC',
		altitude: 48
	},
	{
		zip: '12074',
		name: 'Cortemilia',
		province: 'CN',
		altitude: 247
	},
	{
		zip: '25040',
		name: 'Corteno Golgi',
		province: 'BS',
		altitude: 925
	},
	{
		zip: '23813',
		name: 'Cortenova',
		province: 'LC',
		altitude: 483
	},
	{
		zip: '24050',
		name: 'Cortenuova',
		province: 'BG',
		altitude: 133
	},
	{
		zip: '27014',
		name: 'Corteolona e Genzone',
		province: 'PV',
		altitude: 71
	},
	{
		zip: '14040',
		name: 'Cortiglione',
		province: 'AT',
		altitude: 211
	},
	{
		zip: '32043',
		name: 'Cortina d\'\'Ampezzo',
		province: 'BL',
		altitude: 1224
	},
	{
		zip: '39040',
		name: 'Cortina sulla Strada del Vino',
		province: 'BZ',
		altitude: 212
	},
	{
		zip: '64040',
		name: 'Cortino',
		province: 'TE',
		altitude: 982
	},
	{
		zip: '52044',
		name: 'Cortona',
		province: 'AR',
		altitude: 494
	},
	{
		zip: '65020',
		name: 'Corvara',
		province: 'PE',
		altitude: 625
	},
	{
		zip: '39033',
		name: 'Corvara in Badia',
		province: 'BZ',
		altitude: 1568
	},
	{
		zip: '27050',
		name: 'Corvino San Quirico',
		province: 'PV',
		altitude: 218
	},
	{
		zip: '25030',
		name: 'Corzano',
		province: 'BS',
		altitude: 101
	},
	{
		zip: '33030',
		name: 'Coseano',
		province: 'UD',
		altitude: 121
	},
	{
		zip: '87100',
		name: 'Cosenza',
		province: 'CS',
		altitude: 238
	},
	{
		zip: '23013',
		name: 'Cosio Valtellino',
		province: 'SO',
		altitude: 231
	},
	{
		zip: '18023',
		name: 'Cosio d\'\'Arroscia',
		province: 'IM',
		altitude: 721
	},
	{
		zip: '89050',
		name: 'Cosoleto',
		province: 'RC',
		altitude: 440
	},
	{
		zip: '12054',
		name: 'Cossano Belbo',
		province: 'CN',
		altitude: 244
	},
	{
		zip: '10010',
		name: 'Cossano Canavese',
		province: 'TO',
		altitude: 346
	},
	{
		zip: '13836',
		name: 'Cossato',
		province: 'BI',
		altitude: 257
	},
	{
		zip: '17017',
		name: 'Cosseria',
		province: 'SV',
		altitude: 516
	},
	{
		zip: '63067',
		name: 'Cossignano',
		province: 'AP',
		altitude: 400
	},
	{
		zip: '28801',
		name: 'Cossogno',
		province: 'VB',
		altitude: 398
	},
	{
		zip: '07010',
		name: 'Cossoine',
		province: 'SS',
		altitude: 529
	},
	{
		zip: '14020',
		name: 'Cossombrato',
		province: 'AT',
		altitude: 275
	},
	{
		zip: '23845',
		name: 'Costa Masnaga',
		province: 'LC',
		altitude: 318
	},
	{
		zip: '24010',
		name: 'Costa Serina',
		province: 'BG',
		altitude: 868
	},
	{
		zip: '24030',
		name: 'Costa Valle Imagna',
		province: 'BG',
		altitude: 1014
	},
	{
		zip: '15050',
		name: 'Costa Vescovato',
		province: 'AL',
		altitude: 305
	},
	{
		zip: '24062',
		name: 'Costa Volpino',
		province: 'BG',
		altitude: 248
	},
	{
		zip: '27010',
		name: 'Costa de Nobili',
		province: 'PV',
		altitude: 66
	},
	{
		zip: '24060',
		name: 'Costa di Mezzate',
		province: 'BG',
		altitude: 218
	},
	{
		zip: '45023',
		name: 'Costa di Rovigo',
		province: 'RO',
		altitude: 9
	},
	{
		zip: '36030',
		name: 'Costabissara',
		province: 'VI',
		altitude: 51
	},
	{
		zip: '06021',
		name: 'Costacciaro',
		province: 'PG',
		altitude: 567
	},
	{
		zip: '13033',
		name: 'Costanzana',
		province: 'VC',
		altitude: 129
	},
	{
		zip: '18017',
		name: 'Costarainera',
		province: 'IM',
		altitude: 220
	},
	{
		zip: '37010',
		name: 'Costermano sul Garda',
		province: 'VR',
		altitude: 237
	},
	{
		zip: '12024',
		name: 'Costigliole Saluzzo',
		province: 'CN',
		altitude: 460
	},
	{
		zip: '14055',
		name: 'Costigliole d\'\'Asti',
		province: 'AT',
		altitude: 242
	},
	{
		zip: '48033',
		name: 'Cotignola',
		province: 'RA',
		altitude: 19
	},
	{
		zip: '88836',
		name: 'Cotronei',
		province: 'KR',
		altitude: 502
	},
	{
		zip: '02040',
		name: 'Cottanello',
		province: 'RI',
		altitude: 551
	},
	{
		zip: '11013',
		name: 'Courmayeur',
		province: 'AO',
		altitude: 1224
	},
	{
		zip: '24050',
		name: 'Covo',
		province: 'BG',
		altitude: 115
	},
	{
		zip: '27030',
		name: 'Cozzo',
		province: 'PV',
		altitude: 105
	},
	{
		zip: '23832',
		name: 'Crandola Valsassina',
		province: 'LC',
		altitude: 780
	},
	{
		zip: '13020',
		name: 'Cravagliana',
		province: 'VC',
		altitude: 615
	},
	{
		zip: '12050',
		name: 'Cravanzana',
		province: 'CN',
		altitude: 585
	},
	{
		zip: '28852',
		name: 'Craveggia',
		province: 'VB',
		altitude: 889
	},
	{
		zip: '36051',
		name: 'Creazzo',
		province: 'VI',
		altitude: 99
	},
	{
		zip: '66014',
		name: 'Crecchio',
		province: 'CH',
		altitude: 209
	},
	{
		zip: '24060',
		name: 'Credaro',
		province: 'BG',
		altitude: 225
	},
	{
		zip: '26010',
		name: 'Credera Rubbiano',
		province: 'CR',
		altitude: 69
	},
	{
		zip: '26013',
		name: 'Crema',
		province: 'CR',
		altitude: 79
	},
	{
		zip: '23894',
		name: 'Cremella',
		province: 'LC',
		altitude: 383
	},
	{
		zip: '21030',
		name: 'Cremenaga',
		province: 'VA',
		altitude: 281
	},
	{
		zip: '23814',
		name: 'Cremeno',
		province: 'LC',
		altitude: 792
	},
	{
		zip: '22010',
		name: 'Cremia',
		province: 'CO',
		altitude: 323
	},
	{
		zip: '15010',
		name: 'Cremolino',
		province: 'AL',
		altitude: 405
	},
	{
		zip: '26100',
		name: 'Cremona',
		province: 'CR',
		altitude: 45
	},
	{
		zip: '26010',
		name: 'Cremosano',
		province: 'CR',
		altitude: 82
	},
	{
		zip: '13044',
		name: 'Crescentino',
		province: 'VC',
		altitude: 210
	},
	{
		zip: '36070',
		name: 'Crespadoro',
		province: 'VI',
		altitude: 363
	},
	{
		zip: '26835',
		name: 'Crespiatica',
		province: 'LO',
		altitude: 75
	},
	{
		zip: '56042',
		name: 'Crespina Lorenzana',
		province: 'PI',
		altitude: 86
	},
	{
		zip: '45030',
		name: 'Crespino',
		province: 'RO',
		altitude: 3
	},
	{
		zip: '28012',
		name: 'Cressa',
		province: 'NO',
		altitude: 267
	},
	{
		zip: '13864',
		name: 'Crevacuore',
		province: 'BI',
		altitude: 377
	},
	{
		zip: '40014',
		name: 'Crevalcore',
		province: 'BO',
		altitude: 20
	},
	{
		zip: '28865',
		name: 'Crevoladossola',
		province: 'VB',
		altitude: 375
	},
	{
		zip: '80020',
		name: 'Crispano',
		province: 'NA',
		altitude: 37
	},
	{
		zip: '74012',
		name: 'Crispiano',
		province: 'TA',
		altitude: 232
	},
	{
		zip: '12030',
		name: 'Crissolo',
		province: 'CN',
		altitude: 1318
	},
	{
		zip: '16010',
		name: 'Crocefieschi',
		province: 'GE',
		altitude: 742
	},
	{
		zip: '31035',
		name: 'Crocetta del Montello',
		province: 'TV',
		altitude: 146
	},
	{
		zip: '28862',
		name: 'Crodo',
		province: 'VB',
		altitude: 505
	},
	{
		zip: '64043',
		name: 'Crognaleto',
		province: 'TE',
		altitude: 1094
	},
	{
		zip: '87060',
		name: 'Cropalati',
		province: 'CS',
		altitude: 384
	},
	{
		zip: '88051',
		name: 'Cropani',
		province: 'CZ',
		altitude: 347
	},
	{
		zip: '87060',
		name: 'Crosia',
		province: 'CS',
		altitude: 230
	},
	{
		zip: '21020',
		name: 'Crosio della Valle',
		province: 'VA',
		altitude: 322
	},
	{
		zip: '88900',
		name: 'Crotone',
		province: 'KR',
		altitude: 8
	},
	{
		zip: '26020',
		name: 'Crotta d\'\'Adda',
		province: 'CR',
		altitude: 52
	},
	{
		zip: '13040',
		name: 'Crova',
		province: 'VC',
		altitude: 167
	},
	{
		zip: '38027',
		name: 'Croviana',
		province: 'TN',
		altitude: 721
	},
	{
		zip: '88812',
		name: 'Crucoli',
		province: 'KR',
		altitude: 380
	},
	{
		zip: '21050',
		name: 'Cuasso al Monte',
		province: 'VA',
		altitude: 537
	},
	{
		zip: '84050',
		name: 'Cuccaro Vetere',
		province: 'SA',
		altitude: 629
	},
	{
		zip: '22060',
		name: 'Cucciago',
		province: 'CO',
		altitude: 349
	},
	{
		zip: '10090',
		name: 'Cuceglio',
		province: 'TO',
		altitude: 375
	},
	{
		zip: '20012',
		name: 'Cuggiono',
		province: 'MI',
		altitude: 157
	},
	{
		zip: '21030',
		name: 'Cugliate-Fabiasco',
		province: 'VA',
		altitude: 516
	},
	{
		zip: '09073',
		name: 'Cuglieri',
		province: 'OR',
		altitude: 479
	},
	{
		zip: '65020',
		name: 'Cugnoli',
		province: 'PE',
		altitude: 331
	},
	{
		zip: '10040',
		name: 'Cumiana',
		province: 'TO',
		altitude: 377
	},
	{
		zip: '26020',
		name: 'Cumignano sul Naviglio',
		province: 'CR',
		altitude: 73
	},
	{
		zip: '21035',
		name: 'Cunardo',
		province: 'VA',
		altitude: 450
	},
	{
		zip: '12100',
		name: 'Cuneo',
		province: 'CN',
		altitude: 534
	},
	{
		zip: '14026',
		name: 'Cunico',
		province: 'AT',
		altitude: 257
	},
	{
		zip: '10082',
		name: 'Cuorgne',
		province: 'TO',
		altitude: 414
	},
	{
		zip: '66051',
		name: 'Cupello',
		province: 'CH',
		altitude: 264
	},
	{
		zip: '63064',
		name: 'Cupra Marittima',
		province: 'AP',
		altitude: 4
	},
	{
		zip: '60034',
		name: 'Cupramontana',
		province: 'AN',
		altitude: 505
	},
	{
		zip: '27010',
		name: 'Cura Carpignano',
		province: 'PV',
		altitude: 78
	},
	{
		zip: '09090',
		name: 'Curcuris',
		province: 'OR',
		altitude: 159
	},
	{
		zip: '28060',
		name: 'Cureggio',
		province: 'NO',
		altitude: 289
	},
	{
		zip: '21010',
		name: 'Curiglia con Monteviasco',
		province: 'VA',
		altitude: 670
	},
	{
		zip: '88022',
		name: 'Curinga',
		province: 'CZ',
		altitude: 419
	},
	{
		zip: '13865',
		name: 'Curino',
		province: 'BI',
		altitude: 390
	},
	{
		zip: '24035',
		name: 'Curno',
		province: 'BG',
		altitude: 244
	},
	{
		zip: '39027',
		name: 'Curon Venosta',
		province: 'BZ',
		altitude: 1520
	},
	{
		zip: '73020',
		name: 'Cursi',
		province: 'LE',
		altitude: 91
	},
	{
		zip: '35010',
		name: 'Curtarolo',
		province: 'PD',
		altitude: 22
	},
	{
		zip: '46010',
		name: 'Curtatone',
		province: 'MN',
		altitude: 26
	},
	{
		zip: '81040',
		name: 'Curti',
		province: 'CE',
		altitude: 40
	},
	{
		zip: '20047',
		name: 'Cusago',
		province: 'MI',
		altitude: 126
	},
	{
		zip: '20095',
		name: 'Cusano Milanino',
		province: 'MI',
		altitude: 152
	},
	{
		zip: '82033',
		name: 'Cusano Mutri',
		province: 'BN',
		altitude: 475
	},
	{
		zip: '22010',
		name: 'Cusino',
		province: 'CO',
		altitude: 800
	},
	{
		zip: '24010',
		name: 'Cusio',
		province: 'BG',
		altitude: 1040
	},
	{
		zip: '91015',
		name: 'Custonaci',
		province: 'TP',
		altitude: 186
	},
	{
		zip: '88842',
		name: 'Cutro',
		province: 'KR',
		altitude: 220
	},
	{
		zip: '73020',
		name: 'Cutrofiano',
		province: 'LE',
		altitude: 81
	},
	{
		zip: '21030',
		name: 'Cuveglio',
		province: 'VA',
		altitude: 294
	},
	{
		zip: '21030',
		name: 'Cuvio',
		province: 'VA',
		altitude: 309
	},
	{
		zip: '20020',
		name: 'Dairago',
		province: 'MI',
		altitude: 196
	},
	{
		zip: '24044',
		name: 'Dalmine',
		province: 'BG',
		altitude: 207
	},
	{
		zip: '38010',
		name: 'Dambel',
		province: 'TN',
		altitude: 751
	},
	{
		zip: '32040',
		name: 'Danta di Cadore',
		province: 'BL',
		altitude: 1398
	},
	{
		zip: '25047',
		name: 'Darfo Boario Terme',
		province: 'BS',
		altitude: 220
	},
	{
		zip: '89832',
		name: 'Dasa',
		province: 'VV',
		altitude: 258
	},
	{
		zip: '16022',
		name: 'Davagna',
		province: 'GE',
		altitude: 552
	},
	{
		zip: '21020',
		name: 'Daverio',
		province: 'VA',
		altitude: 327
	},
	{
		zip: '88060',
		name: 'Davoli',
		province: 'CZ',
		altitude: 401
	},
	{
		zip: '23010',
		name: 'Dazio',
		province: 'SO',
		altitude: 568
	},
	{
		zip: '09033',
		name: 'Decimomannu',
		province: 'CA',
		altitude: 10
	},
	{
		zip: '09010',
		name: 'Decimoputzu',
		province: 'SU',
		altitude: 17
	},
	{
		zip: '88041',
		name: 'Decollatura',
		province: 'CZ',
		altitude: 765
	},
	{
		zip: '17058',
		name: 'Dego',
		province: 'SV',
		altitude: 317
	},
	{
		zip: '19013',
		name: 'Deiva Marina',
		province: 'SP',
		altitude: 15
	},
	{
		zip: '23014',
		name: 'Delebio',
		province: 'SO',
		altitude: 218
	},
	{
		zip: '93010',
		name: 'Delia',
		province: 'CL',
		altitude: 420
	},
	{
		zip: '89012',
		name: 'Delianuova',
		province: 'RC',
		altitude: 600
	},
	{
		zip: '71026',
		name: 'Deliceto',
		province: 'FG',
		altitude: 575
	},
	{
		zip: '25020',
		name: 'Dello',
		province: 'BS',
		altitude: 84
	},
	{
		zip: '12014',
		name: 'Demonte',
		province: 'CN',
		altitude: 780
	},
	{
		zip: '15010',
		name: 'Denice',
		province: 'AL',
		altitude: 387
	},
	{
		zip: '38010',
		name: 'Denno',
		province: 'TN',
		altitude: 429
	},
	{
		zip: '15056',
		name: 'Dernice',
		province: 'AL',
		altitude: 600
	},
	{
		zip: '26040',
		name: 'Derovere',
		province: 'CR',
		altitude: 36
	},
	{
		zip: '06053',
		name: 'Deruta',
		province: 'PG',
		altitude: 218
	},
	{
		zip: '23824',
		name: 'Dervio',
		province: 'LC',
		altitude: 213
	},
	{
		zip: '13034',
		name: 'Desana',
		province: 'VC',
		altitude: 131
	},
	{
		zip: '25015',
		name: 'Desenzano del Garda',
		province: 'BS',
		altitude: 67
	},
	{
		zip: '20832',
		name: 'Desio',
		province: 'MB',
		altitude: 196
	},
	{
		zip: '08032',
		name: 'Desulo',
		province: 'NU',
		altitude: 888
	},
	{
		zip: '87023',
		name: 'Diamante',
		province: 'CS',
		altitude: 25
	},
	{
		zip: '18013',
		name: 'Diano Arentino',
		province: 'IM',
		altitude: 331
	},
	{
		zip: '18013',
		name: 'Diano Castello',
		province: 'IM',
		altitude: 135
	},
	{
		zip: '18013',
		name: 'Diano Marina',
		province: 'IM',
		altitude: 4
	},
	{
		zip: '18013',
		name: 'Diano San Pietro',
		province: 'IM',
		altitude: 83
	},
	{
		zip: '12055',
		name: 'Diano d\'\'Alba',
		province: 'CN',
		altitude: 496
	},
	{
		zip: '50062',
		name: 'Dicomano',
		province: 'FI',
		altitude: 162
	},
	{
		zip: '33030',
		name: 'Dignano',
		province: 'UD',
		altitude: 112
	},
	{
		zip: '38025',
		name: 'Dimaro Folgarida',
		province: 'TN',
		altitude: 766
	},
	{
		zip: '89833',
		name: 'Dinami',
		province: 'VV',
		altitude: 260
	},
	{
		zip: '87045',
		name: 'Dipignano',
		province: 'CS',
		altitude: 720
	},
	{
		zip: '73030',
		name: 'Diso',
		province: 'LE',
		altitude: 99
	},
	{
		zip: '28010',
		name: 'Divignano',
		province: 'NO',
		altitude: 337
	},
	{
		zip: '22020',
		name: 'Dizzasco',
		province: 'CO',
		altitude: 506
	},
	{
		zip: '39034',
		name: 'Dobbiaco',
		province: 'BZ',
		altitude: 1213
	},
	{
		zip: '34070',
		name: 'Doberdo del Lago',
		province: 'GO',
		altitude: 92
	},
	{
		zip: '12063',
		name: 'Dogliani',
		province: 'CN',
		altitude: 295
	},
	{
		zip: '66050',
		name: 'Dogliola',
		province: 'CH',
		altitude: 445
	},
	{
		zip: '33010',
		name: 'Dogna',
		province: 'UD',
		altitude: 430
	},
	{
		zip: '18035',
		name: 'Dolceacqua',
		province: 'IM',
		altitude: 51
	},
	{
		zip: '18020',
		name: 'Dolcedo',
		province: 'IM',
		altitude: 75
	},
	{
		zip: '37020',
		name: 'Dolce',
		province: 'VR',
		altitude: 115
	},
	{
		zip: '34070',
		name: 'Dolegna del Collio',
		province: 'GO',
		altitude: 90
	},
	{
		zip: '09041',
		name: 'Dolianova',
		province: 'SU',
		altitude: 212
	},
	{
		zip: '30031',
		name: 'Dolo',
		province: 'VE',
		altitude: 7
	},
	{
		zip: '23843',
		name: 'Dolzago',
		province: 'LC',
		altitude: 298
	},
	{
		zip: '87030',
		name: 'Domanico',
		province: 'CS',
		altitude: 730
	},
	{
		zip: '22013',
		name: 'Domaso',
		province: 'CO',
		altitude: 216
	},
	{
		zip: '32040',
		name: 'Domegge di Cadore',
		province: 'BL',
		altitude: 775
	},
	{
		zip: '83020',
		name: 'Domicella',
		province: 'AV',
		altitude: 200
	},
	{
		zip: '28845',
		name: 'Domodossola',
		province: 'VB',
		altitude: 272
	},
	{
		zip: '09010',
		name: 'Domus de Maria',
		province: 'SU',
		altitude: 66
	},
	{
		zip: '09015',
		name: 'Domusnovas',
		province: 'SU',
		altitude: 152
	},
	{
		zip: '13893',
		name: 'Donato',
		province: 'BI',
		altitude: 711
	},
	{
		zip: '22014',
		name: 'Dongo',
		province: 'CO',
		altitude: 208
	},
	{
		zip: '11020',
		name: 'Donnas',
		province: 'AO',
		altitude: 352
	},
	{
		zip: '09040',
		name: 'Donori',
		province: 'SU',
		altitude: 141
	},
	{
		zip: '08022',
		name: 'Dorgali',
		province: 'NU',
		altitude: 387
	},
	{
		zip: '23824',
		name: 'Dorio',
		province: 'LC',
		altitude: 210
	},
	{
		zip: '28040',
		name: 'Dormelletto',
		province: 'NO',
		altitude: 235
	},
	{
		zip: '27020',
		name: 'Dorno',
		province: 'PV',
		altitude: 90
	},
	{
		zip: '13881',
		name: 'Dorzano',
		province: 'BI',
		altitude: 296
	},
	{
		zip: '46030',
		name: 'Dosolo',
		province: 'MN',
		altitude: 25
	},
	{
		zip: '24010',
		name: 'Dossena',
		province: 'BG',
		altitude: 986
	},
	{
		zip: '22015',
		name: 'Dosso del Liro',
		province: 'CO',
		altitude: 650
	},
	{
		zip: '11010',
		name: 'Doues',
		province: 'AO',
		altitude: 1176
	},
	{
		zip: '47013',
		name: 'Dovadola',
		province: 'FC',
		altitude: 140
	},
	{
		zip: '26010',
		name: 'Dovera',
		province: 'CR',
		altitude: 73
	},
	{
		zip: '40060',
		name: 'Dozza',
		province: 'BO',
		altitude: 190
	},
	{
		zip: '81010',
		name: 'Dragoni',
		province: 'CE',
		altitude: 130
	},
	{
		zip: '89862',
		name: 'Drapia',
		province: 'VV',
		altitude: 262
	},
	{
		zip: '38074',
		name: 'Drena',
		province: 'TN',
		altitude: 398
	},
	{
		zip: '33040',
		name: 'Drenchia',
		province: 'UD',
		altitude: 663
	},
	{
		zip: '20070',
		name: 'Dresano',
		province: 'MI',
		altitude: 91
	},
	{
		zip: '38074',
		name: 'Dro',
		province: 'TN',
		altitude: 123
	},
	{
		zip: '12025',
		name: 'Dronero',
		province: 'CN',
		altitude: 622
	},
	{
		zip: '10040',
		name: 'Druento',
		province: 'TO',
		altitude: 285
	},
	{
		zip: '28853',
		name: 'Druogno',
		province: 'VB',
		altitude: 836
	},
	{
		zip: '08010',
		name: 'Dualchi',
		province: 'NU',
		altitude: 321
	},
	{
		zip: '23015',
		name: 'Dubino',
		province: 'SO',
		altitude: 223
	},
	{
		zip: '35020',
		name: 'Due Carrare',
		province: 'PD',
		altitude: 9
	},
	{
		zip: '36031',
		name: 'Dueville',
		province: 'VI',
		altitude: 57
	},
	{
		zip: '82030',
		name: 'Dugenta',
		province: 'BN',
		altitude: 55
	},
	{
		zip: '21010',
		name: 'Dumenza',
		province: 'VA',
		altitude: 411
	},
	{
		zip: '21030',
		name: 'Duno',
		province: 'VA',
		altitude: 530
	},
	{
		zip: '82015',
		name: 'Durazzano',
		province: 'BN',
		altitude: 286
	},
	{
		zip: '86020',
		name: 'Duronia',
		province: 'CB',
		altitude: 918
	},
	{
		zip: '14010',
		name: 'Dusino San Michele',
		province: 'AT',
		altitude: 264
	},
	{
		zip: '84025',
		name: 'Eboli',
		province: 'SA',
		altitude: 145
	},
	{
		zip: '25048',
		name: 'Edolo',
		province: 'BS',
		altitude: 720
	},
	{
		zip: '39044',
		name: 'Egna',
		province: 'BZ',
		altitude: 214
	},
	{
		zip: '65010',
		name: 'Elice',
		province: 'PE',
		altitude: 259
	},
	{
		zip: '08040',
		name: 'Elini',
		province: 'NU',
		altitude: 472
	},
	{
		zip: '23848',
		name: 'Ello',
		province: 'LC',
		altitude: 411
	},
	{
		zip: '09067',
		name: 'Elmas',
		province: 'CA',
		altitude: 7
	},
	{
		zip: '12020',
		name: 'Elva',
		province: 'CN',
		altitude: 1637
	},
	{
		zip: '11020',
		name: 'Emarese',
		province: 'AO',
		altitude: 1170
	},
	{
		zip: '50053',
		name: 'Empoli',
		province: 'FI',
		altitude: 28
	},
	{
		zip: '24060',
		name: 'Endine Gaiano',
		province: 'BG',
		altitude: 382
	},
	{
		zip: '36052',
		name: 'Enego',
		province: 'VI',
		altitude: 750
	},
	{
		zip: '33020',
		name: 'Enemonzo',
		province: 'UD',
		altitude: 398
	},
	{
		zip: '94100',
		name: 'Enna',
		province: 'EN',
		altitude: 931
	},
	{
		zip: '12010',
		name: 'Entracque',
		province: 'CN',
		altitude: 894
	},
	{
		zip: '24060',
		name: 'Entratico',
		province: 'BG',
		altitude: 299
	},
	{
		zip: '12030',
		name: 'Envie',
		province: 'CN',
		altitude: 327
	},
	{
		zip: '85033',
		name: 'Episcopia',
		province: 'PZ',
		altitude: 530
	},
	{
		zip: '30020',
		name: 'Eraclea',
		province: 'VE',
		altitude: 2
	},
	{
		zip: '22036',
		name: 'Erba',
		province: 'CO',
		altitude: 320
	},
	{
		zip: '37020',
		name: 'Erbezzo',
		province: 'VR',
		altitude: 1118
	},
	{
		zip: '25030',
		name: 'Erbusco',
		province: 'BS',
		altitude: 236
	},
	{
		zip: '37060',
		name: 'Erbe',
		province: 'VR',
		altitude: 22
	},
	{
		zip: '72020',
		name: 'Erchie',
		province: 'BR',
		altitude: 68
	},
	{
		zip: '80056',
		name: 'Ercolano',
		province: 'NA',
		altitude: 44
	},
	{
		zip: '91016',
		name: 'Erice',
		province: 'TP',
		altitude: 751
	},
	{
		zip: '17030',
		name: 'Erli',
		province: 'SV',
		altitude: 287
	},
	{
		zip: '33080',
		name: 'Erto e Casso',
		province: 'PN',
		altitude: 775
	},
	{
		zip: '07030',
		name: 'Erula',
		province: 'SS',
		altitude: 457
	},
	{
		zip: '23805',
		name: 'Erve',
		province: 'LC',
		altitude: 559
	},
	{
		zip: '62024',
		name: 'Esanatoglia',
		province: 'MC',
		altitude: 495
	},
	{
		zip: '09051',
		name: 'Escalaplano',
		province: 'SU',
		altitude: 338
	},
	{
		zip: '09052',
		name: 'Escolca',
		province: 'SU',
		altitude: 416
	},
	{
		zip: '25040',
		name: 'Esine',
		province: 'BS',
		altitude: 286
	},
	{
		zip: '23825',
		name: 'Esino Lario',
		province: 'LC',
		altitude: 910
	},
	{
		zip: '03045',
		name: 'Esperia',
		province: 'FR',
		altitude: 670
	},
	{
		zip: '07010',
		name: 'Esporlatu',
		province: 'SS',
		altitude: 474
	},
	{
		zip: '35042',
		name: 'Este',
		province: 'PD',
		altitude: 15
	},
	{
		zip: '09053',
		name: 'Esterzili',
		province: 'SU',
		altitude: 731
	},
	{
		zip: '11014',
		name: 'Etroubles',
		province: 'AO',
		altitude: 1270
	},
	{
		zip: '22030',
		name: 'Eupilio',
		province: 'CO',
		altitude: 383
	},
	{
		zip: '10050',
		name: 'Exilles',
		province: 'TO',
		altitude: 870
	},
	{
		zip: '15054',
		name: 'Fabbrica Curone',
		province: 'AL',
		altitude: 712
	},
	{
		zip: '55021',
		name: 'Fabbriche di Vergemoli',
		province: 'LU',
		altitude: 349
	},
	{
		zip: '42042',
		name: 'Fabbrico',
		province: 'RE',
		altitude: 25
	},
	{
		zip: '60044',
		name: 'Fabriano',
		province: 'AN',
		altitude: 325
	},
	{
		zip: '01034',
		name: 'Fabrica di Roma',
		province: 'VT',
		altitude: 296
	},
	{
		zip: '89823',
		name: 'Fabrizia',
		province: 'VV',
		altitude: 947
	},
	{
		zip: '05015',
		name: 'Fabro',
		province: 'TR',
		altitude: 364
	},
	{
		zip: '33040',
		name: 'Faedis',
		province: 'UD',
		altitude: 176
	},
	{
		zip: '23020',
		name: 'Faedo Valtellino',
		province: 'SO',
		altitude: 557
	},
	{
		zip: '48018',
		name: 'Faenza',
		province: 'RA',
		altitude: 35
	},
	{
		zip: '71020',
		name: 'Faeto',
		province: 'FG',
		altitude: 820
	},
	{
		zip: '33034',
		name: 'Fagagna',
		province: 'UD',
		altitude: 177
	},
	{
		zip: '22020',
		name: 'Faggeto Lario',
		province: 'CO',
		altitude: 533
	},
	{
		zip: '74020',
		name: 'Faggiano',
		province: 'TA',
		altitude: 36
	},
	{
		zip: '67020',
		name: 'Fagnano Alto',
		province: 'AQ',
		altitude: 665
	},
	{
		zip: '87013',
		name: 'Fagnano Castello',
		province: 'CS',
		altitude: 516
	},
	{
		zip: '21054',
		name: 'Fagnano Olona',
		province: 'VA',
		altitude: 265
	},
	{
		zip: '38010',
		name: 'Fai della Paganella',
		province: 'TN',
		altitude: 958
	},
	{
		zip: '82030',
		name: 'Faicchio',
		province: 'BN',
		altitude: 175
	},
	{
		zip: '32020',
		name: 'Falcade',
		province: 'BL',
		altitude: 1148
	},
	{
		zip: '81030',
		name: 'Falciano del Massico',
		province: 'CE',
		altitude: 70
	},
	{
		zip: '87030',
		name: 'Falconara Albanese',
		province: 'CS',
		altitude: 602
	},
	{
		zip: '60015',
		name: 'Falconara Marittima',
		province: 'AN',
		altitude: 5
	},
	{
		zip: '98060',
		name: 'Falcone',
		province: 'ME',
		altitude: 3
	},
	{
		zip: '01030',
		name: 'Faleria',
		province: 'VT',
		altitude: 202
	},
	{
		zip: '88042',
		name: 'Falerna',
		province: 'CZ',
		altitude: 550
	},
	{
		zip: '63837',
		name: 'Falerone',
		province: 'FM',
		altitude: 433
	},
	{
		zip: '66040',
		name: 'Fallo',
		province: 'CH',
		altitude: 575
	},
	{
		zip: '22020',
		name: 'Faloppio',
		province: 'CO',
		altitude: 376
	},
	{
		zip: '03020',
		name: 'Falvaterra',
		province: 'FR',
		altitude: 282
	},
	{
		zip: '39030',
		name: 'Falzes',
		province: 'BZ',
		altitude: 1022
	},
	{
		zip: '41021',
		name: 'Fanano',
		province: 'MO',
		altitude: 640
	},
	{
		zip: '33092',
		name: 'Fanna',
		province: 'PN',
		altitude: 274
	},
	{
		zip: '61032',
		name: 'Fano',
		province: 'PU',
		altitude: 12
	},
	{
		zip: '64044',
		name: 'Fano Adriano',
		province: 'TE',
		altitude: 750
	},
	{
		zip: '66010',
		name: 'Fara Filiorum Petri',
		province: 'CH',
		altitude: 227
	},
	{
		zip: '24045',
		name: 'Fara Gera d\'\'Adda',
		province: 'BG',
		altitude: 131
	},
	{
		zip: '28073',
		name: 'Fara Novarese',
		province: 'NO',
		altitude: 210
	},
	{
		zip: '24058',
		name: 'Fara Olivana con Sola',
		province: 'BG',
		altitude: 107
	},
	{
		zip: '66015',
		name: 'Fara San Martino',
		province: 'CH',
		altitude: 440
	},
	{
		zip: '36030',
		name: 'Fara Vicentino',
		province: 'VI',
		altitude: 202
	},
	{
		zip: '02032',
		name: 'Fara in Sabina',
		province: 'RI',
		altitude: 482
	},
	{
		zip: '85030',
		name: 'Fardella',
		province: 'PZ',
		altitude: 745
	},
	{
		zip: '12060',
		name: 'Farigliano',
		province: 'CN',
		altitude: 263
	},
	{
		zip: '65010',
		name: 'Farindola',
		province: 'PE',
		altitude: 530
	},
	{
		zip: '29023',
		name: 'Farini',
		province: 'PC',
		altitude: 424
	},
	{
		zip: '01010',
		name: 'Farnese',
		province: 'VT',
		altitude: 341
	},
	{
		zip: '34072',
		name: 'Farra d\'\'Isonzo',
		province: 'GO',
		altitude: 46
	},
	{
		zip: '31010',
		name: 'Farra di Soligo',
		province: 'TV',
		altitude: 163
	},
	{
		zip: '72015',
		name: 'Fasano',
		province: 'BR',
		altitude: 111
	},
	{
		zip: '16020',
		name: 'Fascia',
		province: 'GE',
		altitude: 1118
	},
	{
		zip: '56043',
		name: 'Fauglia',
		province: 'PI',
		altitude: 91
	},
	{
		zip: '12030',
		name: 'Faule',
		province: 'CN',
		altitude: 246
	},
	{
		zip: '16040',
		name: 'Favale di Malvaro',
		province: 'GE',
		altitude: 300
	},
	{
		zip: '92026',
		name: 'Favara',
		province: 'AG',
		altitude: 338
	},
	{
		zip: '91023',
		name: 'Favignana',
		province: 'TP',
		altitude: 6
	},
	{
		zip: '10083',
		name: 'Favria',
		province: 'TO',
		altitude: 316
	},
	{
		zip: '12050',
		name: 'Feisoglio',
		province: 'CN',
		altitude: 706
	},
	{
		zip: '10080',
		name: 'Feletto',
		province: 'TO',
		altitude: 275
	},
	{
		zip: '43035',
		name: 'Felino',
		province: 'PR',
		altitude: 180
	},
	{
		zip: '84055',
		name: 'Felitto',
		province: 'SA',
		altitude: 275
	},
	{
		zip: '15023',
		name: 'Felizzano',
		province: 'AL',
		altitude: 114
	},
	{
		zip: '32032',
		name: 'Feltre',
		province: 'BL',
		altitude: 325
	},
	{
		zip: '22070',
		name: 'Fenegro',
		province: 'CO',
		altitude: 290
	},
	{
		zip: '10060',
		name: 'Fenestrelle',
		province: 'TO',
		altitude: 1145
	},
	{
		zip: '05034',
		name: 'Ferentillo',
		province: 'TR',
		altitude: 260
	},
	{
		zip: '03013',
		name: 'Ferentino',
		province: 'FR',
		altitude: 395
	},
	{
		zip: '96010',
		name: 'Ferla',
		province: 'SR',
		altitude: 556
	},
	{
		zip: '61033',
		name: 'Fermignano',
		province: 'PU',
		altitude: 200
	},
	{
		zip: '63900',
		name: 'Fermo',
		province: 'FM',
		altitude: 319
	},
	{
		zip: '21010',
		name: 'Ferno',
		province: 'VA',
		altitude: 211
	},
	{
		zip: '88040',
		name: 'Feroleto Antico',
		province: 'CZ',
		altitude: 280
	},
	{
		zip: '89050',
		name: 'Feroleto della Chiesa',
		province: 'RC',
		altitude: 159
	},
	{
		zip: '75013',
		name: 'Ferrandina',
		province: 'MT',
		altitude: 497
	},
	{
		zip: '44121',
		name: 'Ferrara',
		province: 'FE',
		altitude: 9
	},
	{
		zip: '37020',
		name: 'Ferrara di Monte Baldo',
		province: 'VR',
		altitude: 856
	},
	{
		zip: '86010',
		name: 'Ferrazzano',
		province: 'CB',
		altitude: 872
	},
	{
		zip: '27032',
		name: 'Ferrera Erbognone',
		province: 'PV',
		altitude: 89
	},
	{
		zip: '21030',
		name: 'Ferrera di Varese',
		province: 'VA',
		altitude: 299
	},
	{
		zip: '14012',
		name: 'Ferrere',
		province: 'AT',
		altitude: 268
	},
	{
		zip: '29024',
		name: 'Ferriere',
		province: 'PC',
		altitude: 626
	},
	{
		zip: '89030',
		name: 'Ferruzzano',
		province: 'RC',
		altitude: 470
	},
	{
		zip: '02023',
		name: 'Fiamignano',
		province: 'RI',
		altitude: 1000
	},
	{
		zip: '10070',
		name: 'Fiano',
		province: 'TO',
		altitude: 429
	},
	{
		zip: '00065',
		name: 'Fiano Romano',
		province: 'RM',
		altitude: 97
	},
	{
		zip: '62035',
		name: 'Fiastra',
		province: 'MC',
		altitude: 732
	},
	{
		zip: '38075',
		name: 'Fiave',
		province: 'TN',
		altitude: 660
	},
	{
		zip: '90010',
		name: 'Ficarazzi',
		province: 'PA',
		altitude: 23
	},
	{
		zip: '45036',
		name: 'Ficarolo',
		province: 'RO',
		altitude: 10
	},
	{
		zip: '98062',
		name: 'Ficarra',
		province: 'ME',
		altitude: 450
	},
	{
		zip: '05016',
		name: 'Ficulle',
		province: 'TR',
		altitude: 437
	},
	{
		zip: '43036',
		name: 'Fidenza',
		province: 'PR',
		altitude: 75
	},
	{
		zip: '38050',
		name: 'Fierozzo',
		province: 'TN',
		altitude: 1127
	},
	{
		zip: '26010',
		name: 'Fiesco',
		province: 'CR',
		altitude: 69
	},
	{
		zip: '50014',
		name: 'Fiesole',
		province: 'FI',
		altitude: 295
	},
	{
		zip: '25020',
		name: 'Fiesse',
		province: 'BS',
		altitude: 39
	},
	{
		zip: '45024',
		name: 'Fiesso Umbertiano',
		province: 'RO',
		altitude: 9
	},
	{
		zip: '30032',
		name: 'Fiesso d\'\'Artico',
		province: 'VE',
		altitude: 9
	},
	{
		zip: '22060',
		name: 'Figino Serenza',
		province: 'CO',
		altitude: 329
	},
	{
		zip: '87050',
		name: 'Figline Vegliaturo',
		province: 'CS',
		altitude: 705
	},
	{
		zip: '50063',
		name: 'Figline e Incisa Valdarno',
		province: 'FI',
		altitude: 122
	},
	{
		zip: '00060',
		name: 'Filacciano',
		province: 'RM',
		altitude: 197
	},
	{
		zip: '24040',
		name: 'Filago',
		province: 'BG',
		altitude: 190
	},
	{
		zip: '89841',
		name: 'Filandari',
		province: 'VV',
		altitude: 486
	},
	{
		zip: '54023',
		name: 'Filattiera',
		province: 'MS',
		altitude: 213
	},
	{
		zip: '03010',
		name: 'Filettino',
		province: 'FR',
		altitude: 1063
	},
	{
		zip: '66030',
		name: 'Filetto',
		province: 'CH',
		altitude: 403
	},
	{
		zip: '85020',
		name: 'Filiano',
		province: 'PZ',
		altitude: 597
	},
	{
		zip: '27010',
		name: 'Filighera',
		province: 'PV',
		altitude: 74
	},
	{
		zip: '86074',
		name: 'Filignano',
		province: 'IS',
		altitude: 460
	},
	{
		zip: '89843',
		name: 'Filogaso',
		province: 'VV',
		altitude: 283
	},
	{
		zip: '60024',
		name: 'Filottrano',
		province: 'AN',
		altitude: 270
	},
	{
		zip: '41034',
		name: 'Finale Emilia',
		province: 'MO',
		altitude: 15
	},
	{
		zip: '17024',
		name: 'Finale Ligure',
		province: 'SV',
		altitude: 10
	},
	{
		zip: '22073',
		name: 'Fino Mornasco',
		province: 'CO',
		altitude: 334
	},
	{
		zip: '24020',
		name: 'Fino del Monte',
		province: 'BG',
		altitude: 662
	},
	{
		zip: '10010',
		name: 'Fiorano Canavese',
		province: 'TO',
		altitude: 256
	},
	{
		zip: '41042',
		name: 'Fiorano Modenese',
		province: 'MO',
		altitude: 115
	},
	{
		zip: '24020',
		name: 'Fiorano al Serio',
		province: 'BG',
		altitude: 396
	},
	{
		zip: '29017',
		name: 'Fiorenzuola d\'\'Arda',
		province: 'PC',
		altitude: 80
	},
	{
		zip: '50100',
		name: 'Firenze',
		province: 'FI',
		altitude: 50
	},
	{
		zip: '50033',
		name: 'Firenzuola',
		province: 'FI',
		altitude: 422
	},
	{
		zip: '87010',
		name: 'Firmo',
		province: 'CS',
		altitude: 370
	},
	{
		zip: '44027',
		name: 'Fiscaglia',
		province: 'FE',
		altitude: 3
	},
	{
		zip: '84084',
		name: 'Fisciano',
		province: 'SA',
		altitude: 320
	},
	{
		zip: '03014',
		name: 'Fiuggi',
		province: 'FR',
		altitude: 747
	},
	{
		zip: '41022',
		name: 'Fiumalbo',
		province: 'MO',
		altitude: 953
	},
	{
		zip: '89050',
		name: 'Fiumara',
		province: 'RC',
		altitude: 192
	},
	{
		zip: '33080',
		name: 'Fiume Veneto',
		province: 'PN',
		altitude: 20
	},
	{
		zip: '98022',
		name: 'Fiumedinisi',
		province: 'ME',
		altitude: 200
	},
	{
		zip: '87030',
		name: 'Fiumefreddo Bruzio',
		province: 'CS',
		altitude: 220
	},
	{
		zip: '95013',
		name: 'Fiumefreddo di Sicilia',
		province: 'CT',
		altitude: 62
	},
	{
		zip: '33059',
		name: 'Fiumicello Villa Vicentina',
		province: 'UD',
		altitude: 6
	},
	{
		zip: '00054',
		name: 'Fiumicino',
		province: 'RM',
		altitude: 1
	},
	{
		zip: '62025',
		name: 'Fiuminata',
		province: 'MC',
		altitude: 479
	},
	{
		zip: '54013',
		name: 'Fivizzano',
		province: 'MS',
		altitude: 326
	},
	{
		zip: '39050',
		name: 'Fie allo Sciliar',
		province: 'BZ',
		altitude: 880
	},
	{
		zip: '33030',
		name: 'Flaibano',
		province: 'UD',
		altitude: 104
	},
	{
		zip: '25020',
		name: 'Flero',
		province: 'BS',
		altitude: 104
	},
	{
		zip: '98030',
		name: 'Floresta',
		province: 'ME',
		altitude: 1275
	},
	{
		zip: '96014',
		name: 'Floridia',
		province: 'SR',
		altitude: 111
	},
	{
		zip: '07030',
		name: 'Florinas',
		province: 'SS',
		altitude: 417
	},
	{
		zip: '83040',
		name: 'Flumeri',
		province: 'AV',
		altitude: 638
	},
	{
		zip: '09010',
		name: 'Fluminimaggiore',
		province: 'SU',
		altitude: 63
	},
	{
		zip: '09090',
		name: 'Flussio',
		province: 'OR',
		altitude: 305
	},
	{
		zip: '13025',
		name: 'Fobello',
		province: 'VC',
		altitude: 873
	},
	{
		zip: '71121',
		name: 'Foggia',
		province: 'FG',
		altitude: 76
	},
	{
		zip: '82030',
		name: 'Foglianise',
		province: 'BN',
		altitude: 350
	},
	{
		zip: '34070',
		name: 'Fogliano Redipuglia',
		province: 'GO',
		altitude: 23
	},
	{
		zip: '10090',
		name: 'Foglizzo',
		province: 'TO',
		altitude: 247
	},
	{
		zip: '52045',
		name: 'Foiano della Chiana',
		province: 'AR',
		altitude: 318
	},
	{
		zip: '82020',
		name: 'Foiano di Val Fortore',
		province: 'BN',
		altitude: 520
	},
	{
		zip: '38064',
		name: 'Folgaria',
		province: 'TN',
		altitude: 1169
	},
	{
		zip: '63084',
		name: 'Folignano',
		province: 'AP',
		altitude: 319
	},
	{
		zip: '06034',
		name: 'Foligno',
		province: 'PG',
		altitude: 234
	},
	{
		zip: '31051',
		name: 'Follina',
		province: 'TV',
		altitude: 191
	},
	{
		zip: '19020',
		name: 'Follo',
		province: 'SP',
		altitude: 30
	},
	{
		zip: '58022',
		name: 'Follonica',
		province: 'GR',
		altitude: 4
	},
	{
		zip: '26861',
		name: 'Fombio',
		province: 'LO',
		altitude: 56
	},
	{
		zip: '98050',
		name: 'Fondachelli-Fantina',
		province: 'ME',
		altitude: 604
	},
	{
		zip: '04022',
		name: 'Fondi',
		province: 'LT',
		altitude: 8
	},
	{
		zip: '08023',
		name: 'Fonni',
		province: 'NU',
		altitude: 1000
	},
	{
		zip: '11020',
		name: 'Fontainemore',
		province: 'AO',
		altitude: 760
	},
	{
		zip: '03035',
		name: 'Fontana Liri',
		province: 'FR',
		altitude: 150
	},
	{
		zip: '33074',
		name: 'Fontanafredda',
		province: 'PN',
		altitude: 52
	},
	{
		zip: '83040',
		name: 'Fontanarosa',
		province: 'AV',
		altitude: 480
	},
	{
		zip: '40025',
		name: 'Fontanelice',
		province: 'BO',
		altitude: 165
	},
	{
		zip: '24056',
		name: 'Fontanella',
		province: 'BG',
		altitude: 105
	},
	{
		zip: '43012',
		name: 'Fontanellato',
		province: 'PR',
		altitude: 45
	},
	{
		zip: '31043',
		name: 'Fontanelle',
		province: 'TV',
		altitude: 18
	},
	{
		zip: '28010',
		name: 'Fontaneto d\'\'Agogna',
		province: 'NO',
		altitude: 260
	},
	{
		zip: '13040',
		name: 'Fontanetto Po',
		province: 'VC',
		altitude: 143
	},
	{
		zip: '16023',
		name: 'Fontanigorda',
		province: 'GE',
		altitude: 819
	},
	{
		zip: '14044',
		name: 'Fontanile',
		province: 'AT',
		altitude: 276
	},
	{
		zip: '35014',
		name: 'Fontaniva',
		province: 'PD',
		altitude: 44
	},
	{
		zip: '31010',
		name: 'Fonte',
		province: 'TV',
		altitude: 107
	},
	{
		zip: '00013',
		name: 'Fonte Nuova',
		province: 'RM',
		altitude: 130
	},
	{
		zip: '67020',
		name: 'Fontecchio',
		province: 'AQ',
		altitude: 668
	},
	{
		zip: '03030',
		name: 'Fontechiari',
		province: 'FR',
		altitude: 375
	},
	{
		zip: '81010',
		name: 'Fontegreca',
		province: 'CE',
		altitude: 320
	},
	{
		zip: '24060',
		name: 'Fonteno',
		province: 'BG',
		altitude: 606
	},
	{
		zip: '43010',
		name: 'Fontevivo',
		province: 'PR',
		altitude: 53
	},
	{
		zip: '32030',
		name: 'Fonzaso',
		province: 'BL',
		altitude: 329
	},
	{
		zip: '24010',
		name: 'Foppolo',
		province: 'BG',
		altitude: 1508
	},
	{
		zip: '02044',
		name: 'Forano',
		province: 'RI',
		altitude: 218
	},
	{
		zip: '63086',
		name: 'Force',
		province: 'AP',
		altitude: 689
	},
	{
		zip: '82011',
		name: 'Forchia',
		province: 'BN',
		altitude: 282
	},
	{
		zip: '23010',
		name: 'Forcola',
		province: 'SO',
		altitude: 285
	},
	{
		zip: '09083',
		name: 'Fordongianus',
		province: 'OR',
		altitude: 40
	},
	{
		zip: '85023',
		name: 'Forenza',
		province: 'PZ',
		altitude: 836
	},
	{
		zip: '24060',
		name: 'Foresto Sparso',
		province: 'BG',
		altitude: 346
	},
	{
		zip: '33030',
		name: 'Forgaria nel Friuli',
		province: 'UD',
		altitude: 270
	},
	{
		zip: '83020',
		name: 'Forino',
		province: 'AV',
		altitude: 420
	},
	{
		zip: '80075',
		name: 'Forio',
		province: 'NA',
		altitude: 18
	},
	{
		zip: '47034',
		name: 'Forlimpopoli',
		province: 'FC',
		altitude: 30
	},
	{
		zip: '47121',
		name: 'Forli',
		province: 'FC',
		altitude: 34
	},
	{
		zip: '86084',
		name: 'Forli del Sannio',
		province: 'IS',
		altitude: 610
	},
	{
		zip: '28863',
		name: 'Formazza',
		province: 'VB',
		altitude: 1280
	},
	{
		zip: '00060',
		name: 'Formello',
		province: 'RM',
		altitude: 225
	},
	{
		zip: '04023',
		name: 'Formia',
		province: 'LT',
		altitude: 19
	},
	{
		zip: '81040',
		name: 'Formicola',
		province: 'CE',
		altitude: 192
	},
	{
		zip: '26020',
		name: 'Formigara',
		province: 'CR',
		altitude: 56
	},
	{
		zip: '41043',
		name: 'Formigine',
		province: 'MO',
		altitude: 82
	},
	{
		zip: '13030',
		name: 'Formigliana',
		province: 'VC',
		altitude: 157
	},
	{
		zip: '38040',
		name: 'Fornace',
		province: 'TN',
		altitude: 740
	},
	{
		zip: '86070',
		name: 'Fornelli',
		province: 'IS',
		altitude: 530
	},
	{
		zip: '33020',
		name: 'Forni Avoltri',
		province: 'UD',
		altitude: 888
	},
	{
		zip: '33024',
		name: 'Forni di Sopra',
		province: 'UD',
		altitude: 907
	},
	{
		zip: '33020',
		name: 'Forni di Sotto',
		province: 'UD',
		altitude: 777
	},
	{
		zip: '10084',
		name: 'Forno Canavese',
		province: 'TO',
		altitude: 584
	},
	{
		zip: '24040',
		name: 'Fornovo San Giovanni',
		province: 'BG',
		altitude: 109
	},
	{
		zip: '43045',
		name: 'Fornovo di Taro',
		province: 'PR',
		altitude: 158
	},
	{
		zip: '55042',
		name: 'Forte dei Marmi',
		province: 'LU',
		altitude: 2
	},
	{
		zip: '39045',
		name: 'Fortezza',
		province: 'BZ',
		altitude: 749
	},
	{
		zip: '27040',
		name: 'Fortunago',
		province: 'PV',
		altitude: 482
	},
	{
		zip: '98030',
		name: 'Forza d\'\'Agro',
		province: 'ME',
		altitude: 420
	},
	{
		zip: '55020',
		name: 'Fosciandora',
		province: 'LU',
		altitude: 390
	},
	{
		zip: '54035',
		name: 'Fosdinovo',
		province: 'MS',
		altitude: 500
	},
	{
		zip: '67020',
		name: 'Fossa',
		province: 'AQ',
		altitude: 644
	},
	{
		zip: '66022',
		name: 'Fossacesia',
		province: 'CH',
		altitude: 142
	},
	{
		zip: '30020',
		name: 'Fossalta di Piave',
		province: 'VE',
		altitude: 5
	},
	{
		zip: '30025',
		name: 'Fossalta di Portogruaro',
		province: 'VE',
		altitude: 8
	},
	{
		zip: '86020',
		name: 'Fossalto',
		province: 'CB',
		altitude: 511
	},
	{
		zip: '12045',
		name: 'Fossano',
		province: 'CN',
		altitude: 375
	},
	{
		zip: '88050',
		name: 'Fossato Serralta',
		province: 'CZ',
		altitude: 722
	},
	{
		zip: '06022',
		name: 'Fossato di Vico',
		province: 'PG',
		altitude: 581
	},
	{
		zip: '61034',
		name: 'Fossombrone',
		province: 'PU',
		altitude: 118
	},
	{
		zip: '30030',
		name: 'Fosso',
		province: 'VE',
		altitude: 7
	},
	{
		zip: '36010',
		name: 'Foza',
		province: 'VI',
		altitude: 1083
	},
	{
		zip: '12082',
		name: 'Frabosa Soprana',
		province: 'CN',
		altitude: 891
	},
	{
		zip: '12083',
		name: 'Frabosa Sottana',
		province: 'CN',
		altitude: 641
	},
	{
		zip: '15060',
		name: 'Fraconalto',
		province: 'AL',
		altitude: 725
	},
	{
		zip: '74022',
		name: 'Fragagnano',
		province: 'TA',
		altitude: 140
	},
	{
		zip: '82020',
		name: 'Fragneto Monforte',
		province: 'BN',
		altitude: 415
	},
	{
		zip: '82020',
		name: 'Fragneto l\'\'Abate',
		province: 'BN',
		altitude: 501
	},
	{
		zip: '66050',
		name: 'Fraine',
		province: 'CH',
		altitude: 751
	},
	{
		zip: '19014',
		name: 'Framura',
		province: 'SP',
		altitude: 76
	},
	{
		zip: '89815',
		name: 'Francavilla Angitola',
		province: 'VV',
		altitude: 290
	},
	{
		zip: '15060',
		name: 'Francavilla Bisio',
		province: 'AL',
		altitude: 160
	},
	{
		zip: '72021',
		name: 'Francavilla Fontana',
		province: 'BR',
		altitude: 142
	},
	{
		zip: '87072',
		name: 'Francavilla Marittima',
		province: 'CS',
		altitude: 273
	},
	{
		zip: '66023',
		name: 'Francavilla al Mare',
		province: 'CH',
		altitude: 19
	},
	{
		zip: '63816',
		name: 'Francavilla d\'\'Ete',
		province: 'FM',
		altitude: 231
	},
	{
		zip: '98034',
		name: 'Francavilla di Sicilia',
		province: 'ME',
		altitude: 330
	},
	{
		zip: '85034',
		name: 'Francavilla in Sinni',
		province: 'PZ',
		altitude: 421
	},
	{
		zip: '89851',
		name: 'Francica',
		province: 'VV',
		altitude: 322
	},
	{
		zip: '96015',
		name: 'Francofonte',
		province: 'SR',
		altitude: 281
	},
	{
		zip: '81050',
		name: 'Francolise',
		province: 'CE',
		altitude: 103
	},
	{
		zip: '15010',
		name: 'Frascaro',
		province: 'AL',
		altitude: 124
	},
	{
		zip: '27030',
		name: 'Frascarolo',
		province: 'PV',
		altitude: 87
	},
	{
		zip: '00044',
		name: 'Frascati',
		province: 'RM',
		altitude: 320
	},
	{
		zip: '87010',
		name: 'Frascineto',
		province: 'CS',
		altitude: 486
	},
	{
		zip: '38050',
		name: 'Frassilongo',
		province: 'TN',
		altitude: 852
	},
	{
		zip: '45030',
		name: 'Frassinelle Polesine',
		province: 'RO',
		altitude: 7
	},
	{
		zip: '15035',
		name: 'Frassinello Monferrato',
		province: 'AL',
		altitude: 261
	},
	{
		zip: '15040',
		name: 'Frassineto Po',
		province: 'AL',
		altitude: 104
	},
	{
		zip: '10080',
		name: 'Frassinetto',
		province: 'TO',
		altitude: 1048
	},
	{
		zip: '12020',
		name: 'Frassino',
		province: 'CN',
		altitude: 750
	},
	{
		zip: '41044',
		name: 'Frassinoro',
		province: 'MO',
		altitude: 1131
	},
	{
		zip: '02030',
		name: 'Frasso Sabino',
		province: 'RI',
		altitude: 412
	},
	{
		zip: '82030',
		name: 'Frasso Telesino',
		province: 'BN',
		altitude: 374
	},
	{
		zip: '45025',
		name: 'Fratta Polesine',
		province: 'RO',
		altitude: 11
	},
	{
		zip: '06054',
		name: 'Fratta Todina',
		province: 'PG',
		altitude: 215
	},
	{
		zip: '80027',
		name: 'Frattamaggiore',
		province: 'NA',
		altitude: 44
	},
	{
		zip: '80020',
		name: 'Frattaminore',
		province: 'NA',
		altitude: 36
	},
	{
		zip: '61040',
		name: 'Fratte Rosa',
		province: 'PU',
		altitude: 419
	},
	{
		zip: '98070',
		name: 'Frazzano',
		province: 'ME',
		altitude: 563
	},
	{
		zip: '31010',
		name: 'Fregona',
		province: 'TV',
		altitude: 251
	},
	{
		zip: '66050',
		name: 'Fresagrandinaria',
		province: 'CH',
		altitude: 391
	},
	{
		zip: '15064',
		name: 'Fresonara',
		province: 'AL',
		altitude: 143
	},
	{
		zip: '83040',
		name: 'Frigento',
		province: 'AV',
		altitude: 911
	},
	{
		zip: '81030',
		name: 'Frignano',
		province: 'CE',
		altitude: 30
	},
	{
		zip: '14030',
		name: 'Frinco',
		province: 'AT',
		altitude: 217
	},
	{
		zip: '66030',
		name: 'Frisa',
		province: 'CH',
		altitude: 237
	},
	{
		zip: '33080',
		name: 'Frisanco',
		province: 'PN',
		altitude: 500
	},
	{
		zip: '10070',
		name: 'Front',
		province: 'TO',
		altitude: 270
	},
	{
		zip: '61020',
		name: 'Frontino',
		province: 'PU',
		altitude: 519
	},
	{
		zip: '61040',
		name: 'Frontone',
		province: 'PU',
		altitude: 412
	},
	{
		zip: '03100',
		name: 'Frosinone',
		province: 'FR',
		altitude: 291
	},
	{
		zip: '86095',
		name: 'Frosolone',
		province: 'IS',
		altitude: 894
	},
	{
		zip: '10060',
		name: 'Frossasco',
		province: 'TO',
		altitude: 376
	},
	{
		zip: '15065',
		name: 'Frugarolo',
		province: 'AL',
		altitude: 112
	},
	{
		zip: '15043',
		name: 'Fubine Monferrato',
		province: 'AL',
		altitude: 192
	},
	{
		zip: '50054',
		name: 'Fucecchio',
		province: 'FI',
		altitude: 25
	},
	{
		zip: '24030',
		name: 'Fuipiano Valle Imagna',
		province: 'BG',
		altitude: 1055
	},
	{
		zip: '37022',
		name: 'Fumane',
		province: 'VR',
		altitude: 198
	},
	{
		zip: '03010',
		name: 'Fumone',
		province: 'FR',
		altitude: 783
	},
	{
		zip: '39040',
		name: 'Funes',
		province: 'BZ',
		altitude: 1109
	},
	{
		zip: '66050',
		name: 'Furci',
		province: 'CH',
		altitude: 550
	},
	{
		zip: '98023',
		name: 'Furci Siculo',
		province: 'ME',
		altitude: 9
	},
	{
		zip: '98054',
		name: 'Furnari',
		province: 'ME',
		altitude: 145
	},
	{
		zip: '84010',
		name: 'Furore',
		province: 'SA',
		altitude: 300
	},
	{
		zip: '09040',
		name: 'Furtei',
		province: 'SU',
		altitude: 90
	},
	{
		zip: '87024',
		name: 'Fuscaldo',
		province: 'CS',
		altitude: 350
	},
	{
		zip: '48034',
		name: 'Fusignano',
		province: 'RA',
		altitude: 9
	},
	{
		zip: '23010',
		name: 'Fusine',
		province: 'SO',
		altitude: 285
	},
	{
		zip: '84050',
		name: 'Futani',
		province: 'SA',
		altitude: 431
	},
	{
		zip: '11020',
		name: 'Fénis',
		province: 'AO',
		altitude: 541
	},
	{
		zip: '26030',
		name: 'Gabbioneta-Binanuova',
		province: 'CR',
		altitude: 38
	},
	{
		zip: '15020',
		name: 'Gabiano',
		province: 'AL',
		altitude: 300
	},
	{
		zip: '61011',
		name: 'Gabicce Mare',
		province: 'PU',
		altitude: 11
	},
	{
		zip: '11020',
		name: 'Gaby',
		province: 'AO',
		altitude: 1047
	},
	{
		zip: '26030',
		name: 'Gadesco-Pieve Delmona',
		province: 'CR',
		altitude: 44
	},
	{
		zip: '08030',
		name: 'Gadoni',
		province: 'NU',
		altitude: 696
	},
	{
		zip: '04024',
		name: 'Gaeta',
		province: 'LT',
		altitude: 2
	},
	{
		zip: '98030',
		name: 'Gaggi',
		province: 'ME',
		altitude: 106
	},
	{
		zip: '20083',
		name: 'Gaggiano',
		province: 'MI',
		altitude: 117
	},
	{
		zip: '40041',
		name: 'Gaggio Montano',
		province: 'BO',
		altitude: 682
	},
	{
		zip: '13894',
		name: 'Gaglianico',
		province: 'BI',
		altitude: 353
	},
	{
		zip: '67020',
		name: 'Gagliano Aterno',
		province: 'AQ',
		altitude: 650
	},
	{
		zip: '94010',
		name: 'Gagliano Castelferrato',
		province: 'EN',
		altitude: 651
	},
	{
		zip: '73034',
		name: 'Gagliano del Capo',
		province: 'LE',
		altitude: 144
	},
	{
		zip: '88060',
		name: 'Gagliato',
		province: 'CZ',
		altitude: 450
	},
	{
		zip: '62022',
		name: 'Gagliole',
		province: 'MC',
		altitude: 484
	},
	{
		zip: '31018',
		name: 'Gaiarine',
		province: 'TV',
		altitude: 20
	},
	{
		zip: '45030',
		name: 'Gaiba',
		province: 'RO',
		altitude: 9
	},
	{
		zip: '12010',
		name: 'Gaiola',
		province: 'CN',
		altitude: 692
	},
	{
		zip: '53013',
		name: 'Gaiole in Chianti',
		province: 'SI',
		altitude: 360
	},
	{
		zip: '08040',
		name: 'Gairo',
		province: 'NU',
		altitude: 670
	},
	{
		zip: '39030',
		name: 'Gais',
		province: 'BZ',
		altitude: 841
	},
	{
		zip: '98070',
		name: 'Galati Mamertino',
		province: 'ME',
		altitude: 820
	},
	{
		zip: '73013',
		name: 'Galatina',
		province: 'LE',
		altitude: 75
	},
	{
		zip: '73044',
		name: 'Galatone',
		province: 'LE',
		altitude: 58
	},
	{
		zip: '89054',
		name: 'Galatro',
		province: 'RC',
		altitude: 158
	},
	{
		zip: '23851',
		name: 'Galbiate',
		province: 'LC',
		altitude: 371
	},
	{
		zip: '47010',
		name: 'Galeata',
		province: 'FC',
		altitude: 237
	},
	{
		zip: '26832',
		name: 'Galgagnano',
		province: 'LO',
		altitude: 86
	},
	{
		zip: '21013',
		name: 'Gallarate',
		province: 'VA',
		altitude: 238
	},
	{
		zip: '01035',
		name: 'Gallese',
		province: 'VT',
		altitude: 135
	},
	{
		zip: '28066',
		name: 'Galliate',
		province: 'NO',
		altitude: 154
	},
	{
		zip: '21020',
		name: 'Galliate Lombardo',
		province: 'VA',
		altitude: 336
	},
	{
		zip: '27034',
		name: 'Galliavola',
		province: 'PV',
		altitude: 90
	},
	{
		zip: '55027',
		name: 'Gallicano',
		province: 'LU',
		altitude: 186
	},
	{
		zip: '00010',
		name: 'Gallicano nel Lazio',
		province: 'RM',
		altitude: 214
	},
	{
		zip: '85010',
		name: 'Gallicchio',
		province: 'PZ',
		altitude: 730
	},
	{
		zip: '40015',
		name: 'Galliera',
		province: 'BO',
		altitude: 9
	},
	{
		zip: '35015',
		name: 'Galliera Veneta',
		province: 'PD',
		altitude: 49
	},
	{
		zip: '03040',
		name: 'Gallinaro',
		province: 'FR',
		altitude: 558
	},
	{
		zip: '36032',
		name: 'Gallio',
		province: 'VI',
		altitude: 1093
	},
	{
		zip: '73014',
		name: 'Gallipoli',
		province: 'LE',
		altitude: 12
	},
	{
		zip: '81010',
		name: 'Gallo Matese',
		province: 'CE',
		altitude: 875
	},
	{
		zip: '98030',
		name: 'Gallodoro',
		province: 'ME',
		altitude: 388
	},
	{
		zip: '81044',
		name: 'Galluccio',
		province: 'CE',
		altitude: 368
	},
	{
		zip: '08020',
		name: 'Galtelli',
		province: 'NU',
		altitude: 35
	},
	{
		zip: '35030',
		name: 'Galzignano Terme',
		province: 'PD',
		altitude: 22
	},
	{
		zip: '15010',
		name: 'Gamalero',
		province: 'AL',
		altitude: 142
	},
	{
		zip: '25020',
		name: 'Gambara',
		province: 'BS',
		altitude: 51
	},
	{
		zip: '27030',
		name: 'Gambarana',
		province: 'PV',
		altitude: 83
	},
	{
		zip: '12030',
		name: 'Gambasca',
		province: 'CN',
		altitude: 478
	},
	{
		zip: '50050',
		name: 'Gambassi Terme',
		province: 'FI',
		altitude: 332
	},
	{
		zip: '86013',
		name: 'Gambatesa',
		province: 'CB',
		altitude: 468
	},
	{
		zip: '36053',
		name: 'Gambellara',
		province: 'VI',
		altitude: 70
	},
	{
		zip: '66040',
		name: 'Gamberale',
		province: 'CH',
		altitude: 1343
	},
	{
		zip: '47035',
		name: 'Gambettola',
		province: 'FC',
		altitude: 31
	},
	{
		zip: '27025',
		name: 'Gambolo',
		province: 'PV',
		altitude: 104
	},
	{
		zip: '36050',
		name: 'Gambugliano',
		province: 'VI',
		altitude: 133
	},
	{
		zip: '24020',
		name: 'Gandellino',
		province: 'BG',
		altitude: 675
	},
	{
		zip: '24024',
		name: 'Gandino',
		province: 'BG',
		altitude: 552
	},
	{
		zip: '24060',
		name: 'Gandosso',
		province: 'BG',
		altitude: 488
	},
	{
		zip: '90024',
		name: 'Gangi',
		province: 'PA',
		altitude: 1011
	},
	{
		zip: '75010',
		name: 'Garaguso',
		province: 'MT',
		altitude: 492
	},
	{
		zip: '15050',
		name: 'Garbagna',
		province: 'AL',
		altitude: 287
	},
	{
		zip: '28070',
		name: 'Garbagna Novarese',
		province: 'NO',
		altitude: 132
	},
	{
		zip: '20024',
		name: 'Garbagnate Milanese',
		province: 'MI',
		altitude: 179
	},
	{
		zip: '23846',
		name: 'Garbagnate Monastero',
		province: 'LC',
		altitude: 300
	},
	{
		zip: '37016',
		name: 'Garda',
		province: 'VR',
		altitude: 67
	},
	{
		zip: '25083',
		name: 'Gardone Riviera',
		province: 'BS',
		altitude: 71
	},
	{
		zip: '25063',
		name: 'Gardone Val Trompia',
		province: 'BS',
		altitude: 332
	},
	{
		zip: '12075',
		name: 'Garessio',
		province: 'CN',
		altitude: 621
	},
	{
		zip: '28010',
		name: 'Gargallo',
		province: 'NO',
		altitude: 397
	},
	{
		zip: '39010',
		name: 'Gargazzone',
		province: 'BZ',
		altitude: 267
	},
	{
		zip: '25084',
		name: 'Gargnano',
		province: 'BS',
		altitude: 66
	},
	{
		zip: '27026',
		name: 'Garlasco',
		province: 'PV',
		altitude: 93
	},
	{
		zip: '23852',
		name: 'Garlate',
		province: 'LC',
		altitude: 205
	},
	{
		zip: '17033',
		name: 'Garlenda',
		province: 'SV',
		altitude: 75
	},
	{
		zip: '38060',
		name: 'Garniga Terme',
		province: 'TN',
		altitude: 850
	},
	{
		zip: '22010',
		name: 'Garzeno',
		province: 'CO',
		altitude: 662
	},
	{
		zip: '10060',
		name: 'Garzigliana',
		province: 'TO',
		altitude: 314
	},
	{
		zip: '88060',
		name: 'Gasperina',
		province: 'CZ',
		altitude: 489
	},
	{
		zip: '10090',
		name: 'Gassino Torinese',
		province: 'TO',
		altitude: 230
	},
	{
		zip: '42043',
		name: 'Gattatico',
		province: 'RE',
		altitude: 40
	},
	{
		zip: '47043',
		name: 'Gatteo',
		province: 'FC',
		altitude: 20
	},
	{
		zip: '28013',
		name: 'Gattico-Veruno',
		province: 'NO',
		altitude: 383
	},
	{
		zip: '13045',
		name: 'Gattinara',
		province: 'VC',
		altitude: 263
	},
	{
		zip: '25085',
		name: 'Gavardo',
		province: 'BS',
		altitude: 199
	},
	{
		zip: '45010',
		name: 'Gavello',
		province: 'RO',
		altitude: 4
	},
	{
		zip: '24060',
		name: 'Gaverina Terme',
		province: 'BG',
		altitude: 509
	},
	{
		zip: '15066',
		name: 'Gavi',
		province: 'AL',
		altitude: 233
	},
	{
		zip: '00030',
		name: 'Gavignano',
		province: 'RM',
		altitude: 404
	},
	{
		zip: '21026',
		name: 'Gavirate',
		province: 'VA',
		altitude: 261
	},
	{
		zip: '08020',
		name: 'Gavoi',
		province: 'NU',
		altitude: 777
	},
	{
		zip: '58023',
		name: 'Gavorrano',
		province: 'GR',
		altitude: 273
	},
	{
		zip: '46040',
		name: 'Gazoldo degli Ippoliti',
		province: 'MN',
		altitude: 35
	},
	{
		zip: '21045',
		name: 'Gazzada Schianno',
		province: 'VA',
		altitude: 368
	},
	{
		zip: '24025',
		name: 'Gazzaniga',
		province: 'BG',
		altitude: 386
	},
	{
		zip: '35010',
		name: 'Gazzo',
		province: 'PD',
		altitude: 36
	},
	{
		zip: '37060',
		name: 'Gazzo Veronese',
		province: 'VR',
		altitude: 16
	},
	{
		zip: '29010',
		name: 'Gazzola',
		province: 'PC',
		altitude: 146
	},
	{
		zip: '46010',
		name: 'Gazzuolo',
		province: 'MN',
		altitude: 25
	},
	{
		zip: '47855',
		name: 'Gemmano',
		province: 'RN',
		altitude: 404
	},
	{
		zip: '33013',
		name: 'Gemona del Friuli',
		province: 'UD',
		altitude: 272
	},
	{
		zip: '21036',
		name: 'Gemonio',
		province: 'VA',
		altitude: 303
	},
	{
		zip: '00030',
		name: 'Genazzano',
		province: 'RM',
		altitude: 375
	},
	{
		zip: '60040',
		name: 'Genga',
		province: 'AN',
		altitude: 320
	},
	{
		zip: '26020',
		name: 'Genivolta',
		province: 'CR',
		altitude: 70
	},
	{
		zip: '12040',
		name: 'Genola',
		province: 'CN',
		altitude: 345
	},
	{
		zip: '09054',
		name: 'Genoni',
		province: 'SU',
		altitude: 447
	},
	{
		zip: '16121',
		name: 'Genova',
		province: 'GE',
		altitude: 19
	},
	{
		zip: '09020',
		name: 'Genuri',
		province: 'SU',
		altitude: 243
	},
	{
		zip: '85013',
		name: 'Genzano di Lucania',
		province: 'PZ',
		altitude: 587
	},
	{
		zip: '00045',
		name: 'Genzano di Roma',
		province: 'RO',
		altitude: 435
	},
	{
		zip: '22010',
		name: 'Gera Lario',
		province: 'CO',
		altitude: 201
	},
	{
		zip: '89040',
		name: 'Gerace',
		province: 'RC',
		altitude: 500
	},
	{
		zip: '90010',
		name: 'Geraci Siculo',
		province: 'PA',
		altitude: 1077
	},
	{
		zip: '00025',
		name: 'Gerano',
		province: 'RM',
		altitude: 502
	},
	{
		zip: '27010',
		name: 'Gerenzago',
		province: 'PV',
		altitude: 74
	},
	{
		zip: '21040',
		name: 'Gerenzano',
		province: 'VA',
		altitude: 226
	},
	{
		zip: '09055',
		name: 'Gergei',
		province: 'SU',
		altitude: 374
	},
	{
		zip: '10070',
		name: 'Germagnano',
		province: 'TO',
		altitude: 500
	},
	{
		zip: '28887',
		name: 'Germagno',
		province: 'VB',
		altitude: 602
	},
	{
		zip: '21010',
		name: 'Germignaga',
		province: 'VA',
		altitude: 204
	},
	{
		zip: '89831',
		name: 'Gerocarne',
		province: 'VV',
		altitude: 241
	},
	{
		zip: '23010',
		name: 'Gerola Alta',
		province: 'SO',
		altitude: 1050
	},
	{
		zip: '26040',
		name: 'Gerre de Caprioli',
		province: 'CR',
		altitude: 37
	},
	{
		zip: '09040',
		name: 'Gesico',
		province: 'SU',
		altitude: 300
	},
	{
		zip: '20060',
		name: 'Gessate',
		province: 'MI',
		altitude: 144
	},
	{
		zip: '66010',
		name: 'Gessopalena',
		province: 'CH',
		altitude: 654
	},
	{
		zip: '09020',
		name: 'Gesturi',
		province: 'SU',
		altitude: 310
	},
	{
		zip: '83040',
		name: 'Gesualdo',
		province: 'AV',
		altitude: 676
	},
	{
		zip: '25016',
		name: 'Ghedi',
		province: 'BS',
		altitude: 85
	},
	{
		zip: '28074',
		name: 'Ghemme',
		province: 'NO',
		altitude: 241
	},
	{
		zip: '28823',
		name: 'Ghiffa',
		province: 'VB',
		altitude: 201
	},
	{
		zip: '09074',
		name: 'Ghilarza',
		province: 'OR',
		altitude: 290
	},
	{
		zip: '24050',
		name: 'Ghisalba',
		province: 'BG',
		altitude: 170
	},
	{
		zip: '13030',
		name: 'Ghislarengo',
		province: 'VC',
		altitude: 206
	},
	{
		zip: '45020',
		name: 'Giacciano con Baruchella',
		province: 'RO',
		altitude: 14
	},
	{
		zip: '10050',
		name: 'Giaglione',
		province: 'TO',
		altitude: 774
	},
	{
		zip: '25040',
		name: 'Gianico',
		province: 'BS',
		altitude: 287
	},
	{
		zip: '81042',
		name: 'Giano Vetusto',
		province: 'CE',
		altitude: 225
	},
	{
		zip: '06030',
		name: 'Giano dell\'\'Umbria',
		province: 'PG',
		altitude: 546
	},
	{
		zip: '90040',
		name: 'Giardinello',
		province: 'PA',
		altitude: 275
	},
	{
		zip: '98035',
		name: 'Giardini-Naxos',
		province: 'ME',
		altitude: 5
	},
	{
		zip: '15036',
		name: 'Giarole',
		province: 'AL',
		altitude: 98
	},
	{
		zip: '97010',
		name: 'Giarratana',
		province: 'RG',
		altitude: 520
	},
	{
		zip: '95014',
		name: 'Giarre',
		province: 'CT',
		altitude: 81
	},
	{
		zip: '07010',
		name: 'Giave',
		province: 'SS',
		altitude: 595
	},
	{
		zip: '10094',
		name: 'Giaveno',
		province: 'TO',
		altitude: 506
	},
	{
		zip: '31040',
		name: 'Giavera del Montello',
		province: 'TV',
		altitude: 78
	},
	{
		zip: '09010',
		name: 'Giba',
		province: 'SU',
		altitude: 59
	},
	{
		zip: '91024',
		name: 'Gibellina',
		province: 'TP',
		altitude: 233
	},
	{
		zip: '13874',
		name: 'Gifflenga',
		province: 'BI',
		altitude: 187
	},
	{
		zip: '89020',
		name: 'Giffone',
		province: 'RC',
		altitude: 594
	},
	{
		zip: '84090',
		name: 'Giffoni Sei Casali',
		province: 'SA',
		altitude: 225
	},
	{
		zip: '84095',
		name: 'Giffoni Valle Piana',
		province: 'SA',
		altitude: 200
	},
	{
		zip: '28836',
		name: 'Gignese',
		province: 'VB',
		altitude: 707
	},
	{
		zip: '11010',
		name: 'Gignod',
		province: 'AO',
		altitude: 988
	},
	{
		zip: '86010',
		name: 'Gildone',
		province: 'CB',
		altitude: 608
	},
	{
		zip: '88045',
		name: 'Gimigliano',
		province: 'CZ',
		altitude: 600
	},
	{
		zip: '85020',
		name: 'Ginestra',
		province: 'PZ',
		altitude: 564
	},
	{
		zip: '82020',
		name: 'Ginestra degli Schiavoni',
		province: 'BN',
		altitude: 540
	},
	{
		zip: '74013',
		name: 'Ginosa',
		province: 'TA',
		altitude: 240
	},
	{
		zip: '84056',
		name: 'Gioi',
		province: 'SA',
		altitude: 684
	},
	{
		zip: '81010',
		name: 'Gioia Sannitica',
		province: 'CE',
		altitude: 275
	},
	{
		zip: '89013',
		name: 'Gioia Tauro',
		province: 'RC',
		altitude: 29
	},
	{
		zip: '67055',
		name: 'Gioia dei Marsi',
		province: 'AQ',
		altitude: 725
	},
	{
		zip: '70023',
		name: 'Gioia del Colle',
		province: 'BA',
		altitude: 360
	},
	{
		zip: '89042',
		name: 'Gioiosa Ionica',
		province: 'RC',
		altitude: 120
	},
	{
		zip: '98063',
		name: 'Gioiosa Marea',
		province: 'ME',
		altitude: 30
	},
	{
		zip: '05024',
		name: 'Giove',
		province: 'TR',
		altitude: 292
	},
	{
		zip: '70054',
		name: 'Giovinazzo',
		province: 'BA',
		altitude: 7
	},
	{
		zip: '38030',
		name: 'Giovo',
		province: 'TN',
		altitude: 496
	},
	{
		zip: '08040',
		name: 'Girasole',
		province: 'NU',
		altitude: 10
	},
	{
		zip: '88024',
		name: 'Girifalco',
		province: 'CZ',
		altitude: 456
	},
	{
		zip: '66052',
		name: 'Gissi',
		province: 'CH',
		altitude: 499
	},
	{
		zip: '73030',
		name: 'Giuggianello',
		province: 'LE',
		altitude: 79
	},
	{
		zip: '80014',
		name: 'Giugliano in Campania',
		province: 'NA',
		altitude: 97
	},
	{
		zip: '90030',
		name: 'Giuliana',
		province: 'PA',
		altitude: 710
	},
	{
		zip: '66010',
		name: 'Giuliano Teatino',
		province: 'CH',
		altitude: 272
	},
	{
		zip: '03020',
		name: 'Giuliano di Roma',
		province: 'FR',
		altitude: 363
	},
	{
		zip: '64021',
		name: 'Giulianova',
		province: 'TE',
		altitude: 68
	},
	{
		zip: '84050',
		name: 'Giungano',
		province: 'SA',
		altitude: 250
	},
	{
		zip: '73020',
		name: 'Giurdignano',
		province: 'LE',
		altitude: 78
	},
	{
		zip: '27010',
		name: 'Giussago',
		province: 'PV',
		altitude: 91
	},
	{
		zip: '20833',
		name: 'Giussano',
		province: 'MB',
		altitude: 256
	},
	{
		zip: '17027',
		name: 'Giustenice',
		province: 'SV',
		altitude: 140
	},
	{
		zip: '38086',
		name: 'Giustino',
		province: 'TN',
		altitude: 780
	},
	{
		zip: '17010',
		name: 'Giusvalla',
		province: 'SV',
		altitude: 475
	},
	{
		zip: '10040',
		name: 'Givoletto',
		province: 'TO',
		altitude: 398
	},
	{
		zip: '88040',
		name: 'Gizzeria',
		province: 'CZ',
		altitude: 630
	},
	{
		zip: '39020',
		name: 'Glorenza',
		province: 'BZ',
		altitude: 907
	},
	{
		zip: '31010',
		name: 'Godega di Sant\'\'Urbano',
		province: 'TV',
		altitude: 52
	},
	{
		zip: '27052',
		name: 'Godiasco Salice Terme',
		province: 'PV',
		altitude: 196
	},
	{
		zip: '90030',
		name: 'Godrano',
		province: 'PA',
		altitude: 693
	},
	{
		zip: '46044',
		name: 'Goito',
		province: 'MN',
		altitude: 33
	},
	{
		zip: '21010',
		name: 'Golasecca',
		province: 'VA',
		altitude: 280
	},
	{
		zip: '27047',
		name: 'Golferenzo',
		province: 'PV',
		altitude: 464
	},
	{
		zip: '07020',
		name: 'Golfo Aranci',
		province: 'SS',
		altitude: 19
	},
	{
		zip: '26020',
		name: 'Gombito',
		province: 'CR',
		altitude: 65
	},
	{
		zip: '33050',
		name: 'Gonars',
		province: 'UD',
		altitude: 21
	},
	{
		zip: '09040',
		name: 'Goni',
		province: 'SU',
		altitude: 383
	},
	{
		zip: '09010',
		name: 'Gonnesa',
		province: 'SU',
		altitude: 40
	},
	{
		zip: '09090',
		name: 'Gonnoscodina',
		province: 'OR',
		altitude: 112
	},
	{
		zip: '09035',
		name: 'Gonnosfanadiga',
		province: 'SU',
		altitude: 180
	},
	{
		zip: '09090',
		name: 'Gonnosno',
		province: 'OR',
		altitude: 220
	},
	{
		zip: '09093',
		name: 'Gonnostramatza',
		province: 'OR',
		altitude: 104
	},
	{
		zip: '46023',
		name: 'Gonzaga',
		province: 'MN',
		altitude: 22
	},
	{
		zip: '23020',
		name: 'Gordona',
		province: 'SO',
		altitude: 283
	},
	{
		zip: '00030',
		name: 'Gorga',
		province: 'RM',
		altitude: 766
	},
	{
		zip: '31040',
		name: 'Gorgo al Monticano',
		province: 'TV',
		altitude: 10
	},
	{
		zip: '75010',
		name: 'Gorgoglione',
		province: 'MT',
		altitude: 800
	},
	{
		zip: '20064',
		name: 'Gorgonzola',
		province: 'MI',
		altitude: 133
	},
	{
		zip: '67030',
		name: 'Goriano Sicoli',
		province: 'AQ',
		altitude: 720
	},
	{
		zip: '34170',
		name: 'Gorizia',
		province: 'GO',
		altitude: 86
	},
	{
		zip: '21050',
		name: 'Gorla Maggiore',
		province: 'VA',
		altitude: 254
	},
	{
		zip: '21055',
		name: 'Gorla Minore',
		province: 'VA',
		altitude: 239
	},
	{
		zip: '24060',
		name: 'Gorlago',
		province: 'BG',
		altitude: 233
	},
	{
		zip: '24020',
		name: 'Gorle',
		province: 'BG',
		altitude: 268
	},
	{
		zip: '21040',
		name: 'Gornate Olona',
		province: 'VA',
		altitude: 303
	},
	{
		zip: '24020',
		name: 'Gorno',
		province: 'BG',
		altitude: 710
	},
	{
		zip: '44020',
		name: 'Goro',
		province: 'FE',
		altitude: 1
	},
	{
		zip: '16020',
		name: 'Gorreto',
		province: 'GE',
		altitude: 533
	},
	{
		zip: '12070',
		name: 'Gorzegno',
		province: 'CN',
		altitude: 319
	},
	{
		zip: '32020',
		name: 'Gosaldo',
		province: 'BL',
		altitude: 1141
	},
	{
		zip: '29020',
		name: 'Gossolengo',
		province: 'PC',
		altitude: 86
	},
	{
		zip: '12070',
		name: 'Gottasecca',
		province: 'CN',
		altitude: 710
	},
	{
		zip: '25023',
		name: 'Gottolengo',
		province: 'BS',
		altitude: 53
	},
	{
		zip: '12040',
		name: 'Govone',
		province: 'CN',
		altitude: 301
	},
	{
		zip: '28024',
		name: 'Gozzano',
		province: 'NO',
		altitude: 367
	},
	{
		zip: '61012',
		name: 'Gradara',
		province: 'PU',
		altitude: 142
	},
	{
		zip: '34072',
		name: 'Gradisca d\'\'Isonzo',
		province: 'GO',
		altitude: 32
	},
	{
		zip: '34073',
		name: 'Grado',
		province: 'GO',
		altitude: 2
	},
	{
		zip: '01010',
		name: 'Gradoli',
		province: 'VT',
		altitude: 470
	},
	{
		zip: '26813',
		name: 'Graffignana',
		province: 'LO',
		altitude: 67
	},
	{
		zip: '01020',
		name: 'Graffignano',
		province: 'VT',
		altitude: 187
	},
	{
		zip: '13895',
		name: 'Graglia',
		province: 'BI',
		altitude: 596
	},
	{
		zip: '80054',
		name: 'Gragnano',
		province: 'NA',
		altitude: 141
	},
	{
		zip: '29010',
		name: 'Gragnano Trebbiense',
		province: 'PC',
		altitude: 82
	},
	{
		zip: '95042',
		name: 'Grammichele',
		province: 'CT',
		altitude: 520
	},
	{
		zip: '14031',
		name: 'Grana',
		province: 'AT',
		altitude: 289
	},
	{
		zip: '40057',
		name: 'Granarolo dell\'\'Emilia',
		province: 'BO',
		altitude: 28
	},
	{
		zip: '22070',
		name: 'Grandate',
		province: 'CO',
		altitude: 320
	},
	{
		zip: '22010',
		name: 'Grandola ed Uniti',
		province: 'CO',
		altitude: 443
	},
	{
		zip: '98036',
		name: 'Graniti',
		province: 'ME',
		altitude: 350
	},
	{
		zip: '28060',
		name: 'Granozzo con Monticello',
		province: 'NO',
		altitude: 129
	},
	{
		zip: '21030',
		name: 'Grantola',
		province: 'VA',
		altitude: 250
	},
	{
		zip: '35010',
		name: 'Grantorto',
		province: 'PD',
		altitude: 36
	},
	{
		zip: '35040',
		name: 'Granze',
		province: 'PD',
		altitude: 6
	},
	{
		zip: '75014',
		name: 'Grassano',
		province: 'MT',
		altitude: 559
	},
	{
		zip: '24050',
		name: 'Grassobbio',
		province: 'BG',
		altitude: 225
	},
	{
		zip: '90010',
		name: 'Gratteri',
		province: 'PA',
		altitude: 670
	},
	{
		zip: '22015',
		name: 'Gravedona ed Uniti',
		province: 'CO',
		altitude: 201
	},
	{
		zip: '27020',
		name: 'Gravellona Lomellina',
		province: 'PV',
		altitude: 118
	},
	{
		zip: '28883',
		name: 'Gravellona Toce',
		province: 'VB',
		altitude: 211
	},
	{
		zip: '10050',
		name: 'Gravere',
		province: 'TO',
		altitude: 821
	},
	{
		zip: '95030',
		name: 'Gravina di Catania',
		province: 'CT',
		altitude: 355
	},
	{
		zip: '70024',
		name: 'Gravina in Puglia',
		province: 'BA',
		altitude: 338
	},
	{
		zip: '81046',
		name: 'Grazzanise',
		province: 'CE',
		altitude: 12
	},
	{
		zip: '14035',
		name: 'Grazzano Badoglio',
		province: 'AT',
		altitude: 299
	},
	{
		zip: '02040',
		name: 'Greccio',
		province: 'RI',
		altitude: 705
	},
	{
		zip: '83030',
		name: 'Greci',
		province: 'AV',
		altitude: 821
	},
	{
		zip: '13030',
		name: 'Greggio',
		province: 'VC',
		altitude: 161
	},
	{
		zip: '15050',
		name: 'Gremiasco',
		province: 'AL',
		altitude: 400
	},
	{
		zip: '11020',
		name: 'Gressan',
		province: 'AO',
		altitude: 626
	},
	{
		zip: '11020',
		name: 'Gressoney-La-Trinité',
		province: 'AO',
		altitude: 1635
	},
	{
		zip: '11025',
		name: 'Gressoney-Saint-Jean',
		province: 'AO',
		altitude: 1385
	},
	{
		zip: '50022',
		name: 'Greve in Chianti',
		province: 'FI',
		altitude: 236
	},
	{
		zip: '20056',
		name: 'Grezzago',
		province: 'MI',
		altitude: 178
	},
	{
		zip: '37023',
		name: 'Grezzana',
		province: 'VR',
		altitude: 630
	},
	{
		zip: '22011',
		name: 'Griante',
		province: 'CO',
		altitude: 274
	},
	{
		zip: '81030',
		name: 'Gricignano di Aversa',
		province: 'CE',
		altitude: 28
	},
	{
		zip: '28075',
		name: 'Grignasco',
		province: 'NO',
		altitude: 322
	},
	{
		zip: '38055',
		name: 'Grigno',
		province: 'TN',
		altitude: 263
	},
	{
		zip: '33040',
		name: 'Grimacco',
		province: 'UD',
		altitude: 248
	},
	{
		zip: '87034',
		name: 'Grimaldi',
		province: 'CS',
		altitude: 650
	},
	{
		zip: '12060',
		name: 'Grinzane Cavour',
		province: 'CN',
		altitude: 195
	},
	{
		zip: '36040',
		name: 'Grisignano di Zocco',
		province: 'VI',
		altitude: 23
	},
	{
		zip: '87020',
		name: 'Grisolia',
		province: 'CS',
		altitude: 465
	},
	{
		zip: '40030',
		name: 'Grizzana Morandi',
		province: 'BO',
		altitude: 547
	},
	{
		zip: '15010',
		name: 'Grognardo',
		province: 'AL',
		altitude: 206
	},
	{
		zip: '24020',
		name: 'Gromo',
		province: 'BG',
		altitude: 676
	},
	{
		zip: '15060',
		name: 'Grondona',
		province: 'AL',
		altitude: 303
	},
	{
		zip: '24060',
		name: 'Grone',
		province: 'BG',
		altitude: 388
	},
	{
		zip: '26044',
		name: 'Grontardo',
		province: 'CR',
		altitude: 46
	},
	{
		zip: '27027',
		name: 'Gropello Cairoli',
		province: 'PV',
		altitude: 89
	},
	{
		zip: '29025',
		name: 'Gropparello',
		province: 'PC',
		altitude: 355
	},
	{
		zip: '10070',
		name: 'Groscavallo',
		province: 'TO',
		altitude: 1110
	},
	{
		zip: '23033',
		name: 'Grosio',
		province: 'SO',
		altitude: 656
	},
	{
		zip: '23034',
		name: 'Grosotto',
		province: 'SO',
		altitude: 610
	},
	{
		zip: '58100',
		name: 'Grosseto',
		province: 'GR',
		altitude: 10
	},
	{
		zip: '10070',
		name: 'Grosso',
		province: 'TO',
		altitude: 394
	},
	{
		zip: '00046',
		name: 'Grottaferrata',
		province: 'RM',
		altitude: 320
	},
	{
		zip: '74023',
		name: 'Grottaglie',
		province: 'TA',
		altitude: 133
	},
	{
		zip: '83035',
		name: 'Grottaminarda',
		province: 'AV',
		altitude: 405
	},
	{
		zip: '63066',
		name: 'Grottammare',
		province: 'AP',
		altitude: 4
	},
	{
		zip: '63844',
		name: 'Grottazzolina',
		province: 'FM',
		altitude: 222
	},
	{
		zip: '92020',
		name: 'Grotte',
		province: 'AG',
		altitude: 516
	},
	{
		zip: '01025',
		name: 'Grotte di Castro',
		province: 'VT',
		altitude: 467
	},
	{
		zip: '89043',
		name: 'Grotteria',
		province: 'RC',
		altitude: 317
	},
	{
		zip: '75010',
		name: 'Grottole',
		province: 'MT',
		altitude: 482
	},
	{
		zip: '83010',
		name: 'Grottolella',
		province: 'AV',
		altitude: 565
	},
	{
		zip: '30020',
		name: 'Gruaro',
		province: 'VE',
		altitude: 10
	},
	{
		zip: '10095',
		name: 'Grugliasco',
		province: 'TO',
		altitude: 293
	},
	{
		zip: '26023',
		name: 'Grumello Cremonese ed Uniti',
		province: 'CR',
		altitude: 50
	},
	{
		zip: '24064',
		name: 'Grumello del Monte',
		province: 'BG',
		altitude: 208
	},
	{
		zip: '85050',
		name: 'Grumento Nova',
		province: 'PZ',
		altitude: 771
	},
	{
		zip: '70025',
		name: 'Grumo Appula',
		province: 'BA',
		altitude: 181
	},
	{
		zip: '80028',
		name: 'Grumo Nevano',
		province: 'NA',
		altitude: 53
	},
	{
		zip: '36040',
		name: 'Grumolo delle Abbadesse',
		province: 'VI',
		altitude: 30
	},
	{
		zip: '73010',
		name: 'Guagnano',
		province: 'LE',
		altitude: 44
	},
	{
		zip: '62020',
		name: 'Gualdo',
		province: 'MC',
		altitude: 650
	},
	{
		zip: '06035',
		name: 'Gualdo Cattaneo',
		province: 'PG',
		altitude: 446
	},
	{
		zip: '06023',
		name: 'Gualdo Tadino',
		province: 'PG',
		altitude: 536
	},
	{
		zip: '42044',
		name: 'Gualtieri',
		province: 'RE',
		altitude: 22
	},
	{
		zip: '98040',
		name: 'Gualtieri Sicamino',
		province: 'ME',
		altitude: 80
	},
	{
		zip: '09040',
		name: 'Guamaggiore',
		province: 'SU',
		altitude: 199
	},
	{
		zip: '22070',
		name: 'Guanzate',
		province: 'CO',
		altitude: 342
	},
	{
		zip: '03016',
		name: 'Guarcino',
		province: 'FR',
		altitude: 675
	},
	{
		zip: '45030',
		name: 'Guarda Veneta',
		province: 'RO',
		altitude: 5
	},
	{
		zip: '13010',
		name: 'Guardabosone',
		province: 'VC',
		altitude: 479
	},
	{
		zip: '26862',
		name: 'Guardamiglio',
		province: 'LO',
		altitude: 49
	},
	{
		zip: '88065',
		name: 'Guardavalle',
		province: 'CZ',
		altitude: 225
	},
	{
		zip: '05025',
		name: 'Guardea',
		province: 'TR',
		altitude: 387
	},
	{
		zip: '83040',
		name: 'Guardia Lombardi',
		province: 'AV',
		altitude: 998
	},
	{
		zip: '85010',
		name: 'Guardia Perticara',
		province: 'PZ',
		altitude: 750
	},
	{
		zip: '87020',
		name: 'Guardia Piemontese',
		province: 'CS',
		altitude: 515
	},
	{
		zip: '82034',
		name: 'Guardia Sanframondi',
		province: 'BN',
		altitude: 428
	},
	{
		zip: '66016',
		name: 'Guardiagrele',
		province: 'CH',
		altitude: 576
	},
	{
		zip: '86030',
		name: 'Guardialfiera',
		province: 'CB',
		altitude: 274
	},
	{
		zip: '86014',
		name: 'Guardiaregia',
		province: 'CB',
		altitude: 730
	},
	{
		zip: '56040',
		name: 'Guardistallo',
		province: 'PI',
		altitude: 278
	},
	{
		zip: '12050',
		name: 'Guarene',
		province: 'CN',
		altitude: 360
	},
	{
		zip: '09040',
		name: 'Guasila',
		province: 'SU',
		altitude: 210
	},
	{
		zip: '42016',
		name: 'Guastalla',
		province: 'RE',
		altitude: 25
	},
	{
		zip: '15050',
		name: 'Guazzora',
		province: 'AL',
		altitude: 78
	},
	{
		zip: '06024',
		name: 'Gubbio',
		province: 'PG',
		altitude: 522
	},
	{
		zip: '20088',
		name: 'Gudo Visconti',
		province: 'MI',
		altitude: 111
	},
	{
		zip: '86034',
		name: 'Guglionesi',
		province: 'CB',
		altitude: 369
	},
	{
		zip: '46040',
		name: 'Guidizzolo',
		province: 'MN',
		altitude: 61
	},
	{
		zip: '00012',
		name: 'Guidonia Montecelio',
		province: 'RM',
		altitude: 105
	},
	{
		zip: '41052',
		name: 'Guiglia',
		province: 'MO',
		altitude: 490
	},
	{
		zip: '66050',
		name: 'Guilmi',
		province: 'CH',
		altitude: 674
	},
	{
		zip: '28828',
		name: 'Gurro',
		province: 'VB',
		altitude: 812
	},
	{
		zip: '09036',
		name: 'Guspini',
		province: 'SU',
		altitude: 137
	},
	{
		zip: '25064',
		name: 'Gussago',
		province: 'BS',
		altitude: 190
	},
	{
		zip: '26040',
		name: 'Gussola',
		province: 'CR',
		altitude: 27
	},
	{
		zip: '11020',
		name: 'Hône',
		province: 'AO',
		altitude: 364
	},
	{
		zip: '25074',
		name: 'Idro',
		province: 'BS',
		altitude: 368
	},
	{
		zip: '09016',
		name: 'Iglesias',
		province: 'SU',
		altitude: 200
	},
	{
		zip: '12060',
		name: 'Igliano',
		province: 'CN',
		altitude: 532
	},
	{
		zip: '08040',
		name: 'Ilbono',
		province: 'NU',
		altitude: 400
	},
	{
		zip: '37031',
		name: 'Illasi',
		province: 'VR',
		altitude: 157
	},
	{
		zip: '07010',
		name: 'Illorai',
		province: 'SS',
		altitude: 503
	},
	{
		zip: '23898',
		name: 'Imbersago',
		province: 'LC',
		altitude: 249
	},
	{
		zip: '38050',
		name: 'Imer',
		province: 'TN',
		altitude: 670
	},
	{
		zip: '40026',
		name: 'Imola',
		province: 'BO',
		altitude: 47
	},
	{
		zip: '18100',
		name: 'Imperia',
		province: 'IM',
		altitude: 10
	},
	{
		zip: '50023',
		name: 'Impruneta',
		province: 'FI',
		altitude: 275
	},
	{
		zip: '21020',
		name: 'Inarzo',
		province: 'VA',
		altitude: 283
	},
	{
		zip: '14045',
		name: 'Incisa Scapaccino',
		province: 'AT',
		altitude: 131
	},
	{
		zip: '25040',
		name: 'Incudine',
		province: 'BS',
		altitude: 910
	},
	{
		zip: '21056',
		name: 'Induno Olona',
		province: 'VA',
		altitude: 394
	},
	{
		zip: '10080',
		name: 'Ingria',
		province: 'TO',
		altitude: 816
	},
	{
		zip: '28816',
		name: 'Intragna',
		province: 'VB',
		altitude: 729
	},
	{
		zip: '23815',
		name: 'Introbio',
		province: 'LC',
		altitude: 586
	},
	{
		zip: '11010',
		name: 'Introd',
		province: 'AO',
		altitude: 880
	},
	{
		zip: '67030',
		name: 'Introdacqua',
		province: 'AQ',
		altitude: 642
	},
	{
		zip: '22044',
		name: 'Inverigo',
		province: 'CO',
		altitude: 346
	},
	{
		zip: '27010',
		name: 'Inverno e Monteleone',
		province: 'PV',
		altitude: 74
	},
	{
		zip: '10060',
		name: 'Inverso Pinasca',
		province: 'TO',
		altitude: 600
	},
	{
		zip: '20010',
		name: 'Inveruno',
		province: 'MI',
		altitude: 161
	},
	{
		zip: '28045',
		name: 'Invorio',
		province: 'NO',
		altitude: 366
	},
	{
		zip: '20065',
		name: 'Inzago',
		province: 'MI',
		altitude: 137
	},
	{
		zip: '89851',
		name: 'Ionadi',
		province: 'VV',
		altitude: 430
	},
	{
		zip: '08020',
		name: 'Irgoli',
		province: 'NU',
		altitude: 26
	},
	{
		zip: '25061',
		name: 'Irma',
		province: 'BS',
		altitude: 804
	},
	{
		zip: '75022',
		name: 'Irsina',
		province: 'MT',
		altitude: 548
	},
	{
		zip: '12020',
		name: 'Isasca',
		province: 'CN',
		altitude: 660
	},
	{
		zip: '88060',
		name: 'Isca sullo Ionio',
		province: 'CZ',
		altitude: 188
	},
	{
		zip: '80077',
		name: 'Ischia',
		province: 'NA',
		altitude: 2
	},
	{
		zip: '01010',
		name: 'Ischia di Castro',
		province: 'VT',
		altitude: 384
	},
	{
		zip: '71010',
		name: 'Ischitella',
		province: 'FG',
		altitude: 314
	},
	{
		zip: '25049',
		name: 'Iseo',
		province: 'BS',
		altitude: 186
	},
	{
		zip: '38060',
		name: 'Isera',
		province: 'TN',
		altitude: 243
	},
	{
		zip: '86170',
		name: 'Isernia',
		province: 'IS',
		altitude: 423
	},
	{
		zip: '09056',
		name: 'Isili',
		province: 'SU',
		altitude: 523
	},
	{
		zip: '90010',
		name: 'Isnello',
		province: 'PA',
		altitude: 530
	},
	{
		zip: '26031',
		name: 'Isola Dovarese',
		province: 'CR',
		altitude: 35
	},
	{
		zip: '37050',
		name: 'Isola Rizza',
		province: 'VR',
		altitude: 23
	},
	{
		zip: '15050',
		name: 'Isola Sant\'\'Antonio',
		province: 'AL',
		altitude: 76
	},
	{
		zip: '36033',
		name: 'Isola Vicentina',
		province: 'VI',
		altitude: 55
	},
	{
		zip: '14057',
		name: 'Isola d\'\'Asti',
		province: 'AT',
		altitude: 136
	},
	{
		zip: '16017',
		name: 'Isola del Cantone',
		province: 'GE',
		altitude: 298
	},
	{
		zip: '58012',
		name: 'Isola del Giglio',
		province: 'GR',
		altitude: 496
	},
	{
		zip: '64045',
		name: 'Isola del Gran Sasso d\'\'Italia',
		province: 'TE',
		altitude: 415
	},
	{
		zip: '03036',
		name: 'Isola del Liri',
		province: 'FR',
		altitude: 217
	},
	{
		zip: '61030',
		name: 'Isola del Piano',
		province: 'PU',
		altitude: 210
	},
	{
		zip: '37063',
		name: 'Isola della Scala',
		province: 'VR',
		altitude: 31
	},
	{
		zip: '90040',
		name: 'Isola delle Femmine',
		province: 'PA',
		altitude: 7
	},
	{
		zip: '88841',
		name: 'Isola di Capo Rizzuto',
		province: 'KR',
		altitude: 90
	},
	{
		zip: '24010',
		name: 'Isola di Fondra',
		province: 'BG',
		altitude: 799
	},
	{
		zip: '18035',
		name: 'Isolabona',
		province: 'IM',
		altitude: 106
	},
	{
		zip: '71051',
		name: 'Isole Tremiti',
		province: 'FG',
		altitude: 70
	},
	{
		zip: '25010',
		name: 'Isorella',
		province: 'BS',
		altitude: 56
	},
	{
		zip: '84050',
		name: 'Ispani',
		province: 'SA',
		altitude: 256
	},
	{
		zip: '97014',
		name: 'Ispica',
		province: 'RG',
		altitude: 170
	},
	{
		zip: '21027',
		name: 'Ispra',
		province: 'VA',
		altitude: 220
	},
	{
		zip: '10080',
		name: 'Issiglio',
		province: 'TO',
		altitude: 485
	},
	{
		zip: '11020',
		name: 'Issime',
		province: 'AO',
		altitude: 956
	},
	{
		zip: '24040',
		name: 'Isso',
		province: 'BG',
		altitude: 104
	},
	{
		zip: '11020',
		name: 'Issogne',
		province: 'AO',
		altitude: 387
	},
	{
		zip: '31036',
		name: 'Istrana',
		province: 'TV',
		altitude: 32
	},
	{
		zip: '98025',
		name: 'Itala',
		province: 'ME',
		altitude: 210
	},
	{
		zip: '04020',
		name: 'Itri',
		province: 'LT',
		altitude: 170
	},
	{
		zip: '07010',
		name: 'Ittireddu',
		province: 'SS',
		altitude: 313
	},
	{
		zip: '07044',
		name: 'Ittiri',
		province: 'SS',
		altitude: 400
	},
	{
		zip: '10015',
		name: 'Ivrea',
		province: 'TO',
		altitude: 330
	},
	{
		zip: '26010',
		name: 'Izano',
		province: 'CR',
		altitude: 74
	},
	{
		zip: '88020',
		name: 'Jacurso',
		province: 'CZ',
		altitude: 441
	},
	{
		zip: '86015',
		name: 'Jelsi',
		province: 'CB',
		altitude: 580
	},
	{
		zip: '00020',
		name: 'Jenne',
		province: 'RM',
		altitude: 834
	},
	{
		zip: '21040',
		name: 'Jerago con Orago',
		province: 'VA',
		altitude: 324
	},
	{
		zip: '08044',
		name: 'Jerzu',
		province: 'NU',
		altitude: 427
	},
	{
		zip: '60035',
		name: 'Jesi',
		province: 'AN',
		altitude: 97
	},
	{
		zip: '30016',
		name: 'Jesolo',
		province: 'VE',
		altitude: 2
	},
	{
		zip: '44037',
		name: 'Jolanda di Savoia',
		province: 'FE',
		altitude: 1
	},
	{
		zip: '89863',
		name: 'Joppolo',
		province: 'VV',
		altitude: 177
	},
	{
		zip: '92010',
		name: 'Joppolo Giancaxio',
		province: 'AG',
		altitude: 275
	},
	{
		zip: '11020',
		name: 'Jovençan',
		province: 'AO',
		altitude: 632
	},
	{
		zip: '67100',
		name: 'L\'\'Aquila',
		province: 'AQ',
		altitude: 714
	},
	{
		zip: '10040',
		name: 'La Cassa',
		province: 'TO',
		altitude: 374
	},
	{
		zip: '10040',
		name: 'La Loggia',
		province: 'TO',
		altitude: 230
	},
	{
		zip: '07024',
		name: 'La Maddalena',
		province: 'SS',
		altitude: 27
	},
	{
		zip: '11020',
		name: 'La Magdeleine',
		province: 'AO',
		altitude: 1644
	},
	{
		zip: '12064',
		name: 'La Morra',
		province: 'CN',
		altitude: 513
	},
	{
		zip: '11015',
		name: 'La Salle',
		province: 'AO',
		altitude: 1001
	},
	{
		zip: '19121',
		name: 'La Spezia',
		province: 'SP',
		altitude: 3
	},
	{
		zip: '11016',
		name: 'La Thuile',
		province: 'AO',
		altitude: 1450
	},
	{
		zip: '39030',
		name: 'La Valle',
		province: 'BZ',
		altitude: 1353
	},
	{
		zip: '32020',
		name: 'La Valle Agordina',
		province: 'BL',
		altitude: 800
	},
	{
		zip: '23888',
		name: 'La Valletta Brianza',
		province: 'LC',
		altitude: 342
	},
	{
		zip: '00030',
		name: 'Labico',
		province: 'RM',
		altitude: 319
	},
	{
		zip: '02010',
		name: 'Labro',
		province: 'RI',
		altitude: 628
	},
	{
		zip: '20084',
		name: 'Lacchiarella',
		province: 'MI',
		altitude: 99
	},
	{
		zip: '80076',
		name: 'Lacco Ameno',
		province: 'NA',
		altitude: 2
	},
	{
		zip: '83046',
		name: 'Lacedonia',
		province: 'AV',
		altitude: 732
	},
	{
		zip: '39021',
		name: 'Laces',
		province: 'BZ',
		altitude: 639
	},
	{
		zip: '09090',
		name: 'Laconi',
		province: 'OR',
		altitude: 555
	},
	{
		zip: '00055',
		name: 'Ladispoli',
		province: 'RM',
		altitude: 2
	},
	{
		zip: '07030',
		name: 'Laerru',
		province: 'SS',
		altitude: 165
	},
	{
		zip: '89050',
		name: 'Laganadi',
		province: 'RC',
		altitude: 499
	},
	{
		zip: '36010',
		name: 'Laghi',
		province: 'VI',
		altitude: 570
	},
	{
		zip: '22010',
		name: 'Laglio',
		province: 'CO',
		altitude: 199
	},
	{
		zip: '12030',
		name: 'Lagnasco',
		province: 'CN',
		altitude: 353
	},
	{
		zip: '87035',
		name: 'Lago',
		province: 'CS',
		altitude: 485
	},
	{
		zip: '85042',
		name: 'Lagonegro',
		province: 'PZ',
		altitude: 666
	},
	{
		zip: '44023',
		name: 'Lagosanto',
		province: 'FE',
		altitude: 2
	},
	{
		zip: '39022',
		name: 'Lagundo',
		province: 'BZ',
		altitude: 350
	},
	{
		zip: '17053',
		name: 'Laigueglia',
		province: 'SV',
		altitude: 6
	},
	{
		zip: '20045',
		name: 'Lainate',
		province: 'MI',
		altitude: 176
	},
	{
		zip: '22020',
		name: 'Laino',
		province: 'CO',
		altitude: 700
	},
	{
		zip: '87014',
		name: 'Laino Borgo',
		province: 'CS',
		altitude: 271
	},
	{
		zip: '87015',
		name: 'Laino Castello',
		province: 'CS',
		altitude: 545
	},
	{
		zip: '39040',
		name: 'Laion',
		province: 'BZ',
		altitude: 1093
	},
	{
		zip: '39055',
		name: 'Laives',
		province: 'BZ',
		altitude: 258
	},
	{
		zip: '56030',
		name: 'Lajatico',
		province: 'PI',
		altitude: 205
	},
	{
		zip: '24040',
		name: 'Lallio',
		province: 'BG',
		altitude: 216
	},
	{
		zip: '41023',
		name: 'Lama Mocogno',
		province: 'MO',
		altitude: 842
	},
	{
		zip: '66010',
		name: 'Lama dei Peligni',
		province: 'CH',
		altitude: 669
	},
	{
		zip: '22045',
		name: 'Lambrugo',
		province: 'CO',
		altitude: 290
	},
	{
		zip: '88046',
		name: 'Lamezia Terme',
		province: 'CZ',
		altitude: 216
	},
	{
		zip: '32033',
		name: 'Lamon',
		province: 'BL',
		altitude: 594
	},
	{
		zip: '92031',
		name: 'Lampedusa e Linosa',
		province: 'AG',
		altitude: 16
	},
	{
		zip: '51035',
		name: 'Lamporecchio',
		province: 'PT',
		altitude: 56
	},
	{
		zip: '13046',
		name: 'Lamporo',
		province: 'VC',
		altitude: 165
	},
	{
		zip: '39011',
		name: 'Lana',
		province: 'BZ',
		altitude: 310
	},
	{
		zip: '66034',
		name: 'Lanciano',
		province: 'CH',
		altitude: 265
	},
	{
		zip: '28064',
		name: 'Landiona',
		province: 'NO',
		altitude: 184
	},
	{
		zip: '27015',
		name: 'Landriano',
		province: 'PV',
		altitude: 88
	},
	{
		zip: '43013',
		name: 'Langhirano',
		province: 'PR',
		altitude: 265
	},
	{
		zip: '27030',
		name: 'Langosco',
		province: 'PV',
		altitude: 111
	},
	{
		zip: '08045',
		name: 'Lanusei',
		province: 'NU',
		altitude: 595
	},
	{
		zip: '00040',
		name: 'Lanuvio',
		province: 'RM',
		altitude: 324
	},
	{
		zip: '23020',
		name: 'Lanzada',
		province: 'SO',
		altitude: 983
	},
	{
		zip: '10074',
		name: 'Lanzo Torinese',
		province: 'TO',
		altitude: 525
	},
	{
		zip: '63823',
		name: 'Lapedona',
		province: 'FM',
		altitude: 263
	},
	{
		zip: '83030',
		name: 'Lapio',
		province: 'AV',
		altitude: 500
	},
	{
		zip: '87050',
		name: 'Lappano',
		province: 'CS',
		altitude: 650
	},
	{
		zip: '51036',
		name: 'Larciano',
		province: 'PT',
		altitude: 50
	},
	{
		zip: '27016',
		name: 'Lardirago',
		province: 'PV',
		altitude: 83
	},
	{
		zip: '00076',
		name: 'Lariano',
		province: 'RM',
		altitude: 350
	},
	{
		zip: '86035',
		name: 'Larino',
		province: 'CB',
		altitude: 341
	},
	{
		zip: '09020',
		name: 'Las Plassas',
		province: 'SU',
		altitude: 148
	},
	{
		zip: '39023',
		name: 'Lasa',
		province: 'BZ',
		altitude: 868
	},
	{
		zip: '90010',
		name: 'Lascari',
		province: 'PA',
		altitude: 76
	},
	{
		zip: '22030',
		name: 'Lasnigo',
		province: 'CO',
		altitude: 570
	},
	{
		zip: '36040',
		name: 'Lastebasse',
		province: 'VI',
		altitude: 585
	},
	{
		zip: '50055',
		name: 'Lastra a Signa',
		province: 'FI',
		altitude: 36
	},
	{
		zip: '01010',
		name: 'Latera',
		province: 'VT',
		altitude: 508
	},
	{
		zip: '52019',
		name: 'Laterina Pergine Valdarno',
		province: 'AR',
		altitude: 240
	},
	{
		zip: '74014',
		name: 'Laterza',
		province: 'TA',
		altitude: 362
	},
	{
		zip: '72022',
		name: 'Latiano',
		province: 'BR',
		altitude: 97
	},
	{
		zip: '04100',
		name: 'Latina',
		province: 'LT',
		altitude: 21
	},
	{
		zip: '33053',
		name: 'Latisana',
		province: 'UD',
		altitude: 7
	},
	{
		zip: '85043',
		name: 'Latronico',
		province: 'PZ',
		altitude: 888
	},
	{
		zip: '87010',
		name: 'Lattarico',
		province: 'CS',
		altitude: 406
	},
	{
		zip: '33029',
		name: 'Lauco',
		province: 'UD',
		altitude: 719
	},
	{
		zip: '84050',
		name: 'Laureana Cilento',
		province: 'SA',
		altitude: 452
	},
	{
		zip: '89023',
		name: 'Laureana di Borrello',
		province: 'RC',
		altitude: 270
	},
	{
		zip: '39040',
		name: 'Lauregno',
		province: 'BZ',
		altitude: 1150
	},
	{
		zip: '85014',
		name: 'Laurenzana',
		province: 'PZ',
		altitude: 850
	},
	{
		zip: '85044',
		name: 'Lauria',
		province: 'PZ',
		altitude: 430
	},
	{
		zip: '10020',
		name: 'Lauriano',
		province: 'TO',
		altitude: 175
	},
	{
		zip: '84057',
		name: 'Laurino',
		province: 'SA',
		altitude: 531
	},
	{
		zip: '84050',
		name: 'Laurito',
		province: 'SA',
		altitude: 475
	},
	{
		zip: '83023',
		name: 'Lauro',
		province: 'AV',
		altitude: 192
	},
	{
		zip: '16033',
		name: 'Lavagna',
		province: 'GE',
		altitude: 6
	},
	{
		zip: '37030',
		name: 'Lavagno',
		province: 'VR',
		altitude: 67
	},
	{
		zip: '38046',
		name: 'Lavarone',
		province: 'TN',
		altitude: 1174
	},
	{
		zip: '85024',
		name: 'Lavello',
		province: 'PZ',
		altitude: 313
	},
	{
		zip: '21037',
		name: 'Lavena Ponte Tresa',
		province: 'VA',
		altitude: 275
	},
	{
		zip: '21014',
		name: 'Laveno-Mombello',
		province: 'VA',
		altitude: 205
	},
	{
		zip: '25070',
		name: 'Lavenone',
		province: 'BS',
		altitude: 385
	},
	{
		zip: '84020',
		name: 'Laviano',
		province: 'SA',
		altitude: 475
	},
	{
		zip: '38015',
		name: 'Lavis',
		province: 'TN',
		altitude: 238
	},
	{
		zip: '37017',
		name: 'Lazise',
		province: 'VR',
		altitude: 76
	},
	{
		zip: '20824',
		name: 'Lazzate',
		province: 'MB',
		altitude: 257
	},
	{
		zip: '73100',
		name: 'Lecce',
		province: 'LE',
		altitude: 49
	},
	{
		zip: '67050',
		name: 'Lecce nei Marsi',
		province: 'AQ',
		altitude: 740
	},
	{
		zip: '23900',
		name: 'Lecco',
		province: 'LC',
		altitude: 214
	},
	{
		zip: '38067',
		name: 'Ledro',
		province: 'TN',
		altitude: 660
	},
	{
		zip: '24026',
		name: 'Leffe',
		province: 'BG',
		altitude: 453
	},
	{
		zip: '21038',
		name: 'Leggiuno',
		province: 'VA',
		altitude: 240
	},
	{
		zip: '37045',
		name: 'Legnago',
		province: 'VR',
		altitude: 16
	},
	{
		zip: '20025',
		name: 'Legnano',
		province: 'MI',
		altitude: 199
	},
	{
		zip: '35020',
		name: 'Legnaro',
		province: 'PD',
		altitude: 8
	},
	{
		zip: '08010',
		name: 'Lei',
		province: 'NU',
		altitude: 456
	},
	{
		zip: '10040',
		name: 'Leini',
		province: 'TO',
		altitude: 245
	},
	{
		zip: '16040',
		name: 'Leivi',
		province: 'GE',
		altitude: 272
	},
	{
		zip: '10070',
		name: 'Lemie',
		province: 'TO',
		altitude: 960
	},
	{
		zip: '45026',
		name: 'Lendinara',
		province: 'RO',
		altitude: 9
	},
	{
		zip: '98050',
		name: 'Leni',
		province: 'ME',
		altitude: 202
	},
	{
		zip: '24010',
		name: 'Lenna',
		province: 'BG',
		altitude: 540
	},
	{
		zip: '25024',
		name: 'Leno',
		province: 'BS',
		altitude: 66
	},
	{
		zip: '04025',
		name: 'Lenola',
		province: 'LT',
		altitude: 475
	},
	{
		zip: '13035',
		name: 'Lenta',
		province: 'VC',
		altitude: 219
	},
	{
		zip: '20823',
		name: 'Lentate sul Seveso',
		province: 'MB',
		altitude: 250
	},
	{
		zip: '66050',
		name: 'Lentella',
		province: 'CH',
		altitude: 398
	},
	{
		zip: '96016',
		name: 'Lentini',
		province: 'SR',
		altitude: 53
	},
	{
		zip: '02016',
		name: 'Leonessa',
		province: 'RI',
		altitude: 969
	},
	{
		zip: '94013',
		name: 'Leonforte',
		province: 'EN',
		altitude: 603
	},
	{
		zip: '74020',
		name: 'Leporano',
		province: 'TA',
		altitude: 47
	},
	{
		zip: '73010',
		name: 'Lequile',
		province: 'LE',
		altitude: 38
	},
	{
		zip: '12050',
		name: 'Lequio Berria',
		province: 'CN',
		altitude: 715
	},
	{
		zip: '12060',
		name: 'Lequio Tanaro',
		province: 'CN',
		altitude: 328
	},
	{
		zip: '90025',
		name: 'Lercara Friddi',
		province: 'PA',
		altitude: 675
	},
	{
		zip: '19032',
		name: 'Lerici',
		province: 'SP',
		altitude: 10
	},
	{
		zip: '15070',
		name: 'Lerma',
		province: 'AL',
		altitude: 293
	},
	{
		zip: '28040',
		name: 'Lesa',
		province: 'NO',
		altitude: 198
	},
	{
		zip: '12076',
		name: 'Lesegno',
		province: 'CN',
		altitude: 422
	},
	{
		zip: '43037',
		name: 'Lesignano de Bagni',
		province: 'PR',
		altitude: 252
	},
	{
		zip: '71010',
		name: 'Lesina',
		province: 'FG',
		altitude: 5
	},
	{
		zip: '20855',
		name: 'Lesmo',
		province: 'MB',
		altitude: 240
	},
	{
		zip: '10010',
		name: 'Lessolo',
		province: 'TO',
		altitude: 277
	},
	{
		zip: '13853',
		name: 'Lessona',
		province: 'BI',
		altitude: 360
	},
	{
		zip: '33050',
		name: 'Lestizza',
		province: 'UD',
		altitude: 24
	},
	{
		zip: '81010',
		name: 'Letino',
		province: 'CE',
		altitude: 961
	},
	{
		zip: '98037',
		name: 'Letojanni',
		province: 'ME',
		altitude: 5
	},
	{
		zip: '80050',
		name: 'Lettere',
		province: 'NA',
		altitude: 356
	},
	{
		zip: '65020',
		name: 'Lettomanoppello',
		province: 'PE',
		altitude: 375
	},
	{
		zip: '66010',
		name: 'Lettopalena',
		province: 'CH',
		altitude: 680
	},
	{
		zip: '19015',
		name: 'Levanto',
		province: 'SP',
		altitude: 3
	},
	{
		zip: '24040',
		name: 'Levate',
		province: 'BG',
		altitude: 185
	},
	{
		zip: '73045',
		name: 'Leverano',
		province: 'LE',
		altitude: 37
	},
	{
		zip: '12070',
		name: 'Levice',
		province: 'CN',
		altitude: 547
	},
	{
		zip: '38056',
		name: 'Levico Terme',
		province: 'TN',
		altitude: 506
	},
	{
		zip: '10070',
		name: 'Levone',
		province: 'TO',
		altitude: 353
	},
	{
		zip: '22025',
		name: 'Lezzeno',
		province: 'CO',
		altitude: 202
	},
	{
		zip: '81040',
		name: 'Liberi',
		province: 'CE',
		altitude: 470
	},
	{
		zip: '98064',
		name: 'Librizzi',
		province: 'ME',
		altitude: 501
	},
	{
		zip: '92027',
		name: 'Licata',
		province: 'AG',
		altitude: 8
	},
	{
		zip: '54016',
		name: 'Licciana Nardi',
		province: 'MS',
		altitude: 210
	},
	{
		zip: '00026',
		name: 'Licenza',
		province: 'RM',
		altitude: 475
	},
	{
		zip: '95040',
		name: 'Licodia Eubea',
		province: 'CT',
		altitude: 688
	},
	{
		zip: '23827',
		name: 'Lierna',
		province: 'LC',
		altitude: 202
	},
	{
		zip: '13034',
		name: 'Lignana',
		province: 'VC',
		altitude: 134
	},
	{
		zip: '33054',
		name: 'Lignano Sabbiadoro',
		province: 'UD',
		altitude: 2
	},
	{
		zip: '11020',
		name: 'Lillianes',
		province: 'AO',
		altitude: 667
	},
	{
		zip: '32020',
		name: 'Limana',
		province: 'BL',
		altitude: 364
	},
	{
		zip: '82030',
		name: 'Limatola',
		province: 'BN',
		altitude: 48
	},
	{
		zip: '89844',
		name: 'Limbadi',
		province: 'VV',
		altitude: 229
	},
	{
		zip: '20812',
		name: 'Limbiate',
		province: 'MB',
		altitude: 187
	},
	{
		zip: '35010',
		name: 'Limena',
		province: 'PD',
		altitude: 22
	},
	{
		zip: '22070',
		name: 'Limido Comasco',
		province: 'CO',
		altitude: 276
	},
	{
		zip: '98030',
		name: 'Limina',
		province: 'ME',
		altitude: 552
	},
	{
		zip: '12015',
		name: 'Limone Piemonte',
		province: 'CN',
		altitude: 1009
	},
	{
		zip: '25010',
		name: 'Limone sul Garda',
		province: 'BS',
		altitude: 65
	},
	{
		zip: '86022',
		name: 'Limosano',
		province: 'CB',
		altitude: 586
	},
	{
		zip: '27010',
		name: 'Linarolo',
		province: 'PV',
		altitude: 73
	},
	{
		zip: '95015',
		name: 'Linguaglossa',
		province: 'CT',
		altitude: 550
	},
	{
		zip: '83047',
		name: 'Lioni',
		province: 'AV',
		altitude: 550
	},
	{
		zip: '98055',
		name: 'Lipari',
		province: 'ME',
		altitude: 44
	},
	{
		zip: '22030',
		name: 'Lipomo',
		province: 'CO',
		altitude: 384
	},
	{
		zip: '27043',
		name: 'Lirio',
		province: 'PV',
		altitude: 257
	},
	{
		zip: '20050',
		name: 'Liscate',
		province: 'MI',
		altitude: 115
	},
	{
		zip: '66050',
		name: 'Liscia',
		province: 'CH',
		altitude: 740
	},
	{
		zip: '06060',
		name: 'Lisciano Niccone',
		province: 'PG',
		altitude: 314
	},
	{
		zip: '12070',
		name: 'Lisio',
		province: 'CN',
		altitude: 575
	},
	{
		zip: '20851',
		name: 'Lissone',
		province: 'MB',
		altitude: 181
	},
	{
		zip: '80030',
		name: 'Liveri',
		province: 'NA',
		altitude: 90
	},
	{
		zip: '23041',
		name: 'Livigno',
		province: 'SO',
		altitude: 1816
	},
	{
		zip: '32020',
		name: 'Livinallongo del Col di Lana',
		province: 'BL',
		altitude: 1475
	},
	{
		zip: '57121',
		name: 'Livorno',
		province: 'LI',
		altitude: 3
	},
	{
		zip: '13046',
		name: 'Livorno Ferraris',
		province: 'VC',
		altitude: 188
	},
	{
		zip: '26814',
		name: 'Livraga',
		province: 'LO',
		altitude: 67
	},
	{
		zip: '73023',
		name: 'Lizzanello',
		province: 'LE',
		altitude: 45
	},
	{
		zip: '74020',
		name: 'Lizzano',
		province: 'TA',
		altitude: 42
	},
	{
		zip: '40042',
		name: 'Lizzano in Belvedere',
		province: 'BO',
		altitude: 640
	},
	{
		zip: '17025',
		name: 'Loano',
		province: 'SV',
		altitude: 5
	},
	{
		zip: '14050',
		name: 'Loazzolo',
		province: 'AT',
		altitude: 430
	},
	{
		zip: '10080',
		name: 'Locana',
		province: 'TO',
		altitude: 613
	},
	{
		zip: '22070',
		name: 'Locate Varesino',
		province: 'CO',
		altitude: 274
	},
	{
		zip: '20085',
		name: 'Locate di Triulzi',
		province: 'MI',
		altitude: 96
	},
	{
		zip: '24030',
		name: 'Locatello',
		province: 'BG',
		altitude: 557
	},
	{
		zip: '08040',
		name: 'Loceri',
		province: 'NU',
		altitude: 206
	},
	{
		zip: '70010',
		name: 'Locorotondo',
		province: 'BA',
		altitude: 410
	},
	{
		zip: '89044',
		name: 'Locri',
		province: 'RC',
		altitude: 7
	},
	{
		zip: '08020',
		name: 'Loculi',
		province: 'NU',
		altitude: 26
	},
	{
		zip: '26900',
		name: 'Lodi',
		province: 'LO',
		altitude: 87
	},
	{
		zip: '26855',
		name: 'Lodi Vecchio',
		province: 'LO',
		altitude: 82
	},
	{
		zip: '08020',
		name: 'Lodine',
		province: 'NU',
		altitude: 884
	},
	{
		zip: '25060',
		name: 'Lodrino',
		province: 'BS',
		altitude: 725
	},
	{
		zip: '08020',
		name: 'Lode',
		province: 'NU',
		altitude: 345
	},
	{
		zip: '25030',
		name: 'Lograto',
		province: 'BS',
		altitude: 113
	},
	{
		zip: '40050',
		name: 'Loiano',
		province: 'BO',
		altitude: 714
	},
	{
		zip: '07020',
		name: 'Loiri Porto San Paolo',
		province: 'SS',
		altitude: 105
	},
	{
		zip: '23871',
		name: 'Lomagna',
		province: 'LC',
		altitude: 255
	},
	{
		zip: '22074',
		name: 'Lomazzo',
		province: 'CO',
		altitude: 296
	},
	{
		zip: '10040',
		name: 'Lombardore',
		province: 'TO',
		altitude: 268
	},
	{
		zip: '10040',
		name: 'Lombriasco',
		province: 'TO',
		altitude: 241
	},
	{
		zip: '27034',
		name: 'Lomello',
		province: 'PV',
		altitude: 96
	},
	{
		zip: '38040',
		name: 'Lona-Lases',
		province: 'TN',
		altitude: 639
	},
	{
		zip: '21050',
		name: 'Lonate Ceppino',
		province: 'VA',
		altitude: 287
	},
	{
		zip: '21015',
		name: 'Lonate Pozzolo',
		province: 'VA',
		altitude: 205
	},
	{
		zip: '25017',
		name: 'Lonato del Garda',
		province: 'BS',
		altitude: 188
	},
	{
		zip: '50060',
		name: 'Londa',
		province: 'FI',
		altitude: 226
	},
	{
		zip: '86090',
		name: 'Longano',
		province: 'IS',
		altitude: 680
	},
	{
		zip: '36023',
		name: 'Longare',
		province: 'VI',
		altitude: 29
	},
	{
		zip: '32013',
		name: 'Longarone',
		province: 'BL',
		altitude: 473
	},
	{
		zip: '25030',
		name: 'Longhena',
		province: 'BS',
		altitude: 93
	},
	{
		zip: '98070',
		name: 'Longi',
		province: 'ME',
		altitude: 616
	},
	{
		zip: '47020',
		name: 'Longiano',
		province: 'FC',
		altitude: 179
	},
	{
		zip: '87030',
		name: 'Longobardi',
		province: 'CS',
		altitude: 325
	},
	{
		zip: '87066',
		name: 'Longobucco',
		province: 'CS',
		altitude: 784
	},
	{
		zip: '02020',
		name: 'Longone Sabino',
		province: 'RI',
		altitude: 804
	},
	{
		zip: '22030',
		name: 'Longone al Segrino',
		province: 'CO',
		altitude: 368
	},
	{
		zip: '36045',
		name: 'Lonigo',
		province: 'VI',
		altitude: 31
	},
	{
		zip: '10010',
		name: 'Loranze',
		province: 'TO',
		altitude: 243
	},
	{
		zip: '35010',
		name: 'Loreggia',
		province: 'PD',
		altitude: 26
	},
	{
		zip: '28893',
		name: 'Loreglia',
		province: 'VB',
		altitude: 723
	},
	{
		zip: '32040',
		name: 'Lorenzago di Cadore',
		province: 'BL',
		altitude: 883
	},
	{
		zip: '45017',
		name: 'Loreo',
		province: 'RO',
		altitude: 1
	},
	{
		zip: '60025',
		name: 'Loreto',
		province: 'AN',
		altitude: 127
	},
	{
		zip: '65014',
		name: 'Loreto Aprutino',
		province: 'PE',
		altitude: 307
	},
	{
		zip: '31037',
		name: 'Loria',
		province: 'TV',
		altitude: 75
	},
	{
		zip: '52024',
		name: 'Loro Ciuffenna',
		province: 'AR',
		altitude: 330
	},
	{
		zip: '62020',
		name: 'Loro Piceno',
		province: 'MC',
		altitude: 436
	},
	{
		zip: '16045',
		name: 'Lorsica',
		province: 'GE',
		altitude: 343
	},
	{
		zip: '25050',
		name: 'Losine',
		province: 'BS',
		altitude: 368
	},
	{
		zip: '08040',
		name: 'Lotzorai',
		province: 'NU',
		altitude: 11
	},
	{
		zip: '24065',
		name: 'Lovere',
		province: 'BG',
		altitude: 208
	},
	{
		zip: '23030',
		name: 'Lovero',
		province: 'SO',
		altitude: 515
	},
	{
		zip: '25040',
		name: 'Lozio',
		province: 'BS',
		altitude: 975
	},
	{
		zip: '21040',
		name: 'Lozza',
		province: 'VA',
		altitude: 350
	},
	{
		zip: '35034',
		name: 'Lozzo Atestino',
		province: 'PD',
		altitude: 19
	},
	{
		zip: '32040',
		name: 'Lozzo di Cadore',
		province: 'BL',
		altitude: 753
	},
	{
		zip: '13045',
		name: 'Lozzolo',
		province: 'VC',
		altitude: 320
	},
	{
		zip: '15037',
		name: 'Lu e Cuccaro Monferrato',
		province: 'AL',
		altitude: 307
	},
	{
		zip: '01020',
		name: 'Lubriano',
		province: 'VT',
		altitude: 441
	},
	{
		zip: '55100',
		name: 'Lucca',
		province: 'LU',
		altitude: 19
	},
	{
		zip: '92010',
		name: 'Lucca Sicula',
		province: 'AG',
		altitude: 513
	},
	{
		zip: '71036',
		name: 'Lucera',
		province: 'FG',
		altitude: 219
	},
	{
		zip: '52046',
		name: 'Lucignano',
		province: 'AR',
		altitude: 400
	},
	{
		zip: '18020',
		name: 'Lucinasco',
		province: 'IM',
		altitude: 499
	},
	{
		zip: '86030',
		name: 'Lucito',
		province: 'CB',
		altitude: 480
	},
	{
		zip: '67056',
		name: 'Luco dei Marsi',
		province: 'AQ',
		altitude: 680
	},
	{
		zip: '67045',
		name: 'Lucoli',
		province: 'AQ',
		altitude: 956
	},
	{
		zip: '29018',
		name: 'Lugagnano Val d\'\'Arda',
		province: 'PC',
		altitude: 229
	},
	{
		zip: '05020',
		name: 'Lugnano in Teverina',
		province: 'TR',
		altitude: 440
	},
	{
		zip: '48022',
		name: 'Lugo',
		province: 'RA',
		altitude: 15
	},
	{
		zip: '36030',
		name: 'Lugo di Vicenza',
		province: 'VI',
		altitude: 203
	},
	{
		zip: '21016',
		name: 'Luino',
		province: 'VA',
		altitude: 202
	},
	{
		zip: '22070',
		name: 'Luisago',
		province: 'CO',
		altitude: 327
	},
	{
		zip: '08020',
		name: 'Lula',
		province: 'NU',
		altitude: 521
	},
	{
		zip: '16024',
		name: 'Lumarzo',
		province: 'GE',
		altitude: 228
	},
	{
		zip: '25065',
		name: 'Lumezzane',
		province: 'BS',
		altitude: 460
	},
	{
		zip: '09022',
		name: 'Lunamatrona',
		province: 'SU',
		altitude: 168
	},
	{
		zip: '61026',
		name: 'Lunano',
		province: 'PU',
		altitude: 297
	},
	{
		zip: '27053',
		name: 'Lungavilla',
		province: 'PV',
		altitude: 75
	},
	{
		zip: '87010',
		name: 'Lungro',
		province: 'CS',
		altitude: 600
	},
	{
		zip: '19034',
		name: 'Luni',
		province: 'SP',
		altitude: 76
	},
	{
		zip: '83040',
		name: 'Luogosano',
		province: 'AV',
		altitude: 390
	},
	{
		zip: '07020',
		name: 'Luogosanto',
		province: 'SS',
		altitude: 321
	},
	{
		zip: '86030',
		name: 'Lupara',
		province: 'CB',
		altitude: 505
	},
	{
		zip: '22070',
		name: 'Lurago Marinone',
		province: 'CO',
		altitude: 294
	},
	{
		zip: '22040',
		name: 'Lurago d\'\'Erba',
		province: 'CO',
		altitude: 351
	},
	{
		zip: '24050',
		name: 'Lurano',
		province: 'BG',
		altitude: 147
	},
	{
		zip: '07025',
		name: 'Luras',
		province: 'SS',
		altitude: 508
	},
	{
		zip: '22075',
		name: 'Lurate Caccivio',
		province: 'CO',
		altitude: 322
	},
	{
		zip: '81030',
		name: 'Lusciano',
		province: 'CE',
		altitude: 44
	},
	{
		zip: '38040',
		name: 'Luserna',
		province: 'TN',
		altitude: 1333
	},
	{
		zip: '10062',
		name: 'Luserna San Giovanni',
		province: 'TO',
		altitude: 474
	},
	{
		zip: '10060',
		name: 'Lusernetta',
		province: 'TO',
		altitude: 507
	},
	{
		zip: '33010',
		name: 'Lusevera',
		province: 'UD',
		altitude: 504
	},
	{
		zip: '45020',
		name: 'Lusia',
		province: 'RO',
		altitude: 10
	},
	{
		zip: '36046',
		name: 'Lusiana Conco',
		province: 'TV',
		altitude: 830
	},
	{
		zip: '10080',
		name: 'Lusiglie',
		province: 'TO',
		altitude: 268
	},
	{
		zip: '39040',
		name: 'Luson',
		province: 'BZ',
		altitude: 962
	},
	{
		zip: '84050',
		name: 'Lustra',
		province: 'SA',
		altitude: 466
	},
	{
		zip: '21020',
		name: 'Luvinate',
		province: 'VA',
		altitude: 425
	},
	{
		zip: '24069',
		name: 'Luzzana',
		province: 'BG',
		altitude: 310
	},
	{
		zip: '42045',
		name: 'Luzzara',
		province: 'RE',
		altitude: 22
	},
	{
		zip: '87040',
		name: 'Luzzi',
		province: 'CS',
		altitude: 376
	},
	{
		zip: '21061',
		name: 'Maccagno con Pino e Veddasca',
		province: 'VA',
		altitude: 210
	},
	{
		zip: '26943',
		name: 'Maccastorna',
		province: 'LO',
		altitude: 45
	},
	{
		zip: '86040',
		name: 'Macchia Valfortore',
		province: 'CB',
		altitude: 477
	},
	{
		zip: '86070',
		name: 'Macchia d\'\'Isernia',
		province: 'IS',
		altitude: 360
	},
	{
		zip: '86096',
		name: 'Macchiagodena',
		province: 'IS',
		altitude: 864
	},
	{
		zip: '10060',
		name: 'Macello',
		province: 'TO',
		altitude: 301
	},
	{
		zip: '62100',
		name: 'Macerata',
		province: 'MC',
		altitude: 315
	},
	{
		zip: '81047',
		name: 'Macerata Campania',
		province: 'CE',
		altitude: 34
	},
	{
		zip: '61023',
		name: 'Macerata Feltria',
		province: 'PU',
		altitude: 321
	},
	{
		zip: '20846',
		name: 'Macherio',
		province: 'MB',
		altitude: 215
	},
	{
		zip: '25030',
		name: 'Maclodio',
		province: 'BS',
		altitude: 109
	},
	{
		zip: '08015',
		name: 'Macomer',
		province: 'NU',
		altitude: 572
	},
	{
		zip: '12020',
		name: 'Macra',
		province: 'CN',
		altitude: 875
	},
	{
		zip: '28876',
		name: 'Macugnaga',
		province: 'VB',
		altitude: 1327
	},
	{
		zip: '81024',
		name: 'Maddaloni',
		province: 'CE',
		altitude: 73
	},
	{
		zip: '23024',
		name: 'Madesimo',
		province: 'SO',
		altitude: 1394
	},
	{
		zip: '26020',
		name: 'Madignano',
		province: 'CR',
		altitude: 70
	},
	{
		zip: '24040',
		name: 'Madone',
		province: 'BG',
		altitude: 202
	},
	{
		zip: '28894',
		name: 'Madonna del Sasso',
		province: 'VB',
		altitude: 696
	},
	{
		zip: '04010',
		name: 'Maenza',
		province: 'LT',
		altitude: 358
	},
	{
		zip: '86030',
		name: 'Mafalda',
		province: 'CB',
		altitude: 460
	},
	{
		zip: '25080',
		name: 'Magasa',
		province: 'BS',
		altitude: 976
	},
	{
		zip: '20013',
		name: 'Magenta',
		province: 'MI',
		altitude: 138
	},
	{
		zip: '28014',
		name: 'Maggiora',
		province: 'NO',
		altitude: 397
	},
	{
		zip: '27010',
		name: 'Magherno',
		province: 'PV',
		altitude: 76
	},
	{
		zip: '06063',
		name: 'Magione',
		province: 'PG',
		altitude: 299
	},
	{
		zip: '88050',
		name: 'Magisano',
		province: 'CZ',
		altitude: 565
	},
	{
		zip: '12050',
		name: 'Magliano Alfieri',
		province: 'CN',
		altitude: 328
	},
	{
		zip: '12060',
		name: 'Magliano Alpi',
		province: 'CN',
		altitude: 403
	},
	{
		zip: '00060',
		name: 'Magliano Romano',
		province: 'RM',
		altitude: 270
	},
	{
		zip: '02046',
		name: 'Magliano Sabina',
		province: 'RI',
		altitude: 222
	},
	{
		zip: '84050',
		name: 'Magliano Vetere',
		province: 'SA',
		altitude: 650
	},
	{
		zip: '67062',
		name: 'Magliano de Marsi',
		province: 'AQ',
		altitude: 728
	},
	{
		zip: '63832',
		name: 'Magliano di Tenna',
		province: 'FM',
		altitude: 293
	},
	{
		zip: '58051',
		name: 'Magliano in Toscana',
		province: 'GR',
		altitude: 128
	},
	{
		zip: '73024',
		name: 'Maglie',
		province: 'LE',
		altitude: 81
	},
	{
		zip: '17020',
		name: 'Magliolo',
		province: 'SV',
		altitude: 270
	},
	{
		zip: '10030',
		name: 'Maglione',
		province: 'TO',
		altitude: 310
	},
	{
		zip: '46020',
		name: 'Magnacavallo',
		province: 'MN',
		altitude: 11
	},
	{
		zip: '20020',
		name: 'Magnago',
		province: 'MI',
		altitude: 197
	},
	{
		zip: '13887',
		name: 'Magnano',
		province: 'BI',
		altitude: 543
	},
	{
		zip: '33010',
		name: 'Magnano in Riviera',
		province: 'UD',
		altitude: 201
	},
	{
		zip: '09090',
		name: 'Magomadas',
		province: 'OR',
		altitude: 263
	},
	{
		zip: '22030',
		name: 'Magreglio',
		province: 'CO',
		altitude: 750
	},
	{
		zip: '39040',
		name: 'Magre sulla Strada del Vino',
		province: 'BZ',
		altitude: 241
	},
	{
		zip: '88025',
		name: 'Maida',
		province: 'CZ',
		altitude: 299
	},
	{
		zip: '89843',
		name: 'Maierato',
		province: 'VV',
		altitude: 258
	},
	{
		zip: '87020',
		name: 'Maiera',
		province: 'CS',
		altitude: 360
	},
	{
		zip: '60030',
		name: 'Maiolati Spontini',
		province: 'AN',
		altitude: 405
	},
	{
		zip: '47862',
		name: 'Maiolo',
		province: 'RN',
		altitude: 590
	},
	{
		zip: '84010',
		name: 'Maiori',
		province: 'SA',
		altitude: 5
	},
	{
		zip: '26825',
		name: 'Mairago',
		province: 'LO',
		altitude: 69
	},
	{
		zip: '25030',
		name: 'Mairano',
		province: 'BS',
		altitude: 96
	},
	{
		zip: '19010',
		name: 'Maissana',
		province: 'SP',
		altitude: 575
	},
	{
		zip: '33030',
		name: 'Majano',
		province: 'UD',
		altitude: 170
	},
	{
		zip: '26030',
		name: 'Malagnino',
		province: 'CR',
		altitude: 43
	},
	{
		zip: '40051',
		name: 'Malalbergo',
		province: 'BO',
		altitude: 12
	},
	{
		zip: '33010',
		name: 'Malborghetto Valbruna',
		province: 'UD',
		altitude: 721
	},
	{
		zip: '37010',
		name: 'Malcesine',
		province: 'VR',
		altitude: 89
	},
	{
		zip: '25053',
		name: 'Malegno',
		province: 'BS',
		altitude: 364
	},
	{
		zip: '26847',
		name: 'Maleo',
		province: 'LO',
		altitude: 58
	},
	{
		zip: '28854',
		name: 'Malesco',
		province: 'VB',
		altitude: 761
	},
	{
		zip: '95035',
		name: 'Maletto',
		province: 'CT',
		altitude: 960
	},
	{
		zip: '98050',
		name: 'Malfa',
		province: 'ME',
		altitude: 100
	},
	{
		zip: '21020',
		name: 'Malgesso',
		province: 'VA',
		altitude: 291
	},
	{
		zip: '23864',
		name: 'Malgrate',
		province: 'LC',
		altitude: 231
	},
	{
		zip: '87030',
		name: 'Malito',
		province: 'CS',
		altitude: 728
	},
	{
		zip: '17045',
		name: 'Mallare',
		province: 'SV',
		altitude: 458
	},
	{
		zip: '39024',
		name: 'Malles Venosta',
		province: 'BZ',
		altitude: 1051
	},
	{
		zip: '21046',
		name: 'Malnate',
		province: 'VA',
		altitude: 355
	},
	{
		zip: '36034',
		name: 'Malo',
		province: 'VI',
		altitude: 116
	},
	{
		zip: '25040',
		name: 'Malonno',
		province: 'BS',
		altitude: 596
	},
	{
		zip: '63085',
		name: 'Maltignano',
		province: 'AP',
		altitude: 307
	},
	{
		zip: '98030',
		name: 'Malvagna',
		province: 'ME',
		altitude: 710
	},
	{
		zip: '15015',
		name: 'Malvicino',
		province: 'AL',
		altitude: 420
	},
	{
		zip: '87010',
		name: 'Malvito',
		province: 'CS',
		altitude: 449
	},
	{
		zip: '38027',
		name: 'Malé',
		province: 'TN',
		altitude: 737
	},
	{
		zip: '89045',
		name: 'Mammola',
		province: 'RC',
		altitude: 240
	},
	{
		zip: '08024',
		name: 'Mamoiada',
		province: 'NU',
		altitude: 644
	},
	{
		zip: '58014',
		name: 'Manciano',
		province: 'GR',
		altitude: 444
	},
	{
		zip: '98020',
		name: 'Mandanici',
		province: 'ME',
		altitude: 417
	},
	{
		zip: '09040',
		name: 'Mandas',
		province: 'SU',
		altitude: 457
	},
	{
		zip: '87060',
		name: 'Mandatoriccio',
		province: 'CS',
		altitude: 561
	},
	{
		zip: '00020',
		name: 'Mandela',
		province: 'RM',
		altitude: 487
	},
	{
		zip: '28060',
		name: 'Mandello Vitta',
		province: 'NO',
		altitude: 175
	},
	{
		zip: '23826',
		name: 'Mandello del Lario',
		province: 'LC',
		altitude: 214
	},
	{
		zip: '74024',
		name: 'Manduria',
		province: 'TA',
		altitude: 79
	},
	{
		zip: '25080',
		name: 'Manerba del Garda',
		province: 'BS',
		altitude: 130
	},
	{
		zip: '25025',
		name: 'Manerbio',
		province: 'BS',
		altitude: 64
	},
	{
		zip: '71043',
		name: 'Manfredonia',
		province: 'FG',
		altitude: 5
	},
	{
		zip: '12056',
		name: 'Mango',
		province: 'CN',
		altitude: 521
	},
	{
		zip: '87050',
		name: 'Mangone',
		province: 'CS',
		altitude: 805
	},
	{
		zip: '95030',
		name: 'Maniace',
		province: 'CT',
		altitude: 787
	},
	{
		zip: '33085',
		name: 'Maniago',
		province: 'PN',
		altitude: 286
	},
	{
		zip: '83030',
		name: 'Manocalzati',
		province: 'AV',
		altitude: 450
	},
	{
		zip: '65024',
		name: 'Manoppello',
		province: 'PE',
		altitude: 257
	},
	{
		zip: '31040',
		name: 'Mansue',
		province: 'TV',
		altitude: 13
	},
	{
		zip: '12030',
		name: 'Manta',
		province: 'CN',
		altitude: 400
	},
	{
		zip: '23016',
		name: 'Mantello',
		province: 'SO',
		altitude: 211
	},
	{
		zip: '46100',
		name: 'Mantova',
		province: 'MN',
		altitude: 19
	},
	{
		zip: '00066',
		name: 'Manziana',
		province: 'RM',
		altitude: 374
	},
	{
		zip: '24030',
		name: 'Mapello',
		province: 'BG',
		altitude: 250
	},
	{
		zip: '10079',
		name: 'Mappano',
		province: 'TO',
		altitude: 277
	},
	{
		zip: '07010',
		name: 'Mara',
		province: 'SS',
		altitude: 257
	},
	{
		zip: '09069',
		name: 'Maracalagonis',
		province: 'CA',
		altitude: 82
	},
	{
		zip: '41053',
		name: 'Maranello',
		province: 'MO',
		altitude: 137
	},
	{
		zip: '00020',
		name: 'Marano Equo',
		province: 'RM',
		altitude: 450
	},
	{
		zip: '33050',
		name: 'Marano Lagunare',
		province: 'UD',
		altitude: 2
	},
	{
		zip: '87040',
		name: 'Marano Marchesato',
		province: 'CS',
		altitude: 550
	},
	{
		zip: '87040',
		name: 'Marano Principato',
		province: 'CS',
		altitude: 496
	},
	{
		zip: '28040',
		name: 'Marano Ticino',
		province: 'NO',
		altitude: 258
	},
	{
		zip: '36035',
		name: 'Marano Vicentino',
		province: 'VI',
		altitude: 136
	},
	{
		zip: '80016',
		name: 'Marano di Napoli',
		province: 'NA',
		altitude: 151
	},
	{
		zip: '37020',
		name: 'Marano di Valpolicella',
		province: 'VR',
		altitude: 350
	},
	{
		zip: '41054',
		name: 'Marano sul Panaro',
		province: 'MO',
		altitude: 142
	},
	{
		zip: '14040',
		name: 'Maranzana',
		province: 'AT',
		altitude: 272
	},
	{
		zip: '85046',
		name: 'Maratea',
		province: 'PZ',
		altitude: 300
	},
	{
		zip: '20010',
		name: 'Marcallo con Casone',
		province: 'MI',
		altitude: 147
	},
	{
		zip: '46010',
		name: 'Marcaria',
		province: 'MN',
		altitude: 25
	},
	{
		zip: '88050',
		name: 'Marcedusa',
		province: 'CZ',
		altitude: 288
	},
	{
		zip: '00010',
		name: 'Marcellina',
		province: 'RO',
		altitude: 285
	},
	{
		zip: '88044',
		name: 'Marcellinara',
		province: 'CZ',
		altitude: 337
	},
	{
		zip: '02020',
		name: 'Marcetelli',
		province: 'RI',
		altitude: 930
	},
	{
		zip: '25060',
		name: 'Marcheno',
		province: 'BS',
		altitude: 372
	},
	{
		zip: '21030',
		name: 'Marchirolo',
		province: 'VA',
		altitude: 500
	},
	{
		zip: '57030',
		name: 'Marciana',
		province: 'LI',
		altitude: 375
	},
	{
		zip: '57033',
		name: 'Marciana Marina',
		province: 'LI',
		altitude: 3
	},
	{
		zip: '81025',
		name: 'Marcianise',
		province: 'CE',
		altitude: 33
	},
	{
		zip: '52047',
		name: 'Marciano della Chiana',
		province: 'AR',
		altitude: 320
	},
	{
		zip: '27020',
		name: 'Marcignago',
		province: 'PV',
		altitude: 89
	},
	{
		zip: '30020',
		name: 'Marcon',
		province: 'VE',
		altitude: 5
	},
	{
		zip: '39030',
		name: 'Marebbe',
		province: 'BZ',
		altitude: 1186
	},
	{
		zip: '12030',
		name: 'Marene',
		province: 'CN',
		altitude: 310
	},
	{
		zip: '31010',
		name: 'Mareno di Piave',
		province: 'TV',
		altitude: 36
	},
	{
		zip: '10020',
		name: 'Marentino',
		province: 'TO',
		altitude: 383
	},
	{
		zip: '14018',
		name: 'Maretto',
		province: 'AT',
		altitude: 240
	},
	{
		zip: '12040',
		name: 'Margarita',
		province: 'CN',
		altitude: 448
	},
	{
		zip: '76016',
		name: 'Margherita di Savoia',
		province: 'BT',
		altitude: 1
	},
	{
		zip: '23832',
		name: 'Margno',
		province: 'LC',
		altitude: 730
	},
	{
		zip: '46010',
		name: 'Mariana Mantovana',
		province: 'MN',
		altitude: 36
	},
	{
		zip: '22066',
		name: 'Mariano Comense',
		province: 'CO',
		altitude: 252
	},
	{
		zip: '34070',
		name: 'Mariano del Friuli',
		province: 'GO',
		altitude: 32
	},
	{
		zip: '93010',
		name: 'Marianopoli',
		province: 'CL',
		altitude: 720
	},
	{
		zip: '80030',
		name: 'Mariglianella',
		province: 'NA',
		altitude: 28
	},
	{
		zip: '80034',
		name: 'Marigliano',
		province: 'NA',
		altitude: 30
	},
	{
		zip: '89046',
		name: 'Marina di Gioiosa Ionica',
		province: 'RC',
		altitude: 10
	},
	{
		zip: '90035',
		name: 'Marineo',
		province: 'PA',
		altitude: 520
	},
	{
		zip: '00047',
		name: 'Marino',
		province: 'RM',
		altitude: 373
	},
	{
		zip: '39020',
		name: 'Marlengo',
		province: 'BZ',
		altitude: 363
	},
	{
		zip: '51010',
		name: 'Marliana',
		province: 'PT',
		altitude: 469
	},
	{
		zip: '25060',
		name: 'Marmentino',
		province: 'BS',
		altitude: 875
	},
	{
		zip: '46045',
		name: 'Marmirolo',
		province: 'MN',
		altitude: 30
	},
	{
		zip: '12020',
		name: 'Marmora',
		province: 'CN',
		altitude: 1225
	},
	{
		zip: '21050',
		name: 'Marnate',
		province: 'VA',
		altitude: 227
	},
	{
		zip: '25054',
		name: 'Marone',
		province: 'BS',
		altitude: 189
	},
	{
		zip: '89020',
		name: 'Maropati',
		province: 'RC',
		altitude: 239
	},
	{
		zip: '36063',
		name: 'Marostica',
		province: 'VI',
		altitude: 103
	},
	{
		zip: '50034',
		name: 'Marradi',
		province: 'FI',
		altitude: 328
	},
	{
		zip: '09094',
		name: 'Marrubiu',
		province: 'OR',
		altitude: 7
	},
	{
		zip: '12060',
		name: 'Marsaglia',
		province: 'CN',
		altitude: 607
	},
	{
		zip: '91025',
		name: 'Marsala',
		province: 'TP',
		altitude: 3
	},
	{
		zip: '06055',
		name: 'Marsciano',
		province: 'PG',
		altitude: 184
	},
	{
		zip: '85052',
		name: 'Marsico Nuovo',
		province: 'PZ',
		altitude: 865
	},
	{
		zip: '85050',
		name: 'Marsicovetere',
		province: 'PZ',
		altitude: 1037
	},
	{
		zip: '01010',
		name: 'Marta',
		province: 'VT',
		altitude: 315
	},
	{
		zip: '73025',
		name: 'Martano',
		province: 'LE',
		altitude: 91
	},
	{
		zip: '30030',
		name: 'Martellago',
		province: 'VE',
		altitude: 12
	},
	{
		zip: '39020',
		name: 'Martello',
		province: 'BZ',
		altitude: 1312
	},
	{
		zip: '33035',
		name: 'Martignacco',
		province: 'UD',
		altitude: 141
	},
	{
		zip: '26040',
		name: 'Martignana di Po',
		province: 'CR',
		altitude: 26
	},
	{
		zip: '73020',
		name: 'Martignano',
		province: 'LE',
		altitude: 90
	},
	{
		zip: '74015',
		name: 'Martina Franca',
		province: 'TA',
		altitude: 431
	},
	{
		zip: '24057',
		name: 'Martinengo',
		province: 'BG',
		altitude: 149
	},
	{
		zip: '12030',
		name: 'Martiniana Po',
		province: 'CN',
		altitude: 460
	},
	{
		zip: '64014',
		name: 'Martinsicuro',
		province: 'TE',
		altitude: 2
	},
	{
		zip: '88040',
		name: 'Martirano',
		province: 'CZ',
		altitude: 381
	},
	{
		zip: '88040',
		name: 'Martirano Lombardo',
		province: 'CZ',
		altitude: 520
	},
	{
		zip: '07030',
		name: 'Martis',
		province: 'SS',
		altitude: 295
	},
	{
		zip: '89040',
		name: 'Martone',
		province: 'RC',
		altitude: 290
	},
	{
		zip: '26866',
		name: 'Marudo',
		province: 'LO',
		altitude: 77
	},
	{
		zip: '74020',
		name: 'Maruggio',
		province: 'TA',
		altitude: 26
	},
	{
		zip: '40043',
		name: 'Marzabotto',
		province: 'BO',
		altitude: 130
	},
	{
		zip: '27010',
		name: 'Marzano',
		province: 'PV',
		altitude: 78
	},
	{
		zip: '81035',
		name: 'Marzano Appio',
		province: 'CE',
		altitude: 318
	},
	{
		zip: '83020',
		name: 'Marzano di Nola',
		province: 'AV',
		altitude: 90
	},
	{
		zip: '87050',
		name: 'Marzi',
		province: 'CS',
		altitude: 530
	},
	{
		zip: '21030',
		name: 'Marzio',
		province: 'VA',
		altitude: 728
	},
	{
		zip: '09010',
		name: 'Masainas',
		province: 'SU',
		altitude: 57
	},
	{
		zip: '20060',
		name: 'Masate',
		province: 'MI',
		altitude: 153
	},
	{
		zip: '95016',
		name: 'Mascali',
		province: 'CT',
		altitude: 18
	},
	{
		zip: '95030',
		name: 'Mascalucia',
		province: 'CT',
		altitude: 420
	},
	{
		zip: '85020',
		name: 'Maschito',
		province: 'PZ',
		altitude: 595
	},
	{
		zip: '21030',
		name: 'Masciago Primo',
		province: 'VA',
		altitude: 347
	},
	{
		zip: '31010',
		name: 'Maser',
		province: 'TV',
		altitude: 147
	},
	{
		zip: '28855',
		name: 'Masera',
		province: 'VB',
		altitude: 297
	},
	{
		zip: '31052',
		name: 'Maserada sul Piave',
		province: 'TV',
		altitude: 31
	},
	{
		zip: '35020',
		name: 'Masera di Padova',
		province: 'PD',
		altitude: 9
	},
	{
		zip: '35040',
		name: 'Masi',
		province: 'PD',
		altitude: 11
	},
	{
		zip: '44020',
		name: 'Masi Torello',
		province: 'FE',
		altitude: 3
	},
	{
		zip: '15024',
		name: 'Masio',
		province: 'AL',
		altitude: 142
	},
	{
		zip: '22026',
		name: 'Maslianico',
		province: 'CO',
		altitude: 255
	},
	{
		zip: '16010',
		name: 'Masone',
		province: 'GE',
		altitude: 403
	},
	{
		zip: '54100',
		name: 'Massa',
		province: 'MS',
		altitude: 65
	},
	{
		zip: '63834',
		name: 'Massa Fermana',
		province: 'FM',
		altitude: 340
	},
	{
		zip: '48024',
		name: 'Massa Lombarda',
		province: 'RA',
		altitude: 13
	},
	{
		zip: '80061',
		name: 'Massa Lubrense',
		province: 'NA',
		altitude: 121
	},
	{
		zip: '58024',
		name: 'Massa Marittima',
		province: 'GR',
		altitude: 380
	},
	{
		zip: '06056',
		name: 'Massa Martana',
		province: 'PG',
		altitude: 351
	},
	{
		zip: '67050',
		name: 'Massa d\'\'Albe',
		province: 'AQ',
		altitude: 865
	},
	{
		zip: '80040',
		name: 'Massa di Somma',
		province: 'NA',
		altitude: 175
	},
	{
		zip: '51010',
		name: 'Massa e Cozzile',
		province: 'PT',
		altitude: 223
	},
	{
		zip: '74016',
		name: 'Massafra',
		province: 'TA',
		altitude: 110
	},
	{
		zip: '26815',
		name: 'Massalengo',
		province: 'LO',
		altitude: 76
	},
	{
		zip: '35010',
		name: 'Massanzago',
		province: 'PD',
		altitude: 18
	},
	{
		zip: '55040',
		name: 'Massarosa',
		province: 'LU',
		altitude: 10
	},
	{
		zip: '13873',
		name: 'Massazza',
		province: 'BI',
		altitude: 226
	},
	{
		zip: '10060',
		name: 'Massello',
		province: 'TO',
		altitude: 1188
	},
	{
		zip: '13866',
		name: 'Masserano',
		province: 'BI',
		altitude: 340
	},
	{
		zip: '63061',
		name: 'Massignano',
		province: 'AP',
		altitude: 254
	},
	{
		zip: '38086',
		name: 'Massimeno',
		province: 'TN',
		altitude: 861
	},
	{
		zip: '12071',
		name: 'Massimino',
		province: 'SV',
		altitude: 540
	},
	{
		zip: '28040',
		name: 'Massino Visconti',
		province: 'NO',
		altitude: 465
	},
	{
		zip: '28895',
		name: 'Massiola',
		province: 'VB',
		altitude: 772
	},
	{
		zip: '09090',
		name: 'Masullas',
		province: 'OR',
		altitude: 129
	},
	{
		zip: '62024',
		name: 'Matelica',
		province: 'MC',
		altitude: 354
	},
	{
		zip: '75100',
		name: 'Matera',
		province: 'MT',
		altitude: 401
	},
	{
		zip: '10075',
		name: 'Mathi',
		province: 'TO',
		altitude: 410
	},
	{
		zip: '73046',
		name: 'Matino',
		province: 'LE',
		altitude: 75
	},
	{
		zip: '86030',
		name: 'Matrice',
		province: 'CB',
		altitude: 690
	},
	{
		zip: '10050',
		name: 'Mattie',
		province: 'TO',
		altitude: 730
	},
	{
		zip: '71030',
		name: 'Mattinata',
		province: 'FG',
		altitude: 75
	},
	{
		zip: '91026',
		name: 'Mazara del Vallo',
		province: 'TP',
		altitude: 8
	},
	{
		zip: '25080',
		name: 'Mazzano',
		province: 'BS',
		altitude: 153
	},
	{
		zip: '00060',
		name: 'Mazzano Romano',
		province: 'RM',
		altitude: 200
	},
	{
		zip: '93013',
		name: 'Mazzarino',
		province: 'CL',
		altitude: 553
	},
	{
		zip: '95040',
		name: 'Mazzarrone',
		province: 'CT',
		altitude: 285
	},
	{
		zip: '98056',
		name: 'Mazzarra Sant\'\'Andrea',
		province: 'ME',
		altitude: 110
	},
	{
		zip: '38030',
		name: 'Mazzin',
		province: 'TN',
		altitude: 1395
	},
	{
		zip: '23030',
		name: 'Mazzo di Valtellina',
		province: 'SO',
		altitude: 552
	},
	{
		zip: '10035',
		name: 'Mazze',
		province: 'TO',
		altitude: 323
	},
	{
		zip: '08030',
		name: 'Meana Sardo',
		province: 'NU',
		altitude: 588
	},
	{
		zip: '10050',
		name: 'Meana di Susa',
		province: 'TO',
		altitude: 681
	},
	{
		zip: '20821',
		name: 'Meda',
		province: 'MB',
		altitude: 221
	},
	{
		zip: '27035',
		name: 'Mede',
		province: 'PV',
		altitude: 93
	},
	{
		zip: '34076',
		name: 'Medea',
		province: 'GO',
		altitude: 30
	},
	{
		zip: '43014',
		name: 'Medesano',
		province: 'PR',
		altitude: 136
	},
	{
		zip: '40059',
		name: 'Medicina',
		province: 'BO',
		altitude: 25
	},
	{
		zip: '20076',
		name: 'Mediglia',
		province: 'MI',
		altitude: 95
	},
	{
		zip: '24030',
		name: 'Medolago',
		province: 'BG',
		altitude: 277
	},
	{
		zip: '46046',
		name: 'Medole',
		province: 'MN',
		altitude: 75
	},
	{
		zip: '41036',
		name: 'Medolla',
		province: 'MO',
		altitude: 22
	},
	{
		zip: '31040',
		name: 'Meduna di Livenza',
		province: 'TV',
		altitude: 8
	},
	{
		zip: '33092',
		name: 'Meduno',
		province: 'PN',
		altitude: 313
	},
	{
		zip: '35040',
		name: 'Megliadino San Vitale',
		province: 'PD',
		altitude: 12
	},
	{
		zip: '28046',
		name: 'Meina',
		province: 'NO',
		altitude: 214
	},
	{
		zip: '45037',
		name: 'Melara',
		province: 'RO',
		altitude: 13
	},
	{
		zip: '15010',
		name: 'Melazzo',
		province: 'AL',
		altitude: 254
	},
	{
		zip: '47014',
		name: 'Meldola',
		province: 'FC',
		altitude: 58
	},
	{
		zip: '16010',
		name: 'Mele',
		province: 'GE',
		altitude: 125
	},
	{
		zip: '20077',
		name: 'Melegnano',
		province: 'MI',
		altitude: 88
	},
	{
		zip: '73026',
		name: 'Melendugno',
		province: 'LE',
		altitude: 36
	},
	{
		zip: '26843',
		name: 'Meleti',
		province: 'LO',
		altitude: 40
	},
	{
		zip: '85025',
		name: 'Melfi',
		province: 'PZ',
		altitude: 530
	},
	{
		zip: '89020',
		name: 'Melicucco',
		province: 'RC',
		altitude: 167
	},
	{
		zip: '89020',
		name: 'Melicucca',
		province: 'RC',
		altitude: 273
	},
	{
		zip: '96010',
		name: 'Melilli',
		province: 'SR',
		altitude: 310
	},
	{
		zip: '88817',
		name: 'Melissa',
		province: 'KR',
		altitude: 256
	},
	{
		zip: '73040',
		name: 'Melissano',
		province: 'LE',
		altitude: 59
	},
	{
		zip: '83030',
		name: 'Melito Irpino',
		province: 'AV',
		altitude: 461
	},
	{
		zip: '80017',
		name: 'Melito di Napoli',
		province: 'NA',
		altitude: 89
	},
	{
		zip: '89063',
		name: 'Melito di Porto Salvo',
		province: 'RC',
		altitude: 28
	},
	{
		zip: '82030',
		name: 'Melizzano',
		province: 'BN',
		altitude: 190
	},
	{
		zip: '12020',
		name: 'Melle',
		province: 'CN',
		altitude: 683
	},
	{
		zip: '23010',
		name: 'Mello',
		province: 'SO',
		altitude: 681
	},
	{
		zip: '73020',
		name: 'Melpignano',
		province: 'LE',
		altitude: 89
	},
	{
		zip: '39010',
		name: 'Meltina',
		province: 'BZ',
		altitude: 1140
	},
	{
		zip: '20066',
		name: 'Melzo',
		province: 'MI',
		altitude: 118
	},
	{
		zip: '22017',
		name: 'Menaggio',
		province: 'CO',
		altitude: 202
	},
	{
		zip: '27050',
		name: 'Menconico',
		province: 'PV',
		altitude: 728
	},
	{
		zip: '18025',
		name: 'Mendatica',
		province: 'IM',
		altitude: 778
	},
	{
		zip: '87040',
		name: 'Mendicino',
		province: 'CS',
		altitude: 500
	},
	{
		zip: '92013',
		name: 'Menfi',
		province: 'AG',
		altitude: 109
	},
	{
		zip: '00013',
		name: 'Mentana',
		province: 'RM',
		altitude: 150
	},
	{
		zip: '30020',
		name: 'Meolo',
		province: 'VE',
		altitude: 4
	},
	{
		zip: '15010',
		name: 'Merana',
		province: 'AL',
		altitude: 253
	},
	{
		zip: '39012',
		name: 'Merano',
		province: 'BZ',
		altitude: 325
	},
	{
		zip: '23807',
		name: 'Merate',
		province: 'LC',
		altitude: 292
	},
	{
		zip: '21020',
		name: 'Mercallo',
		province: 'VA',
		altitude: 277
	},
	{
		zip: '61040',
		name: 'Mercatello sul Metauro',
		province: 'PU',
		altitude: 429
	},
	{
		zip: '61013',
		name: 'Mercatino Conca',
		province: 'PU',
		altitude: 275
	},
	{
		zip: '84085',
		name: 'Mercato San Severino',
		province: 'SA',
		altitude: 146
	},
	{
		zip: '47025',
		name: 'Mercato Saraceno',
		province: 'FC',
		altitude: 150
	},
	{
		zip: '10010',
		name: 'Mercenasco',
		province: 'TO',
		altitude: 330
	},
	{
		zip: '83013',
		name: 'Mercogliano',
		province: 'AV',
		altitude: 550
	},
	{
		zip: '33036',
		name: 'Mereto di Tomba',
		province: 'UD',
		altitude: 98
	},
	{
		zip: '60030',
		name: 'Mergo',
		province: 'AN',
		altitude: 368
	},
	{
		zip: '28802',
		name: 'Mergozzo',
		province: 'VB',
		altitude: 204
	},
	{
		zip: '35040',
		name: 'Merlara',
		province: 'PD',
		altitude: 12
	},
	{
		zip: '26833',
		name: 'Merlino',
		province: 'LO',
		altitude: 101
	},
	{
		zip: '22046',
		name: 'Merone',
		province: 'CO',
		altitude: 280
	},
	{
		zip: '98040',
		name: 'Meri',
		province: 'ME',
		altitude: 64
	},
	{
		zip: '72023',
		name: 'Mesagne',
		province: 'BR',
		altitude: 72
	},
	{
		zip: '23020',
		name: 'Mese',
		province: 'SO',
		altitude: 274
	},
	{
		zip: '21030',
		name: 'Mesenzana',
		province: 'VA',
		altitude: 305
	},
	{
		zip: '20010',
		name: 'Mesero',
		province: 'MI',
		altitude: 154
	},
	{
		zip: '44026',
		name: 'Mesola',
		province: 'FE',
		altitude: 1
	},
	{
		zip: '88838',
		name: 'Mesoraca',
		province: 'KR',
		altitude: 415
	},
	{
		zip: '98121',
		name: 'Messina',
		province: 'ME',
		altitude: 3
	},
	{
		zip: '35035',
		name: 'Mestrino',
		province: 'PD',
		altitude: 20
	},
	{
		zip: '80062',
		name: 'Meta',
		province: 'NA',
		altitude: 111
	},
	{
		zip: '20883',
		name: 'Mezzago',
		province: 'MB',
		altitude: 219
	},
	{
		zip: '38020',
		name: 'Mezzana',
		province: 'TN',
		altitude: 940
	},
	{
		zip: '27030',
		name: 'Mezzana Bigli',
		province: 'PV',
		altitude: 76
	},
	{
		zip: '13831',
		name: 'Mezzana Mortigliengo',
		province: 'BI',
		altitude: 420
	},
	{
		zip: '27030',
		name: 'Mezzana Rabattone',
		province: 'PV',
		altitude: 68
	},
	{
		zip: '37030',
		name: 'Mezzane di Sotto',
		province: 'VR',
		altitude: 122
	},
	{
		zip: '16046',
		name: 'Mezzanego',
		province: 'GE',
		altitude: 83
	},
	{
		zip: '27040',
		name: 'Mezzanino',
		province: 'PV',
		altitude: 62
	},
	{
		zip: '38050',
		name: 'Mezzano',
		province: 'TN',
		altitude: 640
	},
	{
		zip: '10070',
		name: 'Mezzenile',
		province: 'TO',
		altitude: 680
	},
	{
		zip: '38016',
		name: 'Mezzocorona',
		province: 'TN',
		altitude: 219
	},
	{
		zip: '90030',
		name: 'Mezzojuso',
		province: 'PA',
		altitude: 546
	},
	{
		zip: '24010',
		name: 'Mezzoldo',
		province: 'BG',
		altitude: 835
	},
	{
		zip: '38017',
		name: 'Mezzolombardo',
		province: 'TN',
		altitude: 227
	},
	{
		zip: '28040',
		name: 'Mezzomerico',
		province: 'NO',
		altitude: 266
	},
	{
		zip: '13816',
		name: 'Miagliano',
		province: 'BI',
		altitude: 520
	},
	{
		zip: '31050',
		name: 'Miane',
		province: 'TV',
		altitude: 259
	},
	{
		zip: '28010',
		name: 'Miasino',
		province: 'NO',
		altitude: 479
	},
	{
		zip: '28817',
		name: 'Miazzina',
		province: 'VB',
		altitude: 721
	},
	{
		zip: '02010',
		name: 'Micigliano',
		province: 'RI',
		altitude: 1005
	},
	{
		zip: '73035',
		name: 'Miggiano',
		province: 'LE',
		altitude: 107
	},
	{
		zip: '66010',
		name: 'Miglianico',
		province: 'CH',
		altitude: 125
	},
	{
		zip: '88040',
		name: 'Miglierina',
		province: 'CZ',
		altitude: 575
	},
	{
		zip: '75010',
		name: 'Miglionico',
		province: 'MT',
		altitude: 461
	},
	{
		zip: '16018',
		name: 'Mignanego',
		province: 'GE',
		altitude: 137
	},
	{
		zip: '81049',
		name: 'Mignano Monte Lungo',
		province: 'CE',
		altitude: 137
	},
	{
		zip: '20121',
		name: 'Milano',
		province: 'MI',
		altitude: 120
	},
	{
		zip: '98057',
		name: 'Milazzo',
		province: 'ME',
		altitude: 1
	},
	{
		zip: '93010',
		name: 'Milena',
		province: 'CL',
		altitude: 423
	},
	{
		zip: '89852',
		name: 'Mileto',
		province: 'VV',
		altitude: 365
	},
	{
		zip: '09070',
		name: 'Milis',
		province: 'OR',
		altitude: 72
	},
	{
		zip: '98070',
		name: 'Militello Rosmarino',
		province: 'ME',
		altitude: 450
	},
	{
		zip: '95043',
		name: 'Militello in Val di Catania',
		province: 'CT',
		altitude: 413
	},
	{
		zip: '17017',
		name: 'Millesimo',
		province: 'SV',
		altitude: 429
	},
	{
		zip: '95010',
		name: 'Milo',
		province: 'CT',
		altitude: 720
	},
	{
		zip: '25020',
		name: 'Milzano',
		province: 'BS',
		altitude: 49
	},
	{
		zip: '95044',
		name: 'Mineo',
		province: 'CT',
		altitude: 528
	},
	{
		zip: '37046',
		name: 'Minerbe',
		province: 'VR',
		altitude: 16
	},
	{
		zip: '40061',
		name: 'Minerbio',
		province: 'BO',
		altitude: 16
	},
	{
		zip: '76013',
		name: 'Minervino Murge',
		province: 'BT',
		altitude: 429
	},
	{
		zip: '73027',
		name: 'Minervino di Lecce',
		province: 'LE',
		altitude: 98
	},
	{
		zip: '84010',
		name: 'Minori',
		province: 'SA',
		altitude: 5
	},
	{
		zip: '04026',
		name: 'Minturno',
		province: 'LT',
		altitude: 141
	},
	{
		zip: '55034',
		name: 'Minucciano',
		province: 'LU',
		altitude: 697
	},
	{
		zip: '17040',
		name: 'Mioglia',
		province: 'SV',
		altitude: 349
	},
	{
		zip: '30034',
		name: 'Mira',
		province: 'VE',
		altitude: 6
	},
	{
		zip: '83036',
		name: 'Mirabella Eclano',
		province: 'AV',
		altitude: 372
	},
	{
		zip: '95040',
		name: 'Mirabella Imbaccari',
		province: 'CT',
		altitude: 518
	},
	{
		zip: '15040',
		name: 'Mirabello Monferrato',
		province: 'AL',
		altitude: 124
	},
	{
		zip: '86010',
		name: 'Mirabello Sannitico',
		province: 'CB',
		altitude: 600
	},
	{
		zip: '27010',
		name: 'Miradolo Terme',
		province: 'PV',
		altitude: 72
	},
	{
		zip: '86080',
		name: 'Miranda',
		province: 'IS',
		altitude: 860
	},
	{
		zip: '41037',
		name: 'Mirandola',
		province: 'MO',
		altitude: 18
	},
	{
		zip: '30035',
		name: 'Mirano',
		province: 'VE',
		altitude: 9
	},
	{
		zip: '98070',
		name: 'Mirto',
		province: 'ME',
		altitude: 428
	},
	{
		zip: '47843',
		name: 'Misano Adriatico',
		province: 'RN',
		altitude: 49
	},
	{
		zip: '24040',
		name: 'Misano di Gera d\'\'Adda',
		province: 'BG',
		altitude: 104
	},
	{
		zip: '90036',
		name: 'Misilmeri',
		province: 'PA',
		altitude: 129
	},
	{
		zip: '20826',
		name: 'Misinto',
		province: 'MB',
		altitude: 252
	},
	{
		zip: '23873',
		name: 'Missaglia',
		province: 'LC',
		altitude: 326
	},
	{
		zip: '85010',
		name: 'Missanello',
		province: 'PZ',
		altitude: 604
	},
	{
		zip: '95045',
		name: 'Misterbianco',
		province: 'CT',
		altitude: 210
	},
	{
		zip: '14050',
		name: 'Moasca',
		province: 'AT',
		altitude: 260
	},
	{
		zip: '16047',
		name: 'Moconesi',
		province: 'GE',
		altitude: 132
	},
	{
		zip: '41121',
		name: 'Modena',
		province: 'MO',
		altitude: 34
	},
	{
		zip: '97015',
		name: 'Modica',
		province: 'RG',
		altitude: 296
	},
	{
		zip: '47015',
		name: 'Modigliana',
		province: 'FC',
		altitude: 185
	},
	{
		zip: '09090',
		name: 'Modolo',
		province: 'OR',
		altitude: 131
	},
	{
		zip: '70026',
		name: 'Modugno',
		province: 'BA',
		altitude: 79
	},
	{
		zip: '38035',
		name: 'Moena',
		province: 'TN',
		altitude: 1184
	},
	{
		zip: '23817',
		name: 'Moggio',
		province: 'LC',
		altitude: 890
	},
	{
		zip: '33015',
		name: 'Moggio Udinese',
		province: 'UD',
		altitude: 341
	},
	{
		zip: '46024',
		name: 'Moglia',
		province: 'MN',
		altitude: 20
	},
	{
		zip: '62010',
		name: 'Mogliano',
		province: 'MC',
		altitude: 313
	},
	{
		zip: '31021',
		name: 'Mogliano Veneto',
		province: 'TV',
		altitude: 8
	},
	{
		zip: '09080',
		name: 'Mogorella',
		province: 'OR',
		altitude: 265
	},
	{
		zip: '09095',
		name: 'Mogoro',
		province: 'OR',
		altitude: 136
	},
	{
		zip: '82010',
		name: 'Moiano',
		province: 'BN',
		altitude: 271
	},
	{
		zip: '33040',
		name: 'Moimacco',
		province: 'UD',
		altitude: 118
	},
	{
		zip: '98030',
		name: 'Moio Alcantara',
		province: 'ME',
		altitude: 535
	},
	{
		zip: '24070',
		name: 'Moio de Calvi',
		province: 'BG',
		altitude: 654
	},
	{
		zip: '84060',
		name: 'Moio della Civitella',
		province: 'SA',
		altitude: 515
	},
	{
		zip: '12010',
		name: 'Moiola',
		province: 'CN',
		altitude: 689
	},
	{
		zip: '70042',
		name: 'Mola di Bari',
		province: 'BA',
		altitude: 5
	},
	{
		zip: '15074',
		name: 'Molare',
		province: 'AL',
		altitude: 226
	},
	{
		zip: '55020',
		name: 'Molazzana',
		province: 'LU',
		altitude: 474
	},
	{
		zip: '70056',
		name: 'Molfetta',
		province: 'BA',
		altitude: 15
	},
	{
		zip: '67020',
		name: 'Molina Aterno',
		province: 'AQ',
		altitude: 512
	},
	{
		zip: '82020',
		name: 'Molinara',
		province: 'BN',
		altitude: 582
	},
	{
		zip: '40062',
		name: 'Molinella',
		province: 'BO',
		altitude: 8
	},
	{
		zip: '18010',
		name: 'Molini di Triora',
		province: 'IM',
		altitude: 460
	},
	{
		zip: '15050',
		name: 'Molino dei Torti',
		province: 'AL',
		altitude: 76
	},
	{
		zip: '85047',
		name: 'Moliterno',
		province: 'PZ',
		altitude: 879
	},
	{
		zip: '13023',
		name: 'Mollia',
		province: 'VC',
		altitude: 880
	},
	{
		zip: '89010',
		name: 'Molochio',
		province: 'RC',
		altitude: 310
	},
	{
		zip: '23847',
		name: 'Molteno',
		province: 'LC',
		altitude: 292
	},
	{
		zip: '22010',
		name: 'Moltrasio',
		province: 'CO',
		altitude: 247
	},
	{
		zip: '38018',
		name: 'Molveno',
		province: 'TN',
		altitude: 864
	},
	{
		zip: '14050',
		name: 'Mombaldone',
		province: 'AT',
		altitude: 219
	},
	{
		zip: '12070',
		name: 'Mombarcaro',
		province: 'CN',
		altitude: 896
	},
	{
		zip: '61024',
		name: 'Mombaroccio',
		province: 'PU',
		altitude: 321
	},
	{
		zip: '14046',
		name: 'Mombaruzzo',
		province: 'AT',
		altitude: 275
	},
	{
		zip: '12070',
		name: 'Mombasiglio',
		province: 'CN',
		altitude: 454
	},
	{
		zip: '15020',
		name: 'Mombello Monferrato',
		province: 'AL',
		altitude: 273
	},
	{
		zip: '10020',
		name: 'Mombello di Torino',
		province: 'TO',
		altitude: 336
	},
	{
		zip: '14047',
		name: 'Mombercelli',
		province: 'AT',
		altitude: 233
	},
	{
		zip: '28015',
		name: 'Momo',
		province: 'NO',
		altitude: 213
	},
	{
		zip: '10059',
		name: 'Mompantero',
		province: 'TO',
		altitude: 531
	},
	{
		zip: '02040',
		name: 'Mompeo',
		province: 'RI',
		altitude: 457
	},
	{
		zip: '15050',
		name: 'Momperone',
		province: 'AL',
		altitude: 279
	},
	{
		zip: '86040',
		name: 'Monacilioni',
		province: 'CB',
		altitude: 590
	},
	{
		zip: '14013',
		name: 'Monale',
		province: 'AT',
		altitude: 200
	},
	{
		zip: '89040',
		name: 'Monasterace',
		province: 'RC',
		altitude: 138
	},
	{
		zip: '14058',
		name: 'Monastero Bormida',
		province: 'AT',
		altitude: 191
	},
	{
		zip: '10070',
		name: 'Monastero di Lanzo',
		province: 'TO',
		altitude: 825
	},
	{
		zip: '12080',
		name: 'Monastero di Vasco',
		province: 'CN',
		altitude: 508
	},
	{
		zip: '12080',
		name: 'Monasterolo Casotto',
		province: 'CN',
		altitude: 726
	},
	{
		zip: '24060',
		name: 'Monasterolo del Castello',
		province: 'BG',
		altitude: 365
	},
	{
		zip: '12030',
		name: 'Monasterolo di Savigliano',
		province: 'CN',
		altitude: 291
	},
	{
		zip: '31050',
		name: 'Monastier di Treviso',
		province: 'TV',
		altitude: 6
	},
	{
		zip: '09023',
		name: 'Monastir',
		province: 'SU',
		altitude: 81
	},
	{
		zip: '10024',
		name: 'Moncalieri',
		province: 'TO',
		altitude: 260
	},
	{
		zip: '14036',
		name: 'Moncalvo',
		province: 'AT',
		altitude: 305
	},
	{
		zip: '15020',
		name: 'Moncestino',
		province: 'AL',
		altitude: 287
	},
	{
		zip: '12060',
		name: 'Monchiero',
		province: 'CN',
		altitude: 235
	},
	{
		zip: '43010',
		name: 'Monchio delle Corti',
		province: 'PR',
		altitude: 820
	},
	{
		zip: '13040',
		name: 'Moncrivello',
		province: 'VC',
		altitude: 322
	},
	{
		zip: '14024',
		name: 'Moncucco Torinese',
		province: 'AT',
		altitude: 403
	},
	{
		zip: '47836',
		name: 'Mondaino',
		province: 'RN',
		altitude: 420
	},
	{
		zip: '61040',
		name: 'Mondavio',
		province: 'PU',
		altitude: 280
	},
	{
		zip: '61037',
		name: 'Mondolfo',
		province: 'PU',
		altitude: 144
	},
	{
		zip: '12084',
		name: 'Mondovi',
		province: 'CN',
		altitude: 395
	},
	{
		zip: '81034',
		name: 'Mondragone',
		province: 'CE',
		altitude: 10
	},
	{
		zip: '16030',
		name: 'Moneglia',
		province: 'GE',
		altitude: 4
	},
	{
		zip: '12077',
		name: 'Monesiglio',
		province: 'CN',
		altitude: 372
	},
	{
		zip: '34074',
		name: 'Monfalcone',
		province: 'GO',
		altitude: 7
	},
	{
		zip: '98041',
		name: 'Monforte San Giorgio',
		province: 'ME',
		altitude: 287
	},
	{
		zip: '12065',
		name: 'Monforte d\'\'Alba',
		province: 'CN',
		altitude: 480
	},
	{
		zip: '31010',
		name: 'Monfumo',
		province: 'TV',
		altitude: 227
	},
	{
		zip: '14040',
		name: 'Mongardino',
		province: 'AT',
		altitude: 292
	},
	{
		zip: '40063',
		name: 'Monghidoro',
		province: 'BO',
		altitude: 841
	},
	{
		zip: '89823',
		name: 'Mongiana',
		province: 'VV',
		altitude: 922
	},
	{
		zip: '15060',
		name: 'Mongiardino Ligure',
		province: 'AL',
		altitude: 600
	},
	{
		zip: '98030',
		name: 'Mongiuffi Melia',
		province: 'ME',
		altitude: 421
	},
	{
		zip: '13888',
		name: 'Mongrando',
		province: 'BI',
		altitude: 355
	},
	{
		zip: '87040',
		name: 'Mongrassano',
		province: 'CS',
		altitude: 540
	},
	{
		zip: '39035',
		name: 'Monguelfo-Tesido',
		province: 'BZ',
		altitude: 1087
	},
	{
		zip: '22040',
		name: 'Monguzzo',
		province: 'CO',
		altitude: 320
	},
	{
		zip: '25080',
		name: 'Moniga del Garda',
		province: 'BS',
		altitude: 105
	},
	{
		zip: '15059',
		name: 'Monleale',
		province: 'AL',
		altitude: 184
	},
	{
		zip: '25040',
		name: 'Monno',
		province: 'BS',
		altitude: 1066
	},
	{
		zip: '70043',
		name: 'Monopoli',
		province: 'BA',
		altitude: 9
	},
	{
		zip: '90046',
		name: 'Monreale',
		province: 'PA',
		altitude: 310
	},
	{
		zip: '34016',
		name: 'Monrupino',
		province: 'TS',
		altitude: 418
	},
	{
		zip: '63842',
		name: 'Monsampietro Morico',
		province: 'FM',
		altitude: 289
	},
	{
		zip: '63077',
		name: 'Monsampolo del Tronto',
		province: 'AP',
		altitude: 158
	},
	{
		zip: '60030',
		name: 'Monsano',
		province: 'AN',
		altitude: 191
	},
	{
		zip: '35043',
		name: 'Monselice',
		province: 'PD',
		altitude: 13
	},
	{
		zip: '09042',
		name: 'Monserrato',
		province: 'CA',
		altitude: 2
	},
	{
		zip: '51015',
		name: 'Monsummano Terme',
		province: 'PT',
		altitude: 20
	},
	{
		zip: '14040',
		name: 'Montabone',
		province: 'AT',
		altitude: 454
	},
	{
		zip: '15050',
		name: 'Montacuto',
		province: 'AL',
		altitude: 525
	},
	{
		zip: '14014',
		name: 'Montafia',
		province: 'AT',
		altitude: 300
	},
	{
		zip: '86023',
		name: 'Montagano',
		province: 'CB',
		altitude: 801
	},
	{
		zip: '39040',
		name: 'Montagna',
		province: 'BZ',
		altitude: 497
	},
	{
		zip: '23020',
		name: 'Montagna in Valtellina',
		province: 'SO',
		altitude: 567
	},
	{
		zip: '35044',
		name: 'Montagnana',
		province: 'PD',
		altitude: 16
	},
	{
		zip: '98060',
		name: 'Montagnareale',
		province: 'ME',
		altitude: 300
	},
	{
		zip: '83030',
		name: 'Montaguto',
		province: 'AV',
		altitude: 730
	},
	{
		zip: '50050',
		name: 'Montaione',
		province: 'FI',
		altitude: 342
	},
	{
		zip: '98065',
		name: 'Montalbano Elicona',
		province: 'ME',
		altitude: 908
	},
	{
		zip: '75023',
		name: 'Montalbano Jonico',
		province: 'MT',
		altitude: 288
	},
	{
		zip: '53024',
		name: 'Montalcino',
		province: 'SI',
		altitude: 564
	},
	{
		zip: '15060',
		name: 'Montaldeo',
		province: 'AL',
		altitude: 332
	},
	{
		zip: '15010',
		name: 'Montaldo Bormida',
		province: 'AL',
		altitude: 334
	},
	{
		zip: '12040',
		name: 'Montaldo Roero',
		province: 'CN',
		altitude: 378
	},
	{
		zip: '14048',
		name: 'Montaldo Scarampi',
		province: 'AT',
		altitude: 258
	},
	{
		zip: '10020',
		name: 'Montaldo Torinese',
		province: 'TO',
		altitude: 375
	},
	{
		zip: '12080',
		name: 'Montaldo di Mondovi',
		province: 'CN',
		altitude: 796
	},
	{
		zip: '51037',
		name: 'Montale',
		province: 'PT',
		altitude: 85
	},
	{
		zip: '10090',
		name: 'Montalenghe',
		province: 'TO',
		altitude: 360
	},
	{
		zip: '92010',
		name: 'Montallegro',
		province: 'AG',
		altitude: 100
	},
	{
		zip: '18028',
		name: 'Montalto Carpasio',
		province: 'IM',
		altitude: 720
	},
	{
		zip: '10016',
		name: 'Montalto Dora',
		province: 'TO',
		altitude: 252
	},
	{
		zip: '27040',
		name: 'Montalto Pavese',
		province: 'PV',
		altitude: 380
	},
	{
		zip: '87046',
		name: 'Montalto Uffugo',
		province: 'CS',
		altitude: 430
	},
	{
		zip: '63068',
		name: 'Montalto delle Marche',
		province: 'AP',
		altitude: 513
	},
	{
		zip: '01014',
		name: 'Montalto di Castro',
		province: 'VT',
		altitude: 42
	},
	{
		zip: '10017',
		name: 'Montanaro',
		province: 'TO',
		altitude: 302
	},
	{
		zip: '26836',
		name: 'Montanaso Lombardo',
		province: 'LO',
		altitude: 83
	},
	{
		zip: '12040',
		name: 'Montanera',
		province: 'CN',
		altitude: 427
	},
	{
		zip: '84060',
		name: 'Montano Antilia',
		province: 'SA',
		altitude: 767
	},
	{
		zip: '22070',
		name: 'Montano Lucino',
		province: 'CO',
		altitude: 400
	},
	{
		zip: '63835',
		name: 'Montappone',
		province: 'FM',
		altitude: 370
	},
	{
		zip: '86070',
		name: 'Montaquila',
		province: 'IS',
		altitude: 460
	},
	{
		zip: '02040',
		name: 'Montasola',
		province: 'RI',
		altitude: 604
	},
	{
		zip: '88060',
		name: 'Montauro',
		province: 'CZ',
		altitude: 393
	},
	{
		zip: '66030',
		name: 'Montazzoli',
		province: 'CH',
		altitude: 850
	},
	{
		zip: '58019',
		name: 'Monte Argentario',
		province: 'GR',
		altitude: 5
	},
	{
		zip: '06057',
		name: 'Monte Castello di Vibio',
		province: 'PG',
		altitude: 423
	},
	{
		zip: '62030',
		name: 'Monte Cavallo',
		province: 'MC',
		altitude: 648
	},
	{
		zip: '61010',
		name: 'Monte Cerignone',
		province: 'PU',
		altitude: 528
	},
	{
		zip: '00077',
		name: 'Monte Compatri',
		province: 'RM',
		altitude: 576
	},
	{
		zip: '26010',
		name: 'Monte Cremasco',
		province: 'CR',
		altitude: 84
	},
	{
		zip: '63846',
		name: 'Monte Giberto',
		province: 'FM',
		altitude: 322
	},
	{
		zip: '61010',
		name: 'Monte Grimano Terme',
		province: 'PU',
		altitude: 536
	},
	{
		zip: '25050',
		name: 'Monte Isola',
		province: 'BS',
		altitude: 262
	},
	{
		zip: '23804',
		name: 'Monte Marenzo',
		province: 'LC',
		altitude: 440
	},
	{
		zip: '61040',
		name: 'Monte Porzio',
		province: 'PU',
		altitude: 105
	},
	{
		zip: '00078',
		name: 'Monte Porzio Catone',
		province: 'RM',
		altitude: 451
	},
	{
		zip: '63852',
		name: 'Monte Rinaldo',
		province: 'FM',
		altitude: 475
	},
	{
		zip: '60030',
		name: 'Monte Roberto',
		province: 'AN',
		altitude: 348
	},
	{
		zip: '01010',
		name: 'Monte Romano',
		province: 'VT',
		altitude: 230
	},
	{
		zip: '04020',
		name: 'Monte San Biagio',
		province: 'LT',
		altitude: 133
	},
	{
		zip: '84030',
		name: 'Monte San Giacomo',
		province: 'SA',
		altitude: 668
	},
	{
		zip: '03025',
		name: 'Monte San Giovanni Campano',
		province: 'FR',
		altitude: 438
	},
	{
		zip: '02040',
		name: 'Monte San Giovanni in Sabina',
		province: 'RI',
		altitude: 728
	},
	{
		zip: '62015',
		name: 'Monte San Giusto',
		province: 'MC',
		altitude: 236
	},
	{
		zip: '62020',
		name: 'Monte San Martino',
		province: 'MC',
		altitude: 600
	},
	{
		zip: '63815',
		name: 'Monte San Pietrangeli',
		province: 'FM',
		altitude: 241
	},
	{
		zip: '40050',
		name: 'Monte San Pietro',
		province: 'BO',
		altitude: 112
	},
	{
		zip: '52048',
		name: 'Monte San Savino',
		province: 'AR',
		altitude: 330
	},
	{
		zip: '60037',
		name: 'Monte San Vito',
		province: 'AN',
		altitude: 135
	},
	{
		zip: '71037',
		name: 'Monte Sant\'\'Angelo',
		province: 'FG',
		altitude: 796
	},
	{
		zip: '06010',
		name: 'Monte Santa Maria Tiberina',
		province: 'PG',
		altitude: 688
	},
	{
		zip: '63813',
		name: 'Monte Urano',
		province: 'FM',
		altitude: 247
	},
	{
		zip: '63847',
		name: 'Monte Vidon Combatte',
		province: 'FM',
		altitude: 393
	},
	{
		zip: '63836',
		name: 'Monte Vidon Corrado',
		province: 'FM',
		altitude: 429
	},
	{
		zip: '36030',
		name: 'Monte di Malo',
		province: 'VI',
		altitude: 374
	},
	{
		zip: '80070',
		name: 'Monte di Procida',
		province: 'NA',
		altitude: 63
	},
	{
		zip: '89064',
		name: 'Montebello Jonico',
		province: 'RC',
		altitude: 425
	},
	{
		zip: '36054',
		name: 'Montebello Vicentino',
		province: 'VI',
		altitude: 53
	},
	{
		zip: '27054',
		name: 'Montebello della Battaglia',
		province: 'PV',
		altitude: 110
	},
	{
		zip: '65010',
		name: 'Montebello di Bertona',
		province: 'PE',
		altitude: 615
	},
	{
		zip: '66040',
		name: 'Montebello sul Sangro',
		province: 'CH',
		altitude: 810
	},
	{
		zip: '31044',
		name: 'Montebelluna',
		province: 'TV',
		altitude: 109
	},
	{
		zip: '16025',
		name: 'Montebruno',
		province: 'GE',
		altitude: 655
	},
	{
		zip: '02040',
		name: 'Montebuono',
		province: 'RI',
		altitude: 325
	},
	{
		zip: '83037',
		name: 'Montecalvo Irpino',
		province: 'AV',
		altitude: 623
	},
	{
		zip: '27047',
		name: 'Montecalvo Versiggia',
		province: 'PV',
		altitude: 360
	},
	{
		zip: '61020',
		name: 'Montecalvo in Foglia',
		province: 'PU',
		altitude: 345
	},
	{
		zip: '60036',
		name: 'Montecarotto',
		province: 'AN',
		altitude: 380
	},
	{
		zip: '62010',
		name: 'Montecassiano',
		province: 'MC',
		altitude: 215
	},
	{
		zip: '15040',
		name: 'Montecastello',
		province: 'AL',
		altitude: 116
	},
	{
		zip: '05026',
		name: 'Montecastrilli',
		province: 'TR',
		altitude: 391
	},
	{
		zip: '56040',
		name: 'Montecatini Val di Cecina',
		province: 'PI',
		altitude: 416
	},
	{
		zip: '51016',
		name: 'Montecatini-Terme',
		province: 'PT',
		altitude: 29
	},
	{
		zip: '37030',
		name: 'Montecchia di Crosara',
		province: 'VR',
		altitude: 87
	},
	{
		zip: '05020',
		name: 'Montecchio',
		province: 'TR',
		altitude: 377
	},
	{
		zip: '42027',
		name: 'Montecchio Emilia',
		province: 'RE',
		altitude: 99
	},
	{
		zip: '36075',
		name: 'Montecchio Maggiore',
		province: 'VI',
		altitude: 72
	},
	{
		zip: '36030',
		name: 'Montecchio Precalcino',
		province: 'VI',
		altitude: 84
	},
	{
		zip: '15010',
		name: 'Montechiaro d\'\'Acqui',
		province: 'AL',
		altitude: 560
	},
	{
		zip: '14025',
		name: 'Montechiaro d\'\'Asti',
		province: 'AT',
		altitude: 292
	},
	{
		zip: '43022',
		name: 'Montechiarugolo',
		province: 'PR',
		altitude: 128
	},
	{
		zip: '86032',
		name: 'Montecilfone',
		province: 'CB',
		altitude: 405
	},
	{
		zip: '47868',
		name: 'Montecopiolo',
		province: 'RN',
		altitude: 915
	},
	{
		zip: '84060',
		name: 'Montecorice',
		province: 'SA',
		altitude: 90
	},
	{
		zip: '84090',
		name: 'Montecorvino Pugliano',
		province: 'SA',
		altitude: 342
	},
	{
		zip: '84096',
		name: 'Montecorvino Rovella',
		province: 'SA',
		altitude: 295
	},
	{
		zip: '62010',
		name: 'Montecosaro',
		province: 'MC',
		altitude: 252
	},
	{
		zip: '28864',
		name: 'Montecrestese',
		province: 'VB',
		altitude: 486
	},
	{
		zip: '41025',
		name: 'Montecreto',
		province: 'MO',
		altitude: 864
	},
	{
		zip: '63069',
		name: 'Montedinove',
		province: 'AP',
		altitude: 561
	},
	{
		zip: '93010',
		name: 'Montedoro',
		province: 'CL',
		altitude: 450
	},
	{
		zip: '83030',
		name: 'Montefalcione',
		province: 'AV',
		altitude: 523
	},
	{
		zip: '06036',
		name: 'Montefalco',
		province: 'PG',
		altitude: 472
	},
	{
		zip: '63855',
		name: 'Montefalcone Appennino',
		province: 'FM',
		altitude: 757
	},
	{
		zip: '82025',
		name: 'Montefalcone di Val Fortore',
		province: 'BN',
		altitude: 830
	},
	{
		zip: '86033',
		name: 'Montefalcone nel Sannio',
		province: 'CB',
		altitude: 659
	},
	{
		zip: '62010',
		name: 'Montefano',
		province: 'MC',
		altitude: 242
	},
	{
		zip: '61030',
		name: 'Montefelcino',
		province: 'PU',
		altitude: 260
	},
	{
		zip: '66040',
		name: 'Monteferrante',
		province: 'CH',
		altitude: 800
	},
	{
		zip: '01027',
		name: 'Montefiascone',
		province: 'VT',
		altitude: 590
	},
	{
		zip: '64030',
		name: 'Montefino',
		province: 'TE',
		altitude: 352
	},
	{
		zip: '47834',
		name: 'Montefiore Conca',
		province: 'RN',
		altitude: 385
	},
	{
		zip: '63062',
		name: 'Montefiore dell\'\'Aso',
		province: 'AP',
		altitude: 412
	},
	{
		zip: '41045',
		name: 'Montefiorino',
		province: 'MO',
		altitude: 797
	},
	{
		zip: '00010',
		name: 'Monteflavio',
		province: 'RM',
		altitude: 858
	},
	{
		zip: '84060',
		name: 'Monteforte Cilento',
		province: 'SA',
		altitude: 600
	},
	{
		zip: '83024',
		name: 'Monteforte Irpino',
		province: 'AV',
		altitude: 502
	},
	{
		zip: '37032',
		name: 'Monteforte d\'\'Alpone',
		province: 'VR',
		altitude: 38
	},
	{
		zip: '63858',
		name: 'Montefortino',
		province: 'FM',
		altitude: 612
	},
	{
		zip: '05030',
		name: 'Montefranco',
		province: 'TR',
		altitude: 414
	},
	{
		zip: '83030',
		name: 'Montefredane',
		province: 'AV',
		altitude: 593
	},
	{
		zip: '83030',
		name: 'Montefusco',
		province: 'AV',
		altitude: 705
	},
	{
		zip: '05010',
		name: 'Montegabbione',
		province: 'TR',
		altitude: 594
	},
	{
		zip: '36047',
		name: 'Montegalda',
		province: 'VI',
		altitude: 28
	},
	{
		zip: '36047',
		name: 'Montegaldella',
		province: 'VI',
		altitude: 23
	},
	{
		zip: '63094',
		name: 'Montegallo',
		province: 'AP',
		altitude: 870
	},
	{
		zip: '15050',
		name: 'Montegioco',
		province: 'AL',
		altitude: 197
	},
	{
		zip: '87070',
		name: 'Montegiordano',
		province: 'CS',
		altitude: 619
	},
	{
		zip: '63833',
		name: 'Montegiorgio',
		province: 'FM',
		altitude: 411
	},
	{
		zip: '63812',
		name: 'Montegranaro',
		province: 'FM',
		altitude: 279
	},
	{
		zip: '47837',
		name: 'Montegridolfo',
		province: 'RN',
		altitude: 290
	},
	{
		zip: '21010',
		name: 'Montegrino Valtravaglia',
		province: 'VA',
		altitude: 525
	},
	{
		zip: '18025',
		name: 'Montegrosso Pian Latte',
		province: 'IM',
		altitude: 721
	},
	{
		zip: '14048',
		name: 'Montegrosso d\'\'Asti',
		province: 'AT',
		altitude: 244
	},
	{
		zip: '35036',
		name: 'Montegrotto Terme',
		province: 'PD',
		altitude: 11
	},
	{
		zip: '74020',
		name: 'Monteiasi',
		province: 'TA',
		altitude: 47
	},
	{
		zip: '61025',
		name: 'Montelabbate',
		province: 'PU',
		altitude: 65
	},
	{
		zip: '00030',
		name: 'Montelanico',
		province: 'RM',
		altitude: 297
	},
	{
		zip: '66040',
		name: 'Montelapiano',
		province: 'CH',
		altitude: 740
	},
	{
		zip: '07010',
		name: 'Monteleone Rocca Doria',
		province: 'SS',
		altitude: 368
	},
	{
		zip: '02033',
		name: 'Monteleone Sabino',
		province: 'RI',
		altitude: 496
	},
	{
		zip: '05017',
		name: 'Monteleone d\'\'Orvieto',
		province: 'TR',
		altitude: 500
	},
	{
		zip: '63841',
		name: 'Monteleone di Fermo',
		province: 'FM',
		altitude: 427
	},
	{
		zip: '71020',
		name: 'Monteleone di Puglia',
		province: 'FG',
		altitude: 842
	},
	{
		zip: '06045',
		name: 'Monteleone di Spoleto',
		province: 'PG',
		altitude: 978
	},
	{
		zip: '90040',
		name: 'Montelepre',
		province: 'PA',
		altitude: 342
	},
	{
		zip: '00010',
		name: 'Montelibretti',
		province: 'RM',
		altitude: 232
	},
	{
		zip: '83048',
		name: 'Montella',
		province: 'AV',
		altitude: 560
	},
	{
		zip: '86040',
		name: 'Montelongo',
		province: 'CB',
		altitude: 592
	},
	{
		zip: '63853',
		name: 'Montelparo',
		province: 'FM',
		altitude: 588
	},
	{
		zip: '12050',
		name: 'Montelupo Albese',
		province: 'CN',
		altitude: 564
	},
	{
		zip: '50056',
		name: 'Montelupo Fiorentino',
		province: 'FI',
		altitude: 40
	},
	{
		zip: '62010',
		name: 'Montelupone',
		province: 'MC',
		altitude: 272
	},
	{
		zip: '90020',
		name: 'Montemaggiore Belsito',
		province: 'PA',
		altitude: 530
	},
	{
		zip: '14030',
		name: 'Montemagno',
		province: 'AT',
		altitude: 260
	},
	{
		zip: '12025',
		name: 'Montemale di Cuneo',
		province: 'CN',
		altitude: 931
	},
	{
		zip: '83040',
		name: 'Montemarano',
		province: 'AV',
		altitude: 820
	},
	{
		zip: '60018',
		name: 'Montemarciano',
		province: 'AN',
		altitude: 92
	},
	{
		zip: '15050',
		name: 'Montemarzino',
		province: 'AL',
		altitude: 448
	},
	{
		zip: '74020',
		name: 'Montemesola',
		province: 'TA',
		altitude: 183
	},
	{
		zip: '22010',
		name: 'Montemezzo',
		province: 'CO',
		altitude: 522
	},
	{
		zip: '52010',
		name: 'Montemignaio',
		province: 'AR',
		altitude: 739
	},
	{
		zip: '83038',
		name: 'Montemiletto',
		province: 'AV',
		altitude: 600
	},
	{
		zip: '85020',
		name: 'Montemilone',
		province: 'PZ',
		altitude: 320
	},
	{
		zip: '86030',
		name: 'Montemitro',
		province: 'CB',
		altitude: 508
	},
	{
		zip: '63088',
		name: 'Montemonaco',
		province: 'AP',
		altitude: 988
	},
	{
		zip: '59013',
		name: 'Montemurlo',
		province: 'PO',
		altitude: 73
	},
	{
		zip: '85053',
		name: 'Montemurro',
		province: 'PZ',
		altitude: 723
	},
	{
		zip: '33010',
		name: 'Montenars',
		province: 'UD',
		altitude: 472
	},
	{
		zip: '02040',
		name: 'Montenero Sabino',
		province: 'RI',
		altitude: 450
	},
	{
		zip: '86080',
		name: 'Montenero Val Cocchiara',
		province: 'IS',
		altitude: 893
	},
	{
		zip: '86036',
		name: 'Montenero di Bisaccia',
		province: 'CB',
		altitude: 273
	},
	{
		zip: '66010',
		name: 'Montenerodomo',
		province: 'CH',
		altitude: 1165
	},
	{
		zip: '66050',
		name: 'Monteodorisio',
		province: 'CH',
		altitude: 315
	},
	{
		zip: '88060',
		name: 'Montepaone',
		province: 'CZ',
		altitude: 367
	},
	{
		zip: '74020',
		name: 'Monteparano',
		province: 'TA',
		altitude: 135
	},
	{
		zip: '63076',
		name: 'Monteprandone',
		province: 'AP',
		altitude: 273
	},
	{
		zip: '53045',
		name: 'Montepulciano',
		province: 'SI',
		altitude: 605
	},
	{
		zip: '52035',
		name: 'Monterchi',
		province: 'AR',
		altitude: 356
	},
	{
		zip: '67015',
		name: 'Montereale',
		province: 'AQ',
		altitude: 948
	},
	{
		zip: '33086',
		name: 'Montereale Valcellina',
		province: 'PN',
		altitude: 317
	},
	{
		zip: '40050',
		name: 'Monterenzio',
		province: 'BO',
		altitude: 207
	},
	{
		zip: '53035',
		name: 'Monteriggioni',
		province: 'SI',
		altitude: 274
	},
	{
		zip: '86075',
		name: 'Monteroduni',
		province: 'IS',
		altitude: 468
	},
	{
		zip: '53014',
		name: 'Monteroni d\'\'Arbia',
		province: 'SI',
		altitude: 161
	},
	{
		zip: '73047',
		name: 'Monteroni di Lecce',
		province: 'LE',
		altitude: 35
	},
	{
		zip: '01030',
		name: 'Monterosi',
		province: 'VT',
		altitude: 276
	},
	{
		zip: '97010',
		name: 'Monterosso Almo',
		province: 'RG',
		altitude: 691
	},
	{
		zip: '89819',
		name: 'Monterosso Calabro',
		province: 'VV',
		altitude: 310
	},
	{
		zip: '12020',
		name: 'Monterosso Grana',
		province: 'CN',
		altitude: 720
	},
	{
		zip: '19016',
		name: 'Monterosso al Mare',
		province: 'SP',
		altitude: 12
	},
	{
		zip: '00015',
		name: 'Monterotondo',
		province: 'RM',
		altitude: 165
	},
	{
		zip: '58025',
		name: 'Monterotondo Marittimo',
		province: 'GR',
		altitude: 539
	},
	{
		zip: '63825',
		name: 'Monterubbiano',
		province: 'FM',
		altitude: 463
	},
	{
		zip: '73030',
		name: 'Montesano Salentino',
		province: 'LE',
		altitude: 105
	},
	{
		zip: '84033',
		name: 'Montesano sulla Marcellana',
		province: 'SA',
		altitude: 850
	},
	{
		zip: '82016',
		name: 'Montesarchio',
		province: 'BN',
		altitude: 300
	},
	{
		zip: '75024',
		name: 'Montescaglioso',
		province: 'MT',
		altitude: 352
	},
	{
		zip: '27040',
		name: 'Montescano',
		province: 'PV',
		altitude: 208
	},
	{
		zip: '28843',
		name: 'Montescheno',
		province: 'VB',
		altitude: 512
	},
	{
		zip: '56040',
		name: 'Montescudaio',
		province: 'PI',
		altitude: 242
	},
	{
		zip: '47854',
		name: 'Montescudo-Monte Colombo',
		province: 'RN',
		altitude: 328
	},
	{
		zip: '41055',
		name: 'Montese',
		province: 'MO',
		altitude: 841
	},
	{
		zip: '27052',
		name: 'Montesegale',
		province: 'PV',
		altitude: 326
	},
	{
		zip: '65015',
		name: 'Montesilvano',
		province: 'PE',
		altitude: 5
	},
	{
		zip: '50025',
		name: 'Montespertoli',
		province: 'FI',
		altitude: 257
	},
	{
		zip: '12040',
		name: 'Monteu Roero',
		province: 'CN',
		altitude: 395
	},
	{
		zip: '10020',
		name: 'Monteu da Po',
		province: 'TO',
		altitude: 177
	},
	{
		zip: '92010',
		name: 'Montevago',
		province: 'AG',
		altitude: 380
	},
	{
		zip: '52025',
		name: 'Montevarchi',
		province: 'AR',
		altitude: 144
	},
	{
		zip: '23874',
		name: 'Montevecchia',
		province: 'LC',
		altitude: 479
	},
	{
		zip: '83049',
		name: 'Monteverde',
		province: 'AV',
		altitude: 740
	},
	{
		zip: '56040',
		name: 'Monteverdi Marittimo',
		province: 'PI',
		altitude: 364
	},
	{
		zip: '36050',
		name: 'Monteviale',
		province: 'VI',
		altitude: 157
	},
	{
		zip: '12070',
		name: 'Montezemolo',
		province: 'CN',
		altitude: 750
	},
	{
		zip: '07020',
		name: 'Monti',
		province: 'SS',
		altitude: 300
	},
	{
		zip: '47020',
		name: 'Montiano',
		province: 'FC',
		altitude: 159
	},
	{
		zip: '25040',
		name: 'Monticelli Brusati',
		province: 'BS',
		altitude: 283
	},
	{
		zip: '27010',
		name: 'Monticelli Pavese',
		province: 'PV',
		altitude: 53
	},
	{
		zip: '29010',
		name: 'Monticelli d\'\'Ongina',
		province: 'PC',
		altitude: 40
	},
	{
		zip: '23876',
		name: 'Monticello Brianza',
		province: 'LC',
		altitude: 408
	},
	{
		zip: '36010',
		name: 'Monticello Conte Otto',
		province: 'VI',
		altitude: 42
	},
	{
		zip: '12066',
		name: 'Monticello d\'\'Alba',
		province: 'CN',
		altitude: 320
	},
	{
		zip: '25018',
		name: 'Montichiari',
		province: 'BS',
		altitude: 104
	},
	{
		zip: '53015',
		name: 'Monticiano',
		province: 'SI',
		altitude: 375
	},
	{
		zip: '58026',
		name: 'Montieri',
		province: 'GR',
		altitude: 704
	},
	{
		zip: '14026',
		name: 'Montiglio Monferrato',
		province: 'AT',
		altitude: 321
	},
	{
		zip: '54038',
		name: 'Montignoso',
		province: 'MS',
		altitude: 130
	},
	{
		zip: '25010',
		name: 'Montirone',
		province: 'BS',
		altitude: 100
	},
	{
		zip: '11020',
		name: 'Montjovet',
		province: 'AO',
		altitude: 406
	},
	{
		zip: '26010',
		name: 'Montodine',
		province: 'CR',
		altitude: 61
	},
	{
		zip: '16026',
		name: 'Montoggio',
		province: 'GE',
		altitude: 438
	},
	{
		zip: '06014',
		name: 'Montone',
		province: 'PG',
		altitude: 482
	},
	{
		zip: '02034',
		name: 'Montopoli di Sabina',
		province: 'RI',
		altitude: 331
	},
	{
		zip: '56020',
		name: 'Montopoli in Val d\'\'Arno',
		province: 'PI',
		altitude: 98
	},
	{
		zip: '22030',
		name: 'Montorfano',
		province: 'CO',
		altitude: 414
	},
	{
		zip: '00010',
		name: 'Montorio Romano',
		province: 'RM',
		altitude: 575
	},
	{
		zip: '64046',
		name: 'Montorio al Vomano',
		province: 'TE',
		altitude: 262
	},
	{
		zip: '86040',
		name: 'Montorio nei Frentani',
		province: 'CB',
		altitude: 654
	},
	{
		zip: '83025',
		name: 'Montoro',
		province: 'AV',
		altitude: 190
	},
	{
		zip: '36050',
		name: 'Montorso Vicentino',
		province: 'VI',
		altitude: 118
	},
	{
		zip: '63843',
		name: 'Montottone',
		province: 'FM',
		altitude: 277
	},
	{
		zip: '09090',
		name: 'Montresta',
		province: 'OR',
		altitude: 410
	},
	{
		zip: '12046',
		name: 'Monta',
		province: 'CN',
		altitude: 316
	},
	{
		zip: '27040',
		name: 'Montu Beccaria',
		province: 'PV',
		altitude: 277
	},
	{
		zip: '21020',
		name: 'Monvalle',
		province: 'VA',
		altitude: 226
	},
	{
		zip: '20900',
		name: 'Monza',
		province: 'MB',
		altitude: 162
	},
	{
		zip: '46040',
		name: 'Monzambano',
		province: 'MN',
		altitude: 88
	},
	{
		zip: '40036',
		name: 'Monzuno',
		province: 'BO',
		altitude: 621
	},
	{
		zip: '87016',
		name: 'Morano Calabro',
		province: 'CS',
		altitude: 694
	},
	{
		zip: '15025',
		name: 'Morano sul Po',
		province: 'AL',
		altitude: 123
	},
	{
		zip: '14023',
		name: 'Moransengo',
		province: 'AT',
		altitude: 400
	},
	{
		zip: '34070',
		name: 'Moraro',
		province: 'GO',
		altitude: 44
	},
	{
		zip: '21040',
		name: 'Morazzone',
		province: 'VA',
		altitude: 432
	},
	{
		zip: '23017',
		name: 'Morbegno',
		province: 'SO',
		altitude: 262
	},
	{
		zip: '15010',
		name: 'Morbello',
		province: 'AL',
		altitude: 402
	},
	{
		zip: '73040',
		name: 'Morciano di Leuca',
		province: 'LE',
		altitude: 130
	},
	{
		zip: '47833',
		name: 'Morciano di Romagna',
		province: 'RN',
		altitude: 83
	},
	{
		zip: '82026',
		name: 'Morcone',
		province: 'BN',
		altitude: 600
	},
	{
		zip: '40027',
		name: 'Mordano',
		province: 'BO',
		altitude: 21
	},
	{
		zip: '24050',
		name: 'Morengo',
		province: 'BG',
		altitude: 126
	},
	{
		zip: '07013',
		name: 'Mores',
		province: 'SS',
		altitude: 366
	},
	{
		zip: '63826',
		name: 'Moresco',
		province: 'FM',
		altitude: 405
	},
	{
		zip: '12033',
		name: 'Moretta',
		province: 'CN',
		altitude: 262
	},
	{
		zip: '29020',
		name: 'Morfasso',
		province: 'PC',
		altitude: 631
	},
	{
		zip: '31050',
		name: 'Morgano',
		province: 'TV',
		altitude: 23
	},
	{
		zip: '11017',
		name: 'Morgex',
		province: 'AO',
		altitude: 923
	},
	{
		zip: '09090',
		name: 'Morgongiori',
		province: 'OR',
		altitude: 351
	},
	{
		zip: '38065',
		name: 'Mori',
		province: 'TN',
		altitude: 204
	},
	{
		zip: '31010',
		name: 'Moriago della Battaglia',
		province: 'TV',
		altitude: 119
	},
	{
		zip: '00010',
		name: 'Moricone',
		province: 'RM',
		altitude: 296
	},
	{
		zip: '84030',
		name: 'Morigerati',
		province: 'SA',
		altitude: 268
	},
	{
		zip: '20081',
		name: 'Morimondo',
		province: 'MI',
		altitude: 109
	},
	{
		zip: '67050',
		name: 'Morino',
		province: 'AQ',
		altitude: 443
	},
	{
		zip: '10020',
		name: 'Moriondo Torinese',
		province: 'TO',
		altitude: 323
	},
	{
		zip: '00067',
		name: 'Morlupo',
		province: 'RM',
		altitude: 207
	},
	{
		zip: '87026',
		name: 'Mormanno',
		province: 'CS',
		altitude: 840
	},
	{
		zip: '21020',
		name: 'Mornago',
		province: 'VA',
		altitude: 250
	},
	{
		zip: '15075',
		name: 'Mornese',
		province: 'AL',
		altitude: 380
	},
	{
		zip: '27040',
		name: 'Mornico Losana',
		province: 'PV',
		altitude: 284
	},
	{
		zip: '24050',
		name: 'Mornico al Serio',
		province: 'BG',
		altitude: 162
	},
	{
		zip: '03017',
		name: 'Morolo',
		province: 'FR',
		altitude: 397
	},
	{
		zip: '12040',
		name: 'Morozzo',
		province: 'CN',
		altitude: 431
	},
	{
		zip: '83040',
		name: 'Morra De Sanctis',
		province: 'AV',
		altitude: 863
	},
	{
		zip: '02010',
		name: 'Morro Reatino',
		province: 'RI',
		altitude: 745
	},
	{
		zip: '60030',
		name: 'Morro d\'\'Alba',
		province: 'AN',
		altitude: 199
	},
	{
		zip: '64020',
		name: 'Morro d\'\'Oro',
		province: 'TE',
		altitude: 210
	},
	{
		zip: '86040',
		name: 'Morrone del Sannio',
		province: 'CB',
		altitude: 839
	},
	{
		zip: '62010',
		name: 'Morrovalle',
		province: 'MC',
		altitude: 246
	},
	{
		zip: '33075',
		name: 'Morsano al Tagliamento',
		province: 'PN',
		altitude: 14
	},
	{
		zip: '15010',
		name: 'Morsasco',
		province: 'AL',
		altitude: 350
	},
	{
		zip: '27036',
		name: 'Mortara',
		province: 'PV',
		altitude: 101
	},
	{
		zip: '33050',
		name: 'Mortegliano',
		province: 'UD',
		altitude: 41
	},
	{
		zip: '23811',
		name: 'Morterone',
		province: 'LC',
		altitude: 1070
	},
	{
		zip: '33030',
		name: 'Moruzzo',
		province: 'UD',
		altitude: 267
	},
	{
		zip: '26010',
		name: 'Moscazzano',
		province: 'CR',
		altitude: 67
	},
	{
		zip: '83020',
		name: 'Moschiano',
		province: 'AV',
		altitude: 276
	},
	{
		zip: '64023',
		name: 'Mosciano Sant\'\'Angelo',
		province: 'TE',
		altitude: 227
	},
	{
		zip: '65010',
		name: 'Moscufo',
		province: 'PE',
		altitude: 246
	},
	{
		zip: '39013',
		name: 'Moso in Passiria',
		province: 'BZ',
		altitude: 1007
	},
	{
		zip: '34070',
		name: 'Mossa',
		province: 'GO',
		altitude: 59
	},
	{
		zip: '26045',
		name: 'Motta Baluffi',
		province: 'CR',
		altitude: 31
	},
	{
		zip: '98030',
		name: 'Motta Camastra',
		province: 'ME',
		altitude: 453
	},
	{
		zip: '71030',
		name: 'Motta Montecorvino',
		province: 'FG',
		altitude: 662
	},
	{
		zip: '89065',
		name: 'Motta San Giovanni',
		province: 'RC',
		altitude: 450
	},
	{
		zip: '95040',
		name: 'Motta Sant\'\'Anastasia',
		province: 'CT',
		altitude: 275
	},
	{
		zip: '88040',
		name: 'Motta Santa Lucia',
		province: 'CZ',
		altitude: 590
	},
	{
		zip: '20086',
		name: 'Motta Visconti',
		province: 'MI',
		altitude: 100
	},
	{
		zip: '98070',
		name: 'Motta d\'\'Affermo',
		province: 'ME',
		altitude: 660
	},
	{
		zip: '13010',
		name: 'Motta de Conti',
		province: 'VC',
		altitude: 107
	},
	{
		zip: '31045',
		name: 'Motta di Livenza',
		province: 'TV',
		altitude: 7
	},
	{
		zip: '87010',
		name: 'Mottafollone',
		province: 'CS',
		altitude: 384
	},
	{
		zip: '13874',
		name: 'Mottalciata',
		province: 'BI',
		altitude: 203
	},
	{
		zip: '46020',
		name: 'Motteggiana',
		province: 'MN',
		altitude: 20
	},
	{
		zip: '74017',
		name: 'Mottola',
		province: 'TA',
		altitude: 387
	},
	{
		zip: '66030',
		name: 'Mozzagrogna',
		province: 'CH',
		altitude: 223
	},
	{
		zip: '24050',
		name: 'Mozzanica',
		province: 'BG',
		altitude: 102
	},
	{
		zip: '22076',
		name: 'Mozzate',
		province: 'CO',
		altitude: 286
	},
	{
		zip: '37060',
		name: 'Mozzecane',
		province: 'VR',
		altitude: 47
	},
	{
		zip: '24030',
		name: 'Mozzo',
		province: 'BG',
		altitude: 252
	},
	{
		zip: '62034',
		name: 'Muccia',
		province: 'MC',
		altitude: 454
	},
	{
		zip: '34015',
		name: 'Muggia',
		province: 'TS',
		altitude: 2
	},
	{
		zip: '20835',
		name: 'Muggio',
		province: 'MB',
		altitude: 186
	},
	{
		zip: '83027',
		name: 'Mugnano del Cardinale',
		province: 'AV',
		altitude: 250
	},
	{
		zip: '80018',
		name: 'Mugnano di Napoli',
		province: 'NA',
		altitude: 125
	},
	{
		zip: '26837',
		name: 'Mulazzano',
		province: 'LO',
		altitude: 91
	},
	{
		zip: '54026',
		name: 'Mulazzo',
		province: 'MS',
		altitude: 351
	},
	{
		zip: '25070',
		name: 'Mura',
		province: 'BS',
		altitude: 691
	},
	{
		zip: '09043',
		name: 'Muravera',
		province: 'SU',
		altitude: 9
	},
	{
		zip: '12060',
		name: 'Murazzano',
		province: 'CN',
		altitude: 739
	},
	{
		zip: '12030',
		name: 'Murello',
		province: 'CN',
		altitude: 260
	},
	{
		zip: '17013',
		name: 'Murialdo',
		province: 'SV',
		altitude: 524
	},
	{
		zip: '15020',
		name: 'Murisengo',
		province: 'AL',
		altitude: 338
	},
	{
		zip: '53016',
		name: 'Murlo',
		province: 'SI',
		altitude: 294
	},
	{
		zip: '73036',
		name: 'Muro Leccese',
		province: 'LE',
		altitude: 82
	},
	{
		zip: '85054',
		name: 'Muro Lucano',
		province: 'PZ',
		altitude: 600
	},
	{
		zip: '07030',
		name: 'Muros',
		province: 'SS',
		altitude: 305
	},
	{
		zip: '25080',
		name: 'Muscoline',
		province: 'BS',
		altitude: 272
	},
	{
		zip: '09010',
		name: 'Musei',
		province: 'SU',
		altitude: 119
	},
	{
		zip: '30024',
		name: 'Musile di Piave',
		province: 'VE',
		altitude: 4
	},
	{
		zip: '22010',
		name: 'Musso',
		province: 'CO',
		altitude: 201
	},
	{
		zip: '36065',
		name: 'Mussolente',
		province: 'VI',
		altitude: 129
	},
	{
		zip: '93014',
		name: 'Mussomeli',
		province: 'CL',
		altitude: 650
	},
	{
		zip: '33055',
		name: 'Muzzana del Turgnano',
		province: 'UD',
		altitude: 7
	},
	{
		zip: '13895',
		name: 'Muzzano',
		province: 'BI',
		altitude: 565
	},
	{
		zip: '38060',
		name: 'Nago-Torbole',
		province: 'TN',
		altitude: 64
	},
	{
		zip: '39010',
		name: 'Nalles',
		province: 'BZ',
		altitude: 331
	},
	{
		zip: '36024',
		name: 'Nanto',
		province: 'VI',
		altitude: 20
	},
	{
		zip: '80121',
		name: 'Napoli',
		province: 'NA',
		altitude: 17
	},
	{
		zip: '09070',
		name: 'Narbolia',
		province: 'OR',
		altitude: 57
	},
	{
		zip: '09010',
		name: 'Narcao',
		province: 'SU',
		altitude: 125
	},
	{
		zip: '89824',
		name: 'Nardodipace',
		province: 'VV',
		altitude: 1080
	},
	{
		zip: '73048',
		name: 'Nardo',
		province: 'LE',
		altitude: 45
	},
	{
		zip: '05035',
		name: 'Narni',
		province: 'TR',
		altitude: 240
	},
	{
		zip: '92028',
		name: 'Naro',
		province: 'AG',
		altitude: 600
	},
	{
		zip: '12068',
		name: 'Narzole',
		province: 'CN',
		altitude: 325
	},
	{
		zip: '17030',
		name: 'Nasino',
		province: 'SV',
		altitude: 335
	},
	{
		zip: '98074',
		name: 'Naso',
		province: 'ME',
		altitude: 498
	},
	{
		zip: '39025',
		name: 'Naturno',
		province: 'BZ',
		altitude: 528
	},
	{
		zip: '25075',
		name: 'Nave',
		province: 'BS',
		altitude: 236
	},
	{
		zip: '67020',
		name: 'Navelli',
		province: 'AQ',
		altitude: 760
	},
	{
		zip: '39040',
		name: 'Naz-Sciaves',
		province: 'BZ',
		altitude: 772
	},
	{
		zip: '00060',
		name: 'Nazzano',
		province: 'RM',
		altitude: 202
	},
	{
		zip: '16040',
		name: 'Ne',
		province: 'GE',
		altitude: 68
	},
	{
		zip: '28010',
		name: 'Nebbiuno',
		province: 'NO',
		altitude: 430
	},
	{
		zip: '37024',
		name: 'Negrar di Valpolicella',
		province: 'VR',
		altitude: 190
	},
	{
		zip: '16040',
		name: 'Neirone',
		province: 'GE',
		altitude: 350
	},
	{
		zip: '12052',
		name: 'Neive',
		province: 'CN',
		altitude: 308
	},
	{
		zip: '24027',
		name: 'Nembro',
		province: 'BG',
		altitude: 309
	},
	{
		zip: '00074',
		name: 'Nemi',
		province: 'RM',
		altitude: 521
	},
	{
		zip: '85040',
		name: 'Nemoli',
		province: 'PZ',
		altitude: 421
	},
	{
		zip: '09080',
		name: 'Neoneli',
		province: 'OR',
		altitude: 554
	},
	{
		zip: '01036',
		name: 'Nepi',
		province: 'VT',
		altitude: 227
	},
	{
		zip: '64015',
		name: 'Nereto',
		province: 'TE',
		altitude: 163
	},
	{
		zip: '00017',
		name: 'Nerola',
		province: 'RM',
		altitude: 453
	},
	{
		zip: '31040',
		name: 'Nervesa della Battaglia',
		province: 'TV',
		altitude: 78
	},
	{
		zip: '20014',
		name: 'Nerviano',
		province: 'MI',
		altitude: 175
	},
	{
		zip: '02020',
		name: 'Nespolo',
		province: 'RI',
		altitude: 886
	},
	{
		zip: '22020',
		name: 'Nesso',
		province: 'CO',
		altitude: 300
	},
	{
		zip: '13896',
		name: 'Netro',
		province: 'BI',
		altitude: 606
	},
	{
		zip: '00048',
		name: 'Nettuno',
		province: 'RO',
		altitude: 11
	},
	{
		zip: '73040',
		name: 'Neviano',
		province: 'LE',
		altitude: 108
	},
	{
		zip: '43024',
		name: 'Neviano degli Arduini',
		province: 'PR',
		altitude: 517
	},
	{
		zip: '12050',
		name: 'Neviglie',
		province: 'CN',
		altitude: 370
	},
	{
		zip: '25050',
		name: 'Niardo',
		province: 'BS',
		altitude: 443
	},
	{
		zip: '28070',
		name: 'Nibbiola',
		province: 'NO',
		altitude: 133
	},
	{
		zip: '23895',
		name: 'Nibionno',
		province: 'LC',
		altitude: 306
	},
	{
		zip: '10042',
		name: 'Nichelino',
		province: 'TO',
		altitude: 229
	},
	{
		zip: '95030',
		name: 'Nicolosi',
		province: 'CT',
		altitude: 700
	},
	{
		zip: '27020',
		name: 'Nicorvo',
		province: 'PV',
		altitude: 115
	},
	{
		zip: '89844',
		name: 'Nicotera',
		province: 'VV',
		altitude: 212
	},
	{
		zip: '12050',
		name: 'Niella Belbo',
		province: 'CN',
		altitude: 785
	},
	{
		zip: '12060',
		name: 'Niella Tanaro',
		province: 'CN',
		altitude: 371
	},
	{
		zip: '33045',
		name: 'Nimis',
		province: 'UD',
		altitude: 207
	},
	{
		zip: '93015',
		name: 'Niscemi',
		province: 'CL',
		altitude: 332
	},
	{
		zip: '94010',
		name: 'Nissoria',
		province: 'EN',
		altitude: 691
	},
	{
		zip: '14049',
		name: 'Nizza Monferrato',
		province: 'AT',
		altitude: 138
	},
	{
		zip: '98026',
		name: 'Nizza di Sicilia',
		province: 'ME',
		altitude: 9
	},
	{
		zip: '30033',
		name: 'Noale',
		province: 'VE',
		altitude: 18
	},
	{
		zip: '10080',
		name: 'Noasca',
		province: 'TO',
		altitude: 1065
	},
	{
		zip: '87070',
		name: 'Nocara',
		province: 'CS',
		altitude: 859
	},
	{
		zip: '65010',
		name: 'Nocciano',
		province: 'PE',
		altitude: 301
	},
	{
		zip: '84014',
		name: 'Nocera Inferiore',
		province: 'SA',
		altitude: 43
	},
	{
		zip: '84015',
		name: 'Nocera Superiore',
		province: 'SA',
		altitude: 70
	},
	{
		zip: '88047',
		name: 'Nocera Terinese',
		province: 'CZ',
		altitude: 240
	},
	{
		zip: '06025',
		name: 'Nocera Umbra',
		province: 'PG',
		altitude: 520
	},
	{
		zip: '43015',
		name: 'Noceto',
		province: 'PR',
		altitude: 74
	},
	{
		zip: '70015',
		name: 'Noci',
		province: 'BA',
		altitude: 420
	},
	{
		zip: '73020',
		name: 'Nociglia',
		province: 'LE',
		altitude: 104
	},
	{
		zip: '85035',
		name: 'Noepoli',
		province: 'PZ',
		altitude: 676
	},
	{
		zip: '37054',
		name: 'Nogara',
		province: 'VR',
		altitude: 18
	},
	{
		zip: '38060',
		name: 'Nogaredo',
		province: 'TN',
		altitude: 216
	},
	{
		zip: '37060',
		name: 'Nogarole Rocca',
		province: 'VR',
		altitude: 37
	},
	{
		zip: '36070',
		name: 'Nogarole Vicentino',
		province: 'VI',
		altitude: 525
	},
	{
		zip: '70016',
		name: 'Noicattaro',
		province: 'BA',
		altitude: 100
	},
	{
		zip: '80035',
		name: 'Nola',
		province: 'NA',
		altitude: 28
	},
	{
		zip: '10076',
		name: 'Nole',
		province: 'TO',
		altitude: 372
	},
	{
		zip: '17026',
		name: 'Noli',
		province: 'SV',
		altitude: 2
	},
	{
		zip: '10010',
		name: 'Nomaglio',
		province: 'TO',
		altitude: 575
	},
	{
		zip: '38060',
		name: 'Nomi',
		province: 'TN',
		altitude: 179
	},
	{
		zip: '41015',
		name: 'Nonantola',
		province: 'MO',
		altitude: 20
	},
	{
		zip: '10060',
		name: 'None',
		province: 'TO',
		altitude: 246
	},
	{
		zip: '28891',
		name: 'Nonio',
		province: 'VB',
		altitude: 476
	},
	{
		zip: '08010',
		name: 'Noragugume',
		province: 'NU',
		altitude: 288
	},
	{
		zip: '09070',
		name: 'Norbello',
		province: 'OR',
		altitude: 350
	},
	{
		zip: '06046',
		name: 'Norcia',
		province: 'PG',
		altitude: 604
	},
	{
		zip: '04010',
		name: 'Norma',
		province: 'LT',
		altitude: 444
	},
	{
		zip: '20020',
		name: 'Nosate',
		province: 'MI',
		altitude: 177
	},
	{
		zip: '64024',
		name: 'Notaresco',
		province: 'TE',
		altitude: 267
	},
	{
		zip: '96017',
		name: 'Noto',
		province: 'SR',
		altitude: 152
	},
	{
		zip: '39056',
		name: 'Nova Levante',
		province: 'BZ',
		altitude: 1182
	},
	{
		zip: '20834',
		name: 'Nova Milanese',
		province: 'MB',
		altitude: 175
	},
	{
		zip: '39050',
		name: 'Nova Ponente',
		province: 'BZ',
		altitude: 1357
	},
	{
		zip: '75020',
		name: 'Nova Siri',
		province: 'MT',
		altitude: 355
	},
	{
		zip: '47863',
		name: 'Novafeltria',
		province: 'RN',
		altitude: 275
	},
	{
		zip: '38050',
		name: 'Novaledo',
		province: 'TN',
		altitude: 475
	},
	{
		zip: '10050',
		name: 'Novalesa',
		province: 'TO',
		altitude: 826
	},
	{
		zip: '28100',
		name: 'Novara',
		province: 'NO',
		altitude: 162
	},
	{
		zip: '98058',
		name: 'Novara di Sicilia',
		province: 'ME',
		altitude: 650
	},
	{
		zip: '23025',
		name: 'Novate Mezzola',
		province: 'SO',
		altitude: 212
	},
	{
		zip: '20026',
		name: 'Novate Milanese',
		province: 'MI',
		altitude: 148
	},
	{
		zip: '36055',
		name: 'Nove',
		province: 'VI',
		altitude: 84
	},
	{
		zip: '22060',
		name: 'Novedrate',
		province: 'CO',
		altitude: 277
	},
	{
		zip: '42017',
		name: 'Novellara',
		province: 'RE',
		altitude: 23
	},
	{
		zip: '12060',
		name: 'Novello',
		province: 'CN',
		altitude: 471
	},
	{
		zip: '35027',
		name: 'Noventa Padovana',
		province: 'PD',
		altitude: 13
	},
	{
		zip: '36025',
		name: 'Noventa Vicentina',
		province: 'VI',
		altitude: 13
	},
	{
		zip: '30020',
		name: 'Noventa di Piave',
		province: 'VE',
		altitude: 3
	},
	{
		zip: '15067',
		name: 'Novi Ligure',
		province: 'AL',
		altitude: 197
	},
	{
		zip: '84060',
		name: 'Novi Velia',
		province: 'SA',
		altitude: 648
	},
	{
		zip: '41016',
		name: 'Novi di Modena',
		province: 'MO',
		altitude: 21
	},
	{
		zip: '20082',
		name: 'Noviglio',
		province: 'MI',
		altitude: 103
	},
	{
		zip: '73051',
		name: 'Novoli',
		province: 'LE',
		altitude: 37
	},
	{
		zip: '12070',
		name: 'Nucetto',
		province: 'CN',
		altitude: 450
	},
	{
		zip: '07010',
		name: 'Nughedu San Nicolo',
		province: 'SS',
		altitude: 577
	},
	{
		zip: '09080',
		name: 'Nughedu Santa Vittoria',
		province: 'OR',
		altitude: 533
	},
	{
		zip: '07010',
		name: 'Nule',
		province: 'SS',
		altitude: 650
	},
	{
		zip: '07032',
		name: 'Nulvi',
		province: 'SS',
		altitude: 478
	},
	{
		zip: '60026',
		name: 'Numana',
		province: 'AN',
		altitude: 96
	},
	{
		zip: '08100',
		name: 'Nuoro',
		province: 'NU',
		altitude: 554
	},
	{
		zip: '09070',
		name: 'Nurachi',
		province: 'OR',
		altitude: 7
	},
	{
		zip: '09057',
		name: 'Nuragus',
		province: 'SU',
		altitude: 360
	},
	{
		zip: '09058',
		name: 'Nurallao',
		province: 'SU',
		altitude: 390
	},
	{
		zip: '09024',
		name: 'Nuraminis',
		province: 'SU',
		altitude: 91
	},
	{
		zip: '09080',
		name: 'Nureci',
		province: 'OR',
		altitude: 335
	},
	{
		zip: '09059',
		name: 'Nurri',
		province: 'SU',
		altitude: 612
	},
	{
		zip: '11020',
		name: 'Nus',
		province: 'AO',
		altitude: 529
	},
	{
		zip: '83051',
		name: 'Nusco',
		province: 'AV',
		altitude: 914
	},
	{
		zip: '25080',
		name: 'Nuvolento',
		province: 'BS',
		altitude: 176
	},
	{
		zip: '25080',
		name: 'Nuvolera',
		province: 'BS',
		altitude: 165
	},
	{
		zip: '09010',
		name: 'Nuxis',
		province: 'SU',
		altitude: 196
	},
	{
		zip: '13897',
		name: 'Occhieppo Inferiore',
		province: 'BI',
		altitude: 416
	},
	{
		zip: '13898',
		name: 'Occhieppo Superiore',
		province: 'BI',
		altitude: 465
	},
	{
		zip: '45030',
		name: 'Occhiobello',
		province: 'RO',
		altitude: 8
	},
	{
		zip: '15040',
		name: 'Occimiano',
		province: 'AL',
		altitude: 107
	},
	{
		zip: '67040',
		name: 'Ocre',
		province: 'AQ',
		altitude: 850
	},
	{
		zip: '15020',
		name: 'Odalengo Grande',
		province: 'AL',
		altitude: 381
	},
	{
		zip: '15020',
		name: 'Odalengo Piccolo',
		province: 'AL',
		altitude: 289
	},
	{
		zip: '31046',
		name: 'Oderzo',
		province: 'TV',
		altitude: 13
	},
	{
		zip: '25076',
		name: 'Odolo',
		province: 'BS',
		altitude: 345
	},
	{
		zip: '67025',
		name: 'Ofena',
		province: 'AQ',
		altitude: 531
	},
	{
		zip: '60020',
		name: 'Offagna',
		province: 'AN',
		altitude: 306
	},
	{
		zip: '26010',
		name: 'Offanengo',
		province: 'CR',
		altitude: 80
	},
	{
		zip: '63073',
		name: 'Offida',
		province: 'AP',
		altitude: 293
	},
	{
		zip: '25020',
		name: 'Offlaga',
		province: 'BS',
		altitude: 73
	},
	{
		zip: '28824',
		name: 'Oggebbio',
		province: 'VB',
		altitude: 265
	},
	{
		zip: '21040',
		name: 'Oggiona con Santo Stefano',
		province: 'VA',
		altitude: 293
	},
	{
		zip: '23848',
		name: 'Oggiono',
		province: 'LC',
		altitude: 268
	},
	{
		zip: '10080',
		name: 'Oglianico',
		province: 'TO',
		altitude: 326
	},
	{
		zip: '84061',
		name: 'Ogliastro Cilento',
		province: 'SA',
		altitude: 365
	},
	{
		zip: '07026',
		name: 'Olbia',
		province: 'SS',
		altitude: 10
	},
	{
		zip: '13047',
		name: 'Olcenengo',
		province: 'VC',
		altitude: 149
	},
	{
		zip: '13030',
		name: 'Oldenico',
		province: 'VC',
		altitude: 143
	},
	{
		zip: '28047',
		name: 'Oleggio',
		province: 'NO',
		altitude: 233
	},
	{
		zip: '28040',
		name: 'Oleggio Castello',
		province: 'NO',
		altitude: 293
	},
	{
		zip: '00035',
		name: 'Olevano Romano',
		province: 'RM',
		altitude: 571
	},
	{
		zip: '27020',
		name: 'Olevano di Lomellina',
		province: 'PV',
		altitude: 105
	},
	{
		zip: '84062',
		name: 'Olevano sul Tusciano',
		province: 'SA',
		altitude: 197
	},
	{
		zip: '22077',
		name: 'Olgiate Comasco',
		province: 'CO',
		altitude: 400
	},
	{
		zip: '23887',
		name: 'Olgiate Molgora',
		province: 'LC',
		altitude: 287
	},
	{
		zip: '21057',
		name: 'Olgiate Olona',
		province: 'VA',
		altitude: 235
	},
	{
		zip: '23854',
		name: 'Olginate',
		province: 'LC',
		altitude: 200
	},
	{
		zip: '08025',
		name: 'Oliena',
		province: 'NU',
		altitude: 339
	},
	{
		zip: '27050',
		name: 'Oliva Gessi',
		province: 'PV',
		altitude: 245
	},
	{
		zip: '88060',
		name: 'Olivadi',
		province: 'CZ',
		altitude: 485
	},
	{
		zip: '98060',
		name: 'Oliveri',
		province: 'ME',
		altitude: 2
	},
	{
		zip: '84020',
		name: 'Oliveto Citra',
		province: 'SA',
		altitude: 300
	},
	{
		zip: '23865',
		name: 'Oliveto Lario',
		province: 'LC',
		altitude: 208
	},
	{
		zip: '75010',
		name: 'Oliveto Lucano',
		province: 'MT',
		altitude: 546
	},
	{
		zip: '18030',
		name: 'Olivetta San Michele',
		province: 'IM',
		altitude: 292
	},
	{
		zip: '15030',
		name: 'Olivola',
		province: 'AL',
		altitude: 280
	},
	{
		zip: '09088',
		name: 'Ollastra',
		province: 'OR',
		altitude: 23
	},
	{
		zip: '08020',
		name: 'Ollolai',
		province: 'NU',
		altitude: 920
	},
	{
		zip: '11010',
		name: 'Ollomont',
		province: 'AO',
		altitude: 1335
	},
	{
		zip: '07040',
		name: 'Olmedo',
		province: 'SS',
		altitude: 68
	},
	{
		zip: '26010',
		name: 'Olmeneta',
		province: 'CR',
		altitude: 55
	},
	{
		zip: '14050',
		name: 'Olmo Gentile',
		province: 'AT',
		altitude: 615
	},
	{
		zip: '24010',
		name: 'Olmo al Brembo',
		province: 'BG',
		altitude: 556
	},
	{
		zip: '24013',
		name: 'Oltre il Colle',
		province: 'BG',
		altitude: 1030
	},
	{
		zip: '24020',
		name: 'Oltressenda Alta',
		province: 'BG',
		altitude: 714
	},
	{
		zip: '22070',
		name: 'Oltrona di San Mamette',
		province: 'CO',
		altitude: 370
	},
	{
		zip: '08020',
		name: 'Olzai',
		province: 'NU',
		altitude: 474
	},
	{
		zip: '25050',
		name: 'Ome',
		province: 'BS',
		altitude: 231
	},
	{
		zip: '28887',
		name: 'Omegna',
		province: 'VB',
		altitude: 295
	},
	{
		zip: '84060',
		name: 'Omignano',
		province: 'SA',
		altitude: 540
	},
	{
		zip: '01010',
		name: 'Onano',
		province: 'VT',
		altitude: 510
	},
	{
		zip: '08020',
		name: 'Onani',
		province: 'NU',
		altitude: 482
	},
	{
		zip: '12030',
		name: 'Oncino',
		province: 'CN',
		altitude: 1220
	},
	{
		zip: '24020',
		name: 'Oneta',
		province: 'BG',
		altitude: 740
	},
	{
		zip: '08020',
		name: 'Onifai',
		province: 'NU',
		altitude: 29
	},
	{
		zip: '08020',
		name: 'Oniferi',
		province: 'NU',
		altitude: 478
	},
	{
		zip: '25050',
		name: 'Ono San Pietro',
		province: 'BS',
		altitude: 516
	},
	{
		zip: '24020',
		name: 'Onore',
		province: 'BG',
		altitude: 700
	},
	{
		zip: '17030',
		name: 'Onzo',
		province: 'SV',
		altitude: 410
	},
	{
		zip: '20073',
		name: 'Opera',
		province: 'MI',
		altitude: 99
	},
	{
		zip: '67030',
		name: 'Opi',
		province: 'AQ',
		altitude: 1250
	},
	{
		zip: '37050',
		name: 'Oppeano',
		province: 'VR',
		altitude: 26
	},
	{
		zip: '85015',
		name: 'Oppido Lucano',
		province: 'PZ',
		altitude: 670
	},
	{
		zip: '89014',
		name: 'Oppido Mamertina',
		province: 'RC',
		altitude: 321
	},
	{
		zip: '39040',
		name: 'Ora',
		province: 'BZ',
		altitude: 242
	},
	{
		zip: '08026',
		name: 'Orani',
		province: 'NU',
		altitude: 521
	},
	{
		zip: '86010',
		name: 'Oratino',
		province: 'CB',
		altitude: 795
	},
	{
		zip: '10043',
		name: 'Orbassano',
		province: 'TO',
		altitude: 273
	},
	{
		zip: '58010',
		name: 'Orbetello',
		province: 'GR',
		altitude: 3
	},
	{
		zip: '56040',
		name: 'Orciano Pisano',
		province: 'PI',
		altitude: 122
	},
	{
		zip: '17024',
		name: 'Orco Feglino',
		province: 'SV',
		altitude: 161
	},
	{
		zip: '71040',
		name: 'Ordona',
		province: 'FG',
		altitude: 120
	},
	{
		zip: '16040',
		name: 'Orero',
		province: 'GE',
		altitude: 169
	},
	{
		zip: '36040',
		name: 'Orgiano',
		province: 'VI',
		altitude: 30
	},
	{
		zip: '08027',
		name: 'Orgosolo',
		province: 'NU',
		altitude: 620
	},
	{
		zip: '72024',
		name: 'Oria',
		province: 'BR',
		altitude: 166
	},
	{
		zip: '67063',
		name: 'Oricola',
		province: 'AQ',
		altitude: 810
	},
	{
		zip: '21040',
		name: 'Origgio',
		province: 'VA',
		altitude: 194
	},
	{
		zip: '21030',
		name: 'Orino',
		province: 'VA',
		altitude: 456
	},
	{
		zip: '10010',
		name: 'Orio Canavese',
		province: 'TO',
		altitude: 327
	},
	{
		zip: '26863',
		name: 'Orio Litta',
		province: 'LO',
		altitude: 63
	},
	{
		zip: '24050',
		name: 'Orio al Serio',
		province: 'BG',
		altitude: 241
	},
	{
		zip: '87073',
		name: 'Oriolo',
		province: 'CS',
		altitude: 450
	},
	{
		zip: '01010',
		name: 'Oriolo Romano',
		province: 'VT',
		altitude: 420
	},
	{
		zip: '09170',
		name: 'Oristano',
		province: 'OR',
		altitude: 5
	},
	{
		zip: '12078',
		name: 'Ormea',
		province: 'CN',
		altitude: 736
	},
	{
		zip: '31024',
		name: 'Ormelle',
		province: 'TV',
		altitude: 22
	},
	{
		zip: '20876',
		name: 'Ornago',
		province: 'MB',
		altitude: 193
	},
	{
		zip: '28877',
		name: 'Ornavasso',
		province: 'VB',
		altitude: 215
	},
	{
		zip: '24010',
		name: 'Ornica',
		province: 'BG',
		altitude: 922
	},
	{
		zip: '08028',
		name: 'Orosei',
		province: 'NU',
		altitude: 19
	},
	{
		zip: '08020',
		name: 'Orotelli',
		province: 'NU',
		altitude: 406
	},
	{
		zip: '84060',
		name: 'Orria',
		province: 'SA',
		altitude: 540
	},
	{
		zip: '09061',
		name: 'Orroli',
		province: 'SU',
		altitude: 550
	},
	{
		zip: '31010',
		name: 'Orsago',
		province: 'TV',
		altitude: 44
	},
	{
		zip: '15010',
		name: 'Orsara Bormida',
		province: 'AL',
		altitude: 220
	},
	{
		zip: '71027',
		name: 'Orsara di Puglia',
		province: 'FG',
		altitude: 635
	},
	{
		zip: '22030',
		name: 'Orsenigo',
		province: 'CO',
		altitude: 329
	},
	{
		zip: '66036',
		name: 'Orsogna',
		province: 'CH',
		altitude: 432
	},
	{
		zip: '87020',
		name: 'Orsomarso',
		province: 'CS',
		altitude: 120
	},
	{
		zip: '71045',
		name: 'Orta Nova',
		province: 'FG',
		altitude: 69
	},
	{
		zip: '28016',
		name: 'Orta San Giulio',
		province: 'NO',
		altitude: 294
	},
	{
		zip: '81030',
		name: 'Orta di Atella',
		province: 'CE',
		altitude: 36
	},
	{
		zip: '09040',
		name: 'Ortacesus',
		province: 'SU',
		altitude: 161
	},
	{
		zip: '01028',
		name: 'Orte',
		province: 'VT',
		altitude: 132
	},
	{
		zip: '73030',
		name: 'Ortelle',
		province: 'LE',
		altitude: 99
	},
	{
		zip: '63851',
		name: 'Ortezzano',
		province: 'FM',
		altitude: 301
	},
	{
		zip: '52010',
		name: 'Ortignano Raggiolo',
		province: 'AR',
		altitude: 483
	},
	{
		zip: '39046',
		name: 'Ortisei',
		province: 'BZ',
		altitude: 1220
	},
	{
		zip: '66026',
		name: 'Ortona',
		province: 'CH',
		altitude: 72
	},
	{
		zip: '67050',
		name: 'Ortona dei Marsi',
		province: 'AQ',
		altitude: 1003
	},
	{
		zip: '17037',
		name: 'Ortovero',
		province: 'SV',
		altitude: 63
	},
	{
		zip: '67050',
		name: 'Ortucchio',
		province: 'AQ',
		altitude: 680
	},
	{
		zip: '08036',
		name: 'Ortueri',
		province: 'NU',
		altitude: 584
	},
	{
		zip: '08020',
		name: 'Orune',
		province: 'NU',
		altitude: 745
	},
	{
		zip: '05018',
		name: 'Orvieto',
		province: 'TR',
		altitude: 325
	},
	{
		zip: '02035',
		name: 'Orvinio',
		province: 'RI',
		altitude: 840
	},
	{
		zip: '25034',
		name: 'Orzinuovi',
		province: 'BS',
		altitude: 89
	},
	{
		zip: '25030',
		name: 'Orzivecchi',
		province: 'BS',
		altitude: 91
	},
	{
		zip: '10060',
		name: 'Osasco',
		province: 'TO',
		altitude: 344
	},
	{
		zip: '10040',
		name: 'Osasio',
		province: 'TO',
		altitude: 241
	},
	{
		zip: '07027',
		name: 'Oschiri',
		province: 'SS',
		altitude: 202
	},
	{
		zip: '08020',
		name: 'Osidda',
		province: 'NU',
		altitude: 650
	},
	{
		zip: '17010',
		name: 'Osiglia',
		province: 'SV',
		altitude: 715
	},
	{
		zip: '07033',
		name: 'Osilo',
		province: 'SS',
		altitude: 615
	},
	{
		zip: '60027',
		name: 'Osimo',
		province: 'AN',
		altitude: 265
	},
	{
		zip: '08040',
		name: 'Osini',
		province: 'NU',
		altitude: 645
	},
	{
		zip: '24040',
		name: 'Osio Sopra',
		province: 'BG',
		altitude: 192
	},
	{
		zip: '24046',
		name: 'Osio Sotto',
		province: 'BG',
		altitude: 182
	},
	{
		zip: '23875',
		name: 'Osnago',
		province: 'LC',
		altitude: 249
	},
	{
		zip: '33010',
		name: 'Osoppo',
		province: 'UD',
		altitude: 184
	},
	{
		zip: '18014',
		name: 'Ospedaletti',
		province: 'IM',
		altitude: 5
	},
	{
		zip: '38050',
		name: 'Ospedaletto',
		province: 'TN',
		altitude: 360
	},
	{
		zip: '35045',
		name: 'Ospedaletto Euganeo',
		province: 'PD',
		altitude: 12
	},
	{
		zip: '26864',
		name: 'Ospedaletto Lodigiano',
		province: 'LO',
		altitude: 64
	},
	{
		zip: '83014',
		name: 'Ospedaletto d\'\'Alpinolo',
		province: 'AV',
		altitude: 725
	},
	{
		zip: '32010',
		name: 'Ospitale di Cadore',
		province: 'BL',
		altitude: 490
	},
	{
		zip: '25035',
		name: 'Ospitaletto',
		province: 'BS',
		altitude: 154
	},
	{
		zip: '26816',
		name: 'Ossago Lodigiano',
		province: 'LO',
		altitude: 71
	},
	{
		zip: '38026',
		name: 'Ossana',
		province: 'TN',
		altitude: 970
	},
	{
		zip: '07045',
		name: 'Ossi',
		province: 'SS',
		altitude: 322
	},
	{
		zip: '25050',
		name: 'Ossimo',
		province: 'BS',
		altitude: 869
	},
	{
		zip: '20010',
		name: 'Ossona',
		province: 'MI',
		altitude: 156
	},
	{
		zip: '12030',
		name: 'Ostana',
		province: 'CN',
		altitude: 1250
	},
	{
		zip: '44020',
		name: 'Ostellato',
		province: 'FE',
		altitude: 2
	},
	{
		zip: '26032',
		name: 'Ostiano',
		province: 'CR',
		altitude: 43
	},
	{
		zip: '46035',
		name: 'Ostiglia',
		province: 'MN',
		altitude: 13
	},
	{
		zip: '60010',
		name: 'Ostra',
		province: 'AN',
		altitude: 188
	},
	{
		zip: '60010',
		name: 'Ostra Vetere',
		province: 'AN',
		altitude: 250
	},
	{
		zip: '72017',
		name: 'Ostuni',
		province: 'BR',
		altitude: 218
	},
	{
		zip: '73028',
		name: 'Otranto',
		province: 'LE',
		altitude: 15
	},
	{
		zip: '05030',
		name: 'Otricoli',
		province: 'TR',
		altitude: 209
	},
	{
		zip: '08020',
		name: 'Ottana',
		province: 'NU',
		altitude: 185
	},
	{
		zip: '84020',
		name: 'Ottati',
		province: 'SA',
		altitude: 530
	},
	{
		zip: '80044',
		name: 'Ottaviano',
		province: 'NA',
		altitude: 220
	},
	{
		zip: '15038',
		name: 'Ottiglio',
		province: 'AL',
		altitude: 264
	},
	{
		zip: '27030',
		name: 'Ottobiano',
		province: 'PV',
		altitude: 96
	},
	{
		zip: '29026',
		name: 'Ottone',
		province: 'PC',
		altitude: 510
	},
	{
		zip: '10056',
		name: 'Oulx',
		province: 'TO',
		altitude: 1100
	},
	{
		zip: '15076',
		name: 'Ovada',
		province: 'AL',
		altitude: 186
	},
	{
		zip: '33025',
		name: 'Ovaro',
		province: 'UD',
		altitude: 525
	},
	{
		zip: '15026',
		name: 'Oviglio',
		province: 'AL',
		altitude: 107
	},
	{
		zip: '67046',
		name: 'Ovindoli',
		province: 'AQ',
		altitude: 1375
	},
	{
		zip: '08020',
		name: 'Ovodda',
		province: 'NU',
		altitude: 751
	},
	{
		zip: '11010',
		name: 'Oyace',
		province: 'AO',
		altitude: 1377
	},
	{
		zip: '10080',
		name: 'Ozegna',
		province: 'TO',
		altitude: 300
	},
	{
		zip: '07014',
		name: 'Ozieri',
		province: 'SS',
		altitude: 390
	},
	{
		zip: '15039',
		name: 'Ozzano Monferrato',
		province: 'AL',
		altitude: 246
	},
	{
		zip: '40064',
		name: 'Ozzano dell\'\'Emilia',
		province: 'BO',
		altitude: 67
	},
	{
		zip: '20080',
		name: 'Ozzero',
		province: 'MI',
		altitude: 107
	},
	{
		zip: '09030',
		name: 'Pabillonis',
		province: 'SU',
		altitude: 42
	},
	{
		zip: '98042',
		name: 'Pace del Mela',
		province: 'ME',
		altitude: 114
	},
	{
		zip: '91027',
		name: 'Paceco',
		province: 'TP',
		altitude: 36
	},
	{
		zip: '67030',
		name: 'Pacentro',
		province: 'AQ',
		altitude: 690
	},
	{
		zip: '96018',
		name: 'Pachino',
		province: 'SR',
		altitude: 65
	},
	{
		zip: '06060',
		name: 'Paciano',
		province: 'PG',
		altitude: 391
	},
	{
		zip: '25080',
		name: 'Padenghe sul Garda',
		province: 'BS',
		altitude: 127
	},
	{
		zip: '15050',
		name: 'Paderna',
		province: 'AL',
		altitude: 300
	},
	{
		zip: '20037',
		name: 'Paderno Dugnano',
		province: 'MI',
		altitude: 163
	},
	{
		zip: '25050',
		name: 'Paderno Franciacorta',
		province: 'BS',
		altitude: 182
	},
	{
		zip: '26024',
		name: 'Paderno Ponchielli',
		province: 'CR',
		altitude: 58
	},
	{
		zip: '23877',
		name: 'Paderno d\'\'Adda',
		province: 'LC',
		altitude: 266
	},
	{
		zip: '35121',
		name: 'Padova',
		province: 'PD',
		altitude: 12
	},
	{
		zip: '07015',
		name: 'Padria',
		province: 'SS',
		altitude: 304
	},
	{
		zip: '07020',
		name: 'Padru',
		province: 'SS',
		altitude: 160
	},
	{
		zip: '84034',
		name: 'Padula',
		province: 'SA',
		altitude: 699
	},
	{
		zip: '82020',
		name: 'Paduli',
		province: 'BN',
		altitude: 349
	},
	{
		zip: '12034',
		name: 'Paesana',
		province: 'CN',
		altitude: 614
	},
	{
		zip: '31038',
		name: 'Paese',
		province: 'TV',
		altitude: 32
	},
	{
		zip: '84016',
		name: 'Pagani',
		province: 'SA',
		altitude: 35
	},
	{
		zip: '02020',
		name: 'Paganico Sabino',
		province: 'RI',
		altitude: 720
	},
	{
		zip: '24040',
		name: 'Pagazzano',
		province: 'BG',
		altitude: 126
	},
	{
		zip: '98020',
		name: 'Pagliara',
		province: 'ME',
		altitude: 200
	},
	{
		zip: '66020',
		name: 'Paglieta',
		province: 'CH',
		altitude: 235
	},
	{
		zip: '33010',
		name: 'Pagnacco',
		province: 'UD',
		altitude: 170
	},
	{
		zip: '12030',
		name: 'Pagno',
		province: 'CN',
		altitude: 362
	},
	{
		zip: '23833',
		name: 'Pagnona',
		province: 'LC',
		altitude: 790
	},
	{
		zip: '82020',
		name: 'Pago Veiano',
		province: 'BN',
		altitude: 485
	},
	{
		zip: '83020',
		name: 'Pago del Vallo di Lauro',
		province: 'AV',
		altitude: 130
	},
	{
		zip: '25050',
		name: 'Paisco Loveno',
		province: 'BS',
		altitude: 853
	},
	{
		zip: '25080',
		name: 'Paitone',
		province: 'BS',
		altitude: 177
	},
	{
		zip: '24030',
		name: 'Paladina',
		province: 'BG',
		altitude: 272
	},
	{
		zip: '41046',
		name: 'Palagano',
		province: 'MO',
		altitude: 723
	},
	{
		zip: '74018',
		name: 'Palagianello',
		province: 'TA',
		altitude: 130
	},
	{
		zip: '74019',
		name: 'Palagiano',
		province: 'TA',
		altitude: 40
	},
	{
		zip: '95046',
		name: 'Palagonia',
		province: 'CT',
		altitude: 200
	},
	{
		zip: '56036',
		name: 'Palaia',
		province: 'PI',
		altitude: 240
	},
	{
		zip: '43025',
		name: 'Palanzano',
		province: 'PR',
		altitude: 691
	},
	{
		zip: '86037',
		name: 'Palata',
		province: 'CB',
		altitude: 520
	},
	{
		zip: '07020',
		name: 'Palau',
		province: 'SS',
		altitude: 5
	},
	{
		zip: '24030',
		name: 'Palazzago',
		province: 'BG',
		altitude: 407
	},
	{
		zip: '90030',
		name: 'Palazzo Adriano',
		province: 'PA',
		altitude: 695
	},
	{
		zip: '10010',
		name: 'Palazzo Canavese',
		province: 'TO',
		altitude: 248
	},
	{
		zip: '26020',
		name: 'Palazzo Pignano',
		province: 'CR',
		altitude: 82
	},
	{
		zip: '85026',
		name: 'Palazzo San Gervasio',
		province: 'PZ',
		altitude: 485
	},
	{
		zip: '96010',
		name: 'Palazzolo Acreide',
		province: 'SR',
		altitude: 670
	},
	{
		zip: '13040',
		name: 'Palazzolo Vercellese',
		province: 'VC',
		altitude: 137
	},
	{
		zip: '33056',
		name: 'Palazzolo dello Stella',
		province: 'UD',
		altitude: 5
	},
	{
		zip: '25036',
		name: 'Palazzolo sull\'\'Oglio',
		province: 'BS',
		altitude: 166
	},
	{
		zip: '50035',
		name: 'Palazzuolo sul Senio',
		province: 'FI',
		altitude: 437
	},
	{
		zip: '66017',
		name: 'Palena',
		province: 'CH',
		altitude: 767
	},
	{
		zip: '88050',
		name: 'Palermiti',
		province: 'CZ',
		altitude: 496
	},
	{
		zip: '90121',
		name: 'Palermo',
		province: 'PA',
		altitude: 14
	},
	{
		zip: '00036',
		name: 'Palestrina',
		province: 'RM',
		altitude: 450
	},
	{
		zip: '27030',
		name: 'Palestro',
		province: 'PV',
		altitude: 121
	},
	{
		zip: '03018',
		name: 'Paliano',
		province: 'FR',
		altitude: 471
	},
	{
		zip: '89030',
		name: 'Palizzi',
		province: 'RC',
		altitude: 272
	},
	{
		zip: '88818',
		name: 'Pallagorio',
		province: 'KR',
		altitude: 554
	},
	{
		zip: '28884',
		name: 'Pallanzeno',
		province: 'VB',
		altitude: 230
	},
	{
		zip: '17043',
		name: 'Pallare',
		province: 'SV',
		altitude: 404
	},
	{
		zip: '80036',
		name: 'Palma Campania',
		province: 'NA',
		altitude: 63
	},
	{
		zip: '92020',
		name: 'Palma di Montechiaro',
		province: 'AG',
		altitude: 165
	},
	{
		zip: '33057',
		name: 'Palmanova',
		province: 'UD',
		altitude: 27
	},
	{
		zip: '73020',
		name: 'Palmariggi',
		province: 'LE',
		altitude: 99
	},
	{
		zip: '09090',
		name: 'Palmas Arborea',
		province: 'OR',
		altitude: 4
	},
	{
		zip: '89015',
		name: 'Palmi',
		province: 'RC',
		altitude: 228
	},
	{
		zip: '63092',
		name: 'Palmiano',
		province: 'AP',
		altitude: 550
	},
	{
		zip: '66050',
		name: 'Palmoli',
		province: 'CH',
		altitude: 727
	},
	{
		zip: '70027',
		name: 'Palo del Colle',
		province: 'BA',
		altitude: 177
	},
	{
		zip: '00018',
		name: 'Palombara Sabina',
		province: 'RM',
		altitude: 372
	},
	{
		zip: '66010',
		name: 'Palombaro',
		province: 'CH',
		altitude: 536
	},
	{
		zip: '84020',
		name: 'Palomonte',
		province: 'SA',
		altitude: 550
	},
	{
		zip: '24050',
		name: 'Palosco',
		province: 'BG',
		altitude: 157
	},
	{
		zip: '87060',
		name: 'Paludi',
		province: 'CS',
		altitude: 430
	},
	{
		zip: '33026',
		name: 'Paluzza',
		province: 'UD',
		altitude: 605
	},
	{
		zip: '37050',
		name: 'Palu',
		province: 'VR',
		altitude: 23
	},
	{
		zip: '38050',
		name: 'Palu del Fersina',
		province: 'TN',
		altitude: 1360
	},
	{
		zip: '12087',
		name: 'Pamparato',
		province: 'CN',
		altitude: 816
	},
	{
		zip: '10060',
		name: 'Pancalieri',
		province: 'TO',
		altitude: 243
	},
	{
		zip: '27050',
		name: 'Pancarana',
		province: 'PV',
		altitude: 68
	},
	{
		zip: '38030',
		name: 'Panchia',
		province: 'TN',
		altitude: 981
	},
	{
		zip: '26025',
		name: 'Pandino',
		province: 'CR',
		altitude: 85
	},
	{
		zip: '87050',
		name: 'Panettieri',
		province: 'CS',
		altitude: 937
	},
	{
		zip: '06064',
		name: 'Panicale',
		province: 'PG',
		altitude: 431
	},
	{
		zip: '82017',
		name: 'Pannarano',
		province: 'BN',
		altitude: 360
	},
	{
		zip: '71020',
		name: 'Panni',
		province: 'FG',
		altitude: 801
	},
	{
		zip: '91017',
		name: 'Pantelleria',
		province: 'TP',
		altitude: 5
	},
	{
		zip: '20048',
		name: 'Pantigliate',
		province: 'MI',
		altitude: 102
	},
	{
		zip: '87027',
		name: 'Paola',
		province: 'CS',
		altitude: 94
	},
	{
		zip: '82011',
		name: 'Paolisi',
		province: 'BN',
		altitude: 270
	},
	{
		zip: '87020',
		name: 'Papasidero',
		province: 'CS',
		altitude: 208
	},
	{
		zip: '45010',
		name: 'Papozze',
		province: 'RO',
		altitude: 5
	},
	{
		zip: '20015',
		name: 'Parabiago',
		province: 'MI',
		altitude: 184
	},
	{
		zip: '73052',
		name: 'Parabita',
		province: 'LE',
		altitude: 83
	},
	{
		zip: '25030',
		name: 'Paratico',
		province: 'BS',
		altitude: 234
	},
	{
		zip: '39020',
		name: 'Parcines',
		province: 'BZ',
		altitude: 626
	},
	{
		zip: '10010',
		name: 'Parella',
		province: 'TO',
		altitude: 330
	},
	{
		zip: '87040',
		name: 'Parenti',
		province: 'CS',
		altitude: 798
	},
	{
		zip: '81030',
		name: 'Parete',
		province: 'CE',
		altitude: 62
	},
	{
		zip: '15010',
		name: 'Pareto',
		province: 'AL',
		altitude: 476
	},
	{
		zip: '89861',
		name: 'Parghelia',
		province: 'VV',
		altitude: 80
	},
	{
		zip: '23837',
		name: 'Parlasco',
		province: 'LC',
		altitude: 679
	},
	{
		zip: '43121',
		name: 'Parma',
		province: 'PR',
		altitude: 57
	},
	{
		zip: '15060',
		name: 'Parodi Ligure',
		province: 'AL',
		altitude: 330
	},
	{
		zip: '12070',
		name: 'Paroldo',
		province: 'CN',
		altitude: 640
	},
	{
		zip: '83050',
		name: 'Parolise',
		province: 'AV',
		altitude: 546
	},
	{
		zip: '27020',
		name: 'Parona',
		province: 'PV',
		altitude: 113
	},
	{
		zip: '05010',
		name: 'Parrano',
		province: 'TR',
		altitude: 441
	},
	{
		zip: '24020',
		name: 'Parre',
		province: 'BG',
		altitude: 650
	},
	{
		zip: '91028',
		name: 'Partanna',
		province: 'TP',
		altitude: 424
	},
	{
		zip: '90047',
		name: 'Partinico',
		province: 'PA',
		altitude: 175
	},
	{
		zip: '28040',
		name: 'Paruzzaro',
		province: 'NO',
		altitude: 334
	},
	{
		zip: '24060',
		name: 'Parzanica',
		province: 'BG',
		altitude: 753
	},
	{
		zip: '33037',
		name: 'Pasian di Prato',
		province: 'UD',
		altitude: 95
	},
	{
		zip: '33087',
		name: 'Pasiano di Pordenone',
		province: 'PN',
		altitude: 13
	},
	{
		zip: '25050',
		name: 'Paspardo',
		province: 'BS',
		altitude: 1005
	},
	{
		zip: '14020',
		name: 'Passerano Marmorito',
		province: 'AT',
		altitude: 320
	},
	{
		zip: '06065',
		name: 'Passignano sul Trasimeno',
		province: 'PG',
		altitude: 289
	},
	{
		zip: '25050',
		name: 'Passirano',
		province: 'BS',
		altitude: 250
	},
	{
		zip: '03020',
		name: 'Pastena',
		province: 'FR',
		altitude: 318
	},
	{
		zip: '81050',
		name: 'Pastorano',
		province: 'CE',
		altitude: 67
	},
	{
		zip: '37010',
		name: 'Pastrengo',
		province: 'VR',
		altitude: 192
	},
	{
		zip: '15060',
		name: 'Pasturana',
		province: 'AL',
		altitude: 214
	},
	{
		zip: '23818',
		name: 'Pasturo',
		province: 'LC',
		altitude: 641
	},
	{
		zip: '85050',
		name: 'Paterno',
		province: 'PZ',
		altitude: 634
	},
	{
		zip: '87040',
		name: 'Paterno Calabro',
		province: 'CS',
		altitude: 680
	},
	{
		zip: '83052',
		name: 'Paternopoli',
		province: 'AV',
		altitude: 480
	},
	{
		zip: '95047',
		name: 'Paterno',
		province: 'CT',
		altitude: 225
	},
	{
		zip: '03010',
		name: 'Patrica',
		province: 'FR',
		altitude: 450
	},
	{
		zip: '07016',
		name: 'Pattada',
		province: 'SS',
		altitude: 778
	},
	{
		zip: '98066',
		name: 'Patti',
		province: 'ME',
		altitude: 157
	},
	{
		zip: '73053',
		name: 'Patu',
		province: 'LE',
		altitude: 124
	},
	{
		zip: '09090',
		name: 'Pau',
		province: 'OR',
		altitude: 315
	},
	{
		zip: '33027',
		name: 'Paularo',
		province: 'UD',
		altitude: 648
	},
	{
		zip: '09020',
		name: 'Pauli Arbarei',
		province: 'SU',
		altitude: 140
	},
	{
		zip: '09070',
		name: 'Paulilatino',
		province: 'OR',
		altitude: 280
	},
	{
		zip: '20067',
		name: 'Paullo',
		province: 'MI',
		altitude: 97
	},
	{
		zip: '82030',
		name: 'Paupisi',
		province: 'BN',
		altitude: 320
	},
	{
		zip: '10020',
		name: 'Pavarolo',
		province: 'TO',
		altitude: 363
	},
	{
		zip: '27100',
		name: 'Pavia',
		province: 'PV',
		altitude: 77
	},
	{
		zip: '33050',
		name: 'Pavia di Udine',
		province: 'UD',
		altitude: 56
	},
	{
		zip: '10018',
		name: 'Pavone Canavese',
		province: 'TO',
		altitude: 262
	},
	{
		zip: '25020',
		name: 'Pavone del Mella',
		province: 'BS',
		altitude: 54
	},
	{
		zip: '41026',
		name: 'Pavullo nel Frignano',
		province: 'MO',
		altitude: 682
	},
	{
		zip: '89040',
		name: 'Pazzano',
		province: 'RC',
		altitude: 410
	},
	{
		zip: '56037',
		name: 'Peccioli',
		province: 'PI',
		altitude: 144
	},
	{
		zip: '10020',
		name: 'Pecetto Torinese',
		province: 'TO',
		altitude: 398
	},
	{
		zip: '15040',
		name: 'Pecetto di Valenza',
		province: 'AL',
		altitude: 212
	},
	{
		zip: '95030',
		name: 'Pedara',
		province: 'CT',
		altitude: 610
	},
	{
		zip: '63827',
		name: 'Pedaso',
		province: 'FM',
		altitude: 4
	},
	{
		zip: '32034',
		name: 'Pedavena',
		province: 'BL',
		altitude: 356
	},
	{
		zip: '36040',
		name: 'Pedemonte',
		province: 'VI',
		altitude: 446
	},
	{
		zip: '31040',
		name: 'Pederobba',
		province: 'TV',
		altitude: 174
	},
	{
		zip: '23010',
		name: 'Pedesina',
		province: 'SO',
		altitude: 1032
	},
	{
		zip: '87050',
		name: 'Pedivigliano',
		province: 'CS',
		altitude: 580
	},
	{
		zip: '24066',
		name: 'Pedrengo',
		province: 'BG',
		altitude: 262
	},
	{
		zip: '46020',
		name: 'Pegognaga',
		province: 'MN',
		altitude: 22
	},
	{
		zip: '24020',
		name: 'Peia',
		province: 'BG',
		altitude: 570
	},
	{
		zip: '38024',
		name: 'Peio',
		province: 'TN',
		altitude: 1173
	},
	{
		zip: '50060',
		name: 'Pelago',
		province: 'FI',
		altitude: 309
	},
	{
		zip: '28010',
		name: 'Pella',
		province: 'NO',
		altitude: 305
	},
	{
		zip: '43047',
		name: 'Pellegrino Parmense',
		province: 'PR',
		altitude: 410
	},
	{
		zip: '84080',
		name: 'Pellezzano',
		province: 'SA',
		altitude: 247
	},
	{
		zip: '38020',
		name: 'Pellizzano',
		province: 'TN',
		altitude: 925
	},
	{
		zip: '38079',
		name: 'Pelugo',
		province: 'TN',
		altitude: 675
	},
	{
		zip: '14030',
		name: 'Penango',
		province: 'AT',
		altitude: 264
	},
	{
		zip: '62020',
		name: 'Penna San Giovanni',
		province: 'MC',
		altitude: 630
	},
	{
		zip: '64039',
		name: 'Penna Sant\'\'Andrea',
		province: 'TE',
		altitude: 413
	},
	{
		zip: '05028',
		name: 'Penna in Teverina',
		province: 'TR',
		altitude: 302
	},
	{
		zip: '47864',
		name: 'Pennabilli',
		province: 'RN',
		altitude: 629
	},
	{
		zip: '66040',
		name: 'Pennadomo',
		province: 'CH',
		altitude: 460
	},
	{
		zip: '66010',
		name: 'Pennapiedimonte',
		province: 'CH',
		altitude: 669
	},
	{
		zip: '65017',
		name: 'Penne',
		province: 'PE',
		altitude: 438
	},
	{
		zip: '88050',
		name: 'Pentone',
		province: 'CZ',
		altitude: 648
	},
	{
		zip: '66040',
		name: 'Perano',
		province: 'CH',
		altitude: 256
	},
	{
		zip: '32010',
		name: 'Perarolo di Cadore',
		province: 'BL',
		altitude: 532
	},
	{
		zip: '39030',
		name: 'Perca',
		province: 'BZ',
		altitude: 972
	},
	{
		zip: '00020',
		name: 'Percile',
		province: 'RM',
		altitude: 575
	},
	{
		zip: '08046',
		name: 'Perdasdefogu',
		province: 'NU',
		altitude: 599
	},
	{
		zip: '09010',
		name: 'Perdaxius',
		province: 'SU',
		altitude: 98
	},
	{
		zip: '84060',
		name: 'Perdifumo',
		province: 'SA',
		altitude: 425
	},
	{
		zip: '67064',
		name: 'Pereto',
		province: 'AQ',
		altitude: 800
	},
	{
		zip: '07034',
		name: 'Perfugas',
		province: 'SS',
		altitude: 90
	},
	{
		zip: '38057',
		name: 'Pergine Valsugana',
		province: 'TN',
		altitude: 482
	},
	{
		zip: '61045',
		name: 'Pergola',
		province: 'PU',
		altitude: 265
	},
	{
		zip: '18032',
		name: 'Perinaldo',
		province: 'IM',
		altitude: 572
	},
	{
		zip: '23828',
		name: 'Perledo',
		province: 'LC',
		altitude: 395
	},
	{
		zip: '12070',
		name: 'Perletto',
		province: 'CN',
		altitude: 446
	},
	{
		zip: '12070',
		name: 'Perlo',
		province: 'CN',
		altitude: 697
	},
	{
		zip: '11002',
		name: 'Perloz',
		province: 'AO',
		altitude: 661
	},
	{
		zip: '35020',
		name: 'Pernumia',
		province: 'PD',
		altitude: 9
	},
	{
		zip: '20016',
		name: 'Pero',
		province: 'MI',
		altitude: 144
	},
	{
		zip: '10063',
		name: 'Perosa Argentina',
		province: 'TO',
		altitude: 608
	},
	{
		zip: '10010',
		name: 'Perosa Canavese',
		province: 'TO',
		altitude: 265
	},
	{
		zip: '10060',
		name: 'Perrero',
		province: 'TO',
		altitude: 840
	},
	{
		zip: '26043',
		name: 'Persico Dosimo',
		province: 'CR',
		altitude: 48
	},
	{
		zip: '13030',
		name: 'Pertengo',
		province: 'VC',
		altitude: 122
	},
	{
		zip: '25070',
		name: 'Pertica Alta',
		province: 'BS',
		altitude: 900
	},
	{
		zip: '25070',
		name: 'Pertica Bassa',
		province: 'BS',
		altitude: 511
	},
	{
		zip: '84030',
		name: 'Pertosa',
		province: 'SA',
		altitude: 310
	},
	{
		zip: '10080',
		name: 'Pertusio',
		province: 'TO',
		altitude: 364
	},
	{
		zip: '06121',
		name: 'Perugia',
		province: 'PG',
		altitude: 493
	},
	{
		zip: '61121',
		name: 'Pesaro',
		province: 'PU',
		altitude: 11
	},
	{
		zip: '55064',
		name: 'Pescaglia',
		province: 'LU',
		altitude: 504
	},
	{
		zip: '37026',
		name: 'Pescantina',
		province: 'VR',
		altitude: 80
	},
	{
		zip: '65121',
		name: 'Pescara',
		province: 'PE',
		altitude: 4
	},
	{
		zip: '26033',
		name: 'Pescarolo ed Uniti',
		province: 'CR',
		altitude: 45
	},
	{
		zip: '67032',
		name: 'Pescasseroli',
		province: 'AQ',
		altitude: 1167
	},
	{
		zip: '23855',
		name: 'Pescate',
		province: 'LC',
		altitude: 214
	},
	{
		zip: '86090',
		name: 'Pesche',
		province: 'IS',
		altitude: 732
	},
	{
		zip: '71010',
		name: 'Peschici',
		province: 'FG',
		altitude: 90
	},
	{
		zip: '20068',
		name: 'Peschiera Borromeo',
		province: 'MI',
		altitude: 107
	},
	{
		zip: '37019',
		name: 'Peschiera del Garda',
		province: 'VR',
		altitude: 68
	},
	{
		zip: '51017',
		name: 'Pescia',
		province: 'PT',
		altitude: 71
	},
	{
		zip: '67057',
		name: 'Pescina',
		province: 'AQ',
		altitude: 735
	},
	{
		zip: '82020',
		name: 'Pesco Sannita',
		province: 'BN',
		altitude: 393
	},
	{
		zip: '67033',
		name: 'Pescocostanzo',
		province: 'AQ',
		altitude: 1395
	},
	{
		zip: '86097',
		name: 'Pescolanciano',
		province: 'IS',
		altitude: 806
	},
	{
		zip: '85020',
		name: 'Pescopagano',
		province: 'PZ',
		altitude: 954
	},
	{
		zip: '86080',
		name: 'Pescopennataro',
		province: 'IS',
		altitude: 1190
	},
	{
		zip: '02024',
		name: 'Pescorocchiano',
		province: 'RI',
		altitude: 806
	},
	{
		zip: '65020',
		name: 'Pescosansonesco',
		province: 'PE',
		altitude: 610
	},
	{
		zip: '03030',
		name: 'Pescosolido',
		province: 'FR',
		altitude: 630
	},
	{
		zip: '20042',
		name: 'Pessano con Bornago',
		province: 'MI',
		altitude: 148
	},
	{
		zip: '26030',
		name: 'Pessina Cremonese',
		province: 'CR',
		altitude: 42
	},
	{
		zip: '10070',
		name: 'Pessinetto',
		province: 'TO',
		altitude: 590
	},
	{
		zip: '86038',
		name: 'Petacciato',
		province: 'CB',
		altitude: 225
	},
	{
		zip: '88837',
		name: 'Petilia Policastro',
		province: 'KR',
		altitude: 436
	},
	{
		zip: '84020',
		name: 'Petina',
		province: 'SA',
		altitude: 649
	},
	{
		zip: '90026',
		name: 'Petralia Soprana',
		province: 'PA',
		altitude: 1147
	},
	{
		zip: '90027',
		name: 'Petralia Sottana',
		province: 'PA',
		altitude: 1039
	},
	{
		zip: '02025',
		name: 'Petrella Salto',
		province: 'RI',
		altitude: 786
	},
	{
		zip: '86024',
		name: 'Petrella Tifernina',
		province: 'CB',
		altitude: 651
	},
	{
		zip: '61020',
		name: 'Petriano',
		province: 'PU',
		altitude: 327
	},
	{
		zip: '62014',
		name: 'Petriolo',
		province: 'MC',
		altitude: 271
	},
	{
		zip: '63848',
		name: 'Petritoli',
		province: 'FM',
		altitude: 358
	},
	{
		zip: '88060',
		name: 'Petrizzi',
		province: 'CZ',
		altitude: 391
	},
	{
		zip: '88050',
		name: 'Petrona',
		province: 'CZ',
		altitude: 889
	},
	{
		zip: '91020',
		name: 'Petrosino',
		province: 'TP',
		altitude: 16
	},
	{
		zip: '83010',
		name: 'Petruro Irpino',
		province: 'AV',
		altitude: 500
	},
	{
		zip: '28028',
		name: 'Pettenasco',
		province: 'NO',
		altitude: 300
	},
	{
		zip: '13843',
		name: 'Pettinengo',
		province: 'BI',
		altitude: 703
	},
	{
		zip: '98070',
		name: 'Pettineo',
		province: 'ME',
		altitude: 250
	},
	{
		zip: '86090',
		name: 'Pettoranello del Molise',
		province: 'IS',
		altitude: 737
	},
	{
		zip: '67034',
		name: 'Pettorano sul Gizio',
		province: 'AQ',
		altitude: 656
	},
	{
		zip: '45010',
		name: 'Pettorazza Grimani',
		province: 'RO',
		altitude: 3
	},
	{
		zip: '12016',
		name: 'Peveragno',
		province: 'CN',
		altitude: 570
	},
	{
		zip: '13010',
		name: 'Pezzana',
		province: 'VC',
		altitude: 117
	},
	{
		zip: '25060',
		name: 'Pezzaze',
		province: 'BS',
		altitude: 620
	},
	{
		zip: '12070',
		name: 'Pezzolo Valle Uzzone',
		province: 'CN',
		altitude: 321
	},
	{
		zip: '29121',
		name: 'Piacenza',
		province: 'PC',
		altitude: 62
	},
	{
		zip: '35040',
		name: 'Piacenza d\'\'Adige',
		province: 'PD',
		altitude: 10
	},
	{
		zip: '26034',
		name: 'Piadena Drizzona',
		province: 'CR',
		altitude: 34
	},
	{
		zip: '84065',
		name: 'Piaggine',
		province: 'SA',
		altitude: 630
	},
	{
		zip: '25050',
		name: 'Pian Camuno',
		province: 'BS',
		altitude: 244
	},
	{
		zip: '17058',
		name: 'Piana Crixia',
		province: 'SV',
		altitude: 267
	},
	{
		zip: '90037',
		name: 'Piana degli Albanesi',
		province: 'PA',
		altitude: 740
	},
	{
		zip: '81013',
		name: 'Piana di Monte Verna',
		province: 'CE',
		altitude: 84
	},
	{
		zip: '53025',
		name: 'Piancastagnaio',
		province: 'SI',
		altitude: 772
	},
	{
		zip: '25052',
		name: 'Piancogno',
		province: 'BS',
		altitude: 251
	},
	{
		zip: '61026',
		name: 'Piandimeleto',
		province: 'PU',
		altitude: 319
	},
	{
		zip: '87050',
		name: 'Piane Crati',
		province: 'CS',
		altitude: 609
	},
	{
		zip: '65019',
		name: 'Pianella',
		province: 'PE',
		altitude: 236
	},
	{
		zip: '29010',
		name: 'Pianello Val Tidone',
		province: 'PC',
		altitude: 192
	},
	{
		zip: '22010',
		name: 'Pianello del Lario',
		province: 'CO',
		altitude: 200
	},
	{
		zip: '26010',
		name: 'Pianengo',
		province: 'CR',
		altitude: 83
	},
	{
		zip: '10044',
		name: 'Pianezza',
		province: 'TO',
		altitude: 325
	},
	{
		zip: '36060',
		name: 'Pianezze',
		province: 'VI',
		altitude: 184
	},
	{
		zip: '12080',
		name: 'Pianfei',
		province: 'CN',
		altitude: 503
	},
	{
		zip: '24060',
		name: 'Pianico',
		province: 'BG',
		altitude: 328
	},
	{
		zip: '30030',
		name: 'Pianiga',
		province: 'VE',
		altitude: 8
	},
	{
		zip: '80063',
		name: 'Piano di Sorrento',
		province: 'NA',
		altitude: 96
	},
	{
		zip: '88040',
		name: 'Pianopoli',
		province: 'CZ',
		altitude: 250
	},
	{
		zip: '40065',
		name: 'Pianoro',
		province: 'BO',
		altitude: 200
	},
	{
		zip: '01010',
		name: 'Piansano',
		province: 'VT',
		altitude: 409
	},
	{
		zip: '23010',
		name: 'Piantedo',
		province: 'SO',
		altitude: 215
	},
	{
		zip: '24020',
		name: 'Piario',
		province: 'BG',
		altitude: 539
	},
	{
		zip: '12026',
		name: 'Piasco',
		province: 'CN',
		altitude: 480
	},
	{
		zip: '23020',
		name: 'Piateda',
		province: 'SO',
		altitude: 304
	},
	{
		zip: '13844',
		name: 'Piatto',
		province: 'BI',
		altitude: 383
	},
	{
		zip: '94015',
		name: 'Piazza Armerina',
		province: 'EN',
		altitude: 697
	},
	{
		zip: '24014',
		name: 'Piazza Brembana',
		province: 'BG',
		altitude: 518
	},
	{
		zip: '55035',
		name: 'Piazza al Serchio',
		province: 'LU',
		altitude: 536
	},
	{
		zip: '24010',
		name: 'Piazzatorre',
		province: 'BG',
		altitude: 868
	},
	{
		zip: '35016',
		name: 'Piazzola sul Brenta',
		province: 'PD',
		altitude: 30
	},
	{
		zip: '24010',
		name: 'Piazzolo',
		province: 'BG',
		altitude: 702
	},
	{
		zip: '65010',
		name: 'Picciano',
		province: 'PE',
		altitude: 153
	},
	{
		zip: '85055',
		name: 'Picerno',
		province: 'PZ',
		altitude: 721
	},
	{
		zip: '03040',
		name: 'Picinisco',
		province: 'FR',
		altitude: 725
	},
	{
		zip: '03020',
		name: 'Pico',
		province: 'FR',
		altitude: 190
	},
	{
		zip: '14020',
		name: 'Piea',
		province: 'AT',
		altitude: 275
	},
	{
		zip: '13812',
		name: 'Piedicavallo',
		province: 'BI',
		altitude: 1050
	},
	{
		zip: '95017',
		name: 'Piedimonte Etneo',
		province: 'CT',
		altitude: 348
	},
	{
		zip: '81016',
		name: 'Piedimonte Matese',
		province: 'CE',
		altitude: 170
	},
	{
		zip: '03030',
		name: 'Piedimonte San Germano',
		province: 'FR',
		altitude: 115
	},
	{
		zip: '28885',
		name: 'Piedimulera',
		province: 'VB',
		altitude: 247
	},
	{
		zip: '06066',
		name: 'Piegaro',
		province: 'PG',
		altitude: 356
	},
	{
		zip: '53026',
		name: 'Pienza',
		province: 'SI',
		altitude: 491
	},
	{
		zip: '26017',
		name: 'Pieranica',
		province: 'CR',
		altitude: 91
	},
	{
		zip: '17027',
		name: 'Pietra Ligure',
		province: 'SV',
		altitude: 3
	},
	{
		zip: '15040',
		name: 'Pietra Marazzi',
		province: 'AL',
		altitude: 95
	},
	{
		zip: '27040',
		name: 'Pietra de Giorgi',
		province: 'PV',
		altitude: 311
	},
	{
		zip: '86085',
		name: 'Pietrabbondante',
		province: 'IS',
		altitude: 1027
	},
	{
		zip: '18010',
		name: 'Pietrabruna',
		province: 'IM',
		altitude: 400
	},
	{
		zip: '64047',
		name: 'Pietracamela',
		province: 'TE',
		altitude: 1005
	},
	{
		zip: '86040',
		name: 'Pietracatella',
		province: 'CB',
		altitude: 721
	},
	{
		zip: '86020',
		name: 'Pietracupa',
		province: 'CB',
		altitude: 695
	},
	{
		zip: '83030',
		name: 'Pietradefusi',
		province: 'AV',
		altitude: 400
	},
	{
		zip: '66040',
		name: 'Pietraferrazzana',
		province: 'CH',
		altitude: 357
	},
	{
		zip: '87050',
		name: 'Pietrafitta',
		province: 'CS',
		altitude: 700
	},
	{
		zip: '85016',
		name: 'Pietragalla',
		province: 'PZ',
		altitude: 839
	},
	{
		zip: '06026',
		name: 'Pietralunga',
		province: 'PG',
		altitude: 566
	},
	{
		zip: '81051',
		name: 'Pietramelara',
		province: 'CE',
		altitude: 132
	},
	{
		zip: '71038',
		name: 'Pietramontecorvino',
		province: 'FG',
		altitude: 456
	},
	{
		zip: '65020',
		name: 'Pietranico',
		province: 'PE',
		altitude: 590
	},
	{
		zip: '87060',
		name: 'Pietrapaola',
		province: 'CS',
		altitude: 375
	},
	{
		zip: '85010',
		name: 'Pietrapertosa',
		province: 'PZ',
		altitude: 1088
	},
	{
		zip: '94016',
		name: 'Pietraperzia',
		province: 'EN',
		altitude: 476
	},
	{
		zip: '12010',
		name: 'Pietraporzio',
		province: 'CN',
		altitude: 1246
	},
	{
		zip: '82030',
		name: 'Pietraroja',
		province: 'BN',
		altitude: 818
	},
	{
		zip: '61023',
		name: 'Pietrarubbia',
		province: 'PU',
		altitude: 572
	},
	{
		zip: '55045',
		name: 'Pietrasanta',
		province: 'LU',
		altitude: 14
	},
	{
		zip: '83015',
		name: 'Pietrastornina',
		province: 'AV',
		altitude: 513
	},
	{
		zip: '81040',
		name: 'Pietravairano',
		province: 'CE',
		altitude: 250
	},
	{
		zip: '82020',
		name: 'Pietrelcina',
		province: 'BN',
		altitude: 345
	},
	{
		zip: '27030',
		name: 'Pieve Albignola',
		province: 'PV',
		altitude: 85
	},
	{
		zip: '20072',
		name: 'Pieve Emanuele',
		province: 'MI',
		altitude: 97
	},
	{
		zip: '26854',
		name: 'Pieve Fissiraga',
		province: 'LO',
		altitude: 76
	},
	{
		zip: '55036',
		name: 'Pieve Fosciana',
		province: 'LU',
		altitude: 369
	},
	{
		zip: '16031',
		name: 'Pieve Ligure',
		province: 'GE',
		altitude: 70
	},
	{
		zip: '27017',
		name: 'Pieve Porto Morone',
		province: 'PV',
		altitude: 58
	},
	{
		zip: '26035',
		name: 'Pieve San Giacomo',
		province: 'CR',
		altitude: 39
	},
	{
		zip: '52036',
		name: 'Pieve Santo Stefano',
		province: 'AR',
		altitude: 431
	},
	{
		zip: '38050',
		name: 'Pieve Tesino',
		province: 'TN',
		altitude: 843
	},
	{
		zip: '62036',
		name: 'Pieve Torina',
		province: 'MC',
		altitude: 470
	},
	{
		zip: '28886',
		name: 'Pieve Vergonte',
		province: 'VB',
		altitude: 232
	},
	{
		zip: '51018',
		name: 'Pieve a Nievole',
		province: 'PT',
		altitude: 28
	},
	{
		zip: '26040',
		name: 'Pieve d\'\'Olmi',
		province: 'CR',
		altitude: 36
	},
	{
		zip: '27037',
		name: 'Pieve del Cairo',
		province: 'PV',
		altitude: 80
	},
	{
		zip: '31017',
		name: 'Pieve del Grappa',
		province: 'TV',
		altitude: 300
	},
	{
		zip: '38085',
		name: 'Pieve di Bono-Prezzo',
		province: 'TN',
		altitude: 514
	},
	{
		zip: '32044',
		name: 'Pieve di Cadore',
		province: 'BL',
		altitude: 878
	},
	{
		zip: '40066',
		name: 'Pieve di Cento',
		province: 'BO',
		altitude: 18
	},
	{
		zip: '31053',
		name: 'Pieve di Soligo',
		province: 'TV',
		altitude: 132
	},
	{
		zip: '18026',
		name: 'Pieve di Teco',
		province: 'IM',
		altitude: 240
	},
	{
		zip: '41027',
		name: 'Pievepelago',
		province: 'MO',
		altitude: 781
	},
	{
		zip: '03010',
		name: 'Piglio',
		province: 'FR',
		altitude: 620
	},
	{
		zip: '18037',
		name: 'Pigna',
		province: 'IM',
		altitude: 280
	},
	{
		zip: '03040',
		name: 'Pignataro Interamna',
		province: 'FR',
		altitude: 69
	},
	{
		zip: '81052',
		name: 'Pignataro Maggiore',
		province: 'CE',
		altitude: 93
	},
	{
		zip: '85010',
		name: 'Pignola',
		province: 'PZ',
		altitude: 927
	},
	{
		zip: '19020',
		name: 'Pignone',
		province: 'SP',
		altitude: 189
	},
	{
		zip: '22020',
		name: 'Pigra',
		province: 'CO',
		altitude: 881
	},
	{
		zip: '13020',
		name: 'Pila',
		province: 'VC',
		altitude: 686
	},
	{
		zip: '09020',
		name: 'Pimentel',
		province: 'SU',
		altitude: 154
	},
	{
		zip: '80050',
		name: 'Pimonte',
		province: 'NA',
		altitude: 406
	},
	{
		zip: '27040',
		name: 'Pinarolo Po',
		province: 'PV',
		altitude: 67
	},
	{
		zip: '10060',
		name: 'Pinasca',
		province: 'TO',
		altitude: 560
	},
	{
		zip: '45020',
		name: 'Pincara',
		province: 'RO',
		altitude: 5
	},
	{
		zip: '10064',
		name: 'Pinerolo',
		province: 'TO',
		altitude: 376
	},
	{
		zip: '64025',
		name: 'Pineto',
		province: 'TE',
		altitude: 4
	},
	{
		zip: '10025',
		name: 'Pino Torinese',
		province: 'TO',
		altitude: 495
	},
	{
		zip: '14020',
		name: 'Pino d\'\'Asti',
		province: 'AT',
		altitude: 412
	},
	{
		zip: '33094',
		name: 'Pinzano al Tagliamento',
		province: 'PN',
		altitude: 206
	},
	{
		zip: '38086',
		name: 'Pinzolo',
		province: 'TN',
		altitude: 774
	},
	{
		zip: '61046',
		name: 'Piobbico',
		province: 'PU',
		altitude: 339
	},
	{
		zip: '10040',
		name: 'Piobesi Torinese',
		province: 'TO',
		altitude: 233
	},
	{
		zip: '12040',
		name: 'Piobesi d\'\'Alba',
		province: 'CN',
		altitude: 194
	},
	{
		zip: '13020',
		name: 'Piode',
		province: 'VC',
		altitude: 752
	},
	{
		zip: '20096',
		name: 'Pioltello',
		province: 'MI',
		altitude: 122
	},
	{
		zip: '57025',
		name: 'Piombino',
		province: 'LI',
		altitude: 21
	},
	{
		zip: '35017',
		name: 'Piombino Dese',
		province: 'PD',
		altitude: 24
	},
	{
		zip: '62025',
		name: 'Pioraco',
		province: 'MC',
		altitude: 443
	},
	{
		zip: '10045',
		name: 'Piossasco',
		province: 'TO',
		altitude: 304
	},
	{
		zip: '35028',
		name: 'Piove di Sacco',
		province: 'PD',
		altitude: 5
	},
	{
		zip: '36013',
		name: 'Piovene Rocchette',
		province: 'VI',
		altitude: 277
	},
	{
		zip: '14026',
		name: 'Piova Massaia',
		province: 'AT',
		altitude: 300
	},
	{
		zip: '29010',
		name: 'Piozzano',
		province: 'PC',
		altitude: 222
	},
	{
		zip: '12060',
		name: 'Piozzo',
		province: 'CN',
		altitude: 327
	},
	{
		zip: '98060',
		name: 'Piraino',
		province: 'ME',
		altitude: 416
	},
	{
		zip: '56100',
		name: 'Pisa',
		province: 'PI',
		altitude: 4
	},
	{
		zip: '28010',
		name: 'Pisano',
		province: 'NO',
		altitude: 390
	},
	{
		zip: '10060',
		name: 'Piscina',
		province: 'TO',
		altitude: 288
	},
	{
		zip: '09010',
		name: 'Piscinas',
		province: 'SU',
		altitude: 66
	},
	{
		zip: '84066',
		name: 'Pisciotta',
		province: 'SA',
		altitude: 171
	},
	{
		zip: '25055',
		name: 'Pisogne',
		province: 'BS',
		altitude: 187
	},
	{
		zip: '00020',
		name: 'Pisoniano',
		province: 'RM',
		altitude: 532
	},
	{
		zip: '75010',
		name: 'Pisticci',
		province: 'MT',
		altitude: 364
	},
	{
		zip: '51100',
		name: 'Pistoia',
		province: 'PT',
		altitude: 67
	},
	{
		zip: '58017',
		name: 'Pitigliano',
		province: 'GR',
		altitude: 313
	},
	{
		zip: '46040',
		name: 'Piubega',
		province: 'MN',
		altitude: 40
	},
	{
		zip: '23020',
		name: 'Piuro',
		province: 'SO',
		altitude: 390
	},
	{
		zip: '10010',
		name: 'Piverone',
		province: 'TO',
		altitude: 295
	},
	{
		zip: '27050',
		name: 'Pizzale',
		province: 'PV',
		altitude: 78
	},
	{
		zip: '26026',
		name: 'Pizzighettone',
		province: 'CR',
		altitude: 46
	},
	{
		zip: '89812',
		name: 'Pizzo',
		province: 'VV',
		altitude: 44
	},
	{
		zip: '66040',
		name: 'Pizzoferrato',
		province: 'CH',
		altitude: 1251
	},
	{
		zip: '67017',
		name: 'Pizzoli',
		province: 'AQ',
		altitude: 740
	},
	{
		zip: '86071',
		name: 'Pizzone',
		province: 'IS',
		altitude: 730
	},
	{
		zip: '89834',
		name: 'Pizzoni',
		province: 'VV',
		altitude: 290
	},
	{
		zip: '89040',
		name: 'Placanica',
		province: 'RC',
		altitude: 240
	},
	{
		zip: '87070',
		name: 'Plataci',
		province: 'CS',
		altitude: 930
	},
	{
		zip: '88040',
		name: 'Platania',
		province: 'CZ',
		altitude: 750
	},
	{
		zip: '89039',
		name: 'Plati',
		province: 'RC',
		altitude: 300
	},
	{
		zip: '39025',
		name: 'Plaus',
		province: 'BZ',
		altitude: 519
	},
	{
		zip: '22010',
		name: 'Plesio',
		province: 'CO',
		altitude: 595
	},
	{
		zip: '07017',
		name: 'Ploaghe',
		province: 'SS',
		altitude: 427
	},
	{
		zip: '17043',
		name: 'Plodio',
		province: 'SV',
		altitude: 498
	},
	{
		zip: '12060',
		name: 'Pocapaglia',
		province: 'CN',
		altitude: 381
	},
	{
		zip: '33050',
		name: 'Pocenia',
		province: 'UD',
		altitude: 9
	},
	{
		zip: '54010',
		name: 'Podenzana',
		province: 'MS',
		altitude: 312
	},
	{
		zip: '29027',
		name: 'Podenzano',
		province: 'PC',
		altitude: 118
	},
	{
		zip: '03026',
		name: 'Pofi',
		province: 'FR',
		altitude: 283
	},
	{
		zip: '73037',
		name: 'Poggiardo',
		province: 'LE',
		altitude: 87
	},
	{
		zip: '53036',
		name: 'Poggibonsi',
		province: 'SI',
		altitude: 116
	},
	{
		zip: '02018',
		name: 'Poggio Bustone',
		province: 'RI',
		altitude: 756
	},
	{
		zip: '02040',
		name: 'Poggio Catino',
		province: 'RI',
		altitude: 387
	},
	{
		zip: '71010',
		name: 'Poggio Imperiale',
		province: 'FG',
		altitude: 73
	},
	{
		zip: '02047',
		name: 'Poggio Mirteto',
		province: 'RI',
		altitude: 246
	},
	{
		zip: '02037',
		name: 'Poggio Moiano',
		province: 'RI',
		altitude: 520
	},
	{
		zip: '02030',
		name: 'Poggio Nativo',
		province: 'RI',
		altitude: 455
	},
	{
		zip: '67026',
		name: 'Poggio Picenze',
		province: 'AQ',
		altitude: 756
	},
	{
		zip: '44028',
		name: 'Poggio Renatico',
		province: 'FE',
		altitude: 10
	},
	{
		zip: '46025',
		name: 'Poggio Rusco',
		province: 'MN',
		altitude: 16
	},
	{
		zip: '02030',
		name: 'Poggio San Lorenzo',
		province: 'RI',
		altitude: 494
	},
	{
		zip: '60030',
		name: 'Poggio San Marcello',
		province: 'AN',
		altitude: 385
	},
	{
		zip: '62020',
		name: 'Poggio San Vicino',
		province: 'MC',
		altitude: 509
	},
	{
		zip: '86086',
		name: 'Poggio Sannita',
		province: 'IS',
		altitude: 705
	},
	{
		zip: '47824',
		name: 'Poggio Torriana',
		province: 'RN',
		altitude: 155
	},
	{
		zip: '59016',
		name: 'Poggio a Caiano',
		province: 'PO',
		altitude: 45
	},
	{
		zip: '06040',
		name: 'Poggiodomo',
		province: 'PG',
		altitude: 974
	},
	{
		zip: '66030',
		name: 'Poggiofiorito',
		province: 'CH',
		altitude: 299
	},
	{
		zip: '80040',
		name: 'Poggiomarino',
		province: 'NA',
		altitude: 26
	},
	{
		zip: '91020',
		name: 'Poggioreale',
		province: 'TP',
		altitude: 189
	},
	{
		zip: '70020',
		name: 'Poggiorsini',
		province: 'BA',
		altitude: 460
	},
	{
		zip: '23020',
		name: 'Poggiridenti',
		province: 'SO',
		altitude: 564
	},
	{
		zip: '20005',
		name: 'Pogliano Milanese',
		province: 'MI',
		altitude: 164
	},
	{
		zip: '22020',
		name: 'Pognana Lario',
		province: 'CO',
		altitude: 307
	},
	{
		zip: '24040',
		name: 'Pognano',
		province: 'BG',
		altitude: 157
	},
	{
		zip: '28076',
		name: 'Pogno',
		province: 'NO',
		altitude: 420
	},
	{
		zip: '10046',
		name: 'Poirino',
		province: 'TO',
		altitude: 249
	},
	{
		zip: '36026',
		name: 'Pojana Maggiore',
		province: 'VI',
		altitude: 14
	},
	{
		zip: '25060',
		name: 'Polaveno',
		province: 'BS',
		altitude: 568
	},
	{
		zip: '33070',
		name: 'Polcenigo',
		province: 'PN',
		altitude: 42
	},
	{
		zip: '45038',
		name: 'Polesella',
		province: 'RO',
		altitude: 6
	},
	{
		zip: '43016',
		name: 'Polesine Zibello',
		province: 'PR',
		altitude: 35
	},
	{
		zip: '00010',
		name: 'Poli',
		province: 'RM',
		altitude: 435
	},
	{
		zip: '89813',
		name: 'Polia',
		province: 'VV',
		altitude: 400
	},
	{
		zip: '75025',
		name: 'Policoro',
		province: 'MT',
		altitude: 25
	},
	{
		zip: '70044',
		name: 'Polignano a Mare',
		province: 'BA',
		altitude: 24
	},
	{
		zip: '41040',
		name: 'Polinago',
		province: 'MO',
		altitude: 810
	},
	{
		zip: '05030',
		name: 'Polino',
		province: 'TR',
		altitude: 836
	},
	{
		zip: '89024',
		name: 'Polistena',
		province: 'RC',
		altitude: 254
	},
	{
		zip: '90028',
		name: 'Polizzi Generosa',
		province: 'PA',
		altitude: 920
	},
	{
		zip: '84035',
		name: 'Polla',
		province: 'SA',
		altitude: 468
	},
	{
		zip: '11020',
		name: 'Pollein',
		province: 'AO',
		altitude: 551
	},
	{
		zip: '80040',
		name: 'Pollena Trocchia',
		province: 'NA',
		altitude: 149
	},
	{
		zip: '62010',
		name: 'Pollenza',
		province: 'MC',
		altitude: 341
	},
	{
		zip: '84068',
		name: 'Pollica',
		province: 'SA',
		altitude: 370
	},
	{
		zip: '90010',
		name: 'Pollina',
		province: 'PA',
		altitude: 730
	},
	{
		zip: '13814',
		name: 'Pollone',
		province: 'BI',
		altitude: 630
	},
	{
		zip: '66020',
		name: 'Pollutri',
		province: 'CH',
		altitude: 180
	},
	{
		zip: '12030',
		name: 'Polonghera',
		province: 'CN',
		altitude: 245
	},
	{
		zip: '25080',
		name: 'Polpenazze del Garda',
		province: 'BS',
		altitude: 204
	},
	{
		zip: '35020',
		name: 'Polverara',
		province: 'PD',
		altitude: 6
	},
	{
		zip: '60020',
		name: 'Polverigi',
		province: 'AN',
		altitude: 140
	},
	{
		zip: '56045',
		name: 'Pomarance',
		province: 'PI',
		altitude: 370
	},
	{
		zip: '10063',
		name: 'Pomaretto',
		province: 'TO',
		altitude: 630
	},
	{
		zip: '75016',
		name: 'Pomarico',
		province: 'MT',
		altitude: 458
	},
	{
		zip: '15040',
		name: 'Pomaro Monferrato',
		province: 'AL',
		altitude: 142
	},
	{
		zip: '38060',
		name: 'Pomarolo',
		province: 'TN',
		altitude: 206
	},
	{
		zip: '28050',
		name: 'Pombia',
		province: 'NO',
		altitude: 286
	},
	{
		zip: '00071',
		name: 'Pomezia',
		province: 'RM',
		altitude: 108
	},
	{
		zip: '80038',
		name: 'Pomigliano d\'\'Arco',
		province: 'NA',
		altitude: 33
	},
	{
		zip: '80045',
		name: 'Pompei',
		province: 'NA',
		altitude: 14
	},
	{
		zip: '18015',
		name: 'Pompeiana',
		province: 'IM',
		altitude: 200
	},
	{
		zip: '25030',
		name: 'Pompiano',
		province: 'BS',
		altitude: 93
	},
	{
		zip: '46030',
		name: 'Pomponesco',
		province: 'MN',
		altitude: 23
	},
	{
		zip: '09093',
		name: 'Pompu',
		province: 'OR',
		altitude: 147
	},
	{
		zip: '25020',
		name: 'Poncarale',
		province: 'BS',
		altitude: 100
	},
	{
		zip: '13875',
		name: 'Ponderano',
		province: 'BI',
		altitude: 357
	},
	{
		zip: '22020',
		name: 'Ponna',
		province: 'CO',
		altitude: 870
	},
	{
		zip: '56038',
		name: 'Ponsacco',
		province: 'PI',
		altitude: 24
	},
	{
		zip: '35040',
		name: 'Ponso',
		province: 'PD',
		altitude: 11
	},
	{
		zip: '10085',
		name: 'Pont Canavese',
		province: 'TO',
		altitude: 451
	},
	{
		zip: '11026',
		name: 'Pont-Saint-Martin',
		province: 'AO',
		altitude: 350
	},
	{
		zip: '50065',
		name: 'Pontassieve',
		province: 'FI',
		altitude: 108
	},
	{
		zip: '11020',
		name: 'Pontboset',
		province: 'AO',
		altitude: 780
	},
	{
		zip: '82030',
		name: 'Ponte',
		province: 'BN',
		altitude: 147
	},
	{
		zip: '51019',
		name: 'Ponte Buggianese',
		province: 'PT',
		altitude: 18
	},
	{
		zip: '39040',
		name: 'Ponte Gardena',
		province: 'BZ',
		altitude: 471
	},
	{
		zip: '22037',
		name: 'Ponte Lambro',
		province: 'CO',
		altitude: 365
	},
	{
		zip: '27050',
		name: 'Ponte Nizza',
		province: 'PV',
		altitude: 267
	},
	{
		zip: '24028',
		name: 'Ponte Nossa',
		province: 'BG',
		altitude: 465
	},
	{
		zip: '35020',
		name: 'Ponte San Nicolo',
		province: 'PD',
		altitude: 12
	},
	{
		zip: '24036',
		name: 'Ponte San Pietro',
		province: 'BG',
		altitude: 224
	},
	{
		zip: '29028',
		name: 'Ponte dell\'\'Olio',
		province: 'PC',
		altitude: 217
	},
	{
		zip: '25056',
		name: 'Ponte di Legno',
		province: 'BS',
		altitude: 1258
	},
	{
		zip: '31047',
		name: 'Ponte di Piave',
		province: 'TV',
		altitude: 11
	},
	{
		zip: '23026',
		name: 'Ponte in Valtellina',
		province: 'SO',
		altitude: 486
	},
	{
		zip: '32014',
		name: 'Ponte nelle Alpi',
		province: 'BL',
		altitude: 397
	},
	{
		zip: '33016',
		name: 'Pontebba',
		province: 'UD',
		altitude: 568
	},
	{
		zip: '84098',
		name: 'Pontecagnano Faiano',
		province: 'SA',
		altitude: 28
	},
	{
		zip: '45030',
		name: 'Pontecchio Polesine',
		province: 'RO',
		altitude: 5
	},
	{
		zip: '12020',
		name: 'Pontechianale',
		province: 'CN',
		altitude: 1614
	},
	{
		zip: '03037',
		name: 'Pontecorvo',
		province: 'FR',
		altitude: 97
	},
	{
		zip: '15055',
		name: 'Pontecurone',
		province: 'AL',
		altitude: 104
	},
	{
		zip: '18027',
		name: 'Pontedassio',
		province: 'IM',
		altitude: 80
	},
	{
		zip: '56025',
		name: 'Pontedera',
		province: 'PI',
		altitude: 14
	},
	{
		zip: '82027',
		name: 'Pontelandolfo',
		province: 'BN',
		altitude: 510
	},
	{
		zip: '81040',
		name: 'Pontelatone',
		province: 'CE',
		altitude: 120
	},
	{
		zip: '35029',
		name: 'Pontelongo',
		province: 'PD',
		altitude: 5
	},
	{
		zip: '29010',
		name: 'Pontenure',
		province: 'PC',
		altitude: 65
	},
	{
		zip: '24010',
		name: 'Ponteranica',
		province: 'BG',
		altitude: 245
	},
	{
		zip: '15027',
		name: 'Pontestura',
		province: 'AL',
		altitude: 140
	},
	{
		zip: '25026',
		name: 'Pontevico',
		province: 'BS',
		altitude: 55
	},
	{
		zip: '11024',
		name: 'Pontey',
		province: 'AO',
		altitude: 525
	},
	{
		zip: '15010',
		name: 'Ponti',
		province: 'AL',
		altitude: 186
	},
	{
		zip: '46040',
		name: 'Ponti sul Mincio',
		province: 'MN',
		altitude: 113
	},
	{
		zip: '24030',
		name: 'Pontida',
		province: 'BG',
		altitude: 313
	},
	{
		zip: '04014',
		name: 'Pontinia',
		province: 'LT',
		altitude: 7
	},
	{
		zip: '17042',
		name: 'Pontinvrea',
		province: 'SV',
		altitude: 425
	},
	{
		zip: '24040',
		name: 'Pontirolo Nuovo',
		province: 'BG',
		altitude: 155
	},
	{
		zip: '25037',
		name: 'Pontoglio',
		province: 'BS',
		altitude: 155
	},
	{
		zip: '54027',
		name: 'Pontremoli',
		province: 'MS',
		altitude: 236
	},
	{
		zip: '04027',
		name: 'Ponza',
		province: 'LT',
		altitude: 10
	},
	{
		zip: '15020',
		name: 'Ponzano Monferrato',
		province: 'AL',
		altitude: 385
	},
	{
		zip: '00060',
		name: 'Ponzano Romano',
		province: 'RM',
		altitude: 205
	},
	{
		zip: '31050',
		name: 'Ponzano Veneto',
		province: 'TV',
		altitude: 27
	},
	{
		zip: '63845',
		name: 'Ponzano di Fermo',
		province: 'FM',
		altitude: 248
	},
	{
		zip: '15010',
		name: 'Ponzone',
		province: 'AL',
		altitude: 629
	},
	{
		zip: '65026',
		name: 'Popoli',
		province: 'PE',
		altitude: 254
	},
	{
		zip: '52014',
		name: 'Poppi',
		province: 'AR',
		altitude: 437
	},
	{
		zip: '05010',
		name: 'Porano',
		province: 'TR',
		altitude: 444
	},
	{
		zip: '55016',
		name: 'Porcari',
		province: 'LU',
		altitude: 32
	},
	{
		zip: '33080',
		name: 'Porcia',
		province: 'PN',
		altitude: 29
	},
	{
		zip: '33170',
		name: 'Pordenone',
		province: 'PN',
		altitude: 24
	},
	{
		zip: '22018',
		name: 'Porlezza',
		province: 'CO',
		altitude: 275
	},
	{
		zip: '18024',
		name: 'Pornassio',
		province: 'IM',
		altitude: 630
	},
	{
		zip: '33050',
		name: 'Porpetto',
		province: 'UD',
		altitude: 10
	},
	{
		zip: '14037',
		name: 'Portacomaro',
		province: 'AT',
		altitude: 232
	},
	{
		zip: '27040',
		name: 'Portalbera',
		province: 'PV',
		altitude: 64
	},
	{
		zip: '10060',
		name: 'Porte',
		province: 'TO',
		altitude: 436
	},
	{
		zip: '38094',
		name: 'Porte di Rendena',
		province: 'TN',
		altitude: 608
	},
	{
		zip: '80055',
		name: 'Portici',
		province: 'NA',
		altitude: 29
	},
	{
		zip: '81050',
		name: 'Portico di Caserta',
		province: 'CE',
		altitude: 31
	},
	{
		zip: '47010',
		name: 'Portico e San Benedetto',
		province: 'FC',
		altitude: 309
	},
	{
		zip: '89040',
		name: 'Portigliola',
		province: 'RC',
		altitude: 101
	},
	{
		zip: '57036',
		name: 'Porto Azzurro',
		province: 'LI',
		altitude: 3
	},
	{
		zip: '21050',
		name: 'Porto Ceresio',
		province: 'VA',
		altitude: 280
	},
	{
		zip: '73010',
		name: 'Porto Cesareo',
		province: 'LE',
		altitude: 3
	},
	{
		zip: '92014',
		name: 'Porto Empedocle',
		province: 'AG',
		altitude: 2
	},
	{
		zip: '46047',
		name: 'Porto Mantovano',
		province: 'MN',
		altitude: 29
	},
	{
		zip: '62017',
		name: 'Porto Recanati',
		province: 'MC',
		altitude: 6
	},
	{
		zip: '63822',
		name: 'Porto San Giorgio',
		province: 'FM',
		altitude: 4
	},
	{
		zip: '63821',
		name: 'Porto Sant\'\'Elpidio',
		province: 'FM',
		altitude: 4
	},
	{
		zip: '45018',
		name: 'Porto Tolle',
		province: 'RO',
		altitude: 1
	},
	{
		zip: '07046',
		name: 'Porto Torres',
		province: 'SS',
		altitude: 5
	},
	{
		zip: '21010',
		name: 'Porto Valtravaglia',
		province: 'VA',
		altitude: 199
	},
	{
		zip: '45014',
		name: 'Porto Viro',
		province: 'RO',
		altitude: 2
	},
	{
		zip: '31040',
		name: 'Portobuffole',
		province: 'TV',
		altitude: 10
	},
	{
		zip: '86045',
		name: 'Portocannone',
		province: 'CB',
		altitude: 148
	},
	{
		zip: '57037',
		name: 'Portoferraio',
		province: 'LI',
		altitude: 4
	},
	{
		zip: '16034',
		name: 'Portofino',
		province: 'GE',
		altitude: 5
	},
	{
		zip: '30026',
		name: 'Portogruaro',
		province: 'VE',
		altitude: 5
	},
	{
		zip: '44015',
		name: 'Portomaggiore',
		province: 'FE',
		altitude: 2
	},
	{
		zip: '96010',
		name: 'Portopalo di Capo Passero',
		province: 'SR',
		altitude: 20
	},
	{
		zip: '09010',
		name: 'Portoscuso',
		province: 'SU',
		altitude: 6
	},
	{
		zip: '19025',
		name: 'Portovenere',
		province: 'SP',
		altitude: 8
	},
	{
		zip: '13833',
		name: 'Portula',
		province: 'BI',
		altitude: 638
	},
	{
		zip: '08020',
		name: 'Posada',
		province: 'NU',
		altitude: 37
	},
	{
		zip: '36010',
		name: 'Posina',
		province: 'VI',
		altitude: 554
	},
	{
		zip: '84017',
		name: 'Positano',
		province: 'SA',
		altitude: 30
	},
	{
		zip: '31054',
		name: 'Possagno',
		province: 'TV',
		altitude: 276
	},
	{
		zip: '02019',
		name: 'Posta',
		province: 'RI',
		altitude: 721
	},
	{
		zip: '03030',
		name: 'Posta Fibreno',
		province: 'FR',
		altitude: 430
	},
	{
		zip: '39014',
		name: 'Postal',
		province: 'BZ',
		altitude: 270
	},
	{
		zip: '23010',
		name: 'Postalesio',
		province: 'SO',
		altitude: 516
	},
	{
		zip: '84026',
		name: 'Postiglione',
		province: 'SA',
		altitude: 605
	},
	{
		zip: '13010',
		name: 'Postua',
		province: 'VC',
		altitude: 459
	},
	{
		zip: '85100',
		name: 'Potenza',
		province: 'PZ',
		altitude: 819
	},
	{
		zip: '62018',
		name: 'Potenza Picena',
		province: 'MC',
		altitude: 237
	},
	{
		zip: '36020',
		name: 'Pove del Grappa',
		province: 'VI',
		altitude: 163
	},
	{
		zip: '31050',
		name: 'Povegliano',
		province: 'TV',
		altitude: 56
	},
	{
		zip: '37064',
		name: 'Povegliano Veronese',
		province: 'VR',
		altitude: 47
	},
	{
		zip: '42028',
		name: 'Poviglio',
		province: 'RE',
		altitude: 29
	},
	{
		zip: '33040',
		name: 'Povoletto',
		province: 'UD',
		altitude: 116
	},
	{
		zip: '02030',
		name: 'Pozzaglia Sabina',
		province: 'RI',
		altitude: 878
	},
	{
		zip: '26010',
		name: 'Pozzaglio ed Uniti',
		province: 'CR',
		altitude: 50
	},
	{
		zip: '97016',
		name: 'Pozzallo',
		province: 'RG',
		altitude: 20
	},
	{
		zip: '86077',
		name: 'Pozzilli',
		province: 'IS',
		altitude: 235
	},
	{
		zip: '20060',
		name: 'Pozzo d\'\'Adda',
		province: 'MI',
		altitude: 164
	},
	{
		zip: '15050',
		name: 'Pozzol Groppo',
		province: 'AL',
		altitude: 369
	},
	{
		zip: '25010',
		name: 'Pozzolengo',
		province: 'BS',
		altitude: 135
	},
	{
		zip: '36050',
		name: 'Pozzoleone',
		province: 'VI',
		altitude: 56
	},
	{
		zip: '15068',
		name: 'Pozzolo Formigaro',
		province: 'AL',
		altitude: 171
	},
	{
		zip: '07018',
		name: 'Pozzomaggiore',
		province: 'SS',
		altitude: 438
	},
	{
		zip: '35020',
		name: 'Pozzonovo',
		province: 'PD',
		altitude: 6
	},
	{
		zip: '80078',
		name: 'Pozzuoli',
		province: 'NA',
		altitude: 28
	},
	{
		zip: '20060',
		name: 'Pozzuolo Martesana',
		province: 'MI',
		altitude: 121
	},
	{
		zip: '33050',
		name: 'Pozzuolo del Friuli',
		province: 'UD',
		altitude: 67
	},
	{
		zip: '24020',
		name: 'Pradalunga',
		province: 'BG',
		altitude: 327
	},
	{
		zip: '33040',
		name: 'Pradamano',
		province: 'UD',
		altitude: 96
	},
	{
		zip: '12027',
		name: 'Pradleves',
		province: 'CN',
		altitude: 822
	},
	{
		zip: '10060',
		name: 'Pragelato',
		province: 'TO',
		altitude: 1580
	},
	{
		zip: '87028',
		name: 'Praia a Mare',
		province: 'CS',
		altitude: 5
	},
	{
		zip: '84010',
		name: 'Praiano',
		province: 'SA',
		altitude: 120
	},
	{
		zip: '25020',
		name: 'Pralboino',
		province: 'BS',
		altitude: 47
	},
	{
		zip: '10060',
		name: 'Prali',
		province: 'TO',
		altitude: 1455
	},
	{
		zip: '10040',
		name: 'Pralormo',
		province: 'TO',
		altitude: 303
	},
	{
		zip: '13899',
		name: 'Pralungo',
		province: 'BI',
		altitude: 554
	},
	{
		zip: '30020',
		name: 'Pramaggiore',
		province: 'VE',
		altitude: 11
	},
	{
		zip: '10065',
		name: 'Pramollo',
		province: 'TO',
		altitude: 1071
	},
	{
		zip: '13012',
		name: 'Prarolo',
		province: 'VC',
		altitude: 117
	},
	{
		zip: '10060',
		name: 'Prarostino',
		province: 'TO',
		altitude: 738
	},
	{
		zip: '15010',
		name: 'Prasco',
		province: 'AL',
		altitude: 245
	},
	{
		zip: '10080',
		name: 'Prascorsano',
		province: 'TO',
		altitude: 590
	},
	{
		zip: '23020',
		name: 'Prata Camportaccio',
		province: 'SO',
		altitude: 352
	},
	{
		zip: '81010',
		name: 'Prata Sannita',
		province: 'CE',
		altitude: 333
	},
	{
		zip: '67020',
		name: 'Prata d\'\'Ansidonia',
		province: 'AQ',
		altitude: 846
	},
	{
		zip: '33080',
		name: 'Prata di Pordenone',
		province: 'PN',
		altitude: 18
	},
	{
		zip: '83030',
		name: 'Prata di Principato Ultra',
		province: 'AV',
		altitude: 310
	},
	{
		zip: '81010',
		name: 'Pratella',
		province: 'CE',
		altitude: 152
	},
	{
		zip: '10080',
		name: 'Pratiglione',
		province: 'TO',
		altitude: 611
	},
	{
		zip: '59100',
		name: 'Prato',
		province: 'PO',
		altitude: 61
	},
	{
		zip: '33020',
		name: 'Prato Carnico',
		province: 'UD',
		altitude: 686
	},
	{
		zip: '28077',
		name: 'Prato Sesia',
		province: 'NO',
		altitude: 275
	},
	{
		zip: '39026',
		name: 'Prato allo Stelvio',
		province: 'BZ',
		altitude: 915
	},
	{
		zip: '67035',
		name: 'Pratola Peligna',
		province: 'AQ',
		altitude: 342
	},
	{
		zip: '83039',
		name: 'Pratola Serra',
		province: 'AV',
		altitude: 280
	},
	{
		zip: '52015',
		name: 'Pratovecchio Stia',
		province: 'AR',
		altitude: 441
	},
	{
		zip: '33076',
		name: 'Pravisdomini',
		province: 'PN',
		altitude: 10
	},
	{
		zip: '13867',
		name: 'Pray',
		province: 'BI',
		altitude: 496
	},
	{
		zip: '12028',
		name: 'Prazzo',
		province: 'CN',
		altitude: 1030
	},
	{
		zip: '33050',
		name: 'Precenicco',
		province: 'UD',
		altitude: 5
	},
	{
		zip: '06047',
		name: 'Preci',
		province: 'PG',
		altitude: 596
	},
	{
		zip: '38012',
		name: 'Predaia',
		province: 'TN',
		altitude: 515
	},
	{
		zip: '47016',
		name: 'Predappio',
		province: 'FC',
		altitude: 133
	},
	{
		zip: '38037',
		name: 'Predazzo',
		province: 'TN',
		altitude: 1018
	},
	{
		zip: '39030',
		name: 'Predoi',
		province: 'BZ',
		altitude: 1475
	},
	{
		zip: '24060',
		name: 'Predore',
		province: 'BG',
		altitude: 189
	},
	{
		zip: '15077',
		name: 'Predosa',
		province: 'AL',
		altitude: 136
	},
	{
		zip: '31022',
		name: 'Preganziol',
		province: 'TV',
		altitude: 12
	},
	{
		zip: '20006',
		name: 'Pregnana Milanese',
		province: 'MI',
		altitude: 154
	},
	{
		zip: '18020',
		name: 'Prela',
		province: 'IM',
		altitude: 151
	},
	{
		zip: '23834',
		name: 'Premana',
		province: 'LC',
		altitude: 1000
	},
	{
		zip: '33040',
		name: 'Premariacco',
		province: 'UD',
		altitude: 110
	},
	{
		zip: '28818',
		name: 'Premeno',
		province: 'VB',
		altitude: 855
	},
	{
		zip: '28866',
		name: 'Premia',
		province: 'VB',
		altitude: 800
	},
	{
		zip: '47010',
		name: 'Premilcuore',
		province: 'FC',
		altitude: 459
	},
	{
		zip: '24020',
		name: 'Premolo',
		province: 'BG',
		altitude: 625
	},
	{
		zip: '28803',
		name: 'Premosello-Chiovenda',
		province: 'VB',
		altitude: 222
	},
	{
		zip: '33020',
		name: 'Preone',
		province: 'UD',
		altitude: 461
	},
	{
		zip: '33040',
		name: 'Prepotto',
		province: 'UD',
		altitude: 105
	},
	{
		zip: '25070',
		name: 'Preseglie',
		province: 'BS',
		altitude: 391
	},
	{
		zip: '81050',
		name: 'Presenzano',
		province: 'CE',
		altitude: 272
	},
	{
		zip: '24030',
		name: 'Presezzo',
		province: 'BG',
		altitude: 236
	},
	{
		zip: '37040',
		name: 'Pressana',
		province: 'VR',
		altitude: 19
	},
	{
		zip: '66010',
		name: 'Pretoro',
		province: 'CH',
		altitude: 602
	},
	{
		zip: '25080',
		name: 'Prevalle',
		province: 'BS',
		altitude: 180
	},
	{
		zip: '67030',
		name: 'Prezza',
		province: 'AQ',
		altitude: 480
	},
	{
		zip: '12070',
		name: 'Priero',
		province: 'CN',
		altitude: 475
	},
	{
		zip: '84060',
		name: 'Prignano Cilento',
		province: 'SA',
		altitude: 415
	},
	{
		zip: '41048',
		name: 'Prignano sulla Secchia',
		province: 'MO',
		altitude: 557
	},
	{
		zip: '23819',
		name: 'Primaluna',
		province: 'LC',
		altitude: 558
	},
	{
		zip: '38054',
		name: 'Primiero San Martino di Castrozza',
		province: 'TN',
		altitude: 710
	},
	{
		zip: '12040',
		name: 'Priocca',
		province: 'CN',
		altitude: 253
	},
	{
		zip: '12070',
		name: 'Priola',
		province: 'CN',
		altitude: 537
	},
	{
		zip: '96010',
		name: 'Priolo Gargallo',
		province: 'SR',
		altitude: 30
	},
	{
		zip: '04015',
		name: 'Priverno',
		province: 'LT',
		altitude: 151
	},
	{
		zip: '90038',
		name: 'Prizzi',
		province: 'PA',
		altitude: 966
	},
	{
		zip: '01020',
		name: 'Proceno',
		province: 'VT',
		altitude: 418
	},
	{
		zip: '80079',
		name: 'Procida',
		province: 'NA',
		altitude: 27
	},
	{
		zip: '16027',
		name: 'Propata',
		province: 'GE',
		altitude: 990
	},
	{
		zip: '22030',
		name: 'Proserpio',
		province: 'CO',
		altitude: 450
	},
	{
		zip: '04010',
		name: 'Prossedi',
		province: 'LT',
		altitude: 206
	},
	{
		zip: '25070',
		name: 'Provaglio Val Sabbia',
		province: 'BS',
		altitude: 678
	},
	{
		zip: '25050',
		name: 'Provaglio d\'\'Iseo',
		province: 'BS',
		altitude: 220
	},
	{
		zip: '39040',
		name: 'Proves',
		province: 'BZ',
		altitude: 1420
	},
	{
		zip: '86040',
		name: 'Provvidenti',
		province: 'CB',
		altitude: 570
	},
	{
		zip: '12070',
		name: 'Prunetto',
		province: 'CN',
		altitude: 750
	},
	{
		zip: '11010',
		name: 'Pré-Saint-Didier',
		province: 'AO',
		altitude: 1004
	},
	{
		zip: '25080',
		name: 'Puegnago del Garda',
		province: 'BS',
		altitude: 224
	},
	{
		zip: '82030',
		name: 'Puglianello',
		province: 'BN',
		altitude: 61
	},
	{
		zip: '09050',
		name: 'Pula',
		province: 'CA',
		altitude: 10
	},
	{
		zip: '33046',
		name: 'Pulfero',
		province: 'UD',
		altitude: 184
	},
	{
		zip: '74026',
		name: 'Pulsano',
		province: 'TA',
		altitude: 37
	},
	{
		zip: '24050',
		name: 'Pumenengo',
		province: 'BG',
		altitude: 106
	},
	{
		zip: '22030',
		name: 'Pusiano',
		province: 'CO',
		altitude: 264
	},
	{
		zip: '07040',
		name: 'Putifigari',
		province: 'SS',
		altitude: 267
	},
	{
		zip: '70017',
		name: 'Putignano',
		province: 'BA',
		altitude: 372
	},
	{
		zip: '83020',
		name: 'Quadrelle',
		province: 'AV',
		altitude: 300
	},
	{
		zip: '66040',
		name: 'Quadri',
		province: 'CH',
		altitude: 600
	},
	{
		zip: '10010',
		name: 'Quagliuzzo',
		province: 'TO',
		altitude: 334
	},
	{
		zip: '80019',
		name: 'Qualiano',
		province: 'NA',
		altitude: 101
	},
	{
		zip: '14040',
		name: 'Quaranti',
		province: 'AT',
		altitude: 273
	},
	{
		zip: '13854',
		name: 'Quaregna Cerreto',
		province: 'BI',
		altitude: 280
	},
	{
		zip: '15044',
		name: 'Quargnento',
		province: 'AL',
		altitude: 121
	},
	{
		zip: '28898',
		name: 'Quarna Sopra',
		province: 'VB',
		altitude: 860
	},
	{
		zip: '28896',
		name: 'Quarna Sotto',
		province: 'VB',
		altitude: 802
	},
	{
		zip: '13017',
		name: 'Quarona',
		province: 'VC',
		altitude: 401
	},
	{
		zip: '51039',
		name: 'Quarrata',
		province: 'PT',
		altitude: 48
	},
	{
		zip: '11020',
		name: 'Quart',
		province: 'AO',
		altitude: 535
	},
	{
		zip: '80010',
		name: 'Quarto',
		province: 'NA',
		altitude: 55
	},
	{
		zip: '30020',
		name: 'Quarto d\'\'Altino',
		province: 'VE',
		altitude: 4
	},
	{
		zip: '09045',
		name: 'Quartu Sant\'\'Elena',
		province: 'CA',
		altitude: 6
	},
	{
		zip: '09044',
		name: 'Quartucciu',
		province: 'CA',
		altitude: 14
	},
	{
		zip: '10010',
		name: 'Quassolo',
		province: 'TO',
		altitude: 275
	},
	{
		zip: '15028',
		name: 'Quattordio',
		province: 'AL',
		altitude: 135
	},
	{
		zip: '42020',
		name: 'Quattro Castella',
		province: 'RE',
		altitude: 165
	},
	{
		zip: '17047',
		name: 'Quiliano',
		province: 'SV',
		altitude: 32
	},
	{
		zip: '10010',
		name: 'Quincinetto',
		province: 'TO',
		altitude: 338
	},
	{
		zip: '83020',
		name: 'Quindici',
		province: 'AV',
		altitude: 247
	},
	{
		zip: '46020',
		name: 'Quingentole',
		province: 'MN',
		altitude: 16
	},
	{
		zip: '26017',
		name: 'Quintano',
		province: 'CR',
		altitude: 91
	},
	{
		zip: '13030',
		name: 'Quinto Vercellese',
		province: 'VC',
		altitude: 140
	},
	{
		zip: '36050',
		name: 'Quinto Vicentino',
		province: 'VI',
		altitude: 37
	},
	{
		zip: '31055',
		name: 'Quinto di Treviso',
		province: 'TV',
		altitude: 17
	},
	{
		zip: '25027',
		name: 'Quinzano d\'\'Oglio',
		province: 'BS',
		altitude: 65
	},
	{
		zip: '46026',
		name: 'Quistello',
		province: 'MN',
		altitude: 16
	},
	{
		zip: '38020',
		name: 'Rabbi',
		province: 'TN',
		altitude: 1095
	},
	{
		zip: '73055',
		name: 'Racale',
		province: 'LE',
		altitude: 55
	},
	{
		zip: '92020',
		name: 'Racalmuto',
		province: 'AG',
		altitude: 455
	},
	{
		zip: '12035',
		name: 'Racconigi',
		province: 'CN',
		altitude: 260
	},
	{
		zip: '98067',
		name: 'Raccuja',
		province: 'ME',
		altitude: 640
	},
	{
		zip: '39040',
		name: 'Racines',
		province: 'BZ',
		altitude: 976
	},
	{
		zip: '53017',
		name: 'Radda in Chianti',
		province: 'SI',
		altitude: 530
	},
	{
		zip: '95040',
		name: 'Raddusa',
		province: 'CT',
		altitude: 350
	},
	{
		zip: '53040',
		name: 'Radicofani',
		province: 'SI',
		altitude: 814
	},
	{
		zip: '53030',
		name: 'Radicondoli',
		province: 'SI',
		altitude: 509
	},
	{
		zip: '92015',
		name: 'Raffadali',
		province: 'AG',
		altitude: 420
	},
	{
		zip: '95030',
		name: 'Ragalna',
		province: 'CT',
		altitude: 830
	},
	{
		zip: '33030',
		name: 'Ragogna',
		province: 'UD',
		altitude: 235
	},
	{
		zip: '97100',
		name: 'Ragusa',
		province: 'RG',
		altitude: 520
	},
	{
		zip: '67027',
		name: 'Raiano',
		province: 'AQ',
		altitude: 390
	},
	{
		zip: '95040',
		name: 'Ramacca',
		province: 'CT',
		altitude: 275
	},
	{
		zip: '21030',
		name: 'Rancio Valcuvia',
		province: 'VA',
		altitude: 296
	},
	{
		zip: '21020',
		name: 'Ranco',
		province: 'VA',
		altitude: 214
	},
	{
		zip: '95036',
		name: 'Randazzo',
		province: 'CT',
		altitude: 765
	},
	{
		zip: '24020',
		name: 'Ranica',
		province: 'BG',
		altitude: 293
	},
	{
		zip: '24060',
		name: 'Ranzanico',
		province: 'BG',
		altitude: 519
	},
	{
		zip: '18020',
		name: 'Ranzo',
		province: 'IM',
		altitude: 124
	},
	{
		zip: '63831',
		name: 'Rapagnano',
		province: 'FM',
		altitude: 316
	},
	{
		zip: '16035',
		name: 'Rapallo',
		province: 'GE',
		altitude: 3
	},
	{
		zip: '66010',
		name: 'Rapino',
		province: 'CH',
		altitude: 420
	},
	{
		zip: '53040',
		name: 'Rapolano Terme',
		province: 'SI',
		altitude: 334
	},
	{
		zip: '85027',
		name: 'Rapolla',
		province: 'PZ',
		altitude: 450
	},
	{
		zip: '85020',
		name: 'Rapone',
		province: 'PZ',
		altitude: 838
	},
	{
		zip: '13020',
		name: 'Rassa',
		province: 'VC',
		altitude: 917
	},
	{
		zip: '39030',
		name: 'Rasun-Anterselva',
		province: 'BZ',
		altitude: 1030
	},
	{
		zip: '23010',
		name: 'Rasura',
		province: 'SO',
		altitude: 800
	},
	{
		zip: '92029',
		name: 'Ravanusa',
		province: 'AG',
		altitude: 320
	},
	{
		zip: '41017',
		name: 'Ravarino',
		province: 'MO',
		altitude: 23
	},
	{
		zip: '33020',
		name: 'Ravascletto',
		province: 'UD',
		altitude: 952
	},
	{
		zip: '84010',
		name: 'Ravello',
		province: 'SA',
		altitude: 350
	},
	{
		zip: '48121',
		name: 'Ravenna',
		province: 'RA',
		altitude: 4
	},
	{
		zip: '33029',
		name: 'Raveo',
		province: 'UD',
		altitude: 518
	},
	{
		zip: '81017',
		name: 'Raviscanina',
		province: 'CE',
		altitude: 358
	},
	{
		zip: '28856',
		name: 'Re',
		province: 'VB',
		altitude: 710
	},
	{
		zip: '27040',
		name: 'Rea',
		province: 'PV',
		altitude: 63
	},
	{
		zip: '92010',
		name: 'Realmonte',
		province: 'AG',
		altitude: 144
	},
	{
		zip: '33010',
		name: 'Reana del Rojale',
		province: 'UD',
		altitude: 166
	},
	{
		zip: '10090',
		name: 'Reano',
		province: 'TO',
		altitude: 470
	},
	{
		zip: '81020',
		name: 'Recale',
		province: 'CE',
		altitude: 43
	},
	{
		zip: '62019',
		name: 'Recanati',
		province: 'MC',
		altitude: 293
	},
	{
		zip: '16036',
		name: 'Recco',
		province: 'GE',
		altitude: 5
	},
	{
		zip: '28060',
		name: 'Recetto',
		province: 'NO',
		altitude: 162
	},
	{
		zip: '36076',
		name: 'Recoaro Terme',
		province: 'VI',
		altitude: 448
	},
	{
		zip: '27050',
		name: 'Redavalle',
		province: 'PV',
		altitude: 85
	},
	{
		zip: '46010',
		name: 'Redondesco',
		province: 'MN',
		altitude: 31
	},
	{
		zip: '14030',
		name: 'Refrancore',
		province: 'AT',
		altitude: 150
	},
	{
		zip: '31020',
		name: 'Refrontolo',
		province: 'TV',
		altitude: 216
	},
	{
		zip: '94017',
		name: 'Regalbuto',
		province: 'EN',
		altitude: 520
	},
	{
		zip: '50066',
		name: 'Reggello',
		province: 'FI',
		altitude: 390
	},
	{
		zip: '89121',
		name: 'Reggio di Calabria',
		province: 'RC',
		altitude: 31
	},
	{
		zip: '42121',
		name: 'Reggio nell\'\'Emilia',
		province: 'RE',
		altitude: 56
	},
	{
		zip: '42046',
		name: 'Reggiolo',
		province: 'RE',
		altitude: 20
	},
	{
		zip: '82020',
		name: 'Reino',
		province: 'BN',
		altitude: 450
	},
	{
		zip: '98070',
		name: 'Reitano',
		province: 'ME',
		altitude: 396
	},
	{
		zip: '33047',
		name: 'Remanzacco',
		province: 'UD',
		altitude: 110
	},
	{
		zip: '25010',
		name: 'Remedello',
		province: 'BS',
		altitude: 47
	},
	{
		zip: '20838',
		name: 'Renate',
		province: 'MB',
		altitude: 314
	},
	{
		zip: '39054',
		name: 'Renon',
		province: 'BZ',
		altitude: 1154
	},
	{
		zip: '31023',
		name: 'Resana',
		province: 'TV',
		altitude: 31
	},
	{
		zip: '20027',
		name: 'Rescaldina',
		province: 'MI',
		altitude: 225
	},
	{
		zip: '33010',
		name: 'Resia',
		province: 'UD',
		altitude: 492
	},
	{
		zip: '33010',
		name: 'Resiutta',
		province: 'UD',
		altitude: 316
	},
	{
		zip: '93010',
		name: 'Resuttano',
		province: 'CL',
		altitude: 600
	},
	{
		zip: '27050',
		name: 'Retorbido',
		province: 'PV',
		altitude: 169
	},
	{
		zip: '12036',
		name: 'Revello',
		province: 'CN',
		altitude: 351
	},
	{
		zip: '14010',
		name: 'Revigliasco d\'\'Asti',
		province: 'AT',
		altitude: 203
	},
	{
		zip: '31020',
		name: 'Revine Lago',
		province: 'TV',
		altitude: 246
	},
	{
		zip: '22030',
		name: 'Rezzago',
		province: 'CO',
		altitude: 674
	},
	{
		zip: '25086',
		name: 'Rezzato',
		province: 'BS',
		altitude: 147
	},
	{
		zip: '18026',
		name: 'Rezzo',
		province: 'IM',
		altitude: 563
	},
	{
		zip: '16048',
		name: 'Rezzoaglio',
		province: 'GE',
		altitude: 701
	},
	{
		zip: '20017',
		name: 'Rho',
		province: 'MI',
		altitude: 158
	},
	{
		zip: '11010',
		name: 'Rhêmes-Notre-Dame',
		province: 'AO',
		altitude: 1725
	},
	{
		zip: '11010',
		name: 'Rhêmes-Saint-Georges',
		province: 'AO',
		altitude: 1218
	},
	{
		zip: '89040',
		name: 'Riace',
		province: 'RC',
		altitude: 300
	},
	{
		zip: '17020',
		name: 'Rialto',
		province: 'SV',
		altitude: 376
	},
	{
		zip: '00060',
		name: 'Riano',
		province: 'RM',
		altitude: 125
	},
	{
		zip: '81053',
		name: 'Riardo',
		province: 'CE',
		altitude: 150
	},
	{
		zip: '92016',
		name: 'Ribera',
		province: 'AG',
		altitude: 223
	},
	{
		zip: '10080',
		name: 'Ribordone',
		province: 'TO',
		altitude: 1023
	},
	{
		zip: '89866',
		name: 'Ricadi',
		province: 'VV',
		altitude: 284
	},
	{
		zip: '15010',
		name: 'Ricaldone',
		province: 'AL',
		altitude: 285
	},
	{
		zip: '86016',
		name: 'Riccia',
		province: 'CB',
		altitude: 710
	},
	{
		zip: '47838',
		name: 'Riccione',
		province: 'RN',
		altitude: 12
	},
	{
		zip: '19020',
		name: 'Ricco del Golfo di Spezia',
		province: 'SP',
		altitude: 148
	},
	{
		zip: '26010',
		name: 'Ricengo',
		province: 'CR',
		altitude: 86
	},
	{
		zip: '84020',
		name: 'Ricigliano',
		province: 'SA',
		altitude: 560
	},
	{
		zip: '31039',
		name: 'Riese Pio X',
		province: 'TV',
		altitude: 65
	},
	{
		zip: '93016',
		name: 'Riesi',
		province: 'CL',
		altitude: 330
	},
	{
		zip: '02100',
		name: 'Rieti',
		province: 'RI',
		altitude: 405
	},
	{
		zip: '39010',
		name: 'Rifiano',
		province: 'BZ',
		altitude: 504
	},
	{
		zip: '12030',
		name: 'Rifreddo',
		province: 'CN',
		altitude: 455
	},
	{
		zip: '00068',
		name: 'Rignano Flaminio',
		province: 'RM',
		altitude: 250
	},
	{
		zip: '71010',
		name: 'Rignano Garganico',
		province: 'FG',
		altitude: 590
	},
	{
		zip: '50067',
		name: 'Rignano sull\'\'Arno',
		province: 'FI',
		altitude: 118
	},
	{
		zip: '33020',
		name: 'Rigolato',
		province: 'UD',
		altitude: 760
	},
	{
		zip: '13020',
		name: 'Rimella',
		province: 'VC',
		altitude: 1176
	},
	{
		zip: '47921',
		name: 'Rimini',
		province: 'RN',
		altitude: 5
	},
	{
		zip: '42010',
		name: 'Rio Saliceto',
		province: 'RE',
		altitude: 24
	},
	{
		zip: '39037',
		name: 'Rio di Pusteria',
		province: 'BZ',
		altitude: 777
	},
	{
		zip: '00020',
		name: 'Riofreddo',
		province: 'RM',
		altitude: 750
	},
	{
		zip: '09070',
		name: 'Riola Sardo',
		province: 'OR',
		altitude: 9
	},
	{
		zip: '48025',
		name: 'Riolo Terme',
		province: 'RA',
		altitude: 98
	},
	{
		zip: '41020',
		name: 'Riolunato',
		province: 'MO',
		altitude: 716
	},
	{
		zip: '19017',
		name: 'Riomaggiore',
		province: 'SP',
		altitude: 35
	},
	{
		zip: '86087',
		name: 'Rionero Sannitico',
		province: 'IS',
		altitude: 1051
	},
	{
		zip: '85028',
		name: 'Rionero in Vulture',
		province: 'PZ',
		altitude: 656
	},
	{
		zip: '66010',
		name: 'Ripa Teatina',
		province: 'CH',
		altitude: 199
	},
	{
		zip: '86040',
		name: 'Ripabottoni',
		province: 'CB',
		altitude: 695
	},
	{
		zip: '85020',
		name: 'Ripacandida',
		province: 'PZ',
		altitude: 620
	},
	{
		zip: '86025',
		name: 'Ripalimosani',
		province: 'CB',
		altitude: 640
	},
	{
		zip: '26010',
		name: 'Ripalta Arpina',
		province: 'CR',
		altitude: 72
	},
	{
		zip: '26010',
		name: 'Ripalta Cremasca',
		province: 'CR',
		altitude: 78
	},
	{
		zip: '26010',
		name: 'Ripalta Guerina',
		province: 'CR',
		altitude: 67
	},
	{
		zip: '56046',
		name: 'Riparbella',
		province: 'PI',
		altitude: 216
	},
	{
		zip: '63065',
		name: 'Ripatransone',
		province: 'AP',
		altitude: 494
	},
	{
		zip: '62020',
		name: 'Ripe San Ginesio',
		province: 'MC',
		altitude: 430
	},
	{
		zip: '03027',
		name: 'Ripi',
		province: 'FR',
		altitude: 325
	},
	{
		zip: '95018',
		name: 'Riposto',
		province: 'CT',
		altitude: 7
	},
	{
		zip: '12010',
		name: 'Rittana',
		province: 'CN',
		altitude: 750
	},
	{
		zip: '18015',
		name: 'Riva Ligure',
		province: 'IM',
		altitude: 2
	},
	{
		zip: '38066',
		name: 'Riva del Garda',
		province: 'TN',
		altitude: 65
	},
	{
		zip: '24060',
		name: 'Riva di Solto',
		province: 'BG',
		altitude: 186
	},
	{
		zip: '10020',
		name: 'Riva presso Chieri',
		province: 'TO',
		altitude: 262
	},
	{
		zip: '10090',
		name: 'Rivalba',
		province: 'TO',
		altitude: 328
	},
	{
		zip: '15010',
		name: 'Rivalta Bormida',
		province: 'AL',
		altitude: 140
	},
	{
		zip: '10040',
		name: 'Rivalta di Torino',
		province: 'TO',
		altitude: 294
	},
	{
		zip: '32020',
		name: 'Rivamonte Agordino',
		province: 'BL',
		altitude: 973
	},
	{
		zip: '27055',
		name: 'Rivanazzano Terme',
		province: 'PV',
		altitude: 153
	},
	{
		zip: '10080',
		name: 'Rivara',
		province: 'TO',
		altitude: 392
	},
	{
		zip: '10086',
		name: 'Rivarolo Canavese',
		province: 'TO',
		altitude: 318
	},
	{
		zip: '46017',
		name: 'Rivarolo Mantovano',
		province: 'MN',
		altitude: 26
	},
	{
		zip: '26036',
		name: 'Rivarolo del Re ed Uniti',
		province: 'CR',
		altitude: 22
	},
	{
		zip: '15040',
		name: 'Rivarone',
		province: 'AL',
		altitude: 103
	},
	{
		zip: '10040',
		name: 'Rivarossa',
		province: 'TO',
		altitude: 286
	},
	{
		zip: '13030',
		name: 'Rive',
		province: 'VC',
		altitude: 126
	},
	{
		zip: '33030',
		name: 'Rive d\'\'Arcano',
		province: 'UD',
		altitude: 175
	},
	{
		zip: '85040',
		name: 'Rivello',
		province: 'PZ',
		altitude: 479
	},
	{
		zip: '29029',
		name: 'Rivergaro',
		province: 'PC',
		altitude: 140
	},
	{
		zip: '33061',
		name: 'Rivignano Teor',
		province: 'UD',
		altitude: 13
	},
	{
		zip: '67036',
		name: 'Rivisondoli',
		province: 'AQ',
		altitude: 1320
	},
	{
		zip: '02010',
		name: 'Rivodutri',
		province: 'RI',
		altitude: 560
	},
	{
		zip: '10098',
		name: 'Rivoli',
		province: 'TO',
		altitude: 352
	},
	{
		zip: '37010',
		name: 'Rivoli Veronese',
		province: 'VR',
		altitude: 191
	},
	{
		zip: '26027',
		name: 'Rivolta d\'\'Adda',
		province: 'CR',
		altitude: 101
	},
	{
		zip: '89016',
		name: 'Rizziconi',
		province: 'RC',
		altitude: 87
	},
	{
		zip: '36010',
		name: 'Roana',
		province: 'VI',
		altitude: 1001
	},
	{
		zip: '12010',
		name: 'Roaschia',
		province: 'CN',
		altitude: 820
	},
	{
		zip: '12073',
		name: 'Roascio',
		province: 'CN',
		altitude: 458
	},
	{
		zip: '13060',
		name: 'Roasio',
		province: 'VC',
		altitude: 278
	},
	{
		zip: '14018',
		name: 'Roatto',
		province: 'AT',
		altitude: 256
	},
	{
		zip: '10070',
		name: 'Robassomero',
		province: 'TO',
		altitude: 360
	},
	{
		zip: '23899',
		name: 'Robbiate',
		province: 'LC',
		altitude: 265
	},
	{
		zip: '27038',
		name: 'Robbio',
		province: 'PV',
		altitude: 122
	},
	{
		zip: '20020',
		name: 'Robecchetto con Induno',
		province: 'MI',
		altitude: 172
	},
	{
		zip: '27040',
		name: 'Robecco Pavese',
		province: 'PV',
		altitude: 75
	},
	{
		zip: '26010',
		name: 'Robecco d\'\'Oglio',
		province: 'CR',
		altitude: 48
	},
	{
		zip: '20087',
		name: 'Robecco sul Naviglio',
		province: 'MI',
		altitude: 120
	},
	{
		zip: '14020',
		name: 'Robella',
		province: 'AT',
		altitude: 428
	},
	{
		zip: '12017',
		name: 'Robilante',
		province: 'CN',
		altitude: 686
	},
	{
		zip: '12080',
		name: 'Roburent',
		province: 'CN',
		altitude: 788
	},
	{
		zip: '10070',
		name: 'Rocca Canavese',
		province: 'TO',
		altitude: 421
	},
	{
		zip: '00020',
		name: 'Rocca Canterano',
		province: 'RM',
		altitude: 745
	},
	{
		zip: '12060',
		name: 'Rocca Ciglie',
		province: 'CN',
		altitude: 604
	},
	{
		zip: '15078',
		name: 'Rocca Grimalda',
		province: 'AL',
		altitude: 280
	},
	{
		zip: '87074',
		name: 'Rocca Imperiale',
		province: 'CS',
		altitude: 204
	},
	{
		zip: '04010',
		name: 'Rocca Massima',
		province: 'LT',
		altitude: 735
	},
	{
		zip: '67030',
		name: 'Rocca Pia',
		province: 'AQ',
		altitude: 1050
	},
	{
		zip: '32023',
		name: 'Rocca Pietore',
		province: 'BL',
		altitude: 1143
	},
	{
		zip: '00079',
		name: 'Rocca Priora',
		province: 'RM',
		altitude: 768
	},
	{
		zip: '47017',
		name: 'Rocca San Casciano',
		province: 'FC',
		altitude: 210
	},
	{
		zip: '83050',
		name: 'Rocca San Felice',
		province: 'AV',
		altitude: 750
	},
	{
		zip: '66020',
		name: 'Rocca San Giovanni',
		province: 'CH',
		altitude: 155
	},
	{
		zip: '64010',
		name: 'Rocca Santa Maria',
		province: 'TE',
		altitude: 1073
	},
	{
		zip: '00030',
		name: 'Rocca Santo Stefano',
		province: 'RM',
		altitude: 664
	},
	{
		zip: '02026',
		name: 'Rocca Sinibalda',
		province: 'RI',
		altitude: 552
	},
	{
		zip: '27052',
		name: 'Rocca Susella',
		province: 'PV',
		altitude: 525
	},
	{
		zip: '14030',
		name: 'Rocca d\'\'Arazzo',
		province: 'AT',
		altitude: 195
	},
	{
		zip: '03030',
		name: 'Rocca d\'\'Arce',
		province: 'FR',
		altitude: 507
	},
	{
		zip: '81040',
		name: 'Rocca d\'\'Evandro',
		province: 'CE',
		altitude: 83
	},
	{
		zip: '12047',
		name: 'Rocca de Baldi',
		province: 'CN',
		altitude: 414
	},
	{
		zip: '27040',
		name: 'Rocca de Giorgi',
		province: 'PV',
		altitude: 219
	},
	{
		zip: '67066',
		name: 'Rocca di Botte',
		province: 'AQ',
		altitude: 750
	},
	{
		zip: '67047',
		name: 'Rocca di Cambio',
		province: 'AQ',
		altitude: 1434
	},
	{
		zip: '00030',
		name: 'Rocca di Cave',
		province: 'RM',
		altitude: 933
	},
	{
		zip: '67048',
		name: 'Rocca di Mezzo',
		province: 'AQ',
		altitude: 1329
	},
	{
		zip: '88821',
		name: 'Rocca di Neto',
		province: 'KR',
		altitude: 165
	},
	{
		zip: '00040',
		name: 'Rocca di Papa',
		province: 'RM',
		altitude: 680
	},
	{
		zip: '83016',
		name: 'Roccabascerana',
		province: 'AV',
		altitude: 430
	},
	{
		zip: '88835',
		name: 'Roccabernarda',
		province: 'KR',
		altitude: 180
	},
	{
		zip: '43010',
		name: 'Roccabianca',
		province: 'PR',
		altitude: 32
	},
	{
		zip: '12020',
		name: 'Roccabruna',
		province: 'CN',
		altitude: 640
	},
	{
		zip: '67030',
		name: 'Roccacasale',
		province: 'AQ',
		altitude: 450
	},
	{
		zip: '84069',
		name: 'Roccadaspide',
		province: 'SA',
		altitude: 354
	},
	{
		zip: '98030',
		name: 'Roccafiorita',
		province: 'ME',
		altitude: 723
	},
	{
		zip: '63093',
		name: 'Roccafluvione',
		province: 'AP',
		altitude: 299
	},
	{
		zip: '15060',
		name: 'Roccaforte Ligure',
		province: 'AL',
		altitude: 704
	},
	{
		zip: '12088',
		name: 'Roccaforte Mondovi',
		province: 'CN',
		altitude: 574
	},
	{
		zip: '89060',
		name: 'Roccaforte del Greco',
		province: 'RC',
		altitude: 971
	},
	{
		zip: '74020',
		name: 'Roccaforzata',
		province: 'TA',
		altitude: 145
	},
	{
		zip: '25030',
		name: 'Roccafranca',
		province: 'BS',
		altitude: 117
	},
	{
		zip: '00020',
		name: 'Roccagiovine',
		province: 'RM',
		altitude: 520
	},
	{
		zip: '84060',
		name: 'Roccagloriosa',
		province: 'SA',
		altitude: 430
	},
	{
		zip: '04010',
		name: 'Roccagorga',
		province: 'LT',
		altitude: 287
	},
	{
		zip: '58053',
		name: 'Roccalbegna',
		province: 'GR',
		altitude: 522
	},
	{
		zip: '98027',
		name: 'Roccalumera',
		province: 'ME',
		altitude: 7
	},
	{
		zip: '86092',
		name: 'Roccamandolfi',
		province: 'IS',
		altitude: 850
	},
	{
		zip: '90040',
		name: 'Roccamena',
		province: 'PA',
		altitude: 480
	},
	{
		zip: '81035',
		name: 'Roccamonfina',
		province: 'CE',
		altitude: 612
	},
	{
		zip: '66010',
		name: 'Roccamontepiano',
		province: 'CH',
		altitude: 500
	},
	{
		zip: '65020',
		name: 'Roccamorice',
		province: 'PE',
		altitude: 520
	},
	{
		zip: '85036',
		name: 'Roccanova',
		province: 'PZ',
		altitude: 648
	},
	{
		zip: '02040',
		name: 'Roccantica',
		province: 'RI',
		altitude: 457
	},
	{
		zip: '90020',
		name: 'Roccapalumba',
		province: 'PA',
		altitude: 530
	},
	{
		zip: '84086',
		name: 'Roccapiemonte',
		province: 'SA',
		altitude: 86
	},
	{
		zip: '80030',
		name: 'Roccarainola',
		province: 'NA',
		altitude: 102
	},
	{
		zip: '67037',
		name: 'Roccaraso',
		province: 'AQ',
		altitude: 1236
	},
	{
		zip: '81051',
		name: 'Roccaromana',
		province: 'CE',
		altitude: 180
	},
	{
		zip: '66040',
		name: 'Roccascalegna',
		province: 'CH',
		altitude: 430
	},
	{
		zip: '03038',
		name: 'Roccasecca',
		province: 'FR',
		altitude: 245
	},
	{
		zip: '04010',
		name: 'Roccasecca dei Volsci',
		province: 'LT',
		altitude: 376
	},
	{
		zip: '86080',
		name: 'Roccasicura',
		province: 'IS',
		altitude: 742
	},
	{
		zip: '12010',
		name: 'Roccasparvera',
		province: 'CN',
		altitude: 674
	},
	{
		zip: '66050',
		name: 'Roccaspinalveti',
		province: 'CH',
		altitude: 740
	},
	{
		zip: '58036',
		name: 'Roccastrada',
		province: 'GR',
		altitude: 475
	},
	{
		zip: '98040',
		name: 'Roccavaldina',
		province: 'ME',
		altitude: 320
	},
	{
		zip: '14050',
		name: 'Roccaverano',
		province: 'AT',
		altitude: 759
	},
	{
		zip: '17017',
		name: 'Roccavignale',
		province: 'SV',
		altitude: 521
	},
	{
		zip: '12018',
		name: 'Roccavione',
		province: 'CN',
		altitude: 646
	},
	{
		zip: '86020',
		name: 'Roccavivara',
		province: 'CB',
		altitude: 652
	},
	{
		zip: '89047',
		name: 'Roccella Ionica',
		province: 'RC',
		altitude: 16
	},
	{
		zip: '98030',
		name: 'Roccella Valdemone',
		province: 'ME',
		altitude: 763
	},
	{
		zip: '12050',
		name: 'Rocchetta Belbo',
		province: 'CN',
		altitude: 273
	},
	{
		zip: '15060',
		name: 'Rocchetta Ligure',
		province: 'AL',
		altitude: 390
	},
	{
		zip: '18030',
		name: 'Rocchetta Nervina',
		province: 'IM',
		altitude: 235
	},
	{
		zip: '14040',
		name: 'Rocchetta Palafea',
		province: 'AT',
		altitude: 423
	},
	{
		zip: '71020',
		name: 'Rocchetta Sant\'\'Antonio',
		province: 'FG',
		altitude: 633
	},
	{
		zip: '14030',
		name: 'Rocchetta Tanaro',
		province: 'AT',
		altitude: 107
	},
	{
		zip: '86070',
		name: 'Rocchetta a Volturno',
		province: 'IS',
		altitude: 540
	},
	{
		zip: '19020',
		name: 'Rocchetta di Vara',
		province: 'SP',
		altitude: 220
	},
	{
		zip: '81042',
		name: 'Rocchetta e Croce',
		province: 'CE',
		altitude: 459
	},
	{
		zip: '20090',
		name: 'Rodano',
		province: 'MI',
		altitude: 120
	},
	{
		zip: '12060',
		name: 'Roddi',
		province: 'CN',
		altitude: 284
	},
	{
		zip: '12050',
		name: 'Roddino',
		province: 'CN',
		altitude: 610
	},
	{
		zip: '12050',
		name: 'Rodello',
		province: 'CN',
		altitude: 537
	},
	{
		zip: '39037',
		name: 'Rodengo',
		province: 'BZ',
		altitude: 885
	},
	{
		zip: '25050',
		name: 'Rodengo Saiano',
		province: 'BS',
		altitude: 176
	},
	{
		zip: '22070',
		name: 'Rodero',
		province: 'CO',
		altitude: 400
	},
	{
		zip: '71012',
		name: 'Rodi Garganico',
		province: 'FG',
		altitude: 42
	},
	{
		zip: '46040',
		name: 'Rodigo',
		province: 'MN',
		altitude: 31
	},
	{
		zip: '98059',
		name: 'Rodi Milici',
		province: 'ME',
		altitude: 125
	},
	{
		zip: '84070',
		name: 'Rofrano',
		province: 'SA',
		altitude: 450
	},
	{
		zip: '23849',
		name: 'Rogeno',
		province: 'LC',
		altitude: 292
	},
	{
		zip: '87017',
		name: 'Roggiano Gravina',
		province: 'CS',
		altitude: 260
	},
	{
		zip: '89060',
		name: 'Roghudi',
		province: 'RC',
		altitude: 55
	},
	{
		zip: '87054',
		name: 'Rogliano',
		province: 'CS',
		altitude: 660
	},
	{
		zip: '27012',
		name: 'Rognano',
		province: 'PV',
		altitude: 95
	},
	{
		zip: '24060',
		name: 'Rogno',
		province: 'BG',
		altitude: 215
	},
	{
		zip: '23010',
		name: 'Rogolo',
		province: 'SO',
		altitude: 216
	},
	{
		zip: '00030',
		name: 'Roiate',
		province: 'RM',
		altitude: 697
	},
	{
		zip: '66040',
		name: 'Roio del Sangro',
		province: 'CH',
		altitude: 840
	},
	{
		zip: '11010',
		name: 'Roisan',
		province: 'AO',
		altitude: 866
	},
	{
		zip: '10060',
		name: 'Roletto',
		province: 'TO',
		altitude: 412
	},
	{
		zip: '42047',
		name: 'Rolo',
		province: 'RE',
		altitude: 21
	},
	{
		zip: '28078',
		name: 'Romagnano Sesia',
		province: 'NO',
		altitude: 268
	},
	{
		zip: '84020',
		name: 'Romagnano al Monte',
		province: 'SA',
		altitude: 650
	},
	{
		zip: '27050',
		name: 'Romagnese',
		province: 'PV',
		altitude: 630
	},
	{
		zip: '07010',
		name: 'Romana',
		province: 'SS',
		altitude: 267
	},
	{
		zip: '26014',
		name: 'Romanengo',
		province: 'CR',
		altitude: 81
	},
	{
		zip: '10090',
		name: 'Romano Canavese',
		province: 'TO',
		altitude: 270
	},
	{
		zip: '36060',
		name: 'Romano d\'\'Ezzelino',
		province: 'VI',
		altitude: 132
	},
	{
		zip: '24058',
		name: 'Romano di Lombardia',
		province: 'BG',
		altitude: 120
	},
	{
		zip: '34076',
		name: 'Romans d\'\'Isonzo',
		province: 'GO',
		altitude: 23
	},
	{
		zip: '89841',
		name: 'Rombiolo',
		province: 'VV',
		altitude: 460
	},
	{
		zip: '38010',
		name: 'Romeno',
		province: 'TN',
		altitude: 962
	},
	{
		zip: '28068',
		name: 'Romentino',
		province: 'NO',
		altitude: 146
	},
	{
		zip: '98043',
		name: 'Rometta',
		province: 'ME',
		altitude: 560
	},
	{
		zip: '22027',
		name: 'Ronago',
		province: 'CO',
		altitude: 357
	},
	{
		zip: '31056',
		name: 'Roncade',
		province: 'TV',
		altitude: 8
	},
	{
		zip: '25030',
		name: 'Roncadelle',
		province: 'BS',
		altitude: 158
	},
	{
		zip: '27010',
		name: 'Roncaro',
		province: 'PV',
		altitude: 81
	},
	{
		zip: '38050',
		name: 'Roncegno Terme',
		province: 'TN',
		altitude: 535
	},
	{
		zip: '20877',
		name: 'Roncello',
		province: 'MB',
		altitude: 196
	},
	{
		zip: '38051',
		name: 'Ronchi Valsugana',
		province: 'TN',
		altitude: 776
	},
	{
		zip: '34077',
		name: 'Ronchi dei Legionari',
		province: 'GO',
		altitude: 11
	},
	{
		zip: '33050',
		name: 'Ronchis',
		province: 'UD',
		altitude: 8
	},
	{
		zip: '01037',
		name: 'Ronciglione',
		province: 'VT',
		altitude: 441
	},
	{
		zip: '13845',
		name: 'Ronco Biellese',
		province: 'BI',
		altitude: 457
	},
	{
		zip: '20885',
		name: 'Ronco Briantino',
		province: 'MB',
		altitude: 247
	},
	{
		zip: '10080',
		name: 'Ronco Canavese',
		province: 'TO',
		altitude: 956
	},
	{
		zip: '16019',
		name: 'Ronco Scrivia',
		province: 'GE',
		altitude: 334
	},
	{
		zip: '37055',
		name: 'Ronco all\'\'Adige',
		province: 'VR',
		altitude: 23
	},
	{
		zip: '24010',
		name: 'Roncobello',
		province: 'BG',
		altitude: 1007
	},
	{
		zip: '46037',
		name: 'Roncoferraro',
		province: 'MN',
		altitude: 25
	},
	{
		zip: '47020',
		name: 'Roncofreddo',
		province: 'FC',
		altitude: 314
	},
	{
		zip: '24030',
		name: 'Roncola',
		province: 'BG',
		altitude: 854
	},
	{
		zip: '37030',
		name: 'Ronca',
		province: 'VR',
		altitude: 89
	},
	{
		zip: '16025',
		name: 'Rondanina',
		province: 'GE',
		altitude: 981
	},
	{
		zip: '10030',
		name: 'Rondissone',
		province: 'TO',
		altitude: 211
	},
	{
		zip: '13036',
		name: 'Ronsecco',
		province: 'VC',
		altitude: 145
	},
	{
		zip: '38060',
		name: 'Ronzo-Chienis',
		province: 'TN',
		altitude: 1000
	},
	{
		zip: '38010',
		name: 'Ronzone',
		province: 'TN',
		altitude: 1085
	},
	{
		zip: '13883',
		name: 'Roppolo',
		province: 'BI',
		altitude: 310
	},
	{
		zip: '10060',
		name: 'Rora',
		province: 'TO',
		altitude: 967
	},
	{
		zip: '89025',
		name: 'Rosarno',
		province: 'RC',
		altitude: 67
	},
	{
		zip: '27030',
		name: 'Rosasco',
		province: 'PV',
		altitude: 114
	},
	{
		zip: '20088',
		name: 'Rosate',
		province: 'MI',
		altitude: 107
	},
	{
		zip: '13815',
		name: 'Rosazza',
		province: 'BI',
		altitude: 882
	},
	{
		zip: '65020',
		name: 'Rosciano',
		province: 'PE',
		altitude: 253
	},
	{
		zip: '84020',
		name: 'Roscigno',
		province: 'SA',
		altitude: 570
	},
	{
		zip: '87040',
		name: 'Rose',
		province: 'CS',
		altitude: 399
	},
	{
		zip: '66040',
		name: 'Rosello',
		province: 'CH',
		altitude: 920
	},
	{
		zip: '87070',
		name: 'Roseto Capo Spulico',
		province: 'CS',
		altitude: 217
	},
	{
		zip: '71039',
		name: 'Roseto Valfortore',
		province: 'FG',
		altitude: 658
	},
	{
		zip: '64026',
		name: 'Roseto degli Abruzzi',
		province: 'TE',
		altitude: 5
	},
	{
		zip: '57016',
		name: 'Rosignano Marittimo',
		province: 'LI',
		altitude: 147
	},
	{
		zip: '15030',
		name: 'Rosignano Monferrato',
		province: 'AL',
		altitude: 280
	},
	{
		zip: '45010',
		name: 'Rosolina',
		province: 'RO',
		altitude: 1
	},
	{
		zip: '96019',
		name: 'Rosolini',
		province: 'SR',
		altitude: 154
	},
	{
		zip: '60030',
		name: 'Rosora',
		province: 'AN',
		altitude: 380
	},
	{
		zip: '13020',
		name: 'Rossa',
		province: 'VC',
		altitude: 813
	},
	{
		zip: '12020',
		name: 'Rossana',
		province: 'CN',
		altitude: 535
	},
	{
		zip: '36028',
		name: 'Rossano Veneto',
		province: 'VI',
		altitude: 78
	},
	{
		zip: '16010',
		name: 'Rossiglione',
		province: 'GE',
		altitude: 297
	},
	{
		zip: '10090',
		name: 'Rosta',
		province: 'TO',
		altitude: 399
	},
	{
		zip: '36027',
		name: 'Rosa',
		province: 'VI',
		altitude: 97
	},
	{
		zip: '87010',
		name: 'Rota Greca',
		province: 'CS',
		altitude: 510
	},
	{
		zip: '24037',
		name: 'Rota d\'\'Imagna',
		province: 'BG',
		altitude: 690
	},
	{
		zip: '63071',
		name: 'Rotella',
		province: 'AP',
		altitude: 395
	},
	{
		zip: '86040',
		name: 'Rotello',
		province: 'CB',
		altitude: 360
	},
	{
		zip: '85048',
		name: 'Rotonda',
		province: 'PZ',
		altitude: 580
	},
	{
		zip: '75026',
		name: 'Rotondella',
		province: 'MT',
		altitude: 576
	},
	{
		zip: '83017',
		name: 'Rotondi',
		province: 'AV',
		altitude: 272
	},
	{
		zip: '29010',
		name: 'Rottofreno',
		province: 'PC',
		altitude: 65
	},
	{
		zip: '36010',
		name: 'Rotzo',
		province: 'VI',
		altitude: 938
	},
	{
		zip: '10060',
		name: 'Roure',
		province: 'TO',
		altitude: 860
	},
	{
		zip: '13040',
		name: 'Rovasenda',
		province: 'VC',
		altitude: 221
	},
	{
		zip: '25038',
		name: 'Rovato',
		province: 'BS',
		altitude: 192
	},
	{
		zip: '16028',
		name: 'Rovegno',
		province: 'GE',
		altitude: 666
	},
	{
		zip: '22069',
		name: 'Rovellasca',
		province: 'CO',
		altitude: 244
	},
	{
		zip: '22070',
		name: 'Rovello Porro',
		province: 'CO',
		altitude: 240
	},
	{
		zip: '46048',
		name: 'Roverbella',
		province: 'MN',
		altitude: 47
	},
	{
		zip: '37050',
		name: 'Roverchiara',
		province: 'VR',
		altitude: 20
	},
	{
		zip: '37040',
		name: 'Roveredo di Gua',
		province: 'VR',
		altitude: 16
	},
	{
		zip: '33080',
		name: 'Roveredo in Piano',
		province: 'PN',
		altitude: 99
	},
	{
		zip: '38068',
		name: 'Rovereto',
		province: 'TN',
		altitude: 204
	},
	{
		zip: '37028',
		name: 'Rovere Veronese',
		province: 'VR',
		altitude: 843
	},
	{
		zip: '38030',
		name: 'Rovere della Luna',
		province: 'TN',
		altitude: 251
	},
	{
		zip: '27040',
		name: 'Rovescala',
		province: 'PV',
		altitude: 250
	},
	{
		zip: '24020',
		name: 'Rovetta',
		province: 'BG',
		altitude: 650
	},
	{
		zip: '00027',
		name: 'Roviano',
		province: 'RM',
		altitude: 523
	},
	{
		zip: '45100',
		name: 'Rovigo',
		province: 'RO',
		altitude: 7
	},
	{
		zip: '87050',
		name: 'Rovito',
		province: 'CS',
		altitude: 744
	},
	{
		zip: '35030',
		name: 'Rovolon',
		province: 'PD',
		altitude: 152
	},
	{
		zip: '20089',
		name: 'Rozzano',
		province: 'MI',
		altitude: 103
	},
	{
		zip: '25077',
		name: 'Roe Volciano',
		province: 'BS',
		altitude: 240
	},
	{
		zip: '35030',
		name: 'Rubano',
		province: 'PD',
		altitude: 18
	},
	{
		zip: '10040',
		name: 'Rubiana',
		province: 'TO',
		altitude: 640
	},
	{
		zip: '42048',
		name: 'Rubiera',
		province: 'RE',
		altitude: 53
	},
	{
		zip: '33050',
		name: 'Ruda',
		province: 'UD',
		altitude: 12
	},
	{
		zip: '25030',
		name: 'Rudiano',
		province: 'BS',
		altitude: 117
	},
	{
		zip: '10010',
		name: 'Rueglio',
		province: 'TO',
		altitude: 675
	},
	{
		zip: '73049',
		name: 'Ruffano',
		province: 'LE',
		altitude: 127
	},
	{
		zip: '12030',
		name: 'Ruffia',
		province: 'CN',
		altitude: 282
	},
	{
		zip: '38010',
		name: 'Ruffre-Mendola',
		province: 'TN',
		altitude: 1200
	},
	{
		zip: '50068',
		name: 'Rufina',
		province: 'FI',
		altitude: 115
	},
	{
		zip: '09085',
		name: 'Ruinas',
		province: 'OR',
		altitude: 359
	},
	{
		zip: '38020',
		name: 'Rumo',
		province: 'TN',
		altitude: 944
	},
	{
		zip: '85056',
		name: 'Ruoti',
		province: 'PZ',
		altitude: 751
	},
	{
		zip: '48026',
		name: 'Russi',
		province: 'RA',
		altitude: 13
	},
	{
		zip: '70018',
		name: 'Rutigliano',
		province: 'BA',
		altitude: 125
	},
	{
		zip: '84070',
		name: 'Rutino',
		province: 'SA',
		altitude: 371
	},
	{
		zip: '81010',
		name: 'Ruviano',
		province: 'CE',
		altitude: 80
	},
	{
		zip: '85020',
		name: 'Ruvo del Monte',
		province: 'PZ',
		altitude: 638
	},
	{
		zip: '70037',
		name: 'Ruvo di Puglia',
		province: 'BA',
		altitude: 266
	},
	{
		zip: '04016',
		name: 'Sabaudia',
		province: 'LT',
		altitude: 17
	},
	{
		zip: '25070',
		name: 'Sabbio Chiese',
		province: 'BS',
		altitude: 277
	},
	{
		zip: '46018',
		name: 'Sabbioneta',
		province: 'MN',
		altitude: 18
	},
	{
		zip: '84070',
		name: 'Sacco',
		province: 'SA',
		altitude: 600
	},
	{
		zip: '35030',
		name: 'Saccolongo',
		province: 'PD',
		altitude: 19
	},
	{
		zip: '33077',
		name: 'Sacile',
		province: 'PN',
		altitude: 25
	},
	{
		zip: '00060',
		name: 'Sacrofano',
		province: 'RM',
		altitude: 260
	},
	{
		zip: '09062',
		name: 'Sadali',
		province: 'SU',
		altitude: 705
	},
	{
		zip: '09090',
		name: 'Sagama',
		province: 'OR',
		altitude: 347
	},
	{
		zip: '13816',
		name: 'Sagliano Micca',
		province: 'BI',
		altitude: 589
	},
	{
		zip: '34078',
		name: 'Sagrado',
		province: 'GO',
		altitude: 32
	},
	{
		zip: '38050',
		name: 'Sagron Mis',
		province: 'TN',
		altitude: 1062
	},
	{
		zip: '11020',
		name: 'Saint-Christophe',
		province: 'AO',
		altitude: 619
	},
	{
		zip: '11023',
		name: 'Saint-Denis',
		province: 'AO',
		altitude: 820
	},
	{
		zip: '11020',
		name: 'Saint-Marcel',
		province: 'AO',
		altitude: 625
	},
	{
		zip: '11010',
		name: 'Saint-Nicolas',
		province: 'AO',
		altitude: 1200
	},
	{
		zip: '11014',
		name: 'Saint-Oyen',
		province: 'AO',
		altitude: 1373
	},
	{
		zip: '11010',
		name: 'Saint-Pierre',
		province: 'AO',
		altitude: 731
	},
	{
		zip: '11010',
		name: 'Saint-Rhémy-en-Bosses',
		province: 'AO',
		altitude: 1632
	},
	{
		zip: '11027',
		name: 'Saint-Vincent',
		province: 'AO',
		altitude: 575
	},
	{
		zip: '43038',
		name: 'Sala Baganza',
		province: 'PR',
		altitude: 176
	},
	{
		zip: '13884',
		name: 'Sala Biellese',
		province: 'BI',
		altitude: 626
	},
	{
		zip: '40010',
		name: 'Sala Bolognese',
		province: 'BO',
		altitude: 25
	},
	{
		zip: '22010',
		name: 'Sala Comacina',
		province: 'CO',
		altitude: 213
	},
	{
		zip: '84036',
		name: 'Sala Consilina',
		province: 'SA',
		altitude: 614
	},
	{
		zip: '15030',
		name: 'Sala Monferrato',
		province: 'AL',
		altitude: 264
	},
	{
		zip: '75017',
		name: 'Salandra',
		province: 'MT',
		altitude: 598
	},
	{
		zip: '91020',
		name: 'Salaparuta',
		province: 'TP',
		altitude: 171
	},
	{
		zip: '45030',
		name: 'Salara',
		province: 'RO',
		altitude: 7
	},
	{
		zip: '13040',
		name: 'Salasco',
		province: 'VC',
		altitude: 148
	},
	{
		zip: '10080',
		name: 'Salassa',
		province: 'TO',
		altitude: 349
	},
	{
		zip: '10050',
		name: 'Salbertrand',
		province: 'TO',
		altitude: 1032
	},
	{
		zip: '36040',
		name: 'Salcedo',
		province: 'VI',
		altitude: 398
	},
	{
		zip: '86026',
		name: 'Salcito',
		province: 'CB',
		altitude: 678
	},
	{
		zip: '15045',
		name: 'Sale',
		province: 'AL',
		altitude: 83
	},
	{
		zip: '25057',
		name: 'Sale Marasino',
		province: 'BS',
		altitude: 200
	},
	{
		zip: '12070',
		name: 'Sale San Giovanni',
		province: 'CN',
		altitude: 615
	},
	{
		zip: '12070',
		name: 'Sale delle Langhe',
		province: 'CN',
		altitude: 480
	},
	{
		zip: '91018',
		name: 'Salemi',
		province: 'TP',
		altitude: 446
	},
	{
		zip: '10010',
		name: 'Salerano Canavese',
		province: 'TO',
		altitude: 247
	},
	{
		zip: '26857',
		name: 'Salerano sul Lambro',
		province: 'LO',
		altitude: 77
	},
	{
		zip: '84121',
		name: 'Salerno',
		province: 'SA',
		altitude: 4
	},
	{
		zip: '31040',
		name: 'Salgareda',
		province: 'TV',
		altitude: 8
	},
	{
		zip: '13040',
		name: 'Sali Vercellese',
		province: 'VC',
		altitude: 139
	},
	{
		zip: '73015',
		name: 'Salice Salentino',
		province: 'LE',
		altitude: 47
	},
	{
		zip: '12079',
		name: 'Saliceto',
		province: 'CN',
		altitude: 389
	},
	{
		zip: '02040',
		name: 'Salisano',
		province: 'RI',
		altitude: 460
	},
	{
		zip: '37056',
		name: 'Salizzole',
		province: 'VR',
		altitude: 22
	},
	{
		zip: '65020',
		name: 'Salle',
		province: 'PE',
		altitude: 470
	},
	{
		zip: '12040',
		name: 'Salmour',
		province: 'CN',
		altitude: 391
	},
	{
		zip: '39040',
		name: 'Salorno sulla Strada del Vino',
		province: 'BZ',
		altitude: 224
	},
	{
		zip: '43039',
		name: 'Salsomaggiore Terme',
		province: 'PR',
		altitude: 157
	},
	{
		zip: '21050',
		name: 'Saltrio',
		province: 'VA',
		altitude: 543
	},
	{
		zip: '47835',
		name: 'Saludecio',
		province: 'RN',
		altitude: 343
	},
	{
		zip: '13040',
		name: 'Saluggia',
		province: 'VC',
		altitude: 205
	},
	{
		zip: '13885',
		name: 'Salussola',
		province: 'BI',
		altitude: 289
	},
	{
		zip: '12037',
		name: 'Saluzzo',
		province: 'CN',
		altitude: 350
	},
	{
		zip: '73050',
		name: 'Salve',
		province: 'LE',
		altitude: 130
	},
	{
		zip: '26010',
		name: 'Salvirola',
		province: 'CR',
		altitude: 74
	},
	{
		zip: '84020',
		name: 'Salvitelle',
		province: 'SA',
		altitude: 630
	},
	{
		zip: '83050',
		name: 'Salza Irpina',
		province: 'AV',
		altitude: 547
	},
	{
		zip: '10060',
		name: 'Salza di Pinerolo',
		province: 'TO',
		altitude: 1210
	},
	{
		zip: '30030',
		name: 'Salzano',
		province: 'VE',
		altitude: 10
	},
	{
		zip: '25087',
		name: 'Salo',
		province: 'BS',
		altitude: 65
	},
	{
		zip: '21017',
		name: 'Samarate',
		province: 'VA',
		altitude: 221
	},
	{
		zip: '09030',
		name: 'Samassi',
		province: 'SU',
		altitude: 56
	},
	{
		zip: '09020',
		name: 'Samatzai',
		province: 'SU',
		altitude: 174
	},
	{
		zip: '51020',
		name: 'Sambuca Pistoiese',
		province: 'PT',
		altitude: 504
	},
	{
		zip: '92017',
		name: 'Sambuca di Sicilia',
		province: 'AG',
		altitude: 364
	},
	{
		zip: '00020',
		name: 'Sambuci',
		province: 'RM',
		altitude: 434
	},
	{
		zip: '12010',
		name: 'Sambuco',
		province: 'CN',
		altitude: 1184
	},
	{
		zip: '70010',
		name: 'Sammichele di Bari',
		province: 'BA',
		altitude: 280
	},
	{
		zip: '89030',
		name: 'Samo',
		province: 'RC',
		altitude: 280
	},
	{
		zip: '23027',
		name: 'Samolaco',
		province: 'SO',
		altitude: 236
	},
	{
		zip: '12020',
		name: 'Sampeyre',
		province: 'CN',
		altitude: 976
	},
	{
		zip: '09086',
		name: 'Samugheo',
		province: 'OR',
		altitude: 370
	},
	{
		zip: '22010',
		name: 'San Bartolomeo Val Cavargna',
		province: 'CO',
		altitude: 875
	},
	{
		zip: '18016',
		name: 'San Bartolomeo al Mare',
		province: 'IM',
		altitude: 26
	},
	{
		zip: '82028',
		name: 'San Bartolomeo in Galdo',
		province: 'BN',
		altitude: 597
	},
	{
		zip: '87010',
		name: 'San Basile',
		province: 'CS',
		altitude: 540
	},
	{
		zip: '09040',
		name: 'San Basilio',
		province: 'SU',
		altitude: 415
	},
	{
		zip: '26020',
		name: 'San Bassano',
		province: 'CR',
		altitude: 59
	},
	{
		zip: '45020',
		name: 'San Bellino',
		province: 'RO',
		altitude: 7
	},
	{
		zip: '12050',
		name: 'San Benedetto Belbo',
		province: 'CN',
		altitude: 637
	},
	{
		zip: '46027',
		name: 'San Benedetto Po',
		province: 'MN',
		altitude: 19
	},
	{
		zip: '87040',
		name: 'San Benedetto Ullano',
		province: 'CS',
		altitude: 460
	},
	{
		zip: '40048',
		name: 'San Benedetto Val di Sambro',
		province: 'BO',
		altitude: 602
	},
	{
		zip: '67058',
		name: 'San Benedetto dei Marsi',
		province: 'AQ',
		altitude: 678
	},
	{
		zip: '63074',
		name: 'San Benedetto del Tronto',
		province: 'AP',
		altitude: 4
	},
	{
		zip: '67020',
		name: 'San Benedetto in Perillis',
		province: 'AQ',
		altitude: 878
	},
	{
		zip: '10080',
		name: 'San Benigno Canavese',
		province: 'TO',
		altitude: 200
	},
	{
		zip: '28804',
		name: 'San Bernardino Verbano',
		province: 'VB',
		altitude: 304
	},
	{
		zip: '92020',
		name: 'San Biagio Platani',
		province: 'AG',
		altitude: 416
	},
	{
		zip: '03040',
		name: 'San Biagio Saracinisco',
		province: 'FR',
		altitude: 836
	},
	{
		zip: '18036',
		name: 'San Biagio della Cima',
		province: 'IM',
		altitude: 100
	},
	{
		zip: '31048',
		name: 'San Biagio di Callalta',
		province: 'TV',
		altitude: 10
	},
	{
		zip: '86020',
		name: 'San Biase',
		province: 'CB',
		altitude: 820
	},
	{
		zip: '37047',
		name: 'San Bonifacio',
		province: 'VR',
		altitude: 31
	},
	{
		zip: '66050',
		name: 'San Buono',
		province: 'CH',
		altitude: 470
	},
	{
		zip: '89842',
		name: 'San Calogero',
		province: 'VV',
		altitude: 261
	},
	{
		zip: '39038',
		name: 'San Candido',
		province: 'BZ',
		altitude: 1175
	},
	{
		zip: '34075',
		name: 'San Canzian d\'\'Isonzo',
		province: 'GO',
		altitude: 6
	},
	{
		zip: '10070',
		name: 'San Carlo Canavese',
		province: 'TO',
		altitude: 370
	},
	{
		zip: '53040',
		name: 'San Casciano dei Bagni',
		province: 'SI',
		altitude: 582
	},
	{
		zip: '50026',
		name: 'San Casciano in Val di Pesa',
		province: 'FI',
		altitude: 310
	},
	{
		zip: '73020',
		name: 'San Cassiano',
		province: 'LE',
		altitude: 89
	},
	{
		zip: '93017',
		name: 'San Cataldo',
		province: 'CL',
		altitude: 625
	},
	{
		zip: '00030',
		name: 'San Cesareo',
		province: 'RM',
		altitude: 312
	},
	{
		zip: '73016',
		name: 'San Cesario di Lecce',
		province: 'LE',
		altitude: 42
	},
	{
		zip: '41018',
		name: 'San Cesario sul Panaro',
		province: 'MO',
		altitude: 54
	},
	{
		zip: '85010',
		name: 'San Chirico Nuovo',
		province: 'PZ',
		altitude: 745
	},
	{
		zip: '85030',
		name: 'San Chirico Raparo',
		province: 'PZ',
		altitude: 780
	},
	{
		zip: '90040',
		name: 'San Cipirello',
		province: 'PA',
		altitude: 394
	},
	{
		zip: '84099',
		name: 'San Cipriano Picentino',
		province: 'SA',
		altitude: 365
	},
	{
		zip: '27043',
		name: 'San Cipriano Po',
		province: 'PV',
		altitude: 63
	},
	{
		zip: '81036',
		name: 'San Cipriano d\'\'Aversa',
		province: 'CE',
		altitude: 20
	},
	{
		zip: '47832',
		name: 'San Clemente',
		province: 'RN',
		altitude: 179
	},
	{
		zip: '10080',
		name: 'San Colombano Belmonte',
		province: 'TO',
		altitude: 550
	},
	{
		zip: '16040',
		name: 'San Colombano Certenoli',
		province: 'GE',
		altitude: 45
	},
	{
		zip: '20078',
		name: 'San Colombano al Lambro',
		province: 'MI',
		altitude: 80
	},
	{
		zip: '95040',
		name: 'San Cono',
		province: 'CT',
		altitude: 525
	},
	{
		zip: '87060',
		name: 'San Cosmo Albanese',
		province: 'CS',
		altitude: 400
	},
	{
		zip: '85030',
		name: 'San Costantino Albanese',
		province: 'PZ',
		altitude: 650
	},
	{
		zip: '89851',
		name: 'San Costantino Calabro',
		province: 'VV',
		altitude: 454
	},
	{
		zip: '61039',
		name: 'San Costanzo',
		province: 'PU',
		altitude: 150
	},
	{
		zip: '15060',
		name: 'San Cristoforo',
		province: 'AL',
		altitude: 301
	},
	{
		zip: '12029',
		name: 'San Damiano Macra',
		province: 'CN',
		altitude: 743
	},
	{
		zip: '27040',
		name: 'San Damiano al Colle',
		province: 'PV',
		altitude: 216
	},
	{
		zip: '14015',
		name: 'San Damiano d\'\'Asti',
		province: 'AT',
		altitude: 179
	},
	{
		zip: '26046',
		name: 'San Daniele Po',
		province: 'CR',
		altitude: 33
	},
	{
		zip: '33038',
		name: 'San Daniele del Friuli',
		province: 'UD',
		altitude: 252
	},
	{
		zip: '87069',
		name: 'San Demetrio Corone',
		province: 'CS',
		altitude: 521
	},
	{
		zip: '67028',
		name: 'San Demetrio ne Vestini',
		province: 'AQ',
		altitude: 662
	},
	{
		zip: '10050',
		name: 'San Didero',
		province: 'TO',
		altitude: 430
	},
	{
		zip: '72025',
		name: 'San Donaci',
		province: 'BR',
		altitude: 42
	},
	{
		zip: '20097',
		name: 'San Donato Milanese',
		province: 'MI',
		altitude: 102
	},
	{
		zip: '03046',
		name: 'San Donato Val di Comino',
		province: 'FR',
		altitude: 728
	},
	{
		zip: '73010',
		name: 'San Donato di Lecce',
		province: 'LE',
		altitude: 70
	},
	{
		zip: '87010',
		name: 'San Donato di Ninea',
		province: 'CS',
		altitude: 720
	},
	{
		zip: '30027',
		name: 'San Dona di Piave',
		province: 'VE',
		altitude: 3
	},
	{
		zip: '34018',
		name: 'San Dorligo della Valle',
		province: 'TS',
		altitude: 106
	},
	{
		zip: '85020',
		name: 'San Fele',
		province: 'PZ',
		altitude: 872
	},
	{
		zip: '04017',
		name: 'San Felice Circeo',
		province: 'LT',
		altitude: 98
	},
	{
		zip: '81027',
		name: 'San Felice a Cancello',
		province: 'CE',
		altitude: 89
	},
	{
		zip: '25010',
		name: 'San Felice del Benaco',
		province: 'BS',
		altitude: 109
	},
	{
		zip: '86030',
		name: 'San Felice del Molise',
		province: 'CB',
		altitude: 546
	},
	{
		zip: '41038',
		name: 'San Felice sul Panaro',
		province: 'MO',
		altitude: 19
	},
	{
		zip: '89026',
		name: 'San Ferdinando',
		province: 'RC',
		altitude: 6
	},
	{
		zip: '76017',
		name: 'San Ferdinando di Puglia',
		province: 'BT',
		altitude: 68
	},
	{
		zip: '22042',
		name: 'San Fermo della Battaglia',
		province: 'CO',
		altitude: 397
	},
	{
		zip: '87037',
		name: 'San Fili',
		province: 'CS',
		altitude: 566
	},
	{
		zip: '98044',
		name: 'San Filippo del Mela',
		province: 'ME',
		altitude: 89
	},
	{
		zip: '31020',
		name: 'San Fior',
		province: 'TV',
		altitude: 57
	},
	{
		zip: '26848',
		name: 'San Fiorano',
		province: 'LO',
		altitude: 56
	},
	{
		zip: '34070',
		name: 'San Floriano del Collio',
		province: 'GO',
		altitude: 276
	},
	{
		zip: '88021',
		name: 'San Floro',
		province: 'CZ',
		altitude: 260
	},
	{
		zip: '10070',
		name: 'San Francesco al Campo',
		province: 'TO',
		altitude: 327
	},
	{
		zip: '98075',
		name: 'San Fratello',
		province: 'ME',
		altitude: 675
	},
	{
		zip: '09037',
		name: 'San Gavino Monreale',
		province: 'SU',
		altitude: 54
	},
	{
		zip: '05029',
		name: 'San Gemini',
		province: 'TR',
		altitude: 337
	},
	{
		zip: '39050',
		name: 'San Genesio Atesino',
		province: 'BZ',
		altitude: 1087
	},
	{
		zip: '27010',
		name: 'San Genesio ed Uniti',
		province: 'PV',
		altitude: 86
	},
	{
		zip: '80040',
		name: 'San Gennaro Vesuviano',
		province: 'NA',
		altitude: 56
	},
	{
		zip: '10065',
		name: 'San Germano Chisone',
		province: 'TO',
		altitude: 486
	},
	{
		zip: '13047',
		name: 'San Germano Vercellese',
		province: 'VC',
		altitude: 161
	},
	{
		zip: '25020',
		name: 'San Gervasio Bresciano',
		province: 'BS',
		altitude: 57
	},
	{
		zip: '23020',
		name: 'San Giacomo Filippo',
		province: 'SO',
		altitude: 522
	},
	{
		zip: '13030',
		name: 'San Giacomo Vercellese',
		province: 'VC',
		altitude: 197
	},
	{
		zip: '86030',
		name: 'San Giacomo degli Schiavoni',
		province: 'CB',
		altitude: 169
	},
	{
		zip: '46020',
		name: 'San Giacomo delle Segnate',
		province: 'MN',
		altitude: 16
	},
	{
		zip: '10040',
		name: 'San Gillio',
		province: 'TO',
		altitude: 320
	},
	{
		zip: '53037',
		name: 'San Gimignano',
		province: 'SI',
		altitude: 324
	},
	{
		zip: '62026',
		name: 'San Ginesio',
		province: 'MC',
		altitude: 680
	},
	{
		zip: '87060',
		name: 'San Giorgio Albanese',
		province: 'CS',
		altitude: 428
	},
	{
		zip: '46051',
		name: 'San Giorgio Bigarello',
		province: 'MN',
		altitude: 25
	},
	{
		zip: '10090',
		name: 'San Giorgio Canavese',
		province: 'TO',
		altitude: 300
	},
	{
		zip: '74027',
		name: 'San Giorgio Ionico',
		province: 'TA',
		altitude: 75
	},
	{
		zip: '82020',
		name: 'San Giorgio La Molara',
		province: 'BN',
		altitude: 667
	},
	{
		zip: '75027',
		name: 'San Giorgio Lucano',
		province: 'MT',
		altitude: 416
	},
	{
		zip: '15020',
		name: 'San Giorgio Monferrato',
		province: 'AL',
		altitude: 281
	},
	{
		zip: '89017',
		name: 'San Giorgio Morgeto',
		province: 'RC',
		altitude: 512
	},
	{
		zip: '29019',
		name: 'San Giorgio Piacentino',
		province: 'PC',
		altitude: 103
	},
	{
		zip: '14059',
		name: 'San Giorgio Scarampi',
		province: 'AT',
		altitude: 655
	},
	{
		zip: '80046',
		name: 'San Giorgio a Cremano',
		province: 'NA',
		altitude: 56
	},
	{
		zip: '03047',
		name: 'San Giorgio a Liri',
		province: 'FR',
		altitude: 38
	},
	{
		zip: '82018',
		name: 'San Giorgio del Sannio',
		province: 'BN',
		altitude: 380
	},
	{
		zip: '33095',
		name: 'San Giorgio della Richinvelda',
		province: 'PN',
		altitude: 86
	},
	{
		zip: '35010',
		name: 'San Giorgio delle Pertiche',
		province: 'PD',
		altitude: 24
	},
	{
		zip: '27020',
		name: 'San Giorgio di Lomellina',
		province: 'PV',
		altitude: 99
	},
	{
		zip: '33058',
		name: 'San Giorgio di Nogaro',
		province: 'UD',
		altitude: 4
	},
	{
		zip: '40016',
		name: 'San Giorgio di Piano',
		province: 'BO',
		altitude: 21
	},
	{
		zip: '35010',
		name: 'San Giorgio in Bosco',
		province: 'PD',
		altitude: 29
	},
	{
		zip: '20034',
		name: 'San Giorgio su Legnano',
		province: 'MI',
		altitude: 198
	},
	{
		zip: '10050',
		name: 'San Giorio di Susa',
		province: 'TO',
		altitude: 420
	},
	{
		zip: '24015',
		name: 'San Giovanni Bianco',
		province: 'BG',
		altitude: 448
	},
	{
		zip: '92020',
		name: 'San Giovanni Gemini',
		province: 'AG',
		altitude: 670
	},
	{
		zip: '37035',
		name: 'San Giovanni Ilarione',
		province: 'VR',
		altitude: 194
	},
	{
		zip: '03028',
		name: 'San Giovanni Incarico',
		province: 'FR',
		altitude: 200
	},
	{
		zip: '66050',
		name: 'San Giovanni Lipioni',
		province: 'CH',
		altitude: 563
	},
	{
		zip: '37057',
		name: 'San Giovanni Lupatoto',
		province: 'VR',
		altitude: 42
	},
	{
		zip: '71013',
		name: 'San Giovanni Rotondo',
		province: 'FG',
		altitude: 566
	},
	{
		zip: '09010',
		name: 'San Giovanni Suergiu',
		province: 'SU',
		altitude: 16
	},
	{
		zip: '66020',
		name: 'San Giovanni Teatino',
		province: 'CH',
		altitude: 145
	},
	{
		zip: '52027',
		name: 'San Giovanni Valdarno',
		province: 'AR',
		altitude: 134
	},
	{
		zip: '84070',
		name: 'San Giovanni a Piro',
		province: 'SA',
		altitude: 450
	},
	{
		zip: '33048',
		name: 'San Giovanni al Natisone',
		province: 'UD',
		altitude: 66
	},
	{
		zip: '46020',
		name: 'San Giovanni del Dosso',
		province: 'MN',
		altitude: 13
	},
	{
		zip: '38036',
		name: 'San Giovanni di Fassa',
		province: 'TN',
		altitude: 1380
	},
	{
		zip: '89040',
		name: 'San Giovanni di Gerace',
		province: 'RC',
		altitude: 310
	},
	{
		zip: '26037',
		name: 'San Giovanni in Croce',
		province: 'CR',
		altitude: 28
	},
	{
		zip: '87055',
		name: 'San Giovanni in Fiore',
		province: 'CS',
		altitude: 1049
	},
	{
		zip: '86010',
		name: 'San Giovanni in Galdo',
		province: 'CB',
		altitude: 552
	},
	{
		zip: '47842',
		name: 'San Giovanni in Marignano',
		province: 'RN',
		altitude: 29
	},
	{
		zip: '40017',
		name: 'San Giovanni in Persiceto',
		province: 'BO',
		altitude: 21
	},
	{
		zip: '95037',
		name: 'San Giovanni la Punta',
		province: 'CT',
		altitude: 350
	},
	{
		zip: '20098',
		name: 'San Giuliano Milanese',
		province: 'MI',
		altitude: 98
	},
	{
		zip: '56017',
		name: 'San Giuliano Terme',
		province: 'PI',
		altitude: 6
	},
	{
		zip: '86010',
		name: 'San Giuliano del Sannio',
		province: 'CB',
		altitude: 621
	},
	{
		zip: '86040',
		name: 'San Giuliano di Puglia',
		province: 'CB',
		altitude: 453
	},
	{
		zip: '90048',
		name: 'San Giuseppe Jato',
		province: 'PA',
		altitude: 463
	},
	{
		zip: '80047',
		name: 'San Giuseppe Vesuviano',
		province: 'NA',
		altitude: 101
	},
	{
		zip: '06016',
		name: 'San Giustino',
		province: 'PG',
		altitude: 336
	},
	{
		zip: '10090',
		name: 'San Giusto Canavese',
		province: 'TO',
		altitude: 264
	},
	{
		zip: '50060',
		name: 'San Godenzo',
		province: 'FI',
		altitude: 404
	},
	{
		zip: '84020',
		name: 'San Gregorio Magno',
		province: 'SA',
		altitude: 475
	},
	{
		zip: '81010',
		name: 'San Gregorio Matese',
		province: 'CE',
		altitude: 765
	},
	{
		zip: '89853',
		name: 'San Gregorio d\'\'Ippona',
		province: 'VV',
		altitude: 402
	},
	{
		zip: '00010',
		name: 'San Gregorio da Sassola',
		province: 'RM',
		altitude: 420
	},
	{
		zip: '95027',
		name: 'San Gregorio di Catania',
		province: 'CT',
		altitude: 321
	},
	{
		zip: '32030',
		name: 'San Gregorio nelle Alpi',
		province: 'BL',
		altitude: 526
	},
	{
		zip: '40068',
		name: 'San Lazzaro di Savena',
		province: 'BO',
		altitude: 62
	},
	{
		zip: '47865',
		name: 'San Leo',
		province: 'RN',
		altitude: 589
	},
	{
		zip: '33040',
		name: 'San Leonardo',
		province: 'UD',
		altitude: 168
	},
	{
		zip: '39015',
		name: 'San Leonardo in Passiria',
		province: 'BZ',
		altitude: 689
	},
	{
		zip: '82010',
		name: 'San Leucio del Sannio',
		province: 'BN',
		altitude: 369
	},
	{
		zip: '82030',
		name: 'San Lorenzello',
		province: 'BN',
		altitude: 250
	},
	{
		zip: '89069',
		name: 'San Lorenzo',
		province: 'RC',
		altitude: 787
	},
	{
		zip: '87070',
		name: 'San Lorenzo Bellizzi',
		province: 'CS',
		altitude: 830
	},
	{
		zip: '38070',
		name: 'San Lorenzo Dorsino',
		province: 'TN',
		altitude: 758
	},
	{
		zip: '34070',
		name: 'San Lorenzo Isontino',
		province: 'GO',
		altitude: 54
	},
	{
		zip: '82034',
		name: 'San Lorenzo Maggiore',
		province: 'BN',
		altitude: 330
	},
	{
		zip: '01020',
		name: 'San Lorenzo Nuovo',
		province: 'VT',
		altitude: 503
	},
	{
		zip: '18017',
		name: 'San Lorenzo al Mare',
		province: 'IM',
		altitude: 6
	},
	{
		zip: '87040',
		name: 'San Lorenzo del Vallo',
		province: 'CS',
		altitude: 330
	},
	{
		zip: '39030',
		name: 'San Lorenzo di Sebato',
		province: 'BZ',
		altitude: 810
	},
	{
		zip: '61047',
		name: 'San Lorenzo in Campo',
		province: 'PU',
		altitude: 209
	},
	{
		zip: '89030',
		name: 'San Luca',
		province: 'RC',
		altitude: 250
	},
	{
		zip: '87038',
		name: 'San Lucido',
		province: 'CS',
		altitude: 56
	},
	{
		zip: '82034',
		name: 'San Lupo',
		province: 'BN',
		altitude: 500
	},
	{
		zip: '84090',
		name: 'San Mango Piemonte',
		province: 'SA',
		altitude: 210
	},
	{
		zip: '88040',
		name: 'San Mango d\'\'Aquino',
		province: 'CZ',
		altitude: 468
	},
	{
		zip: '83050',
		name: 'San Mango sul Calore',
		province: 'AV',
		altitude: 470
	},
	{
		zip: '81030',
		name: 'San Marcellino',
		province: 'CE',
		altitude: 36
	},
	{
		zip: '60030',
		name: 'San Marcello',
		province: 'AN',
		altitude: 231
	},
	{
		zip: '51028',
		name: 'San Marcello Piteglio',
		province: 'PT',
		altitude: 340
	},
	{
		zip: '87018',
		name: 'San Marco Argentano',
		province: 'CS',
		altitude: 426
	},
	{
		zip: '81020',
		name: 'San Marco Evangelista',
		province: 'CE',
		altitude: 46
	},
	{
		zip: '98070',
		name: 'San Marco d\'\'Alunzio',
		province: 'ME',
		altitude: 548
	},
	{
		zip: '82029',
		name: 'San Marco dei Cavoti',
		province: 'BN',
		altitude: 695
	},
	{
		zip: '71014',
		name: 'San Marco in Lamis',
		province: 'FG',
		altitude: 550
	},
	{
		zip: '71030',
		name: 'San Marco la Catola',
		province: 'FG',
		altitude: 683
	},
	{
		zip: '14010',
		name: 'San Martino Alfieri',
		province: 'AT',
		altitude: 257
	},
	{
		zip: '37036',
		name: 'San Martino Buon Albergo',
		province: 'VR',
		altitude: 45
	},
	{
		zip: '10010',
		name: 'San Martino Canavese',
		province: 'TO',
		altitude: 385
	},
	{
		zip: '82010',
		name: 'San Martino Sannita',
		province: 'BN',
		altitude: 450
	},
	{
		zip: '27028',
		name: 'San Martino Siccomario',
		province: 'PV',
		altitude: 63
	},
	{
		zip: '83018',
		name: 'San Martino Valle Caudina',
		province: 'AV',
		altitude: 315
	},
	{
		zip: '33098',
		name: 'San Martino al Tagliamento',
		province: 'PN',
		altitude: 71
	},
	{
		zip: '85030',
		name: 'San Martino d\'\'Agri',
		province: 'PZ',
		altitude: 666
	},
	{
		zip: '46010',
		name: 'San Martino dall\'\'Argine',
		province: 'MN',
		altitude: 29
	},
	{
		zip: '26040',
		name: 'San Martino del Lago',
		province: 'CR',
		altitude: 31
	},
	{
		zip: '87010',
		name: 'San Martino di Finita',
		province: 'CS',
		altitude: 550
	},
	{
		zip: '35018',
		name: 'San Martino di Lupari',
		province: 'PD',
		altitude: 40
	},
	{
		zip: '45030',
		name: 'San Martino di Venezze',
		province: 'RO',
		altitude: 6
	},
	{
		zip: '39030',
		name: 'San Martino in Badia',
		province: 'BZ',
		altitude: 1127
	},
	{
		zip: '39010',
		name: 'San Martino in Passiria',
		province: 'BZ',
		altitude: 597
	},
	{
		zip: '86046',
		name: 'San Martino in Pensilis',
		province: 'CB',
		altitude: 281
	},
	{
		zip: '42018',
		name: 'San Martino in Rio',
		province: 'RE',
		altitude: 36
	},
	{
		zip: '26817',
		name: 'San Martino in Strada',
		province: 'LO',
		altitude: 73
	},
	{
		zip: '66010',
		name: 'San Martino sulla Marrucina',
		province: 'CH',
		altitude: 465
	},
	{
		zip: '14050',
		name: 'San Marzano Oliveto',
		province: 'AT',
		altitude: 301
	},
	{
		zip: '74020',
		name: 'San Marzano di San Giuseppe',
		province: 'TA',
		altitude: 134
	},
	{
		zip: '84010',
		name: 'San Marzano sul Sarno',
		province: 'SA',
		altitude: 20
	},
	{
		zip: '86027',
		name: 'San Massimo',
		province: 'CB',
		altitude: 630
	},
	{
		zip: '10077',
		name: 'San Maurizio Canavese',
		province: 'TO',
		altitude: 317
	},
	{
		zip: '28017',
		name: 'San Maurizio d\'\'Opaglio',
		province: 'NO',
		altitude: 370
	},
	{
		zip: '90010',
		name: 'San Mauro Castelverde',
		province: 'PA',
		altitude: 1050
	},
	{
		zip: '84070',
		name: 'San Mauro Cilento',
		province: 'SA',
		altitude: 560
	},
	{
		zip: '75010',
		name: 'San Mauro Forte',
		province: 'MT',
		altitude: 540
	},
	{
		zip: '88831',
		name: 'San Mauro Marchesato',
		province: 'KR',
		altitude: 289
	},
	{
		zip: '47030',
		name: 'San Mauro Pascoli',
		province: 'FC',
		altitude: 21
	},
	{
		zip: '10099',
		name: 'San Mauro Torinese',
		province: 'TO',
		altitude: 320
	},
	{
		zip: '37030',
		name: 'San Mauro di Saline',
		province: 'VR',
		altitude: 804
	},
	{
		zip: '84070',
		name: 'San Mauro la Bruca',
		province: 'SA',
		altitude: 450
	},
	{
		zip: '12080',
		name: 'San Michele Mondovi',
		province: 'CN',
		altitude: 444
	},
	{
		zip: '72018',
		name: 'San Michele Salentino',
		province: 'BR',
		altitude: 153
	},
	{
		zip: '30028',
		name: 'San Michele al Tagliamento',
		province: 'VE',
		altitude: 7
	},
	{
		zip: '38098',
		name: 'San Michele all\'\'Adige',
		province: 'TN',
		altitude: 228
	},
	{
		zip: '95040',
		name: 'San Michele di Ganzaria',
		province: 'CT',
		altitude: 490
	},
	{
		zip: '83020',
		name: 'San Michele di Serino',
		province: 'AV',
		altitude: 364
	},
	{
		zip: '56028',
		name: 'San Miniato',
		province: 'PI',
		altitude: 190
	},
	{
		zip: '82010',
		name: 'San Nazzaro',
		province: 'BN',
		altitude: 495
	},
	{
		zip: '28060',
		name: 'San Nazzaro Sesia',
		province: 'NO',
		altitude: 153
	},
	{
		zip: '22010',
		name: 'San Nazzaro Val Cavargna',
		province: 'CO',
		altitude: 995
	},
	{
		zip: '71015',
		name: 'San Nicandro Garganico',
		province: 'FG',
		altitude: 224
	},
	{
		zip: '87020',
		name: 'San Nicola Arcella',
		province: 'CS',
		altitude: 110
	},
	{
		zip: '83050',
		name: 'San Nicola Baronia',
		province: 'AV',
		altitude: 610
	},
	{
		zip: '82010',
		name: 'San Nicola Manfredi',
		province: 'BN',
		altitude: 450
	},
	{
		zip: '89821',
		name: 'San Nicola da Crissa',
		province: 'VV',
		altitude: 518
	},
	{
		zip: '88817',
		name: 'San Nicola dell\'\'Alto',
		province: 'KR',
		altitude: 579
	},
	{
		zip: '81020',
		name: 'San Nicola la Strada',
		province: 'CE',
		altitude: 58
	},
	{
		zip: '09040',
		name: 'San Nicolo Gerrei',
		province: 'SU',
		altitude: 365
	},
	{
		zip: '09097',
		name: 'San Nicolo d\'\'Arcidano',
		province: 'OR',
		altitude: 13
	},
	{
		zip: '32040',
		name: 'San Nicolo di Comelico',
		province: 'BL',
		altitude: 1061
	},
	{
		zip: '39010',
		name: 'San Pancrazio',
		province: 'BZ',
		altitude: 735
	},
	{
		zip: '72026',
		name: 'San Pancrazio Salentino',
		province: 'BR',
		altitude: 62
	},
	{
		zip: '25020',
		name: 'San Paolo',
		province: 'BS',
		altitude: 72
	},
	{
		zip: '85030',
		name: 'San Paolo Albanese',
		province: 'PZ',
		altitude: 800
	},
	{
		zip: '80030',
		name: 'San Paolo Bel Sito',
		province: 'NA',
		altitude: 50
	},
	{
		zip: '14010',
		name: 'San Paolo Solbrito',
		province: 'AT',
		altitude: 265
	},
	{
		zip: '24060',
		name: 'San Paolo d\'\'Argon',
		province: 'BG',
		altitude: 255
	},
	{
		zip: '71010',
		name: 'San Paolo di Civitate',
		province: 'FG',
		altitude: 187
	},
	{
		zip: '60038',
		name: 'San Paolo di Jesi',
		province: 'AN',
		altitude: 224
	},
	{
		zip: '24016',
		name: 'San Pellegrino Terme',
		province: 'BG',
		altitude: 358
	},
	{
		zip: '98045',
		name: 'San Pier Niceto',
		province: 'ME',
		altitude: 260
	},
	{
		zip: '34070',
		name: 'San Pier d\'\'Isonzo',
		province: 'GO',
		altitude: 18
	},
	{
		zip: '98068',
		name: 'San Piero Patti',
		province: 'ME',
		altitude: 448
	},
	{
		zip: '88040',
		name: 'San Pietro Apostolo',
		province: 'CZ',
		altitude: 750
	},
	{
		zip: '86088',
		name: 'San Pietro Avellana',
		province: 'IS',
		altitude: 960
	},
	{
		zip: '95030',
		name: 'San Pietro Clarenza',
		province: 'CT',
		altitude: 463
	},
	{
		zip: '81049',
		name: 'San Pietro Infine',
		province: 'CE',
		altitude: 140
	},
	{
		zip: '28060',
		name: 'San Pietro Mosezzo',
		province: 'NO',
		altitude: 155
	},
	{
		zip: '36070',
		name: 'San Pietro Mussolino',
		province: 'VI',
		altitude: 270
	},
	{
		zip: '10060',
		name: 'San Pietro Val Lemina',
		province: 'TO',
		altitude: 451
	},
	{
		zip: '72027',
		name: 'San Pietro Vernotico',
		province: 'BR',
		altitude: 36
	},
	{
		zip: '35020',
		name: 'San Pietro Viminario',
		province: 'PD',
		altitude: 7
	},
	{
		zip: '88025',
		name: 'San Pietro a Maida',
		province: 'CZ',
		altitude: 355
	},
	{
		zip: '33049',
		name: 'San Pietro al Natisone',
		province: 'UD',
		altitude: 175
	},
	{
		zip: '84030',
		name: 'San Pietro al Tanagro',
		province: 'SA',
		altitude: 450
	},
	{
		zip: '32040',
		name: 'San Pietro di Cadore',
		province: 'BL',
		altitude: 1100
	},
	{
		zip: '89020',
		name: 'San Pietro di Carida',
		province: 'RC',
		altitude: 325
	},
	{
		zip: '31020',
		name: 'San Pietro di Feletto',
		province: 'TV',
		altitude: 221
	},
	{
		zip: '37050',
		name: 'San Pietro di Morubio',
		province: 'VR',
		altitude: 19
	},
	{
		zip: '87030',
		name: 'San Pietro in Amantea',
		province: 'CS',
		altitude: 374
	},
	{
		zip: '37029',
		name: 'San Pietro in Cariano',
		province: 'VR',
		altitude: 151
	},
	{
		zip: '40018',
		name: 'San Pietro in Casale',
		province: 'BO',
		altitude: 17
	},
	{
		zip: '29010',
		name: 'San Pietro in Cerro',
		province: 'PC',
		altitude: 44
	},
	{
		zip: '35010',
		name: 'San Pietro in Gu',
		province: 'PD',
		altitude: 45
	},
	{
		zip: '87047',
		name: 'San Pietro in Guarano',
		province: 'CS',
		altitude: 640
	},
	{
		zip: '73010',
		name: 'San Pietro in Lama',
		province: 'LE',
		altitude: 43
	},
	{
		zip: '67020',
		name: 'San Pio delle Camere',
		province: 'AQ',
		altitude: 830
	},
	{
		zip: '86020',
		name: 'San Polo Matese',
		province: 'CB',
		altitude: 751
	},
	{
		zip: '42020',
		name: 'San Polo d\'\'Enza',
		province: 'RE',
		altitude: 166
	},
	{
		zip: '00010',
		name: 'San Polo dei Cavalieri',
		province: 'RM',
		altitude: 651
	},
	{
		zip: '31020',
		name: 'San Polo di Piave',
		province: 'TV',
		altitude: 28
	},
	{
		zip: '10080',
		name: 'San Ponso',
		province: 'TO',
		altitude: 347
	},
	{
		zip: '41039',
		name: 'San Possidonio',
		province: 'MO',
		altitude: 20
	},
	{
		zip: '81016',
		name: 'San Potito Sannitico',
		province: 'CE',
		altitude: 230
	},
	{
		zip: '83050',
		name: 'San Potito Ultra',
		province: 'AV',
		altitude: 517
	},
	{
		zip: '81054',
		name: 'San Prisco',
		province: 'CE',
		altitude: 48
	},
	{
		zip: '89020',
		name: 'San Procopio',
		province: 'RC',
		altitude: 352
	},
	{
		zip: '41030',
		name: 'San Prospero',
		province: 'MO',
		altitude: 22
	},
	{
		zip: '53027',
		name: 'San Quirico d\'\'Orcia',
		province: 'SI',
		altitude: 409
	},
	{
		zip: '33080',
		name: 'San Quirino',
		province: 'PN',
		altitude: 116
	},
	{
		zip: '10090',
		name: 'San Raffaele Cimena',
		province: 'TO',
		altitude: 195
	},
	{
		zip: '89050',
		name: 'San Roberto',
		province: 'RC',
		altitude: 280
	},
	{
		zip: '26865',
		name: 'San Rocco al Porto',
		province: 'LO',
		altitude: 47
	},
	{
		zip: '55038',
		name: 'San Romano in Garfagnana',
		province: 'LU',
		altitude: 555
	},
	{
		zip: '84030',
		name: 'San Rufo',
		province: 'SA',
		altitude: 640
	},
	{
		zip: '15046',
		name: 'San Salvatore Monferrato',
		province: 'AL',
		altitude: 205
	},
	{
		zip: '82030',
		name: 'San Salvatore Telesino',
		province: 'BN',
		altitude: 955
	},
	{
		zip: '98070',
		name: 'San Salvatore di Fitalia',
		province: 'ME',
		altitude: 603
	},
	{
		zip: '66050',
		name: 'San Salvo',
		province: 'CH',
		altitude: 100
	},
	{
		zip: '15056',
		name: 'San Sebastiano Curone',
		province: 'AL',
		altitude: 342
	},
	{
		zip: '80040',
		name: 'San Sebastiano al Vesuvio',
		province: 'NA',
		altitude: 175
	},
	{
		zip: '10020',
		name: 'San Sebastiano da Po',
		province: 'TO',
		altitude: 370
	},
	{
		zip: '43017',
		name: 'San Secondo Parmense',
		province: 'PR',
		altitude: 38
	},
	{
		zip: '10060',
		name: 'San Secondo di Pinerolo',
		province: 'TO',
		altitude: 413
	},
	{
		zip: '85030',
		name: 'San Severino Lucano',
		province: 'PZ',
		altitude: 877
	},
	{
		zip: '62027',
		name: 'San Severino Marche',
		province: 'MC',
		altitude: 236
	},
	{
		zip: '71016',
		name: 'San Severo',
		province: 'FG',
		altitude: 86
	},
	{
		zip: '22010',
		name: 'San Siro',
		province: 'CO',
		altitude: 216
	},
	{
		zip: '83050',
		name: 'San Sossio Baronia',
		province: 'AV',
		altitude: 650
	},
	{
		zip: '88060',
		name: 'San Sostene',
		province: 'CZ',
		altitude: 470
	},
	{
		zip: '87010',
		name: 'San Sosti',
		province: 'CS',
		altitude: 363
	},
	{
		zip: '09026',
		name: 'San Sperate',
		province: 'SU',
		altitude: 41
	},
	{
		zip: '30029',
		name: 'San Stino di Livenza',
		province: 'VE',
		altitude: 6
	},
	{
		zip: '81050',
		name: 'San Tammaro',
		province: 'CE',
		altitude: 22
	},
	{
		zip: '32020',
		name: 'San Tomaso Agordino',
		province: 'BL',
		altitude: 1082
	},
	{
		zip: '84010',
		name: 'San Valentino Torio',
		province: 'SA',
		altitude: 22
	},
	{
		zip: '65020',
		name: 'San Valentino in Abruzzo Citeriore',
		province: 'PE',
		altitude: 450
	},
	{
		zip: '05010',
		name: 'San Venanzo',
		province: 'TR',
		altitude: 465
	},
	{
		zip: '31020',
		name: 'San Vendemiano',
		province: 'TV',
		altitude: 46
	},
	{
		zip: '09070',
		name: 'San Vero Milis',
		province: 'OR',
		altitude: 10
	},
	{
		zip: '57027',
		name: 'San Vincenzo',
		province: 'LI',
		altitude: 5
	},
	{
		zip: '87030',
		name: 'San Vincenzo La Costa',
		province: 'CS',
		altitude: 493
	},
	{
		zip: '67050',
		name: 'San Vincenzo Valle Roveto',
		province: 'AQ',
		altitude: 388
	},
	{
		zip: '80030',
		name: 'San Vitaliano',
		province: 'NA',
		altitude: 30
	},
	{
		zip: '09040',
		name: 'San Vito',
		province: 'SU',
		altitude: 10
	},
	{
		zip: '66038',
		name: 'San Vito Chietino',
		province: 'CH',
		altitude: 122
	},
	{
		zip: '91010',
		name: 'San Vito Lo Capo',
		province: 'TP',
		altitude: 6
	},
	{
		zip: '00030',
		name: 'San Vito Romano',
		province: 'RM',
		altitude: 655
	},
	{
		zip: '33078',
		name: 'San Vito al Tagliamento',
		province: 'PN',
		altitude: 30
	},
	{
		zip: '33050',
		name: 'San Vito al Torre',
		province: 'UD',
		altitude: 17
	},
	{
		zip: '72019',
		name: 'San Vito dei Normanni',
		province: 'BR',
		altitude: 108
	},
	{
		zip: '32046',
		name: 'San Vito di Cadore',
		province: 'BL',
		altitude: 1011
	},
	{
		zip: '33030',
		name: 'San Vito di Fagagna',
		province: 'UD',
		altitude: 135
	},
	{
		zip: '36030',
		name: 'San Vito di Leguzzano',
		province: 'VI',
		altitude: 158
	},
	{
		zip: '88067',
		name: 'San Vito sullo Ionio',
		province: 'CZ',
		altitude: 404
	},
	{
		zip: '20028',
		name: 'San Vittore Olona',
		province: 'MI',
		altitude: 197
	},
	{
		zip: '03040',
		name: 'San Vittore del Lazio',
		province: 'FR',
		altitude: 210
	},
	{
		zip: '25010',
		name: 'San Zeno Naviglio',
		province: 'BS',
		altitude: 112
	},
	{
		zip: '37010',
		name: 'San Zeno di Montagna',
		province: 'VR',
		altitude: 680
	},
	{
		zip: '20070',
		name: 'San Zenone al Lambro',
		province: 'MI',
		altitude: 83
	},
	{
		zip: '27010',
		name: 'San Zenone al Po',
		province: 'PV',
		altitude: 59
	},
	{
		zip: '31020',
		name: 'San Zenone degli Ezzelini',
		province: 'TV',
		altitude: 117
	},
	{
		zip: '73030',
		name: 'Sanarica',
		province: 'LE',
		altitude: 78
	},
	{
		zip: '13876',
		name: 'Sandigliano',
		province: 'BI',
		altitude: 323
	},
	{
		zip: '36066',
		name: 'Sandrigo',
		province: 'VI',
		altitude: 64
	},
	{
		zip: '12030',
		name: 'Sanfront',
		province: 'CN',
		altitude: 490
	},
	{
		zip: '12040',
		name: 'Sanfre',
		province: 'CN',
		altitude: 272
	},
	{
		zip: '10090',
		name: 'Sangano',
		province: 'TO',
		altitude: 340
	},
	{
		zip: '21038',
		name: 'Sangiano',
		province: 'VA',
		altitude: 228
	},
	{
		zip: '87020',
		name: 'Sangineto',
		province: 'CS',
		altitude: 275
	},
	{
		zip: '37058',
		name: 'Sanguinetto',
		province: 'VR',
		altitude: 19
	},
	{
		zip: '09025',
		name: 'Sanluri',
		province: 'SU',
		altitude: 135
	},
	{
		zip: '27039',
		name: 'Sannazzaro de Burgondi',
		province: 'PV',
		altitude: 87
	},
	{
		zip: '70028',
		name: 'Sannicandro di Bari',
		province: 'BA',
		altitude: 183
	},
	{
		zip: '73017',
		name: 'Sannicola',
		province: 'LE',
		altitude: 75
	},
	{
		zip: '18038',
		name: 'Sanremo',
		province: 'IM',
		altitude: 15
	},
	{
		zip: '52037',
		name: 'Sansepolcro',
		province: 'AR',
		altitude: 330
	},
	{
		zip: '86070',
		name: 'Sant\'\'Agapito',
		province: 'IS',
		altitude: 565
	},
	{
		zip: '40019',
		name: 'Sant\'\'Agata Bolognese',
		province: 'BO',
		altitude: 21
	},
	{
		zip: '47866',
		name: 'Sant\'\'Agata Feltria',
		province: 'RN',
		altitude: 607
	},
	{
		zip: '15050',
		name: 'Sant\'\'Agata Fossili',
		province: 'AL',
		altitude: 425
	},
	{
		zip: '82019',
		name: 'Sant\'\'Agata de Goti',
		province: 'BN',
		altitude: 156
	},
	{
		zip: '89030',
		name: 'Sant\'\'Agata del Bianco',
		province: 'RC',
		altitude: 405
	},
	{
		zip: '87010',
		name: 'Sant\'\'Agata di Esaro',
		province: 'CS',
		altitude: 461
	},
	{
		zip: '98076',
		name: 'Sant\'\'Agata di Militello',
		province: 'ME',
		altitude: 30
	},
	{
		zip: '71028',
		name: 'Sant\'\'Agata di Puglia',
		province: 'FG',
		altitude: 794
	},
	{
		zip: '95030',
		name: 'Sant\'\'Agata li Battiati',
		province: 'CT',
		altitude: 263
	},
	{
		zip: '48020',
		name: 'Sant\'\'Agata sul Santerno',
		province: 'RA',
		altitude: 14
	},
	{
		zip: '80065',
		name: 'Sant\'\'Agnello',
		province: 'NA',
		altitude: 67
	},
	{
		zip: '12040',
		name: 'Sant\'\'Albano Stura',
		province: 'CN',
		altitude: 378
	},
	{
		zip: '98030',
		name: 'Sant\'\'Alessio Siculo',
		province: 'ME',
		altitude: 15
	},
	{
		zip: '27016',
		name: 'Sant\'\'Alessio con Vialone',
		province: 'PV',
		altitude: 83
	},
	{
		zip: '89050',
		name: 'Sant\'\'Alessio in Aspromonte',
		province: 'RC',
		altitude: 567
	},
	{
		zip: '95010',
		name: 'Sant\'\'Alfio',
		province: 'CT',
		altitude: 531
	},
	{
		zip: '10057',
		name: 'Sant\'\'Ambrogio di Torino',
		province: 'TO',
		altitude: 356
	},
	{
		zip: '37015',
		name: 'Sant\'\'Ambrogio di Valpolicella',
		province: 'VR',
		altitude: 174
	},
	{
		zip: '03040',
		name: 'Sant\'\'Ambrogio sul Garigliano',
		province: 'FR',
		altitude: 137
	},
	{
		zip: '80048',
		name: 'Sant\'\'Anastasia',
		province: 'NA',
		altitude: 150
	},
	{
		zip: '06040',
		name: 'Sant\'\'Anatolia di Narco',
		province: 'PG',
		altitude: 328
	},
	{
		zip: '88060',
		name: 'Sant\'\'Andrea Apostolo dello Ionio',
		province: 'CZ',
		altitude: 330
	},
	{
		zip: '09040',
		name: 'Sant\'\'Andrea Frius',
		province: 'SU',
		altitude: 280
	},
	{
		zip: '03040',
		name: 'Sant\'\'Andrea del Garigliano',
		province: 'FR',
		altitude: 176
	},
	{
		zip: '83053',
		name: 'Sant\'\'Andrea di Conza',
		province: 'AV',
		altitude: 660
	},
	{
		zip: '85050',
		name: 'Sant\'\'Angelo Le Fratte',
		province: 'PZ',
		altitude: 560
	},
	{
		zip: '86020',
		name: 'Sant\'\'Angelo Limosano',
		province: 'CB',
		altitude: 894
	},
	{
		zip: '26866',
		name: 'Sant\'\'Angelo Lodigiano',
		province: 'LO',
		altitude: 73
	},
	{
		zip: '27030',
		name: 'Sant\'\'Angelo Lomellina',
		province: 'PV',
		altitude: 112
	},
	{
		zip: '92020',
		name: 'Sant\'\'Angelo Muxaro',
		province: 'AG',
		altitude: 335
	},
	{
		zip: '00010',
		name: 'Sant\'\'Angelo Romano',
		province: 'RM',
		altitude: 400
	},
	{
		zip: '82010',
		name: 'Sant\'\'Angelo a Cupolo',
		province: 'BN',
		altitude: 459
	},
	{
		zip: '84027',
		name: 'Sant\'\'Angelo a Fasanella',
		province: 'SA',
		altitude: 520
	},
	{
		zip: '83010',
		name: 'Sant\'\'Angelo a Scala',
		province: 'AV',
		altitude: 582
	},
	{
		zip: '83050',
		name: 'Sant\'\'Angelo all\'\'Esca',
		province: 'AV',
		altitude: 460
	},
	{
		zip: '81017',
		name: 'Sant\'\'Angelo d\'\'Alife',
		province: 'CE',
		altitude: 385
	},
	{
		zip: '83054',
		name: 'Sant\'\'Angelo dei Lombardi',
		province: 'AV',
		altitude: 870
	},
	{
		zip: '86080',
		name: 'Sant\'\'Angelo del Pesco',
		province: 'IS',
		altitude: 805
	},
	{
		zip: '98060',
		name: 'Sant\'\'Angelo di Brolo',
		province: 'ME',
		altitude: 314
	},
	{
		zip: '35020',
		name: 'Sant\'\'Angelo di Piove di Sacco',
		province: 'PD',
		altitude: 8
	},
	{
		zip: '62020',
		name: 'Sant\'\'Angelo in Pontano',
		province: 'MC',
		altitude: 473
	},
	{
		zip: '61048',
		name: 'Sant\'\'Angelo in Vado',
		province: 'PU',
		altitude: 359
	},
	{
		zip: '09010',
		name: 'Sant\'\'Anna Arresi',
		province: 'SU',
		altitude: 77
	},
	{
		zip: '37020',
		name: 'Sant\'\'Anna d\'\'Alfaedo',
		province: 'VR',
		altitude: 939
	},
	{
		zip: '80029',
		name: 'Sant\'\'Antimo',
		province: 'NA',
		altitude: 58
	},
	{
		zip: '09017',
		name: 'Sant\'\'Antioco',
		province: 'SU',
		altitude: 7
	},
	{
		zip: '10050',
		name: 'Sant\'\'Antonino di Susa',
		province: 'TO',
		altitude: 380
	},
	{
		zip: '80057',
		name: 'Sant\'\'Antonio Abate',
		province: 'NA',
		altitude: 20
	},
	{
		zip: '07030',
		name: 'Sant\'\'Antonio di Gallura',
		province: 'SS',
		altitude: 354
	},
	{
		zip: '03048',
		name: 'Sant\'\'Apollinare',
		province: 'FR',
		altitude: 57
	},
	{
		zip: '85037',
		name: 'Sant\'\'Arcangelo',
		province: 'PZ',
		altitude: 388
	},
	{
		zip: '82021',
		name: 'Sant\'\'Arcangelo Trimonte',
		province: 'BN',
		altitude: 363
	},
	{
		zip: '81030',
		name: 'Sant\'\'Arpino',
		province: 'CE',
		altitude: 43
	},
	{
		zip: '84037',
		name: 'Sant\'\'Arsenio',
		province: 'SA',
		altitude: 463
	},
	{
		zip: '64016',
		name: 'Sant\'\'Egidio alla Vibrata',
		province: 'TE',
		altitude: 239
	},
	{
		zip: '84010',
		name: 'Sant\'\'Egidio del Monte Albino',
		province: 'SA',
		altitude: 60
	},
	{
		zip: '35040',
		name: 'Sant\'\'Elena',
		province: 'PD',
		altitude: 8
	},
	{
		zip: '86099',
		name: 'Sant\'\'Elena Sannita',
		province: 'IS',
		altitude: 780
	},
	{
		zip: '03049',
		name: 'Sant\'\'Elia Fiumerapido',
		province: 'FR',
		altitude: 120
	},
	{
		zip: '86048',
		name: 'Sant\'\'Elia a Pianisi',
		province: 'CB',
		altitude: 666
	},
	{
		zip: '63811',
		name: 'Sant\'\'Elpidio a Mare',
		province: 'FM',
		altitude: 251
	},
	{
		zip: '65020',
		name: 'Sant\'\'Eufemia a Maiella',
		province: 'PE',
		altitude: 878
	},
	{
		zip: '89027',
		name: 'Sant\'\'Eufemia d\'\'Aspromonte',
		province: 'RC',
		altitude: 450
	},
	{
		zip: '67020',
		name: 'Sant\'\'Eusanio Forconese',
		province: 'AQ',
		altitude: 591
	},
	{
		zip: '66037',
		name: 'Sant\'\'Eusanio del Sangro',
		province: 'CH',
		altitude: 200
	},
	{
		zip: '42049',
		name: 'Sant\'\'Ilario d\'\'Enza',
		province: 'RE',
		altitude: 59
	},
	{
		zip: '89040',
		name: 'Sant\'\'Ilario dello Ionio',
		province: 'RC',
		altitude: 128
	},
	{
		zip: '61040',
		name: 'Sant\'\'Ippolito',
		province: 'PU',
		altitude: 246
	},
	{
		zip: '16010',
		name: 'Sant\'\'Olcese',
		province: 'GE',
		altitude: 155
	},
	{
		zip: '64027',
		name: 'Sant\'\'Omero',
		province: 'TE',
		altitude: 209
	},
	{
		zip: '24038',
		name: 'Sant\'\'Omobono Terme',
		province: 'BG',
		altitude: 427
	},
	{
		zip: '89843',
		name: 'Sant\'\'Onofrio',
		province: 'VV',
		altitude: 350
	},
	{
		zip: '00060',
		name: 'Sant\'\'Oreste',
		province: 'RM',
		altitude: 420
	},
	{
		zip: '38050',
		name: 'Sant\'\'Orsola Terme',
		province: 'TN',
		altitude: 925
	},
	{
		zip: '35040',
		name: 'Sant\'\'Urbano',
		province: 'PD',
		altitude: 9
	},
	{
		zip: '24010',
		name: 'Santa Brigida',
		province: 'BG',
		altitude: 805
	},
	{
		zip: '87010',
		name: 'Santa Caterina Albanese',
		province: 'CS',
		altitude: 472
	},
	{
		zip: '93018',
		name: 'Santa Caterina Villarmosa',
		province: 'CL',
		altitude: 650
	},
	{
		zip: '88060',
		name: 'Santa Caterina dello Ionio',
		province: 'CZ',
		altitude: 459
	},
	{
		zip: '73020',
		name: 'Santa Cesarea Terme',
		province: 'LE',
		altitude: 25
	},
	{
		zip: '90030',
		name: 'Santa Cristina Gela',
		province: 'PA',
		altitude: 674
	},
	{
		zip: '39047',
		name: 'Santa Cristina Valgardena',
		province: 'BZ',
		altitude: 1428
	},
	{
		zip: '89056',
		name: 'Santa Cristina d\'\'Aspromonte',
		province: 'RC',
		altitude: 514
	},
	{
		zip: '27010',
		name: 'Santa Cristina e Bissone',
		province: 'PV',
		altitude: 71
	},
	{
		zip: '97017',
		name: 'Santa Croce Camerina',
		province: 'RG',
		altitude: 87
	},
	{
		zip: '82020',
		name: 'Santa Croce del Sannio',
		province: 'BN',
		altitude: 689
	},
	{
		zip: '86047',
		name: 'Santa Croce di Magliano',
		province: 'CB',
		altitude: 608
	},
	{
		zip: '56029',
		name: 'Santa Croce sull\'\'Arno',
		province: 'PI',
		altitude: 18
	},
	{
		zip: '87020',
		name: 'Santa Domenica Talao',
		province: 'CS',
		altitude: 304
	},
	{
		zip: '98030',
		name: 'Santa Domenica Vittoria',
		province: 'ME',
		altitude: 1027
	},
	{
		zip: '92020',
		name: 'Santa Elisabetta',
		province: 'AG',
		altitude: 457
	},
	{
		zip: '58037',
		name: 'Santa Fiora',
		province: 'GR',
		altitude: 687
	},
	{
		zip: '90017',
		name: 'Santa Flavia',
		province: 'PA',
		altitude: 55
	},
	{
		zip: '27046',
		name: 'Santa Giuletta',
		province: 'PV',
		altitude: 78
	},
	{
		zip: '09096',
		name: 'Santa Giusta',
		province: 'OR',
		altitude: 10
	},
	{
		zip: '32035',
		name: 'Santa Giustina',
		province: 'BL',
		altitude: 306
	},
	{
		zip: '35010',
		name: 'Santa Giustina in Colle',
		province: 'PD',
		altitude: 24
	},
	{
		zip: '56040',
		name: 'Santa Luce',
		province: 'PI',
		altitude: 200
	},
	{
		zip: '98046',
		name: 'Santa Lucia del Mela',
		province: 'ME',
		altitude: 215
	},
	{
		zip: '31025',
		name: 'Santa Lucia di Piave',
		province: 'TV',
		altitude: 55
	},
	{
		zip: '83020',
		name: 'Santa Lucia di Serino',
		province: 'AV',
		altitude: 400
	},
	{
		zip: '16038',
		name: 'Santa Margherita Ligure',
		province: 'GE',
		altitude: 13
	},
	{
		zip: '92018',
		name: 'Santa Margherita di Belice',
		province: 'AG',
		altitude: 400
	},
	{
		zip: '27050',
		name: 'Santa Margherita di Staffora',
		province: 'PV',
		altitude: 550
	},
	{
		zip: '81055',
		name: 'Santa Maria Capua Vetere',
		province: 'CE',
		altitude: 36
	},
	{
		zip: '07030',
		name: 'Santa Maria Coghinas',
		province: 'SS',
		altitude: 21
	},
	{
		zip: '23889',
		name: 'Santa Maria Hoe',
		province: 'LC',
		altitude: 371
	},
	{
		zip: '66030',
		name: 'Santa Maria Imbaro',
		province: 'CH',
		altitude: 224
	},
	{
		zip: '28857',
		name: 'Santa Maria Maggiore',
		province: 'VB',
		altitude: 816
	},
	{
		zip: '60030',
		name: 'Santa Maria Nuova',
		province: 'AN',
		altitude: 249
	},
	{
		zip: '56020',
		name: 'Santa Maria a Monte',
		province: 'PI',
		altitude: 56
	},
	{
		zip: '81028',
		name: 'Santa Maria a Vico',
		province: 'CE',
		altitude: 83
	},
	{
		zip: '87020',
		name: 'Santa Maria del Cedro',
		province: 'CS',
		altitude: 110
	},
	{
		zip: '86090',
		name: 'Santa Maria del Molise',
		province: 'IS',
		altitude: 587
	},
	{
		zip: '27047',
		name: 'Santa Maria della Versa',
		province: 'PV',
		altitude: 199
	},
	{
		zip: '95038',
		name: 'Santa Maria di Licodia',
		province: 'CT',
		altitude: 442
	},
	{
		zip: '30036',
		name: 'Santa Maria di Sala',
		province: 'VE',
		altitude: 13
	},
	{
		zip: '80050',
		name: 'Santa Maria la Carita',
		province: 'NA',
		altitude: 16
	},
	{
		zip: '81050',
		name: 'Santa Maria la Fossa',
		province: 'CE',
		altitude: 16
	},
	{
		zip: '33050',
		name: 'Santa Maria la Longa',
		province: 'UD',
		altitude: 38
	},
	{
		zip: '84070',
		name: 'Santa Marina',
		province: 'SA',
		altitude: 415
	},
	{
		zip: '98050',
		name: 'Santa Marina Salina',
		province: 'ME',
		altitude: 25
	},
	{
		zip: '00058',
		name: 'Santa Marinella',
		province: 'RM',
		altitude: 7
	},
	{
		zip: '91029',
		name: 'Santa Ninfa',
		province: 'TP',
		altitude: 475
	},
	{
		zip: '83030',
		name: 'Santa Paolina',
		province: 'AV',
		altitude: 550
	},
	{
		zip: '88832',
		name: 'Santa Severina',
		province: 'KR',
		altitude: 326
	},
	{
		zip: '47018',
		name: 'Santa Sofia',
		province: 'FC',
		altitude: 257
	},
	{
		zip: '87048',
		name: 'Santa Sofia d\'\'Epiro',
		province: 'CS',
		altitude: 558
	},
	{
		zip: '07028',
		name: 'Santa Teresa Gallura',
		province: 'SS',
		altitude: 40
	},
	{
		zip: '98028',
		name: 'Santa Teresa di Riva',
		province: 'ME',
		altitude: 6
	},
	{
		zip: '95010',
		name: 'Santa Venerina',
		province: 'CT',
		altitude: 337
	},
	{
		zip: '12069',
		name: 'Santa Vittoria d\'\'Alba',
		province: 'CN',
		altitude: 346
	},
	{
		zip: '63854',
		name: 'Santa Vittoria in Matenano',
		province: 'FM',
		altitude: 625
	},
	{
		zip: '09010',
		name: 'Santadi',
		province: 'SU',
		altitude: 135
	},
	{
		zip: '47822',
		name: 'Santarcangelo di Romagna',
		province: 'RN',
		altitude: 42
	},
	{
		zip: '67067',
		name: 'Sante Marie',
		province: 'AQ',
		altitude: 850
	},
	{
		zip: '10026',
		name: 'Santena',
		province: 'TO',
		altitude: 237
	},
	{
		zip: '70029',
		name: 'Santeramo in Colle',
		province: 'BA',
		altitude: 489
	},
	{
		zip: '13048',
		name: 'Santhia',
		province: 'VC',
		altitude: 183
	},
	{
		zip: '04020',
		name: 'Santi Cosma e Damiano',
		province: 'LT',
		altitude: 181
	},
	{
		zip: '12058',
		name: 'Santo Stefano Belbo',
		province: 'CN',
		altitude: 170
	},
	{
		zip: '26849',
		name: 'Santo Stefano Lodigiano',
		province: 'LO',
		altitude: 48
	},
	{
		zip: '92020',
		name: 'Santo Stefano Quisquina',
		province: 'AG',
		altitude: 730
	},
	{
		zip: '12040',
		name: 'Santo Stefano Roero',
		province: 'CN',
		altitude: 330
	},
	{
		zip: '20010',
		name: 'Santo Stefano Ticino',
		province: 'MI',
		altitude: 152
	},
	{
		zip: '18010',
		name: 'Santo Stefano al Mare',
		province: 'IM',
		altitude: 7
	},
	{
		zip: '16049',
		name: 'Santo Stefano d\'\'Aveto',
		province: 'GE',
		altitude: 1012
	},
	{
		zip: '83050',
		name: 'Santo Stefano del Sole',
		province: 'AV',
		altitude: 547
	},
	{
		zip: '32045',
		name: 'Santo Stefano di Cadore',
		province: 'BL',
		altitude: 908
	},
	{
		zip: '98077',
		name: 'Santo Stefano di Camastra',
		province: 'ME',
		altitude: 70
	},
	{
		zip: '19037',
		name: 'Santo Stefano di Magra',
		province: 'SP',
		altitude: 50
	},
	{
		zip: '87056',
		name: 'Santo Stefano di Rogliano',
		province: 'CS',
		altitude: 663
	},
	{
		zip: '67020',
		name: 'Santo Stefano di Sessanio',
		province: 'AQ',
		altitude: 1251
	},
	{
		zip: '89057',
		name: 'Santo Stefano in Aspromonte',
		province: 'RC',
		altitude: 714
	},
	{
		zip: '84020',
		name: 'Santomenna',
		province: 'SA',
		altitude: 540
	},
	{
		zip: '03030',
		name: 'Santopadre',
		province: 'FR',
		altitude: 730
	},
	{
		zip: '36014',
		name: 'Santorso',
		province: 'VI',
		altitude: 240
	},
	{
		zip: '09075',
		name: 'Santu Lussurgiu',
		province: 'OR',
		altitude: 503
	},
	{
		zip: '84030',
		name: 'Sanza',
		province: 'SA',
		altitude: 558
	},
	{
		zip: '38010',
		name: 'Sanzeno',
		province: 'TN',
		altitude: 641
	},
	{
		zip: '35020',
		name: 'Saonara',
		province: 'PD',
		altitude: 10
	},
	{
		zip: '98047',
		name: 'Saponara',
		province: 'ME',
		altitude: 160
	},
	{
		zip: '33012',
		name: 'Sappada',
		province: 'UD',
		altitude: 1245
	},
	{
		zip: '84073',
		name: 'Sapri',
		province: 'SA',
		altitude: 5
	},
	{
		zip: '87010',
		name: 'Saracena',
		province: 'CS',
		altitude: 606
	},
	{
		zip: '00020',
		name: 'Saracinesco',
		province: 'RM',
		altitude: 908
	},
	{
		zip: '36030',
		name: 'Sarcedo',
		province: 'VI',
		altitude: 157
	},
	{
		zip: '85040',
		name: 'Sarconi',
		province: 'PZ',
		altitude: 636
	},
	{
		zip: '09030',
		name: 'Sardara',
		province: 'SU',
		altitude: 163
	},
	{
		zip: '15060',
		name: 'Sardigliano',
		province: 'AL',
		altitude: 210
	},
	{
		zip: '36040',
		name: 'Sarego',
		province: 'VI',
		altitude: 42
	},
	{
		zip: '39058',
		name: 'Sarentino',
		province: 'BZ',
		altitude: 967
	},
	{
		zip: '15050',
		name: 'Sarezzano',
		province: 'AL',
		altitude: 300
	},
	{
		zip: '25068',
		name: 'Sarezzo',
		province: 'BS',
		altitude: 273
	},
	{
		zip: '29010',
		name: 'Sarmato',
		province: 'PC',
		altitude: 74
	},
	{
		zip: '31026',
		name: 'Sarmede',
		province: 'TV',
		altitude: 103
	},
	{
		zip: '62028',
		name: 'Sarnano',
		province: 'MC',
		altitude: 539
	},
	{
		zip: '24067',
		name: 'Sarnico',
		province: 'BG',
		altitude: 197
	},
	{
		zip: '84087',
		name: 'Sarno',
		province: 'SA',
		altitude: 30
	},
	{
		zip: '38010',
		name: 'Sarnonico',
		province: 'TN',
		altitude: 963
	},
	{
		zip: '21047',
		name: 'Saronno',
		province: 'VA',
		altitude: 212
	},
	{
		zip: '11010',
		name: 'Sarre',
		province: 'AO',
		altitude: 631
	},
	{
		zip: '09018',
		name: 'Sarroch',
		province: 'CA',
		altitude: 47
	},
	{
		zip: '47027',
		name: 'Sarsina',
		province: 'FC',
		altitude: 243
	},
	{
		zip: '53047',
		name: 'Sarteano',
		province: 'SI',
		altitude: 573
	},
	{
		zip: '27020',
		name: 'Sartirana Lomellina',
		province: 'PV',
		altitude: 100
	},
	{
		zip: '08020',
		name: 'Sarule',
		province: 'NU',
		altitude: 630
	},
	{
		zip: '19038',
		name: 'Sarzana',
		province: 'SP',
		altitude: 21
	},
	{
		zip: '84038',
		name: 'Sassano',
		province: 'SA',
		altitude: 491
	},
	{
		zip: '07100',
		name: 'Sassari',
		province: 'SS',
		altitude: 225
	},
	{
		zip: '17046',
		name: 'Sassello',
		province: 'SV',
		altitude: 405
	},
	{
		zip: '57020',
		name: 'Sassetta',
		province: 'LI',
		altitude: 330
	},
	{
		zip: '82020',
		name: 'Sassinoro',
		province: 'BN',
		altitude: 545
	},
	{
		zip: '40037',
		name: 'Sasso Marconi',
		province: 'BO',
		altitude: 128
	},
	{
		zip: '85050',
		name: 'Sasso di Castalda',
		province: 'PZ',
		altitude: 949
	},
	{
		zip: '61028',
		name: 'Sassocorvaro Auditore',
		province: 'PU',
		altitude: 326
	},
	{
		zip: '47869',
		name: 'Sassofeltrio',
		province: 'RN',
		altitude: 466
	},
	{
		zip: '60041',
		name: 'Sassoferrato',
		province: 'AN',
		altitude: 386
	},
	{
		zip: '41049',
		name: 'Sassuolo',
		province: 'MO',
		altitude: 121
	},
	{
		zip: '88060',
		name: 'Satriano',
		province: 'CZ',
		altitude: 293
	},
	{
		zip: '85050',
		name: 'Satriano di Lucania',
		province: 'PZ',
		altitude: 653
	},
	{
		zip: '33020',
		name: 'Sauris',
		province: 'UD',
		altitude: 1212
	},
	{
		zip: '10050',
		name: 'Sauze d\'\'Oulx',
		province: 'TO',
		altitude: 1510
	},
	{
		zip: '10054',
		name: 'Sauze di Cesana',
		province: 'TO',
		altitude: 1560
	},
	{
		zip: '74028',
		name: 'Sava',
		province: 'TA',
		altitude: 107
	},
	{
		zip: '88825',
		name: 'Savelli',
		province: 'KR',
		altitude: 1014
	},
	{
		zip: '80039',
		name: 'Saviano',
		province: 'NA',
		altitude: 15
	},
	{
		zip: '12038',
		name: 'Savigliano',
		province: 'CN',
		altitude: 320
	},
	{
		zip: '83030',
		name: 'Savignano Irpino',
		province: 'AV',
		altitude: 718
	},
	{
		zip: '41056',
		name: 'Savignano sul Panaro',
		province: 'MO',
		altitude: 102
	},
	{
		zip: '47039',
		name: 'Savignano sul Rubicone',
		province: 'FC',
		altitude: 32
	},
	{
		zip: '16010',
		name: 'Savignone',
		province: 'GE',
		altitude: 471
	},
	{
		zip: '25040',
		name: 'Saviore dell\'\'Adamello',
		province: 'BS',
		altitude: 1210
	},
	{
		zip: '98038',
		name: 'Savoca',
		province: 'ME',
		altitude: 330
	},
	{
		zip: '33040',
		name: 'Savogna',
		province: 'UD',
		altitude: 235
	},
	{
		zip: '34070',
		name: 'Savogna d\'\'Isonzo',
		province: 'GO',
		altitude: 49
	},
	{
		zip: '85050',
		name: 'Savoia di Lucania',
		province: 'PZ',
		altitude: 720
	},
	{
		zip: '17100',
		name: 'Savona',
		province: 'SV',
		altitude: 4
	},
	{
		zip: '65027',
		name: 'Scafa',
		province: 'PE',
		altitude: 108
	},
	{
		zip: '84018',
		name: 'Scafati',
		province: 'SA',
		altitude: 12
	},
	{
		zip: '12070',
		name: 'Scagnello',
		province: 'CN',
		altitude: 748
	},
	{
		zip: '84010',
		name: 'Scala',
		province: 'SA',
		altitude: 360
	},
	{
		zip: '87060',
		name: 'Scala Coeli',
		province: 'CS',
		altitude: 370
	},
	{
		zip: '27020',
		name: 'Scaldasole',
		province: 'PV',
		altitude: 86
	},
	{
		zip: '87029',
		name: 'Scalea',
		province: 'CS',
		altitude: 25
	},
	{
		zip: '10060',
		name: 'Scalenghe',
		province: 'TO',
		altitude: 314
	},
	{
		zip: '98029',
		name: 'Scaletta Zanclea',
		province: 'ME',
		altitude: 8
	},
	{
		zip: '83050',
		name: 'Scampitella',
		province: 'AV',
		altitude: 775
	},
	{
		zip: '88831',
		name: 'Scandale',
		province: 'KR',
		altitude: 350
	},
	{
		zip: '42019',
		name: 'Scandiano',
		province: 'RE',
		altitude: 95
	},
	{
		zip: '50018',
		name: 'Scandicci',
		province: 'FI',
		altitude: 47
	},
	{
		zip: '26040',
		name: 'Scandolara Ravara',
		province: 'CR',
		altitude: 30
	},
	{
		zip: '26047',
		name: 'Scandolara Ripa d\'\'Oglio',
		province: 'CR',
		altitude: 47
	},
	{
		zip: '02038',
		name: 'Scandriglia',
		province: 'RI',
		altitude: 535
	},
	{
		zip: '67038',
		name: 'Scanno',
		province: 'AQ',
		altitude: 1050
	},
	{
		zip: '09078',
		name: 'Scano di Montiferro',
		province: 'OR',
		altitude: 385
	},
	{
		zip: '58054',
		name: 'Scansano',
		province: 'GR',
		altitude: 500
	},
	{
		zip: '75020',
		name: 'Scanzano Jonico',
		province: 'MT',
		altitude: 21
	},
	{
		zip: '24020',
		name: 'Scanzorosciate',
		province: 'BG',
		altitude: 297
	},
	{
		zip: '86070',
		name: 'Scapoli',
		province: 'IS',
		altitude: 611
	},
	{
		zip: '58020',
		name: 'Scarlino',
		province: 'GR',
		altitude: 229
	},
	{
		zip: '10010',
		name: 'Scarmagno',
		province: 'TO',
		altitude: 318
	},
	{
		zip: '12030',
		name: 'Scarnafigi',
		province: 'CN',
		altitude: 296
	},
	{
		zip: '50038',
		name: 'Scarperia e San Piero',
		province: 'FI',
		altitude: 292
	},
	{
		zip: '39017',
		name: 'Scena',
		province: 'BZ',
		altitude: 600
	},
	{
		zip: '66020',
		name: 'Scerni',
		province: 'CH',
		altitude: 281
	},
	{
		zip: '06027',
		name: 'Scheggia e Pascelupo',
		province: 'PG',
		altitude: 580
	},
	{
		zip: '06040',
		name: 'Scheggino',
		province: 'PG',
		altitude: 282
	},
	{
		zip: '66045',
		name: 'Schiavi di Abruzzo',
		province: 'CH',
		altitude: 1172
	},
	{
		zip: '36060',
		name: 'Schiavon',
		province: 'VI',
		altitude: 74
	},
	{
		zip: '22020',
		name: 'Schignano',
		province: 'CO',
		altitude: 650
	},
	{
		zip: '24020',
		name: 'Schilpario',
		province: 'BG',
		altitude: 1135
	},
	{
		zip: '36015',
		name: 'Schio',
		province: 'VI',
		altitude: 200
	},
	{
		zip: '46020',
		name: 'Schivenoglia',
		province: 'MN',
		altitude: 16
	},
	{
		zip: '92019',
		name: 'Sciacca',
		province: 'AG',
		altitude: 60
	},
	{
		zip: '90020',
		name: 'Sciara',
		province: 'PA',
		altitude: 210
	},
	{
		zip: '97018',
		name: 'Scicli',
		province: 'RG',
		altitude: 108
	},
	{
		zip: '89010',
		name: 'Scido',
		province: 'RC',
		altitude: 456
	},
	{
		zip: '87057',
		name: 'Scigliano',
		province: 'CS',
		altitude: 659
	},
	{
		zip: '90020',
		name: 'Scillato',
		province: 'PA',
		altitude: 215
	},
	{
		zip: '10090',
		name: 'Sciolze',
		province: 'TO',
		altitude: 436
	},
	{
		zip: '80030',
		name: 'Scisciano',
		province: 'NA',
		altitude: 31
	},
	{
		zip: '90020',
		name: 'Sclafani Bagni',
		province: 'PA',
		altitude: 810
	},
	{
		zip: '67030',
		name: 'Scontrone',
		province: 'AQ',
		altitude: 1038
	},
	{
		zip: '13027',
		name: 'Scopa',
		province: 'VC',
		altitude: 622
	},
	{
		zip: '13028',
		name: 'Scopello',
		province: 'VC',
		altitude: 659
	},
	{
		zip: '67019',
		name: 'Scoppito',
		province: 'AQ',
		altitude: 820
	},
	{
		zip: '95048',
		name: 'Scordia',
		province: 'CT',
		altitude: 150
	},
	{
		zip: '73020',
		name: 'Scorrano',
		province: 'LE',
		altitude: 95
	},
	{
		zip: '30037',
		name: 'Scorze',
		province: 'VE',
		altitude: 16
	},
	{
		zip: '67068',
		name: 'Scurcola Marsicana',
		province: 'AQ',
		altitude: 700
	},
	{
		zip: '38050',
		name: 'Scurelle',
		province: 'TN',
		altitude: 375
	},
	{
		zip: '14030',
		name: 'Scurzolengo',
		province: 'AT',
		altitude: 253
	},
	{
		zip: '18012',
		name: 'Seborga',
		province: 'IM',
		altitude: 500
	},
	{
		zip: '67029',
		name: 'Secinaro',
		province: 'AQ',
		altitude: 859
	},
	{
		zip: '73050',
		name: 'Secli',
		province: 'LE',
		altitude: 76
	},
	{
		zip: '26826',
		name: 'Secugnago',
		province: 'LO',
		altitude: 68
	},
	{
		zip: '33039',
		name: 'Sedegliano',
		province: 'UD',
		altitude: 70
	},
	{
		zip: '32036',
		name: 'Sedico',
		province: 'BL',
		altitude: 317
	},
	{
		zip: '09076',
		name: 'Sedilo',
		province: 'OR',
		altitude: 283
	},
	{
		zip: '07035',
		name: 'Sedini',
		province: 'SS',
		altitude: 350
	},
	{
		zip: '20018',
		name: 'Sedriano',
		province: 'MI',
		altitude: 145
	},
	{
		zip: '24010',
		name: 'Sedrina',
		province: 'BG',
		altitude: 328
	},
	{
		zip: '62030',
		name: 'Sefro',
		province: 'MC',
		altitude: 502
	},
	{
		zip: '09040',
		name: 'Segariu',
		province: 'SU',
		altitude: 129
	},
	{
		zip: '58038',
		name: 'Seggiano',
		province: 'GR',
		altitude: 491
	},
	{
		zip: '00037',
		name: 'Segni',
		province: 'RM',
		altitude: 668
	},
	{
		zip: '38047',
		name: 'Segonzano',
		province: 'TN',
		altitude: 660
	},
	{
		zip: '20054',
		name: 'Segrate',
		province: 'MI',
		altitude: 115
	},
	{
		zip: '31040',
		name: 'Segusino',
		province: 'TV',
		altitude: 219
	},
	{
		zip: '09047',
		name: 'Selargius',
		province: 'CA',
		altitude: 10
	},
	{
		zip: '02040',
		name: 'Selci',
		province: 'RI',
		altitude: 204
	},
	{
		zip: '09040',
		name: 'Selegas',
		province: 'SU',
		altitude: 234
	},
	{
		zip: '38087',
		name: 'Sella Giudicarie',
		province: 'TN',
		altitude: 842
	},
	{
		zip: '06030',
		name: 'Sellano',
		province: 'PG',
		altitude: 640
	},
	{
		zip: '25050',
		name: 'Sellero',
		province: 'BS',
		altitude: 476
	},
	{
		zip: '88050',
		name: 'Sellia',
		province: 'CZ',
		altitude: 560
	},
	{
		zip: '88050',
		name: 'Sellia Marina',
		province: 'CZ',
		altitude: 82
	},
	{
		zip: '39030',
		name: 'Selva dei Molini',
		province: 'BZ',
		altitude: 1229
	},
	{
		zip: '32020',
		name: 'Selva di Cadore',
		province: 'BL',
		altitude: 1335
	},
	{
		zip: '37030',
		name: 'Selva di Progno',
		province: 'VR',
		altitude: 570
	},
	{
		zip: '39048',
		name: 'Selva di Val Gardena',
		province: 'BZ',
		altitude: 1563
	},
	{
		zip: '35030',
		name: 'Selvazzano Dentro',
		province: 'PD',
		altitude: 18
	},
	{
		zip: '24020',
		name: 'Selvino',
		province: 'BG',
		altitude: 982
	},
	{
		zip: '07010',
		name: 'Semestene',
		province: 'SS',
		altitude: 408
	},
	{
		zip: '27020',
		name: 'Semiana',
		province: 'PV',
		altitude: 97
	},
	{
		zip: '89028',
		name: 'Seminara',
		province: 'RC',
		altitude: 290
	},
	{
		zip: '58055',
		name: 'Semproniano',
		province: 'GR',
		altitude: 601
	},
	{
		zip: '20030',
		name: 'Senago',
		province: 'MI',
		altitude: 169
	},
	{
		zip: '39010',
		name: 'Senale-San Felice',
		province: 'BZ',
		altitude: 1279
	},
	{
		zip: '39020',
		name: 'Senales',
		province: 'BZ',
		altitude: 1317
	},
	{
		zip: '09070',
		name: 'Seneghe',
		province: 'OR',
		altitude: 305
	},
	{
		zip: '83050',
		name: 'Senerchia',
		province: 'AV',
		altitude: 600
	},
	{
		zip: '25020',
		name: 'Seniga',
		province: 'BS',
		altitude: 48
	},
	{
		zip: '60019',
		name: 'Senigallia',
		province: 'AN',
		altitude: 5
	},
	{
		zip: '09080',
		name: 'Senis',
		province: 'OR',
		altitude: 256
	},
	{
		zip: '85038',
		name: 'Senise',
		province: 'PZ',
		altitude: 335
	},
	{
		zip: '22070',
		name: 'Senna Comasco',
		province: 'CO',
		altitude: 296
	},
	{
		zip: '26856',
		name: 'Senna Lodigiana',
		province: 'LO',
		altitude: 60
	},
	{
		zip: '09078',
		name: 'Sennariolo',
		province: 'OR',
		altitude: 274
	},
	{
		zip: '07036',
		name: 'Sennori',
		province: 'SS',
		altitude: 350
	},
	{
		zip: '09040',
		name: 'Senorbi',
		province: 'SU',
		altitude: 199
	},
	{
		zip: '86017',
		name: 'Sepino',
		province: 'CB',
		altitude: 698
	},
	{
		zip: '33090',
		name: 'Sequals',
		province: 'PN',
		altitude: 270
	},
	{
		zip: '55047',
		name: 'Seravezza',
		province: 'LU',
		altitude: 50
	},
	{
		zip: '09040',
		name: 'Serdiana',
		province: 'SU',
		altitude: 171
	},
	{
		zip: '20831',
		name: 'Seregno',
		province: 'MB',
		altitude: 222
	},
	{
		zip: '32030',
		name: 'Seren del Grappa',
		province: 'BL',
		altitude: 385
	},
	{
		zip: '26010',
		name: 'Sergnano',
		province: 'CR',
		altitude: 88
	},
	{
		zip: '24068',
		name: 'Seriate',
		province: 'BG',
		altitude: 247
	},
	{
		zip: '24017',
		name: 'Serina',
		province: 'BG',
		altitude: 820
	},
	{
		zip: '83028',
		name: 'Serino',
		province: 'AV',
		altitude: 416
	},
	{
		zip: '25080',
		name: 'Serle',
		province: 'BS',
		altitude: 493
	},
	{
		zip: '04013',
		name: 'Sermoneta',
		province: 'LT',
		altitude: 237
	},
	{
		zip: '31020',
		name: 'Sernaglia della Battaglia',
		province: 'TV',
		altitude: 117
	},
	{
		zip: '23030',
		name: 'Sernio',
		province: 'SO',
		altitude: 632
	},
	{
		zip: '14050',
		name: 'Serole',
		province: 'AT',
		altitude: 588
	},
	{
		zip: '16010',
		name: 'Serra Ricco',
		province: 'GE',
		altitude: 187
	},
	{
		zip: '89822',
		name: 'Serra San Bruno',
		province: 'VV',
		altitude: 790
	},
	{
		zip: '60048',
		name: 'Serra San Quirico',
		province: 'AN',
		altitude: 300
	},
	{
		zip: '61040',
		name: 'Serra Sant\'\'Abbondio',
		province: 'PU',
		altitude: 523
	},
	{
		zip: '87030',
		name: 'Serra d\'\'Aiello',
		province: 'CS',
		altitude: 373
	},
	{
		zip: '60030',
		name: 'Serra de Conti',
		province: 'AN',
		altitude: 216
	},
	{
		zip: '71010',
		name: 'Serracapriola',
		province: 'FG',
		altitude: 270
	},
	{
		zip: '93010',
		name: 'Serradifalco',
		province: 'CL',
		altitude: 504
	},
	{
		zip: '12050',
		name: 'Serralunga d\'\'Alba',
		province: 'CN',
		altitude: 414
	},
	{
		zip: '15020',
		name: 'Serralunga di Crea',
		province: 'AL',
		altitude: 240
	},
	{
		zip: '09038',
		name: 'Serramanna',
		province: 'SU',
		altitude: 38
	},
	{
		zip: '41028',
		name: 'Serramazzoni',
		province: 'MO',
		altitude: 791
	},
	{
		zip: '84070',
		name: 'Serramezzana',
		province: 'SA',
		altitude: 520
	},
	{
		zip: '65025',
		name: 'Serramonacesca',
		province: 'PE',
		altitude: 280
	},
	{
		zip: '62020',
		name: 'Serrapetrona',
		province: 'MC',
		altitude: 474
	},
	{
		zip: '80081',
		name: 'Serrara Fontana',
		province: 'NA',
		altitude: 366
	},
	{
		zip: '88040',
		name: 'Serrastretta',
		province: 'CZ',
		altitude: 840
	},
	{
		zip: '89020',
		name: 'Serrata',
		province: 'RC',
		altitude: 277
	},
	{
		zip: '12050',
		name: 'Serravalle Langhe',
		province: 'CN',
		altitude: 762
	},
	{
		zip: '51034',
		name: 'Serravalle Pistoiese',
		province: 'PT',
		altitude: 182
	},
	{
		zip: '15069',
		name: 'Serravalle Scrivia',
		province: 'AL',
		altitude: 225
	},
	{
		zip: '13037',
		name: 'Serravalle Sesia',
		province: 'VC',
		altitude: 313
	},
	{
		zip: '46030',
		name: 'Serravalle a Po',
		province: 'MN',
		altitude: 15
	},
	{
		zip: '62038',
		name: 'Serravalle di Chienti',
		province: 'MC',
		altitude: 667
	},
	{
		zip: '84028',
		name: 'Serre',
		province: 'SA',
		altitude: 200
	},
	{
		zip: '09027',
		name: 'Serrenti',
		province: 'SU',
		altitude: 114
	},
	{
		zip: '09063',
		name: 'Serri',
		province: 'SU',
		altitude: 640
	},
	{
		zip: '03010',
		name: 'Serrone',
		province: 'FR',
		altitude: 738
	},
	{
		zip: '88054',
		name: 'Sersale',
		province: 'CZ',
		altitude: 740
	},
	{
		zip: '63839',
		name: 'Servigliano',
		province: 'FM',
		altitude: 215
	},
	{
		zip: '81037',
		name: 'Sessa Aurunca',
		province: 'CE',
		altitude: 203
	},
	{
		zip: '84074',
		name: 'Sessa Cilento',
		province: 'SA',
		altitude: 520
	},
	{
		zip: '14058',
		name: 'Sessame',
		province: 'AT',
		altitude: 325
	},
	{
		zip: '86097',
		name: 'Sessano del Molise',
		province: 'IS',
		altitude: 796
	},
	{
		zip: '19020',
		name: 'Sesta Godano',
		province: 'SP',
		altitude: 242
	},
	{
		zip: '52038',
		name: 'Sestino',
		province: 'AR',
		altitude: 496
	},
	{
		zip: '39030',
		name: 'Sesto',
		province: 'BZ',
		altitude: 1310
	},
	{
		zip: '21018',
		name: 'Sesto Calende',
		province: 'VA',
		altitude: 198
	},
	{
		zip: '86078',
		name: 'Sesto Campano',
		province: 'IS',
		altitude: 323
	},
	{
		zip: '50019',
		name: 'Sesto Fiorentino',
		province: 'FI',
		altitude: 55
	},
	{
		zip: '20099',
		name: 'Sesto San Giovanni',
		province: 'MI',
		altitude: 140
	},
	{
		zip: '33079',
		name: 'Sesto al Reghena',
		province: 'PN',
		altitude: 13
	},
	{
		zip: '26028',
		name: 'Sesto ed Uniti',
		province: 'CR',
		altitude: 52
	},
	{
		zip: '41029',
		name: 'Sestola',
		province: 'MO',
		altitude: 1020
	},
	{
		zip: '16039',
		name: 'Sestri Levante',
		province: 'GE',
		altitude: 10
	},
	{
		zip: '10058',
		name: 'Sestriere',
		province: 'TO',
		altitude: 2035
	},
	{
		zip: '09028',
		name: 'Sestu',
		province: 'CA',
		altitude: 44
	},
	{
		zip: '20049',
		name: 'Settala',
		province: 'MI',
		altitude: 108
	},
	{
		zip: '03040',
		name: 'Settefrati',
		province: 'FR',
		altitude: 784
	},
	{
		zip: '14020',
		name: 'Settime',
		province: 'AT',
		altitude: 272
	},
	{
		zip: '20019',
		name: 'Settimo Milanese',
		province: 'MI',
		altitude: 134
	},
	{
		zip: '10010',
		name: 'Settimo Rottaro',
		province: 'TO',
		altitude: 258
	},
	{
		zip: '09060',
		name: 'Settimo San Pietro',
		province: 'CA',
		altitude: 70
	},
	{
		zip: '10036',
		name: 'Settimo Torinese',
		province: 'TO',
		altitude: 207
	},
	{
		zip: '10010',
		name: 'Settimo Vittone',
		province: 'TO',
		altitude: 282
	},
	{
		zip: '88040',
		name: 'Settingiano',
		province: 'CZ',
		altitude: 270
	},
	{
		zip: '09029',
		name: 'Setzu',
		province: 'SU',
		altitude: 206
	},
	{
		zip: '09064',
		name: 'Seui',
		province: 'SU',
		altitude: 820
	},
	{
		zip: '09065',
		name: 'Seulo',
		province: 'SU',
		altitude: 797
	},
	{
		zip: '20822',
		name: 'Seveso',
		province: 'MB',
		altitude: 211
	},
	{
		zip: '15079',
		name: 'Sezzadio',
		province: 'AL',
		altitude: 127
	},
	{
		zip: '04018',
		name: 'Sezze',
		province: 'LT',
		altitude: 319
	},
	{
		zip: '38010',
		name: 'Sfruz',
		province: 'TN',
		altitude: 1012
	},
	{
		zip: '34010',
		name: 'Sgonico',
		province: 'TS',
		altitude: 278
	},
	{
		zip: '03010',
		name: 'Sgurgola',
		province: 'FR',
		altitude: 386
	},
	{
		zip: '09070',
		name: 'Siamaggiore',
		province: 'OR',
		altitude: 8
	},
	{
		zip: '09080',
		name: 'Siamanna',
		province: 'OR',
		altitude: 49
	},
	{
		zip: '84088',
		name: 'Siano',
		province: 'SA',
		altitude: 126
	},
	{
		zip: '09084',
		name: 'Siapiccia',
		province: 'OR',
		altitude: 64
	},
	{
		zip: '84029',
		name: 'Sicignano degli Alburni',
		province: 'SA',
		altitude: 609
	},
	{
		zip: '92010',
		name: 'Siculiana',
		province: 'AG',
		altitude: 129
	},
	{
		zip: '09020',
		name: 'Siddi',
		province: 'SU',
		altitude: 184
	},
	{
		zip: '89048',
		name: 'Siderno',
		province: 'RC',
		altitude: 10
	},
	{
		zip: '53100',
		name: 'Siena',
		province: 'SI',
		altitude: 322
	},
	{
		zip: '06028',
		name: 'Sigillo',
		province: 'PG',
		altitude: 490
	},
	{
		zip: '50058',
		name: 'Signa',
		province: 'FI',
		altitude: 46
	},
	{
		zip: '39028',
		name: 'Silandro',
		province: 'BZ',
		altitude: 720
	},
	{
		zip: '08017',
		name: 'Silanus',
		province: 'NU',
		altitude: 432
	},
	{
		zip: '31057',
		name: 'Silea',
		province: 'TV',
		altitude: 7
	},
	{
		zip: '07040',
		name: 'Siligo',
		province: 'SS',
		altitude: 400
	},
	{
		zip: '09010',
		name: 'Siliqua',
		province: 'SU',
		altitude: 66
	},
	{
		zip: '09040',
		name: 'Silius',
		province: 'SU',
		altitude: 585
	},
	{
		zip: '55039',
		name: 'Sillano Giuncugnano',
		province: 'LU',
		altitude: 735
	},
	{
		zip: '28060',
		name: 'Sillavengo',
		province: 'NO',
		altitude: 192
	},
	{
		zip: '27050',
		name: 'Silvano Pietra',
		province: 'PV',
		altitude: 83
	},
	{
		zip: '15060',
		name: 'Silvano d\'\'Orba',
		province: 'AL',
		altitude: 175
	},
	{
		zip: '64028',
		name: 'Silvi',
		province: 'TE',
		altitude: 2
	},
	{
		zip: '09090',
		name: 'Simala',
		province: 'OR',
		altitude: 155
	},
	{
		zip: '09088',
		name: 'Simaxis',
		province: 'OR',
		altitude: 7
	},
	{
		zip: '89822',
		name: 'Simbario',
		province: 'VV',
		altitude: 766
	},
	{
		zip: '88050',
		name: 'Simeri Crichi',
		province: 'CZ',
		altitude: 465
	},
	{
		zip: '98069',
		name: 'Sinagra',
		province: 'ME',
		altitude: 260
	},
	{
		zip: '53048',
		name: 'Sinalunga',
		province: 'SI',
		altitude: 364
	},
	{
		zip: '08018',
		name: 'Sindia',
		province: 'NU',
		altitude: 509
	},
	{
		zip: '09090',
		name: 'Sini',
		province: 'OR',
		altitude: 255
	},
	{
		zip: '12050',
		name: 'Sinio',
		province: 'CN',
		altitude: 357
	},
	{
		zip: '08029',
		name: 'Siniscola',
		province: 'NU',
		altitude: 38
	},
	{
		zip: '09048',
		name: 'Sinnai',
		province: 'CA',
		altitude: 133
	},
	{
		zip: '89020',
		name: 'Sinopoli',
		province: 'RC',
		altitude: 500
	},
	{
		zip: '96100',
		name: 'Siracusa',
		province: 'SR',
		altitude: 17
	},
	{
		zip: '83020',
		name: 'Sirignano',
		province: 'AV',
		altitude: 270
	},
	{
		zip: '09090',
		name: 'Siris',
		province: 'OR',
		altitude: 161
	},
	{
		zip: '25019',
		name: 'Sirmione',
		province: 'BS',
		altitude: 66
	},
	{
		zip: '60020',
		name: 'Sirolo',
		province: 'AN',
		altitude: 125
	},
	{
		zip: '23844',
		name: 'Sirone',
		province: 'LC',
		altitude: 280
	},
	{
		zip: '23896',
		name: 'Sirtori',
		province: 'LC',
		altitude: 457
	},
	{
		zip: '43018',
		name: 'Sissa Trecasali',
		province: 'PR',
		altitude: 32
	},
	{
		zip: '09040',
		name: 'Siurgus Donigala',
		province: 'SU',
		altitude: 452
	},
	{
		zip: '27010',
		name: 'Siziano',
		province: 'PV',
		altitude: 93
	},
	{
		zip: '28070',
		name: 'Sizzano',
		province: 'NO',
		altitude: 246
	},
	{
		zip: '39020',
		name: 'Sluderno',
		province: 'BZ',
		altitude: 921
	},
	{
		zip: '63856',
		name: 'Smerillo',
		province: 'FM',
		altitude: 806
	},
	{
		zip: '37038',
		name: 'Soave',
		province: 'VR',
		altitude: 40
	},
	{
		zip: '33020',
		name: 'Socchieve',
		province: 'UD',
		altitude: 486
	},
	{
		zip: '09080',
		name: 'Soddi',
		province: 'OR',
		altitude: 250
	},
	{
		zip: '73010',
		name: 'Sogliano Cavour',
		province: 'LE',
		altitude: 75
	},
	{
		zip: '47030',
		name: 'Sogliano al Rubicone',
		province: 'FC',
		altitude: 362
	},
	{
		zip: '14020',
		name: 'Soglio',
		province: 'AT',
		altitude: 223
	},
	{
		zip: '25080',
		name: 'Soiano del Lago',
		province: 'BS',
		altitude: 196
	},
	{
		zip: '36020',
		name: 'Solagna',
		province: 'VI',
		altitude: 131
	},
	{
		zip: '96010',
		name: 'Solarino',
		province: 'SR',
		altitude: 165
	},
	{
		zip: '20033',
		name: 'Solaro',
		province: 'MI',
		altitude: 211
	},
	{
		zip: '48027',
		name: 'Solarolo',
		province: 'RA',
		altitude: 25
	},
	{
		zip: '26030',
		name: 'Solarolo Rainerio',
		province: 'CR',
		altitude: 28
	},
	{
		zip: '09077',
		name: 'Solarussa',
		province: 'OR',
		altitude: 20
	},
	{
		zip: '21048',
		name: 'Solbiate Arno',
		province: 'VA',
		altitude: 325
	},
	{
		zip: '21058',
		name: 'Solbiate Olona',
		province: 'VA',
		altitude: 247
	},
	{
		zip: '18036',
		name: 'Soldano',
		province: 'IM',
		altitude: 80
	},
	{
		zip: '09040',
		name: 'Soleminis',
		province: 'SU',
		altitude: 200
	},
	{
		zip: '15029',
		name: 'Solero',
		province: 'AL',
		altitude: 102
	},
	{
		zip: '35047',
		name: 'Solesino',
		province: 'PD',
		altitude: 10
	},
	{
		zip: '73010',
		name: 'Soleto',
		province: 'LE',
		altitude: 90
	},
	{
		zip: '46040',
		name: 'Solferino',
		province: 'MN',
		altitude: 124
	},
	{
		zip: '41019',
		name: 'Soliera',
		province: 'MO',
		altitude: 28
	},
	{
		zip: '43040',
		name: 'Solignano',
		province: 'PR',
		altitude: 232
	},
	{
		zip: '83029',
		name: 'Solofra',
		province: 'AV',
		altitude: 400
	},
	{
		zip: '15020',
		name: 'Solonghello',
		province: 'AL',
		altitude: 220
	},
	{
		zip: '82036',
		name: 'Solopaca',
		province: 'BN',
		altitude: 180
	},
	{
		zip: '24060',
		name: 'Solto Collina',
		province: 'BG',
		altitude: 449
	},
	{
		zip: '24030',
		name: 'Solza',
		province: 'BG',
		altitude: 254
	},
	{
		zip: '26867',
		name: 'Somaglia',
		province: 'LO',
		altitude: 57
	},
	{
		zip: '12060',
		name: 'Somano',
		province: 'CN',
		altitude: 516
	},
	{
		zip: '21019',
		name: 'Somma Lombardo',
		province: 'VA',
		altitude: 282
	},
	{
		zip: '80049',
		name: 'Somma Vesuviana',
		province: 'NA',
		altitude: 165
	},
	{
		zip: '37066',
		name: 'Sommacampagna',
		province: 'VR',
		altitude: 121
	},
	{
		zip: '12040',
		name: 'Sommariva Perno',
		province: 'CN',
		altitude: 389
	},
	{
		zip: '12048',
		name: 'Sommariva del Bosco',
		province: 'CN',
		altitude: 298
	},
	{
		zip: '93019',
		name: 'Sommatino',
		province: 'CL',
		altitude: 359
	},
	{
		zip: '27048',
		name: 'Sommo',
		province: 'PV',
		altitude: 80
	},
	{
		zip: '37060',
		name: 'Sona',
		province: 'VR',
		altitude: 169
	},
	{
		zip: '26029',
		name: 'Soncino',
		province: 'CR',
		altitude: 89
	},
	{
		zip: '23035',
		name: 'Sondalo',
		province: 'SO',
		altitude: 940
	},
	{
		zip: '23100',
		name: 'Sondrio',
		province: 'SO',
		altitude: 307
	},
	{
		zip: '24020',
		name: 'Songavazzo',
		province: 'BG',
		altitude: 640
	},
	{
		zip: '25048',
		name: 'Sonico',
		province: 'BS',
		altitude: 650
	},
	{
		zip: '04010',
		name: 'Sonnino',
		province: 'LT',
		altitude: 430
	},
	{
		zip: '03039',
		name: 'Sora',
		province: 'FR',
		altitude: 300
	},
	{
		zip: '38030',
		name: 'Soraga di Fassa',
		province: 'TN',
		altitude: 1220
	},
	{
		zip: '43019',
		name: 'Soragna',
		province: 'PR',
		altitude: 49
	},
	{
		zip: '58010',
		name: 'Sorano',
		province: 'GR',
		altitude: 379
	},
	{
		zip: '88050',
		name: 'Sorbo San Basile',
		province: 'CZ',
		altitude: 620
	},
	{
		zip: '83050',
		name: 'Sorbo Serpico',
		province: 'AV',
		altitude: 480
	},
	{
		zip: '43058',
		name: 'Sorbolo Mezzani',
		province: 'PR',
		altitude: 30
	},
	{
		zip: '13817',
		name: 'Sordevolo',
		province: 'BI',
		altitude: 627
	},
	{
		zip: '26858',
		name: 'Sordio',
		province: 'LO',
		altitude: 85
	},
	{
		zip: '26015',
		name: 'Soresina',
		province: 'CR',
		altitude: 69
	},
	{
		zip: '08038',
		name: 'Sorgono',
		province: 'NU',
		altitude: 700
	},
	{
		zip: '37060',
		name: 'Sorga',
		province: 'VR',
		altitude: 25
	},
	{
		zip: '16031',
		name: 'Sori',
		province: 'GE',
		altitude: 14
	},
	{
		zip: '89831',
		name: 'Sorianello',
		province: 'VV',
		altitude: 420
	},
	{
		zip: '89831',
		name: 'Soriano Calabro',
		province: 'VV',
		altitude: 268
	},
	{
		zip: '01038',
		name: 'Soriano nel Cimino',
		province: 'VT',
		altitude: 509
	},
	{
		zip: '22010',
		name: 'Sorico',
		province: 'CO',
		altitude: 201
	},
	{
		zip: '28010',
		name: 'Soriso',
		province: 'NO',
		altitude: 452
	},
	{
		zip: '24010',
		name: 'Sorisole',
		province: 'BG',
		altitude: 415
	},
	{
		zip: '22030',
		name: 'Sormano',
		province: 'CO',
		altitude: 775
	},
	{
		zip: '09080',
		name: 'Sorradile',
		province: 'OR',
		altitude: 350
	},
	{
		zip: '80067',
		name: 'Sorrento',
		province: 'NA',
		altitude: 50
	},
	{
		zip: '07037',
		name: 'Sorso',
		province: 'SS',
		altitude: 136
	},
	{
		zip: '96010',
		name: 'Sortino',
		province: 'SR',
		altitude: 438
	},
	{
		zip: '26048',
		name: 'Sospiro',
		province: 'CR',
		altitude: 36
	},
	{
		zip: '32037',
		name: 'Sospirolo',
		province: 'BL',
		altitude: 447
	},
	{
		zip: '36040',
		name: 'Sossano',
		province: 'VI',
		altitude: 15
	},
	{
		zip: '13868',
		name: 'Sostegno',
		province: 'BI',
		altitude: 397
	},
	{
		zip: '24039',
		name: 'Sotto il Monte Giovanni XXIII',
		province: 'BG',
		altitude: 305
	},
	{
		zip: '38048',
		name: 'Sover',
		province: 'TN',
		altitude: 831
	},
	{
		zip: '88068',
		name: 'Soverato',
		province: 'CZ',
		altitude: 8
	},
	{
		zip: '24060',
		name: 'Sovere',
		province: 'BG',
		altitude: 375
	},
	{
		zip: '88049',
		name: 'Soveria Mannelli',
		province: 'CZ',
		altitude: 774
	},
	{
		zip: '88050',
		name: 'Soveria Simeri',
		province: 'CZ',
		altitude: 367
	},
	{
		zip: '32010',
		name: 'Soverzene',
		province: 'BL',
		altitude: 424
	},
	{
		zip: '53018',
		name: 'Sovicille',
		province: 'SI',
		altitude: 265
	},
	{
		zip: '20845',
		name: 'Sovico',
		province: 'MB',
		altitude: 221
	},
	{
		zip: '36050',
		name: 'Sovizzo',
		province: 'VI',
		altitude: 44
	},
	{
		zip: '32030',
		name: 'Sovramonte',
		province: 'BL',
		altitude: 600
	},
	{
		zip: '28060',
		name: 'Sozzago',
		province: 'NO',
		altitude: 129
	},
	{
		zip: '98048',
		name: 'Spadafora',
		province: 'ME',
		altitude: 6
	},
	{
		zip: '89822',
		name: 'Spadola',
		province: 'VV',
		altitude: 754
	},
	{
		zip: '81056',
		name: 'Sparanise',
		province: 'CE',
		altitude: 65
	},
	{
		zip: '10080',
		name: 'Sparone',
		province: 'TO',
		altitude: 552
	},
	{
		zip: '73040',
		name: 'Specchia',
		province: 'LE',
		altitude: 131
	},
	{
		zip: '06038',
		name: 'Spello',
		province: 'PG',
		altitude: 280
	},
	{
		zip: '94010',
		name: 'Sperlinga',
		province: 'EN',
		altitude: 750
	},
	{
		zip: '04029',
		name: 'Sperlonga',
		province: 'LT',
		altitude: 55
	},
	{
		zip: '83020',
		name: 'Sperone',
		province: 'AV',
		altitude: 175
	},
	{
		zip: '27010',
		name: 'Spessa',
		province: 'PV',
		altitude: 61
	},
	{
		zip: '87019',
		name: 'Spezzano Albanese',
		province: 'CS',
		altitude: 320
	},
	{
		zip: '87058',
		name: 'Spezzano della Sila',
		province: 'CS',
		altitude: 800
	},
	{
		zip: '38088',
		name: 'Spiazzo',
		province: 'TN',
		altitude: 649
	},
	{
		zip: '15018',
		name: 'Spigno Monferrato',
		province: 'AL',
		altitude: 217
	},
	{
		zip: '04020',
		name: 'Spigno Saturnia',
		province: 'LT',
		altitude: 46
	},
	{
		zip: '41057',
		name: 'Spilamberto',
		province: 'MO',
		altitude: 69
	},
	{
		zip: '33097',
		name: 'Spilimbergo',
		province: 'PN',
		altitude: 132
	},
	{
		zip: '89864',
		name: 'Spilinga',
		province: 'VV',
		altitude: 455
	},
	{
		zip: '26020',
		name: 'Spinadesco',
		province: 'CR',
		altitude: 48
	},
	{
		zip: '76014',
		name: 'Spinazzola',
		province: 'BT',
		altitude: 435
	},
	{
		zip: '30038',
		name: 'Spinea',
		province: 'VE',
		altitude: 6
	},
	{
		zip: '26030',
		name: 'Spineda',
		province: 'CR',
		altitude: 23
	},
	{
		zip: '86020',
		name: 'Spinete',
		province: 'CB',
		altitude: 600
	},
	{
		zip: '15050',
		name: 'Spineto Scrivia',
		province: 'AL',
		altitude: 265
	},
	{
		zip: '63078',
		name: 'Spinetoli',
		province: 'AP',
		altitude: 177
	},
	{
		zip: '26016',
		name: 'Spino d\'\'Adda',
		province: 'CR',
		altitude: 84
	},
	{
		zip: '24060',
		name: 'Spinone al Lago',
		province: 'BG',
		altitude: 360
	},
	{
		zip: '85039',
		name: 'Spinoso',
		province: 'PZ',
		altitude: 649
	},
	{
		zip: '24050',
		name: 'Spirano',
		province: 'BG',
		altitude: 154
	},
	{
		zip: '06049',
		name: 'Spoleto',
		province: 'PG',
		altitude: 396
	},
	{
		zip: '65010',
		name: 'Spoltore',
		province: 'PE',
		altitude: 185
	},
	{
		zip: '73038',
		name: 'Spongano',
		province: 'LE',
		altitude: 96
	},
	{
		zip: '38010',
		name: 'Spormaggiore',
		province: 'TN',
		altitude: 565
	},
	{
		zip: '38010',
		name: 'Sporminore',
		province: 'TN',
		altitude: 515
	},
	{
		zip: '17028',
		name: 'Spotorno',
		province: 'SV',
		altitude: 7
	},
	{
		zip: '31027',
		name: 'Spresiano',
		province: 'TV',
		altitude: 56
	},
	{
		zip: '23020',
		name: 'Spriana',
		province: 'SO',
		altitude: 754
	},
	{
		zip: '88069',
		name: 'Squillace',
		province: 'CZ',
		altitude: 344
	},
	{
		zip: '73018',
		name: 'Squinzano',
		province: 'LE',
		altitude: 48
	},
	{
		zip: '60039',
		name: 'Staffolo',
		province: 'AN',
		altitude: 442
	},
	{
		zip: '26049',
		name: 'Stagno Lombardo',
		province: 'CR',
		altitude: 36
	},
	{
		zip: '89030',
		name: 'Staiti',
		province: 'RC',
		altitude: 550
	},
	{
		zip: '88069',
		name: 'Staletti',
		province: 'CZ',
		altitude: 382
	},
	{
		zip: '35048',
		name: 'Stanghella',
		province: 'PD',
		altitude: 7
	},
	{
		zip: '34079',
		name: 'Staranzano',
		province: 'GO',
		altitude: 7
	},
	{
		zip: '74010',
		name: 'Statte',
		province: 'TA',
		altitude: 138
	},
	{
		zip: '15060',
		name: 'Stazzano',
		province: 'AL',
		altitude: 225
	},
	{
		zip: '55040',
		name: 'Stazzema',
		province: 'LU',
		altitude: 450
	},
	{
		zip: '22010',
		name: 'Stazzona',
		province: 'CO',
		altitude: 540
	},
	{
		zip: '89843',
		name: 'Stefanaconi',
		province: 'VV',
		altitude: 365
	},
	{
		zip: '17044',
		name: 'Stella',
		province: 'SV',
		altitude: 266
	},
	{
		zip: '84070',
		name: 'Stella Cilento',
		province: 'SA',
		altitude: 386
	},
	{
		zip: '17020',
		name: 'Stellanello',
		province: 'SV',
		altitude: 141
	},
	{
		zip: '39020',
		name: 'Stelvio',
		province: 'BZ',
		altitude: 1310
	},
	{
		zip: '38070',
		name: 'Stenico',
		province: 'TN',
		altitude: 666
	},
	{
		zip: '73010',
		name: 'Sternatia',
		province: 'LE',
		altitude: 75
	},
	{
		zip: '24040',
		name: 'Stezzano',
		province: 'BG',
		altitude: 211
	},
	{
		zip: '45039',
		name: 'Stienta',
		province: 'RO',
		altitude: 9
	},
	{
		zip: '75018',
		name: 'Stigliano',
		province: 'MT',
		altitude: 909
	},
	{
		zip: '89040',
		name: 'Stignano',
		province: 'RC',
		altitude: 343
	},
	{
		zip: '89049',
		name: 'Stilo',
		province: 'RC',
		altitude: 400
	},
	{
		zip: '02048',
		name: 'Stimigliano',
		province: 'RI',
		altitude: 207
	},
	{
		zip: '07040',
		name: 'Stintino',
		province: 'SS',
		altitude: 9
	},
	{
		zip: '84075',
		name: 'Stio',
		province: 'SA',
		altitude: 675
	},
	{
		zip: '71047',
		name: 'Stornara',
		province: 'FG',
		altitude: 107
	},
	{
		zip: '71048',
		name: 'Stornarella',
		province: 'FG',
		altitude: 154
	},
	{
		zip: '38089',
		name: 'Storo',
		province: 'TN',
		altitude: 409
	},
	{
		zip: '30039',
		name: 'Stra',
		province: 'VE',
		altitude: 9
	},
	{
		zip: '27049',
		name: 'Stradella',
		province: 'PV',
		altitude: 101
	},
	{
		zip: '10010',
		name: 'Strambinello',
		province: 'TO',
		altitude: 356
	},
	{
		zip: '10019',
		name: 'Strambino',
		province: 'TO',
		altitude: 240
	},
	{
		zip: '03020',
		name: 'Strangolagalli',
		province: 'FR',
		altitude: 232
	},
	{
		zip: '33040',
		name: 'Stregna',
		province: 'UD',
		altitude: 404
	},
	{
		zip: '38080',
		name: 'Strembo',
		province: 'TN',
		altitude: 714
	},
	{
		zip: '28838',
		name: 'Stresa',
		province: 'VB',
		altitude: 200
	},
	{
		zip: '15019',
		name: 'Strevi',
		province: 'AL',
		altitude: 150
	},
	{
		zip: '80040',
		name: 'Striano',
		province: 'NA',
		altitude: 22
	},
	{
		zip: '13823',
		name: 'Strona',
		province: 'BI',
		altitude: 450
	},
	{
		zip: '05039',
		name: 'Stroncone',
		province: 'TR',
		altitude: 450
	},
	{
		zip: '88815',
		name: 'Strongoli',
		province: 'KR',
		altitude: 342
	},
	{
		zip: '13010',
		name: 'Stroppiana',
		province: 'VC',
		altitude: 119
	},
	{
		zip: '12020',
		name: 'Stroppo',
		province: 'CN',
		altitude: 1087
	},
	{
		zip: '24030',
		name: 'Strozza',
		province: 'BG',
		altitude: 378
	},
	{
		zip: '83055',
		name: 'Sturno',
		province: 'AV',
		altitude: 652
	},
	{
		zip: '27030',
		name: 'Suardi',
		province: 'PV',
		altitude: 84
	},
	{
		zip: '52010',
		name: 'Subbiano',
		province: 'AR',
		altitude: 266
	},
	{
		zip: '00028',
		name: 'Subiaco',
		province: 'RM',
		altitude: 408
	},
	{
		zip: '81030',
		name: 'Succivo',
		province: 'CE',
		altitude: 35
	},
	{
		zip: '23835',
		name: 'Sueglio',
		province: 'LC',
		altitude: 775
	},
	{
		zip: '09040',
		name: 'Suelli',
		province: 'SU',
		altitude: 256
	},
	{
		zip: '23867',
		name: 'Suello',
		province: 'LC',
		altitude: 275
	},
	{
		zip: '24040',
		name: 'Suisio',
		province: 'BG',
		altitude: 234
	},
	{
		zip: '20884',
		name: 'Sulbiate',
		province: 'MB',
		altitude: 227
	},
	{
		zip: '67039',
		name: 'Sulmona',
		province: 'AQ',
		altitude: 405
	},
	{
		zip: '25058',
		name: 'Sulzano',
		province: 'BS',
		altitude: 200
	},
	{
		zip: '21040',
		name: 'Sumirago',
		province: 'VA',
		altitude: 392
	},
	{
		zip: '83010',
		name: 'Summonte',
		province: 'AV',
		altitude: 738
	},
	{
		zip: '09090',
		name: 'Suni',
		province: 'OR',
		altitude: 340
	},
	{
		zip: '28019',
		name: 'Suno',
		province: 'NO',
		altitude: 251
	},
	{
		zip: '73040',
		name: 'Supersano',
		province: 'LE',
		altitude: 105
	},
	{
		zip: '03019',
		name: 'Supino',
		province: 'FR',
		altitude: 321
	},
	{
		zip: '73030',
		name: 'Surano',
		province: 'LE',
		altitude: 102
	},
	{
		zip: '73010',
		name: 'Surbo',
		province: 'LE',
		altitude: 40
	},
	{
		zip: '10059',
		name: 'Susa',
		province: 'TO',
		altitude: 503
	},
	{
		zip: '31058',
		name: 'Susegana',
		province: 'TV',
		altitude: 76
	},
	{
		zip: '46030',
		name: 'Sustinente',
		province: 'MN',
		altitude: 17
	},
	{
		zip: '93010',
		name: 'Sutera',
		province: 'CL',
		altitude: 590
	},
	{
		zip: '01015',
		name: 'Sutri',
		province: 'VT',
		altitude: 291
	},
	{
		zip: '33020',
		name: 'Sutrio',
		province: 'UD',
		altitude: 570
	},
	{
		zip: '57028',
		name: 'Suvereto',
		province: 'LI',
		altitude: 90
	},
	{
		zip: '46029',
		name: 'Suzzara',
		province: 'MN',
		altitude: 20
	},
	{
		zip: '23837',
		name: 'Taceno',
		province: 'LC',
		altitude: 507
	},
	{
		zip: '09080',
		name: 'Tadasuni',
		province: 'OR',
		altitude: 180
	},
	{
		zip: '18018',
		name: 'Taggia',
		province: 'IM',
		altitude: 39
	},
	{
		zip: '67069',
		name: 'Tagliacozzo',
		province: 'AQ',
		altitude: 740
	},
	{
		zip: '45019',
		name: 'Taglio di Po',
		province: 'RO',
		altitude: 0
	},
	{
		zip: '15070',
		name: 'Tagliolo Monferrato',
		province: 'AL',
		altitude: 315
	},
	{
		zip: '32027',
		name: 'Taibon Agordino',
		province: 'BL',
		altitude: 628
	},
	{
		zip: '21020',
		name: 'Taino',
		province: 'VA',
		altitude: 262
	},
	{
		zip: '33040',
		name: 'Taipana',
		province: 'UD',
		altitude: 478
	},
	{
		zip: '47867',
		name: 'Talamello',
		province: 'RN',
		altitude: 386
	},
	{
		zip: '23018',
		name: 'Talamona',
		province: 'SO',
		altitude: 285
	},
	{
		zip: '08040',
		name: 'Talana',
		province: 'NU',
		altitude: 682
	},
	{
		zip: '24010',
		name: 'Taleggio',
		province: 'BG',
		altitude: 758
	},
	{
		zip: '52010',
		name: 'Talla',
		province: 'AR',
		altitude: 348
	},
	{
		zip: '33030',
		name: 'Talmassons',
		province: 'UD',
		altitude: 30
	},
	{
		zip: '32010',
		name: 'Tambre',
		province: 'BL',
		altitude: 922
	},
	{
		zip: '98039',
		name: 'Taormina',
		province: 'ME',
		altitude: 204
	},
	{
		zip: '02040',
		name: 'Tarano',
		province: 'RI',
		altitude: 234
	},
	{
		zip: '66018',
		name: 'Taranta Peligna',
		province: 'CH',
		altitude: 460
	},
	{
		zip: '12020',
		name: 'Tarantasca',
		province: 'CN',
		altitude: 451
	},
	{
		zip: '74121',
		name: 'Taranto',
		province: 'TA',
		altitude: 15
	},
	{
		zip: '33017',
		name: 'Tarcento',
		province: 'UD',
		altitude: 230
	},
	{
		zip: '01016',
		name: 'Tarquinia',
		province: 'VT',
		altitude: 133
	},
	{
		zip: '87040',
		name: 'Tarsia',
		province: 'CS',
		altitude: 192
	},
	{
		zip: '23010',
		name: 'Tartano',
		province: 'SO',
		altitude: 1210
	},
	{
		zip: '33018',
		name: 'Tarvisio',
		province: 'UD',
		altitude: 754
	},
	{
		zip: '31020',
		name: 'Tarzo',
		province: 'TV',
		altitude: 267
	},
	{
		zip: '15060',
		name: 'Tassarolo',
		province: 'AL',
		altitude: 250
	},
	{
		zip: '83020',
		name: 'Taurano',
		province: 'AV',
		altitude: 300
	},
	{
		zip: '83030',
		name: 'Taurasi',
		province: 'AV',
		altitude: 398
	},
	{
		zip: '89029',
		name: 'Taurianova',
		province: 'RC',
		altitude: 210
	},
	{
		zip: '73056',
		name: 'Taurisano',
		province: 'LE',
		altitude: 110
	},
	{
		zip: '33010',
		name: 'Tavagnacco',
		province: 'UD',
		altitude: 137
	},
	{
		zip: '10010',
		name: 'Tavagnasco',
		province: 'TO',
		altitude: 270
	},
	{
		zip: '26838',
		name: 'Tavazzano con Villavesco',
		province: 'LO',
		altitude: 82
	},
	{
		zip: '86030',
		name: 'Tavenna',
		province: 'CB',
		altitude: 550
	},
	{
		zip: '88055',
		name: 'Taverna',
		province: 'CZ',
		altitude: 521
	},
	{
		zip: '22038',
		name: 'Tavernerio',
		province: 'CO',
		altitude: 460
	},
	{
		zip: '24060',
		name: 'Tavernola Bergamasca',
		province: 'BG',
		altitude: 191
	},
	{
		zip: '25060',
		name: 'Tavernole sul Mella',
		province: 'BS',
		altitude: 475
	},
	{
		zip: '73057',
		name: 'Taviano',
		province: 'LE',
		altitude: 58
	},
	{
		zip: '13811',
		name: 'Tavigliano',
		province: 'BI',
		altitude: 659
	},
	{
		zip: '61020',
		name: 'Tavoleto',
		province: 'PU',
		altitude: 426
	},
	{
		zip: '61010',
		name: 'Tavullia',
		province: 'PU',
		altitude: 170
	},
	{
		zip: '85030',
		name: 'Teana',
		province: 'PZ',
		altitude: 806
	},
	{
		zip: '81057',
		name: 'Teano',
		province: 'CE',
		altitude: 168
	},
	{
		zip: '84039',
		name: 'Teggiano',
		province: 'SA',
		altitude: 635
	},
	{
		zip: '23036',
		name: 'Teglio',
		province: 'SO',
		altitude: 851
	},
	{
		zip: '30025',
		name: 'Teglio Veneto',
		province: 'VE',
		altitude: 9
	},
	{
		zip: '82037',
		name: 'Telese Terme',
		province: 'BN',
		altitude: 55
	},
	{
		zip: '24060',
		name: 'Telgate',
		province: 'BG',
		altitude: 191
	},
	{
		zip: '07020',
		name: 'Telti',
		province: 'SS',
		altitude: 326
	},
	{
		zip: '38050',
		name: 'Telve',
		province: 'TN',
		altitude: 548
	},
	{
		zip: '38050',
		name: 'Telve di Sopra',
		province: 'TN',
		altitude: 650
	},
	{
		zip: '07029',
		name: 'Tempio Pausania',
		province: 'SS',
		altitude: 566
	},
	{
		zip: '25050',
		name: 'Temu',
		province: 'BS',
		altitude: 1144
	},
	{
		zip: '38050',
		name: 'Tenna',
		province: 'TN',
		altitude: 569
	},
	{
		zip: '38060',
		name: 'Tenno',
		province: 'TN',
		altitude: 428
	},
	{
		zip: '35037',
		name: 'Teolo',
		province: 'PD',
		altitude: 175
	},
	{
		zip: '83056',
		name: 'Teora',
		province: 'AV',
		altitude: 660
	},
	{
		zip: '64100',
		name: 'Teramo',
		province: 'TE',
		altitude: 265
	},
	{
		zip: '28070',
		name: 'Terdobbiate',
		province: 'NO',
		altitude: 128
	},
	{
		zip: '03040',
		name: 'Terelle',
		province: 'FR',
		altitude: 905
	},
	{
		zip: '39030',
		name: 'Terento',
		province: 'BZ',
		altitude: 1210
	},
	{
		zip: '43040',
		name: 'Terenzo',
		province: 'PR',
		altitude: 541
	},
	{
		zip: '07030',
		name: 'Tergu',
		province: 'SS',
		altitude: 284
	},
	{
		zip: '39018',
		name: 'Terlano',
		province: 'BZ',
		altitude: 250
	},
	{
		zip: '70038',
		name: 'Terlizzi',
		province: 'BA',
		altitude: 190
	},
	{
		zip: '98050',
		name: 'Terme Vigliatore',
		province: 'ME',
		altitude: 10
	},
	{
		zip: '39040',
		name: 'Termeno sulla Strada del Vino',
		province: 'BZ',
		altitude: 276
	},
	{
		zip: '90018',
		name: 'Termini Imerese',
		province: 'PA',
		altitude: 77
	},
	{
		zip: '86039',
		name: 'Termoli',
		province: 'CB',
		altitude: 15
	},
	{
		zip: '21020',
		name: 'Ternate',
		province: 'VA',
		altitude: 281
	},
	{
		zip: '13844',
		name: 'Ternengo',
		province: 'BI',
		altitude: 429
	},
	{
		zip: '05100',
		name: 'Terni',
		province: 'TR',
		altitude: 130
	},
	{
		zip: '24030',
		name: 'Terno d\'\'Isola',
		province: 'BG',
		altitude: 229
	},
	{
		zip: '04019',
		name: 'Terracina',
		province: 'LT',
		altitude: 22
	},
	{
		zip: '38060',
		name: 'Terragnolo',
		province: 'TN',
		altitude: 785
	},
	{
		zip: '09098',
		name: 'Terralba',
		province: 'OR',
		altitude: 9
	},
	{
		zip: '89010',
		name: 'Terranova Sappo Minulio',
		province: 'RC',
		altitude: 250
	},
	{
		zip: '87010',
		name: 'Terranova da Sibari',
		province: 'CS',
		altitude: 313
	},
	{
		zip: '26827',
		name: 'Terranova dei Passerini',
		province: 'LO',
		altitude: 63
	},
	{
		zip: '85030',
		name: 'Terranova di Pollino',
		province: 'PZ',
		altitude: 926
	},
	{
		zip: '52028',
		name: 'Terranuova Bracciolini',
		province: 'AR',
		altitude: 156
	},
	{
		zip: '90049',
		name: 'Terrasini',
		province: 'PA',
		altitude: 32
	},
	{
		zip: '35020',
		name: 'Terrassa Padovana',
		province: 'PD',
		altitude: 6
	},
	{
		zip: '87060',
		name: 'Terravecchia',
		province: 'CS',
		altitude: 472
	},
	{
		zip: '56030',
		name: 'Terricciola',
		province: 'PI',
		altitude: 180
	},
	{
		zip: '15030',
		name: 'Terruggia',
		province: 'AL',
		altitude: 199
	},
	{
		zip: '08047',
		name: 'Tertenia',
		province: 'NU',
		altitude: 129
	},
	{
		zip: '80040',
		name: 'Terzigno',
		province: 'NA',
		altitude: 105
	},
	{
		zip: '15010',
		name: 'Terzo',
		province: 'AL',
		altitude: 222
	},
	{
		zip: '33050',
		name: 'Terzo d\'\'Aquileia',
		province: 'UD',
		altitude: 5
	},
	{
		zip: '38027',
		name: 'Terzolas',
		province: 'TN',
		altitude: 755
	},
	{
		zip: '18010',
		name: 'Terzorio',
		province: 'IM',
		altitude: 185
	},
	{
		zip: '38038',
		name: 'Tesero',
		province: 'TN',
		altitude: 1000
	},
	{
		zip: '39010',
		name: 'Tesimo',
		province: 'BZ',
		altitude: 635
	},
	{
		zip: '01010',
		name: 'Tessennano',
		province: 'VT',
		altitude: 302
	},
	{
		zip: '17020',
		name: 'Testico',
		province: 'SV',
		altitude: 473
	},
	{
		zip: '08030',
		name: 'Teti',
		province: 'NU',
		altitude: 714
	},
	{
		zip: '09019',
		name: 'Teulada',
		province: 'SU',
		altitude: 50
	},
	{
		zip: '81030',
		name: 'Teverola',
		province: 'CE',
		altitude: 25
	},
	{
		zip: '36056',
		name: 'Tezze sul Brenta',
		province: 'VI',
		altitude: 69
	},
	{
		zip: '36016',
		name: 'Thiene',
		province: 'VI',
		altitude: 147
	},
	{
		zip: '07047',
		name: 'Thiesi',
		province: 'SS',
		altitude: 461
	},
	{
		zip: '08020',
		name: 'Tiana',
		province: 'NU',
		altitude: 564
	},
	{
		zip: '26010',
		name: 'Ticengo',
		province: 'CR',
		altitude: 76
	},
	{
		zip: '15040',
		name: 'Ticineto',
		province: 'AL',
		altitude: 102
	},
	{
		zip: '73030',
		name: 'Tiggiano',
		province: 'LE',
		altitude: 128
	},
	{
		zip: '16010',
		name: 'Tiglieto',
		province: 'GE',
		altitude: 500
	},
	{
		zip: '14016',
		name: 'Tigliole',
		province: 'AT',
		altitude: 239
	},
	{
		zip: '25080',
		name: 'Tignale',
		province: 'BS',
		altitude: 555
	},
	{
		zip: '09090',
		name: 'Tinnura',
		province: 'OR',
		altitude: 328
	},
	{
		zip: '67020',
		name: 'Tione degli Abruzzi',
		province: 'AQ',
		altitude: 581
	},
	{
		zip: '38079',
		name: 'Tione di Trento',
		province: 'TN',
		altitude: 565
	},
	{
		zip: '23037',
		name: 'Tirano',
		province: 'SO',
		altitude: 441
	},
	{
		zip: '39050',
		name: 'Tires',
		province: 'BZ',
		altitude: 1028
	},
	{
		zip: '88056',
		name: 'Tiriolo',
		province: 'CZ',
		altitude: 690
	},
	{
		zip: '39019',
		name: 'Tirolo',
		province: 'BZ',
		altitude: 594
	},
	{
		zip: '07040',
		name: 'Tissi',
		province: 'SS',
		altitude: 250
	},
	{
		zip: '85050',
		name: 'Tito',
		province: 'PZ',
		altitude: 650
	},
	{
		zip: '00019',
		name: 'Tivoli',
		province: 'RO',
		altitude: 235
	},
	{
		zip: '43028',
		name: 'Tizzano Val Parma',
		province: 'PR',
		altitude: 814
	},
	{
		zip: '42010',
		name: 'Toano',
		province: 'RE',
		altitude: 842
	},
	{
		zip: '82030',
		name: 'Tocco Caudio',
		province: 'BN',
		altitude: 500
	},
	{
		zip: '65028',
		name: 'Tocco da Casauria',
		province: 'PE',
		altitude: 356
	},
	{
		zip: '28858',
		name: 'Toceno',
		province: 'VB',
		altitude: 907
	},
	{
		zip: '06059',
		name: 'Todi',
		province: 'PG',
		altitude: 400
	},
	{
		zip: '02039',
		name: 'Toffia',
		province: 'RI',
		altitude: 262
	},
	{
		zip: '17055',
		name: 'Toirano',
		province: 'SV',
		altitude: 38
	},
	{
		zip: '62029',
		name: 'Tolentino',
		province: 'MC',
		altitude: 228
	},
	{
		zip: '00059',
		name: 'Tolfa',
		province: 'RM',
		altitude: 484
	},
	{
		zip: '13818',
		name: 'Tollegno',
		province: 'BI',
		altitude: 495
	},
	{
		zip: '66010',
		name: 'Tollo',
		province: 'CH',
		altitude: 152
	},
	{
		zip: '33028',
		name: 'Tolmezzo',
		province: 'UD',
		altitude: 323
	},
	{
		zip: '85017',
		name: 'Tolve',
		province: 'PZ',
		altitude: 568
	},
	{
		zip: '35019',
		name: 'Tombolo',
		province: 'PD',
		altitude: 42
	},
	{
		zip: '38010',
		name: 'Ton',
		province: 'TN',
		altitude: 482
	},
	{
		zip: '08039',
		name: 'Tonara',
		province: 'NU',
		altitude: 900
	},
	{
		zip: '14039',
		name: 'Tonco',
		province: 'AT',
		altitude: 271
	},
	{
		zip: '14023',
		name: 'Tonengo',
		province: 'AT',
		altitude: 430
	},
	{
		zip: '36040',
		name: 'Tonezza del Cimone',
		province: 'VI',
		altitude: 1001
	},
	{
		zip: '81044',
		name: 'Tora e Piccilli',
		province: 'CE',
		altitude: 343
	},
	{
		zip: '87010',
		name: 'Torano Castello',
		province: 'CS',
		altitude: 370
	},
	{
		zip: '64010',
		name: 'Torano Nuovo',
		province: 'TE',
		altitude: 237
	},
	{
		zip: '25030',
		name: 'Torbole Casaglia',
		province: 'BS',
		altitude: 114
	},
	{
		zip: '38050',
		name: 'Torcegno',
		province: 'TN',
		altitude: 769
	},
	{
		zip: '84076',
		name: 'Torchiara',
		province: 'SA',
		altitude: 360
	},
	{
		zip: '72020',
		name: 'Torchiarolo',
		province: 'BR',
		altitude: 28
	},
	{
		zip: '83057',
		name: 'Torella dei Lombardi',
		province: 'AV',
		altitude: 666
	},
	{
		zip: '86028',
		name: 'Torella del Sannio',
		province: 'CB',
		altitude: 837
	},
	{
		zip: '06089',
		name: 'Torgiano',
		province: 'PG',
		altitude: 219
	},
	{
		zip: '11020',
		name: 'Torgnon',
		province: 'AO',
		altitude: 1489
	},
	{
		zip: '10121',
		name: 'Torino',
		province: 'TO',
		altitude: 239
	},
	{
		zip: '66020',
		name: 'Torino di Sangro',
		province: 'CH',
		altitude: 164
	},
	{
		zip: '70020',
		name: 'Toritto',
		province: 'BA',
		altitude: 240
	},
	{
		zip: '26017',
		name: 'Torlino Vimercati',
		province: 'CR',
		altitude: 88
	},
	{
		zip: '28070',
		name: 'Tornaco',
		province: 'NO',
		altitude: 122
	},
	{
		zip: '66046',
		name: 'Tornareccio',
		province: 'CH',
		altitude: 630
	},
	{
		zip: '26030',
		name: 'Tornata',
		province: 'CR',
		altitude: 29
	},
	{
		zip: '67049',
		name: 'Tornimparte',
		province: 'AQ',
		altitude: 830
	},
	{
		zip: '22020',
		name: 'Torno',
		province: 'CO',
		altitude: 225
	},
	{
		zip: '43059',
		name: 'Tornolo',
		province: 'PR',
		altitude: 620
	},
	{
		zip: '86018',
		name: 'Toro',
		province: 'CB',
		altitude: 588
	},
	{
		zip: '08020',
		name: 'Torpe',
		province: 'NU',
		altitude: 24
	},
	{
		zip: '84030',
		name: 'Torraca',
		province: 'SA',
		altitude: 425
	},
	{
		zip: '07048',
		name: 'Torralba',
		province: 'SS',
		altitude: 435
	},
	{
		zip: '27050',
		name: 'Torrazza Coste',
		province: 'PV',
		altitude: 159
	},
	{
		zip: '10037',
		name: 'Torrazza Piemonte',
		province: 'TO',
		altitude: 225
	},
	{
		zip: '13884',
		name: 'Torrazzo',
		province: 'BI',
		altitude: 622
	},
	{
		zip: '80058',
		name: 'Torre Annunziata',
		province: 'NA',
		altitude: 9
	},
	{
		zip: '27030',
		name: 'Torre Beretti e Castellaro',
		province: 'PV',
		altitude: 89
	},
	{
		zip: '24020',
		name: 'Torre Boldone',
		province: 'BG',
		altitude: 280
	},
	{
		zip: '12070',
		name: 'Torre Bormida',
		province: 'CN',
		altitude: 391
	},
	{
		zip: '03010',
		name: 'Torre Cajetani',
		province: 'FR',
		altitude: 819
	},
	{
		zip: '10010',
		name: 'Torre Canavese',
		province: 'TO',
		altitude: 417
	},
	{
		zip: '83030',
		name: 'Torre Le Nocelle',
		province: 'AV',
		altitude: 420
	},
	{
		zip: '12080',
		name: 'Torre Mondovi',
		province: 'CN',
		altitude: 460
	},
	{
		zip: '84077',
		name: 'Torre Orsaia',
		province: 'SA',
		altitude: 295
	},
	{
		zip: '24050',
		name: 'Torre Pallavicina',
		province: 'BG',
		altitude: 95
	},
	{
		zip: '10066',
		name: 'Torre Pellice',
		province: 'TO',
		altitude: 516
	},
	{
		zip: '12030',
		name: 'Torre San Giorgio',
		province: 'CN',
		altitude: 262
	},
	{
		zip: '63814',
		name: 'Torre San Patrizio',
		province: 'FM',
		altitude: 224
	},
	{
		zip: '72028',
		name: 'Torre Santa Susanna',
		province: 'BR',
		altitude: 72
	},
	{
		zip: '27010',
		name: 'Torre d\'\'Arese',
		province: 'PV',
		altitude: 78
	},
	{
		zip: '27020',
		name: 'Torre d\'\'Isola',
		province: 'PV',
		altitude: 84
	},
	{
		zip: '24032',
		name: 'Torre de Busi',
		province: 'BG',
		altitude: 472
	},
	{
		zip: '27011',
		name: 'Torre de Negri',
		province: 'PV',
		altitude: 73
	},
	{
		zip: '65029',
		name: 'Torre de Passeri',
		province: 'PE',
		altitude: 172
	},
	{
		zip: '26038',
		name: 'Torre de Picenardi',
		province: 'CR',
		altitude: 37
	},
	{
		zip: '24060',
		name: 'Torre de Roveri',
		province: 'BG',
		altitude: 271
	},
	{
		zip: '80059',
		name: 'Torre del Greco',
		province: 'NA',
		altitude: 43
	},
	{
		zip: '30020',
		name: 'Torre di Mosto',
		province: 'VE',
		altitude: 2
	},
	{
		zip: '88060',
		name: 'Torre di Ruggiero',
		province: 'CZ',
		altitude: 566
	},
	{
		zip: '23020',
		name: 'Torre di Santa Maria',
		province: 'SO',
		altitude: 795
	},
	{
		zip: '33040',
		name: 'Torreano',
		province: 'UD',
		altitude: 189
	},
	{
		zip: '36036',
		name: 'Torrebelvicino',
		province: 'VI',
		altitude: 260
	},
	{
		zip: '66050',
		name: 'Torrebruna',
		province: 'CH',
		altitude: 845
	},
	{
		zip: '82030',
		name: 'Torrecuso',
		province: 'BN',
		altitude: 420
	},
	{
		zip: '35038',
		name: 'Torreglia',
		province: 'PD',
		altitude: 16
	},
	{
		zip: '98040',
		name: 'Torregrotta',
		province: 'ME',
		altitude: 44
	},
	{
		zip: '71017',
		name: 'Torremaggiore',
		province: 'FG',
		altitude: 169
	},
	{
		zip: '98070',
		name: 'Torrenova',
		province: 'ME',
		altitude: 10
	},
	{
		zip: '12070',
		name: 'Torresina',
		province: 'CN',
		altitude: 704
	},
	{
		zip: '90040',
		name: 'Torretta',
		province: 'PA',
		altitude: 325
	},
	{
		zip: '27010',
		name: 'Torrevecchia Pia',
		province: 'PV',
		altitude: 84
	},
	{
		zip: '66010',
		name: 'Torrevecchia Teatina',
		province: 'CH',
		altitude: 220
	},
	{
		zip: '37010',
		name: 'Torri del Benaco',
		province: 'VR',
		altitude: 67
	},
	{
		zip: '36040',
		name: 'Torri di Quartesolo',
		province: 'VI',
		altitude: 30
	},
	{
		zip: '02049',
		name: 'Torri in Sabina',
		province: 'RI',
		altitude: 275
	},
	{
		zip: '03020',
		name: 'Torrice',
		province: 'FR',
		altitude: 321
	},
	{
		zip: '74020',
		name: 'Torricella',
		province: 'TA',
		altitude: 32
	},
	{
		zip: '66019',
		name: 'Torricella Peligna',
		province: 'CH',
		altitude: 910
	},
	{
		zip: '64010',
		name: 'Torricella Sicura',
		province: 'TE',
		altitude: 437
	},
	{
		zip: '27050',
		name: 'Torricella Verzate',
		province: 'PV',
		altitude: 160
	},
	{
		zip: '26040',
		name: 'Torricella del Pizzo',
		province: 'CR',
		altitude: 29
	},
	{
		zip: '02030',
		name: 'Torricella in Sabina',
		province: 'RI',
		altitude: 615
	},
	{
		zip: '16029',
		name: 'Torriglia',
		province: 'GE',
		altitude: 769
	},
	{
		zip: '43056',
		name: 'Torrile',
		province: 'PR',
		altitude: 32
	},
	{
		zip: '83010',
		name: 'Torrioni',
		province: 'AV',
		altitude: 645
	},
	{
		zip: '00060',
		name: 'Torrita Tiberina',
		province: 'RM',
		altitude: 179
	},
	{
		zip: '53049',
		name: 'Torrita di Siena',
		province: 'SI',
		altitude: 325
	},
	{
		zip: '08048',
		name: 'Tortoli',
		province: 'NU',
		altitude: 13
	},
	{
		zip: '15057',
		name: 'Tortona',
		province: 'AL',
		altitude: 122
	},
	{
		zip: '87020',
		name: 'Tortora',
		province: 'CS',
		altitude: 300
	},
	{
		zip: '84030',
		name: 'Tortorella',
		province: 'SA',
		altitude: 582
	},
	{
		zip: '64018',
		name: 'Tortoreto',
		province: 'TE',
		altitude: 227
	},
	{
		zip: '98078',
		name: 'Tortorici',
		province: 'ME',
		altitude: 468
	},
	{
		zip: '33050',
		name: 'Torviscosa',
		province: 'UD',
		altitude: 3
	},
	{
		zip: '25084',
		name: 'Toscolano-Maderno',
		province: 'BS',
		altitude: 86
	},
	{
		zip: '64049',
		name: 'Tossicia',
		province: 'TE',
		altitude: 409
	},
	{
		zip: '17020',
		name: 'Tovo San Giacomo',
		province: 'SV',
		altitude: 47
	},
	{
		zip: '23030',
		name: 'Tovo di Sant\'\'Agata',
		province: 'SO',
		altitude: 531
	},
	{
		zip: '90019',
		name: 'Trabia',
		province: 'PA',
		altitude: 50
	},
	{
		zip: '21049',
		name: 'Tradate',
		province: 'VA',
		altitude: 303
	},
	{
		zip: '09070',
		name: 'Tramatza',
		province: 'OR',
		altitude: 19
	},
	{
		zip: '38068',
		name: 'Trambileno',
		province: 'TN',
		altitude: 525
	},
	{
		zip: '84010',
		name: 'Tramonti',
		province: 'SA',
		altitude: 321
	},
	{
		zip: '33090',
		name: 'Tramonti di Sopra',
		province: 'PN',
		altitude: 420
	},
	{
		zip: '33090',
		name: 'Tramonti di Sotto',
		province: 'PN',
		altitude: 366
	},
	{
		zip: '85057',
		name: 'Tramutola',
		province: 'PZ',
		altitude: 650
	},
	{
		zip: '10090',
		name: 'Trana',
		province: 'TO',
		altitude: 372
	},
	{
		zip: '76125',
		name: 'Trani',
		province: 'BT',
		altitude: 7
	},
	{
		zip: '23019',
		name: 'Traona',
		province: 'SO',
		altitude: 252
	},
	{
		zip: '91100',
		name: 'Trapani',
		province: 'TP',
		altitude: 3
	},
	{
		zip: '90040',
		name: 'Trappeto',
		province: 'PA',
		altitude: 8
	},
	{
		zip: '28826',
		name: 'Trarego Viggiona',
		province: 'VB',
		altitude: 771
	},
	{
		zip: '67059',
		name: 'Trasacco',
		province: 'AQ',
		altitude: 685
	},
	{
		zip: '33010',
		name: 'Trasaghis',
		province: 'UD',
		altitude: 217
	},
	{
		zip: '28868',
		name: 'Trasquera',
		province: 'VB',
		altitude: 1100
	},
	{
		zip: '09010',
		name: 'Tratalias',
		province: 'SU',
		altitude: 17
	},
	{
		zip: '27020',
		name: 'Travaco Siccomario',
		province: 'PV',
		altitude: 61
	},
	{
		zip: '25039',
		name: 'Travagliato',
		province: 'BS',
		altitude: 129
	},
	{
		zip: '21028',
		name: 'Travedona-Monate',
		province: 'VA',
		altitude: 273
	},
	{
		zip: '10080',
		name: 'Traversella',
		province: 'TO',
		altitude: 827
	},
	{
		zip: '43029',
		name: 'Traversetolo',
		province: 'PR',
		altitude: 176
	},
	{
		zip: '10070',
		name: 'Traves',
		province: 'TO',
		altitude: 628
	},
	{
		zip: '33090',
		name: 'Travesio',
		province: 'PN',
		altitude: 226
	},
	{
		zip: '29020',
		name: 'Travo',
		province: 'PC',
		altitude: 171
	},
	{
		zip: '38095',
		name: 'Tre Ville',
		province: 'TN',
		altitude: 575
	},
	{
		zip: '35010',
		name: 'Trebaseleghe',
		province: 'PD',
		altitude: 22
	},
	{
		zip: '87075',
		name: 'Trebisacce',
		province: 'CS',
		altitude: 73
	},
	{
		zip: '80040',
		name: 'Trecase',
		province: 'NA',
		altitude: 99
	},
	{
		zip: '95039',
		name: 'Trecastagni',
		province: 'CT',
		altitude: 586
	},
	{
		zip: '60012',
		name: 'Trecastelli',
		province: 'AN',
		altitude: 143
	},
	{
		zip: '28069',
		name: 'Trecate',
		province: 'NO',
		altitude: 136
	},
	{
		zip: '85049',
		name: 'Trecchina',
		province: 'PZ',
		altitude: 500
	},
	{
		zip: '45027',
		name: 'Trecenta',
		province: 'RO',
		altitude: 11
	},
	{
		zip: '47019',
		name: 'Tredozio',
		province: 'FC',
		altitude: 334
	},
	{
		zip: '66030',
		name: 'Treglio',
		province: 'CH',
		altitude: 183
	},
	{
		zip: '37039',
		name: 'Tregnago',
		province: 'VR',
		altitude: 317
	},
	{
		zip: '62010',
		name: 'Treia',
		province: 'MC',
		altitude: 342
	},
	{
		zip: '12050',
		name: 'Treiso',
		province: 'CN',
		altitude: 410
	},
	{
		zip: '95030',
		name: 'Tremestieri Etneo',
		province: 'CT',
		altitude: 400
	},
	{
		zip: '22016',
		name: 'Tremezzina',
		province: 'CO',
		altitude: 209
	},
	{
		zip: '25010',
		name: 'Tremosine sul Garda',
		province: 'BS',
		altitude: 414
	},
	{
		zip: '84070',
		name: 'Trentinara',
		province: 'SA',
		altitude: 606
	},
	{
		zip: '38121',
		name: 'Trento',
		province: 'TN',
		altitude: 194
	},
	{
		zip: '81038',
		name: 'Trentola Ducenta',
		province: 'CE',
		altitude: 42
	},
	{
		zip: '25030',
		name: 'Trenzano',
		province: 'BS',
		altitude: 108
	},
	{
		zip: '33010',
		name: 'Treppo Grande',
		province: 'UD',
		altitude: 231
	},
	{
		zip: '33014',
		name: 'Treppo Ligosullo',
		province: 'UD',
		altitude: 671
	},
	{
		zip: '73019',
		name: 'Trepuzzi',
		province: 'LE',
		altitude: 55
	},
	{
		zip: '53020',
		name: 'Trequanda',
		province: 'SI',
		altitude: 453
	},
	{
		zip: '54012',
		name: 'Tresana',
		province: 'MS',
		altitude: 112
	},
	{
		zip: '24069',
		name: 'Trescore Balneario',
		province: 'BG',
		altitude: 271
	},
	{
		zip: '26017',
		name: 'Trescore Cremasco',
		province: 'CR',
		altitude: 86
	},
	{
		zip: '23020',
		name: 'Tresivio',
		province: 'SO',
		altitude: 520
	},
	{
		zip: '09079',
		name: 'Tresnuraghes',
		province: 'OR',
		altitude: 257
	},
	{
		zip: '37060',
		name: 'Trevenzuolo',
		province: 'VR',
		altitude: 31
	},
	{
		zip: '06039',
		name: 'Trevi',
		province: 'PG',
		altitude: 412
	},
	{
		zip: '03010',
		name: 'Trevi nel Lazio',
		province: 'FR',
		altitude: 821
	},
	{
		zip: '83058',
		name: 'Trevico',
		province: 'AV',
		altitude: 1094
	},
	{
		zip: '24047',
		name: 'Treviglio',
		province: 'BG',
		altitude: 125
	},
	{
		zip: '31040',
		name: 'Trevignano',
		province: 'TV',
		altitude: 77
	},
	{
		zip: '00069',
		name: 'Trevignano Romano',
		province: 'RM',
		altitude: 173
	},
	{
		zip: '15030',
		name: 'Treville',
		province: 'AL',
		altitude: 300
	},
	{
		zip: '24048',
		name: 'Treviolo',
		province: 'BG',
		altitude: 225
	},
	{
		zip: '31100',
		name: 'Treviso',
		province: 'TV',
		altitude: 15
	},
	{
		zip: '25070',
		name: 'Treviso Bresciano',
		province: 'BS',
		altitude: 687
	},
	{
		zip: '20060',
		name: 'Trezzano Rosa',
		province: 'MI',
		altitude: 170
	},
	{
		zip: '20090',
		name: 'Trezzano sul Naviglio',
		province: 'MI',
		altitude: 116
	},
	{
		zip: '12050',
		name: 'Trezzo Tinella',
		province: 'CN',
		altitude: 341
	},
	{
		zip: '20056',
		name: 'Trezzo sull\'\'Adda',
		province: 'MI',
		altitude: 187
	},
	{
		zip: '22010',
		name: 'Trezzone',
		province: 'CO',
		altitude: 430
	},
	{
		zip: '35020',
		name: 'Tribano',
		province: 'PD',
		altitude: 7
	},
	{
		zip: '20067',
		name: 'Tribiano',
		province: 'MI',
		altitude: 93
	},
	{
		zip: '16030',
		name: 'Tribogna',
		province: 'GE',
		altitude: 329
	},
	{
		zip: '75019',
		name: 'Tricarico',
		province: 'MT',
		altitude: 698
	},
	{
		zip: '73039',
		name: 'Tricase',
		province: 'LE',
		altitude: 98
	},
	{
		zip: '13038',
		name: 'Tricerro',
		province: 'VC',
		altitude: 141
	},
	{
		zip: '33019',
		name: 'Tricesimo',
		province: 'UD',
		altitude: 199
	},
	{
		zip: '08040',
		name: 'Triei',
		province: 'NU',
		altitude: 140
	},
	{
		zip: '34121',
		name: 'Trieste',
		province: 'TS',
		altitude: 2
	},
	{
		zip: '70019',
		name: 'Triggiano',
		province: 'BA',
		altitude: 60
	},
	{
		zip: '26018',
		name: 'Trigolo',
		province: 'CR',
		altitude: 70
	},
	{
		zip: '76015',
		name: 'Trinitapoli',
		province: 'BT',
		altitude: 5
	},
	{
		zip: '12049',
		name: 'Trinita',
		province: 'CN',
		altitude: 383
	},
	{
		zip: '07038',
		name: 'Trinita d\'\'Agultu e Vignola',
		province: 'SS',
		altitude: 365
	},
	{
		zip: '13039',
		name: 'Trino',
		province: 'VC',
		altitude: 130
	},
	{
		zip: '18010',
		name: 'Triora',
		province: 'IM',
		altitude: 780
	},
	{
		zip: '98060',
		name: 'Tripi',
		province: 'ME',
		altitude: 450
	},
	{
		zip: '15070',
		name: 'Trisobbio',
		province: 'AL',
		altitude: 341
	},
	{
		zip: '36070',
		name: 'Trissino',
		province: 'VI',
		altitude: 125
	},
	{
		zip: '20844',
		name: 'Triuggio',
		province: 'MB',
		altitude: 231
	},
	{
		zip: '86029',
		name: 'Trivento',
		province: 'CB',
		altitude: 599
	},
	{
		zip: '03010',
		name: 'Trivigliano',
		province: 'FR',
		altitude: 780
	},
	{
		zip: '33050',
		name: 'Trivignano Udinese',
		province: 'UD',
		altitude: 43
	},
	{
		zip: '85018',
		name: 'Trivigno',
		province: 'PZ',
		altitude: 725
	},
	{
		zip: '27020',
		name: 'Trivolzio',
		province: 'PV',
		altitude: 97
	},
	{
		zip: '39040',
		name: 'Trodena nel parco naturale',
		province: 'BZ',
		altitude: 1127
	},
	{
		zip: '10028',
		name: 'Trofarello',
		province: 'TO',
		altitude: 276
	},
	{
		zip: '71029',
		name: 'Troia',
		province: 'FG',
		altitude: 439
	},
	{
		zip: '94018',
		name: 'Troina',
		province: 'EN',
		altitude: 1121
	},
	{
		zip: '27020',
		name: 'Tromello',
		province: 'PV',
		altitude: 97
	},
	{
		zip: '28859',
		name: 'Trontano',
		province: 'VB',
		altitude: 520
	},
	{
		zip: '21010',
		name: 'Tronzano Lago Maggiore',
		province: 'VA',
		altitude: 342
	},
	{
		zip: '13049',
		name: 'Tronzano Vercellese',
		province: 'VC',
		altitude: 182
	},
	{
		zip: '89861',
		name: 'Tropea',
		province: 'VV',
		altitude: 61
	},
	{
		zip: '27020',
		name: 'Trovo',
		province: 'PV',
		altitude: 97
	},
	{
		zip: '20060',
		name: 'Truccazzano',
		province: 'MI',
		altitude: 108
	},
	{
		zip: '39020',
		name: 'Tubre',
		province: 'BZ',
		altitude: 1240
	},
	{
		zip: '86010',
		name: 'Tufara',
		province: 'CB',
		altitude: 420
	},
	{
		zip: '66050',
		name: 'Tufillo',
		province: 'CH',
		altitude: 578
	},
	{
		zip: '80030',
		name: 'Tufino',
		province: 'NA',
		altitude: 91
	},
	{
		zip: '83010',
		name: 'Tufo',
		province: 'AV',
		altitude: 280
	},
	{
		zip: '73058',
		name: 'Tuglie',
		province: 'LE',
		altitude: 74
	},
	{
		zip: '09029',
		name: 'Tuili',
		province: 'SU',
		altitude: 208
	},
	{
		zip: '07010',
		name: 'Tula',
		province: 'SS',
		altitude: 275
	},
	{
		zip: '06069',
		name: 'Tuoro sul Trasimeno',
		province: 'PG',
		altitude: 309
	},
	{
		zip: '02020',
		name: 'Turania',
		province: 'RI',
		altitude: 703
	},
	{
		zip: '26828',
		name: 'Turano Lodigiano',
		province: 'LO',
		altitude: 68
	},
	{
		zip: '22078',
		name: 'Turate',
		province: 'CO',
		altitude: 240
	},
	{
		zip: '20029',
		name: 'Turbigo',
		province: 'MI',
		altitude: 146
	},
	{
		zip: '70010',
		name: 'Turi',
		province: 'BA',
		altitude: 251
	},
	{
		zip: '09020',
		name: 'Turri',
		province: 'SU',
		altitude: 164
	},
	{
		zip: '34070',
		name: 'Turriaco',
		province: 'GO',
		altitude: 12
	},
	{
		zip: '65020',
		name: 'Turrivalignani',
		province: 'PE',
		altitude: 312
	},
	{
		zip: '75028',
		name: 'Tursi',
		province: 'MT',
		altitude: 210
	},
	{
		zip: '98079',
		name: 'Tusa',
		province: 'ME',
		altitude: 614
	},
	{
		zip: '01017',
		name: 'Tuscania',
		province: 'VT',
		altitude: 165
	},
	{
		zip: '24010',
		name: 'Ubiale Clanezzo',
		province: 'BG',
		altitude: 336
	},
	{
		zip: '21040',
		name: 'Uboldo',
		province: 'VA',
		altitude: 205
	},
	{
		zip: '98060',
		name: 'Ucria',
		province: 'ME',
		altitude: 710
	},
	{
		zip: '33100',
		name: 'Udine',
		province: 'UD',
		altitude: 113
	},
	{
		zip: '73059',
		name: 'Ugento',
		province: 'LE',
		altitude: 108
	},
	{
		zip: '73020',
		name: 'Uggiano la Chiesa',
		province: 'LE',
		altitude: 77
	},
	{
		zip: '22029',
		name: 'Uggiate-Trevano',
		province: 'CO',
		altitude: 414
	},
	{
		zip: '08040',
		name: 'Ulassai',
		province: 'NU',
		altitude: 775
	},
	{
		zip: '39016',
		name: 'Ultimo',
		province: 'BZ',
		altitude: 1190
	},
	{
		zip: '09080',
		name: 'Ula Tirso',
		province: 'OR',
		altitude: 348
	},
	{
		zip: '06019',
		name: 'Umbertide',
		province: 'PG',
		altitude: 247
	},
	{
		zip: '88823',
		name: 'Umbriatico',
		province: 'KR',
		altitude: 422
	},
	{
		zip: '25030',
		name: 'Urago d\'\'Oglio',
		province: 'BS',
		altitude: 131
	},
	{
		zip: '09099',
		name: 'Uras',
		province: 'OR',
		altitude: 23
	},
	{
		zip: '35040',
		name: 'Urbana',
		province: 'PD',
		altitude: 13
	},
	{
		zip: '61049',
		name: 'Urbania',
		province: 'PU',
		altitude: 273
	},
	{
		zip: '17048',
		name: 'Urbe',
		province: 'SV',
		altitude: 540
	},
	{
		zip: '61029',
		name: 'Urbino',
		province: 'PU',
		altitude: 485
	},
	{
		zip: '62010',
		name: 'Urbisaglia',
		province: 'MC',
		altitude: 310
	},
	{
		zip: '24059',
		name: 'Urgnano',
		province: 'BG',
		altitude: 173
	},
	{
		zip: '07040',
		name: 'Uri',
		province: 'SS',
		altitude: 150
	},
	{
		zip: '86049',
		name: 'Ururi',
		province: 'CB',
		altitude: 262
	},
	{
		zip: '08040',
		name: 'Urzulei',
		province: 'NU',
		altitude: 511
	},
	{
		zip: '16036',
		name: 'Uscio',
		province: 'GE',
		altitude: 361
	},
	{
		zip: '09090',
		name: 'Usellus',
		province: 'OR',
		altitude: 289
	},
	{
		zip: '07049',
		name: 'Usini',
		province: 'SS',
		altitude: 200
	},
	{
		zip: '20865',
		name: 'Usmate Velate',
		province: 'MB',
		altitude: 221
	},
	{
		zip: '09020',
		name: 'Ussana',
		province: 'SU',
		altitude: 97
	},
	{
		zip: '09020',
		name: 'Ussaramanna',
		province: 'SU',
		altitude: 157
	},
	{
		zip: '08040',
		name: 'Ussassai',
		province: 'NU',
		altitude: 710
	},
	{
		zip: '10060',
		name: 'Usseaux',
		province: 'TO',
		altitude: 1416
	},
	{
		zip: '10070',
		name: 'Usseglio',
		province: 'TO',
		altitude: 1265
	},
	{
		zip: '62039',
		name: 'Ussita',
		province: 'MC',
		altitude: 744
	},
	{
		zip: '90051',
		name: 'Ustica',
		province: 'PA',
		altitude: 49
	},
	{
		zip: '09068',
		name: 'Uta',
		province: 'CA',
		altitude: 6
	},
	{
		zip: '51010',
		name: 'Uzzano',
		province: 'PT',
		altitude: 50
	},
	{
		zip: '87060',
		name: 'Vaccarizzo Albanese',
		province: 'CS',
		altitude: 448
	},
	{
		zip: '02040',
		name: 'Vacone',
		province: 'RI',
		altitude: 517
	},
	{
		zip: '66010',
		name: 'Vacri',
		province: 'CH',
		altitude: 310
	},
	{
		zip: '39051',
		name: 'Vadena',
		province: 'BZ',
		altitude: 243
	},
	{
		zip: '17047',
		name: 'Vado Ligure',
		province: 'SV',
		altitude: 12
	},
	{
		zip: '55030',
		name: 'Vagli Sotto',
		province: 'LU',
		altitude: 575
	},
	{
		zip: '50036',
		name: 'Vaglia',
		province: 'FI',
		altitude: 290
	},
	{
		zip: '85010',
		name: 'Vaglio Basilicata',
		province: 'PZ',
		altitude: 954
	},
	{
		zip: '14049',
		name: 'Vaglio Serra',
		province: 'AT',
		altitude: 278
	},
	{
		zip: '59021',
		name: 'Vaiano',
		province: 'PO',
		altitude: 150
	},
	{
		zip: '26010',
		name: 'Vaiano Cremasco',
		province: 'CR',
		altitude: 82
	},
	{
		zip: '10050',
		name: 'Vaie',
		province: 'TO',
		altitude: 381
	},
	{
		zip: '26019',
		name: 'Vailate',
		province: 'CR',
		altitude: 105
	},
	{
		zip: '81058',
		name: 'Vairano Patenora',
		province: 'CE',
		altitude: 168
	},
	{
		zip: '33080',
		name: 'Vajont',
		province: 'PN',
		altitude: 282
	},
	{
		zip: '24012',
		name: 'Val Brembilla',
		province: 'BG',
		altitude: 425
	},
	{
		zip: '36044',
		name: 'Val Liona',
		province: 'VI',
		altitude: 90
	},
	{
		zip: '23010',
		name: 'Val Masino',
		province: 'SO',
		altitude: 787
	},
	{
		zip: '22010',
		name: 'Val Rezzo',
		province: 'CO',
		altitude: 1044
	},
	{
		zip: '10040',
		name: 'Val della Torre',
		province: 'TO',
		altitude: 510
	},
	{
		zip: '10039',
		name: 'Val di Chy',
		province: 'TO',
		altitude: 650
	},
	{
		zip: '27050',
		name: 'Val di Nizza',
		province: 'PV',
		altitude: 412
	},
	{
		zip: '39049',
		name: 'Val di Vizze',
		province: 'BZ',
		altitude: 948
	},
	{
		zip: '32012',
		name: 'Val di Zoldo',
		province: 'BL',
		altitude: 1177
	},
	{
		zip: '24020',
		name: 'Valbondione',
		province: 'BG',
		altitude: 900
	},
	{
		zip: '24030',
		name: 'Valbrembo',
		province: 'BG',
		altitude: 261
	},
	{
		zip: '36029',
		name: 'Valbrenta',
		province: 'VI',
		altitude: 160
	},
	{
		zip: '16010',
		name: 'Valbrevenna',
		province: 'GE',
		altitude: 533
	},
	{
		zip: '22039',
		name: 'Valbrona',
		province: 'CO',
		altitude: 494
	},
	{
		zip: '10089',
		name: 'Valchiusa',
		province: 'TO',
		altitude: 738
	},
	{
		zip: '36078',
		name: 'Valdagno',
		province: 'VI',
		altitude: 260
	},
	{
		zip: '38091',
		name: 'Valdaone',
		province: 'TN',
		altitude: 767
	},
	{
		zip: '39030',
		name: 'Valdaora',
		province: 'BZ',
		altitude: 1048
	},
	{
		zip: '36040',
		name: 'Valdastico',
		province: 'VI',
		altitude: 405
	},
	{
		zip: '13855',
		name: 'Valdengo',
		province: 'BI',
		altitude: 285
	},
	{
		zip: '91019',
		name: 'Valderice',
		province: 'TP',
		altitude: 240
	},
	{
		zip: '23038',
		name: 'Valdidentro',
		province: 'SO',
		altitude: 1350
	},
	{
		zip: '12010',
		name: 'Valdieri',
		province: 'CN',
		altitude: 774
	},
	{
		zip: '13835',
		name: 'Valdilana',
		province: 'BI',
		altitude: 434
	},
	{
		zip: '98040',
		name: 'Valdina',
		province: 'ME',
		altitude: 213
	},
	{
		zip: '23030',
		name: 'Valdisotto',
		province: 'SO',
		altitude: 1120
	},
	{
		zip: '31049',
		name: 'Valdobbiadene',
		province: 'TV',
		altitude: 253
	},
	{
		zip: '13018',
		name: 'Valduggia',
		province: 'VC',
		altitude: 390
	},
	{
		zip: '27020',
		name: 'Valeggio',
		province: 'PV',
		altitude: 93
	},
	{
		zip: '37067',
		name: 'Valeggio sul Mincio',
		province: 'VR',
		altitude: 88
	},
	{
		zip: '01018',
		name: 'Valentano',
		province: 'VT',
		altitude: 538
	},
	{
		zip: '15048',
		name: 'Valenza',
		province: 'AL',
		altitude: 125
	},
	{
		zip: '70010',
		name: 'Valenzano',
		province: 'BA',
		altitude: 85
	},
	{
		zip: '26859',
		name: 'Valera Fratta',
		province: 'LO',
		altitude: 78
	},
	{
		zip: '06029',
		name: 'Valfabbrica',
		province: 'PG',
		altitude: 289
	},
	{
		zip: '14017',
		name: 'Valfenera',
		province: 'AT',
		altitude: 282
	},
	{
		zip: '38040',
		name: 'Valfloriana',
		province: 'TN',
		altitude: 853
	},
	{
		zip: '23030',
		name: 'Valfurva',
		province: 'SO',
		altitude: 1339
	},
	{
		zip: '21039',
		name: 'Valganna',
		province: 'VA',
		altitude: 380
	},
	{
		zip: '10094',
		name: 'Valgioie',
		province: 'TO',
		altitude: 870
	},
	{
		zip: '24020',
		name: 'Valgoglio',
		province: 'BG',
		altitude: 929
	},
	{
		zip: '12020',
		name: 'Valgrana',
		province: 'CN',
		altitude: 642
	},
	{
		zip: '23857',
		name: 'Valgreghentino',
		province: 'LC',
		altitude: 304
	},
	{
		zip: '11010',
		name: 'Valgrisenche',
		province: 'AO',
		altitude: 1664
	},
	{
		zip: '94019',
		name: 'Valguarnera Caropepe',
		province: 'EN',
		altitude: 590
	},
	{
		zip: '32020',
		name: 'Vallada Agordina',
		province: 'BL',
		altitude: 1036
	},
	{
		zip: '13847',
		name: 'Vallanzengo',
		province: 'BI',
		altitude: 410
	},
	{
		zip: '38060',
		name: 'Vallarsa',
		province: 'TN',
		altitude: 724
	},
	{
		zip: '83059',
		name: 'Vallata',
		province: 'AV',
		altitude: 870
	},
	{
		zip: '81010',
		name: 'Valle Agricola',
		province: 'CE',
		altitude: 691
	},
	{
		zip: '39030',
		name: 'Valle Aurina',
		province: 'BZ',
		altitude: 1054
	},
	{
		zip: '28825',
		name: 'Valle Cannobina',
		province: 'VB',
		altitude: 415
	},
	{
		zip: '64010',
		name: 'Valle Castellana',
		province: 'TE',
		altitude: 625
	},
	{
		zip: '27020',
		name: 'Valle Lomellina',
		province: 'PV',
		altitude: 101
	},
	{
		zip: '27010',
		name: 'Valle Salimbene',
		province: 'PV',
		altitude: 71
	},
	{
		zip: '13847',
		name: 'Valle San Nicolao',
		province: 'BI',
		altitude: 464
	},
	{
		zip: '84070',
		name: 'Valle dell\'\'Angelo',
		province: 'SA',
		altitude: 620
	},
	{
		zip: '32040',
		name: 'Valle di Cadore',
		province: 'BL',
		altitude: 851
	},
	{
		zip: '39035',
		name: 'Valle di Casies',
		province: 'BZ',
		altitude: 1305
	},
	{
		zip: '81020',
		name: 'Valle di Maddaloni',
		province: 'CE',
		altitude: 156
	},
	{
		zip: '18012',
		name: 'Vallebona',
		province: 'IM',
		altitude: 149
	},
	{
		zip: '03020',
		name: 'Vallecorsa',
		province: 'FR',
		altitude: 350
	},
	{
		zip: '18019',
		name: 'Vallecrosia',
		province: 'IM',
		altitude: 5
	},
	{
		zip: '90029',
		name: 'Valledolmo',
		province: 'PA',
		altitude: 780
	},
	{
		zip: '07039',
		name: 'Valledoria',
		province: 'SS',
		altitude: 16
	},
	{
		zip: '88050',
		name: 'Vallefiorita',
		province: 'CZ',
		altitude: 329
	},
	{
		zip: '61022',
		name: 'Vallefoglia',
		province: 'PU',
		altitude: 295
	},
	{
		zip: '38096',
		name: 'Vallelaghi',
		province: 'TN',
		altitude: 385
	},
	{
		zip: '89821',
		name: 'Vallelonga',
		province: 'VV',
		altitude: 646
	},
	{
		zip: '93010',
		name: 'Vallelunga Pratameno',
		province: 'CL',
		altitude: 472
	},
	{
		zip: '03040',
		name: 'Vallemaio',
		province: 'FR',
		altitude: 337
	},
	{
		zip: '00020',
		name: 'Vallepietra',
		province: 'RM',
		altitude: 825
	},
	{
		zip: '01030',
		name: 'Vallerano',
		province: 'VT',
		altitude: 390
	},
	{
		zip: '09010',
		name: 'Vallermosa',
		province: 'SU',
		altitude: 70
	},
	{
		zip: '03040',
		name: 'Vallerotonda',
		province: 'FR',
		altitude: 700
	},
	{
		zip: '83050',
		name: 'Vallesaccarda',
		province: 'AV',
		altitude: 650
	},
	{
		zip: '24010',
		name: 'Valleve',
		province: 'BG',
		altitude: 1141
	},
	{
		zip: '36030',
		name: 'Valli del Pasubio',
		province: 'VI',
		altitude: 350
	},
	{
		zip: '00020',
		name: 'Vallinfreda',
		province: 'RM',
		altitude: 874
	},
	{
		zip: '25080',
		name: 'Vallio Terme',
		province: 'BS',
		altitude: 400
	},
	{
		zip: '10070',
		name: 'Vallo Torinese',
		province: 'TO',
		altitude: 508
	},
	{
		zip: '84078',
		name: 'Vallo della Lucania',
		province: 'SA',
		altitude: 380
	},
	{
		zip: '06040',
		name: 'Vallo di Nera',
		province: 'PG',
		altitude: 467
	},
	{
		zip: '12010',
		name: 'Valloriate',
		province: 'CN',
		altitude: 785
	},
	{
		zip: '15040',
		name: 'Valmacca',
		province: 'AL',
		altitude: 97
	},
	{
		zip: '23868',
		name: 'Valmadrera',
		province: 'LC',
		altitude: 237
	},
	{
		zip: '00038',
		name: 'Valmontone',
		province: 'RO',
		altitude: 303
	},
	{
		zip: '22070',
		name: 'Valmorea',
		province: 'CO',
		altitude: 408
	},
	{
		zip: '43050',
		name: 'Valmozzola',
		province: 'PR',
		altitude: 565
	},
	{
		zip: '24010',
		name: 'Valnegra',
		province: 'BG',
		altitude: 581
	},
	{
		zip: '11010',
		name: 'Valpelline',
		province: 'AO',
		altitude: 964
	},
	{
		zip: '10087',
		name: 'Valperga',
		province: 'TO',
		altitude: 385
	},
	{
		zip: '10080',
		name: 'Valprato Soana',
		province: 'TO',
		altitude: 1113
	},
	{
		zip: '40053',
		name: 'Valsamoggia',
		province: 'BO',
		altitude: 93
	},
	{
		zip: '11010',
		name: 'Valsavarenche',
		province: 'AO',
		altitude: 1541
	},
	{
		zip: '75029',
		name: 'Valsinni',
		province: 'MT',
		altitude: 250
	},
	{
		zip: '22010',
		name: 'Valsolda',
		province: 'CO',
		altitude: 275
	},
	{
		zip: '28897',
		name: 'Valstrona',
		province: 'VB',
		altitude: 525
	},
	{
		zip: '06030',
		name: 'Valtopina',
		province: 'PG',
		altitude: 360
	},
	{
		zip: '24010',
		name: 'Valtorta',
		province: 'BG',
		altitude: 938
	},
	{
		zip: '11028',
		name: 'Valtournenche',
		province: 'AO',
		altitude: 1524
	},
	{
		zip: '84020',
		name: 'Valva',
		province: 'SA',
		altitude: 510
	},
	{
		zip: '23836',
		name: 'Valvarrone',
		province: 'LC',
		altitude: 587
	},
	{
		zip: '33098',
		name: 'Valvasone Arzene',
		province: 'PN',
		altitude: 59
	},
	{
		zip: '95028',
		name: 'Valverde',
		province: 'CT',
		altitude: 305
	},
	{
		zip: '25080',
		name: 'Valvestino',
		province: 'BS',
		altitude: 680
	},
	{
		zip: '39030',
		name: 'Vandoies',
		province: 'BZ',
		altitude: 755
	},
	{
		zip: '20020',
		name: 'Vanzaghello',
		province: 'MI',
		altitude: 194
	},
	{
		zip: '20043',
		name: 'Vanzago',
		province: 'MI',
		altitude: 161
	},
	{
		zip: '28879',
		name: 'Vanzone con San Carlo',
		province: 'VB',
		altitude: 677
	},
	{
		zip: '20069',
		name: 'Vaprio d\'\'Adda',
		province: 'MI',
		altitude: 161
	},
	{
		zip: '28010',
		name: 'Vaprio d\'\'Agogna',
		province: 'NO',
		altitude: 251
	},
	{
		zip: '13019',
		name: 'Varallo',
		province: 'VC',
		altitude: 450
	},
	{
		zip: '28040',
		name: 'Varallo Pombia',
		province: 'NO',
		altitude: 300
	},
	{
		zip: '21020',
		name: 'Varano Borghi',
		province: 'VA',
		altitude: 281
	},
	{
		zip: '43040',
		name: 'Varano de Melegari',
		province: 'PR',
		altitude: 190
	},
	{
		zip: '89010',
		name: 'Varapodio',
		province: 'RC',
		altitude: 231
	},
	{
		zip: '17019',
		name: 'Varazze',
		province: 'SV',
		altitude: 10
	},
	{
		zip: '02020',
		name: 'Varco Sabino',
		province: 'RI',
		altitude: 742
	},
	{
		zip: '20814',
		name: 'Varedo',
		province: 'MB',
		altitude: 180
	},
	{
		zip: '23829',
		name: 'Varenna',
		province: 'LC',
		altitude: 220
	},
	{
		zip: '21100',
		name: 'Varese',
		province: 'VA',
		altitude: 382
	},
	{
		zip: '19028',
		name: 'Varese Ligure',
		province: 'SP',
		altitude: 353
	},
	{
		zip: '10070',
		name: 'Varisella',
		province: 'TO',
		altitude: 521
	},
	{
		zip: '33030',
		name: 'Varmo',
		province: 'UD',
		altitude: 18
	},
	{
		zip: '43049',
		name: 'Varsi',
		province: 'PR',
		altitude: 426
	},
	{
		zip: '27057',
		name: 'Varzi',
		province: 'PV',
		altitude: 416
	},
	{
		zip: '28868',
		name: 'Varzo',
		province: 'VB',
		altitude: 568
	},
	{
		zip: '01030',
		name: 'Vasanello',
		province: 'VT',
		altitude: 265
	},
	{
		zip: '18020',
		name: 'Vasia',
		province: 'IM',
		altitude: 385
	},
	{
		zip: '66054',
		name: 'Vasto',
		province: 'CH',
		altitude: 144
	},
	{
		zip: '86089',
		name: 'Vastogirardi',
		province: 'IS',
		altitude: 1200
	},
	{
		zip: '10070',
		name: 'Vauda Canavese',
		province: 'TO',
		altitude: 396
	},
	{
		zip: '89834',
		name: 'Vazzano',
		province: 'VV',
		altitude: 357
	},
	{
		zip: '31028',
		name: 'Vazzola',
		province: 'TV',
		altitude: 30
	},
	{
		zip: '56019',
		name: 'Vecchiano',
		province: 'PI',
		altitude: 5
	},
	{
		zip: '21040',
		name: 'Vedano Olona',
		province: 'VA',
		altitude: 360
	},
	{
		zip: '20854',
		name: 'Vedano al Lambro',
		province: 'MB',
		altitude: 187
	},
	{
		zip: '31050',
		name: 'Vedelago',
		province: 'TV',
		altitude: 43
	},
	{
		zip: '24010',
		name: 'Vedeseta',
		province: 'BG',
		altitude: 820
	},
	{
		zip: '20837',
		name: 'Veduggio con Colzano',
		province: 'MB',
		altitude: 325
	},
	{
		zip: '35030',
		name: 'Veggiano',
		province: 'PD',
		altitude: 21
	},
	{
		zip: '73010',
		name: 'Veglie',
		province: 'LE',
		altitude: 47
	},
	{
		zip: '13824',
		name: 'Veglio',
		province: 'BI',
		altitude: 734
	},
	{
		zip: '01010',
		name: 'Vejano',
		province: 'VT',
		altitude: 390
	},
	{
		zip: '22020',
		name: 'Veleso',
		province: 'CO',
		altitude: 826
	},
	{
		zip: '27020',
		name: 'Velezzo Lomellina',
		province: 'PV',
		altitude: 98
	},
	{
		zip: '00049',
		name: 'Velletri',
		province: 'RO',
		altitude: 332
	},
	{
		zip: '27010',
		name: 'Vellezzo Bellini',
		province: 'PV',
		altitude: 94
	},
	{
		zip: '37030',
		name: 'Velo Veronese',
		province: 'VR',
		altitude: 1087
	},
	{
		zip: '36010',
		name: 'Velo d\'\'Astico',
		province: 'VI',
		altitude: 346
	},
	{
		zip: '39040',
		name: 'Velturno',
		province: 'BZ',
		altitude: 851
	},
	{
		zip: '86079',
		name: 'Venafro',
		province: 'IS',
		altitude: 222
	},
	{
		zip: '10078',
		name: 'Venaria Reale',
		province: 'TO',
		altitude: 256
	},
	{
		zip: '63091',
		name: 'Venarotta',
		province: 'AP',
		altitude: 421
	},
	{
		zip: '12020',
		name: 'Venasca',
		province: 'CN',
		altitude: 549
	},
	{
		zip: '10050',
		name: 'Venaus',
		province: 'TO',
		altitude: 604
	},
	{
		zip: '17032',
		name: 'Vendone',
		province: 'SV',
		altitude: 398
	},
	{
		zip: '21040',
		name: 'Venegono Inferiore',
		province: 'VA',
		altitude: 345
	},
	{
		zip: '21040',
		name: 'Venegono Superiore',
		province: 'VA',
		altitude: 331
	},
	{
		zip: '98040',
		name: 'Venetico',
		province: 'ME',
		altitude: 6
	},
	{
		zip: '30121',
		name: 'Venezia',
		province: 'VE',
		altitude: 256
	},
	{
		zip: '22070',
		name: 'Veniano',
		province: 'CO',
		altitude: 316
	},
	{
		zip: '85029',
		name: 'Venosa',
		province: 'PZ',
		altitude: 415
	},
	{
		zip: '42032',
		name: 'Ventasso',
		province: 'RE',
		altitude: 810
	},
	{
		zip: '83030',
		name: 'Venticano',
		province: 'AV',
		altitude: 375
	},
	{
		zip: '18039',
		name: 'Ventimiglia',
		province: 'IM',
		altitude: 9
	},
	{
		zip: '90020',
		name: 'Ventimiglia di Sicilia',
		province: 'PA',
		altitude: 540
	},
	{
		zip: '04031',
		name: 'Ventotene',
		province: 'LT',
		altitude: 18
	},
	{
		zip: '33010',
		name: 'Venzone',
		province: 'UD',
		altitude: 230
	},
	{
		zip: '39010',
		name: 'Verano',
		province: 'BZ',
		altitude: 1204
	},
	{
		zip: '20843',
		name: 'Verano Brianza',
		province: 'MB',
		altitude: 264
	},
	{
		zip: '28900',
		name: 'Verbania',
		province: 'VB',
		altitude: 197
	},
	{
		zip: '87020',
		name: 'Verbicaro',
		province: 'CS',
		altitude: 428
	},
	{
		zip: '22013',
		name: 'Vercana',
		province: 'CO',
		altitude: 345
	},
	{
		zip: '23020',
		name: 'Verceia',
		province: 'SO',
		altitude: 200
	},
	{
		zip: '13100',
		name: 'Vercelli',
		province: 'VC',
		altitude: 130
	},
	{
		zip: '23808',
		name: 'Vercurago',
		province: 'LC',
		altitude: 225
	},
	{
		zip: '24040',
		name: 'Verdellino',
		province: 'BG',
		altitude: 172
	},
	{
		zip: '24049',
		name: 'Verdello',
		province: 'BG',
		altitude: 173
	},
	{
		zip: '23879',
		name: 'Verderio',
		province: 'LC',
		altitude: 249
	},
	{
		zip: '12060',
		name: 'Verduno',
		province: 'CN',
		altitude: 381
	},
	{
		zip: '40038',
		name: 'Vergato',
		province: 'BO',
		altitude: 193
	},
	{
		zip: '47028',
		name: 'Verghereto',
		province: 'FC',
		altitude: 812
	},
	{
		zip: '21029',
		name: 'Vergiate',
		province: 'VA',
		altitude: 270
	},
	{
		zip: '20071',
		name: 'Vermezzo con Zelo',
		province: 'MI',
		altitude: 119
	},
	{
		zip: '38029',
		name: 'Vermiglio',
		province: 'TN',
		altitude: 1261
	},
	{
		zip: '12019',
		name: 'Vernante',
		province: 'CN',
		altitude: 785
	},
	{
		zip: '29010',
		name: 'Vernasca',
		province: 'PC',
		altitude: 457
	},
	{
		zip: '20080',
		name: 'Vernate',
		province: 'MI',
		altitude: 108
	},
	{
		zip: '19018',
		name: 'Vernazza',
		province: 'SP',
		altitude: 3
	},
	{
		zip: '59024',
		name: 'Vernio',
		province: 'PO',
		altitude: 257
	},
	{
		zip: '73029',
		name: 'Vernole',
		province: 'LE',
		altitude: 38
	},
	{
		zip: '25028',
		name: 'Verolanuova',
		province: 'BS',
		altitude: 64
	},
	{
		zip: '25029',
		name: 'Verolavecchia',
		province: 'BS',
		altitude: 68
	},
	{
		zip: '10038',
		name: 'Verolengo',
		province: 'TO',
		altitude: 270
	},
	{
		zip: '03029',
		name: 'Veroli',
		province: 'FR',
		altitude: 594
	},
	{
		zip: '37121',
		name: 'Verona',
		province: 'VR',
		altitude: 59
	},
	{
		zip: '37040',
		name: 'Veronella',
		province: 'VR',
		altitude: 21
	},
	{
		zip: '11020',
		name: 'Verrayes',
		province: 'AO',
		altitude: 1017
	},
	{
		zip: '27053',
		name: 'Verretto',
		province: 'PV',
		altitude: 74
	},
	{
		zip: '13871',
		name: 'Verrone',
		province: 'BI',
		altitude: 277
	},
	{
		zip: '27040',
		name: 'Verrua Po',
		province: 'PV',
		altitude: 64
	},
	{
		zip: '10020',
		name: 'Verrua Savoia',
		province: 'TO',
		altitude: 387
	},
	{
		zip: '11029',
		name: 'Verres',
		province: 'AO',
		altitude: 391
	},
	{
		zip: '22070',
		name: 'Vertemate con Minoprio',
		province: 'CO',
		altitude: 340
	},
	{
		zip: '24029',
		name: 'Vertova',
		province: 'BG',
		altitude: 397
	},
	{
		zip: '47826',
		name: 'Verucchio',
		province: 'RN',
		altitude: 330
	},
	{
		zip: '23030',
		name: 'Vervio',
		province: 'SO',
		altitude: 549
	},
	{
		zip: '33020',
		name: 'Verzegnis',
		province: 'UD',
		altitude: 407
	},
	{
		zip: '88819',
		name: 'Verzino',
		province: 'KR',
		altitude: 549
	},
	{
		zip: '12039',
		name: 'Verzuolo',
		province: 'CN',
		altitude: 420
	},
	{
		zip: '35040',
		name: 'Vescovana',
		province: 'PD',
		altitude: 7
	},
	{
		zip: '26039',
		name: 'Vescovato',
		province: 'CR',
		altitude: 46
	},
	{
		zip: '14059',
		name: 'Vesime',
		province: 'AT',
		altitude: 225
	},
	{
		zip: '28079',
		name: 'Vespolate',
		province: 'NO',
		altitude: 123
	},
	{
		zip: '18026',
		name: 'Vessalico',
		province: 'IM',
		altitude: 197
	},
	{
		zip: '37030',
		name: 'Vestenanova',
		province: 'VR',
		altitude: 510
	},
	{
		zip: '10030',
		name: 'Vestigne',
		province: 'TO',
		altitude: 235
	},
	{
		zip: '25078',
		name: 'Vestone',
		province: 'BS',
		altitude: 318
	},
	{
		zip: '01019',
		name: 'Vetralla',
		province: 'VT',
		altitude: 300
	},
	{
		zip: '42020',
		name: 'Vetto',
		province: 'RE',
		altitude: 447
	},
	{
		zip: '12040',
		name: 'Vezza d\'\'Alba',
		province: 'CN',
		altitude: 353
	},
	{
		zip: '25059',
		name: 'Vezza d\'\'Oglio',
		province: 'BS',
		altitude: 1080
	},
	{
		zip: '19020',
		name: 'Vezzano Ligure',
		province: 'SP',
		altitude: 271
	},
	{
		zip: '42030',
		name: 'Vezzano sul Crostolo',
		province: 'RE',
		altitude: 166
	},
	{
		zip: '17028',
		name: 'Vezzi Portio',
		province: 'SV',
		altitude: 300
	},
	{
		zip: '46019',
		name: 'Viadana',
		province: 'MN',
		altitude: 26
	},
	{
		zip: '24060',
		name: 'Viadanica',
		province: 'BG',
		altitude: 336
	},
	{
		zip: '95029',
		name: 'Viagrande',
		province: 'CT',
		altitude: 410
	},
	{
		zip: '14010',
		name: 'Viale',
		province: 'AT',
		altitude: 261
	},
	{
		zip: '10090',
		name: 'Vialfre',
		province: 'TO',
		altitude: 470
	},
	{
		zip: '42030',
		name: 'Viano',
		province: 'RE',
		altitude: 275
	},
	{
		zip: '55049',
		name: 'Viareggio',
		province: 'LU',
		altitude: 2
	},
	{
		zip: '14030',
		name: 'Viarigi',
		province: 'AT',
		altitude: 252
	},
	{
		zip: '89900',
		name: 'Vibo Valentia',
		province: 'VV',
		altitude: 476
	},
	{
		zip: '84079',
		name: 'Vibonati',
		province: 'SA',
		altitude: 110
	},
	{
		zip: '03030',
		name: 'Vicalvi',
		province: 'FR',
		altitude: 590
	},
	{
		zip: '90020',
		name: 'Vicari',
		province: 'PA',
		altitude: 640
	},
	{
		zip: '50039',
		name: 'Vicchio',
		province: 'FI',
		altitude: 203
	},
	{
		zip: '36100',
		name: 'Vicenza',
		province: 'VI',
		altitude: 39
	},
	{
		zip: '80069',
		name: 'Vico Equense',
		province: 'NA',
		altitude: 90
	},
	{
		zip: '71018',
		name: 'Vico del Gargano',
		province: 'FG',
		altitude: 445
	},
	{
		zip: '03010',
		name: 'Vico nel Lazio',
		province: 'FR',
		altitude: 721
	},
	{
		zip: '12080',
		name: 'Vicoforte',
		province: 'CN',
		altitude: 598
	},
	{
		zip: '65010',
		name: 'Vicoli',
		province: 'PE',
		altitude: 445
	},
	{
		zip: '28060',
		name: 'Vicolungo',
		province: 'NO',
		altitude: 170
	},
	{
		zip: '56010',
		name: 'Vicopisano',
		province: 'PI',
		altitude: 12
	},
	{
		zip: '00029',
		name: 'Vicovaro',
		province: 'RM',
		altitude: 300
	},
	{
		zip: '07030',
		name: 'Viddalba',
		province: 'SS',
		altitude: 22
	},
	{
		zip: '27018',
		name: 'Vidigulfo',
		province: 'PV',
		altitude: 88
	},
	{
		zip: '31020',
		name: 'Vidor',
		province: 'TV',
		altitude: 152
	},
	{
		zip: '10080',
		name: 'Vidracco',
		province: 'TO',
		altitude: 481
	},
	{
		zip: '71019',
		name: 'Vieste',
		province: 'FG',
		altitude: 43
	},
	{
		zip: '85058',
		name: 'Vietri di Potenza',
		province: 'PZ',
		altitude: 305
	},
	{
		zip: '84019',
		name: 'Vietri sul Mare',
		province: 'SA',
		altitude: 80
	},
	{
		zip: '24060',
		name: 'Vigano San Martino',
		province: 'BG',
		altitude: 363
	},
	{
		zip: '23897',
		name: 'Vigano',
		province: 'LC',
		altitude: 390
	},
	{
		zip: '44049',
		name: 'Vigarano Mainarda',
		province: 'FE',
		altitude: 10
	},
	{
		zip: '37068',
		name: 'Vigasio',
		province: 'VR',
		altitude: 37
	},
	{
		zip: '27029',
		name: 'Vigevano',
		province: 'PV',
		altitude: 116
	},
	{
		zip: '85040',
		name: 'Viggianello',
		province: 'PZ',
		altitude: 500
	},
	{
		zip: '85059',
		name: 'Viggiano',
		province: 'PZ',
		altitude: 1023
	},
	{
		zip: '21059',
		name: 'Viggiu',
		province: 'VA',
		altitude: 506
	},
	{
		zip: '35040',
		name: 'Vighizzolo d\'\'Este',
		province: 'PD',
		altitude: 11
	},
	{
		zip: '13856',
		name: 'Vigliano Biellese',
		province: 'BI',
		altitude: 312
	},
	{
		zip: '14040',
		name: 'Vigliano d\'\'Asti',
		province: 'AT',
		altitude: 279
	},
	{
		zip: '15049',
		name: 'Vignale Monferrato',
		province: 'AL',
		altitude: 308
	},
	{
		zip: '01039',
		name: 'Vignanello',
		province: 'VT',
		altitude: 369
	},
	{
		zip: '20052',
		name: 'Vignate',
		province: 'MI',
		altitude: 121
	},
	{
		zip: '41058',
		name: 'Vignola',
		province: 'MO',
		altitude: 125
	},
	{
		zip: '38050',
		name: 'Vignola-Falesina',
		province: 'TN',
		altitude: 984
	},
	{
		zip: '15060',
		name: 'Vignole Borbera',
		province: 'AL',
		altitude: 243
	},
	{
		zip: '12010',
		name: 'Vignolo',
		province: 'CN',
		altitude: 630
	},
	{
		zip: '28819',
		name: 'Vignone',
		province: 'VB',
		altitude: 449
	},
	{
		zip: '32040',
		name: 'Vigo di Cadore',
		province: 'BL',
		altitude: 951
	},
	{
		zip: '35010',
		name: 'Vigodarzere',
		province: 'PD',
		altitude: 17
	},
	{
		zip: '24060',
		name: 'Vigolo',
		province: 'BG',
		altitude: 616
	},
	{
		zip: '29020',
		name: 'Vigolzone',
		province: 'PC',
		altitude: 151
	},
	{
		zip: '10067',
		name: 'Vigone',
		province: 'TO',
		altitude: 260
	},
	{
		zip: '30030',
		name: 'Vigonovo',
		province: 'VE',
		altitude: 8
	},
	{
		zip: '35010',
		name: 'Vigonza',
		province: 'PD',
		altitude: 10
	},
	{
		zip: '15058',
		name: 'Viguzzolo',
		province: 'AL',
		altitude: 128
	},
	{
		zip: '37049',
		name: 'Villa Bartolomea',
		province: 'VR',
		altitude: 14
	},
	{
		zip: '55019',
		name: 'Villa Basilica',
		province: 'LU',
		altitude: 330
	},
	{
		zip: '27035',
		name: 'Villa Biscossi',
		province: 'PV',
		altitude: 90
	},
	{
		zip: '25069',
		name: 'Villa Carcina',
		province: 'BS',
		altitude: 241
	},
	{
		zip: '72029',
		name: 'Villa Castelli',
		province: 'BR',
		altitude: 251
	},
	{
		zip: '65010',
		name: 'Villa Celiera',
		province: 'PE',
		altitude: 714
	},
	{
		zip: '55030',
		name: 'Villa Collemandina',
		province: 'LU',
		altitude: 549
	},
	{
		zip: '20035',
		name: 'Villa Cortese',
		province: 'MI',
		altitude: 192
	},
	{
		zip: '35040',
		name: 'Villa Estense',
		province: 'PD',
		altitude: 10
	},
	{
		zip: '18010',
		name: 'Villa Faraldi',
		province: 'IM',
		altitude: 336
	},
	{
		zip: '22079',
		name: 'Villa Guardia',
		province: 'CO',
		altitude: 350
	},
	{
		zip: '38060',
		name: 'Villa Lagarina',
		province: 'TN',
		altitude: 180
	},
	{
		zip: '03040',
		name: 'Villa Latina',
		province: 'FR',
		altitude: 415
	},
	{
		zip: '81039',
		name: 'Villa Literno',
		province: 'CE',
		altitude: 10
	},
	{
		zip: '42030',
		name: 'Villa Minozzo',
		province: 'RE',
		altitude: 684
	},
	{
		zip: '89018',
		name: 'Villa San Giovanni',
		province: 'RC',
		altitude: 15
	},
	{
		zip: '01010',
		name: 'Villa San Giovanni in Tuscia',
		province: 'VT',
		altitude: 329
	},
	{
		zip: '09050',
		name: 'Villa San Pietro',
		province: 'CA',
		altitude: 37
	},
	{
		zip: '14020',
		name: 'Villa San Secondo',
		province: 'AT',
		altitude: 287
	},
	{
		zip: '67020',
		name: 'Villa Sant\'\'Angelo',
		province: 'AQ',
		altitude: 570
	},
	{
		zip: '09080',
		name: 'Villa Sant\'\'Antonio',
		province: 'OR',
		altitude: 249
	},
	{
		zip: '03030',
		name: 'Villa Santa Lucia',
		province: 'FR',
		altitude: 393
	},
	{
		zip: '67020',
		name: 'Villa Santa Lucia degli Abruzzi',
		province: 'AQ',
		altitude: 850
	},
	{
		zip: '66047',
		name: 'Villa Santa Maria',
		province: 'CH',
		altitude: 336
	},
	{
		zip: '33029',
		name: 'Villa Santina',
		province: 'UD',
		altitude: 363
	},
	{
		zip: '03020',
		name: 'Villa Santo Stefano',
		province: 'FR',
		altitude: 205
	},
	{
		zip: '09090',
		name: 'Villa Verde',
		province: 'OR',
		altitude: 204
	},
	{
		zip: '24030',
		name: 'Villa d\'\'Adda',
		province: 'BG',
		altitude: 286
	},
	{
		zip: '24018',
		name: 'Villa d\'\'Alme',
		province: 'BG',
		altitude: 300
	},
	{
		zip: '24020',
		name: 'Villa d\'\'Ogna',
		province: 'BG',
		altitude: 542
	},
	{
		zip: '13868',
		name: 'Villa del Bosco',
		province: 'BI',
		altitude: 293
	},
	{
		zip: '35010',
		name: 'Villa del Conte',
		province: 'PD',
		altitude: 28
	},
	{
		zip: '81030',
		name: 'Villa di Briano',
		province: 'CE',
		altitude: 28
	},
	{
		zip: '23029',
		name: 'Villa di Chiavenna',
		province: 'SO',
		altitude: 633
	},
	{
		zip: '24020',
		name: 'Villa di Serio',
		province: 'BG',
		altitude: 275
	},
	{
		zip: '23030',
		name: 'Villa di Tirano',
		province: 'SO',
		altitude: 406
	},
	{
		zip: '39039',
		name: 'Villabassa',
		province: 'BZ',
		altitude: 1158
	},
	{
		zip: '90039',
		name: 'Villabate',
		province: 'PA',
		altitude: 47
	},
	{
		zip: '25030',
		name: 'Villachiara',
		province: 'BS',
		altitude: 75
	},
	{
		zip: '09039',
		name: 'Villacidro',
		province: 'SU',
		altitude: 267
	},
	{
		zip: '15020',
		name: 'Villadeati',
		province: 'AL',
		altitude: 410
	},
	{
		zip: '45010',
		name: 'Villadose',
		province: 'RO',
		altitude: 3
	},
	{
		zip: '28844',
		name: 'Villadossola',
		province: 'VB',
		altitude: 257
	},
	{
		zip: '12020',
		name: 'Villafalletto',
		province: 'CN',
		altitude: 431
	},
	{
		zip: '35010',
		name: 'Villafranca Padovana',
		province: 'PD',
		altitude: 22
	},
	{
		zip: '10068',
		name: 'Villafranca Piemonte',
		province: 'TO',
		altitude: 253
	},
	{
		zip: '92020',
		name: 'Villafranca Sicula',
		province: 'AG',
		altitude: 326
	},
	{
		zip: '98049',
		name: 'Villafranca Tirrena',
		province: 'ME',
		altitude: 22
	},
	{
		zip: '14018',
		name: 'Villafranca d\'\'Asti',
		province: 'AT',
		altitude: 206
	},
	{
		zip: '37069',
		name: 'Villafranca di Verona',
		province: 'VR',
		altitude: 54
	},
	{
		zip: '54028',
		name: 'Villafranca in Lunigiana',
		province: 'MS',
		altitude: 138
	},
	{
		zip: '90030',
		name: 'Villafrati',
		province: 'PA',
		altitude: 500
	},
	{
		zip: '36021',
		name: 'Villaga',
		province: 'VI',
		altitude: 45
	},
	{
		zip: '08049',
		name: 'Villagrande Strisaili',
		province: 'NU',
		altitude: 700
	},
	{
		zip: '67030',
		name: 'Villalago',
		province: 'AQ',
		altitude: 930
	},
	{
		zip: '93010',
		name: 'Villalba',
		province: 'CL',
		altitude: 620
	},
	{
		zip: '66020',
		name: 'Villalfonsina',
		province: 'CH',
		altitude: 203
	},
	{
		zip: '15050',
		name: 'Villalvernia',
		province: 'AL',
		altitude: 193
	},
	{
		zip: '66010',
		name: 'Villamagna',
		province: 'CH',
		altitude: 255
	},
	{
		zip: '83050',
		name: 'Villamaina',
		province: 'AV',
		altitude: 560
	},
	{
		zip: '09020',
		name: 'Villamar',
		province: 'SU',
		altitude: 108
	},
	{
		zip: '45030',
		name: 'Villamarzana',
		province: 'RO',
		altitude: 7
	},
	{
		zip: '09010',
		name: 'Villamassargia',
		province: 'SU',
		altitude: 121
	},
	{
		zip: '15020',
		name: 'Villamiroglio',
		province: 'AL',
		altitude: 329
	},
	{
		zip: '39043',
		name: 'Villandro',
		province: 'BZ',
		altitude: 880
	},
	{
		zip: '13877',
		name: 'Villanova Biellese',
		province: 'BI',
		altitude: 232
	},
	{
		zip: '10070',
		name: 'Villanova Canavese',
		province: 'TO',
		altitude: 380
	},
	{
		zip: '45030',
		name: 'Villanova Marchesana',
		province: 'RO',
		altitude: 3
	},
	{
		zip: '12089',
		name: 'Villanova Mondovi',
		province: 'CN',
		altitude: 526
	},
	{
		zip: '15030',
		name: 'Villanova Monferrato',
		province: 'AL',
		altitude: 111
	},
	{
		zip: '07019',
		name: 'Villanova Monteleone',
		province: 'SS',
		altitude: 567
	},
	{
		zip: '12030',
		name: 'Villanova Solaro',
		province: 'CN',
		altitude: 268
	},
	{
		zip: '09084',
		name: 'Villanova Truschedu',
		province: 'OR',
		altitude: 56
	},
	{
		zip: '09066',
		name: 'Villanova Tulo',
		province: 'SU',
		altitude: 600
	},
	{
		zip: '17038',
		name: 'Villanova d\'\'Albenga',
		province: 'SV',
		altitude: 29
	},
	{
		zip: '27030',
		name: 'Villanova d\'\'Ardenghi',
		province: 'PV',
		altitude: 86
	},
	{
		zip: '14019',
		name: 'Villanova d\'\'Asti',
		province: 'AT',
		altitude: 260
	},
	{
		zip: '83030',
		name: 'Villanova del Battista',
		province: 'AV',
		altitude: 742
	},
	{
		zip: '45020',
		name: 'Villanova del Ghebbo',
		province: 'RO',
		altitude: 11
	},
	{
		zip: '26818',
		name: 'Villanova del Sillaro',
		province: 'LO',
		altitude: 69
	},
	{
		zip: '35010',
		name: 'Villanova di Camposampiero',
		province: 'PD',
		altitude: 12
	},
	{
		zip: '29010',
		name: 'Villanova sull\'\'Arda',
		province: 'PC',
		altitude: 42
	},
	{
		zip: '09020',
		name: 'Villanovaforru',
		province: 'SU',
		altitude: 324
	},
	{
		zip: '09020',
		name: 'Villanovafranca',
		province: 'SU',
		altitude: 292
	},
	{
		zip: '27019',
		name: 'Villanterio',
		province: 'PV',
		altitude: 75
	},
	{
		zip: '25089',
		name: 'Villanuova sul Clisi',
		province: 'BS',
		altitude: 216
	},
	{
		zip: '09010',
		name: 'Villaperuccio',
		province: 'SU',
		altitude: 68
	},
	{
		zip: '87076',
		name: 'Villapiana',
		province: 'CS',
		altitude: 206
	},
	{
		zip: '09040',
		name: 'Villaputzu',
		province: 'SU',
		altitude: 8
	},
	{
		zip: '10040',
		name: 'Villar Dora',
		province: 'TO',
		altitude: 367
	},
	{
		zip: '10050',
		name: 'Villar Focchiardo',
		province: 'TO',
		altitude: 450
	},
	{
		zip: '10060',
		name: 'Villar Pellice',
		province: 'TO',
		altitude: 664
	},
	{
		zip: '10069',
		name: 'Villar Perosa',
		province: 'TO',
		altitude: 530
	},
	{
		zip: '12020',
		name: 'Villar San Costanzo',
		province: 'CN',
		altitude: 609
	},
	{
		zip: '10090',
		name: 'Villarbasse',
		province: 'TO',
		altitude: 381
	},
	{
		zip: '13030',
		name: 'Villarboit',
		province: 'VC',
		altitude: 162
	},
	{
		zip: '10030',
		name: 'Villareggia',
		province: 'TO',
		altitude: 274
	},
	{
		zip: '80010',
		name: 'Villaricca',
		province: 'NA',
		altitude: 105
	},
	{
		zip: '15050',
		name: 'Villaromagnano',
		province: 'AL',
		altitude: 170
	},
	{
		zip: '09040',
		name: 'Villasalto',
		province: 'SU',
		altitude: 502
	},
	{
		zip: '20852',
		name: 'Villasanta',
		province: 'MB',
		altitude: 173
	},
	{
		zip: '09049',
		name: 'Villasimius',
		province: 'SU',
		altitude: 49
	},
	{
		zip: '09034',
		name: 'Villasor',
		province: 'SU',
		altitude: 26
	},
	{
		zip: '09010',
		name: 'Villaspeciosa',
		province: 'SU',
		altitude: 7
	},
	{
		zip: '10029',
		name: 'Villastellone',
		province: 'TO',
		altitude: 234
	},
	{
		zip: '13010',
		name: 'Villata',
		province: 'VC',
		altitude: 136
	},
	{
		zip: '09080',
		name: 'Villaurbana',
		province: 'OR',
		altitude: 110
	},
	{
		zip: '67050',
		name: 'Villavallelonga',
		province: 'AQ',
		altitude: 1005
	},
	{
		zip: '36030',
		name: 'Villaverla',
		province: 'VI',
		altitude: 75
	},
	{
		zip: '38019',
		name: 'Ville d\'\'Anaunia',
		province: 'TN',
		altitude: 629
	},
	{
		zip: '38099',
		name: 'Ville di Fiemme',
		province: 'TN',
		altitude: 1160
	},
	{
		zip: '11018',
		name: 'Villeneuve',
		province: 'AO',
		altitude: 670
	},
	{
		zip: '34070',
		name: 'Villesse',
		province: 'GO',
		altitude: 18
	},
	{
		zip: '67030',
		name: 'Villetta Barrea',
		province: 'AQ',
		altitude: 990
	},
	{
		zip: '28856',
		name: 'Villette',
		province: 'VB',
		altitude: 807
	},
	{
		zip: '46039',
		name: 'Villimpenta',
		province: 'MN',
		altitude: 18
	},
	{
		zip: '24060',
		name: 'Villongo',
		province: 'BG',
		altitude: 220
	},
	{
		zip: '31020',
		name: 'Villorba',
		province: 'TV',
		altitude: 26
	},
	{
		zip: '24020',
		name: 'Vilminore di Scalve',
		province: 'BG',
		altitude: 1019
	},
	{
		zip: '20871',
		name: 'Vimercate',
		province: 'MB',
		altitude: 194
	},
	{
		zip: '20055',
		name: 'Vimodrone',
		province: 'MI',
		altitude: 128
	},
	{
		zip: '12010',
		name: 'Vinadio',
		province: 'CN',
		altitude: 904
	},
	{
		zip: '86019',
		name: 'Vinchiaturo',
		province: 'CB',
		altitude: 620
	},
	{
		zip: '14040',
		name: 'Vinchio',
		province: 'AT',
		altitude: 269
	},
	{
		zip: '50059',
		name: 'Vinci',
		province: 'FI',
		altitude: 97
	},
	{
		zip: '10048',
		name: 'Vinovo',
		province: 'TO',
		altitude: 232
	},
	{
		zip: '28060',
		name: 'Vinzaglio',
		province: 'NO',
		altitude: 124
	},
	{
		zip: '12070',
		name: 'Viola',
		province: 'CN',
		altitude: 827
	},
	{
		zip: '25050',
		name: 'Vione',
		province: 'BS',
		altitude: 1250
	},
	{
		zip: '39049',
		name: 'Vipiteno',
		province: 'BZ',
		altitude: 948
	},
	{
		zip: '10060',
		name: 'Virle Piemonte',
		province: 'TO',
		altitude: 245
	},
	{
		zip: '25010',
		name: 'Visano',
		province: 'BS',
		altitude: 60
	},
	{
		zip: '10030',
		name: 'Vische',
		province: 'TO',
		altitude: 243
	},
	{
		zip: '80030',
		name: 'Visciano',
		province: 'NA',
		altitude: 340
	},
	{
		zip: '33040',
		name: 'Visco',
		province: 'UD',
		altitude: 27
	},
	{
		zip: '15010',
		name: 'Visone',
		province: 'AL',
		altitude: 161
	},
	{
		zip: '62039',
		name: 'Visso',
		province: 'MC',
		altitude: 607
	},
	{
		zip: '27010',
		name: 'Vistarino',
		province: 'PV',
		altitude: 72
	},
	{
		zip: '10080',
		name: 'Vistrorio',
		province: 'TO',
		altitude: 480
	},
	{
		zip: '91010',
		name: 'Vita',
		province: 'TP',
		altitude: 480
	},
	{
		zip: '01100',
		name: 'Viterbo',
		province: 'VT',
		altitude: 326
	},
	{
		zip: '03040',
		name: 'Viticuso',
		province: 'FR',
		altitude: 858
	},
	{
		zip: '33090',
		name: 'Vito d\'\'Asio',
		province: 'PN',
		altitude: 320
	},
	{
		zip: '01030',
		name: 'Vitorchiano',
		province: 'VT',
		altitude: 285
	},
	{
		zip: '97019',
		name: 'Vittoria',
		province: 'RG',
		altitude: 168
	},
	{
		zip: '31029',
		name: 'Vittorio Veneto',
		province: 'TV',
		altitude: 138
	},
	{
		zip: '67030',
		name: 'Vittorito',
		province: 'AQ',
		altitude: 377
	},
	{
		zip: '20009',
		name: 'Vittuone',
		province: 'MI',
		altitude: 146
	},
	{
		zip: '82038',
		name: 'Vitulano',
		province: 'BN',
		altitude: 430
	},
	{
		zip: '81041',
		name: 'Vitulazio',
		province: 'CE',
		altitude: 57
	},
	{
		zip: '33099',
		name: 'Vivaro',
		province: 'PN',
		altitude: 138
	},
	{
		zip: '00020',
		name: 'Vivaro Romano',
		province: 'RM',
		altitude: 757
	},
	{
		zip: '13886',
		name: 'Viverone',
		province: 'BI',
		altitude: 310
	},
	{
		zip: '95049',
		name: 'Vizzini',
		province: 'CT',
		altitude: 586
	},
	{
		zip: '21010',
		name: 'Vizzola Ticino',
		province: 'VA',
		altitude: 196
	},
	{
		zip: '20070',
		name: 'Vizzolo Predabissi',
		province: 'MI',
		altitude: 90
	},
	{
		zip: '10070',
		name: 'Viu',
		province: 'TO',
		altitude: 765
	},
	{
		zip: '35030',
		name: 'Vo',
		province: 'PD',
		altitude: 19
	},
	{
		zip: '25079',
		name: 'Vobarno',
		province: 'BS',
		altitude: 245
	},
	{
		zip: '16010',
		name: 'Vobbia',
		province: 'GE',
		altitude: 477
	},
	{
		zip: '13020',
		name: 'Vocca',
		province: 'VC',
		altitude: 506
	},
	{
		zip: '32040',
		name: 'Vodo Cadore',
		province: 'BL',
		altitude: 901
	},
	{
		zip: '27058',
		name: 'Voghera',
		province: 'PV',
		altitude: 96
	},
	{
		zip: '44019',
		name: 'Voghiera',
		province: 'FE',
		altitude: 7
	},
	{
		zip: '28805',
		name: 'Vogogna',
		province: 'VB',
		altitude: 226
	},
	{
		zip: '38060',
		name: 'Volano',
		province: 'TN',
		altitude: 189
	},
	{
		zip: '80040',
		name: 'Volla',
		province: 'NA',
		altitude: 25
	},
	{
		zip: '26030',
		name: 'Volongo',
		province: 'CR',
		altitude: 43
	},
	{
		zip: '31040',
		name: 'Volpago del Montello',
		province: 'TV',
		altitude: 94
	},
	{
		zip: '27047',
		name: 'Volpara',
		province: 'PV',
		altitude: 357
	},
	{
		zip: '15059',
		name: 'Volpedo',
		province: 'AL',
		altitude: 182
	},
	{
		zip: '15050',
		name: 'Volpeglino',
		province: 'AL',
		altitude: 243
	},
	{
		zip: '10088',
		name: 'Volpiano',
		province: 'TO',
		altitude: 219
	},
	{
		zip: '46049',
		name: 'Volta Mantovana',
		province: 'MN',
		altitude: 91
	},
	{
		zip: '15060',
		name: 'Voltaggio',
		province: 'AL',
		altitude: 342
	},
	{
		zip: '32020',
		name: 'Voltago Agordino',
		province: 'BL',
		altitude: 858
	},
	{
		zip: '56048',
		name: 'Volterra',
		province: 'PI',
		altitude: 531
	},
	{
		zip: '26030',
		name: 'Voltido',
		province: 'CR',
		altitude: 35
	},
	{
		zip: '71030',
		name: 'Volturara Appula',
		province: 'FG',
		altitude: 489
	},
	{
		zip: '83050',
		name: 'Volturara Irpina',
		province: 'AV',
		altitude: 697
	},
	{
		zip: '71030',
		name: 'Volturino',
		province: 'FG',
		altitude: 735
	},
	{
		zip: '10040',
		name: 'Volvera',
		province: 'TO',
		altitude: 251
	},
	{
		zip: '12020',
		name: 'Vottignasco',
		province: 'CN',
		altitude: 380
	},
	{
		zip: '89867',
		name: 'Zaccanopoli',
		province: 'VV',
		altitude: 430
	},
	{
		zip: '95019',
		name: 'Zafferana Etnea',
		province: 'CT',
		altitude: 580
	},
	{
		zip: '88050',
		name: 'Zagarise',
		province: 'CZ',
		altitude: 581
	},
	{
		zip: '00039',
		name: 'Zagarolo',
		province: 'RM',
		altitude: 303
	},
	{
		zip: '89868',
		name: 'Zambrone',
		province: 'VV',
		altitude: 222
	},
	{
		zip: '24060',
		name: 'Zandobbio',
		province: 'BG',
		altitude: 715
	},
	{
		zip: '24050',
		name: 'Zanica',
		province: 'BG',
		altitude: 210
	},
	{
		zip: '36010',
		name: 'Zane',
		province: 'VI',
		altitude: 183
	},
	{
		zip: '71030',
		name: 'Zapponeta',
		province: 'FG',
		altitude: 2
	},
	{
		zip: '27059',
		name: 'Zavattarello',
		province: 'PV',
		altitude: 600
	},
	{
		zip: '27010',
		name: 'Zeccone',
		province: 'PV',
		altitude: 86
	},
	{
		zip: '09070',
		name: 'Zeddiani',
		province: 'OR',
		altitude: 10
	},
	{
		zip: '22020',
		name: 'Zelbio',
		province: 'CO',
		altitude: 802
	},
	{
		zip: '26839',
		name: 'Zelo Buon Persico',
		province: 'LO',
		altitude: 95
	},
	{
		zip: '27030',
		name: 'Zeme',
		province: 'PV',
		altitude: 104
	},
	{
		zip: '27049',
		name: 'Zenevredo',
		province: 'PV',
		altitude: 204
	},
	{
		zip: '31050',
		name: 'Zenson di Piave',
		province: 'TV',
		altitude: 7
	},
	{
		zip: '29020',
		name: 'Zerba',
		province: 'PC',
		altitude: 906
	},
	{
		zip: '27017',
		name: 'Zerbo',
		province: 'PV',
		altitude: 68
	},
	{
		zip: '27020',
		name: 'Zerbolo',
		province: 'PV',
		altitude: 68
	},
	{
		zip: '09070',
		name: 'Zerfaliu',
		province: 'OR',
		altitude: 15
	},
	{
		zip: '54029',
		name: 'Zeri',
		province: 'MS',
		altitude: 708
	},
	{
		zip: '36050',
		name: 'Zermeghedo',
		province: 'VI',
		altitude: 84
	},
	{
		zip: '31059',
		name: 'Zero Branco',
		province: 'TV',
		altitude: 18
	},
	{
		zip: '37059',
		name: 'Zevio',
		province: 'VR',
		altitude: 32
	},
	{
		zip: '29010',
		name: 'Ziano Piacentino',
		province: 'PC',
		altitude: 220
	},
	{
		zip: '38030',
		name: 'Ziano di Fiemme',
		province: 'TN',
		altitude: 952
	},
	{
		zip: '20058',
		name: 'Zibido San Giacomo',
		province: 'MI',
		altitude: 111
	},
	{
		zip: '19020',
		name: 'Zignago',
		province: 'SP',
		altitude: 632
	},
	{
		zip: '37040',
		name: 'Zimella',
		province: 'VR',
		altitude: 29
	},
	{
		zip: '13887',
		name: 'Zimone',
		province: 'BI',
		altitude: 465
	},
	{
		zip: '27030',
		name: 'Zinasco',
		province: 'PV',
		altitude: 84
	},
	{
		zip: '16035',
		name: 'Zoagli',
		province: 'GE',
		altitude: 17
	},
	{
		zip: '41059',
		name: 'Zocca',
		province: 'MO',
		altitude: 758
	},
	{
		zip: '24019',
		name: 'Zogno',
		province: 'BG',
		altitude: 334
	},
	{
		zip: '40069',
		name: 'Zola Predosa',
		province: 'BO',
		altitude: 74
	},
	{
		zip: '73010',
		name: 'Zollino',
		province: 'LE',
		altitude: 90
	},
	{
		zip: '25050',
		name: 'Zone',
		province: 'BS',
		altitude: 684
	},
	{
		zip: '33080',
		name: 'Zoppola',
		province: 'PN',
		altitude: 36
	},
	{
		zip: '32010',
		name: 'Zoppe di Cadore',
		province: 'BL',
		altitude: 1461
	},
	{
		zip: '36020',
		name: 'Zovencedo',
		province: 'VI',
		altitude: 276
	},
	{
		zip: '13888',
		name: 'Zubiena',
		province: 'BI',
		altitude: 492
	},
	{
		zip: '17039',
		name: 'Zuccarello',
		province: 'SV',
		altitude: 130
	},
	{
		zip: '36030',
		name: 'Zugliano',
		province: 'VI',
		altitude: 154
	},
	{
		zip: '33020',
		name: 'Zuglio',
		province: 'UD',
		altitude: 429
	},
	{
		zip: '13848',
		name: 'Zumaglia',
		province: 'BI',
		altitude: 580
	},
	{
		zip: '87040',
		name: 'Zumpano',
		province: 'CS',
		altitude: 429
	},
	{
		zip: '83030',
		name: 'Zungoli',
		province: 'AV',
		altitude: 657
	},
	{
		zip: '89867',
		name: 'Zungri',
		province: 'VV',
		altitude: 554
	}
]